
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2cd9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2cd9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bbzbN", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2nzLi"));

});
parcelRegister("2nzLi", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1bb9784afa87e369$export$ffb0004e005737fa; }, function (v) { return $1bb9784afa87e369$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1bb9784afa87e369$export$34b9dba7ce09269b; }, function (v) { return $1bb9784afa87e369$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1bb9784afa87e369$export$25062201e9e25d76; }, function (v) { return $1bb9784afa87e369$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bb9784afa87e369$export$ffb0004e005737fa;
var $1bb9784afa87e369$export$34b9dba7ce09269b;
var $1bb9784afa87e369$export$25062201e9e25d76;
'use strict';

var $7fPBF = parcelRequire("7fPBF");
var $1bb9784afa87e369$var$k = Symbol.for("react.element"), $1bb9784afa87e369$var$l = Symbol.for("react.fragment"), $1bb9784afa87e369$var$m = Object.prototype.hasOwnProperty, $1bb9784afa87e369$var$n = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1bb9784afa87e369$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1bb9784afa87e369$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$1bb9784afa87e369$var$m.call(a, b) && !$1bb9784afa87e369$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1bb9784afa87e369$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $1bb9784afa87e369$var$n.current
    };
}
$1bb9784afa87e369$export$ffb0004e005737fa = $1bb9784afa87e369$var$l;
$1bb9784afa87e369$export$34b9dba7ce09269b = $1bb9784afa87e369$var$q;
$1bb9784afa87e369$export$25062201e9e25d76 = $1bb9784afa87e369$var$q;

});
parcelRegister("7fPBF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fSPLm"));

});
parcelRegister("fSPLm", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $b9040d2deeb360f4$export$dca3b0875bd9a954; }, function (v) { return $b9040d2deeb360f4$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b9040d2deeb360f4$export$16fa2f45be04daa8; }, function (v) { return $b9040d2deeb360f4$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b9040d2deeb360f4$export$ffb0004e005737fa; }, function (v) { return $b9040d2deeb360f4$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $b9040d2deeb360f4$export$e2c29f18771995cb; }, function (v) { return $b9040d2deeb360f4$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b9040d2deeb360f4$export$221d75b3f55bb0bd; }, function (v) { return $b9040d2deeb360f4$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b9040d2deeb360f4$export$5f8d39834fd61797; }, function (v) { return $b9040d2deeb360f4$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b9040d2deeb360f4$export$74bf444e3cd11ea5; }, function (v) { return $b9040d2deeb360f4$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b9040d2deeb360f4$export$ae55be85d98224ed; }, function (v) { return $b9040d2deeb360f4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $b9040d2deeb360f4$export$3ba232387fd5d6dd; }, function (v) { return $b9040d2deeb360f4$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b9040d2deeb360f4$export$e530037191fcd5d7; }, function (v) { return $b9040d2deeb360f4$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b9040d2deeb360f4$export$fd42f52fd3ae1109; }, function (v) { return $b9040d2deeb360f4$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b9040d2deeb360f4$export$c8a8987d4410bf2d; }, function (v) { return $b9040d2deeb360f4$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $b9040d2deeb360f4$export$d38cd72104c1f0e9; }, function (v) { return $b9040d2deeb360f4$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43; }, function (v) { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b9040d2deeb360f4$export$257a8862b851cb5b; }, function (v) { return $b9040d2deeb360f4$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b9040d2deeb360f4$export$a8257692ac88316c; }, function (v) { return $b9040d2deeb360f4$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b9040d2deeb360f4$export$488013bae63b21da; }, function (v) { return $b9040d2deeb360f4$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b9040d2deeb360f4$export$7c73462e0d25e514; }, function (v) { return $b9040d2deeb360f4$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $b9040d2deeb360f4$export$7568632d0d33d16d; }, function (v) { return $b9040d2deeb360f4$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $b9040d2deeb360f4$export$88948ce120ea2619; }, function (v) { return $b9040d2deeb360f4$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b9040d2deeb360f4$export$35808ee640e87ca7; }, function (v) { return $b9040d2deeb360f4$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b9040d2deeb360f4$export$fae74005e78b1a27; }, function (v) { return $b9040d2deeb360f4$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e; }, function (v) { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf; }, function (v) { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $b9040d2deeb360f4$export$6d9c69b0de29b591; }, function (v) { return $b9040d2deeb360f4$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $b9040d2deeb360f4$export$f680877a34711e37; }, function (v) { return $b9040d2deeb360f4$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b9040d2deeb360f4$export$d5a552a76deda3c2; }, function (v) { return $b9040d2deeb360f4$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $b9040d2deeb360f4$export$aaabe4eda9ed9969; }, function (v) { return $b9040d2deeb360f4$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b9040d2deeb360f4$export$e5c5a5f917a5871c; }, function (v) { return $b9040d2deeb360f4$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b9040d2deeb360f4$export$1538c33de8887b59; }, function (v) { return $b9040d2deeb360f4$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $b9040d2deeb360f4$export$13e3392192263954; }, function (v) { return $b9040d2deeb360f4$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b9040d2deeb360f4$export$b8f5890fc79d6aca; }, function (v) { return $b9040d2deeb360f4$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b9040d2deeb360f4$export$60241385465d0a34; }, function (v) { return $b9040d2deeb360f4$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $b9040d2deeb360f4$export$306c0aa65ff9ec16; }, function (v) { return $b9040d2deeb360f4$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $b9040d2deeb360f4$export$7b286972b8d8ccbf; }, function (v) { return $b9040d2deeb360f4$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $b9040d2deeb360f4$export$83d89fbfd8236492; }, function (v) { return $b9040d2deeb360f4$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b9040d2deeb360f4$export$dca3b0875bd9a954;
var $b9040d2deeb360f4$export$16fa2f45be04daa8;
var $b9040d2deeb360f4$export$ffb0004e005737fa;
var $b9040d2deeb360f4$export$e2c29f18771995cb;
var $b9040d2deeb360f4$export$221d75b3f55bb0bd;
var $b9040d2deeb360f4$export$5f8d39834fd61797;
var $b9040d2deeb360f4$export$74bf444e3cd11ea5;
var $b9040d2deeb360f4$export$ae55be85d98224ed;
var $b9040d2deeb360f4$export$3ba232387fd5d6dd;
var $b9040d2deeb360f4$export$e530037191fcd5d7;
var $b9040d2deeb360f4$export$fd42f52fd3ae1109;
var $b9040d2deeb360f4$export$c8a8987d4410bf2d;
var $b9040d2deeb360f4$export$d38cd72104c1f0e9;
var $b9040d2deeb360f4$export$7d1e3a5e95ceca43;
var $b9040d2deeb360f4$export$257a8862b851cb5b;
var $b9040d2deeb360f4$export$a8257692ac88316c;
var $b9040d2deeb360f4$export$488013bae63b21da;
var $b9040d2deeb360f4$export$7c73462e0d25e514;
var $b9040d2deeb360f4$export$7568632d0d33d16d;
var $b9040d2deeb360f4$export$88948ce120ea2619;
var $b9040d2deeb360f4$export$35808ee640e87ca7;
var $b9040d2deeb360f4$export$fae74005e78b1a27;
var $b9040d2deeb360f4$export$dc8fbce3eb94dc1e;
var $b9040d2deeb360f4$export$6a7bc4e911dc01cf;
var $b9040d2deeb360f4$export$6d9c69b0de29b591;
var $b9040d2deeb360f4$export$f680877a34711e37;
var $b9040d2deeb360f4$export$d5a552a76deda3c2;
var $b9040d2deeb360f4$export$aaabe4eda9ed9969;
var $b9040d2deeb360f4$export$e5c5a5f917a5871c;
var $b9040d2deeb360f4$export$1538c33de8887b59;
var $b9040d2deeb360f4$export$13e3392192263954;
var $b9040d2deeb360f4$export$b8f5890fc79d6aca;
var $b9040d2deeb360f4$export$60241385465d0a34;
var $b9040d2deeb360f4$export$306c0aa65ff9ec16;
var $b9040d2deeb360f4$export$7b286972b8d8ccbf;
var $b9040d2deeb360f4$export$83d89fbfd8236492;
'use strict';
var $b9040d2deeb360f4$var$l = Symbol.for("react.element"), $b9040d2deeb360f4$var$n = Symbol.for("react.portal"), $b9040d2deeb360f4$var$p = Symbol.for("react.fragment"), $b9040d2deeb360f4$var$q = Symbol.for("react.strict_mode"), $b9040d2deeb360f4$var$r = Symbol.for("react.profiler"), $b9040d2deeb360f4$var$t = Symbol.for("react.provider"), $b9040d2deeb360f4$var$u = Symbol.for("react.context"), $b9040d2deeb360f4$var$v = Symbol.for("react.forward_ref"), $b9040d2deeb360f4$var$w = Symbol.for("react.suspense"), $b9040d2deeb360f4$var$x = Symbol.for("react.memo"), $b9040d2deeb360f4$var$y = Symbol.for("react.lazy"), $b9040d2deeb360f4$var$z = Symbol.iterator;
function $b9040d2deeb360f4$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b9040d2deeb360f4$var$z && a[$b9040d2deeb360f4$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b9040d2deeb360f4$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b9040d2deeb360f4$var$C = Object.assign, $b9040d2deeb360f4$var$D = {};
function $b9040d2deeb360f4$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
$b9040d2deeb360f4$var$E.prototype.isReactComponent = {};
$b9040d2deeb360f4$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b9040d2deeb360f4$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b9040d2deeb360f4$var$F() {}
$b9040d2deeb360f4$var$F.prototype = $b9040d2deeb360f4$var$E.prototype;
function $b9040d2deeb360f4$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
var $b9040d2deeb360f4$var$H = $b9040d2deeb360f4$var$G.prototype = new $b9040d2deeb360f4$var$F;
$b9040d2deeb360f4$var$H.constructor = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$var$C($b9040d2deeb360f4$var$H, $b9040d2deeb360f4$var$E.prototype);
$b9040d2deeb360f4$var$H.isPureReactComponent = !0;
var $b9040d2deeb360f4$var$I = Array.isArray, $b9040d2deeb360f4$var$J = Object.prototype.hasOwnProperty, $b9040d2deeb360f4$var$K = {
    current: null
}, $b9040d2deeb360f4$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b9040d2deeb360f4$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b9040d2deeb360f4$var$J.call(b, d) && !$b9040d2deeb360f4$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $b9040d2deeb360f4$var$K.current
    };
}
function $b9040d2deeb360f4$var$N(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b9040d2deeb360f4$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b9040d2deeb360f4$var$l;
}
function $b9040d2deeb360f4$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b9040d2deeb360f4$var$P = /\/+/g;
function $b9040d2deeb360f4$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b9040d2deeb360f4$var$escape("" + a.key) : b.toString(36);
}
function $b9040d2deeb360f4$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b9040d2deeb360f4$var$l:
                case $b9040d2deeb360f4$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $b9040d2deeb360f4$var$Q(h, 0) : d, $b9040d2deeb360f4$var$I(c) ? (e = "", null != a && (e = a.replace($b9040d2deeb360f4$var$P, "$&/") + "/"), $b9040d2deeb360f4$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($b9040d2deeb360f4$var$O(c) && (c = $b9040d2deeb360f4$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($b9040d2deeb360f4$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($b9040d2deeb360f4$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $b9040d2deeb360f4$var$Q(k, g);
        h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    }
    else if (f = $b9040d2deeb360f4$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $b9040d2deeb360f4$var$Q(k, g++), h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $b9040d2deeb360f4$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $b9040d2deeb360f4$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $b9040d2deeb360f4$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $b9040d2deeb360f4$var$U = {
    current: null
}, $b9040d2deeb360f4$var$V = {
    transition: null
}, $b9040d2deeb360f4$var$W = {
    ReactCurrentDispatcher: $b9040d2deeb360f4$var$U,
    ReactCurrentBatchConfig: $b9040d2deeb360f4$var$V,
    ReactCurrentOwner: $b9040d2deeb360f4$var$K
};
function $b9040d2deeb360f4$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$b9040d2deeb360f4$export$dca3b0875bd9a954 = {
    map: $b9040d2deeb360f4$var$S,
    forEach: function(a, b, e) {
        $b9040d2deeb360f4$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $b9040d2deeb360f4$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b9040d2deeb360f4$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b9040d2deeb360f4$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$b9040d2deeb360f4$export$16fa2f45be04daa8 = $b9040d2deeb360f4$var$E;
$b9040d2deeb360f4$export$ffb0004e005737fa = $b9040d2deeb360f4$var$p;
$b9040d2deeb360f4$export$e2c29f18771995cb = $b9040d2deeb360f4$var$r;
$b9040d2deeb360f4$export$221d75b3f55bb0bd = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$export$5f8d39834fd61797 = $b9040d2deeb360f4$var$q;
$b9040d2deeb360f4$export$74bf444e3cd11ea5 = $b9040d2deeb360f4$var$w;
$b9040d2deeb360f4$export$ae55be85d98224ed = $b9040d2deeb360f4$var$W;
$b9040d2deeb360f4$export$3ba232387fd5d6dd = $b9040d2deeb360f4$var$X;
$b9040d2deeb360f4$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $b9040d2deeb360f4$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b9040d2deeb360f4$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b9040d2deeb360f4$var$J.call(b, f) && !$b9040d2deeb360f4$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$b9040d2deeb360f4$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $b9040d2deeb360f4$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $b9040d2deeb360f4$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$b9040d2deeb360f4$export$c8a8987d4410bf2d = $b9040d2deeb360f4$var$M;
$b9040d2deeb360f4$export$d38cd72104c1f0e9 = function(a) {
    var b = $b9040d2deeb360f4$var$M.bind(null, a);
    b.type = a;
    return b;
};
$b9040d2deeb360f4$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b9040d2deeb360f4$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$v,
        render: a
    };
};
$b9040d2deeb360f4$export$a8257692ac88316c = $b9040d2deeb360f4$var$O;
$b9040d2deeb360f4$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b9040d2deeb360f4$var$T
    };
};
$b9040d2deeb360f4$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b9040d2deeb360f4$export$7568632d0d33d16d = function(a) {
    var b = $b9040d2deeb360f4$var$V.transition;
    $b9040d2deeb360f4$var$V.transition = {};
    try {
        a();
    } finally{
        $b9040d2deeb360f4$var$V.transition = b;
    }
};
$b9040d2deeb360f4$export$88948ce120ea2619 = $b9040d2deeb360f4$var$X;
$b9040d2deeb360f4$export$35808ee640e87ca7 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useCallback(a, b);
};
$b9040d2deeb360f4$export$fae74005e78b1a27 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useContext(a);
};
$b9040d2deeb360f4$export$dc8fbce3eb94dc1e = function() {};
$b9040d2deeb360f4$export$6a7bc4e911dc01cf = function(a) {
    return $b9040d2deeb360f4$var$U.current.useDeferredValue(a);
};
$b9040d2deeb360f4$export$6d9c69b0de29b591 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useEffect(a, b);
};
$b9040d2deeb360f4$export$f680877a34711e37 = function() {
    return $b9040d2deeb360f4$var$U.current.useId();
};
$b9040d2deeb360f4$export$d5a552a76deda3c2 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useImperativeHandle(a, b, e);
};
$b9040d2deeb360f4$export$aaabe4eda9ed9969 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useInsertionEffect(a, b);
};
$b9040d2deeb360f4$export$e5c5a5f917a5871c = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useLayoutEffect(a, b);
};
$b9040d2deeb360f4$export$1538c33de8887b59 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useMemo(a, b);
};
$b9040d2deeb360f4$export$13e3392192263954 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useReducer(a, b, e);
};
$b9040d2deeb360f4$export$b8f5890fc79d6aca = function(a) {
    return $b9040d2deeb360f4$var$U.current.useRef(a);
};
$b9040d2deeb360f4$export$60241385465d0a34 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useState(a);
};
$b9040d2deeb360f4$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useSyncExternalStore(a, b, e);
};
$b9040d2deeb360f4$export$7b286972b8d8ccbf = function() {
    return $b9040d2deeb360f4$var$U.current.useTransition();
};
$b9040d2deeb360f4$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("kY3Ke", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f43c50d92a19d876$export$2e2bcd8739ae039; });
function $f43c50d92a19d876$export$2e2bcd8739ae039() {
    return $f43c50d92a19d876$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f43c50d92a19d876$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("45MkT", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $2fad1f91101d4119$export$2b8d127b894957b9; }, function (v) { return $2fad1f91101d4119$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $2fad1f91101d4119$export$cea3a54a6425200c; }, function (v) { return $2fad1f91101d4119$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $2fad1f91101d4119$export$a7c73072b1a182ae; }, function (v) { return $2fad1f91101d4119$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $2fad1f91101d4119$export$9f27bc3417b4524d; }, function (v) { return $2fad1f91101d4119$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $2fad1f91101d4119$export$db77ccec0bb4ccac; }, function (v) { return $2fad1f91101d4119$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $2fad1f91101d4119$export$8392c0c9d3dcbd35; }, function (v) { return $2fad1f91101d4119$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $2fad1f91101d4119$export$ffb0004e005737fa; }, function (v) { return $2fad1f91101d4119$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $2fad1f91101d4119$export$b624eff549462981; }, function (v) { return $2fad1f91101d4119$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $2fad1f91101d4119$export$7897aa7841a5380c; }, function (v) { return $2fad1f91101d4119$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $2fad1f91101d4119$export$602eac185826482c; }, function (v) { return $2fad1f91101d4119$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $2fad1f91101d4119$export$e2c29f18771995cb; }, function (v) { return $2fad1f91101d4119$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $2fad1f91101d4119$export$5f8d39834fd61797; }, function (v) { return $2fad1f91101d4119$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $2fad1f91101d4119$export$74bf444e3cd11ea5; }, function (v) { return $2fad1f91101d4119$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $2fad1f91101d4119$export$92387174baf9b227; }, function (v) { return $2fad1f91101d4119$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $2fad1f91101d4119$export$ec112efeb987d9c6; }, function (v) { return $2fad1f91101d4119$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $2fad1f91101d4119$export$b706b080d889d2c9; }, function (v) { return $2fad1f91101d4119$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $2fad1f91101d4119$export$5be5a87408f70ddc; }, function (v) { return $2fad1f91101d4119$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $2fad1f91101d4119$export$45a5e7f76e0caa8d; }, function (v) { return $2fad1f91101d4119$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $2fad1f91101d4119$export$455c2e768291efa6; }, function (v) { return $2fad1f91101d4119$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $2fad1f91101d4119$export$9522e17588c12572; }, function (v) { return $2fad1f91101d4119$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $2fad1f91101d4119$export$2110ac352bb060b9; }, function (v) { return $2fad1f91101d4119$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $2fad1f91101d4119$export$56885ab8b9c456ab; }, function (v) { return $2fad1f91101d4119$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $2fad1f91101d4119$export$d927fcb6adf8f9de; }, function (v) { return $2fad1f91101d4119$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $2fad1f91101d4119$export$b82d16f27459e05a; }, function (v) { return $2fad1f91101d4119$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $2fad1f91101d4119$export$522c17b4f5e123e8; }, function (v) { return $2fad1f91101d4119$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $2fad1f91101d4119$export$1aabd8a0274ecfd6; }, function (v) { return $2fad1f91101d4119$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $2fad1f91101d4119$export$9b621391a187a31a; }, function (v) { return $2fad1f91101d4119$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $2fad1f91101d4119$export$f5bbd400c2f4426f; }, function (v) { return $2fad1f91101d4119$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2fad1f91101d4119$export$2b8d127b894957b9;
var $2fad1f91101d4119$export$cea3a54a6425200c;
var $2fad1f91101d4119$export$a7c73072b1a182ae;
var $2fad1f91101d4119$export$9f27bc3417b4524d;
var $2fad1f91101d4119$export$db77ccec0bb4ccac;
var $2fad1f91101d4119$export$8392c0c9d3dcbd35;
var $2fad1f91101d4119$export$ffb0004e005737fa;
var $2fad1f91101d4119$export$b624eff549462981;
var $2fad1f91101d4119$export$7897aa7841a5380c;
var $2fad1f91101d4119$export$602eac185826482c;
var $2fad1f91101d4119$export$e2c29f18771995cb;
var $2fad1f91101d4119$export$5f8d39834fd61797;
var $2fad1f91101d4119$export$74bf444e3cd11ea5;
var $2fad1f91101d4119$export$92387174baf9b227;
var $2fad1f91101d4119$export$ec112efeb987d9c6;
var $2fad1f91101d4119$export$b706b080d889d2c9;
var $2fad1f91101d4119$export$5be5a87408f70ddc;
var $2fad1f91101d4119$export$45a5e7f76e0caa8d;
var $2fad1f91101d4119$export$455c2e768291efa6;
var $2fad1f91101d4119$export$9522e17588c12572;
var $2fad1f91101d4119$export$2110ac352bb060b9;
var $2fad1f91101d4119$export$56885ab8b9c456ab;
var $2fad1f91101d4119$export$d927fcb6adf8f9de;
var $2fad1f91101d4119$export$b82d16f27459e05a;
var $2fad1f91101d4119$export$522c17b4f5e123e8;
var $2fad1f91101d4119$export$1aabd8a0274ecfd6;
var $2fad1f91101d4119$export$9b621391a187a31a;
var $2fad1f91101d4119$export$f5bbd400c2f4426f;
'use strict';
var $2fad1f91101d4119$var$b = "function" === typeof Symbol && Symbol.for, $2fad1f91101d4119$var$c = $2fad1f91101d4119$var$b ? Symbol.for("react.element") : 60103, $2fad1f91101d4119$var$d = $2fad1f91101d4119$var$b ? Symbol.for("react.portal") : 60106, $2fad1f91101d4119$var$e = $2fad1f91101d4119$var$b ? Symbol.for("react.fragment") : 60107, $2fad1f91101d4119$var$f = $2fad1f91101d4119$var$b ? Symbol.for("react.strict_mode") : 60108, $2fad1f91101d4119$var$g = $2fad1f91101d4119$var$b ? Symbol.for("react.profiler") : 60114, $2fad1f91101d4119$var$h = $2fad1f91101d4119$var$b ? Symbol.for("react.provider") : 60109, $2fad1f91101d4119$var$k = $2fad1f91101d4119$var$b ? Symbol.for("react.context") : 60110, $2fad1f91101d4119$var$l = $2fad1f91101d4119$var$b ? Symbol.for("react.async_mode") : 60111, $2fad1f91101d4119$var$m = $2fad1f91101d4119$var$b ? Symbol.for("react.concurrent_mode") : 60111, $2fad1f91101d4119$var$n = $2fad1f91101d4119$var$b ? Symbol.for("react.forward_ref") : 60112, $2fad1f91101d4119$var$p = $2fad1f91101d4119$var$b ? Symbol.for("react.suspense") : 60113, $2fad1f91101d4119$var$q = $2fad1f91101d4119$var$b ? Symbol.for("react.suspense_list") : 60120, $2fad1f91101d4119$var$r = $2fad1f91101d4119$var$b ? Symbol.for("react.memo") : 60115, $2fad1f91101d4119$var$t = $2fad1f91101d4119$var$b ? Symbol.for("react.lazy") : 60116, $2fad1f91101d4119$var$v = $2fad1f91101d4119$var$b ? Symbol.for("react.block") : 60121, $2fad1f91101d4119$var$w = $2fad1f91101d4119$var$b ? Symbol.for("react.fundamental") : 60117, $2fad1f91101d4119$var$x = $2fad1f91101d4119$var$b ? Symbol.for("react.responder") : 60118, $2fad1f91101d4119$var$y = $2fad1f91101d4119$var$b ? Symbol.for("react.scope") : 60119;
function $2fad1f91101d4119$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $2fad1f91101d4119$var$c:
                switch(a = a.type, a){
                    case $2fad1f91101d4119$var$l:
                    case $2fad1f91101d4119$var$m:
                    case $2fad1f91101d4119$var$e:
                    case $2fad1f91101d4119$var$g:
                    case $2fad1f91101d4119$var$f:
                    case $2fad1f91101d4119$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2fad1f91101d4119$var$k:
                            case $2fad1f91101d4119$var$n:
                            case $2fad1f91101d4119$var$t:
                            case $2fad1f91101d4119$var$r:
                            case $2fad1f91101d4119$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $2fad1f91101d4119$var$d:
                return u;
        }
    }
}
function $2fad1f91101d4119$var$A(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$m;
}
$2fad1f91101d4119$export$2b8d127b894957b9 = $2fad1f91101d4119$var$l;
$2fad1f91101d4119$export$cea3a54a6425200c = $2fad1f91101d4119$var$m;
$2fad1f91101d4119$export$a7c73072b1a182ae = $2fad1f91101d4119$var$k;
$2fad1f91101d4119$export$9f27bc3417b4524d = $2fad1f91101d4119$var$h;
$2fad1f91101d4119$export$db77ccec0bb4ccac = $2fad1f91101d4119$var$c;
$2fad1f91101d4119$export$8392c0c9d3dcbd35 = $2fad1f91101d4119$var$n;
$2fad1f91101d4119$export$ffb0004e005737fa = $2fad1f91101d4119$var$e;
$2fad1f91101d4119$export$b624eff549462981 = $2fad1f91101d4119$var$t;
$2fad1f91101d4119$export$7897aa7841a5380c = $2fad1f91101d4119$var$r;
$2fad1f91101d4119$export$602eac185826482c = $2fad1f91101d4119$var$d;
$2fad1f91101d4119$export$e2c29f18771995cb = $2fad1f91101d4119$var$g;
$2fad1f91101d4119$export$5f8d39834fd61797 = $2fad1f91101d4119$var$f;
$2fad1f91101d4119$export$74bf444e3cd11ea5 = $2fad1f91101d4119$var$p;
$2fad1f91101d4119$export$92387174baf9b227 = function(a) {
    return $2fad1f91101d4119$var$A(a) || $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$l;
};
$2fad1f91101d4119$export$ec112efeb987d9c6 = $2fad1f91101d4119$var$A;
$2fad1f91101d4119$export$b706b080d889d2c9 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$k;
};
$2fad1f91101d4119$export$5be5a87408f70ddc = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$h;
};
$2fad1f91101d4119$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2fad1f91101d4119$var$c;
};
$2fad1f91101d4119$export$455c2e768291efa6 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$n;
};
$2fad1f91101d4119$export$9522e17588c12572 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$e;
};
$2fad1f91101d4119$export$2110ac352bb060b9 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$t;
};
$2fad1f91101d4119$export$56885ab8b9c456ab = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$r;
};
$2fad1f91101d4119$export$d927fcb6adf8f9de = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$d;
};
$2fad1f91101d4119$export$b82d16f27459e05a = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$g;
};
$2fad1f91101d4119$export$522c17b4f5e123e8 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$f;
};
$2fad1f91101d4119$export$1aabd8a0274ecfd6 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$p;
};
$2fad1f91101d4119$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2fad1f91101d4119$var$e || a === $2fad1f91101d4119$var$m || a === $2fad1f91101d4119$var$g || a === $2fad1f91101d4119$var$f || a === $2fad1f91101d4119$var$p || a === $2fad1f91101d4119$var$q || "object" === typeof a && null !== a && (a.$$typeof === $2fad1f91101d4119$var$t || a.$$typeof === $2fad1f91101d4119$var$r || a.$$typeof === $2fad1f91101d4119$var$h || a.$$typeof === $2fad1f91101d4119$var$k || a.$$typeof === $2fad1f91101d4119$var$n || a.$$typeof === $2fad1f91101d4119$var$w || a.$$typeof === $2fad1f91101d4119$var$x || a.$$typeof === $2fad1f91101d4119$var$y || a.$$typeof === $2fad1f91101d4119$var$v);
};
$2fad1f91101d4119$export$f5bbd400c2f4426f = $2fad1f91101d4119$var$z;

});

parcelRegister("fO8TG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8226d5132dedede$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2iTlU = parcelRequire("2iTlU");

var $hBN0S = parcelRequire("hBN0S");

var $jwhZE = parcelRequire("jwhZE");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $b8226d5132dedede$export$2e2bcd8739ae039({ theme: theme, ...props }) {
    const noVarsTheme = $7fPBF.useMemo(()=>{
        if (typeof theme === 'function') return theme;
        const muiTheme = (0, $jwhZE.default) in theme ? theme[0, $jwhZE.default] : theme;
        if (!('colorSchemes' in muiTheme)) {
            if (!('vars' in muiTheme)) // For non-CSS variables themes, set `vars` to null to prevent theme inheritance from the upper theme.
            // The example use case is the docs demo that uses ThemeProvider to customize the theme while the upper theme is using CSS variables.
            return {
                ...theme,
                vars: null
            };
            return theme;
        }
        return null;
    }, [
        theme
    ]);
    if (noVarsTheme) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2iTlU.default), {
        theme: noVarsTheme,
        ...props
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hBN0S.CssVarsProvider), {
        theme: theme,
        ...props
    });
}

});
parcelRegister("2iTlU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ad83304ee89086b$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $hpqHU = parcelRequire("hpqHU");

var $jwhZE = parcelRequire("jwhZE");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $1ad83304ee89086b$export$2e2bcd8739ae039({ theme: themeInput, ...props }) {
    const scopedTheme = (0, $jwhZE.default) in themeInput ? themeInput[0, $jwhZE.default] : undefined;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hpqHU.default), {
        ...props,
        themeId: scopedTheme ? (0, $jwhZE.default) : undefined,
        theme: scopedTheme || themeInput
    });
}

});
parcelRegister("hpqHU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cac97cfcc46fa531$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $kRQLX = parcelRequire("kRQLX");
var $fC1zT = parcelRequire("fC1zT");

parcelRequire("5nUae");
var $6te04 = parcelRequire("6te04");

var $gU1gT = parcelRequire("gU1gT");

var $kyirV = parcelRequire("kyirV");

var $7eatR = parcelRequire("7eatR");

var $k9qD2 = parcelRequire("k9qD2");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $cac97cfcc46fa531$var$EMPTY_THEME = {};
function $cac97cfcc46fa531$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $7fPBF.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $cac97cfcc46fa531$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $gU1gT.default)($cac97cfcc46fa531$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $fC1zT.default)() || $cac97cfcc46fa531$var$EMPTY_THEME;
    const engineTheme = $cac97cfcc46fa531$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $cac97cfcc46fa531$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    const layerOrder = (0, $k9qD2.default)(engineTheme);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kRQLX.default), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6te04.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kyirV.default), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $7eatR.default), {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $cac97cfcc46fa531$export$2e2bcd8739ae039 = $cac97cfcc46fa531$var$ThemeProvider;

});
parcelRegister("kRQLX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f311b16c4b43b6fd$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");



var $gFfZb = parcelRequire("gFfZb");

var $fC1zT = parcelRequire("fC1zT");

var $3ax6g = parcelRequire("3ax6g");

var $bbzbN = parcelRequire("bbzbN");
function $f311b16c4b43b6fd$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $f311b16c4b43b6fd$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $fC1zT.default)();
    const theme = $7fPBF.useMemo(()=>{
        const output = outerTheme === null ? {
            ...localTheme
        } : $f311b16c4b43b6fd$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $3ax6g.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gFfZb.default).Provider, {
        value: theme,
        children: children
    });
}
var $f311b16c4b43b6fd$export$2e2bcd8739ae039 = $f311b16c4b43b6fd$var$ThemeProvider;

});
parcelRegister("gFfZb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c21ce0253dc11cd3$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
'use client';
const $c21ce0253dc11cd3$var$ThemeContext = /*#__PURE__*/ $7fPBF.createContext(null);
var $c21ce0253dc11cd3$export$2e2bcd8739ae039 = $c21ce0253dc11cd3$var$ThemeContext;

});

parcelRegister("fC1zT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5dba0f0f3e50f8f$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $gFfZb = parcelRequire("gFfZb");
function $b5dba0f0f3e50f8f$export$2e2bcd8739ae039() {
    const theme = $7fPBF.useContext((0, $gFfZb.default));
    return theme;
}

});

parcelRegister("3ax6g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24ebfb3bf89f6ffe$export$2e2bcd8739ae039; });
const $24ebfb3bf89f6ffe$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $24ebfb3bf89f6ffe$export$2e2bcd8739ae039 = $24ebfb3bf89f6ffe$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

});


parcelRegister("5nUae", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $3ebaaabf76fb5db5$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $3ebaaabf76fb5db5$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $3ebaaabf76fb5db5$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("6te04")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("6te04")).w; });

var $6te04 = parcelRequire("6te04");

var $7fPBF = parcelRequire("7fPBF");

var $80dPg = parcelRequire("80dPg");

var $9uXao = parcelRequire("9uXao");

var $6lPck = parcelRequire("6lPck");
parcelRequire("3mESc");
parcelRequire("cvBp9");
parcelRequire("lT6zG");

parcelRequire("8Ae2G");
var $3ebaaabf76fb5db5$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $6te04.h).call(props, 'css')) return $7fPBF.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $6te04.E);
    createElementArgArray[1] = (0, $6te04.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $7fPBF.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($3ebaaabf76fb5db5$export$c8a8987d4410bf2d || ($3ebaaabf76fb5db5$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $3ebaaabf76fb5db5$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $6te04.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $6lPck.serializeStyles)([
        styles
    ], undefined, $7fPBF.useContext((0, $6te04.T)));
    if (!(0, $6te04.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $7fPBF.useRef();
    (0, $9uXao.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $9uXao.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $80dPg.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $3ebaaabf76fb5db5$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $6lPck.serializeStyles)(args);
}
function $3ebaaabf76fb5db5$export$d25ddfdf17c3ad3e() {
    var insertable = $3ebaaabf76fb5db5$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $3ebaaabf76fb5db5$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $3ebaaabf76fb5db5$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $80dPg.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $3ebaaabf76fb5db5$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $9uXao.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $80dPg.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $6te04.i) && res !== undefined) rules += res;
        }
        if (!(0, $6te04.i)) return rules;
    });
    if (!(0, $6te04.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $3ebaaabf76fb5db5$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $6te04.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $6te04.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $6lPck.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $80dPg.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $6te04.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $3ebaaabf76fb5db5$var$merge(cache.registered, css, $3ebaaabf76fb5db5$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $7fPBF.useContext((0, $6te04.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($3ebaaabf76fb5db5$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("6te04", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $4b604f9ff2f6f5b8$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $4b604f9ff2f6f5b8$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "C", function () { return $4b604f9ff2f6f5b8$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $4b604f9ff2f6f5b8$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $4b604f9ff2f6f5b8$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $4b604f9ff2f6f5b8$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $4b604f9ff2f6f5b8$export$a9c23c6ac3fc3eca; });

var $7fPBF = parcelRequire("7fPBF");

var $3mESc = parcelRequire("3mESc");

var $kY3Ke = parcelRequire("kY3Ke");

var $lT6zG = parcelRequire("lT6zG");

var $10FT7 = parcelRequire("10FT7");

var $80dPg = parcelRequire("80dPg");

var $6lPck = parcelRequire("6lPck");

var $9uXao = parcelRequire("9uXao");
var $4b604f9ff2f6f5b8$export$407448d2b89b1813 = false;
var $4b604f9ff2f6f5b8$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $4b604f9ff2f6f5b8$var$EmotionCacheContext = /* #__PURE__ */ $7fPBF.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $3mESc.default)({
    key: 'css'
}) : null);
var $4b604f9ff2f6f5b8$export$e7094788287c5e9b = $4b604f9ff2f6f5b8$var$EmotionCacheContext.Provider;
var $4b604f9ff2f6f5b8$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $7fPBF.useContext)($4b604f9ff2f6f5b8$var$EmotionCacheContext);
};
var $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $7fPBF.useContext)($4b604f9ff2f6f5b8$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$4b604f9ff2f6f5b8$export$23f2a1d2818174ef) $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $7fPBF.useContext)($4b604f9ff2f6f5b8$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $3mESc.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $7fPBF.createElement($4b604f9ff2f6f5b8$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $4b604f9ff2f6f5b8$export$971d5caa766a69d7 = /* #__PURE__ */ $7fPBF.createContext({});
var $4b604f9ff2f6f5b8$export$3b14a55fb2447963 = function useTheme() {
    return $7fPBF.useContext($4b604f9ff2f6f5b8$export$971d5caa766a69d7);
};
var $4b604f9ff2f6f5b8$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $kY3Ke.default)({}, outerTheme, theme);
};
var $4b604f9ff2f6f5b8$var$createCacheWithTheme = /* #__PURE__ */ (0, $lT6zG.default)(function(outerTheme) {
    return (0, $lT6zG.default)(function(theme) {
        return $4b604f9ff2f6f5b8$var$getTheme(outerTheme, theme);
    });
});
var $4b604f9ff2f6f5b8$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $7fPBF.useContext($4b604f9ff2f6f5b8$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $4b604f9ff2f6f5b8$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $7fPBF.createElement($4b604f9ff2f6f5b8$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $4b604f9ff2f6f5b8$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $7fPBF.forwardRef(function render(props, ref) {
        var theme = $7fPBF.useContext($4b604f9ff2f6f5b8$export$971d5caa766a69d7);
        return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $10FT7.default)(WithTheme, Component);
}
var $4b604f9ff2f6f5b8$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $4b604f9ff2f6f5b8$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $4b604f9ff2f6f5b8$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($4b604f9ff2f6f5b8$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$4b604f9ff2f6f5b8$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $4b604f9ff2f6f5b8$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $80dPg.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $9uXao.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $80dPg.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$4b604f9ff2f6f5b8$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $4b604f9ff2f6f5b8$var$Emotion = /* #__PURE__ */ $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$4b604f9ff2f6f5b8$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $80dPg.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $6lPck.serializeStyles)(registeredStyles, undefined, $7fPBF.useContext($4b604f9ff2f6f5b8$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($4b604f9ff2f6f5b8$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $4b604f9ff2f6f5b8$var$typePropName && !$4b604f9ff2f6f5b8$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($4b604f9ff2f6f5b8$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $7fPBF.createElement(WrappedComponent, newProps));
});
var $4b604f9ff2f6f5b8$export$a9c23c6ac3fc3eca = $4b604f9ff2f6f5b8$var$Emotion;

});
parcelRegister("3mESc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $273321b94be832ab$export$2e2bcd8739ae039; });

var $4cVy4 = parcelRequire("4cVy4");

var $cByrN = parcelRequire("cByrN");

var $lT6zG = parcelRequire("lT6zG");

var $4AWAi = parcelRequire("4AWAi");
var $273321b94be832ab$var$isBrowser = typeof document !== 'undefined';
var $273321b94be832ab$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $cByrN.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $cByrN.token)(character)) break;
        (0, $cByrN.next)();
    }
    return (0, $cByrN.slice)(begin, (0, $cByrN.position));
};
var $273321b94be832ab$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $cByrN.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $cByrN.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $273321b94be832ab$var$identifierWithPointTracking((0, $cByrN.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $cByrN.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $cByrN.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $cByrN.from)(character);
    }
    while (character = (0, $cByrN.next)());
    return parsed;
};
var $273321b94be832ab$var$getRules = function getRules(value, points) {
    return (0, $cByrN.dealloc)($273321b94be832ab$var$toRules((0, $cByrN.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $273321b94be832ab$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $273321b94be832ab$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$273321b94be832ab$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $273321b94be832ab$var$fixedElements.set(element, true);
    var points = [];
    var rules = $273321b94be832ab$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $273321b94be832ab$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $273321b94be832ab$var$prefix(value, length) {
    switch((0, $cByrN.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $cByrN.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $cByrN.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MOZ) + value + (0, $cByrN.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + value + value;
        // order
        case 6165:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.replace)(value, /(\w+).+(:[^]+)/, (0, $cByrN.WEBKIT) + 'box-$1$2' + (0, $cByrN.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + 'flex-item-' + (0, $cByrN.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + 'flex-line-pack' + (0, $cByrN.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $cByrN.WEBKIT) + 'box-' + (0, $cByrN.replace)(value, '-grow', '') + (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $cByrN.WEBKIT) + (0, $cByrN.replace)(value, /([^-])(transform)/g, '$1' + (0, $cByrN.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $cByrN.replace)((0, $cByrN.replace)((0, $cByrN.replace)(value, /(zoom-|grab)/, (0, $cByrN.WEBKIT) + '$1'), /(image-set)/, (0, $cByrN.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $cByrN.replace)(value, /(image-set\([^]*)/, (0, $cByrN.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $cByrN.replace)((0, $cByrN.replace)(value, /(.+:)(flex-)?(.*)/, (0, $cByrN.WEBKIT) + 'box-pack:$3' + (0, $cByrN.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $cByrN.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $cByrN.replace)(value, /(.+)-inline(.+)/, (0, $cByrN.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $cByrN.strlen)(value) - 1 - length > 6) switch((0, $cByrN.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $cByrN.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $cByrN.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $cByrN.WEBKIT) + '$2-$3' + '$1' + (0, $cByrN.MOZ) + ((0, $cByrN.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $cByrN.indexof)(value, 'stretch') ? $273321b94be832ab$var$prefix((0, $cByrN.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $cByrN.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $cByrN.charat)(value, (0, $cByrN.strlen)(value) - 3 - (~(0, $cByrN.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $cByrN.replace)(value, ':', ':' + (0, $cByrN.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $cByrN.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $cByrN.WEBKIT) + ((0, $cByrN.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $cByrN.WEBKIT) + '$2$3' + '$1' + (0, $cByrN.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $cByrN.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + value + value;
    }
    return value;
}
var $273321b94be832ab$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $cByrN.DECLARATION:
                element["return"] = $273321b94be832ab$var$prefix(element.value, element.length);
                break;
            case 0, $cByrN.KEYFRAMES:
                return (0, $cByrN.serialize)([
                    (0, $cByrN.copy)(element, {
                        value: (0, $cByrN.replace)(element.value, '@', '@' + (0, $cByrN.WEBKIT))
                    })
                ], callback);
            case 0, $cByrN.RULESET:
                if (element.length) return (0, $cByrN.combine)(element.props, function(value) {
                    switch((0, $cByrN.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $cByrN.serialize)([
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(read-\w+)/, ':' + (0, $cByrN.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $cByrN.serialize)([
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(plac\w+)/, ':' + (0, $cByrN.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(plac\w+)/, ':' + (0, $cByrN.MOZ) + '$1')
                                    ]
                                }),
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(plac\w+)/, (0, $cByrN.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $273321b94be832ab$var$getServerStylisCache = $273321b94be832ab$var$isBrowser ? undefined : (0, $lT6zG.default)(function() {
    return (0, $4AWAi.default)(function() {
        return {};
    });
});
var $273321b94be832ab$var$defaultStylisPlugins = [
    $273321b94be832ab$var$prefixer
];
var $273321b94be832ab$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($273321b94be832ab$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $273321b94be832ab$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($273321b94be832ab$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $273321b94be832ab$var$compat,
        $273321b94be832ab$var$removeLabel
    ];
    if (!$273321b94be832ab$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $cByrN.stringify),
            (0, $cByrN.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $cByrN.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $cByrN.serialize)((0, $cByrN.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $cByrN.stringify)
        ];
        var _serializer = (0, $cByrN.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $cByrN.serialize)((0, $cByrN.compile)(styles), _serializer);
        };
        var serverStylisCache = $273321b94be832ab$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $4cVy4.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("4cVy4", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $3104ec53a35158ff$export$9d753cd7ae895cce; });
var $3104ec53a35158ff$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $3104ec53a35158ff$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $3104ec53a35158ff$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $3104ec53a35158ff$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$3104ec53a35158ff$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($3104ec53a35158ff$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $3104ec53a35158ff$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("cByrN", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $83f8df0fc4bef2f6$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $83f8df0fc4bef2f6$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $83f8df0fc4bef2f6$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $83f8df0fc4bef2f6$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $83f8df0fc4bef2f6$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $83f8df0fc4bef2f6$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $83f8df0fc4bef2f6$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $83f8df0fc4bef2f6$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $83f8df0fc4bef2f6$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $83f8df0fc4bef2f6$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $83f8df0fc4bef2f6$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $83f8df0fc4bef2f6$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $83f8df0fc4bef2f6$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $83f8df0fc4bef2f6$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $83f8df0fc4bef2f6$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $83f8df0fc4bef2f6$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $83f8df0fc4bef2f6$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $83f8df0fc4bef2f6$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $83f8df0fc4bef2f6$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $83f8df0fc4bef2f6$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $83f8df0fc4bef2f6$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $83f8df0fc4bef2f6$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $83f8df0fc4bef2f6$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $83f8df0fc4bef2f6$export$38bcb760f1d4871c; });
var $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 = "-ms-";
var $83f8df0fc4bef2f6$export$2c0f367103c8d01c = "-moz-";
var $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 = "-webkit-";
var $83f8df0fc4bef2f6$export$a29989082612d0d9 = "comm";
var $83f8df0fc4bef2f6$export$aa3a2e812ca8570d = "rule";
var $83f8df0fc4bef2f6$export$527d108ccf083c2b = "decl";
var $83f8df0fc4bef2f6$export$d3d35020fa5b54f0 = "@page";
var $83f8df0fc4bef2f6$export$500415a86c544f73 = "@media";
var $83f8df0fc4bef2f6$export$a763edbf796b780a = "@import";
var $83f8df0fc4bef2f6$export$2790aeb8b4e5c826 = "@charset";
var $83f8df0fc4bef2f6$export$1cc683e23b84b133 = "@viewport";
var $83f8df0fc4bef2f6$export$9447a5efea57e862 = "@supports";
var $83f8df0fc4bef2f6$export$ef011b4e114b1fba = "@document";
var $83f8df0fc4bef2f6$export$6aad947bda0f3f46 = "@namespace";
var $83f8df0fc4bef2f6$export$b44a8529a35fcb60 = "@keyframes";
var $83f8df0fc4bef2f6$export$2c16de31893252e6 = "@font-face";
var $83f8df0fc4bef2f6$export$3d846dd52e150c6f = "@counter-style";
var $83f8df0fc4bef2f6$export$22314bfbb57653fe = "@font-feature-values";
var $83f8df0fc4bef2f6$export$d773506282b3cfe6 = "@layer";
var $83f8df0fc4bef2f6$export$2335f513bbd82c6d = Math.abs;
var $83f8df0fc4bef2f6$export$6788812c4e6611e6 = String.fromCharCode;
var $83f8df0fc4bef2f6$export$e6e34fd1f2686227 = Object.assign;
function $83f8df0fc4bef2f6$export$d6af199866bfb566(e, r) {
    return $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 0)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 1)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 2)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 3) : 0;
}
function $83f8df0fc4bef2f6$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $83f8df0fc4bef2f6$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $83f8df0fc4bef2f6$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $83f8df0fc4bef2f6$export$36776f635604f274(e) {
    return e.length;
}
function $83f8df0fc4bef2f6$export$f9084667e487ed46(e) {
    return e.length;
}
function $83f8df0fc4bef2f6$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $83f8df0fc4bef2f6$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c = 1;
var $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1;
var $83f8df0fc4bef2f6$export$f24224f1c91d8156 = 0;
var $83f8df0fc4bef2f6$export$5880b8b5730aff45 = 0;
var $83f8df0fc4bef2f6$export$c0306caf338ac095 = 0;
var $83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = "";
function $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c,
        column: $83f8df0fc4bef2f6$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $83f8df0fc4bef2f6$export$784d13d8ee351f07(e, r) {
    return $83f8df0fc4bef2f6$export$e6e34fd1f2686227($83f8df0fc4bef2f6$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $83f8df0fc4bef2f6$export$eba6f6f03b0a92e7() {
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$232faf9add678146() {
    $83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$5880b8b5730aff45 > 0 ? $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, --$83f8df0fc4bef2f6$export$5880b8b5730aff45) : 0;
    if ($83f8df0fc4bef2f6$export$4e0c71f277ca26b3--, $83f8df0fc4bef2f6$export$c0306caf338ac095 === 10) $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c--;
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$48cfd1e771a65c4f() {
    $83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$5880b8b5730aff45 < $83f8df0fc4bef2f6$export$f24224f1c91d8156 ? $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, $83f8df0fc4bef2f6$export$5880b8b5730aff45++) : 0;
    if ($83f8df0fc4bef2f6$export$4e0c71f277ca26b3++, $83f8df0fc4bef2f6$export$c0306caf338ac095 === 10) $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c++;
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() {
    return $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, $83f8df0fc4bef2f6$export$5880b8b5730aff45);
}
function $83f8df0fc4bef2f6$export$e88cb2efb12ae807() {
    return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
}
function $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, r) {
    return $83f8df0fc4bef2f6$export$2f35ab04d2335697($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, e, r);
}
function $83f8df0fc4bef2f6$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $83f8df0fc4bef2f6$export$2de70f21292aac9e(e) {
    return $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c = $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$f24224f1c91d8156 = $83f8df0fc4bef2f6$export$36776f635604f274($83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = e), $83f8df0fc4bef2f6$export$5880b8b5730aff45 = 0, [];
}
function $83f8df0fc4bef2f6$export$45918ac1574455b1(e) {
    return $83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = "", e;
}
function $83f8df0fc4bef2f6$export$410ac95b9ec204b8(e) {
    return $83f8df0fc4bef2f6$export$87c2784dc9fc4ab($83f8df0fc4bef2f6$export$58adb3bec8346d0f($83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1, $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $83f8df0fc4bef2f6$export$660b2ee2d4fb4eff(e) {
    return $83f8df0fc4bef2f6$export$45918ac1574455b1($83f8df0fc4bef2f6$export$5f8c09e3ae6f64e1($83f8df0fc4bef2f6$export$2de70f21292aac9e(e)));
}
function $83f8df0fc4bef2f6$export$7af1228ff777d175(e) {
    while($83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$4d3fb11e950abb9e())if ($83f8df0fc4bef2f6$export$c0306caf338ac095 < 33) $83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
    else break;
    return $83f8df0fc4bef2f6$export$9e1725a4cfeada27(e) > 2 || $83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $83f8df0fc4bef2f6$export$5f8c09e3ae6f64e1(e) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())switch($83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$c0306caf338ac095)){
        case 0:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$c2ab62c7bf24634($83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$410ac95b9ec204b8($83f8df0fc4bef2f6$export$c0306caf338ac095), e);
            break;
        default:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$6788812c4e6611e6($83f8df0fc4bef2f6$export$c0306caf338ac095), e);
    }
    return e;
}
function $83f8df0fc4bef2f6$export$955ba06d119e085e(e, r) {
    while(--r && $83f8df0fc4bef2f6$export$48cfd1e771a65c4f())if ($83f8df0fc4bef2f6$export$c0306caf338ac095 < 48 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 102 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 57 && $83f8df0fc4bef2f6$export$c0306caf338ac095 < 65 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 70 && $83f8df0fc4bef2f6$export$c0306caf338ac095 < 97) break;
    return $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, $83f8df0fc4bef2f6$export$e88cb2efb12ae807() + (r < 6 && $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() == 32 && $83f8df0fc4bef2f6$export$48cfd1e771a65c4f() == 32));
}
function $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())switch($83f8df0fc4bef2f6$export$c0306caf338ac095){
        case e:
            return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $83f8df0fc4bef2f6$export$c889f2fcc19dbf12($83f8df0fc4bef2f6$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
            break;
    }
    return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
}
function $83f8df0fc4bef2f6$export$4254d4e2b3745c4c(e, r) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())if (e + $83f8df0fc4bef2f6$export$c0306caf338ac095 === 57) break;
    else if (e + $83f8df0fc4bef2f6$export$c0306caf338ac095 === 84 && $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $83f8df0fc4bef2f6$export$58adb3bec8346d0f(r, $83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1) + "*" + $83f8df0fc4bef2f6$export$6788812c4e6611e6(e === 47 ? e : $83f8df0fc4bef2f6$export$48cfd1e771a65c4f());
}
function $83f8df0fc4bef2f6$export$c2ab62c7bf24634(e) {
    while(!$83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$4d3fb11e950abb9e()))$83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
    return $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, $83f8df0fc4bef2f6$export$5880b8b5730aff45);
}
function $83f8df0fc4bef2f6$export$ef7acd7185315e22(e) {
    return $83f8df0fc4bef2f6$export$45918ac1574455b1($83f8df0fc4bef2f6$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $83f8df0fc4bef2f6$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $83f8df0fc4bef2f6$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $83f8df0fc4bef2f6$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $83f8df0fc4bef2f6$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($83f8df0fc4bef2f6$export$f8e21b1e77979a08(j += $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $83f8df0fc4bef2f6$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $83f8df0fc4bef2f6$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $83f8df0fc4bef2f6$export$955ba06d119e085e($83f8df0fc4bef2f6$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($83f8df0fc4bef2f6$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$4a34f930e789283c($83f8df0fc4bef2f6$export$4254d4e2b3745c4c($83f8df0fc4bef2f6$export$48cfd1e771a65c4f(), $83f8df0fc4bef2f6$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $83f8df0fc4bef2f6$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $83f8df0fc4bef2f6$export$36776f635604f274(j) - l) $83f8df0fc4bef2f6$export$10d8903dec122b9d(p > 32 ? $83f8df0fc4bef2f6$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $83f8df0fc4bef2f6$export$f8483753829ec8f3($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $83f8df0fc4bef2f6$export$10d8903dec122b9d(y = $83f8df0fc4bef2f6$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $83f8df0fc4bef2f6$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $83f8df0fc4bef2f6$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $83f8df0fc4bef2f6$export$98e6a39c04603d36(e, y, y, n && $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $83f8df0fc4bef2f6$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $83f8df0fc4bef2f6$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $83f8df0fc4bef2f6$export$232faf9add678146() == 125) continue;
            }
            switch(j += $83f8df0fc4bef2f6$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($83f8df0fc4bef2f6$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($83f8df0fc4bef2f6$export$4d3fb11e950abb9e() === 45) j += $83f8df0fc4bef2f6$export$410ac95b9ec204b8($83f8df0fc4bef2f6$export$48cfd1e771a65c4f());
                    v = $83f8df0fc4bef2f6$export$4d3fb11e950abb9e(), o = l = $83f8df0fc4bef2f6$export$36776f635604f274(g = j += $83f8df0fc4bef2f6$export$c2ab62c7bf24634($83f8df0fc4bef2f6$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $83f8df0fc4bef2f6$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $83f8df0fc4bef2f6$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $83f8df0fc4bef2f6$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, v + 1, v = $83f8df0fc4bef2f6$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $83f8df0fc4bef2f6$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, s === 0 ? $83f8df0fc4bef2f6$export$aa3a2e812ca8570d : i, f, o, l);
}
function $83f8df0fc4bef2f6$export$4a34f930e789283c(e, r, a) {
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, $83f8df0fc4bef2f6$export$a29989082612d0d9, $83f8df0fc4bef2f6$export$6788812c4e6611e6($83f8df0fc4bef2f6$export$eba6f6f03b0a92e7()), $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $83f8df0fc4bef2f6$export$f8483753829ec8f3(e, r, a, n) {
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, $83f8df0fc4bef2f6$export$527d108ccf083c2b, $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, 0, n), $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $83f8df0fc4bef2f6$export$82e9f45cca5ba907(n, c, s) {
    switch($83f8df0fc4bef2f6$export$d6af199866bfb566(n, c)){
        case 5103:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $83f8df0fc4bef2f6$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-$1$2" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-item-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-row-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-line-pack" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-grow", "") + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-pack:$3" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-column-align" + $83f8df0fc4bef2f6$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(s, "span") ? $83f8df0fc4bef2f6$export$4659b591c19bdf3d(s, /\d+/) : +$83f8df0fc4bef2f6$export$4659b591c19bdf3d(s, /\d+/) - +$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($83f8df0fc4bef2f6$export$36776f635604f274(n) - 1 - c > 6) switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(n, "stretch") ? $83f8df0fc4bef2f6$export$82e9f45cca5ba907($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 6) === 121) return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, ":", ":" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, $83f8df0fc4bef2f6$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, ":", ":" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $83f8df0fc4bef2f6$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $83f8df0fc4bef2f6$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $83f8df0fc4bef2f6$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $83f8df0fc4bef2f6$export$a763edbf796b780a:
        case $83f8df0fc4bef2f6$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $83f8df0fc4bef2f6$export$a29989082612d0d9:
            return "";
        case $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $83f8df0fc4bef2f6$export$36776f635604f274(a = $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $83f8df0fc4bef2f6$export$5a7767152ae0305f(e) {
    var r = $83f8df0fc4bef2f6$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $83f8df0fc4bef2f6$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $83f8df0fc4bef2f6$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $83f8df0fc4bef2f6$export$527d108ccf083c2b:
                n.return = $83f8df0fc4bef2f6$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
                return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                    $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                        value: $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
                if (n.length) return $83f8df0fc4bef2f6$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($83f8df0fc4bef2f6$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $83f8df0fc4bef2f6$export$76a88f7de6507443(e) {
    switch(e.type){
        case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $83f8df0fc4bef2f6$export$1be1fc439b849fdf($83f8df0fc4bef2f6$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($83f8df0fc4bef2f6$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $83f8df0fc4bef2f6$export$2f35ab04d2335697(r, 1, $83f8df0fc4bef2f6$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $83f8df0fc4bef2f6$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $83f8df0fc4bef2f6$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $83f8df0fc4bef2f6$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("lT6zG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fef3d59b736200bc$export$2e2bcd8739ae039; });
var $fef3d59b736200bc$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("4AWAi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3587f7e2ed7416b3$export$2e2bcd8739ae039; });
function $3587f7e2ed7416b3$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("10FT7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bc6489980e08e1c$export$2e2bcd8739ae039; });

var $8Ae2G = parcelRequire("8Ae2G");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $0bc6489980e08e1c$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8Ae2G)))(targetComponent, sourceComponent);
};

});
parcelRegister("8Ae2G", function(module, exports) {
'use strict';

var $j2VHG = parcelRequire("j2VHG");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $63fc9407ef8fcdfe$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $63fc9407ef8fcdfe$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$TYPE_STATICS = {};
$63fc9407ef8fcdfe$var$TYPE_STATICS[$j2VHG.ForwardRef] = $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS;
$63fc9407ef8fcdfe$var$TYPE_STATICS[$j2VHG.Memo] = $63fc9407ef8fcdfe$var$MEMO_STATICS;
function $63fc9407ef8fcdfe$var$getStatics(component) {
    // React v16.11 and below
    if ($j2VHG.isMemo(component)) return $63fc9407ef8fcdfe$var$MEMO_STATICS;
     // React v16.12 and above
    return $63fc9407ef8fcdfe$var$TYPE_STATICS[component['$$typeof']] || $63fc9407ef8fcdfe$var$REACT_STATICS;
}
var $63fc9407ef8fcdfe$var$defineProperty = Object.defineProperty;
var $63fc9407ef8fcdfe$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $63fc9407ef8fcdfe$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $63fc9407ef8fcdfe$var$getPrototypeOf = Object.getPrototypeOf;
var $63fc9407ef8fcdfe$var$objectPrototype = Object.prototype;
function $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($63fc9407ef8fcdfe$var$objectPrototype) {
            var inheritedComponent = $63fc9407ef8fcdfe$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $63fc9407ef8fcdfe$var$objectPrototype) $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $63fc9407ef8fcdfe$var$getOwnPropertyNames(sourceComponent);
        if ($63fc9407ef8fcdfe$var$getOwnPropertySymbols) keys = keys.concat($63fc9407ef8fcdfe$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $63fc9407ef8fcdfe$var$getStatics(targetComponent);
        var sourceStatics = $63fc9407ef8fcdfe$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$63fc9407ef8fcdfe$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $63fc9407ef8fcdfe$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $63fc9407ef8fcdfe$var$hoistNonReactStatics;

});
parcelRegister("j2VHG", function(module, exports) {
'use strict';

module.exports = (parcelRequire("45MkT"));

});



parcelRegister("80dPg", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $5d390c582efd47c3$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $5d390c582efd47c3$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $5d390c582efd47c3$export$6f077d94b33a01aa; });
var $5d390c582efd47c3$var$isBrowser = typeof document !== 'undefined';
function $5d390c582efd47c3$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5d390c582efd47c3$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5d390c582efd47c3$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5d390c582efd47c3$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5d390c582efd47c3$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$5d390c582efd47c3$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5d390c582efd47c3$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("6lPck", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $49fc6b0b9a1bf345$export$6321afa313b251b5; });

var $1OEsj = parcelRequire("1OEsj");

var $cfR4M = parcelRequire("cfR4M");

var $4AWAi = parcelRequire("4AWAi");
var $49fc6b0b9a1bf345$var$isDevelopment = false;
var $49fc6b0b9a1bf345$var$hyphenateRegex = /[A-Z]|^ms/g;
var $49fc6b0b9a1bf345$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $49fc6b0b9a1bf345$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $49fc6b0b9a1bf345$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $49fc6b0b9a1bf345$var$processStyleName = /* #__PURE__ */ (0, $4AWAi.default)(function(styleName) {
    return $49fc6b0b9a1bf345$var$isCustomProperty(styleName) ? styleName : styleName.replace($49fc6b0b9a1bf345$var$hyphenateRegex, '-$&').toLowerCase();
});
var $49fc6b0b9a1bf345$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($49fc6b0b9a1bf345$var$animationRegex, function(match, p1, p2) {
                $49fc6b0b9a1bf345$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $49fc6b0b9a1bf345$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cfR4M.default)[key] !== 1 && !$49fc6b0b9a1bf345$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $49fc6b0b9a1bf345$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $49fc6b0b9a1bf345$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $49fc6b0b9a1bf345$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $49fc6b0b9a1bf345$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $49fc6b0b9a1bf345$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $49fc6b0b9a1bf345$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $49fc6b0b9a1bf345$var$cursor;
                var result = interpolation(mergedProps);
                $49fc6b0b9a1bf345$var$cursor = previousCursor;
                return $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $49fc6b0b9a1bf345$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($49fc6b0b9a1bf345$var$isProcessableValue(asString)) string += $49fc6b0b9a1bf345$var$processStyleName(key) + ":" + $49fc6b0b9a1bf345$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $49fc6b0b9a1bf345$var$isDevelopment) throw new Error($49fc6b0b9a1bf345$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($49fc6b0b9a1bf345$var$isProcessableValue(value[_i])) string += $49fc6b0b9a1bf345$var$processStyleName(key) + ":" + $49fc6b0b9a1bf345$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $49fc6b0b9a1bf345$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $49fc6b0b9a1bf345$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $49fc6b0b9a1bf345$var$cursor;
function $49fc6b0b9a1bf345$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $49fc6b0b9a1bf345$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $49fc6b0b9a1bf345$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $49fc6b0b9a1bf345$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $1OEsj.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $49fc6b0b9a1bf345$var$cursor
    };
}

});
parcelRegister("1OEsj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1529d79d9aa6f066$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $1529d79d9aa6f066$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("cfR4M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039; });
var $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("9uXao", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $6ea4cfa701df259a$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $6ea4cfa701df259a$export$811a713a7276cb9d; });

var $7fPBF = parcelRequire("7fPBF");
var $6ea4cfa701df259a$var$isBrowser = typeof document !== 'undefined';
var $6ea4cfa701df259a$var$syncFallback = function syncFallback(create) {
    return create();
};
var $6ea4cfa701df259a$var$useInsertionEffect = $7fPBF.useInsertionEffect ? $7fPBF.useInsertionEffect : false;
var $6ea4cfa701df259a$export$db21c7ffa21794e7 = !$6ea4cfa701df259a$var$isBrowser ? $6ea4cfa701df259a$var$syncFallback : $6ea4cfa701df259a$var$useInsertionEffect || $6ea4cfa701df259a$var$syncFallback;
var $6ea4cfa701df259a$export$811a713a7276cb9d = $6ea4cfa701df259a$var$useInsertionEffect || $7fPBF.useLayoutEffect;

});


parcelRegister("cvBp9", function(module, exports) {
function $91b5651481cc9d5c$var$_extends() {
    return module.exports = $91b5651481cc9d5c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $91b5651481cc9d5c$var$_extends.apply(null, arguments);
}
module.exports = $91b5651481cc9d5c$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("gU1gT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4e2dcce0ba73648$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("5nUae");
var $6te04 = parcelRequire("6te04");
'use client';
function $c4e2dcce0ba73648$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $c4e2dcce0ba73648$var$useTheme(defaultTheme = null) {
    const contextTheme = $7fPBF.useContext((0, $6te04.T));
    return !contextTheme || $c4e2dcce0ba73648$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $c4e2dcce0ba73648$export$2e2bcd8739ae039 = $c4e2dcce0ba73648$var$useTheme;

});

parcelRegister("kyirV", function(module, exports) {

$parcel$export(module.exports, "useRtl", function () { return $ef654b446fc390d6$export$b2dd014b6c321cb; });
$parcel$export(module.exports, "default", function () { return $ef654b446fc390d6$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $bbzbN = parcelRequire("bbzbN");
'use client';
const $ef654b446fc390d6$var$RtlContext = /*#__PURE__*/ $7fPBF.createContext();
function $ef654b446fc390d6$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)($ef654b446fc390d6$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $ef654b446fc390d6$export$b2dd014b6c321cb = ()=>{
    const value = $7fPBF.useContext($ef654b446fc390d6$var$RtlContext);
    return value ?? false;
};
var $ef654b446fc390d6$export$2e2bcd8739ae039 = $ef654b446fc390d6$var$RtlProvider;

});

parcelRegister("7eatR", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $5431f86afe49fae8$export$2440da353cedad43; });
$parcel$export(module.exports, "default", function () { return $5431f86afe49fae8$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $gjk5S = parcelRequire("gjk5S");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $5431f86afe49fae8$var$PropsContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
function $5431f86afe49fae8$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)($5431f86afe49fae8$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $5431f86afe49fae8$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $gjk5S.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $gjk5S.default)(config, props);
    return props;
}
function $5431f86afe49fae8$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $7fPBF.useContext($5431f86afe49fae8$var$PropsContext);
    return $5431f86afe49fae8$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $5431f86afe49fae8$export$2e2bcd8739ae039 = $5431f86afe49fae8$var$DefaultPropsProvider;

});
parcelRegister("gjk5S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdfe01df7c24351f$export$2e2bcd8739ae039; });
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @returns resolved props
 */ function $bdfe01df7c24351f$export$2e2bcd8739ae039(defaultProps, props) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $bdfe01df7c24351f$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                }
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}

});


parcelRegister("k9qD2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eab94dcf3e175f98$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $lJRRs = parcelRequire("lJRRs");

var $65Itt = parcelRequire("65Itt");

var $krgTN = parcelRequire("krgTN");

var $gU1gT = parcelRequire("gU1gT");

var $bbzbN = parcelRequire("bbzbN");
function $eab94dcf3e175f98$export$2e2bcd8739ae039(theme) {
    const upperTheme = (0, $gU1gT.default)();
    const id = (0, $65Itt.default)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $lJRRs.default)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && firstChild.hasAttribute?.('data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else head.querySelector(`style[data-mui-layer-order="${id}"]`)?.remove();
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $krgTN.default), {
        styles: layerOrder
    });
}

});
parcelRegister("lJRRs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd3794ae41ea97a8$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $fd3794ae41ea97a8$var$useEnhancedEffect = typeof window !== 'undefined' ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
var $fd3794ae41ea97a8$export$2e2bcd8739ae039 = $fd3794ae41ea97a8$var$useEnhancedEffect;

});

parcelRegister("65Itt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46f5b561912058f9$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
'use client';
let $46f5b561912058f9$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $46f5b561912058f9$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $7fPBF.useState(idOverride);
    const id = idOverride || defaultId;
    $7fPBF.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $46f5b561912058f9$var$globalId += 1;
            setDefaultId(`mui-${$46f5b561912058f9$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $46f5b561912058f9$var$safeReact = {
    ...$7fPBF
};
const $46f5b561912058f9$var$maybeReactUseId = $46f5b561912058f9$var$safeReact.useId;
function $46f5b561912058f9$export$2e2bcd8739ae039(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($46f5b561912058f9$var$maybeReactUseId !== undefined) {
        const reactId = $46f5b561912058f9$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $46f5b561912058f9$var$useGlobalId(idOverride);
}

});

parcelRegister("krgTN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee13700d4d997375$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");


var $5tMhb = parcelRequire("5tMhb");
var $5VCcJ = parcelRequire("5VCcJ");

var $dSbTr = parcelRequire("dSbTr");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $ee13700d4d997375$var$wrapGlobalLayer(styles) {
    const serialized = (0, $5VCcJ.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $ee13700d4d997375$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $dSbTr.default)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $ee13700d4d997375$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $ee13700d4d997375$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $ee13700d4d997375$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5tMhb.default), {
        styles: globalStyles
    });
}
var $ee13700d4d997375$export$2e2bcd8739ae039 = $ee13700d4d997375$var$GlobalStyles;

});
parcelRegister("5tMhb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fd51bd676aa60b7$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");


var $5nUae = parcelRequire("5nUae");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $3fd51bd676aa60b7$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $3fd51bd676aa60b7$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($3fd51bd676aa60b7$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5nUae.Global), {
        styles: globalStyles
    });
}

});

parcelRegister("5VCcJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $450fe936b88a7a32$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_mutateStyles", function () { return $450fe936b88a7a32$export$592c7226e4cb0171; });
$parcel$export(module.exports, "internal_serializeStyles", function () { return $450fe936b88a7a32$export$13a2d3ef13012b32; });
/**
 * @mui/styled-engine v6.5.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ 
var $70jUf = parcelRequire("70jUf");

var $6lPck = parcelRequire("6lPck");

var $5nUae = parcelRequire("5nUae");
var $6te04 = parcelRequire("6te04");

var $e6xq6 = parcelRequire("e6xq6");

var $5tMhb = parcelRequire("5tMhb");
function $450fe936b88a7a32$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $70jUf.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
function $450fe936b88a7a32$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $450fe936b88a7a32$var$wrapper = [];
function $450fe936b88a7a32$export$13a2d3ef13012b32(styles) {
    $450fe936b88a7a32$var$wrapper[0] = styles;
    return (0, $6lPck.serializeStyles)($450fe936b88a7a32$var$wrapper);
}

});
parcelRegister("70jUf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5197f9709daec52b$export$2e2bcd8739ae039; });

var $lmsDT = parcelRequire("lmsDT");
parcelRequire("cvBp9");

parcelRequire("6lPck");
parcelRequire("9uXao");
parcelRequire("80dPg");
parcelRequire("7fPBF");
parcelRequire("9YmaI");
var $5197f9709daec52b$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $5197f9709daec52b$export$2e2bcd8739ae039 = (0, $lmsDT.default).bind(null);
$5197f9709daec52b$var$tags.forEach(function(tagName) {
    $5197f9709daec52b$export$2e2bcd8739ae039[tagName] = $5197f9709daec52b$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("lmsDT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8d1dedc3623dfeb$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("5nUae");
var $6te04 = parcelRequire("6te04");

var $6lPck = parcelRequire("6lPck");

var $9uXao = parcelRequire("9uXao");

var $80dPg = parcelRequire("80dPg");

var $7fPBF = parcelRequire("7fPBF");

var $9YmaI = parcelRequire("9YmaI");
var $f8d1dedc3623dfeb$var$isBrowser = typeof document !== 'undefined';
var $f8d1dedc3623dfeb$var$isDevelopment = false;
var $f8d1dedc3623dfeb$var$testOmitPropsOnStringTag = (0, $9YmaI.default);
var $f8d1dedc3623dfeb$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $f8d1dedc3623dfeb$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $f8d1dedc3623dfeb$var$testOmitPropsOnStringTag : $f8d1dedc3623dfeb$var$testOmitPropsOnComponent;
};
var $f8d1dedc3623dfeb$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $f8d1dedc3623dfeb$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $80dPg.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $9uXao.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $80dPg.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$f8d1dedc3623dfeb$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $f8d1dedc3623dfeb$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $f8d1dedc3623dfeb$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $f8d1dedc3623dfeb$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $6te04.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $7fPBF.useContext((0, $6te04.T));
            }
            if (typeof props.className === 'string') className = (0, $80dPg.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $6lPck.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $f8d1dedc3623dfeb$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($f8d1dedc3623dfeb$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $7fPBF.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $f8d1dedc3623dfeb$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $kY3Ke.default)({}, options, nextOptions, {
                shouldForwardProp: $f8d1dedc3623dfeb$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("9YmaI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $742aea85e4e67b26$export$2e2bcd8739ae039; });

var $4AWAi = parcelRequire("4AWAi");
// eslint-disable-next-line no-undef
var $742aea85e4e67b26$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $742aea85e4e67b26$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $4AWAi.default)(function(prop) {
    return $742aea85e4e67b26$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("e6xq6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a44b8cbd62c27155$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $6te04 = parcelRequire("6te04");

var $3mESc = parcelRequire("3mESc");

var $4cVy4 = parcelRequire("4cVy4");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $a44b8cbd62c27155$var$cacheMap = new Map();
const $a44b8cbd62c27155$export$5a3f4e255fc47e86 = {
    /**
   * to intercept the generated CSS before inserting to the style tag, so that we can check the generated CSS.
   *
   * let rule;
   * TEST_INTERNALS_DO_NOT_USE.insert = (...args) => {
   *    rule = args[0];
   * };
   *
   * expect(rule).to.equal(...);
   */ insert: undefined
};
// We might be able to remove this when this issue is fixed:
// https://github.com/emotion-js/emotion/issues/2790
const $a44b8cbd62c27155$var$createEmotionCache = (options, CustomSheet)=>{
    const cache = (0, $3mESc.default)(options);
    // Do the same as https://github.com/emotion-js/emotion/blob/main/packages/cache/src/index.js#L238-L245
    cache.sheet = new CustomSheet({
        key: cache.key,
        nonce: cache.sheet.nonce,
        container: cache.sheet.container,
        speedy: cache.sheet.isSpeedy,
        prepend: cache.sheet.prepend,
        insertionPoint: cache.sheet.insertionPoint
    });
    return cache;
};
let $a44b8cbd62c27155$var$insertionPoint;
if (typeof document === 'object') {
    // Use `insertionPoint` over `prepend`(deprecated) because it can be controlled for GlobalStyles injection order
    // For more information, see https://github.com/mui/material-ui/issues/44597
    $a44b8cbd62c27155$var$insertionPoint = document.querySelector('[name="emotion-insertion-point"]');
    if (!$a44b8cbd62c27155$var$insertionPoint) {
        $a44b8cbd62c27155$var$insertionPoint = document.createElement('meta');
        $a44b8cbd62c27155$var$insertionPoint.setAttribute('name', 'emotion-insertion-point');
        $a44b8cbd62c27155$var$insertionPoint.setAttribute('content', '');
        const head = document.querySelector('head');
        if (head) head.prepend($a44b8cbd62c27155$var$insertionPoint);
    }
}
function $a44b8cbd62c27155$var$getCache(injectFirst, enableCssLayer) {
    if (injectFirst || enableCssLayer) {
        /**
     * This is for client-side apps only.
     * A custom sheet is required to make the GlobalStyles API injected above the insertion point.
     * This is because the [sheet](https://github.com/emotion-js/emotion/blob/main/packages/react/src/global.js#L94-L99) does not consume the options.
     */ class MyStyleSheet extends (0, $4cVy4.StyleSheet) {
            insert(rule, options) {
                if ($a44b8cbd62c27155$export$5a3f4e255fc47e86.insert) return $a44b8cbd62c27155$export$5a3f4e255fc47e86.insert(rule, options);
                if (this.key && this.key.endsWith('global')) this.before = $a44b8cbd62c27155$var$insertionPoint;
                return super.insert(rule, options);
            }
        }
        const emotionCache = $a44b8cbd62c27155$var$createEmotionCache({
            key: 'css',
            insertionPoint: injectFirst ? $a44b8cbd62c27155$var$insertionPoint : undefined
        }, MyStyleSheet);
        if (enableCssLayer) {
            const prevInsert = emotionCache.insert;
            emotionCache.insert = (...args)=>{
                if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
                args[1].styles = `@layer mui {${args[1].styles}}`;
                return prevInsert(...args);
            };
        }
        return emotionCache;
    }
    return undefined;
}
function $a44b8cbd62c27155$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $7fPBF.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && $a44b8cbd62c27155$var$cacheMap.has(cacheKey)) return $a44b8cbd62c27155$var$cacheMap.get(cacheKey);
        const fresh = $a44b8cbd62c27155$var$getCache(injectFirst, enableCssLayer);
        $a44b8cbd62c27155$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    return cache ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6te04.C), {
        value: cache,
        children: children
    }) : children;
}

});


parcelRegister("dSbTr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $029b402e8bc1f29f$export$2e2bcd8739ae039; });

var $2G6xE = parcelRequire("2G6xE");

var $gU1gT = parcelRequire("gU1gT");
'use client';
const $029b402e8bc1f29f$export$35e57303dbd8a66 = (0, $2G6xE.default)();
function $029b402e8bc1f29f$var$useTheme(defaultTheme = $029b402e8bc1f29f$export$35e57303dbd8a66) {
    return (0, $gU1gT.default)(defaultTheme);
}
var $029b402e8bc1f29f$export$2e2bcd8739ae039 = $029b402e8bc1f29f$var$useTheme;

});
parcelRegister("2G6xE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f34940f58017e5f$export$2e2bcd8739ae039; });

var $3wRTY = parcelRequire("3wRTY");

var $kti2v = parcelRequire("kti2v");

var $315Pc = parcelRequire("315Pc");

var $l8Cag = parcelRequire("l8Cag");

var $GLqnW = parcelRequire("GLqnW");

var $8M6a3 = parcelRequire("8M6a3");

var $hXGiu = parcelRequire("hXGiu");

var $56TFl = parcelRequire("56TFl");
function $1f34940f58017e5f$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $kti2v.default)(breakpointsInput);
    const spacing = (0, $GLqnW.default)(spacingInput);
    let muiTheme = (0, $3wRTY.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $l8Cag.default),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $315Pc.default)(muiTheme);
    muiTheme.applyStyles = (0, $56TFl.default);
    muiTheme = args.reduce((acc, argument)=>(0, $3wRTY.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $hXGiu.default),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $8M6a3.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $1f34940f58017e5f$export$2e2bcd8739ae039 = $1f34940f58017e5f$var$createTheme;

});
parcelRegister("3wRTY", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $291e2c063c5d6173$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $291e2c063c5d6173$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $61wrp = parcelRequire("61wrp");
function $291e2c063c5d6173$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $291e2c063c5d6173$var$deepClone(source) {
    if (/*#__PURE__*/ $7fPBF.isValidElement(source) || (0, $61wrp.isValidElementType)(source) || !$291e2c063c5d6173$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $291e2c063c5d6173$var$deepClone(source[key]);
    });
    return output;
}
function $291e2c063c5d6173$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($291e2c063c5d6173$export$53b83ca8eaab0383(target) && $291e2c063c5d6173$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $7fPBF.isValidElement(source[key]) || (0, $61wrp.isValidElementType)(source[key])) output[key] = source[key];
        else if ($291e2c063c5d6173$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $291e2c063c5d6173$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $291e2c063c5d6173$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $291e2c063c5d6173$export$53b83ca8eaab0383(source[key]) ? $291e2c063c5d6173$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});
parcelRegister("61wrp", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kzuP0"));

});
parcelRegister("kzuP0", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $ef9efc139901a96c$export$a7c73072b1a182ae; }, function (v) { return $ef9efc139901a96c$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $ef9efc139901a96c$export$9f27bc3417b4524d; }, function (v) { return $ef9efc139901a96c$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $ef9efc139901a96c$export$db77ccec0bb4ccac; }, function (v) { return $ef9efc139901a96c$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $ef9efc139901a96c$export$8392c0c9d3dcbd35; }, function (v) { return $ef9efc139901a96c$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $ef9efc139901a96c$export$ffb0004e005737fa; }, function (v) { return $ef9efc139901a96c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $ef9efc139901a96c$export$b624eff549462981; }, function (v) { return $ef9efc139901a96c$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $ef9efc139901a96c$export$7897aa7841a5380c; }, function (v) { return $ef9efc139901a96c$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $ef9efc139901a96c$export$602eac185826482c; }, function (v) { return $ef9efc139901a96c$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $ef9efc139901a96c$export$e2c29f18771995cb; }, function (v) { return $ef9efc139901a96c$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $ef9efc139901a96c$export$5f8d39834fd61797; }, function (v) { return $ef9efc139901a96c$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $ef9efc139901a96c$export$74bf444e3cd11ea5; }, function (v) { return $ef9efc139901a96c$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $ef9efc139901a96c$export$998bcd577473dd93; }, function (v) { return $ef9efc139901a96c$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $ef9efc139901a96c$export$b706b080d889d2c9; }, function (v) { return $ef9efc139901a96c$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $ef9efc139901a96c$export$5be5a87408f70ddc; }, function (v) { return $ef9efc139901a96c$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $ef9efc139901a96c$export$45a5e7f76e0caa8d; }, function (v) { return $ef9efc139901a96c$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $ef9efc139901a96c$export$455c2e768291efa6; }, function (v) { return $ef9efc139901a96c$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $ef9efc139901a96c$export$9522e17588c12572; }, function (v) { return $ef9efc139901a96c$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $ef9efc139901a96c$export$2110ac352bb060b9; }, function (v) { return $ef9efc139901a96c$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $ef9efc139901a96c$export$56885ab8b9c456ab; }, function (v) { return $ef9efc139901a96c$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $ef9efc139901a96c$export$d927fcb6adf8f9de; }, function (v) { return $ef9efc139901a96c$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $ef9efc139901a96c$export$b82d16f27459e05a; }, function (v) { return $ef9efc139901a96c$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $ef9efc139901a96c$export$522c17b4f5e123e8; }, function (v) { return $ef9efc139901a96c$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $ef9efc139901a96c$export$1aabd8a0274ecfd6; }, function (v) { return $ef9efc139901a96c$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $ef9efc139901a96c$export$3d6c20d97e46b957; }, function (v) { return $ef9efc139901a96c$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $ef9efc139901a96c$export$9b621391a187a31a; }, function (v) { return $ef9efc139901a96c$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $ef9efc139901a96c$export$f5bbd400c2f4426f; }, function (v) { return $ef9efc139901a96c$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ef9efc139901a96c$export$a7c73072b1a182ae;
var $ef9efc139901a96c$export$9f27bc3417b4524d;
var $ef9efc139901a96c$export$db77ccec0bb4ccac;
var $ef9efc139901a96c$export$8392c0c9d3dcbd35;
var $ef9efc139901a96c$export$ffb0004e005737fa;
var $ef9efc139901a96c$export$b624eff549462981;
var $ef9efc139901a96c$export$7897aa7841a5380c;
var $ef9efc139901a96c$export$602eac185826482c;
var $ef9efc139901a96c$export$e2c29f18771995cb;
var $ef9efc139901a96c$export$5f8d39834fd61797;
var $ef9efc139901a96c$export$74bf444e3cd11ea5;
var $ef9efc139901a96c$export$998bcd577473dd93;
var $ef9efc139901a96c$export$b706b080d889d2c9;
var $ef9efc139901a96c$export$5be5a87408f70ddc;
var $ef9efc139901a96c$export$45a5e7f76e0caa8d;
var $ef9efc139901a96c$export$455c2e768291efa6;
var $ef9efc139901a96c$export$9522e17588c12572;
var $ef9efc139901a96c$export$2110ac352bb060b9;
var $ef9efc139901a96c$export$56885ab8b9c456ab;
var $ef9efc139901a96c$export$d927fcb6adf8f9de;
var $ef9efc139901a96c$export$b82d16f27459e05a;
var $ef9efc139901a96c$export$522c17b4f5e123e8;
var $ef9efc139901a96c$export$1aabd8a0274ecfd6;
var $ef9efc139901a96c$export$3d6c20d97e46b957;
var $ef9efc139901a96c$export$9b621391a187a31a;
var $ef9efc139901a96c$export$f5bbd400c2f4426f;
"use strict";
var $ef9efc139901a96c$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $ef9efc139901a96c$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $ef9efc139901a96c$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $ef9efc139901a96c$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $ef9efc139901a96c$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $ef9efc139901a96c$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $ef9efc139901a96c$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $ef9efc139901a96c$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $ef9efc139901a96c$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $ef9efc139901a96c$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $ef9efc139901a96c$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $ef9efc139901a96c$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $ef9efc139901a96c$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $ef9efc139901a96c$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $ef9efc139901a96c$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $ef9efc139901a96c$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $ef9efc139901a96c$var$REACT_FRAGMENT_TYPE:
                    case $ef9efc139901a96c$var$REACT_PROFILER_TYPE:
                    case $ef9efc139901a96c$var$REACT_STRICT_MODE_TYPE:
                    case $ef9efc139901a96c$var$REACT_SUSPENSE_TYPE:
                    case $ef9efc139901a96c$var$REACT_SUSPENSE_LIST_TYPE:
                    case $ef9efc139901a96c$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $ef9efc139901a96c$var$REACT_CONTEXT_TYPE:
                            case $ef9efc139901a96c$var$REACT_FORWARD_REF_TYPE:
                            case $ef9efc139901a96c$var$REACT_LAZY_TYPE:
                            case $ef9efc139901a96c$var$REACT_MEMO_TYPE:
                                return object;
                            case $ef9efc139901a96c$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $ef9efc139901a96c$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$ef9efc139901a96c$export$a7c73072b1a182ae = $ef9efc139901a96c$var$REACT_CONSUMER_TYPE;
$ef9efc139901a96c$export$9f27bc3417b4524d = $ef9efc139901a96c$var$REACT_CONTEXT_TYPE;
$ef9efc139901a96c$export$db77ccec0bb4ccac = $ef9efc139901a96c$var$REACT_ELEMENT_TYPE;
$ef9efc139901a96c$export$8392c0c9d3dcbd35 = $ef9efc139901a96c$var$REACT_FORWARD_REF_TYPE;
$ef9efc139901a96c$export$ffb0004e005737fa = $ef9efc139901a96c$var$REACT_FRAGMENT_TYPE;
$ef9efc139901a96c$export$b624eff549462981 = $ef9efc139901a96c$var$REACT_LAZY_TYPE;
$ef9efc139901a96c$export$7897aa7841a5380c = $ef9efc139901a96c$var$REACT_MEMO_TYPE;
$ef9efc139901a96c$export$602eac185826482c = $ef9efc139901a96c$var$REACT_PORTAL_TYPE;
$ef9efc139901a96c$export$e2c29f18771995cb = $ef9efc139901a96c$var$REACT_PROFILER_TYPE;
$ef9efc139901a96c$export$5f8d39834fd61797 = $ef9efc139901a96c$var$REACT_STRICT_MODE_TYPE;
$ef9efc139901a96c$export$74bf444e3cd11ea5 = $ef9efc139901a96c$var$REACT_SUSPENSE_TYPE;
$ef9efc139901a96c$export$998bcd577473dd93 = $ef9efc139901a96c$var$REACT_SUSPENSE_LIST_TYPE;
$ef9efc139901a96c$export$b706b080d889d2c9 = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_CONSUMER_TYPE;
};
$ef9efc139901a96c$export$5be5a87408f70ddc = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_CONTEXT_TYPE;
};
$ef9efc139901a96c$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $ef9efc139901a96c$var$REACT_ELEMENT_TYPE;
};
$ef9efc139901a96c$export$455c2e768291efa6 = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_FORWARD_REF_TYPE;
};
$ef9efc139901a96c$export$9522e17588c12572 = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_FRAGMENT_TYPE;
};
$ef9efc139901a96c$export$2110ac352bb060b9 = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_LAZY_TYPE;
};
$ef9efc139901a96c$export$56885ab8b9c456ab = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_MEMO_TYPE;
};
$ef9efc139901a96c$export$d927fcb6adf8f9de = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_PORTAL_TYPE;
};
$ef9efc139901a96c$export$b82d16f27459e05a = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_PROFILER_TYPE;
};
$ef9efc139901a96c$export$522c17b4f5e123e8 = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_STRICT_MODE_TYPE;
};
$ef9efc139901a96c$export$1aabd8a0274ecfd6 = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_SUSPENSE_TYPE;
};
$ef9efc139901a96c$export$3d6c20d97e46b957 = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_SUSPENSE_LIST_TYPE;
};
$ef9efc139901a96c$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $ef9efc139901a96c$var$REACT_FRAGMENT_TYPE || type === $ef9efc139901a96c$var$REACT_PROFILER_TYPE || type === $ef9efc139901a96c$var$REACT_STRICT_MODE_TYPE || type === $ef9efc139901a96c$var$REACT_SUSPENSE_TYPE || type === $ef9efc139901a96c$var$REACT_SUSPENSE_LIST_TYPE || type === $ef9efc139901a96c$var$REACT_VIEW_TRANSITION_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $ef9efc139901a96c$var$REACT_LAZY_TYPE || type.$$typeof === $ef9efc139901a96c$var$REACT_MEMO_TYPE || type.$$typeof === $ef9efc139901a96c$var$REACT_CONTEXT_TYPE || type.$$typeof === $ef9efc139901a96c$var$REACT_CONSUMER_TYPE || type.$$typeof === $ef9efc139901a96c$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $ef9efc139901a96c$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$ef9efc139901a96c$export$f5bbd400c2f4426f = $ef9efc139901a96c$var$typeOf;

});



parcelRegister("kti2v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee7482569024fa37$export$2e2bcd8739ae039; });
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $ee7482569024fa37$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $ee7482569024fa37$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $ee7482569024fa37$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $ee7482569024fa37$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}

});

parcelRegister("315Pc", function(module, exports) {

$parcel$export(module.exports, "sortContainerQueries", function () { return $2325fbc34513c7d9$export$456f6c1142f990db; });
$parcel$export(module.exports, "isCqShorthand", function () { return $2325fbc34513c7d9$export$77c7c3e357f440e7; });
$parcel$export(module.exports, "getContainerQuery", function () { return $2325fbc34513c7d9$export$10a9745dfa00d15; });
$parcel$export(module.exports, "default", function () { return $2325fbc34513c7d9$export$2e2bcd8739ae039; });

function $2325fbc34513c7d9$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $2325fbc34513c7d9$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $2325fbc34513c7d9$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $2325fbc34513c7d9$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}

});

parcelRegister("l8Cag", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f637f3037d6dee04$export$2e2bcd8739ae039; });
const $f637f3037d6dee04$var$shape = {
    borderRadius: 4
};
var $f637f3037d6dee04$export$2e2bcd8739ae039 = $f637f3037d6dee04$var$shape;

});

parcelRegister("GLqnW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0808b5e3ab0ab6d4$export$2e2bcd8739ae039; });

var $dcAP4 = parcelRequire("dcAP4");
function $0808b5e3ab0ab6d4$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $dcAP4.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("dcAP4", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $99c8f593f1790ef1$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $99c8f593f1790ef1$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $99c8f593f1790ef1$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $99c8f593f1790ef1$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $99c8f593f1790ef1$export$6f98e8eaf0be1996; });


var $6m7cf = parcelRequire("6m7cf");

var $1cYnP = parcelRequire("1cYnP");

var $8rCOD = parcelRequire("8rCOD");

var $5aoqH = parcelRequire("5aoqH");
const $99c8f593f1790ef1$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $99c8f593f1790ef1$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $99c8f593f1790ef1$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $99c8f593f1790ef1$var$getCssProperties = (0, $5aoqH.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($99c8f593f1790ef1$var$aliases[prop]) prop = $99c8f593f1790ef1$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $99c8f593f1790ef1$var$properties[a];
    const direction = $99c8f593f1790ef1$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $99c8f593f1790ef1$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $99c8f593f1790ef1$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $99c8f593f1790ef1$var$spacingKeys = [
    ...$99c8f593f1790ef1$export$aab52a0dde05ad8a,
    ...$99c8f593f1790ef1$export$f8397d44f03ab6ad
];
function $99c8f593f1790ef1$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $1cYnP.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') return `calc(${val} * ${themeSpacing})`;
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $99c8f593f1790ef1$export$1def6f833384e3d1(theme) {
    return $99c8f593f1790ef1$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $99c8f593f1790ef1$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $99c8f593f1790ef1$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $99c8f593f1790ef1$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $99c8f593f1790ef1$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $99c8f593f1790ef1$var$getCssProperties(prop);
    const styleFromPropValue = $99c8f593f1790ef1$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $6m7cf.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $99c8f593f1790ef1$var$style(props, keys) {
    const transformer = $99c8f593f1790ef1$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$99c8f593f1790ef1$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $8rCOD.default), {});
}
function $99c8f593f1790ef1$export$7ede87f9b603dd3c(props) {
    return $99c8f593f1790ef1$var$style(props, $99c8f593f1790ef1$export$aab52a0dde05ad8a);
}
$99c8f593f1790ef1$export$7ede87f9b603dd3c.propTypes = {};
$99c8f593f1790ef1$export$7ede87f9b603dd3c.filterProps = $99c8f593f1790ef1$export$aab52a0dde05ad8a;
function $99c8f593f1790ef1$export$6f98e8eaf0be1996(props) {
    return $99c8f593f1790ef1$var$style(props, $99c8f593f1790ef1$export$f8397d44f03ab6ad);
}
$99c8f593f1790ef1$export$6f98e8eaf0be1996.propTypes = {};
$99c8f593f1790ef1$export$6f98e8eaf0be1996.filterProps = $99c8f593f1790ef1$export$f8397d44f03ab6ad;
function $99c8f593f1790ef1$var$spacing(props) {
    return $99c8f593f1790ef1$var$style(props, $99c8f593f1790ef1$var$spacingKeys);
}
$99c8f593f1790ef1$var$spacing.propTypes = {};
$99c8f593f1790ef1$var$spacing.filterProps = $99c8f593f1790ef1$var$spacingKeys;
var $99c8f593f1790ef1$export$2e2bcd8739ae039 = $99c8f593f1790ef1$var$spacing;

});
parcelRegister("6m7cf", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $4a0a613f758c442e$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $4a0a613f758c442e$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $4a0a613f758c442e$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $4a0a613f758c442e$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $4a0a613f758c442e$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $4a0a613f758c442e$export$980e6a259d807490; });


var $3wRTY = parcelRequire("3wRTY");

var $8rCOD = parcelRequire("8rCOD");

var $315Pc = parcelRequire("315Pc");
const $4a0a613f758c442e$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $4a0a613f758c442e$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$4a0a613f758c442e$export$68c286be0e7e55b7[key]}px)`
};
const $4a0a613f758c442e$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $4a0a613f758c442e$export$68c286be0e7e55b7[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $4a0a613f758c442e$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $4a0a613f758c442e$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $4a0a613f758c442e$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $315Pc.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $315Pc.getContainerQuery)(theme.containerQueries ? theme : $4a0a613f758c442e$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $4a0a613f758c442e$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $4a0a613f758c442e$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $4a0a613f758c442e$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $8rCOD.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $4a0a613f758c442e$export$1f2600516e91381f(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $4a0a613f758c442e$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $4a0a613f758c442e$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $4a0a613f758c442e$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $3wRTY.default)(prev, next), {});
    return $4a0a613f758c442e$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $4a0a613f758c442e$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $4a0a613f758c442e$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $4a0a613f758c442e$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $4a0a613f758c442e$export$2e2bcd8739ae039 = $4a0a613f758c442e$var$breakpoints;

});
parcelRegister("8rCOD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $625ef458e0e03ef7$export$2e2bcd8739ae039; });

var $3wRTY = parcelRequire("3wRTY");
function $625ef458e0e03ef7$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $3wRTY.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $625ef458e0e03ef7$export$2e2bcd8739ae039 = $625ef458e0e03ef7$var$merge;

});


parcelRegister("1cYnP", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $0e15c04d427b6a62$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $0e15c04d427b6a62$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $0e15c04d427b6a62$export$2e2bcd8739ae039; });

var $iCiVn = parcelRequire("iCiVn");


var $6m7cf = parcelRequire("6m7cf");
function $0e15c04d427b6a62$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $0e15c04d427b6a62$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $0e15c04d427b6a62$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $0e15c04d427b6a62$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $0e15c04d427b6a62$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $0e15c04d427b6a62$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $0e15c04d427b6a62$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $iCiVn.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $6m7cf.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $0e15c04d427b6a62$export$2e2bcd8739ae039 = $0e15c04d427b6a62$var$style;

});
parcelRegister("iCiVn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8da749d88f71122$export$2e2bcd8739ae039; });

var $diYUK = parcelRequire("diYUK");
function $d8da749d88f71122$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $diYUK.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("diYUK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9afc3518733c6a5e$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $9afc3518733c6a5e$export$2e2bcd8739ae039(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

});



parcelRegister("5aoqH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c30d62673f7d703$export$2e2bcd8739ae039; });
function $3c30d62673f7d703$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("8M6a3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $663795ec7cbfcd06$export$2e2bcd8739ae039; });

var $iCiVn = parcelRequire("iCiVn");

var $8rCOD = parcelRequire("8rCOD");

var $1cYnP = parcelRequire("1cYnP");

var $6m7cf = parcelRequire("6m7cf");

var $315Pc = parcelRequire("315Pc");

var $hXGiu = parcelRequire("hXGiu");
function $663795ec7cbfcd06$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $663795ec7cbfcd06$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $663795ec7cbfcd06$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $1cYnP.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $1cYnP.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $1cYnP.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $iCiVn.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $6m7cf.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? (0, $hXGiu.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $6m7cf.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $663795ec7cbfcd06$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $8rCOD.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $6m7cf.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($663795ec7cbfcd06$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $8rCOD.default)(css, breakpointsValues);
                        }
                    } else css = (0, $8rCOD.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $315Pc.sortContainerQueries)(theme, (0, $6m7cf.removeUnusedBreakpoints)(breakpointsKeys, css))
            };
            return (0, $315Pc.sortContainerQueries)(theme, (0, $6m7cf.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $663795ec7cbfcd06$var$styleFunctionSx = $663795ec7cbfcd06$export$7d53d8bf2911e013();
$663795ec7cbfcd06$var$styleFunctionSx.filterProps = [
    'sx'
];
var $663795ec7cbfcd06$export$2e2bcd8739ae039 = $663795ec7cbfcd06$var$styleFunctionSx;

});
parcelRegister("hXGiu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d138c1b003d294d5$export$2e2bcd8739ae039; });

var $dcAP4 = parcelRequire("dcAP4");

var $js6Jb = parcelRequire("js6Jb");

var $bTbaS = parcelRequire("bTbaS");

var $lRETI = parcelRequire("lRETI");

var $91SKZ = parcelRequire("91SKZ");
const $d138c1b003d294d5$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $js6Jb.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $js6Jb.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $js6Jb.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $js6Jb.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $js6Jb.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $js6Jb.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $js6Jb.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $lRETI.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $lRETI.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $lRETI.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $dcAP4.padding)
    },
    pt: {
        style: (0, $dcAP4.padding)
    },
    pr: {
        style: (0, $dcAP4.padding)
    },
    pb: {
        style: (0, $dcAP4.padding)
    },
    pl: {
        style: (0, $dcAP4.padding)
    },
    px: {
        style: (0, $dcAP4.padding)
    },
    py: {
        style: (0, $dcAP4.padding)
    },
    padding: {
        style: (0, $dcAP4.padding)
    },
    paddingTop: {
        style: (0, $dcAP4.padding)
    },
    paddingRight: {
        style: (0, $dcAP4.padding)
    },
    paddingBottom: {
        style: (0, $dcAP4.padding)
    },
    paddingLeft: {
        style: (0, $dcAP4.padding)
    },
    paddingX: {
        style: (0, $dcAP4.padding)
    },
    paddingY: {
        style: (0, $dcAP4.padding)
    },
    paddingInline: {
        style: (0, $dcAP4.padding)
    },
    paddingInlineStart: {
        style: (0, $dcAP4.padding)
    },
    paddingInlineEnd: {
        style: (0, $dcAP4.padding)
    },
    paddingBlock: {
        style: (0, $dcAP4.padding)
    },
    paddingBlockStart: {
        style: (0, $dcAP4.padding)
    },
    paddingBlockEnd: {
        style: (0, $dcAP4.padding)
    },
    m: {
        style: (0, $dcAP4.margin)
    },
    mt: {
        style: (0, $dcAP4.margin)
    },
    mr: {
        style: (0, $dcAP4.margin)
    },
    mb: {
        style: (0, $dcAP4.margin)
    },
    ml: {
        style: (0, $dcAP4.margin)
    },
    mx: {
        style: (0, $dcAP4.margin)
    },
    my: {
        style: (0, $dcAP4.margin)
    },
    margin: {
        style: (0, $dcAP4.margin)
    },
    marginTop: {
        style: (0, $dcAP4.margin)
    },
    marginRight: {
        style: (0, $dcAP4.margin)
    },
    marginBottom: {
        style: (0, $dcAP4.margin)
    },
    marginLeft: {
        style: (0, $dcAP4.margin)
    },
    marginX: {
        style: (0, $dcAP4.margin)
    },
    marginY: {
        style: (0, $dcAP4.margin)
    },
    marginInline: {
        style: (0, $dcAP4.margin)
    },
    marginInlineStart: {
        style: (0, $dcAP4.margin)
    },
    marginInlineEnd: {
        style: (0, $dcAP4.margin)
    },
    marginBlock: {
        style: (0, $dcAP4.margin)
    },
    marginBlockStart: {
        style: (0, $dcAP4.margin)
    },
    marginBlockEnd: {
        style: (0, $dcAP4.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $bTbaS.gap)
    },
    rowGap: {
        style: (0, $bTbaS.rowGap)
    },
    columnGap: {
        style: (0, $bTbaS.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $91SKZ.sizingTransform)
    },
    maxWidth: {
        style: (0, $91SKZ.maxWidth)
    },
    minWidth: {
        transform: (0, $91SKZ.sizingTransform)
    },
    height: {
        transform: (0, $91SKZ.sizingTransform)
    },
    maxHeight: {
        transform: (0, $91SKZ.sizingTransform)
    },
    minHeight: {
        transform: (0, $91SKZ.sizingTransform)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $d138c1b003d294d5$export$2e2bcd8739ae039 = $d138c1b003d294d5$var$defaultSxConfig;

});
parcelRegister("js6Jb", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $e295d9da0e132c01$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $e295d9da0e132c01$export$7a57f79000377ca2; });


var $1cYnP = parcelRequire("1cYnP");

var $8GAE3 = parcelRequire("8GAE3");

var $dcAP4 = parcelRequire("dcAP4");

var $6m7cf = parcelRequire("6m7cf");
function $e295d9da0e132c01$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $e295d9da0e132c01$var$createBorderStyle(prop, transform) {
    return (0, $1cYnP.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $e295d9da0e132c01$export$1edee58a52776cd9 = $e295d9da0e132c01$var$createBorderStyle('border', $e295d9da0e132c01$export$34e2febe53ae29cc);
const $e295d9da0e132c01$export$f9a7b6bd24892946 = $e295d9da0e132c01$var$createBorderStyle('borderTop', $e295d9da0e132c01$export$34e2febe53ae29cc);
const $e295d9da0e132c01$export$5abca33e6be905d2 = $e295d9da0e132c01$var$createBorderStyle('borderRight', $e295d9da0e132c01$export$34e2febe53ae29cc);
const $e295d9da0e132c01$export$e2ce9f12a980a822 = $e295d9da0e132c01$var$createBorderStyle('borderBottom', $e295d9da0e132c01$export$34e2febe53ae29cc);
const $e295d9da0e132c01$export$47658cca1a909427 = $e295d9da0e132c01$var$createBorderStyle('borderLeft', $e295d9da0e132c01$export$34e2febe53ae29cc);
const $e295d9da0e132c01$export$e7fb0694ba2404fc = $e295d9da0e132c01$var$createBorderStyle('borderColor');
const $e295d9da0e132c01$export$126a92c968acdb85 = $e295d9da0e132c01$var$createBorderStyle('borderTopColor');
const $e295d9da0e132c01$export$85cc51cb8fbb8c0e = $e295d9da0e132c01$var$createBorderStyle('borderRightColor');
const $e295d9da0e132c01$export$340b0327727f6d1a = $e295d9da0e132c01$var$createBorderStyle('borderBottomColor');
const $e295d9da0e132c01$export$60beef91a985b4bf = $e295d9da0e132c01$var$createBorderStyle('borderLeftColor');
const $e295d9da0e132c01$export$f9258c55612cbed7 = $e295d9da0e132c01$var$createBorderStyle('outline', $e295d9da0e132c01$export$34e2febe53ae29cc);
const $e295d9da0e132c01$export$621fe586efeb64b9 = $e295d9da0e132c01$var$createBorderStyle('outlineColor');
const $e295d9da0e132c01$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $dcAP4.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $dcAP4.getValue)(transformer, propValue)
            });
        return (0, $6m7cf.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$e295d9da0e132c01$export$7a57f79000377ca2.propTypes = {};
$e295d9da0e132c01$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $e295d9da0e132c01$var$borders = (0, $8GAE3.default)($e295d9da0e132c01$export$1edee58a52776cd9, $e295d9da0e132c01$export$f9a7b6bd24892946, $e295d9da0e132c01$export$5abca33e6be905d2, $e295d9da0e132c01$export$e2ce9f12a980a822, $e295d9da0e132c01$export$47658cca1a909427, $e295d9da0e132c01$export$e7fb0694ba2404fc, $e295d9da0e132c01$export$126a92c968acdb85, $e295d9da0e132c01$export$85cc51cb8fbb8c0e, $e295d9da0e132c01$export$340b0327727f6d1a, $e295d9da0e132c01$export$60beef91a985b4bf, $e295d9da0e132c01$export$7a57f79000377ca2, $e295d9da0e132c01$export$f9258c55612cbed7, $e295d9da0e132c01$export$621fe586efeb64b9);
var $e295d9da0e132c01$export$2e2bcd8739ae039 = $e295d9da0e132c01$var$borders;

});
parcelRegister("8GAE3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $652eabee641972a2$export$2e2bcd8739ae039; });

var $8rCOD = parcelRequire("8rCOD");
function $652eabee641972a2$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $8rCOD.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $652eabee641972a2$export$2e2bcd8739ae039 = $652eabee641972a2$var$compose;

});


parcelRegister("bTbaS", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $8a7d7fc795cee191$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $8a7d7fc795cee191$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $8a7d7fc795cee191$export$8a833ffa5f5dbeda; });

var $1cYnP = parcelRequire("1cYnP");

var $8GAE3 = parcelRequire("8GAE3");

var $dcAP4 = parcelRequire("dcAP4");

var $6m7cf = parcelRequire("6m7cf");

const $8a7d7fc795cee191$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $dcAP4.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $dcAP4.getValue)(transformer, propValue)
            });
        return (0, $6m7cf.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$8a7d7fc795cee191$export$5df9adcb0db95e1e.propTypes = {};
$8a7d7fc795cee191$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $8a7d7fc795cee191$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $dcAP4.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $dcAP4.getValue)(transformer, propValue)
            });
        return (0, $6m7cf.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$8a7d7fc795cee191$export$ec60d70ff941a580.propTypes = {};
$8a7d7fc795cee191$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $8a7d7fc795cee191$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $dcAP4.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $dcAP4.getValue)(transformer, propValue)
            });
        return (0, $6m7cf.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$8a7d7fc795cee191$export$8a833ffa5f5dbeda.propTypes = {};
$8a7d7fc795cee191$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $8a7d7fc795cee191$export$baf44164ca3a34e8 = (0, $1cYnP.default)({
    prop: 'gridColumn'
});
const $8a7d7fc795cee191$export$8f7213a1cd01e832 = (0, $1cYnP.default)({
    prop: 'gridRow'
});
const $8a7d7fc795cee191$export$b0e0abbc49ba668 = (0, $1cYnP.default)({
    prop: 'gridAutoFlow'
});
const $8a7d7fc795cee191$export$bcd8b929d4b4142 = (0, $1cYnP.default)({
    prop: 'gridAutoColumns'
});
const $8a7d7fc795cee191$export$e5039a674e14c828 = (0, $1cYnP.default)({
    prop: 'gridAutoRows'
});
const $8a7d7fc795cee191$export$42bd9088661ffb03 = (0, $1cYnP.default)({
    prop: 'gridTemplateColumns'
});
const $8a7d7fc795cee191$export$920682ae05b999bc = (0, $1cYnP.default)({
    prop: 'gridTemplateRows'
});
const $8a7d7fc795cee191$export$1b88fbdd482fd33a = (0, $1cYnP.default)({
    prop: 'gridTemplateAreas'
});
const $8a7d7fc795cee191$export$bdb486e40d52d26f = (0, $1cYnP.default)({
    prop: 'gridArea'
});
const $8a7d7fc795cee191$var$grid = (0, $8GAE3.default)($8a7d7fc795cee191$export$5df9adcb0db95e1e, $8a7d7fc795cee191$export$ec60d70ff941a580, $8a7d7fc795cee191$export$8a833ffa5f5dbeda, $8a7d7fc795cee191$export$baf44164ca3a34e8, $8a7d7fc795cee191$export$8f7213a1cd01e832, $8a7d7fc795cee191$export$b0e0abbc49ba668, $8a7d7fc795cee191$export$bcd8b929d4b4142, $8a7d7fc795cee191$export$e5039a674e14c828, $8a7d7fc795cee191$export$42bd9088661ffb03, $8a7d7fc795cee191$export$920682ae05b999bc, $8a7d7fc795cee191$export$1b88fbdd482fd33a, $8a7d7fc795cee191$export$bdb486e40d52d26f);
var $8a7d7fc795cee191$export$2e2bcd8739ae039 = $8a7d7fc795cee191$var$grid;

});

parcelRegister("lRETI", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $feae45a63d0d7592$export$dbaffd4420ea0ac6; });

var $1cYnP = parcelRequire("1cYnP");

var $8GAE3 = parcelRequire("8GAE3");
function $feae45a63d0d7592$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $feae45a63d0d7592$export$35e9368ef982300f = (0, $1cYnP.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $feae45a63d0d7592$export$dbaffd4420ea0ac6
});
const $feae45a63d0d7592$export$2506f56c10355b33 = (0, $1cYnP.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $feae45a63d0d7592$export$dbaffd4420ea0ac6
});
const $feae45a63d0d7592$export$8c5a050822fd698c = (0, $1cYnP.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $feae45a63d0d7592$export$dbaffd4420ea0ac6
});
const $feae45a63d0d7592$var$palette = (0, $8GAE3.default)($feae45a63d0d7592$export$35e9368ef982300f, $feae45a63d0d7592$export$2506f56c10355b33, $feae45a63d0d7592$export$8c5a050822fd698c);
var $feae45a63d0d7592$export$2e2bcd8739ae039 = $feae45a63d0d7592$var$palette;

});

parcelRegister("91SKZ", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $692eaea4660c42f3$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $692eaea4660c42f3$export$488fda99655ff65a; });

var $1cYnP = parcelRequire("1cYnP");

var $8GAE3 = parcelRequire("8GAE3");

var $6m7cf = parcelRequire("6m7cf");
function $692eaea4660c42f3$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $692eaea4660c42f3$export$7e3df82ee760448c = (0, $1cYnP.default)({
    prop: 'width',
    transform: $692eaea4660c42f3$export$8afece71750ec241
});
const $692eaea4660c42f3$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || (0, $6m7cf.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $692eaea4660c42f3$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $6m7cf.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$692eaea4660c42f3$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $692eaea4660c42f3$export$ee148fbbe8357dd2 = (0, $1cYnP.default)({
    prop: 'minWidth',
    transform: $692eaea4660c42f3$export$8afece71750ec241
});
const $692eaea4660c42f3$export$ac607276a8fe9f0a = (0, $1cYnP.default)({
    prop: 'height',
    transform: $692eaea4660c42f3$export$8afece71750ec241
});
const $692eaea4660c42f3$export$dc0d8bd0b94f8570 = (0, $1cYnP.default)({
    prop: 'maxHeight',
    transform: $692eaea4660c42f3$export$8afece71750ec241
});
const $692eaea4660c42f3$export$a43cf604e12f3b17 = (0, $1cYnP.default)({
    prop: 'minHeight',
    transform: $692eaea4660c42f3$export$8afece71750ec241
});
const $692eaea4660c42f3$export$ffed9f14fb65e276 = (0, $1cYnP.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $692eaea4660c42f3$export$8afece71750ec241
});
const $692eaea4660c42f3$export$905076ed6620e671 = (0, $1cYnP.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $692eaea4660c42f3$export$8afece71750ec241
});
const $692eaea4660c42f3$export$6ccc93f785106a58 = (0, $1cYnP.default)({
    prop: 'boxSizing'
});
const $692eaea4660c42f3$var$sizing = (0, $8GAE3.default)($692eaea4660c42f3$export$7e3df82ee760448c, $692eaea4660c42f3$export$488fda99655ff65a, $692eaea4660c42f3$export$ee148fbbe8357dd2, $692eaea4660c42f3$export$ac607276a8fe9f0a, $692eaea4660c42f3$export$dc0d8bd0b94f8570, $692eaea4660c42f3$export$a43cf604e12f3b17, $692eaea4660c42f3$export$6ccc93f785106a58);
var $692eaea4660c42f3$export$2e2bcd8739ae039 = $692eaea4660c42f3$var$sizing;

});



parcelRegister("56TFl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b88b157d6186746$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $3b88b157d6186746$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});






parcelRegister("jwhZE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e35ef6915a224202$export$2e2bcd8739ae039; });
var $e35ef6915a224202$export$2e2bcd8739ae039 = '$$material';

});


parcelRegister("hBN0S", function(module, exports) {

$parcel$export(module.exports, "CssVarsProvider", function () { return $cd1be95953c44948$export$50ec01b133c61652; });
parcelRequire("7fPBF");

var $8M6a3 = parcelRequire("8M6a3");

var $dQExq = parcelRequire("dQExq");

var $hmhHQ = parcelRequire("hmhHQ");

var $5vuSA = parcelRequire("5vuSA");

var $jwhZE = parcelRequire("jwhZE");

var $ah5cx = parcelRequire("ah5cx");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const { CssVarsProvider: $cd1be95953c44948$var$InternalCssVarsProvider, useColorScheme: $cd1be95953c44948$export$6343629ee1b29116, getInitColorSchemeScript: $cd1be95953c44948$var$deprecatedGetInitColorSchemeScript } = (0, $dQExq.default)({
    themeId: (0, $jwhZE.default),
    // @ts-ignore ignore module augmentation tests
    theme: ()=>(0, $hmhHQ.default)({
            cssVariables: true
        }),
    colorSchemeStorageKey: (0, $ah5cx.defaultConfig).colorSchemeStorageKey,
    modeStorageKey: (0, $ah5cx.defaultConfig).modeStorageKey,
    defaultColorScheme: {
        light: (0, $ah5cx.defaultConfig).defaultLightColorScheme,
        dark: (0, $ah5cx.defaultConfig).defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = {
            ...theme,
            typography: (0, $5vuSA.default)(theme.palette, theme.typography)
        };
        newTheme.unstable_sx = function sx(props) {
            return (0, $8M6a3.default)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    }
});
let $cd1be95953c44948$var$warnedOnce = false;
// TODO: remove in v7
// eslint-disable-next-line @typescript-eslint/naming-convention
function $cd1be95953c44948$export$99adf6d9ed169a14(props) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)($cd1be95953c44948$var$InternalCssVarsProvider, {
        ...props
    });
}
let $cd1be95953c44948$var$warnedInitScriptOnce = false;
// TODO: remove in v7
const $cd1be95953c44948$export$f9a57b4a2abf8ed = (params)=>{
    if (!$cd1be95953c44948$var$warnedInitScriptOnce) {
        console.warn([
            'MUI: The getInitColorSchemeScript function has been deprecated.',
            '',
            "You should use `import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'`",
            'and replace the function call with `<InitColorSchemeScript />` instead.'
        ].join('\n'));
        $cd1be95953c44948$var$warnedInitScriptOnce = true;
    }
    return $cd1be95953c44948$var$deprecatedGetInitColorSchemeScript(params);
};
const $cd1be95953c44948$export$50ec01b133c61652 = $cd1be95953c44948$var$InternalCssVarsProvider;

});
parcelRegister("dQExq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a14f93b4f4171950$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $5tMhb = parcelRequire("5tMhb");

var $fC1zT = parcelRequire("fC1zT");

var $lJRRs = parcelRequire("lJRRs");

var $hpqHU = parcelRequire("hpqHU");

var $49reL = parcelRequire("49reL");

var $i3vpF = parcelRequire("i3vpF");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $a14f93b4f4171950$export$c09f426c4535c3ec = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $a14f93b4f4171950$export$2e2bcd8739ae039(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = (0, $49reL.DEFAULT_MODE_STORAGE_KEY), colorSchemeStorageKey: defaultColorSchemeStorageKey = (0, $49reL.DEFAULT_COLOR_SCHEME_STORAGE_KEY), disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
    const useColorScheme = ()=>$7fPBF.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', noSsr: noSsr } = props;
        const hasMounted = $7fPBF.useRef(false);
        const upperTheme = (0, $fC1zT.default)();
        const ctx = $7fPBF.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $7fPBF.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $7fPBF.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $i3vpF.default)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        const memoTheme = $7fPBF.useMemo(()=>{
            // `colorScheme` is undefined on the server and hydration phase
            const calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            colorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, $lJRRs.default)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $7fPBF.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($a14f93b4f4171950$export$c09f426c4535c3ec));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $7fPBF.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $7fPBF.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hpqHU.default), {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5tMhb.default), {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $bbzbN.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $49reL.default)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}

});
parcelRegister("49reL", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_MODE_STORAGE_KEY", function () { return $305d21673024649a$export$ff0fa3047d11164c; });
$parcel$export(module.exports, "DEFAULT_COLOR_SCHEME_STORAGE_KEY", function () { return $305d21673024649a$export$665054ea9d94dab9; });
$parcel$export(module.exports, "default", function () { return $305d21673024649a$export$2e2bcd8739ae039; });
/**
 * Split this component for RSC import
 */ parcelRequire("7fPBF");

var $bbzbN = parcelRequire("bbzbN");
const $305d21673024649a$export$ff0fa3047d11164c = 'mode';
const $305d21673024649a$export$665054ea9d94dab9 = 'color-scheme';
const $305d21673024649a$export$14ebe5b26ee7fb38 = 'data-color-scheme';
function $305d21673024649a$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $305d21673024649a$export$ff0fa3047d11164c, colorSchemeStorageKey: colorSchemeStorageKey = $305d21673024649a$export$665054ea9d94dab9, attribute: initialAttribute = $305d21673024649a$export$14ebe5b26ee7fb38, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^\]]+)\]/); // case [data-color-scheme=%s] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, $bbzbN.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}

});

parcelRegister("i3vpF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d250dfc8c748030a$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $49reL = parcelRequire("49reL");

var $emE2H = parcelRequire("emE2H");
'use client';
function $d250dfc8c748030a$var$noop() {}
function $d250dfc8c748030a$export$ab3d447356dfa3e5(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $d250dfc8c748030a$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $d250dfc8c748030a$export$3caa7590cc1987bd(state) {
    return $d250dfc8c748030a$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $d250dfc8c748030a$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = (0, $49reL.DEFAULT_MODE_STORAGE_KEY), colorSchemeStorageKey: colorSchemeStorageKey = (0, $49reL.DEFAULT_COLOR_SCHEME_STORAGE_KEY), storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = (0, $emE2H.default), noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $7fPBF.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $7fPBF.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $7fPBF.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $7fPBF.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $d250dfc8c748030a$export$ab3d447356dfa3e5(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $7fPBF.useState(noSsr || !isMultiSchemes);
    $7fPBF.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $d250dfc8c748030a$export$3caa7590cc1987bd(state);
    const setMode = $7fPBF.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: $d250dfc8c748030a$export$ab3d447356dfa3e5(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $7fPBF.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $d250dfc8c748030a$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $7fPBF.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $7fPBF.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $7fPBF.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $7fPBF.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || $d250dfc8c748030a$var$noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || $d250dfc8c748030a$var$noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || $d250dfc8c748030a$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}

});
parcelRegister("emE2H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7522e5e0c82a440$export$2e2bcd8739ae039; });
function $a7522e5e0c82a440$var$noop() {}
const $a7522e5e0c82a440$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $a7522e5e0c82a440$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $a7522e5e0c82a440$export$2e2bcd8739ae039 = $a7522e5e0c82a440$var$localStorageManager;

});



parcelRegister("hmhHQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca3239ce6bf6e490$export$2e2bcd8739ae039; });

var $G7KID = parcelRequire("G7KID");

var $g1fnS = parcelRequire("g1fnS");

var $2PQvt = parcelRequire("2PQvt");
// eslint-disable-next-line consistent-return
function $ca3239ce6bf6e490$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $G7KID.default)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
function $ca3239ce6bf6e490$export$2e2bcd8739ae039(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...rest } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $2PQvt.default)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $2PQvt.default)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $ca3239ce6bf6e490$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $ca3239ce6bf6e490$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $g1fnS.default)({
        ...rest,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}

});
parcelRegister("G7KID", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07e9efd96a5c6f8a$export$2e2bcd8739ae039; });

var $diYUK = parcelRequire("diYUK");

var $3wRTY = parcelRequire("3wRTY");

var $kDjHH = parcelRequire("kDjHH");

var $6akYf = parcelRequire("6akYf");

var $2nhXL = parcelRequire("2nhXL");

var $3Ctzq = parcelRequire("3Ctzq");

var $9PTBs = parcelRequire("9PTBs");

var $5WQac = parcelRequire("5WQac");

var $gal31 = parcelRequire("gal31");

var $1Btry = parcelRequire("1Btry");

var $hnm6Q = parcelRequire("hnm6Q");
function $07e9efd96a5c6f8a$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: (0, $6akYf.default).white,
            default: (0, $6akYf.default).white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $07e9efd96a5c6f8a$export$a43af521ac8c3202 = $07e9efd96a5c6f8a$var$getLight();
function $07e9efd96a5c6f8a$var$getDark() {
    return {
        text: {
            primary: (0, $6akYf.default).white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: (0, $6akYf.default).white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $07e9efd96a5c6f8a$export$55ce6f3a06c59543 = $07e9efd96a5c6f8a$var$getDark();
function $07e9efd96a5c6f8a$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $kDjHH.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $kDjHH.darken)(intent.main, tonalOffsetDark);
    }
}
function $07e9efd96a5c6f8a$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $gal31.default)[200],
        light: (0, $gal31.default)[50],
        dark: (0, $gal31.default)[400]
    };
    return {
        main: (0, $gal31.default)[700],
        light: (0, $gal31.default)[400],
        dark: (0, $gal31.default)[800]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $3Ctzq.default)[200],
        light: (0, $3Ctzq.default)[50],
        dark: (0, $3Ctzq.default)[400]
    };
    return {
        main: (0, $3Ctzq.default)[500],
        light: (0, $3Ctzq.default)[300],
        dark: (0, $3Ctzq.default)[700]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $9PTBs.default)[500],
        light: (0, $9PTBs.default)[300],
        dark: (0, $9PTBs.default)[700]
    };
    return {
        main: (0, $9PTBs.default)[700],
        light: (0, $9PTBs.default)[400],
        dark: (0, $9PTBs.default)[800]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $1Btry.default)[400],
        light: (0, $1Btry.default)[300],
        dark: (0, $1Btry.default)[700]
    };
    return {
        main: (0, $1Btry.default)[700],
        light: (0, $1Btry.default)[500],
        dark: (0, $1Btry.default)[900]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $hnm6Q.default)[400],
        light: (0, $hnm6Q.default)[300],
        dark: (0, $hnm6Q.default)[700]
    };
    return {
        main: (0, $hnm6Q.default)[800],
        light: (0, $hnm6Q.default)[500],
        dark: (0, $hnm6Q.default)[900]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $5WQac.default)[400],
        light: (0, $5WQac.default)[300],
        dark: (0, $5WQac.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $5WQac.default)[500],
        dark: (0, $5WQac.default)[900]
    };
}
function $07e9efd96a5c6f8a$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, ...other } = palette;
    const primary = palette.primary || $07e9efd96a5c6f8a$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $07e9efd96a5c6f8a$var$getDefaultSecondary(mode);
    const error = palette.error || $07e9efd96a5c6f8a$var$getDefaultError(mode);
    const info = palette.info || $07e9efd96a5c6f8a$var$getDefaultInfo(mode);
    const success = palette.success || $07e9efd96a5c6f8a$var$getDefaultSuccess(mode);
    const warning = palette.warning || $07e9efd96a5c6f8a$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $kDjHH.getContrastRatio)(background, $07e9efd96a5c6f8a$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $07e9efd96a5c6f8a$export$55ce6f3a06c59543.text.primary : $07e9efd96a5c6f8a$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $diYUK.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $diYUK.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $07e9efd96a5c6f8a$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $07e9efd96a5c6f8a$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $07e9efd96a5c6f8a$var$getLight();
    else if (mode === 'dark') modeHydrated = $07e9efd96a5c6f8a$var$getDark();
    const paletteOutput = (0, $3wRTY.default)({
        // A collection of common colors.
        common: {
            ...(0, $6akYf.default)
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $2nhXL.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}

});
parcelRegister("kDjHH", function(module, exports) {

$parcel$export(module.exports, "private_safeColorChannel", function () { return $f056bbf329be1e0e$export$427365fc3db6fc5e; });
$parcel$export(module.exports, "hslToRgb", function () { return $f056bbf329be1e0e$export$29fb7152bd3f781a; });
$parcel$export(module.exports, "getContrastRatio", function () { return $f056bbf329be1e0e$export$d061e26956a60b0a; });
$parcel$export(module.exports, "alpha", function () { return $f056bbf329be1e0e$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "private_safeAlpha", function () { return $f056bbf329be1e0e$export$34109543fc7f43f8; });
$parcel$export(module.exports, "darken", function () { return $f056bbf329be1e0e$export$4b073707ff63303; });
$parcel$export(module.exports, "private_safeDarken", function () { return $f056bbf329be1e0e$export$eaaef2dca3e9e512; });
$parcel$export(module.exports, "lighten", function () { return $f056bbf329be1e0e$export$c0816ed86df316af; });
$parcel$export(module.exports, "private_safeLighten", function () { return $f056bbf329be1e0e$export$aeeda94ef1d01275; });
$parcel$export(module.exports, "private_safeEmphasize", function () { return $f056bbf329be1e0e$export$11bb74ba10c85505; });

var $diYUK = parcelRequire("diYUK");

var $5mrJy = parcelRequire("5mrJy");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $f056bbf329be1e0e$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $5mrJy.default)(value, min, max);
}
function $f056bbf329be1e0e$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $f056bbf329be1e0e$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $f056bbf329be1e0e$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $f056bbf329be1e0e$export$677b39864803984e($f056bbf329be1e0e$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $diYUK.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $diYUK.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $f056bbf329be1e0e$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $f056bbf329be1e0e$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
const $f056bbf329be1e0e$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $f056bbf329be1e0e$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $f056bbf329be1e0e$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $f056bbf329be1e0e$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $f056bbf329be1e0e$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$f056bbf329be1e0e$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $f056bbf329be1e0e$export$29fb7152bd3f781a(color) {
    color = $f056bbf329be1e0e$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $f056bbf329be1e0e$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $f056bbf329be1e0e$export$c852d90bf7403b62(color) {
    color = $f056bbf329be1e0e$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $f056bbf329be1e0e$export$677b39864803984e($f056bbf329be1e0e$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $f056bbf329be1e0e$export$d061e26956a60b0a(foreground, background) {
    const lumA = $f056bbf329be1e0e$export$c852d90bf7403b62(foreground);
    const lumB = $f056bbf329be1e0e$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $f056bbf329be1e0e$export$58f0f39f63f3cf42(color, value) {
    color = $f056bbf329be1e0e$export$677b39864803984e(color);
    value = $f056bbf329be1e0e$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $f056bbf329be1e0e$export$211a73f2b8c10ce4(color);
}
function $f056bbf329be1e0e$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $f056bbf329be1e0e$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $f056bbf329be1e0e$export$4b073707ff63303(color, coefficient) {
    color = $f056bbf329be1e0e$export$677b39864803984e(color);
    coefficient = $f056bbf329be1e0e$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $f056bbf329be1e0e$export$211a73f2b8c10ce4(color);
}
function $f056bbf329be1e0e$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $f056bbf329be1e0e$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $f056bbf329be1e0e$export$c0816ed86df316af(color, coefficient) {
    color = $f056bbf329be1e0e$export$677b39864803984e(color);
    coefficient = $f056bbf329be1e0e$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $f056bbf329be1e0e$export$211a73f2b8c10ce4(color);
}
function $f056bbf329be1e0e$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $f056bbf329be1e0e$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $f056bbf329be1e0e$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $f056bbf329be1e0e$export$c852d90bf7403b62(color) > 0.5 ? $f056bbf329be1e0e$export$4b073707ff63303(color, coefficient) : $f056bbf329be1e0e$export$c0816ed86df316af(color, coefficient);
}
function $f056bbf329be1e0e$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $f056bbf329be1e0e$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $f056bbf329be1e0e$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $f056bbf329be1e0e$export$677b39864803984e(background);
    const overlayColor = $f056bbf329be1e0e$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $f056bbf329be1e0e$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}

});
parcelRegister("5mrJy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e74852d812b8b64$export$2e2bcd8739ae039; });
function $3e74852d812b8b64$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $3e74852d812b8b64$export$2e2bcd8739ae039 = $3e74852d812b8b64$var$clamp;

});


parcelRegister("6akYf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47d3f19e39b3b144$export$2e2bcd8739ae039; });
const $47d3f19e39b3b144$var$common = {
    black: '#000',
    white: '#fff'
};
var $47d3f19e39b3b144$export$2e2bcd8739ae039 = $47d3f19e39b3b144$var$common;

});

parcelRegister("2nhXL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1baba9d0f229a247$export$2e2bcd8739ae039; });
const $1baba9d0f229a247$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $1baba9d0f229a247$export$2e2bcd8739ae039 = $1baba9d0f229a247$var$grey;

});

parcelRegister("3Ctzq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a2bdbc6cce4aa96$export$2e2bcd8739ae039; });
const $2a2bdbc6cce4aa96$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $2a2bdbc6cce4aa96$export$2e2bcd8739ae039 = $2a2bdbc6cce4aa96$var$purple;

});

parcelRegister("9PTBs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72940215fdf862f4$export$2e2bcd8739ae039; });
const $72940215fdf862f4$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $72940215fdf862f4$export$2e2bcd8739ae039 = $72940215fdf862f4$var$red;

});

parcelRegister("5WQac", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $454ad523c90fa85d$export$2e2bcd8739ae039; });
const $454ad523c90fa85d$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $454ad523c90fa85d$export$2e2bcd8739ae039 = $454ad523c90fa85d$var$orange;

});

parcelRegister("gal31", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc4de82bafd68977$export$2e2bcd8739ae039; });
const $bc4de82bafd68977$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $bc4de82bafd68977$export$2e2bcd8739ae039 = $bc4de82bafd68977$var$blue;

});

parcelRegister("1Btry", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12b015f9ee6c8f9f$export$2e2bcd8739ae039; });
const $12b015f9ee6c8f9f$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $12b015f9ee6c8f9f$export$2e2bcd8739ae039 = $12b015f9ee6c8f9f$var$lightBlue;

});

parcelRegister("hnm6Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca65bc19996a7eac$export$2e2bcd8739ae039; });
const $ca65bc19996a7eac$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $ca65bc19996a7eac$export$2e2bcd8739ae039 = $ca65bc19996a7eac$var$green;

});


parcelRegister("g1fnS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba98ac4ef2005c84$export$2e2bcd8739ae039; });

var $diYUK = parcelRequire("diYUK");

var $3wRTY = parcelRequire("3wRTY");

var $GLqnW = parcelRequire("GLqnW");
var $hQtUK = parcelRequire("hQtUK");

var $dcAP4 = parcelRequire("dcAP4");

var $354zy = parcelRequire("354zy");
var $keDZm = parcelRequire("keDZm");
var $GFZn6 = parcelRequire("GFZn6");

var $8M6a3 = parcelRequire("8M6a3");
var $hXGiu = parcelRequire("hXGiu");

var $kDjHH = parcelRequire("kDjHH");

var $2PQvt = parcelRequire("2PQvt");

var $lvniz = parcelRequire("lvniz");

var $k4ub1 = parcelRequire("k4ub1");

var $7wGWH = parcelRequire("7wGWH");

var $bVOFO = parcelRequire("bVOFO");
function $ba98ac4ef2005c84$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $ba98ac4ef2005c84$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $ba98ac4ef2005c84$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $kDjHH.hslToRgb)(color);
}
function $ba98ac4ef2005c84$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $kDjHH.private_safeColorChannel)($ba98ac4ef2005c84$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $ba98ac4ef2005c84$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $ba98ac4ef2005c84$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $ba98ac4ef2005c84$export$65418b4d9082cc44 = (cssVarPrefix = 'mui')=>(0, $hQtUK.default)(cssVarPrefix);
function $ba98ac4ef2005c84$var$attachColorScheme(colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $lvniz.default)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            }
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $2PQvt.default)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        }
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $lvniz.getOpacity)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $lvniz.getOverlays)(mode)
    };
    return muiTheme;
}
function $ba98ac4ef2005c84$export$2e2bcd8739ae039(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $k4ub1.default), colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $ba98ac4ef2005c84$export$65418b4d9082cc44(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $diYUK.default)(21, defaultColorScheme));
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $ba98ac4ef2005c84$var$attachColorScheme(colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $ba98ac4ef2005c84$var$attachColorScheme(colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $ba98ac4ef2005c84$var$attachColorScheme(colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $GFZn6.default)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $ba98ac4ef2005c84$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $ba98ac4ef2005c84$var$setColor(palette.common, 'background', '#fff');
            $ba98ac4ef2005c84$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $ba98ac4ef2005c84$var$setColor(palette.common, 'background', '#000');
            $ba98ac4ef2005c84$var$setColor(palette.common, 'onBackground', '#fff');
        }
        // assign component variables
        $ba98ac4ef2005c84$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'errorColor', (0, $kDjHH.private_safeDarken)(palette.error.light, 0.6));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'infoColor', (0, $kDjHH.private_safeDarken)(palette.info.light, 0.6));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'successColor', (0, $kDjHH.private_safeDarken)(palette.success.light, 0.6));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'warningColor', (0, $kDjHH.private_safeDarken)(palette.warning.light, 0.6));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'errorFilledColor', $ba98ac4ef2005c84$var$silent(()=>palette.getContrastText(palette.error.main)));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'infoFilledColor', $ba98ac4ef2005c84$var$silent(()=>palette.getContrastText(palette.info.main)));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'successFilledColor', $ba98ac4ef2005c84$var$silent(()=>palette.getContrastText(palette.success.main)));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'warningFilledColor', $ba98ac4ef2005c84$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'errorStandardBg', (0, $kDjHH.private_safeLighten)(palette.error.light, 0.9));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'infoStandardBg', (0, $kDjHH.private_safeLighten)(palette.info.light, 0.9));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'successStandardBg', (0, $kDjHH.private_safeLighten)(palette.success.light, 0.9));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'warningStandardBg', (0, $kDjHH.private_safeLighten)(palette.warning.light, 0.9));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $ba98ac4ef2005c84$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $ba98ac4ef2005c84$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $ba98ac4ef2005c84$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $ba98ac4ef2005c84$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $ba98ac4ef2005c84$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $ba98ac4ef2005c84$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $ba98ac4ef2005c84$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $ba98ac4ef2005c84$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $ba98ac4ef2005c84$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $ba98ac4ef2005c84$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $ba98ac4ef2005c84$var$setColor(palette.LinearProgress, 'primaryBg', (0, $kDjHH.private_safeLighten)(palette.primary.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $kDjHH.private_safeLighten)(palette.secondary.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.LinearProgress, 'errorBg', (0, $kDjHH.private_safeLighten)(palette.error.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.LinearProgress, 'infoBg', (0, $kDjHH.private_safeLighten)(palette.info.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.LinearProgress, 'successBg', (0, $kDjHH.private_safeLighten)(palette.success.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.LinearProgress, 'warningBg', (0, $kDjHH.private_safeLighten)(palette.warning.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $ba98ac4ef2005c84$var$setColor(palette.Slider, 'primaryTrack', (0, $kDjHH.private_safeLighten)(palette.primary.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.Slider, 'secondaryTrack', (0, $kDjHH.private_safeLighten)(palette.secondary.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.Slider, 'errorTrack', (0, $kDjHH.private_safeLighten)(palette.error.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.Slider, 'infoTrack', (0, $kDjHH.private_safeLighten)(palette.info.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.Slider, 'successTrack', (0, $kDjHH.private_safeLighten)(palette.success.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.Slider, 'warningTrack', (0, $kDjHH.private_safeLighten)(palette.warning.main, 0.62));
            const snackbarContentBackground = (0, $kDjHH.private_safeEmphasize)(palette.background.default, 0.8);
            $ba98ac4ef2005c84$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $ba98ac4ef2005c84$var$setColor(palette.SnackbarContent, 'color', $ba98ac4ef2005c84$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $ba98ac4ef2005c84$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $kDjHH.private_safeEmphasize)(palette.background.paper, 0.15));
            $ba98ac4ef2005c84$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $ba98ac4ef2005c84$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $kDjHH.private_safeLighten)(palette.primary.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $kDjHH.private_safeLighten)(palette.secondary.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'errorDisabledColor', (0, $kDjHH.private_safeLighten)(palette.error.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'infoDisabledColor', (0, $kDjHH.private_safeLighten)(palette.info.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'successDisabledColor', (0, $kDjHH.private_safeLighten)(palette.success.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'warningDisabledColor', (0, $kDjHH.private_safeLighten)(palette.warning.main, 0.62));
            $ba98ac4ef2005c84$var$setColor(palette.TableCell, 'border', (0, $kDjHH.private_safeLighten)((0, $kDjHH.private_safeAlpha)(palette.divider, 1), 0.88));
            $ba98ac4ef2005c84$var$setColor(palette.Tooltip, 'bg', (0, $kDjHH.private_safeAlpha)(palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'errorColor', (0, $kDjHH.private_safeLighten)(palette.error.light, 0.6));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'infoColor', (0, $kDjHH.private_safeLighten)(palette.info.light, 0.6));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'successColor', (0, $kDjHH.private_safeLighten)(palette.success.light, 0.6));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'warningColor', (0, $kDjHH.private_safeLighten)(palette.warning.light, 0.6));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'errorFilledColor', $ba98ac4ef2005c84$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'infoFilledColor', $ba98ac4ef2005c84$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'successFilledColor', $ba98ac4ef2005c84$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'warningFilledColor', $ba98ac4ef2005c84$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'errorStandardBg', (0, $kDjHH.private_safeDarken)(palette.error.light, 0.9));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'infoStandardBg', (0, $kDjHH.private_safeDarken)(palette.info.light, 0.9));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'successStandardBg', (0, $kDjHH.private_safeDarken)(palette.success.light, 0.9));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'warningStandardBg', (0, $kDjHH.private_safeDarken)(palette.warning.light, 0.9));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $ba98ac4ef2005c84$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $ba98ac4ef2005c84$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $ba98ac4ef2005c84$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $ba98ac4ef2005c84$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $ba98ac4ef2005c84$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $ba98ac4ef2005c84$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $ba98ac4ef2005c84$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $ba98ac4ef2005c84$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $ba98ac4ef2005c84$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $ba98ac4ef2005c84$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $ba98ac4ef2005c84$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $ba98ac4ef2005c84$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $ba98ac4ef2005c84$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $ba98ac4ef2005c84$var$setColor(palette.LinearProgress, 'primaryBg', (0, $kDjHH.private_safeDarken)(palette.primary.main, 0.5));
            $ba98ac4ef2005c84$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $kDjHH.private_safeDarken)(palette.secondary.main, 0.5));
            $ba98ac4ef2005c84$var$setColor(palette.LinearProgress, 'errorBg', (0, $kDjHH.private_safeDarken)(palette.error.main, 0.5));
            $ba98ac4ef2005c84$var$setColor(palette.LinearProgress, 'infoBg', (0, $kDjHH.private_safeDarken)(palette.info.main, 0.5));
            $ba98ac4ef2005c84$var$setColor(palette.LinearProgress, 'successBg', (0, $kDjHH.private_safeDarken)(palette.success.main, 0.5));
            $ba98ac4ef2005c84$var$setColor(palette.LinearProgress, 'warningBg', (0, $kDjHH.private_safeDarken)(palette.warning.main, 0.5));
            $ba98ac4ef2005c84$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $ba98ac4ef2005c84$var$setColor(palette.Slider, 'primaryTrack', (0, $kDjHH.private_safeDarken)(palette.primary.main, 0.5));
            $ba98ac4ef2005c84$var$setColor(palette.Slider, 'secondaryTrack', (0, $kDjHH.private_safeDarken)(palette.secondary.main, 0.5));
            $ba98ac4ef2005c84$var$setColor(palette.Slider, 'errorTrack', (0, $kDjHH.private_safeDarken)(palette.error.main, 0.5));
            $ba98ac4ef2005c84$var$setColor(palette.Slider, 'infoTrack', (0, $kDjHH.private_safeDarken)(palette.info.main, 0.5));
            $ba98ac4ef2005c84$var$setColor(palette.Slider, 'successTrack', (0, $kDjHH.private_safeDarken)(palette.success.main, 0.5));
            $ba98ac4ef2005c84$var$setColor(palette.Slider, 'warningTrack', (0, $kDjHH.private_safeDarken)(palette.warning.main, 0.5));
            const snackbarContentBackground = (0, $kDjHH.private_safeEmphasize)(palette.background.default, 0.98);
            $ba98ac4ef2005c84$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $ba98ac4ef2005c84$var$setColor(palette.SnackbarContent, 'color', $ba98ac4ef2005c84$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $ba98ac4ef2005c84$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $kDjHH.private_safeEmphasize)(palette.background.paper, 0.15));
            $ba98ac4ef2005c84$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $ba98ac4ef2005c84$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $kDjHH.private_safeDarken)(palette.primary.main, 0.55));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $kDjHH.private_safeDarken)(palette.secondary.main, 0.55));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'errorDisabledColor', (0, $kDjHH.private_safeDarken)(palette.error.main, 0.55));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'infoDisabledColor', (0, $kDjHH.private_safeDarken)(palette.info.main, 0.55));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'successDisabledColor', (0, $kDjHH.private_safeDarken)(palette.success.main, 0.55));
            $ba98ac4ef2005c84$var$setColor(palette.Switch, 'warningDisabledColor', (0, $kDjHH.private_safeDarken)(palette.warning.main, 0.55));
            $ba98ac4ef2005c84$var$setColor(palette.TableCell, 'border', (0, $kDjHH.private_safeDarken)((0, $kDjHH.private_safeAlpha)(palette.divider, 1), 0.68));
            $ba98ac4ef2005c84$var$setColor(palette.Tooltip, 'bg', (0, $kDjHH.private_safeAlpha)(palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $ba98ac4ef2005c84$var$setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        $ba98ac4ef2005c84$var$setColorChannel(palette.background, 'paper');
        $ba98ac4ef2005c84$var$setColorChannel(palette.common, 'background');
        $ba98ac4ef2005c84$var$setColorChannel(palette.common, 'onBackground');
        $ba98ac4ef2005c84$var$setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $ba98ac4ef2005c84$var$setColor(palette[color], 'mainChannel', (0, $kDjHH.private_safeColorChannel)($ba98ac4ef2005c84$var$toRgb(colors.main)));
                if (colors.light) $ba98ac4ef2005c84$var$setColor(palette[color], 'lightChannel', (0, $kDjHH.private_safeColorChannel)($ba98ac4ef2005c84$var$toRgb(colors.light)));
                if (colors.dark) $ba98ac4ef2005c84$var$setColor(palette[color], 'darkChannel', (0, $kDjHH.private_safeColorChannel)($ba98ac4ef2005c84$var$toRgb(colors.dark)));
                if (colors.contrastText) $ba98ac4ef2005c84$var$setColor(palette[color], 'contrastTextChannel', (0, $kDjHH.private_safeColorChannel)($ba98ac4ef2005c84$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $ba98ac4ef2005c84$var$setColorChannel(palette[color], 'primary');
                    $ba98ac4ef2005c84$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $ba98ac4ef2005c84$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $ba98ac4ef2005c84$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $3wRTY.default)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $7wGWH.default)(theme)
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $keDZm.default)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $GLqnW.default)(input.spacing, (0, $dcAP4.createUnarySpacing)(this));
    };
    theme.getColorSchemeSelector = (0, $354zy.createGetColorSchemeSelector)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...(0, $hXGiu.default),
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $8M6a3.default)({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = (0, $bVOFO.stringifyTheme); // for Pigment CSS integration
    return theme;
}

});
parcelRegister("hQtUK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfde7f5fc68ec626$export$2e2bcd8739ae039; });
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $cfde7f5fc68ec626$export$2e2bcd8739ae039(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}

});

parcelRegister("354zy", function(module, exports) {

$parcel$export(module.exports, "createGetColorSchemeSelector", function () { return $23e562b91a17329d$export$858538ff6c0d421d; });
/* eslint-disable import/prefer-default-export */ function $23e562b91a17329d$export$858538ff6c0d421d(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}

});

parcelRegister("keDZm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03cd3a5c6e1b23a5$export$2e2bcd8739ae039; });

var $3wRTY = parcelRequire("3wRTY");

var $bTwL3 = parcelRequire("bTwL3");
function $03cd3a5c6e1b23a5$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $bTwL3.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $bTwL3.default)(scheme, parserConfig);
        themeVars = (0, $3wRTY.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $bTwL3.default)(defaultScheme, parserConfig);
        themeVars = (0, $3wRTY.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $3wRTY.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $03cd3a5c6e1b23a5$export$2e2bcd8739ae039 = $03cd3a5c6e1b23a5$var$prepareCssVars;

});
parcelRegister("bTwL3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a8e3dcde93a9cbe$export$2e2bcd8739ae039; });
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $8a8e3dcde93a9cbe$export$b7855adbea215c1a = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
const $8a8e3dcde93a9cbe$export$65957d378dc9a0b3 = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const $8a8e3dcde93a9cbe$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function $8a8e3dcde93a9cbe$export$2e2bcd8739ae039(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $8a8e3dcde93a9cbe$export$65957d378dc9a0b3(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $8a8e3dcde93a9cbe$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $8a8e3dcde93a9cbe$export$b7855adbea215c1a(vars, keys, `var(${cssVar})`, arrayKeys);
                $8a8e3dcde93a9cbe$export$b7855adbea215c1a(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}

});


parcelRegister("GFZn6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08047e78ef5de5cb$export$2e2bcd8739ae039; });
function $08047e78ef5de5cb$export$2e2bcd8739ae039(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}

});

parcelRegister("2PQvt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $210912e9de81c193$export$2e2bcd8739ae039; });

var $diYUK = parcelRequire("diYUK");

var $3wRTY = parcelRequire("3wRTY");

var $8M6a3 = parcelRequire("8M6a3");
var $hXGiu = parcelRequire("hXGiu");

var $2G6xE = parcelRequire("2G6xE");


var $oPCQw = parcelRequire("oPCQw");

var $G7KID = parcelRequire("G7KID");

var $5vuSA = parcelRequire("5vuSA");

var $3jGgo = parcelRequire("3jGgo");

var $kjiCM = parcelRequire("kjiCM");

var $eGmqa = parcelRequire("eGmqa");

var $bVOFO = parcelRequire("bVOFO");
function $210912e9de81c193$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, $diYUK.default)(20));
    const palette = (0, $G7KID.default)(paletteInput);
    const systemTheme = (0, $2G6xE.default)(options);
    let muiTheme = (0, $3wRTY.default)(systemTheme, {
        mixins: (0, $oPCQw.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $3jGgo.default).slice(),
        typography: (0, $5vuSA.default)(palette, typographyInput),
        transitions: (0, $kjiCM.default)(transitionsInput),
        zIndex: {
            ...(0, $eGmqa.default)
        }
    });
    muiTheme = (0, $3wRTY.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $3wRTY.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ...(0, $hXGiu.default),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $8M6a3.default)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = (0, $bVOFO.stringifyTheme); // for Pigment CSS integration
    return muiTheme;
}
let $210912e9de81c193$var$warnedOnce = false;
function $210912e9de81c193$export$c469355549431d9b(...args) {
    return $210912e9de81c193$var$createThemeNoVars(...args);
}
var $210912e9de81c193$export$2e2bcd8739ae039 = $210912e9de81c193$var$createThemeNoVars;

});
parcelRegister("oPCQw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04aa49c3b5b31b02$export$2e2bcd8739ae039; });
function $04aa49c3b5b31b02$export$2e2bcd8739ae039(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}

});

parcelRegister("5vuSA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4027cd084802bc60$export$2e2bcd8739ae039; });

var $3wRTY = parcelRequire("3wRTY");
function $4027cd084802bc60$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $4027cd084802bc60$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $4027cd084802bc60$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $4027cd084802bc60$export$2e2bcd8739ae039(palette, typography) {
    const { fontFamily: fontFamily = $4027cd084802bc60$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $4027cd084802bc60$var$defaultFontFamily ? {
                letterSpacing: `${$4027cd084802bc60$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $4027cd084802bc60$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $4027cd084802bc60$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $3wRTY.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("3jGgo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26a3ee12a0d43232$export$2e2bcd8739ae039; });
const $26a3ee12a0d43232$var$shadowKeyUmbraOpacity = 0.2;
const $26a3ee12a0d43232$var$shadowKeyPenumbraOpacity = 0.14;
const $26a3ee12a0d43232$var$shadowAmbientShadowOpacity = 0.12;
function $26a3ee12a0d43232$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $26a3ee12a0d43232$var$shadows = [
    'none',
    $26a3ee12a0d43232$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $26a3ee12a0d43232$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $26a3ee12a0d43232$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $26a3ee12a0d43232$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $26a3ee12a0d43232$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $26a3ee12a0d43232$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $26a3ee12a0d43232$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $26a3ee12a0d43232$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $26a3ee12a0d43232$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $26a3ee12a0d43232$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $26a3ee12a0d43232$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $26a3ee12a0d43232$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $26a3ee12a0d43232$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $26a3ee12a0d43232$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $26a3ee12a0d43232$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $26a3ee12a0d43232$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $26a3ee12a0d43232$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $26a3ee12a0d43232$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $26a3ee12a0d43232$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $26a3ee12a0d43232$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $26a3ee12a0d43232$export$2e2bcd8739ae039 = $26a3ee12a0d43232$var$shadows;

});

parcelRegister("kjiCM", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $ec94076b9ecccee1$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $ec94076b9ecccee1$export$2e2bcd8739ae039; });
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $ec94076b9ecccee1$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $ec94076b9ecccee1$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $ec94076b9ecccee1$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $ec94076b9ecccee1$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $ec94076b9ecccee1$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = {
        ...$ec94076b9ecccee1$export$24c5ac7c37452e7d,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...$ec94076b9ecccee1$export$1f34108aa9eb96ab,
        ...inputTransitions.duration
    };
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $ec94076b9ecccee1$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $ec94076b9ecccee1$var$formatMs(delay)}`).join(',');
    };
    return {
        getAutoHeightDuration: $ec94076b9ecccee1$var$getAutoHeightDuration,
        create: create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}

});

parcelRegister("eGmqa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab06614e124e32b2$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $ab06614e124e32b2$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $ab06614e124e32b2$export$2e2bcd8739ae039 = $ab06614e124e32b2$var$zIndex;

});

parcelRegister("bVOFO", function(module, exports) {

$parcel$export(module.exports, "stringifyTheme", function () { return $8afc533eb383e46c$export$32c2afa5f91892aa; });
/* eslint-disable import/prefer-default-export */ 
var $3wRTY = parcelRequire("3wRTY");
function $8afc533eb383e46c$var$isSerializable(val) {
    return (0, $3wRTY.isPlainObject)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
function $8afc533eb383e46c$export$32c2afa5f91892aa(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$8afc533eb383e46c$var$isSerializable(value) || key.startsWith('unstable_')) delete object[key];
            else if ((0, $3wRTY.isPlainObject)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}

});


parcelRegister("lvniz", function(module, exports) {

$parcel$export(module.exports, "getOpacity", function () { return $fa7e90d19bb5b73c$export$c85e0347fceb69ba; });
$parcel$export(module.exports, "getOverlays", function () { return $fa7e90d19bb5b73c$export$dd191566510330d3; });
$parcel$export(module.exports, "default", function () { return $fa7e90d19bb5b73c$export$2e2bcd8739ae039; });

var $G7KID = parcelRequire("G7KID");

var $ckFUN = parcelRequire("ckFUN");
const $fa7e90d19bb5b73c$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $ckFUN.default)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $fa7e90d19bb5b73c$export$c85e0347fceb69ba(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $fa7e90d19bb5b73c$export$dd191566510330d3(mode) {
    return mode === 'dark' ? $fa7e90d19bb5b73c$var$defaultDarkOverlays : [];
}
function $fa7e90d19bb5b73c$export$2e2bcd8739ae039(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, ...rest } = options;
    const palette = (0, $G7KID.default)(paletteInput);
    return {
        palette: palette,
        opacity: {
            ...$fa7e90d19bb5b73c$export$c85e0347fceb69ba(palette.mode),
            ...opacity
        },
        overlays: overlays || $fa7e90d19bb5b73c$export$dd191566510330d3(palette.mode),
        ...rest
    };
}

});
parcelRegister("ckFUN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fa7ddbbf42193a7$export$2e2bcd8739ae039; });
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $8fa7ddbbf42193a7$export$2e2bcd8739ae039(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}

});


parcelRegister("k4ub1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9cb96d85031eec5$export$2e2bcd8739ae039; });
function $e9cb96d85031eec5$export$2e2bcd8739ae039(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}

});

parcelRegister("7wGWH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57acd5b568390899$export$2e2bcd8739ae039; });

var $6HQMK = parcelRequire("6HQMK");
var $57acd5b568390899$export$2e2bcd8739ae039 = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $6HQMK.default)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };

});
parcelRegister("6HQMK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e1fb4440bcd8fb8$export$2e2bcd8739ae039; });
/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $4e1fb4440bcd8fb8$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $4e1fb4440bcd8fb8$export$2e2bcd8739ae039 = $4e1fb4440bcd8fb8$var$excludeVariablesFromRoot;

});




parcelRegister("ah5cx", function(module, exports) {

$parcel$export(module.exports, "defaultConfig", function () { return $77af86c63cb046a6$export$f84bd70098573c5c; });
parcelRequire("7fPBF");

var $49reL = parcelRequire("49reL");

var $bbzbN = parcelRequire("bbzbN");
const $77af86c63cb046a6$export$f84bd70098573c5c = {
    attribute: 'data-mui-color-scheme',
    colorSchemeStorageKey: 'mui-color-scheme',
    defaultLightColorScheme: 'light',
    defaultDarkColorScheme: 'dark',
    modeStorageKey: 'mui-mode'
};
var $77af86c63cb046a6$export$2e2bcd8739ae039 = function InitColorSchemeScript(props) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $49reL.default), {
        ...$77af86c63cb046a6$export$f84bd70098573c5c,
        ...props
    });
};

});



parcelRegister("jIH9a", function(module, exports) {

$parcel$export(module.exports, "enqueueSnackbar", function () { return $e5b3986eed0aa56e$export$9d70c354f0150b1b; });
$parcel$export(module.exports, "SnackbarProvider", function () { return $e5b3986eed0aa56e$export$d1e619fddc3508ce; });

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");

var $CVsbx = parcelRequire("CVsbx");

var $5PDlY = parcelRequire("5PDlY");
function $e5b3986eed0aa56e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e5b3986eed0aa56e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e5b3986eed0aa56e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e5b3986eed0aa56e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $e5b3986eed0aa56e$var$_extends() {
    $e5b3986eed0aa56e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e5b3986eed0aa56e$var$_extends.apply(this, arguments);
}
function $e5b3986eed0aa56e$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $e5b3986eed0aa56e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e5b3986eed0aa56e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var $e5b3986eed0aa56e$var$noOp = function noOp() {
    return '';
};
var $e5b3986eed0aa56e$var$SnackbarContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext({
    enqueueSnackbar: $e5b3986eed0aa56e$var$noOp,
    closeSnackbar: $e5b3986eed0aa56e$var$noOp
});
var $e5b3986eed0aa56e$var$breakpoints = {
    downXs: '@media (max-width:599.95px)',
    upSm: '@media (min-width:600px)'
};
var $e5b3986eed0aa56e$var$capitalise = function capitalise(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
};
var $e5b3986eed0aa56e$var$originKeyExtractor = function originKeyExtractor(anchor) {
    return "" + $e5b3986eed0aa56e$var$capitalise(anchor.vertical) + $e5b3986eed0aa56e$var$capitalise(anchor.horizontal);
};
var $e5b3986eed0aa56e$var$isDefined = function isDefined(value) {
    return !!value || value === 0;
};
var $e5b3986eed0aa56e$var$UNMOUNTED = 'unmounted';
var $e5b3986eed0aa56e$var$EXITED = 'exited';
var $e5b3986eed0aa56e$var$ENTERING = 'entering';
var $e5b3986eed0aa56e$var$ENTERED = 'entered';
var $e5b3986eed0aa56e$var$EXITING = 'exiting';
var $e5b3986eed0aa56e$export$be58926105124dd4 = /*#__PURE__*/ function(_React$Component) {
    $e5b3986eed0aa56e$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var appear = props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props["in"]) {
            if (appear) {
                initialStatus = $e5b3986eed0aa56e$var$EXITED;
                _this.appearStatus = $e5b3986eed0aa56e$var$ENTERING;
            } else initialStatus = $e5b3986eed0aa56e$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $e5b3986eed0aa56e$var$UNMOUNTED;
        else initialStatus = $e5b3986eed0aa56e$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref["in"];
        if (nextIn && prevState.status === $e5b3986eed0aa56e$var$UNMOUNTED) return {
            status: $e5b3986eed0aa56e$var$EXITED
        };
        return null;
    };
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props["in"]) {
                if (status !== $e5b3986eed0aa56e$var$ENTERING && status !== $e5b3986eed0aa56e$var$ENTERED) nextStatus = $e5b3986eed0aa56e$var$ENTERING;
            } else if (status === $e5b3986eed0aa56e$var$ENTERING || status === $e5b3986eed0aa56e$var$ENTERED) nextStatus = $e5b3986eed0aa56e$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var enter = timeout;
        var exit = timeout;
        if (timeout != null && typeof timeout !== 'number' && typeof timeout !== 'string') {
            exit = timeout.exit;
            enter = timeout.enter;
        }
        return {
            exit: exit,
            enter: enter
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            this.cancelNextCallback();
            if (nextStatus === $e5b3986eed0aa56e$var$ENTERING) this.performEnter(mounting);
            else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $e5b3986eed0aa56e$var$EXITED) this.setState({
            status: $e5b3986eed0aa56e$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var isAppearing = mounting;
        var timeouts = this.getTimeouts();
        if (!mounting && !enter) {
            this.safeSetState({
                status: $e5b3986eed0aa56e$var$ENTERED
            }, function() {
                if (_this2.props.onEntered) _this2.props.onEntered(_this2.node, isAppearing);
            });
            return;
        }
        if (this.props.onEnter) this.props.onEnter(this.node, isAppearing);
        this.safeSetState({
            status: $e5b3986eed0aa56e$var$ENTERING
        }, function() {
            if (_this2.props.onEntering) _this2.props.onEntering(_this2.node, isAppearing);
            _this2.onTransitionEnd(timeouts.enter, function() {
                _this2.safeSetState({
                    status: $e5b3986eed0aa56e$var$ENTERED
                }, function() {
                    if (_this2.props.onEntered) _this2.props.onEntered(_this2.node, isAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: $e5b3986eed0aa56e$var$EXITED
            }, function() {
                if (_this3.props.onExited) _this3.props.onExited(_this3.node);
            });
            return;
        }
        if (this.props.onExit) this.props.onExit(this.node);
        this.safeSetState({
            status: $e5b3986eed0aa56e$var$EXITING
        }, function() {
            if (_this3.props.onExiting) _this3.props.onExiting(_this3.node);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $e5b3986eed0aa56e$var$EXITED
                }, function() {
                    if (_this3.props.onExited) _this3.props.onExited(_this3.node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null && this.nextCallback.cancel) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function() {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback();
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!this.node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(this.node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $e5b3986eed0aa56e$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = $e5b3986eed0aa56e$var$_objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return children(status, childProps);
    };
    $e5b3986eed0aa56e$var$_createClass(Transition, [
        {
            key: "node",
            get: function get() {
                var _this$props$nodeRef;
                var node = (_this$props$nodeRef = this.props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current;
                if (!node) throw new Error('notistack - Custom snackbar is not refForwarding');
                return node;
            }
        }
    ]);
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
function $e5b3986eed0aa56e$var$noop() {}
$e5b3986eed0aa56e$export$be58926105124dd4.defaultProps = {
    "in": false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $e5b3986eed0aa56e$var$noop,
    onEntering: $e5b3986eed0aa56e$var$noop,
    onEntered: $e5b3986eed0aa56e$var$noop,
    onExit: $e5b3986eed0aa56e$var$noop,
    onExiting: $e5b3986eed0aa56e$var$noop,
    onExited: $e5b3986eed0aa56e$var$noop
};
/**
 * Credit to MUI team @ https://mui.com
 */ /**
 * passes {value} to {ref}
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $e5b3986eed0aa56e$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}
function $e5b3986eed0aa56e$var$useForkRef(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return (0, $7fPBF.useMemo)(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            $e5b3986eed0aa56e$var$setRef(refA, refValue);
            $e5b3986eed0aa56e$var$setRef(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}
function $e5b3986eed0aa56e$var$getTransitionProps(props) {
    var timeout = props.timeout, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style, mode = props.mode;
    return {
        duration: typeof timeout === 'object' ? timeout[mode] || 0 : timeout,
        easing: style.transitionTimingFunction,
        delay: style.transitionDelay
    };
}
/**
 * Credit to MUI team @ https://mui.com
 */ var $e5b3986eed0aa56e$var$defaultEasing = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
/**
 * CSS hack to force a repaint
 */ var $e5b3986eed0aa56e$var$reflow = function reflow(node) {
    // We have to do something with node.scrollTop.
    // Otherwise it's removed from the compiled code by optimisers
    // eslint-disable-next-line no-self-assign
    node.scrollTop = node.scrollTop;
};
var $e5b3986eed0aa56e$var$formatMs = function formatMs(milliseconds) {
    return Math.round(milliseconds) + "ms";
};
function $e5b3986eed0aa56e$var$createTransition(props, options) {
    if (props === void 0) props = [
        'all'
    ];
    var _ref = options || {}, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 300 : _ref$duration, _ref$easing = _ref.easing, easing = _ref$easing === void 0 ? $e5b3986eed0aa56e$var$defaultEasing.easeInOut : _ref$easing, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay;
    var properties = Array.isArray(props) ? props : [
        props
    ];
    return properties.map(function(animatedProp) {
        var formattedDuration = typeof duration === 'string' ? duration : $e5b3986eed0aa56e$var$formatMs(duration);
        var formattedDelay = typeof delay === 'string' ? delay : $e5b3986eed0aa56e$var$formatMs(delay);
        return animatedProp + " " + formattedDuration + " " + easing + " " + formattedDelay;
    }).join(',');
}
function $e5b3986eed0aa56e$var$ownerDocument(node) {
    return node && node.ownerDocument || document;
}
function $e5b3986eed0aa56e$var$ownerWindow(node) {
    var doc = $e5b3986eed0aa56e$var$ownerDocument(node);
    return doc.defaultView || window;
}
/**
 * Corresponds to 10 frames at 60 Hz.
 * A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
 */ function $e5b3986eed0aa56e$var$debounce(func, wait) {
    if (wait === void 0) wait = 166;
    var timeout;
    function debounced() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var later = function later() {
            // @ts-ignore
            func.apply(_this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = function() {
        clearTimeout(timeout);
    };
    return debounced;
}
/**
 * Translate the node so it can't be seen on the screen.
 * Later, we're going to translate the node back to its original location with `none`.
 */ function $e5b3986eed0aa56e$var$getTranslateValue(direction, node) {
    var rect = node.getBoundingClientRect();
    var containerWindow = $e5b3986eed0aa56e$var$ownerWindow(node);
    var transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        var computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    var offsetX = 0;
    var offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        var transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    switch(direction){
        case 'left':
            return "translateX(" + (containerWindow.innerWidth + offsetX - rect.left) + "px)";
        case 'right':
            return "translateX(-" + (rect.left + rect.width - offsetX) + "px)";
        case 'up':
            return "translateY(" + (containerWindow.innerHeight + offsetY - rect.top) + "px)";
        default:
            // down
            return "translateY(-" + (rect.top + rect.height - offsetY) + "px)";
    }
}
function $e5b3986eed0aa56e$var$setTranslateValue(direction, node) {
    if (!node) return;
    var transform = $e5b3986eed0aa56e$var$getTranslateValue(direction, node);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
var $e5b3986eed0aa56e$var$Slide = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
    var children = props.children, _props$direction = props.direction, direction = _props$direction === void 0 ? 'down' : _props$direction, inProp = props["in"], style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? 0 : _props$timeout, onEnter = props.onEnter, onEntered = props.onEntered, onExit = props.onExit, onExited = props.onExited, other = $e5b3986eed0aa56e$var$_objectWithoutPropertiesLoose(props, [
        "children",
        "direction",
        "in",
        "style",
        "timeout",
        "onEnter",
        "onEntered",
        "onExit",
        "onExited"
    ]);
    var nodeRef = (0, $7fPBF.useRef)(null);
    var handleRefIntermediary = $e5b3986eed0aa56e$var$useForkRef(children.ref, nodeRef);
    var handleRef = $e5b3986eed0aa56e$var$useForkRef(handleRefIntermediary, ref);
    var handleEnter = function handleEnter(node, isAppearing) {
        $e5b3986eed0aa56e$var$setTranslateValue(direction, node);
        $e5b3986eed0aa56e$var$reflow(node);
        if (onEnter) onEnter(node, isAppearing);
    };
    var handleEntering = function handleEntering(node) {
        var easing = (style === null || style === void 0 ? void 0 : style.transitionTimingFunction) || $e5b3986eed0aa56e$var$defaultEasing.easeOut;
        var transitionProps = $e5b3986eed0aa56e$var$getTransitionProps({
            timeout: timeout,
            mode: 'enter',
            style: $e5b3986eed0aa56e$var$_extends({}, style, {
                transitionTimingFunction: easing
            })
        });
        node.style.webkitTransition = $e5b3986eed0aa56e$var$createTransition('-webkit-transform', transitionProps);
        node.style.transition = $e5b3986eed0aa56e$var$createTransition('transform', transitionProps);
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
    };
    var handleExit = function handleExit(node) {
        var easing = (style === null || style === void 0 ? void 0 : style.transitionTimingFunction) || $e5b3986eed0aa56e$var$defaultEasing.sharp;
        var transitionProps = $e5b3986eed0aa56e$var$getTransitionProps({
            timeout: timeout,
            mode: 'exit',
            style: $e5b3986eed0aa56e$var$_extends({}, style, {
                transitionTimingFunction: easing
            })
        });
        node.style.webkitTransition = $e5b3986eed0aa56e$var$createTransition('-webkit-transform', transitionProps);
        node.style.transition = $e5b3986eed0aa56e$var$createTransition('transform', transitionProps);
        $e5b3986eed0aa56e$var$setTranslateValue(direction, node);
        if (onExit) onExit(node);
    };
    var handleExited = function handleExited(node) {
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    };
    var updatePosition = (0, $7fPBF.useCallback)(function() {
        if (nodeRef.current) $e5b3986eed0aa56e$var$setTranslateValue(direction, nodeRef.current);
    }, [
        direction
    ]);
    (0, $7fPBF.useEffect)(function() {
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        var handleResize = $e5b3986eed0aa56e$var$debounce(function() {
            if (nodeRef.current) $e5b3986eed0aa56e$var$setTranslateValue(direction, nodeRef.current);
        });
        var containerWindow = $e5b3986eed0aa56e$var$ownerWindow(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return function() {
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return (0, $7fPBF.createElement)($e5b3986eed0aa56e$export$be58926105124dd4, Object.assign({
        appear: true,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: onEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        "in": inProp,
        timeout: timeout
    }, other), function(state, childProps) {
        return (0, $7fPBF.cloneElement)(children, $e5b3986eed0aa56e$var$_extends({
            ref: handleRef,
            style: $e5b3986eed0aa56e$var$_extends({
                visibility: state === 'exited' && !inProp ? 'hidden' : undefined
            }, style, {}, children.props.style)
        }, childProps));
    });
});
$e5b3986eed0aa56e$var$Slide.displayName = 'Slide';
var $e5b3986eed0aa56e$var$SvgIcon = function SvgIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", Object.assign({
        viewBox: "0 0 24 24",
        focusable: "false",
        style: {
            fontSize: 20,
            marginInlineEnd: 8,
            userSelect: 'none',
            width: '1em',
            height: '1em',
            display: 'inline-block',
            fill: 'currentColor',
            flexShrink: 0
        }
    }, props));
};
var $e5b3986eed0aa56e$var$CheckIcon = function CheckIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e5b3986eed0aa56e$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41\n        10.59L10 14.17L17.59 6.58L19 8L10 17Z"
    }));
};
var $e5b3986eed0aa56e$var$WarningIcon = function WarningIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e5b3986eed0aa56e$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z"
    }));
};
var $e5b3986eed0aa56e$var$ErrorIcon = function ErrorIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e5b3986eed0aa56e$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,\n        6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,\n        13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
    }));
};
var $e5b3986eed0aa56e$var$InfoIcon = function InfoIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e5b3986eed0aa56e$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,\n        0 22,12A10,10 0 0,0 12,2Z"
    }));
};
var $e5b3986eed0aa56e$var$defaultIconVariants = {
    "default": undefined,
    success: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e5b3986eed0aa56e$var$CheckIcon, null),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e5b3986eed0aa56e$var$WarningIcon, null),
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e5b3986eed0aa56e$var$ErrorIcon, null),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e5b3986eed0aa56e$var$InfoIcon, null)
};
var $e5b3986eed0aa56e$var$defaults = {
    maxSnack: 3,
    persist: false,
    hideIconVariant: false,
    disableWindowBlurListener: false,
    variant: 'default',
    autoHideDuration: 5000,
    iconVariant: $e5b3986eed0aa56e$var$defaultIconVariants,
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
    },
    TransitionComponent: $e5b3986eed0aa56e$var$Slide,
    transitionDuration: {
        enter: 225,
        exit: 195
    }
};
/**
 * Derives the right autoHideDuration taking into account the following
 * prority order: 1: Options, 2: Props, 3: default fallback
 */ var $e5b3986eed0aa56e$var$getAutoHideDuration = function getAutoHideDuration(optionsDuration, propsDuration) {
    var isNumberOrNull = function isNumberOrNull(numberish) {
        return typeof numberish === 'number' || numberish === null;
    };
    if (isNumberOrNull(optionsDuration)) return optionsDuration;
    if (isNumberOrNull(propsDuration)) return propsDuration;
    return $e5b3986eed0aa56e$var$defaults.autoHideDuration;
};
/**
 * Derives the right transitionDuration taking into account the following
 * prority order: 1: Options, 2: Props, 3: default fallback
 */ var $e5b3986eed0aa56e$var$getTransitionDuration = function getTransitionDuration(optionsDuration, propsDuration) {
    var is = function is(item, types) {
        return types.some(function(t) {
            return typeof item === t;
        });
    };
    if (is(optionsDuration, [
        'string',
        'number'
    ])) return optionsDuration;
    if (is(optionsDuration, [
        'object'
    ])) return $e5b3986eed0aa56e$var$_extends({}, $e5b3986eed0aa56e$var$defaults.transitionDuration, {}, is(propsDuration, [
        'object'
    ]) && propsDuration, {}, optionsDuration);
    if (is(propsDuration, [
        'string',
        'number'
    ])) return propsDuration;
    if (is(propsDuration, [
        'object'
    ])) return $e5b3986eed0aa56e$var$_extends({}, $e5b3986eed0aa56e$var$defaults.transitionDuration, {}, propsDuration);
    return $e5b3986eed0aa56e$var$defaults.transitionDuration;
};
var $e5b3986eed0aa56e$var$merge = function merge(options, props) {
    return function(name, shouldObjectMerge) {
        if (shouldObjectMerge === void 0) shouldObjectMerge = false;
        if (shouldObjectMerge) return $e5b3986eed0aa56e$var$_extends({}, $e5b3986eed0aa56e$var$defaults[name], {}, props[name], {}, options[name]);
        if (name === 'autoHideDuration') return $e5b3986eed0aa56e$var$getAutoHideDuration(options.autoHideDuration, props.autoHideDuration);
        if (name === 'transitionDuration') return $e5b3986eed0aa56e$var$getTransitionDuration(options.transitionDuration, props.transitionDuration);
        return options[name] || props[name] || $e5b3986eed0aa56e$var$defaults[name];
    };
};
function $e5b3986eed0aa56e$var$makeStyles(styles) {
    return Object.entries(styles).reduce(function(acc, _ref) {
        var _extends2;
        var key = _ref[0], value = _ref[1];
        return $e5b3986eed0aa56e$var$_extends({}, acc, (_extends2 = {}, _extends2[key] = (0, $5PDlY.css)(value), _extends2));
    }, {});
}
var $e5b3986eed0aa56e$var$ComponentClasses = {
    SnackbarContainer: 'notistack-SnackbarContainer',
    Snackbar: 'notistack-Snackbar',
    CollapseWrapper: 'notistack-CollapseWrapper',
    MuiContent: 'notistack-MuiContent',
    MuiContentVariant: function MuiContentVariant(variant) {
        return "notistack-MuiContent-" + variant;
    }
};
var $e5b3986eed0aa56e$var$classes = /*#__PURE__*/ $e5b3986eed0aa56e$var$makeStyles({
    root: {
        height: 0
    },
    entered: {
        height: 'auto'
    }
});
var $e5b3986eed0aa56e$var$collapsedSize = '0px';
var $e5b3986eed0aa56e$var$timeout = 175;
var $e5b3986eed0aa56e$var$Collapse = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
    var children = props.children, inProp = props["in"], onExited = props.onExited;
    var wrapperRef = (0, $7fPBF.useRef)(null);
    var nodeRef = (0, $7fPBF.useRef)(null);
    var handleRef = $e5b3986eed0aa56e$var$useForkRef(ref, nodeRef);
    var getWrapperSize = function getWrapperSize() {
        return wrapperRef.current ? wrapperRef.current.clientHeight : 0;
    };
    var handleEnter = function handleEnter(node) {
        node.style.height = $e5b3986eed0aa56e$var$collapsedSize;
    };
    var handleEntering = function handleEntering(node) {
        var wrapperSize = getWrapperSize();
        var _getTransitionProps = $e5b3986eed0aa56e$var$getTransitionProps({
            timeout: $e5b3986eed0aa56e$var$timeout,
            mode: 'enter'
        }), transitionDuration = _getTransitionProps.duration, easing = _getTransitionProps.easing;
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : transitionDuration + "ms";
        node.style.height = wrapperSize + "px";
        node.style.transitionTimingFunction = easing || '';
    };
    var handleEntered = function handleEntered(node) {
        node.style.height = 'auto';
    };
    var handleExit = function handleExit(node) {
        node.style.height = getWrapperSize() + "px";
    };
    var handleExiting = function handleExiting(node) {
        $e5b3986eed0aa56e$var$reflow(node);
        var _getTransitionProps2 = $e5b3986eed0aa56e$var$getTransitionProps({
            timeout: $e5b3986eed0aa56e$var$timeout,
            mode: 'exit'
        }), transitionDuration = _getTransitionProps2.duration, easing = _getTransitionProps2.easing;
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : transitionDuration + "ms";
        node.style.height = $e5b3986eed0aa56e$var$collapsedSize;
        node.style.transitionTimingFunction = easing || '';
    };
    return (0, $7fPBF.createElement)($e5b3986eed0aa56e$export$be58926105124dd4, {
        "in": inProp,
        unmountOnExit: true,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: onExited,
        onExiting: handleExiting,
        nodeRef: nodeRef,
        timeout: $e5b3986eed0aa56e$var$timeout
    }, function(state, childProps) {
        return (0, $7fPBF.createElement)("div", Object.assign({
            ref: handleRef,
            className: (0, $CVsbx.default)($e5b3986eed0aa56e$var$classes.root, state === 'entered' && $e5b3986eed0aa56e$var$classes.entered),
            style: $e5b3986eed0aa56e$var$_extends({
                pointerEvents: 'all',
                overflow: 'hidden',
                minHeight: $e5b3986eed0aa56e$var$collapsedSize,
                transition: $e5b3986eed0aa56e$var$createTransition('height')
            }, state === 'entered' && {
                overflow: 'visible'
            }, {}, state === 'exited' && !inProp && {
                visibility: 'hidden'
            })
        }, childProps), (0, $7fPBF.createElement)("div", {
            ref: wrapperRef,
            className: $e5b3986eed0aa56e$var$ComponentClasses.CollapseWrapper,
            // Hack to get children with a negative margin to not falsify the height computation.
            style: {
                display: 'flex',
                width: '100%'
            }
        }, children));
    });
});
$e5b3986eed0aa56e$var$Collapse.displayName = 'Collapse';
var $e5b3986eed0aa56e$var$direction = {
    right: 'left',
    left: 'right',
    bottom: 'up',
    top: 'down'
};
var $e5b3986eed0aa56e$var$getSlideDirection = function getSlideDirection(anchorOrigin) {
    if (anchorOrigin.horizontal !== 'center') return $e5b3986eed0aa56e$var$direction[anchorOrigin.horizontal];
    return $e5b3986eed0aa56e$var$direction[anchorOrigin.vertical];
};
/** Tranforms classes name */ var $e5b3986eed0aa56e$var$toSnackbarAnchorOrigin = function toSnackbarAnchorOrigin(anchorOrigin) {
    return "anchorOrigin" + $e5b3986eed0aa56e$var$originKeyExtractor(anchorOrigin);
};
/**
 * Omit SnackbarContainer class keys that are not needed for SnackbarItem
 */ var $e5b3986eed0aa56e$var$keepSnackbarClassKeys = function keepSnackbarClassKeys(classes) {
    if (classes === void 0) classes = {};
    var containerClasses = {
        containerRoot: true,
        containerAnchorOriginTopCenter: true,
        containerAnchorOriginBottomCenter: true,
        containerAnchorOriginTopRight: true,
        containerAnchorOriginBottomRight: true,
        containerAnchorOriginTopLeft: true,
        containerAnchorOriginBottomLeft: true
    };
    return Object.keys(classes).filter(function(key) {
        return !containerClasses[key];
    }).reduce(function(obj, key) {
        var _extends2;
        return $e5b3986eed0aa56e$var$_extends({}, obj, (_extends2 = {}, _extends2[key] = classes[key], _extends2));
    }, {});
};
var $e5b3986eed0aa56e$var$noOp$1 = function noOp() {
/* */ };
/**
 * Credit to MUI team @ https://mui.com
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $e5b3986eed0aa56e$var$createChainedFunction(funcs, snackbarId) {
    // @ts-ignore
    return funcs.reduce(function(acc, func) {
        if (func === null || func === undefined) return acc;
        return function chainedFunction() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var argums = [].concat(args);
            if (snackbarId && argums.indexOf(snackbarId) === -1) argums.push(snackbarId);
             // @ts-ignore
            acc.apply(this, argums);
            func.apply(this, argums);
        };
    }, $e5b3986eed0aa56e$var$noOp$1);
}
/**
 * Credit to MUI team @ https://mui.com
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 */ var $e5b3986eed0aa56e$var$useEnhancedEffect = typeof window !== 'undefined' ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);
function $e5b3986eed0aa56e$var$useEventCallback(fn) {
    var ref = (0, $7fPBF.useRef)(fn);
    $e5b3986eed0aa56e$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return (0, $7fPBF.useCallback)(function() {
        return ref.current.apply(void 0, arguments);
    }, []);
}
/**
 * Credit to MUI team @ https://mui.com
 */ var $e5b3986eed0aa56e$var$Snackbar = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
    var children = props.children, className = props.className, autoHideDuration = props.autoHideDuration, _props$disableWindowB = props.disableWindowBlurListener, disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB, onClose = props.onClose, id = props.id, open = props.open, _props$SnackbarProps = props.SnackbarProps, SnackbarProps = _props$SnackbarProps === void 0 ? {} : _props$SnackbarProps;
    var timerAutoHide = (0, $7fPBF.useRef)();
    var handleClose = $e5b3986eed0aa56e$var$useEventCallback(function() {
        if (onClose) onClose.apply(void 0, arguments);
    });
    var setAutoHideTimer = $e5b3986eed0aa56e$var$useEventCallback(function(autoHideDurationParam) {
        if (!onClose || autoHideDurationParam == null) return;
        if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
        timerAutoHide.current = setTimeout(function() {
            handleClose(null, 'timeout', id);
        }, autoHideDurationParam);
    });
    (0, $7fPBF.useEffect)(function() {
        if (open) setAutoHideTimer(autoHideDuration);
        return function() {
            if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
        };
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer
    ]);
    /**
   * Pause the timer when the user is interacting with the Snackbar
   * or when the user hide the window.
   */ var handlePause = function handlePause() {
        if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
    };
    /**
   * Restart the timer when the user is no longer interacting with the Snackbar
   * or when the window is shown back.
   */ var handleResume = (0, $7fPBF.useCallback)(function() {
        if (autoHideDuration != null) setAutoHideTimer(autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        setAutoHideTimer
    ]);
    var handleMouseEnter = function handleMouseEnter(event) {
        if (SnackbarProps.onMouseEnter) SnackbarProps.onMouseEnter(event);
        handlePause();
    };
    var handleMouseLeave = function handleMouseLeave(event) {
        if (SnackbarProps.onMouseLeave) SnackbarProps.onMouseLeave(event);
        handleResume();
    };
    (0, $7fPBF.useEffect)(function() {
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return function() {
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        handleResume,
        open
    ]);
    return (0, $7fPBF.createElement)("div", Object.assign({
        ref: ref
    }, SnackbarProps, {
        className: (0, $CVsbx.default)($e5b3986eed0aa56e$var$ComponentClasses.Snackbar, className),
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
    }), children);
});
$e5b3986eed0aa56e$var$Snackbar.displayName = 'Snackbar';
var $e5b3986eed0aa56e$var$_root;
var $e5b3986eed0aa56e$var$classes$1 = /*#__PURE__*/ $e5b3986eed0aa56e$var$makeStyles({
    root: ($e5b3986eed0aa56e$var$_root = {
        display: 'flex',
        flexWrap: 'wrap',
        flexGrow: 1
    }, $e5b3986eed0aa56e$var$_root[$e5b3986eed0aa56e$var$breakpoints.upSm] = {
        flexGrow: 'initial',
        minWidth: '288px'
    }, $e5b3986eed0aa56e$var$_root)
});
var $e5b3986eed0aa56e$export$860cef82710cac7 = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var className = _ref.className, props = $e5b3986eed0aa56e$var$_objectWithoutPropertiesLoose(_ref, [
        "className"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", Object.assign({
        ref: ref,
        className: (0, $CVsbx.default)($e5b3986eed0aa56e$var$classes$1.root, className)
    }, props));
});
$e5b3986eed0aa56e$export$860cef82710cac7.displayName = 'SnackbarContent';
var $e5b3986eed0aa56e$var$classes$2 = /*#__PURE__*/ $e5b3986eed0aa56e$var$makeStyles({
    root: {
        backgroundColor: '#313131',
        fontSize: '0.875rem',
        lineHeight: 1.43,
        letterSpacing: '0.01071em',
        color: '#fff',
        alignItems: 'center',
        padding: '6px 16px',
        borderRadius: '4px',
        boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)'
    },
    lessPadding: {
        paddingLeft: "20px"
    },
    "default": {
        backgroundColor: '#313131'
    },
    success: {
        backgroundColor: '#43a047'
    },
    error: {
        backgroundColor: '#d32f2f'
    },
    warning: {
        backgroundColor: '#ff9800'
    },
    info: {
        backgroundColor: '#2196f3'
    },
    message: {
        display: 'flex',
        alignItems: 'center',
        padding: '8px 0'
    },
    action: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 'auto',
        paddingLeft: '16px',
        marginRight: '-8px'
    }
});
var $e5b3986eed0aa56e$var$ariaDescribedby = 'notistack-snackbar';
var $e5b3986eed0aa56e$var$MaterialDesignContent = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, forwardedRef) {
    var id = props.id, message = props.message, componentOrFunctionAction = props.action, iconVariant = props.iconVariant, variant = props.variant, hideIconVariant = props.hideIconVariant, style = props.style, className = props.className;
    var icon = iconVariant[variant];
    var action = componentOrFunctionAction;
    if (typeof action === 'function') action = action(id);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e5b3986eed0aa56e$export$860cef82710cac7, {
        ref: forwardedRef,
        role: "alert",
        "aria-describedby": $e5b3986eed0aa56e$var$ariaDescribedby,
        style: style,
        className: (0, $CVsbx.default)($e5b3986eed0aa56e$var$ComponentClasses.MuiContent, $e5b3986eed0aa56e$var$ComponentClasses.MuiContentVariant(variant), $e5b3986eed0aa56e$var$classes$2.root, $e5b3986eed0aa56e$var$classes$2[variant], className, !hideIconVariant && icon && $e5b3986eed0aa56e$var$classes$2.lessPadding)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        id: $e5b3986eed0aa56e$var$ariaDescribedby,
        className: $e5b3986eed0aa56e$var$classes$2.message
    }, !hideIconVariant ? icon : null, message), action && (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: $e5b3986eed0aa56e$var$classes$2.action
    }, action));
});
$e5b3986eed0aa56e$var$MaterialDesignContent.displayName = 'MaterialDesignContent';
var $e5b3986eed0aa56e$export$407b0b907b65dfeb = /*#__PURE__*/ (0, $7fPBF.memo)($e5b3986eed0aa56e$var$MaterialDesignContent);
var $e5b3986eed0aa56e$var$styles = /*#__PURE__*/ $e5b3986eed0aa56e$var$makeStyles({
    wrappedRoot: {
        width: '100%',
        position: 'relative',
        transform: 'translateX(0)',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        minWidth: '288px'
    }
});
var $e5b3986eed0aa56e$var$SnackbarItem = function SnackbarItem(props) {
    var timeout = (0, $7fPBF.useRef)();
    var _useState = (0, $7fPBF.useState)(true), collapsed = _useState[0], setCollapsed = _useState[1];
    var handleClose = $e5b3986eed0aa56e$var$createChainedFunction([
        props.snack.onClose,
        props.onClose
    ]);
    var handleEntered = function handleEntered() {
        if (props.snack.requestClose) handleClose(null, 'instructed', props.snack.id);
    };
    var handleExitedScreen = (0, $7fPBF.useCallback)(function() {
        timeout.current = setTimeout(function() {
            setCollapsed(function(col) {
                return !col;
            });
        }, 125);
    }, []);
    (0, $7fPBF.useEffect)(function() {
        return function() {
            if (timeout.current) clearTimeout(timeout.current);
        };
    }, []);
    var snack = props.snack, allClasses = props.classes, _props$Component = props.Component, Component = _props$Component === void 0 ? $e5b3986eed0aa56e$export$407b0b907b65dfeb : _props$Component;
    var classes = (0, $7fPBF.useMemo)(function() {
        return $e5b3986eed0aa56e$var$keepSnackbarClassKeys(allClasses);
    }, [
        allClasses
    ]);
    var open = snack.open, SnackbarProps = snack.SnackbarProps, TransitionComponent = snack.TransitionComponent, TransitionProps = snack.TransitionProps, transitionDuration = snack.transitionDuration, disableWindowBlurListener = snack.disableWindowBlurListener, componentOrFunctionContent = snack.content, otherSnack = $e5b3986eed0aa56e$var$_objectWithoutPropertiesLoose(snack, [
        "open",
        "SnackbarProps",
        "TransitionComponent",
        "TransitionProps",
        "transitionDuration",
        "disableWindowBlurListener",
        "content",
        "entered",
        "requestClose",
        "onEnter",
        "onEntered",
        "onExit",
        "onExited"
    ]);
    var transitionProps = $e5b3986eed0aa56e$var$_extends({
        direction: $e5b3986eed0aa56e$var$getSlideDirection(otherSnack.anchorOrigin),
        timeout: transitionDuration
    }, TransitionProps);
    var content = componentOrFunctionContent;
    if (typeof content === 'function') content = content(otherSnack.id, otherSnack.message);
    var callbacks = [
        'onEnter',
        'onEntered',
        'onExit',
        'onExited'
    ].reduce(function(acc, cbName) {
        var _extends2;
        return $e5b3986eed0aa56e$var$_extends({}, acc, (_extends2 = {}, _extends2[cbName] = $e5b3986eed0aa56e$var$createChainedFunction([
            props.snack[cbName],
            props[cbName]
        ], otherSnack.id), _extends2));
    }, {});
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e5b3986eed0aa56e$var$Collapse, {
        "in": collapsed,
        onExited: callbacks.onExited
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e5b3986eed0aa56e$var$Snackbar, {
        open: open,
        id: otherSnack.id,
        disableWindowBlurListener: disableWindowBlurListener,
        autoHideDuration: otherSnack.autoHideDuration,
        className: (0, $CVsbx.default)($e5b3986eed0aa56e$var$styles.wrappedRoot, classes.root, classes[$e5b3986eed0aa56e$var$toSnackbarAnchorOrigin(otherSnack.anchorOrigin)]),
        SnackbarProps: SnackbarProps,
        onClose: handleClose
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(TransitionComponent, Object.assign({}, transitionProps, {
        appear: true,
        "in": open,
        onExit: callbacks.onExit,
        onExited: handleExitedScreen,
        onEnter: callbacks.onEnter,
        // order matters. first callbacks.onEntered to set entered: true,
        // then handleEntered to check if there's a request for closing
        onEntered: $e5b3986eed0aa56e$var$createChainedFunction([
            callbacks.onEntered,
            handleEntered
        ], otherSnack.id)
    }), content || (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, Object.assign({}, otherSnack)))));
};
var $e5b3986eed0aa56e$var$_root$1, $e5b3986eed0aa56e$var$_rootDense, $e5b3986eed0aa56e$var$_left, $e5b3986eed0aa56e$var$_right, $e5b3986eed0aa56e$var$_center;
var $e5b3986eed0aa56e$var$indents = {
    view: {
        "default": 20,
        dense: 4
    },
    snackbar: {
        "default": 6,
        dense: 2
    }
};
var $e5b3986eed0aa56e$var$collapseWrapper = "." + $e5b3986eed0aa56e$var$ComponentClasses.CollapseWrapper;
var $e5b3986eed0aa56e$var$xsWidthMargin = 16;
var $e5b3986eed0aa56e$var$styles$1 = /*#__PURE__*/ $e5b3986eed0aa56e$var$makeStyles({
    root: ($e5b3986eed0aa56e$var$_root$1 = {
        boxSizing: 'border-box',
        display: 'flex',
        maxHeight: '100%',
        position: 'fixed',
        zIndex: 1400,
        height: 'auto',
        width: 'auto',
        transition: /*#__PURE__*/ $e5b3986eed0aa56e$var$createTransition([
            'top',
            'right',
            'bottom',
            'left',
            'max-width'
        ], {
            duration: 300,
            easing: 'ease'
        }),
        // container itself is invisible and should not block clicks, clicks should be passed to its children
        // a pointerEvents: all is applied in the collapse component
        pointerEvents: 'none'
    }, $e5b3986eed0aa56e$var$_root$1[$e5b3986eed0aa56e$var$collapseWrapper] = {
        padding: $e5b3986eed0aa56e$var$indents.snackbar["default"] + "px 0px",
        transition: 'padding 300ms ease 0ms'
    }, $e5b3986eed0aa56e$var$_root$1.maxWidth = "calc(100% - " + $e5b3986eed0aa56e$var$indents.view["default"] * 2 + "px)", $e5b3986eed0aa56e$var$_root$1[$e5b3986eed0aa56e$var$breakpoints.downXs] = {
        width: '100%',
        maxWidth: "calc(100% - " + $e5b3986eed0aa56e$var$xsWidthMargin * 2 + "px)"
    }, $e5b3986eed0aa56e$var$_root$1),
    rootDense: ($e5b3986eed0aa56e$var$_rootDense = {}, $e5b3986eed0aa56e$var$_rootDense[$e5b3986eed0aa56e$var$collapseWrapper] = {
        padding: $e5b3986eed0aa56e$var$indents.snackbar.dense + "px 0px"
    }, $e5b3986eed0aa56e$var$_rootDense),
    top: {
        top: $e5b3986eed0aa56e$var$indents.view["default"] - $e5b3986eed0aa56e$var$indents.snackbar["default"] + "px",
        flexDirection: 'column'
    },
    bottom: {
        bottom: $e5b3986eed0aa56e$var$indents.view["default"] - $e5b3986eed0aa56e$var$indents.snackbar["default"] + "px",
        flexDirection: 'column-reverse'
    },
    left: ($e5b3986eed0aa56e$var$_left = {
        left: $e5b3986eed0aa56e$var$indents.view["default"] + "px"
    }, $e5b3986eed0aa56e$var$_left[$e5b3986eed0aa56e$var$breakpoints.upSm] = {
        alignItems: 'flex-start'
    }, $e5b3986eed0aa56e$var$_left[$e5b3986eed0aa56e$var$breakpoints.downXs] = {
        left: $e5b3986eed0aa56e$var$xsWidthMargin + "px"
    }, $e5b3986eed0aa56e$var$_left),
    right: ($e5b3986eed0aa56e$var$_right = {
        right: $e5b3986eed0aa56e$var$indents.view["default"] + "px"
    }, $e5b3986eed0aa56e$var$_right[$e5b3986eed0aa56e$var$breakpoints.upSm] = {
        alignItems: 'flex-end'
    }, $e5b3986eed0aa56e$var$_right[$e5b3986eed0aa56e$var$breakpoints.downXs] = {
        right: $e5b3986eed0aa56e$var$xsWidthMargin + "px"
    }, $e5b3986eed0aa56e$var$_right),
    center: ($e5b3986eed0aa56e$var$_center = {
        left: '50%',
        transform: 'translateX(-50%)'
    }, $e5b3986eed0aa56e$var$_center[$e5b3986eed0aa56e$var$breakpoints.upSm] = {
        alignItems: 'center'
    }, $e5b3986eed0aa56e$var$_center)
});
var $e5b3986eed0aa56e$var$SnackbarContainer = function SnackbarContainer(props) {
    var _props$classes = props.classes, classes = _props$classes === void 0 ? {} : _props$classes, anchorOrigin = props.anchorOrigin, dense = props.dense, children = props.children;
    var combinedClassname = (0, $CVsbx.default)($e5b3986eed0aa56e$var$ComponentClasses.SnackbarContainer, $e5b3986eed0aa56e$var$styles$1[anchorOrigin.vertical], $e5b3986eed0aa56e$var$styles$1[anchorOrigin.horizontal], $e5b3986eed0aa56e$var$styles$1.root, classes.containerRoot, classes["containerAnchorOrigin" + $e5b3986eed0aa56e$var$originKeyExtractor(anchorOrigin)], dense && $e5b3986eed0aa56e$var$styles$1.rootDense);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: combinedClassname
    }, children);
};
var $e5b3986eed0aa56e$var$SnackbarContainer$1 = /*#__PURE__*/ (0, $7fPBF.memo)($e5b3986eed0aa56e$var$SnackbarContainer);
/* eslint-disable */ var $e5b3986eed0aa56e$var$__DEV__ = false;
var $e5b3986eed0aa56e$var$messages = {
    NO_PERSIST_ALL: "Reached maxSnack while all enqueued snackbars have 'persist' flag. Notistack will dismiss the oldest snackbar anyway to allow other ones in the queue to be presented."
};
var $e5b3986eed0aa56e$var$warning = function(messageKey) {
    if (!$e5b3986eed0aa56e$var$__DEV__) return;
    var message = $e5b3986eed0aa56e$var$messages[messageKey];
    if (typeof console !== 'undefined') console.error("WARNING - notistack: " + message);
    try {
        throw new Error(message);
    } catch (x) {}
};
var $e5b3986eed0aa56e$var$isOptions = function isOptions(messageOrOptions) {
    var isMessage = typeof messageOrOptions === 'string' || (0, $7fPBF.isValidElement)(messageOrOptions);
    return !isMessage;
};
var $e5b3986eed0aa56e$export$9d70c354f0150b1b;
var $e5b3986eed0aa56e$export$823cdc5238933767;
var $e5b3986eed0aa56e$export$d1e619fddc3508ce = /*#__PURE__*/ function(_Component) {
    $e5b3986eed0aa56e$var$_inheritsLoose(SnackbarProvider, _Component);
    function SnackbarProvider(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        /**
     * Adds a new snackbar to the queue to be presented.
     * Returns generated or user defined key referencing the new snackbar or null
     */ _this.enqueueSnackbar = function(messageOrOptions, optsOrUndefined) {
            if (optsOrUndefined === void 0) optsOrUndefined = {};
            if (messageOrOptions === undefined || messageOrOptions === null) throw new Error('enqueueSnackbar called with invalid argument');
            var opts = $e5b3986eed0aa56e$var$isOptions(messageOrOptions) ? messageOrOptions : optsOrUndefined;
            var message = $e5b3986eed0aa56e$var$isOptions(messageOrOptions) ? messageOrOptions.message : messageOrOptions;
            var key = opts.key, preventDuplicate = opts.preventDuplicate, options = $e5b3986eed0aa56e$var$_objectWithoutPropertiesLoose(opts, [
                "key",
                "preventDuplicate"
            ]);
            var hasSpecifiedKey = $e5b3986eed0aa56e$var$isDefined(key);
            var id = hasSpecifiedKey ? key : new Date().getTime() + Math.random();
            var merger = $e5b3986eed0aa56e$var$merge(options, _this.props);
            var snack = $e5b3986eed0aa56e$var$_extends({
                id: id
            }, options, {
                message: message,
                open: true,
                entered: false,
                requestClose: false,
                persist: merger('persist'),
                action: merger('action'),
                content: merger('content'),
                variant: merger('variant'),
                anchorOrigin: merger('anchorOrigin'),
                disableWindowBlurListener: merger('disableWindowBlurListener'),
                autoHideDuration: merger('autoHideDuration'),
                hideIconVariant: merger('hideIconVariant'),
                TransitionComponent: merger('TransitionComponent'),
                transitionDuration: merger('transitionDuration'),
                TransitionProps: merger('TransitionProps', true),
                iconVariant: merger('iconVariant', true),
                style: merger('style', true),
                SnackbarProps: merger('SnackbarProps', true),
                className: (0, $CVsbx.default)(_this.props.className, options.className)
            });
            if (snack.persist) snack.autoHideDuration = undefined;
            _this.setState(function(state) {
                if (preventDuplicate === undefined && _this.props.preventDuplicate || preventDuplicate) {
                    var compareFunction = function compareFunction(item) {
                        return hasSpecifiedKey ? item.id === id : item.message === message;
                    };
                    var inQueue = state.queue.findIndex(compareFunction) > -1;
                    var inView = state.snacks.findIndex(compareFunction) > -1;
                    if (inQueue || inView) return state;
                }
                return _this.handleDisplaySnack($e5b3986eed0aa56e$var$_extends({}, state, {
                    queue: [].concat(state.queue, [
                        snack
                    ])
                }));
            });
            return id;
        };
        /**
     * Reducer: Display snack if there's space for it. Otherwise, immediately
     * begin dismissing the oldest message to start showing the new one.
     */ _this.handleDisplaySnack = function(state) {
            var snacks = state.snacks;
            if (snacks.length >= _this.maxSnack) return _this.handleDismissOldest(state);
            return _this.processQueue(state);
        };
        /**
     * Reducer: Display items (notifications) in the queue if there's space for them.
     */ _this.processQueue = function(state) {
            var queue = state.queue, snacks = state.snacks;
            if (queue.length > 0) return $e5b3986eed0aa56e$var$_extends({}, state, {
                snacks: [].concat(snacks, [
                    queue[0]
                ]),
                queue: queue.slice(1, queue.length)
            });
            return state;
        };
        /**
     * Reducer: Hide oldest snackbar on the screen because there exists a new one which we have to display.
     * (ignoring the one with 'persist' flag. i.e. explicitly told by user not to get dismissed).
     *
     * Note 1: If there is already a message leaving the screen, no new messages are dismissed.
     * Note 2: If the oldest message has not yet entered the screen, only a request to close the
     *         snackbar is made. Once it entered the screen, it will be immediately dismissed.
     */ _this.handleDismissOldest = function(state) {
            if (state.snacks.some(function(item) {
                return !item.open || item.requestClose;
            })) return state;
            var popped = false;
            var ignore = false;
            var persistentCount = state.snacks.reduce(function(acc, current) {
                return acc + (current.open && current.persist ? 1 : 0);
            }, 0);
            if (persistentCount === _this.maxSnack) ignore = true;
            var snacks = state.snacks.map(function(item) {
                if (!popped && (!item.persist || ignore)) {
                    popped = true;
                    if (!item.entered) return $e5b3986eed0aa56e$var$_extends({}, item, {
                        requestClose: true
                    });
                    if (item.onClose) item.onClose(null, 'maxsnack', item.id);
                    if (_this.props.onClose) _this.props.onClose(null, 'maxsnack', item.id);
                    return $e5b3986eed0aa56e$var$_extends({}, item, {
                        open: false
                    });
                }
                return $e5b3986eed0aa56e$var$_extends({}, item);
            });
            return $e5b3986eed0aa56e$var$_extends({}, state, {
                snacks: snacks
            });
        };
        /**
     * Set the entered state of the snackbar with the given key.
     */ _this.handleEnteredSnack = function(node, isAppearing, key) {
            if (!$e5b3986eed0aa56e$var$isDefined(key)) throw new Error('handleEnteredSnack Cannot be called with undefined key');
            _this.setState(function(_ref) {
                var snacks = _ref.snacks;
                return {
                    snacks: snacks.map(function(item) {
                        return item.id === key ? $e5b3986eed0aa56e$var$_extends({}, item, {
                            entered: true
                        }) : $e5b3986eed0aa56e$var$_extends({}, item);
                    })
                };
            });
        };
        /**
     * Hide a snackbar after its timeout.
     */ _this.handleCloseSnack = function(event, reason, key) {
            // should not use createChainedFunction for onClose.
            // because this.closeSnackbar called this function
            if (_this.props.onClose) _this.props.onClose(event, reason, key);
            var shouldCloseAll = key === undefined;
            _this.setState(function(_ref2) {
                var snacks = _ref2.snacks, queue = _ref2.queue;
                return {
                    snacks: snacks.map(function(item) {
                        if (!shouldCloseAll && item.id !== key) return $e5b3986eed0aa56e$var$_extends({}, item);
                        return item.entered ? $e5b3986eed0aa56e$var$_extends({}, item, {
                            open: false
                        }) : $e5b3986eed0aa56e$var$_extends({}, item, {
                            requestClose: true
                        });
                    }),
                    queue: queue.filter(function(item) {
                        return item.id !== key;
                    })
                };
            });
        };
        /**
     * Close snackbar with the given key
     */ _this.closeSnackbar = function(key) {
            // call individual snackbar onClose callback passed through options parameter
            var toBeClosed = _this.state.snacks.find(function(item) {
                return item.id === key;
            });
            if ($e5b3986eed0aa56e$var$isDefined(key) && toBeClosed && toBeClosed.onClose) toBeClosed.onClose(null, 'instructed', key);
            _this.handleCloseSnack(null, 'instructed', key);
        };
        /**
     * When we set open attribute of a snackbar to false (i.e. after we hide a snackbar),
     * it leaves the screen and immediately after leaving animation is done, this method
     * gets called. We remove the hidden snackbar from state and then display notifications
     * waiting in the queue (if any). If after this process the queue is not empty, the
     * oldest message is dismissed.
     */ _this.handleExitedSnack = function(node, key) {
            if (!$e5b3986eed0aa56e$var$isDefined(key)) throw new Error('handleExitedSnack Cannot be called with undefined key');
            _this.setState(function(state) {
                var newState = _this.processQueue($e5b3986eed0aa56e$var$_extends({}, state, {
                    snacks: state.snacks.filter(function(item) {
                        return item.id !== key;
                    })
                }));
                if (newState.queue.length === 0) return newState;
                return _this.handleDismissOldest(newState);
            });
        };
        $e5b3986eed0aa56e$export$9d70c354f0150b1b = _this.enqueueSnackbar;
        $e5b3986eed0aa56e$export$823cdc5238933767 = _this.closeSnackbar;
        _this.state = {
            snacks: [],
            queue: [],
            contextValue: {
                enqueueSnackbar: _this.enqueueSnackbar.bind($e5b3986eed0aa56e$var$_assertThisInitialized(_this)),
                closeSnackbar: _this.closeSnackbar.bind($e5b3986eed0aa56e$var$_assertThisInitialized(_this))
            }
        };
        return _this;
    }
    var _proto = SnackbarProvider.prototype;
    _proto.render = function render() {
        var _this2 = this;
        var contextValue = this.state.contextValue;
        var _this$props = this.props, domRoot = _this$props.domRoot, children = _this$props.children, _this$props$dense = _this$props.dense, dense = _this$props$dense === void 0 ? false : _this$props$dense, _this$props$Component = _this$props.Components, Components = _this$props$Component === void 0 ? {} : _this$props$Component, classes = _this$props.classes;
        var categ = this.state.snacks.reduce(function(acc, current) {
            var _extends2;
            var category = $e5b3986eed0aa56e$var$originKeyExtractor(current.anchorOrigin);
            var existingOfCategory = acc[category] || [];
            return $e5b3986eed0aa56e$var$_extends({}, acc, (_extends2 = {}, _extends2[category] = [].concat(existingOfCategory, [
                current
            ]), _extends2));
        }, {});
        var snackbars = Object.keys(categ).map(function(origin) {
            var snacks = categ[origin];
            var nomineeSnack = snacks[0];
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e5b3986eed0aa56e$var$SnackbarContainer$1, {
                key: origin,
                dense: dense,
                anchorOrigin: nomineeSnack.anchorOrigin,
                classes: classes
            }, snacks.map(function(snack) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e5b3986eed0aa56e$var$SnackbarItem, {
                    key: snack.id,
                    snack: snack,
                    classes: classes,
                    Component: Components[snack.variant],
                    onClose: _this2.handleCloseSnack,
                    onEnter: _this2.props.onEnter,
                    onExit: _this2.props.onExit,
                    onExited: $e5b3986eed0aa56e$var$createChainedFunction([
                        _this2.handleExitedSnack,
                        _this2.props.onExited
                    ], snack.id),
                    onEntered: $e5b3986eed0aa56e$var$createChainedFunction([
                        _this2.handleEnteredSnack,
                        _this2.props.onEntered
                    ], snack.id)
                });
            }));
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e5b3986eed0aa56e$var$SnackbarContext.Provider, {
            value: contextValue
        }, children, domRoot ? (0, $fw0lo.createPortal)(snackbars, domRoot) : snackbars);
    };
    $e5b3986eed0aa56e$var$_createClass(SnackbarProvider, [
        {
            key: "maxSnack",
            get: function get() {
                return this.props.maxSnack || $e5b3986eed0aa56e$var$defaults.maxSnack;
            }
        }
    ]);
    return SnackbarProvider;
}((0, $7fPBF.Component));
var $e5b3986eed0aa56e$export$1c97ac2c9a6e7c09 = function() {
    return (0, $7fPBF.useContext)($e5b3986eed0aa56e$var$SnackbarContext);
};

});
parcelRegister("fw0lo", function(module, exports) {
'use strict';
function $b4ba1c853f6e1116$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4ba1c853f6e1116$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4ba1c853f6e1116$var$checkDCE();

module.exports = (parcelRequire("6EA3T"));

});
parcelRegister("6EA3T", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4d82739dd229d539$export$ae55be85d98224ed; }, function (v) { return $4d82739dd229d539$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $4d82739dd229d539$export$d39a5bbd09211389; }, function (v) { return $4d82739dd229d539$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $4d82739dd229d539$export$882461b6382ed46c; }, function (v) { return $4d82739dd229d539$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $4d82739dd229d539$export$466bfc07425424d5; }, function (v) { return $4d82739dd229d539$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $4d82739dd229d539$export$cd75ccfd720a3cd4; }, function (v) { return $4d82739dd229d539$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $4d82739dd229d539$export$fa8d919ba61d84db; }, function (v) { return $4d82739dd229d539$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $4d82739dd229d539$export$757ceba2d55c277e; }, function (v) { return $4d82739dd229d539$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $4d82739dd229d539$export$b3890eb0ae9dca99; }, function (v) { return $4d82739dd229d539$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $4d82739dd229d539$export$502457920280e6be; }, function (v) { return $4d82739dd229d539$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $4d82739dd229d539$export$c78a37762a8d58e1; }, function (v) { return $4d82739dd229d539$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $4d82739dd229d539$export$dc54d992c10e8a18; }, function (v) { return $4d82739dd229d539$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $4d82739dd229d539$export$83d89fbfd8236492; }, function (v) { return $4d82739dd229d539$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $4d82739dd229d539$export$ae55be85d98224ed;
var $4d82739dd229d539$export$d39a5bbd09211389;
var $4d82739dd229d539$export$882461b6382ed46c;
var $4d82739dd229d539$export$466bfc07425424d5;
var $4d82739dd229d539$export$cd75ccfd720a3cd4;
var $4d82739dd229d539$export$fa8d919ba61d84db;
var $4d82739dd229d539$export$757ceba2d55c277e;
var $4d82739dd229d539$export$b3890eb0ae9dca99;
var $4d82739dd229d539$export$502457920280e6be;
var $4d82739dd229d539$export$c78a37762a8d58e1;
var $4d82739dd229d539$export$dc54d992c10e8a18;
var $4d82739dd229d539$export$83d89fbfd8236492;
'use strict';

var $7fPBF = parcelRequire("7fPBF");

var $33s19 = parcelRequire("33s19");
function $4d82739dd229d539$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $4d82739dd229d539$var$da = new Set, $4d82739dd229d539$var$ea = {};
function $4d82739dd229d539$var$fa(a, b) {
    $4d82739dd229d539$var$ha(a, b);
    $4d82739dd229d539$var$ha(a + "Capture", b);
}
function $4d82739dd229d539$var$ha(a, b) {
    $4d82739dd229d539$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$4d82739dd229d539$var$da.add(b[a]);
}
var $4d82739dd229d539$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $4d82739dd229d539$var$ja = Object.prototype.hasOwnProperty, $4d82739dd229d539$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $4d82739dd229d539$var$la = {}, $4d82739dd229d539$var$ma = {};
function $4d82739dd229d539$var$oa(a) {
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$ma, a)) return !0;
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$la, a)) return !1;
    if ($4d82739dd229d539$var$ka.test(a)) return $4d82739dd229d539$var$ma[a] = !0;
    $4d82739dd229d539$var$la[a] = !0;
    return !1;
}
function $4d82739dd229d539$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $4d82739dd229d539$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $4d82739dd229d539$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $4d82739dd229d539$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $4d82739dd229d539$var$ra = /[\-:]([a-z])/g;
function $4d82739dd229d539$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$4d82739dd229d539$var$z.xlinkHref = new $4d82739dd229d539$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $4d82739dd229d539$var$ta(a, b, c, d) {
    var e = $4d82739dd229d539$var$z.hasOwnProperty(b) ? $4d82739dd229d539$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $4d82739dd229d539$var$qa(b, c, e, d) && (c = null), d || null === e ? $4d82739dd229d539$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $4d82739dd229d539$var$ua = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $4d82739dd229d539$var$va = Symbol.for("react.element"), $4d82739dd229d539$var$wa = Symbol.for("react.portal"), $4d82739dd229d539$var$ya = Symbol.for("react.fragment"), $4d82739dd229d539$var$za = Symbol.for("react.strict_mode"), $4d82739dd229d539$var$Aa = Symbol.for("react.profiler"), $4d82739dd229d539$var$Ba = Symbol.for("react.provider"), $4d82739dd229d539$var$Ca = Symbol.for("react.context"), $4d82739dd229d539$var$Da = Symbol.for("react.forward_ref"), $4d82739dd229d539$var$Ea = Symbol.for("react.suspense"), $4d82739dd229d539$var$Fa = Symbol.for("react.suspense_list"), $4d82739dd229d539$var$Ga = Symbol.for("react.memo"), $4d82739dd229d539$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $4d82739dd229d539$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $4d82739dd229d539$var$Ja = Symbol.iterator;
function $4d82739dd229d539$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4d82739dd229d539$var$Ja && a[$4d82739dd229d539$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4d82739dd229d539$var$A = Object.assign, $4d82739dd229d539$var$La;
function $4d82739dd229d539$var$Ma(a) {
    if (void 0 === $4d82739dd229d539$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $4d82739dd229d539$var$La = b && b[1] || "";
    }
    return "\n" + $4d82739dd229d539$var$La + a;
}
var $4d82739dd229d539$var$Na = !1;
function $4d82739dd229d539$var$Oa(a, b) {
    if (!a || $4d82739dd229d539$var$Na) return "";
    $4d82739dd229d539$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $4d82739dd229d539$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $4d82739dd229d539$var$Ma(a) : "";
}
function $4d82739dd229d539$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $4d82739dd229d539$var$Ma(a.type);
        case 16:
            return $4d82739dd229d539$var$Ma("Lazy");
        case 13:
            return $4d82739dd229d539$var$Ma("Suspense");
        case 19:
            return $4d82739dd229d539$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $4d82739dd229d539$var$Oa(a.type, !1), a;
        case 11:
            return a = $4d82739dd229d539$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $4d82739dd229d539$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $4d82739dd229d539$var$ya:
            return "Fragment";
        case $4d82739dd229d539$var$wa:
            return "Portal";
        case $4d82739dd229d539$var$Aa:
            return "Profiler";
        case $4d82739dd229d539$var$za:
            return "StrictMode";
        case $4d82739dd229d539$var$Ea:
            return "Suspense";
        case $4d82739dd229d539$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $4d82739dd229d539$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $4d82739dd229d539$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $4d82739dd229d539$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $4d82739dd229d539$var$Ga:
            return b = a.displayName || null, null !== b ? b : $4d82739dd229d539$var$Qa(a.type) || "Memo";
        case $4d82739dd229d539$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $4d82739dd229d539$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $4d82739dd229d539$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $4d82739dd229d539$var$Qa(b);
        case 8:
            return b === $4d82739dd229d539$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $4d82739dd229d539$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $4d82739dd229d539$var$Ua(a) {
    var b = $4d82739dd229d539$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $4d82739dd229d539$var$Va(a) {
    a._valueTracker || (a._valueTracker = $4d82739dd229d539$var$Ua(a));
}
function $4d82739dd229d539$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $4d82739dd229d539$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $4d82739dd229d539$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $4d82739dd229d539$var$Ya(a, b) {
    var c = b.checked;
    return $4d82739dd229d539$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $4d82739dd229d539$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $4d82739dd229d539$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $4d82739dd229d539$var$ab(a, b) {
    b = b.checked;
    null != b && $4d82739dd229d539$var$ta(a, "checked", b, !1);
}
function $4d82739dd229d539$var$bb(a, b) {
    $4d82739dd229d539$var$ab(a, b);
    var c = $4d82739dd229d539$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $4d82739dd229d539$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $4d82739dd229d539$var$cb(a, b.type, $4d82739dd229d539$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $4d82739dd229d539$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $4d82739dd229d539$var$cb(a, b, c) {
    if ("number" !== b || $4d82739dd229d539$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $4d82739dd229d539$var$eb = Array.isArray;
function $4d82739dd229d539$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $4d82739dd229d539$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $4d82739dd229d539$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($4d82739dd229d539$var$p(91));
    return $4d82739dd229d539$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $4d82739dd229d539$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($4d82739dd229d539$var$p(92));
            if ($4d82739dd229d539$var$eb(c)) {
                if (1 < c.length) throw Error($4d82739dd229d539$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $4d82739dd229d539$var$Sa(c)
    };
}
function $4d82739dd229d539$var$ib(a, b) {
    var c = $4d82739dd229d539$var$Sa(b.value), d = $4d82739dd229d539$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $4d82739dd229d539$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $4d82739dd229d539$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $4d82739dd229d539$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $4d82739dd229d539$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $4d82739dd229d539$var$mb, $4d82739dd229d539$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $4d82739dd229d539$var$mb = $4d82739dd229d539$var$mb || document.createElement("div");
        $4d82739dd229d539$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $4d82739dd229d539$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $4d82739dd229d539$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $4d82739dd229d539$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $4d82739dd229d539$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($4d82739dd229d539$var$pb).forEach(function(a) {
    $4d82739dd229d539$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $4d82739dd229d539$var$pb[b] = $4d82739dd229d539$var$pb[a];
    });
});
function $4d82739dd229d539$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $4d82739dd229d539$var$pb.hasOwnProperty(a) && $4d82739dd229d539$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $4d82739dd229d539$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $4d82739dd229d539$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $4d82739dd229d539$var$tb = $4d82739dd229d539$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $4d82739dd229d539$var$ub(a, b) {
    if (b) {
        if ($4d82739dd229d539$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($4d82739dd229d539$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($4d82739dd229d539$var$p(62));
    }
}
function $4d82739dd229d539$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $4d82739dd229d539$var$wb = null;
function $4d82739dd229d539$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $4d82739dd229d539$var$yb = null, $4d82739dd229d539$var$zb = null, $4d82739dd229d539$var$Ab = null;
function $4d82739dd229d539$var$Bb(a) {
    if (a = $4d82739dd229d539$var$Cb(a)) {
        if ("function" !== typeof $4d82739dd229d539$var$yb) throw Error($4d82739dd229d539$var$p(280));
        var b = a.stateNode;
        b && (b = $4d82739dd229d539$var$Db(b), $4d82739dd229d539$var$yb(a.stateNode, a.type, b));
    }
}
function $4d82739dd229d539$var$Eb(a) {
    $4d82739dd229d539$var$zb ? $4d82739dd229d539$var$Ab ? $4d82739dd229d539$var$Ab.push(a) : $4d82739dd229d539$var$Ab = [
        a
    ] : $4d82739dd229d539$var$zb = a;
}
function $4d82739dd229d539$var$Fb() {
    if ($4d82739dd229d539$var$zb) {
        var a = $4d82739dd229d539$var$zb, b = $4d82739dd229d539$var$Ab;
        $4d82739dd229d539$var$Ab = $4d82739dd229d539$var$zb = null;
        $4d82739dd229d539$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$4d82739dd229d539$var$Bb(b[a]);
    }
}
function $4d82739dd229d539$var$Gb(a, b) {
    return a(b);
}
function $4d82739dd229d539$var$Hb() {}
var $4d82739dd229d539$var$Ib = !1;
function $4d82739dd229d539$var$Jb(a, b, c) {
    if ($4d82739dd229d539$var$Ib) return a(b, c);
    $4d82739dd229d539$var$Ib = !0;
    try {
        return $4d82739dd229d539$var$Gb(a, b, c);
    } finally{
        if ($4d82739dd229d539$var$Ib = !1, null !== $4d82739dd229d539$var$zb || null !== $4d82739dd229d539$var$Ab) $4d82739dd229d539$var$Hb(), $4d82739dd229d539$var$Fb();
    }
}
function $4d82739dd229d539$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $4d82739dd229d539$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($4d82739dd229d539$var$p(231, b, typeof c));
    return c;
}
var $4d82739dd229d539$var$Lb = !1;
if ($4d82739dd229d539$var$ia) try {
    var $4d82739dd229d539$var$Mb = {};
    Object.defineProperty($4d82739dd229d539$var$Mb, "passive", {
        get: function() {
            $4d82739dd229d539$var$Lb = !0;
        }
    });
    window.addEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
    window.removeEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
} catch (a) {
    $4d82739dd229d539$var$Lb = !1;
}
function $4d82739dd229d539$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $4d82739dd229d539$var$Ob = !1, $4d82739dd229d539$var$Pb = null, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, $4d82739dd229d539$var$Sb = {
    onError: function(a) {
        $4d82739dd229d539$var$Ob = !0;
        $4d82739dd229d539$var$Pb = a;
    }
};
function $4d82739dd229d539$var$Tb(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Ob = !1;
    $4d82739dd229d539$var$Pb = null;
    $4d82739dd229d539$var$Nb.apply($4d82739dd229d539$var$Sb, arguments);
}
function $4d82739dd229d539$var$Ub(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Tb.apply(this, arguments);
    if ($4d82739dd229d539$var$Ob) {
        if ($4d82739dd229d539$var$Ob) {
            var l = $4d82739dd229d539$var$Pb;
            $4d82739dd229d539$var$Ob = !1;
            $4d82739dd229d539$var$Pb = null;
        } else throw Error($4d82739dd229d539$var$p(198));
        $4d82739dd229d539$var$Qb || ($4d82739dd229d539$var$Qb = !0, $4d82739dd229d539$var$Rb = l);
    }
}
function $4d82739dd229d539$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $4d82739dd229d539$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $4d82739dd229d539$var$Xb(a) {
    if ($4d82739dd229d539$var$Vb(a) !== a) throw Error($4d82739dd229d539$var$p(188));
}
function $4d82739dd229d539$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $4d82739dd229d539$var$Vb(a);
        if (null === b) throw Error($4d82739dd229d539$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $4d82739dd229d539$var$Xb(e), a;
                if (f === d) return $4d82739dd229d539$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($4d82739dd229d539$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($4d82739dd229d539$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($4d82739dd229d539$var$p(190));
    }
    if (3 !== c.tag) throw Error($4d82739dd229d539$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $4d82739dd229d539$var$Zb(a) {
    a = $4d82739dd229d539$var$Yb(a);
    return null !== a ? $4d82739dd229d539$var$$b(a) : null;
}
function $4d82739dd229d539$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $4d82739dd229d539$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$ac = $33s19.unstable_scheduleCallback, $4d82739dd229d539$var$bc = $33s19.unstable_cancelCallback, $4d82739dd229d539$var$cc = $33s19.unstable_shouldYield, $4d82739dd229d539$var$dc = $33s19.unstable_requestPaint, $4d82739dd229d539$var$B = $33s19.unstable_now, $4d82739dd229d539$var$ec = $33s19.unstable_getCurrentPriorityLevel, $4d82739dd229d539$var$fc = $33s19.unstable_ImmediatePriority, $4d82739dd229d539$var$gc = $33s19.unstable_UserBlockingPriority, $4d82739dd229d539$var$hc = $33s19.unstable_NormalPriority, $4d82739dd229d539$var$ic = $33s19.unstable_LowPriority, $4d82739dd229d539$var$jc = $33s19.unstable_IdlePriority, $4d82739dd229d539$var$kc = null, $4d82739dd229d539$var$lc = null;
function $4d82739dd229d539$var$mc(a) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberRoot) try {
        $4d82739dd229d539$var$lc.onCommitFiberRoot($4d82739dd229d539$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $4d82739dd229d539$var$oc = Math.clz32 ? Math.clz32 : $4d82739dd229d539$var$nc, $4d82739dd229d539$var$pc = Math.log, $4d82739dd229d539$var$qc = Math.LN2;
function $4d82739dd229d539$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($4d82739dd229d539$var$pc(a) / $4d82739dd229d539$var$qc | 0) | 0;
}
var $4d82739dd229d539$var$rc = 64, $4d82739dd229d539$var$sc = 4194304;
function $4d82739dd229d539$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $4d82739dd229d539$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $4d82739dd229d539$var$tc(h) : (f &= g, 0 !== f && (d = $4d82739dd229d539$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $4d82739dd229d539$var$tc(g) : 0 !== f && (d = $4d82739dd229d539$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $4d82739dd229d539$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $4d82739dd229d539$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $4d82739dd229d539$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $4d82739dd229d539$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $4d82739dd229d539$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $4d82739dd229d539$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $4d82739dd229d539$var$yc() {
    var a = $4d82739dd229d539$var$rc;
    $4d82739dd229d539$var$rc <<= 1;
    0 === ($4d82739dd229d539$var$rc & 4194240) && ($4d82739dd229d539$var$rc = 64);
    return a;
}
function $4d82739dd229d539$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $4d82739dd229d539$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $4d82739dd229d539$var$oc(b);
    a[b] = c;
}
function $4d82739dd229d539$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $4d82739dd229d539$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $4d82739dd229d539$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $4d82739dd229d539$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $4d82739dd229d539$var$C = 0;
function $4d82739dd229d539$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $4d82739dd229d539$var$Ec, $4d82739dd229d539$var$Fc, $4d82739dd229d539$var$Gc, $4d82739dd229d539$var$Hc, $4d82739dd229d539$var$Ic, $4d82739dd229d539$var$Jc = !1, $4d82739dd229d539$var$Kc = [], $4d82739dd229d539$var$Lc = null, $4d82739dd229d539$var$Mc = null, $4d82739dd229d539$var$Nc = null, $4d82739dd229d539$var$Oc = new Map, $4d82739dd229d539$var$Pc = new Map, $4d82739dd229d539$var$Qc = [], $4d82739dd229d539$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $4d82739dd229d539$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $4d82739dd229d539$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $4d82739dd229d539$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $4d82739dd229d539$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $4d82739dd229d539$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $4d82739dd229d539$var$Pc.delete(b.pointerId);
    }
}
function $4d82739dd229d539$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $4d82739dd229d539$var$Cb(b), null !== b && $4d82739dd229d539$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $4d82739dd229d539$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $4d82739dd229d539$var$Lc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $4d82739dd229d539$var$Mc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $4d82739dd229d539$var$Nc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $4d82739dd229d539$var$Oc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $4d82739dd229d539$var$Pc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $4d82739dd229d539$var$Vc(a) {
    var b = $4d82739dd229d539$var$Wc(a.target);
    if (null !== b) {
        var c = $4d82739dd229d539$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $4d82739dd229d539$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $4d82739dd229d539$var$Ic(a.priority, function() {
                        $4d82739dd229d539$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $4d82739dd229d539$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $4d82739dd229d539$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $4d82739dd229d539$var$wb = d;
            c.target.dispatchEvent(d);
            $4d82739dd229d539$var$wb = null;
        } else return b = $4d82739dd229d539$var$Cb(c), null !== b && $4d82739dd229d539$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $4d82739dd229d539$var$Zc(a, b, c) {
    $4d82739dd229d539$var$Xc(a) && c.delete(b);
}
function $4d82739dd229d539$var$$c() {
    $4d82739dd229d539$var$Jc = !1;
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Lc) && ($4d82739dd229d539$var$Lc = null);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Mc) && ($4d82739dd229d539$var$Mc = null);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Nc) && ($4d82739dd229d539$var$Nc = null);
    $4d82739dd229d539$var$Oc.forEach($4d82739dd229d539$var$Zc);
    $4d82739dd229d539$var$Pc.forEach($4d82739dd229d539$var$Zc);
}
function $4d82739dd229d539$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $4d82739dd229d539$var$Jc || ($4d82739dd229d539$var$Jc = !0, $33s19.unstable_scheduleCallback($33s19.unstable_NormalPriority, $4d82739dd229d539$var$$c)));
}
function $4d82739dd229d539$var$bd(a) {
    function b(b) {
        return $4d82739dd229d539$var$ad(b, a);
    }
    if (0 < $4d82739dd229d539$var$Kc.length) {
        $4d82739dd229d539$var$ad($4d82739dd229d539$var$Kc[0], a);
        for(var c = 1; c < $4d82739dd229d539$var$Kc.length; c++){
            var d = $4d82739dd229d539$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Lc, a);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Mc, a);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Nc, a);
    $4d82739dd229d539$var$Oc.forEach(b);
    $4d82739dd229d539$var$Pc.forEach(b);
    for(c = 0; c < $4d82739dd229d539$var$Qc.length; c++)d = $4d82739dd229d539$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $4d82739dd229d539$var$Qc.length && (c = $4d82739dd229d539$var$Qc[0], null === c.blockedOn);)$4d82739dd229d539$var$Vc(c), null === c.blockedOn && $4d82739dd229d539$var$Qc.shift();
}
var $4d82739dd229d539$var$cd = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$dd = !0;
function $4d82739dd229d539$var$ed(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$gd(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 4, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$fd(a, b, c, d) {
    if ($4d82739dd229d539$var$dd) {
        var e = $4d82739dd229d539$var$Yc(a, b, c, d);
        if (null === e) $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c), $4d82739dd229d539$var$Sc(a, d);
        else if ($4d82739dd229d539$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($4d82739dd229d539$var$Sc(a, d), b & 4 && -1 < $4d82739dd229d539$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $4d82739dd229d539$var$Cb(e);
                null !== f && $4d82739dd229d539$var$Ec(f);
                f = $4d82739dd229d539$var$Yc(a, b, c, d);
                null === f && $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $4d82739dd229d539$var$hd(a, b, d, null, c);
    }
}
var $4d82739dd229d539$var$id = null;
function $4d82739dd229d539$var$Yc(a, b, c, d) {
    $4d82739dd229d539$var$id = null;
    a = $4d82739dd229d539$var$xb(d);
    a = $4d82739dd229d539$var$Wc(a);
    if (null !== a) {
        if (b = $4d82739dd229d539$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $4d82739dd229d539$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $4d82739dd229d539$var$id = a;
    return null;
}
function $4d82739dd229d539$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($4d82739dd229d539$var$ec()){
                case $4d82739dd229d539$var$fc:
                    return 1;
                case $4d82739dd229d539$var$gc:
                    return 4;
                case $4d82739dd229d539$var$hc:
                case $4d82739dd229d539$var$ic:
                    return 16;
                case $4d82739dd229d539$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ld = null, $4d82739dd229d539$var$md = null;
function $4d82739dd229d539$var$nd() {
    if ($4d82739dd229d539$var$md) return $4d82739dd229d539$var$md;
    var a, b = $4d82739dd229d539$var$ld, c = b.length, d, e = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $4d82739dd229d539$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $4d82739dd229d539$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $4d82739dd229d539$var$pd() {
    return !0;
}
function $4d82739dd229d539$var$qd() {
    return !1;
}
function $4d82739dd229d539$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $4d82739dd229d539$var$pd : $4d82739dd229d539$var$qd;
        this.isPropagationStopped = $4d82739dd229d539$var$qd;
        return this;
    }
    $4d82739dd229d539$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $4d82739dd229d539$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $4d82739dd229d539$var$pd);
        },
        persist: function() {},
        isPersistent: $4d82739dd229d539$var$pd
    });
    return b;
}
var $4d82739dd229d539$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $4d82739dd229d539$var$td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$sd), $4d82739dd229d539$var$ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    view: 0,
    detail: 0
}), $4d82739dd229d539$var$vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$ud), $4d82739dd229d539$var$wd, $4d82739dd229d539$var$xd, $4d82739dd229d539$var$yd, $4d82739dd229d539$var$Ad = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $4d82739dd229d539$var$yd && ($4d82739dd229d539$var$yd && "mousemove" === a.type ? ($4d82739dd229d539$var$wd = a.screenX - $4d82739dd229d539$var$yd.screenX, $4d82739dd229d539$var$xd = a.screenY - $4d82739dd229d539$var$yd.screenY) : $4d82739dd229d539$var$xd = $4d82739dd229d539$var$wd = 0, $4d82739dd229d539$var$yd = a);
        return $4d82739dd229d539$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $4d82739dd229d539$var$xd;
    }
}), $4d82739dd229d539$var$Bd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ad), $4d82739dd229d539$var$Cd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    dataTransfer: 0
}), $4d82739dd229d539$var$Dd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Cd), $4d82739dd229d539$var$Ed = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    relatedTarget: 0
}), $4d82739dd229d539$var$Fd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ed), $4d82739dd229d539$var$Gd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Hd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Gd), $4d82739dd229d539$var$Id = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $4d82739dd229d539$var$Jd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Id), $4d82739dd229d539$var$Kd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    data: 0
}), $4d82739dd229d539$var$Ld = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Kd), $4d82739dd229d539$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $4d82739dd229d539$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $4d82739dd229d539$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $4d82739dd229d539$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $4d82739dd229d539$var$Od[a]) ? !!b[a] : !1;
}
function $4d82739dd229d539$var$zd() {
    return $4d82739dd229d539$var$Pd;
}
var $4d82739dd229d539$var$Qd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $4d82739dd229d539$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $4d82739dd229d539$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $4d82739dd229d539$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $4d82739dd229d539$var$Rd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Qd), $4d82739dd229d539$var$Sd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $4d82739dd229d539$var$Td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Sd), $4d82739dd229d539$var$Ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $4d82739dd229d539$var$zd
}), $4d82739dd229d539$var$Vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ud), $4d82739dd229d539$var$Wd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Xd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Wd), $4d82739dd229d539$var$Yd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $4d82739dd229d539$var$Zd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Yd), $4d82739dd229d539$var$$d = [
    9,
    13,
    27,
    32
], $4d82739dd229d539$var$ae = $4d82739dd229d539$var$ia && "CompositionEvent" in window, $4d82739dd229d539$var$be = null;
$4d82739dd229d539$var$ia && "documentMode" in document && ($4d82739dd229d539$var$be = document.documentMode);
var $4d82739dd229d539$var$ce = $4d82739dd229d539$var$ia && "TextEvent" in window && !$4d82739dd229d539$var$be, $4d82739dd229d539$var$de = $4d82739dd229d539$var$ia && (!$4d82739dd229d539$var$ae || $4d82739dd229d539$var$be && 8 < $4d82739dd229d539$var$be && 11 >= $4d82739dd229d539$var$be), $4d82739dd229d539$var$ee = String.fromCharCode(32), $4d82739dd229d539$var$fe = !1;
function $4d82739dd229d539$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $4d82739dd229d539$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $4d82739dd229d539$var$ie = !1;
function $4d82739dd229d539$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $4d82739dd229d539$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $4d82739dd229d539$var$fe = !0;
            return $4d82739dd229d539$var$ee;
        case "textInput":
            return a = b.data, a === $4d82739dd229d539$var$ee && $4d82739dd229d539$var$fe ? null : a;
        default:
            return null;
    }
}
function $4d82739dd229d539$var$ke(a, b) {
    if ($4d82739dd229d539$var$ie) return "compositionend" === a || !$4d82739dd229d539$var$ae && $4d82739dd229d539$var$ge(a, b) ? (a = $4d82739dd229d539$var$nd(), $4d82739dd229d539$var$md = $4d82739dd229d539$var$ld = $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $4d82739dd229d539$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $4d82739dd229d539$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$4d82739dd229d539$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $4d82739dd229d539$var$ne(a, b, c, d) {
    $4d82739dd229d539$var$Eb(d);
    b = $4d82739dd229d539$var$oe(b, "onChange");
    0 < b.length && (c = new $4d82739dd229d539$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $4d82739dd229d539$var$pe = null, $4d82739dd229d539$var$qe = null;
function $4d82739dd229d539$var$re(a) {
    $4d82739dd229d539$var$se(a, 0);
}
function $4d82739dd229d539$var$te(a) {
    var b = $4d82739dd229d539$var$ue(a);
    if ($4d82739dd229d539$var$Wa(b)) return a;
}
function $4d82739dd229d539$var$ve(a, b) {
    if ("change" === a) return b;
}
var $4d82739dd229d539$var$we = !1;
if ($4d82739dd229d539$var$ia) {
    var $4d82739dd229d539$var$xe;
    if ($4d82739dd229d539$var$ia) {
        var $4d82739dd229d539$var$ye = "oninput" in document;
        if (!$4d82739dd229d539$var$ye) {
            var $4d82739dd229d539$var$ze = document.createElement("div");
            $4d82739dd229d539$var$ze.setAttribute("oninput", "return;");
            $4d82739dd229d539$var$ye = "function" === typeof $4d82739dd229d539$var$ze.oninput;
        }
        $4d82739dd229d539$var$xe = $4d82739dd229d539$var$ye;
    } else $4d82739dd229d539$var$xe = !1;
    $4d82739dd229d539$var$we = $4d82739dd229d539$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $4d82739dd229d539$var$Ae() {
    $4d82739dd229d539$var$pe && ($4d82739dd229d539$var$pe.detachEvent("onpropertychange", $4d82739dd229d539$var$Be), $4d82739dd229d539$var$qe = $4d82739dd229d539$var$pe = null);
}
function $4d82739dd229d539$var$Be(a) {
    if ("value" === a.propertyName && $4d82739dd229d539$var$te($4d82739dd229d539$var$qe)) {
        var b = [];
        $4d82739dd229d539$var$ne(b, $4d82739dd229d539$var$qe, a, $4d82739dd229d539$var$xb(a));
        $4d82739dd229d539$var$Jb($4d82739dd229d539$var$re, b);
    }
}
function $4d82739dd229d539$var$Ce(a, b, c) {
    "focusin" === a ? ($4d82739dd229d539$var$Ae(), $4d82739dd229d539$var$pe = b, $4d82739dd229d539$var$qe = c, $4d82739dd229d539$var$pe.attachEvent("onpropertychange", $4d82739dd229d539$var$Be)) : "focusout" === a && $4d82739dd229d539$var$Ae();
}
function $4d82739dd229d539$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $4d82739dd229d539$var$te($4d82739dd229d539$var$qe);
}
function $4d82739dd229d539$var$Ee(a, b) {
    if ("click" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $4d82739dd229d539$var$He = "function" === typeof Object.is ? Object.is : $4d82739dd229d539$var$Ge;
function $4d82739dd229d539$var$Ie(a, b) {
    if ($4d82739dd229d539$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$4d82739dd229d539$var$ja.call(b, e) || !$4d82739dd229d539$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $4d82739dd229d539$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $4d82739dd229d539$var$Ke(a, b) {
    var c = $4d82739dd229d539$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $4d82739dd229d539$var$Je(c);
    }
}
function $4d82739dd229d539$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $4d82739dd229d539$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $4d82739dd229d539$var$Me() {
    for(var a = window, b = $4d82739dd229d539$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $4d82739dd229d539$var$Xa(a.document);
    }
    return b;
}
function $4d82739dd229d539$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $4d82739dd229d539$var$Oe(a) {
    var b = $4d82739dd229d539$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $4d82739dd229d539$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $4d82739dd229d539$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $4d82739dd229d539$var$Ke(c, f);
                var g = $4d82739dd229d539$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $4d82739dd229d539$var$Pe = $4d82739dd229d539$var$ia && "documentMode" in document && 11 >= document.documentMode, $4d82739dd229d539$var$Qe = null, $4d82739dd229d539$var$Re = null, $4d82739dd229d539$var$Se = null, $4d82739dd229d539$var$Te = !1;
function $4d82739dd229d539$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $4d82739dd229d539$var$Te || null == $4d82739dd229d539$var$Qe || $4d82739dd229d539$var$Qe !== $4d82739dd229d539$var$Xa(d) || (d = $4d82739dd229d539$var$Qe, "selectionStart" in d && $4d82739dd229d539$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $4d82739dd229d539$var$Se && $4d82739dd229d539$var$Ie($4d82739dd229d539$var$Se, d) || ($4d82739dd229d539$var$Se = d, d = $4d82739dd229d539$var$oe($4d82739dd229d539$var$Re, "onSelect"), 0 < d.length && (b = new $4d82739dd229d539$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $4d82739dd229d539$var$Qe)));
}
function $4d82739dd229d539$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $4d82739dd229d539$var$We = {
    animationend: $4d82739dd229d539$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $4d82739dd229d539$var$Ve("Animation", "AnimationIteration"),
    animationstart: $4d82739dd229d539$var$Ve("Animation", "AnimationStart"),
    transitionend: $4d82739dd229d539$var$Ve("Transition", "TransitionEnd")
}, $4d82739dd229d539$var$Xe = {}, $4d82739dd229d539$var$Ye = {};
$4d82739dd229d539$var$ia && ($4d82739dd229d539$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $4d82739dd229d539$var$We.animationend.animation, delete $4d82739dd229d539$var$We.animationiteration.animation, delete $4d82739dd229d539$var$We.animationstart.animation), "TransitionEvent" in window || delete $4d82739dd229d539$var$We.transitionend.transition);
function $4d82739dd229d539$var$Ze(a) {
    if ($4d82739dd229d539$var$Xe[a]) return $4d82739dd229d539$var$Xe[a];
    if (!$4d82739dd229d539$var$We[a]) return a;
    var b = $4d82739dd229d539$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $4d82739dd229d539$var$Ye) return $4d82739dd229d539$var$Xe[a] = b[c];
    return a;
}
var $4d82739dd229d539$var$$e = $4d82739dd229d539$var$Ze("animationend"), $4d82739dd229d539$var$af = $4d82739dd229d539$var$Ze("animationiteration"), $4d82739dd229d539$var$bf = $4d82739dd229d539$var$Ze("animationstart"), $4d82739dd229d539$var$cf = $4d82739dd229d539$var$Ze("transitionend"), $4d82739dd229d539$var$df = new Map, $4d82739dd229d539$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $4d82739dd229d539$var$ff(a, b) {
    $4d82739dd229d539$var$df.set(a, b);
    $4d82739dd229d539$var$fa(b, [
        a
    ]);
}
for(var $4d82739dd229d539$var$gf = 0; $4d82739dd229d539$var$gf < $4d82739dd229d539$var$ef.length; $4d82739dd229d539$var$gf++){
    var $4d82739dd229d539$var$hf = $4d82739dd229d539$var$ef[$4d82739dd229d539$var$gf], $4d82739dd229d539$var$jf = $4d82739dd229d539$var$hf.toLowerCase(), $4d82739dd229d539$var$kf = $4d82739dd229d539$var$hf[0].toUpperCase() + $4d82739dd229d539$var$hf.slice(1);
    $4d82739dd229d539$var$ff($4d82739dd229d539$var$jf, "on" + $4d82739dd229d539$var$kf);
}
$4d82739dd229d539$var$ff($4d82739dd229d539$var$$e, "onAnimationEnd");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$af, "onAnimationIteration");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$bf, "onAnimationStart");
$4d82739dd229d539$var$ff("dblclick", "onDoubleClick");
$4d82739dd229d539$var$ff("focusin", "onFocus");
$4d82739dd229d539$var$ff("focusout", "onBlur");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$cf, "onTransitionEnd");
$4d82739dd229d539$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$4d82739dd229d539$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $4d82739dd229d539$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $4d82739dd229d539$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($4d82739dd229d539$var$lf));
function $4d82739dd229d539$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $4d82739dd229d539$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $4d82739dd229d539$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($4d82739dd229d539$var$Qb) throw a = $4d82739dd229d539$var$Rb, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, a;
}
function $4d82739dd229d539$var$D(a, b) {
    var c = b[$4d82739dd229d539$var$of];
    void 0 === c && (c = b[$4d82739dd229d539$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($4d82739dd229d539$var$pf(b, a, 2, !1), c.add(d));
}
function $4d82739dd229d539$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $4d82739dd229d539$var$pf(c, a, d, b);
}
var $4d82739dd229d539$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $4d82739dd229d539$var$sf(a) {
    if (!a[$4d82739dd229d539$var$rf]) {
        a[$4d82739dd229d539$var$rf] = !0;
        $4d82739dd229d539$var$da.forEach(function(b) {
            "selectionchange" !== b && ($4d82739dd229d539$var$mf.has(b) || $4d82739dd229d539$var$qf(b, !1, a), $4d82739dd229d539$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$4d82739dd229d539$var$rf] || (b[$4d82739dd229d539$var$rf] = !0, $4d82739dd229d539$var$qf("selectionchange", !1, b));
    }
}
function $4d82739dd229d539$var$pf(a, b, c, d) {
    switch($4d82739dd229d539$var$jd(b)){
        case 1:
            var e = $4d82739dd229d539$var$ed;
            break;
        case 4:
            e = $4d82739dd229d539$var$gd;
            break;
        default:
            e = $4d82739dd229d539$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$4d82739dd229d539$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $4d82739dd229d539$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $4d82739dd229d539$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $4d82739dd229d539$var$Jb(function() {
        var d = f, e = $4d82739dd229d539$var$xb(c), g = [];
        a: {
            var h = $4d82739dd229d539$var$df.get(a);
            if (void 0 !== h) {
                var k = $4d82739dd229d539$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $4d82739dd229d539$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $4d82739dd229d539$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $4d82739dd229d539$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $4d82739dd229d539$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $4d82739dd229d539$var$Vd;
                        break;
                    case $4d82739dd229d539$var$$e:
                    case $4d82739dd229d539$var$af:
                    case $4d82739dd229d539$var$bf:
                        k = $4d82739dd229d539$var$Hd;
                        break;
                    case $4d82739dd229d539$var$cf:
                        k = $4d82739dd229d539$var$Xd;
                        break;
                    case "scroll":
                        k = $4d82739dd229d539$var$vd;
                        break;
                    case "wheel":
                        k = $4d82739dd229d539$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $4d82739dd229d539$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $4d82739dd229d539$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $4d82739dd229d539$var$Kb(w, x), null != F && t.push($4d82739dd229d539$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $4d82739dd229d539$var$wb && (n = c.relatedTarget || c.fromElement) && ($4d82739dd229d539$var$Wc(n) || n[$4d82739dd229d539$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $4d82739dd229d539$var$Wc(n) : null, null !== n && (J = $4d82739dd229d539$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $4d82739dd229d539$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $4d82739dd229d539$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $4d82739dd229d539$var$ue(k);
                        u = null == n ? h : $4d82739dd229d539$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $4d82739dd229d539$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $4d82739dd229d539$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $4d82739dd229d539$var$vf(F))u++;
                            for(; 0 < w - u;)t = $4d82739dd229d539$var$vf(t), w--;
                            for(; 0 < u - w;)x = $4d82739dd229d539$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $4d82739dd229d539$var$vf(t);
                                x = $4d82739dd229d539$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $4d82739dd229d539$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $4d82739dd229d539$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $4d82739dd229d539$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $4d82739dd229d539$var$ve;
                else if ($4d82739dd229d539$var$me(h)) {
                    if ($4d82739dd229d539$var$we) na = $4d82739dd229d539$var$Fe;
                    else {
                        na = $4d82739dd229d539$var$De;
                        var xa = $4d82739dd229d539$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $4d82739dd229d539$var$Ee);
                if (na && (na = na(a, d))) {
                    $4d82739dd229d539$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $4d82739dd229d539$var$cb(h, "number", h.value);
            }
            xa = d ? $4d82739dd229d539$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($4d82739dd229d539$var$me(xa) || "true" === xa.contentEditable) $4d82739dd229d539$var$Qe = xa, $4d82739dd229d539$var$Re = d, $4d82739dd229d539$var$Se = null;
                    break;
                case "focusout":
                    $4d82739dd229d539$var$Se = $4d82739dd229d539$var$Re = $4d82739dd229d539$var$Qe = null;
                    break;
                case "mousedown":
                    $4d82739dd229d539$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $4d82739dd229d539$var$Te = !1;
                    $4d82739dd229d539$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($4d82739dd229d539$var$Pe) break;
                case "keydown":
                case "keyup":
                    $4d82739dd229d539$var$Ue(g, c, e);
            }
            var $a;
            if ($4d82739dd229d539$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $4d82739dd229d539$var$ie ? $4d82739dd229d539$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($4d82739dd229d539$var$de && "ko" !== c.locale && ($4d82739dd229d539$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $4d82739dd229d539$var$ie && ($a = $4d82739dd229d539$var$nd()) : ($4d82739dd229d539$var$kd = e, $4d82739dd229d539$var$ld = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, $4d82739dd229d539$var$ie = !0)), xa = $4d82739dd229d539$var$oe(d, ba), 0 < xa.length && (ba = new $4d82739dd229d539$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $4d82739dd229d539$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $4d82739dd229d539$var$ce ? $4d82739dd229d539$var$je(a, c) : $4d82739dd229d539$var$ke(a, c)) d = $4d82739dd229d539$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $4d82739dd229d539$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $4d82739dd229d539$var$se(g, b);
    });
}
function $4d82739dd229d539$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $4d82739dd229d539$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $4d82739dd229d539$var$Kb(a, c), null != f && d.unshift($4d82739dd229d539$var$tf(a, f, e)), f = $4d82739dd229d539$var$Kb(a, b), null != f && d.push($4d82739dd229d539$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $4d82739dd229d539$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $4d82739dd229d539$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.unshift($4d82739dd229d539$var$tf(c, k, h))) : e || (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.push($4d82739dd229d539$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $4d82739dd229d539$var$xf = /\r\n?/g, $4d82739dd229d539$var$yf = /\u0000|\uFFFD/g;
function $4d82739dd229d539$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($4d82739dd229d539$var$xf, "\n").replace($4d82739dd229d539$var$yf, "");
}
function $4d82739dd229d539$var$Af(a, b, c) {
    b = $4d82739dd229d539$var$zf(b);
    if ($4d82739dd229d539$var$zf(a) !== b && c) throw Error($4d82739dd229d539$var$p(425));
}
function $4d82739dd229d539$var$Bf() {}
var $4d82739dd229d539$var$Cf = null, $4d82739dd229d539$var$Df = null;
function $4d82739dd229d539$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $4d82739dd229d539$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $4d82739dd229d539$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $4d82739dd229d539$var$Hf = "function" === typeof Promise ? Promise : void 0, $4d82739dd229d539$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $4d82739dd229d539$var$Hf ? function(a) {
    return $4d82739dd229d539$var$Hf.resolve(null).then(a).catch($4d82739dd229d539$var$If);
} : $4d82739dd229d539$var$Ff;
function $4d82739dd229d539$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $4d82739dd229d539$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $4d82739dd229d539$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $4d82739dd229d539$var$bd(b);
}
function $4d82739dd229d539$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $4d82739dd229d539$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $4d82739dd229d539$var$Nf = Math.random().toString(36).slice(2), $4d82739dd229d539$var$Of = "__reactFiber$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Pf = "__reactProps$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$uf = "__reactContainer$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$of = "__reactEvents$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Qf = "__reactListeners$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Rf = "__reactHandles$" + $4d82739dd229d539$var$Nf;
function $4d82739dd229d539$var$Wc(a) {
    var b = a[$4d82739dd229d539$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$4d82739dd229d539$var$uf] || c[$4d82739dd229d539$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $4d82739dd229d539$var$Mf(a); null !== a;){
                if (c = a[$4d82739dd229d539$var$Of]) return c;
                a = $4d82739dd229d539$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $4d82739dd229d539$var$Cb(a) {
    a = a[$4d82739dd229d539$var$Of] || a[$4d82739dd229d539$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $4d82739dd229d539$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($4d82739dd229d539$var$p(33));
}
function $4d82739dd229d539$var$Db(a) {
    return a[$4d82739dd229d539$var$Pf] || null;
}
var $4d82739dd229d539$var$Sf = [], $4d82739dd229d539$var$Tf = -1;
function $4d82739dd229d539$var$Uf(a) {
    return {
        current: a
    };
}
function $4d82739dd229d539$var$E(a) {
    0 > $4d82739dd229d539$var$Tf || (a.current = $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf], $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = null, $4d82739dd229d539$var$Tf--);
}
function $4d82739dd229d539$var$G(a, b) {
    $4d82739dd229d539$var$Tf++;
    $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = a.current;
    a.current = b;
}
var $4d82739dd229d539$var$Vf = {}, $4d82739dd229d539$var$H = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Vf), $4d82739dd229d539$var$Wf = $4d82739dd229d539$var$Uf(!1), $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$Vf;
function $4d82739dd229d539$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $4d82739dd229d539$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $4d82739dd229d539$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $4d82739dd229d539$var$$f() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
}
function $4d82739dd229d539$var$ag(a, b, c) {
    if ($4d82739dd229d539$var$H.current !== $4d82739dd229d539$var$Vf) throw Error($4d82739dd229d539$var$p(168));
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
function $4d82739dd229d539$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($4d82739dd229d539$var$p(108, $4d82739dd229d539$var$Ra(a) || "Unknown", e));
    return $4d82739dd229d539$var$A({}, c, d);
}
function $4d82739dd229d539$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $4d82739dd229d539$var$Vf;
    $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$H.current;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, $4d82739dd229d539$var$Wf.current);
    return !0;
}
function $4d82739dd229d539$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($4d82739dd229d539$var$p(169));
    c ? (a = $4d82739dd229d539$var$bg(a, b, $4d82739dd229d539$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a)) : $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
var $4d82739dd229d539$var$eg = null, $4d82739dd229d539$var$fg = !1, $4d82739dd229d539$var$gg = !1;
function $4d82739dd229d539$var$hg(a) {
    null === $4d82739dd229d539$var$eg ? $4d82739dd229d539$var$eg = [
        a
    ] : $4d82739dd229d539$var$eg.push(a);
}
function $4d82739dd229d539$var$ig(a) {
    $4d82739dd229d539$var$fg = !0;
    $4d82739dd229d539$var$hg(a);
}
function $4d82739dd229d539$var$jg() {
    if (!$4d82739dd229d539$var$gg && null !== $4d82739dd229d539$var$eg) {
        $4d82739dd229d539$var$gg = !0;
        var a = 0, b = $4d82739dd229d539$var$C;
        try {
            var c = $4d82739dd229d539$var$eg;
            for($4d82739dd229d539$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $4d82739dd229d539$var$eg = null;
            $4d82739dd229d539$var$fg = !1;
        } catch (e) {
            throw null !== $4d82739dd229d539$var$eg && ($4d82739dd229d539$var$eg = $4d82739dd229d539$var$eg.slice(a + 1)), $4d82739dd229d539$var$ac($4d82739dd229d539$var$fc, $4d82739dd229d539$var$jg), e;
        } finally{
            $4d82739dd229d539$var$C = b, $4d82739dd229d539$var$gg = !1;
        }
    }
    return null;
}
var $4d82739dd229d539$var$kg = [], $4d82739dd229d539$var$lg = 0, $4d82739dd229d539$var$mg = null, $4d82739dd229d539$var$ng = 0, $4d82739dd229d539$var$og = [], $4d82739dd229d539$var$pg = 0, $4d82739dd229d539$var$qg = null, $4d82739dd229d539$var$rg = 1, $4d82739dd229d539$var$sg = "";
function $4d82739dd229d539$var$tg(a, b) {
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$ng;
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$mg;
    $4d82739dd229d539$var$mg = a;
    $4d82739dd229d539$var$ng = b;
}
function $4d82739dd229d539$var$ug(a, b, c) {
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg;
    $4d82739dd229d539$var$qg = a;
    var d = $4d82739dd229d539$var$rg;
    a = $4d82739dd229d539$var$sg;
    var e = 32 - $4d82739dd229d539$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $4d82739dd229d539$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $4d82739dd229d539$var$rg = 1 << 32 - $4d82739dd229d539$var$oc(b) + e | c << e | d;
        $4d82739dd229d539$var$sg = f + a;
    } else $4d82739dd229d539$var$rg = 1 << f | c << e | d, $4d82739dd229d539$var$sg = a;
}
function $4d82739dd229d539$var$vg(a) {
    null !== a.return && ($4d82739dd229d539$var$tg(a, 1), $4d82739dd229d539$var$ug(a, 1, 0));
}
function $4d82739dd229d539$var$wg(a) {
    for(; a === $4d82739dd229d539$var$mg;)$4d82739dd229d539$var$mg = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null, $4d82739dd229d539$var$ng = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null;
    for(; a === $4d82739dd229d539$var$qg;)$4d82739dd229d539$var$qg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$sg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$rg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null;
}
var $4d82739dd229d539$var$xg = null, $4d82739dd229d539$var$yg = null, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$zg = null;
function $4d82739dd229d539$var$Ag(a, b) {
    var c = $4d82739dd229d539$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $4d82739dd229d539$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $4d82739dd229d539$var$qg ? {
                id: $4d82739dd229d539$var$rg,
                overflow: $4d82739dd229d539$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $4d82739dd229d539$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $4d82739dd229d539$var$Eg(a) {
    if ($4d82739dd229d539$var$I) {
        var b = $4d82739dd229d539$var$yg;
        if (b) {
            var c = b;
            if (!$4d82739dd229d539$var$Cg(a, b)) {
                if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
                b = $4d82739dd229d539$var$Lf(c.nextSibling);
                var d = $4d82739dd229d539$var$xg;
                b && $4d82739dd229d539$var$Cg(a, b) ? $4d82739dd229d539$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$xg = a);
            }
        } else {
            if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $4d82739dd229d539$var$I = !1;
            $4d82739dd229d539$var$xg = a;
        }
    }
}
function $4d82739dd229d539$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $4d82739dd229d539$var$xg = a;
}
function $4d82739dd229d539$var$Gg(a) {
    if (a !== $4d82739dd229d539$var$xg) return !1;
    if (!$4d82739dd229d539$var$I) return $4d82739dd229d539$var$Fg(a), $4d82739dd229d539$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$4d82739dd229d539$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $4d82739dd229d539$var$yg)) {
        if ($4d82739dd229d539$var$Dg(a)) throw $4d82739dd229d539$var$Hg(), Error($4d82739dd229d539$var$p(418));
        for(; b;)$4d82739dd229d539$var$Ag(a, b), b = $4d82739dd229d539$var$Lf(b.nextSibling);
    }
    $4d82739dd229d539$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($4d82739dd229d539$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $4d82739dd229d539$var$yg = null;
        }
    } else $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg ? $4d82739dd229d539$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $4d82739dd229d539$var$Hg() {
    for(var a = $4d82739dd229d539$var$yg; a;)a = $4d82739dd229d539$var$Lf(a.nextSibling);
}
function $4d82739dd229d539$var$Ig() {
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg = null;
    $4d82739dd229d539$var$I = !1;
}
function $4d82739dd229d539$var$Jg(a) {
    null === $4d82739dd229d539$var$zg ? $4d82739dd229d539$var$zg = [
        a
    ] : $4d82739dd229d539$var$zg.push(a);
}
var $4d82739dd229d539$var$Kg = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig;
function $4d82739dd229d539$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($4d82739dd229d539$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($4d82739dd229d539$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($4d82739dd229d539$var$p(284));
        if (!c._owner) throw Error($4d82739dd229d539$var$p(290, a));
    }
    return a;
}
function $4d82739dd229d539$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($4d82739dd229d539$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $4d82739dd229d539$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $4d82739dd229d539$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $4d82739dd229d539$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $4d82739dd229d539$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $4d82739dd229d539$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $4d82739dd229d539$var$Lg(a, b, c), d.return = a, d;
        d = $4d82739dd229d539$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $4d82739dd229d539$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $4d82739dd229d539$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $4d82739dd229d539$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $4d82739dd229d539$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c = $4d82739dd229d539$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $4d82739dd229d539$var$Lg(a, null, b), c.return = a, c;
                case $4d82739dd229d539$var$wa:
                    return b = $4d82739dd229d539$var$Sg(b, a.mode, c), b.return = a, b;
                case $4d82739dd229d539$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($4d82739dd229d539$var$eb(b) || $4d82739dd229d539$var$Ka(b)) return b = $4d82739dd229d539$var$Tg(b, a.mode, c, null), b.return = a, b;
            $4d82739dd229d539$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $4d82739dd229d539$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $4d82739dd229d539$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($4d82739dd229d539$var$eb(c) || $4d82739dd229d539$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $4d82739dd229d539$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $4d82739dd229d539$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $4d82739dd229d539$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $4d82739dd229d539$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($4d82739dd229d539$var$eb(d) || $4d82739dd229d539$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $4d82739dd229d539$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $4d82739dd229d539$var$Ka(h);
        if ("function" !== typeof l) throw Error($4d82739dd229d539$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($4d82739dd229d539$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $4d82739dd229d539$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $4d82739dd229d539$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $4d82739dd229d539$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $4d82739dd229d539$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $4d82739dd229d539$var$ya ? (d = $4d82739dd229d539$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $4d82739dd229d539$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $4d82739dd229d539$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $4d82739dd229d539$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $4d82739dd229d539$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $4d82739dd229d539$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($4d82739dd229d539$var$eb(f)) return n(a, d, f, h);
            if ($4d82739dd229d539$var$Ka(f)) return t(a, d, f, h);
            $4d82739dd229d539$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $4d82739dd229d539$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $4d82739dd229d539$var$Ug = $4d82739dd229d539$var$Og(!0), $4d82739dd229d539$var$Vg = $4d82739dd229d539$var$Og(!1), $4d82739dd229d539$var$Wg = $4d82739dd229d539$var$Uf(null), $4d82739dd229d539$var$Xg = null, $4d82739dd229d539$var$Yg = null, $4d82739dd229d539$var$Zg = null;
function $4d82739dd229d539$var$$g() {
    $4d82739dd229d539$var$Zg = $4d82739dd229d539$var$Yg = $4d82739dd229d539$var$Xg = null;
}
function $4d82739dd229d539$var$ah(a) {
    var b = $4d82739dd229d539$var$Wg.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Wg);
    a._currentValue = b;
}
function $4d82739dd229d539$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $4d82739dd229d539$var$ch(a, b) {
    $4d82739dd229d539$var$Xg = a;
    $4d82739dd229d539$var$Zg = $4d82739dd229d539$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($4d82739dd229d539$var$dh = !0), a.firstContext = null);
}
function $4d82739dd229d539$var$eh(a) {
    var b = a._currentValue;
    if ($4d82739dd229d539$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $4d82739dd229d539$var$Yg) {
            if (null === $4d82739dd229d539$var$Xg) throw Error($4d82739dd229d539$var$p(308));
            $4d82739dd229d539$var$Yg = a;
            $4d82739dd229d539$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $4d82739dd229d539$var$Yg = $4d82739dd229d539$var$Yg.next = a;
    }
    return b;
}
var $4d82739dd229d539$var$fh = null;
function $4d82739dd229d539$var$gh(a) {
    null === $4d82739dd229d539$var$fh ? $4d82739dd229d539$var$fh = [
        a
    ] : $4d82739dd229d539$var$fh.push(a);
}
function $4d82739dd229d539$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $4d82739dd229d539$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $4d82739dd229d539$var$ih(a, d);
}
function $4d82739dd229d539$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $4d82739dd229d539$var$jh = !1;
function $4d82739dd229d539$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $4d82739dd229d539$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $4d82739dd229d539$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $4d82739dd229d539$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($4d82739dd229d539$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $4d82739dd229d539$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $4d82739dd229d539$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $4d82739dd229d539$var$ih(a, c);
}
function $4d82739dd229d539$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
function $4d82739dd229d539$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $4d82739dd229d539$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $4d82739dd229d539$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $4d82739dd229d539$var$A({}, q, r);
                            break a;
                        case 2:
                            $4d82739dd229d539$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $4d82739dd229d539$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $4d82739dd229d539$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($4d82739dd229d539$var$p(191, e));
            e.call(d);
        }
    }
}
var $4d82739dd229d539$var$th = {}, $4d82739dd229d539$var$uh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th), $4d82739dd229d539$var$vh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th), $4d82739dd229d539$var$wh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th);
function $4d82739dd229d539$var$xh(a) {
    if (a === $4d82739dd229d539$var$th) throw Error($4d82739dd229d539$var$p(174));
    return a;
}
function $4d82739dd229d539$var$yh(a, b) {
    $4d82739dd229d539$var$G($4d82739dd229d539$var$wh, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$vh, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, $4d82739dd229d539$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $4d82739dd229d539$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $4d82739dd229d539$var$lb(b, a);
    }
    $4d82739dd229d539$var$E($4d82739dd229d539$var$uh);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, b);
}
function $4d82739dd229d539$var$zh() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$uh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$vh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$wh);
}
function $4d82739dd229d539$var$Ah(a) {
    $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
    var b = $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
    var c = $4d82739dd229d539$var$lb(b, a.type);
    b !== c && ($4d82739dd229d539$var$G($4d82739dd229d539$var$vh, a), $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, c));
}
function $4d82739dd229d539$var$Bh(a) {
    $4d82739dd229d539$var$vh.current === a && ($4d82739dd229d539$var$E($4d82739dd229d539$var$uh), $4d82739dd229d539$var$E($4d82739dd229d539$var$vh));
}
var $4d82739dd229d539$var$L = $4d82739dd229d539$var$Uf(0);
function $4d82739dd229d539$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$Dh = [];
function $4d82739dd229d539$var$Eh() {
    for(var a = 0; a < $4d82739dd229d539$var$Dh.length; a++)$4d82739dd229d539$var$Dh[a]._workInProgressVersionPrimary = null;
    $4d82739dd229d539$var$Dh.length = 0;
}
var $4d82739dd229d539$var$Fh = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$Gh = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$Hh = 0, $4d82739dd229d539$var$M = null, $4d82739dd229d539$var$N = null, $4d82739dd229d539$var$O = null, $4d82739dd229d539$var$Ih = !1, $4d82739dd229d539$var$Jh = !1, $4d82739dd229d539$var$Kh = 0, $4d82739dd229d539$var$Lh = 0;
function $4d82739dd229d539$var$P() {
    throw Error($4d82739dd229d539$var$p(321));
}
function $4d82739dd229d539$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$4d82739dd229d539$var$He(a[c], b[c])) return !1;
    return !0;
}
function $4d82739dd229d539$var$Nh(a, b, c, d, e, f) {
    $4d82739dd229d539$var$Hh = f;
    $4d82739dd229d539$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $4d82739dd229d539$var$Fh.current = null === a || null === a.memoizedState ? $4d82739dd229d539$var$Oh : $4d82739dd229d539$var$Ph;
    a = c(d, e);
    if ($4d82739dd229d539$var$Jh) {
        f = 0;
        do {
            $4d82739dd229d539$var$Jh = !1;
            $4d82739dd229d539$var$Kh = 0;
            if (25 <= f) throw Error($4d82739dd229d539$var$p(301));
            f += 1;
            $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = null;
            b.updateQueue = null;
            $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Qh;
            a = c(d, e);
        }while ($4d82739dd229d539$var$Jh);
    }
    $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Rh;
    b = null !== $4d82739dd229d539$var$N && null !== $4d82739dd229d539$var$N.next;
    $4d82739dd229d539$var$Hh = 0;
    $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = $4d82739dd229d539$var$M = null;
    $4d82739dd229d539$var$Ih = !1;
    if (b) throw Error($4d82739dd229d539$var$p(300));
    return a;
}
function $4d82739dd229d539$var$Sh() {
    var a = 0 !== $4d82739dd229d539$var$Kh;
    $4d82739dd229d539$var$Kh = 0;
    return a;
}
function $4d82739dd229d539$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState = $4d82739dd229d539$var$O = a : $4d82739dd229d539$var$O = $4d82739dd229d539$var$O.next = a;
    return $4d82739dd229d539$var$O;
}
function $4d82739dd229d539$var$Uh() {
    if (null === $4d82739dd229d539$var$N) {
        var a = $4d82739dd229d539$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $4d82739dd229d539$var$N.next;
    var b = null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState : $4d82739dd229d539$var$O.next;
    if (null !== b) $4d82739dd229d539$var$O = b, $4d82739dd229d539$var$N = a;
    else {
        if (null === a) throw Error($4d82739dd229d539$var$p(310));
        $4d82739dd229d539$var$N = a;
        a = {
            memoizedState: $4d82739dd229d539$var$N.memoizedState,
            baseState: $4d82739dd229d539$var$N.baseState,
            baseQueue: $4d82739dd229d539$var$N.baseQueue,
            queue: $4d82739dd229d539$var$N.queue,
            next: null
        };
        null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState = $4d82739dd229d539$var$O = a : $4d82739dd229d539$var$O = $4d82739dd229d539$var$O.next = a;
    }
    return $4d82739dd229d539$var$O;
}
function $4d82739dd229d539$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $4d82739dd229d539$var$Wh(a) {
    var b = $4d82739dd229d539$var$Uh(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = $4d82739dd229d539$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($4d82739dd229d539$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $4d82739dd229d539$var$M.lanes |= m;
                $4d82739dd229d539$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $4d82739dd229d539$var$He(d, b.memoizedState) || ($4d82739dd229d539$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $4d82739dd229d539$var$M.lanes |= f, $4d82739dd229d539$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $4d82739dd229d539$var$Xh(a) {
    var b = $4d82739dd229d539$var$Uh(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $4d82739dd229d539$var$He(f, b.memoizedState) || ($4d82739dd229d539$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $4d82739dd229d539$var$Yh() {}
function $4d82739dd229d539$var$Zh(a, b) {
    var c = $4d82739dd229d539$var$M, d = $4d82739dd229d539$var$Uh(), e = b(), f = !$4d82739dd229d539$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $4d82739dd229d539$var$dh = !0);
    d = d.queue;
    $4d82739dd229d539$var$$h($4d82739dd229d539$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $4d82739dd229d539$var$O && $4d82739dd229d539$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $4d82739dd229d539$var$bi(9, $4d82739dd229d539$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $4d82739dd229d539$var$Q) throw Error($4d82739dd229d539$var$p(349));
        0 !== ($4d82739dd229d539$var$Hh & 30) || $4d82739dd229d539$var$di(c, b, e);
    }
    return e;
}
function $4d82739dd229d539$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $4d82739dd229d539$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $4d82739dd229d539$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $4d82739dd229d539$var$ei(b) && $4d82739dd229d539$var$fi(a);
}
function $4d82739dd229d539$var$ai(a, b, c) {
    return c(function() {
        $4d82739dd229d539$var$ei(b) && $4d82739dd229d539$var$fi(a);
    });
}
function $4d82739dd229d539$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$4d82739dd229d539$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $4d82739dd229d539$var$fi(a) {
    var b = $4d82739dd229d539$var$ih(a, 1);
    null !== b && $4d82739dd229d539$var$gi(b, a, 1, -1);
}
function $4d82739dd229d539$var$hi(a) {
    var b = $4d82739dd229d539$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $4d82739dd229d539$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $4d82739dd229d539$var$ii.bind(null, $4d82739dd229d539$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $4d82739dd229d539$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $4d82739dd229d539$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $4d82739dd229d539$var$ji() {
    return $4d82739dd229d539$var$Uh().memoizedState;
}
function $4d82739dd229d539$var$ki(a, b, c, d) {
    var e = $4d82739dd229d539$var$Th();
    $4d82739dd229d539$var$M.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $4d82739dd229d539$var$li(a, b, c, d) {
    var e = $4d82739dd229d539$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $4d82739dd229d539$var$N) {
        var g = $4d82739dd229d539$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $4d82739dd229d539$var$Mh(d, g.deps)) {
            e.memoizedState = $4d82739dd229d539$var$bi(b, c, f, d);
            return;
        }
    }
    $4d82739dd229d539$var$M.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$bi(1 | b, c, f, d);
}
function $4d82739dd229d539$var$mi(a, b) {
    return $4d82739dd229d539$var$ki(8390656, 8, a, b);
}
function $4d82739dd229d539$var$$h(a, b) {
    return $4d82739dd229d539$var$li(2048, 8, a, b);
}
function $4d82739dd229d539$var$ni(a, b) {
    return $4d82739dd229d539$var$li(4, 2, a, b);
}
function $4d82739dd229d539$var$oi(a, b) {
    return $4d82739dd229d539$var$li(4, 4, a, b);
}
function $4d82739dd229d539$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $4d82739dd229d539$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $4d82739dd229d539$var$li(4, 4, $4d82739dd229d539$var$pi.bind(null, b, a), c);
}
function $4d82739dd229d539$var$ri() {}
function $4d82739dd229d539$var$si(a, b) {
    var c = $4d82739dd229d539$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$ti(a, b) {
    var c = $4d82739dd229d539$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$ui(a, b, c) {
    if (0 === ($4d82739dd229d539$var$Hh & 21)) return a.baseState && (a.baseState = !1, $4d82739dd229d539$var$dh = !0), a.memoizedState = c;
    $4d82739dd229d539$var$He(c, b) || (c = $4d82739dd229d539$var$yc(), $4d82739dd229d539$var$M.lanes |= c, $4d82739dd229d539$var$rh |= c, a.baseState = !0);
    return b;
}
function $4d82739dd229d539$var$vi(a, b) {
    var c = $4d82739dd229d539$var$C;
    $4d82739dd229d539$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $4d82739dd229d539$var$Gh.transition;
    $4d82739dd229d539$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$Gh.transition = d;
    }
}
function $4d82739dd229d539$var$wi() {
    return $4d82739dd229d539$var$Uh().memoizedState;
}
function $4d82739dd229d539$var$xi(a, b, c) {
    var d = $4d82739dd229d539$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$zi(a)) $4d82739dd229d539$var$Ai(b, c);
    else if (c = $4d82739dd229d539$var$hh(a, b, c, d), null !== c) {
        var e = $4d82739dd229d539$var$R();
        $4d82739dd229d539$var$gi(c, a, d, e);
        $4d82739dd229d539$var$Bi(c, b, d);
    }
}
function $4d82739dd229d539$var$ii(a, b, c) {
    var d = $4d82739dd229d539$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$zi(a)) $4d82739dd229d539$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($4d82739dd229d539$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $4d82739dd229d539$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $4d82739dd229d539$var$hh(a, b, e, d);
        null !== c && (e = $4d82739dd229d539$var$R(), $4d82739dd229d539$var$gi(c, a, d, e), $4d82739dd229d539$var$Bi(c, b, d));
    }
}
function $4d82739dd229d539$var$zi(a) {
    var b = a.alternate;
    return a === $4d82739dd229d539$var$M || null !== b && b === $4d82739dd229d539$var$M;
}
function $4d82739dd229d539$var$Ai(a, b) {
    $4d82739dd229d539$var$Jh = $4d82739dd229d539$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $4d82739dd229d539$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
var $4d82739dd229d539$var$Rh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$P,
    useContext: $4d82739dd229d539$var$P,
    useEffect: $4d82739dd229d539$var$P,
    useImperativeHandle: $4d82739dd229d539$var$P,
    useInsertionEffect: $4d82739dd229d539$var$P,
    useLayoutEffect: $4d82739dd229d539$var$P,
    useMemo: $4d82739dd229d539$var$P,
    useReducer: $4d82739dd229d539$var$P,
    useRef: $4d82739dd229d539$var$P,
    useState: $4d82739dd229d539$var$P,
    useDebugValue: $4d82739dd229d539$var$P,
    useDeferredValue: $4d82739dd229d539$var$P,
    useTransition: $4d82739dd229d539$var$P,
    useMutableSource: $4d82739dd229d539$var$P,
    useSyncExternalStore: $4d82739dd229d539$var$P,
    useId: $4d82739dd229d539$var$P,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Oh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: function(a, b) {
        $4d82739dd229d539$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $4d82739dd229d539$var$ki(4194308, 4, $4d82739dd229d539$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $4d82739dd229d539$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $4d82739dd229d539$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $4d82739dd229d539$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $4d82739dd229d539$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $4d82739dd229d539$var$xi.bind(null, $4d82739dd229d539$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $4d82739dd229d539$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $4d82739dd229d539$var$hi,
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        return $4d82739dd229d539$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$hi(!1), b = a[0];
        a = $4d82739dd229d539$var$vi.bind(null, a[1]);
        $4d82739dd229d539$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $4d82739dd229d539$var$M, e = $4d82739dd229d539$var$Th();
        if ($4d82739dd229d539$var$I) {
            if (void 0 === c) throw Error($4d82739dd229d539$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $4d82739dd229d539$var$Q) throw Error($4d82739dd229d539$var$p(349));
            0 !== ($4d82739dd229d539$var$Hh & 30) || $4d82739dd229d539$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $4d82739dd229d539$var$mi($4d82739dd229d539$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $4d82739dd229d539$var$bi(9, $4d82739dd229d539$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $4d82739dd229d539$var$Th(), b = $4d82739dd229d539$var$Q.identifierPrefix;
        if ($4d82739dd229d539$var$I) {
            var c = $4d82739dd229d539$var$sg;
            var d = $4d82739dd229d539$var$rg;
            c = (d & ~(1 << 32 - $4d82739dd229d539$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $4d82739dd229d539$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $4d82739dd229d539$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Ph = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$si,
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$$h,
    useImperativeHandle: $4d82739dd229d539$var$qi,
    useInsertionEffect: $4d82739dd229d539$var$ni,
    useLayoutEffect: $4d82739dd229d539$var$oi,
    useMemo: $4d82739dd229d539$var$ti,
    useReducer: $4d82739dd229d539$var$Wh,
    useRef: $4d82739dd229d539$var$ji,
    useState: function() {
        return $4d82739dd229d539$var$Wh($4d82739dd229d539$var$Vh);
    },
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$Uh();
        return $4d82739dd229d539$var$ui(b, $4d82739dd229d539$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$Wh($4d82739dd229d539$var$Vh)[0], b = $4d82739dd229d539$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$Yh,
    useSyncExternalStore: $4d82739dd229d539$var$Zh,
    useId: $4d82739dd229d539$var$wi,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Qh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$si,
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$$h,
    useImperativeHandle: $4d82739dd229d539$var$qi,
    useInsertionEffect: $4d82739dd229d539$var$ni,
    useLayoutEffect: $4d82739dd229d539$var$oi,
    useMemo: $4d82739dd229d539$var$ti,
    useReducer: $4d82739dd229d539$var$Xh,
    useRef: $4d82739dd229d539$var$ji,
    useState: function() {
        return $4d82739dd229d539$var$Xh($4d82739dd229d539$var$Vh);
    },
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$Uh();
        return null === $4d82739dd229d539$var$N ? b.memoizedState = a : $4d82739dd229d539$var$ui(b, $4d82739dd229d539$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$Xh($4d82739dd229d539$var$Vh)[0], b = $4d82739dd229d539$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$Yh,
    useSyncExternalStore: $4d82739dd229d539$var$Zh,
    useId: $4d82739dd229d539$var$wi,
    unstable_isNewReconciler: !1
};
function $4d82739dd229d539$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $4d82739dd229d539$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $4d82739dd229d539$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $4d82739dd229d539$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $4d82739dd229d539$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $4d82739dd229d539$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$R(), e = $4d82739dd229d539$var$yi(a), f = $4d82739dd229d539$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$nh(a, f, e);
        null !== b && ($4d82739dd229d539$var$gi(b, a, e, d), $4d82739dd229d539$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$R(), e = $4d82739dd229d539$var$yi(a), f = $4d82739dd229d539$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$nh(a, f, e);
        null !== b && ($4d82739dd229d539$var$gi(b, a, e, d), $4d82739dd229d539$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $4d82739dd229d539$var$R(), d = $4d82739dd229d539$var$yi(a), e = $4d82739dd229d539$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $4d82739dd229d539$var$nh(a, e, d);
        null !== b && ($4d82739dd229d539$var$gi(b, a, d, c), $4d82739dd229d539$var$oh(b, a, d));
    }
};
function $4d82739dd229d539$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$4d82739dd229d539$var$Ie(c, d) || !$4d82739dd229d539$var$Ie(e, f) : !0;
}
function $4d82739dd229d539$var$Gi(a, b, c) {
    var d = !1, e = $4d82739dd229d539$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $4d82739dd229d539$var$eh(f) : (e = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $4d82739dd229d539$var$Yf(a, e) : $4d82739dd229d539$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $4d82739dd229d539$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $4d82739dd229d539$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $4d82739dd229d539$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $4d82739dd229d539$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $4d82739dd229d539$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $4d82739dd229d539$var$eh(f) : (f = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, e.context = $4d82739dd229d539$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($4d82739dd229d539$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $4d82739dd229d539$var$Ei.enqueueReplaceState(e, e.state, null), $4d82739dd229d539$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $4d82739dd229d539$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $4d82739dd229d539$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $4d82739dd229d539$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $4d82739dd229d539$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $4d82739dd229d539$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $4d82739dd229d539$var$Ni(a, b, c) {
    c = $4d82739dd229d539$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $4d82739dd229d539$var$Oi || ($4d82739dd229d539$var$Oi = !0, $4d82739dd229d539$var$Pi = d);
        $4d82739dd229d539$var$Li(a, b);
    };
    return c;
}
function $4d82739dd229d539$var$Qi(a, b, c) {
    c = $4d82739dd229d539$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $4d82739dd229d539$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $4d82739dd229d539$var$Li(a, b);
        "function" !== typeof d && (null === $4d82739dd229d539$var$Ri ? $4d82739dd229d539$var$Ri = new Set([
            this
        ]) : $4d82739dd229d539$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $4d82739dd229d539$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $4d82739dd229d539$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $4d82739dd229d539$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $4d82739dd229d539$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $4d82739dd229d539$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $4d82739dd229d539$var$mh(-1, 1), b.tag = 2, $4d82739dd229d539$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $4d82739dd229d539$var$Wi = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$dh = !1;
function $4d82739dd229d539$var$Xi(a, b, c, d) {
    b.child = null === a ? $4d82739dd229d539$var$Vg(b, null, c, d) : $4d82739dd229d539$var$Ug(b, a.child, c, d);
}
function $4d82739dd229d539$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $4d82739dd229d539$var$ch(b, e);
    d = $4d82739dd229d539$var$Nh(a, b, c, d, f, e);
    c = $4d82739dd229d539$var$Sh();
    if (null !== a && !$4d82739dd229d539$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$Zi(a, b, e);
    $4d82739dd229d539$var$I && c && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Xi(a, b, d, e);
    return b.child;
}
function $4d82739dd229d539$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$4d82739dd229d539$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $4d82739dd229d539$var$bj(a, b, f, d, e);
        a = $4d82739dd229d539$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $4d82739dd229d539$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $4d82739dd229d539$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $4d82739dd229d539$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $4d82739dd229d539$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($4d82739dd229d539$var$Ie(f, d) && a.ref === b.ref) {
            if ($4d82739dd229d539$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($4d82739dd229d539$var$dh = !0);
            else return b.lanes = a.lanes, $4d82739dd229d539$var$Zi(a, b, e);
        }
    }
    return $4d82739dd229d539$var$cj(a, b, c, d, e);
}
function $4d82739dd229d539$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj);
            $4d82739dd229d539$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= d;
    $4d82739dd229d539$var$Xi(a, b, e, c);
    return b.child;
}
function $4d82739dd229d539$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $4d82739dd229d539$var$cj(a, b, c, d, e) {
    var f = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current;
    f = $4d82739dd229d539$var$Yf(b, f);
    $4d82739dd229d539$var$ch(b, e);
    c = $4d82739dd229d539$var$Nh(a, b, c, d, f, e);
    d = $4d82739dd229d539$var$Sh();
    if (null !== a && !$4d82739dd229d539$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$Zi(a, b, e);
    $4d82739dd229d539$var$I && d && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Xi(a, b, c, e);
    return b.child;
}
function $4d82739dd229d539$var$hj(a, b, c, d, e) {
    if ($4d82739dd229d539$var$Zf(c)) {
        var f = !0;
        $4d82739dd229d539$var$cg(b);
    } else f = !1;
    $4d82739dd229d539$var$ch(b, e);
    if (null === b.stateNode) $4d82739dd229d539$var$ij(a, b), $4d82739dd229d539$var$Gi(b, c, d), $4d82739dd229d539$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $4d82739dd229d539$var$eh(l) : (l = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, l = $4d82739dd229d539$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $4d82739dd229d539$var$Hi(b, g, d, l);
        $4d82739dd229d539$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$jh ? ("function" === typeof m && ($4d82739dd229d539$var$Di(b, c, m, d), k = b.memoizedState), (h = $4d82739dd229d539$var$jh || $4d82739dd229d539$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $4d82739dd229d539$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $4d82739dd229d539$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $4d82739dd229d539$var$eh(k) : (k = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, k = $4d82739dd229d539$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $4d82739dd229d539$var$Hi(b, g, d, k);
        $4d82739dd229d539$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$jh ? ("function" === typeof y && ($4d82739dd229d539$var$Di(b, c, y, d), n = b.memoizedState), (l = $4d82739dd229d539$var$jh || $4d82739dd229d539$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $4d82739dd229d539$var$jj(a, b, c, d, f, e);
}
function $4d82739dd229d539$var$jj(a, b, c, d, e, f) {
    $4d82739dd229d539$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $4d82739dd229d539$var$dg(b, c, !1), $4d82739dd229d539$var$Zi(a, b, f);
    d = b.stateNode;
    $4d82739dd229d539$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $4d82739dd229d539$var$Ug(b, a.child, null, f), b.child = $4d82739dd229d539$var$Ug(b, null, h, f)) : $4d82739dd229d539$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $4d82739dd229d539$var$dg(b, c, !0);
    return b.child;
}
function $4d82739dd229d539$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $4d82739dd229d539$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $4d82739dd229d539$var$ag(a, b.context, !1);
    $4d82739dd229d539$var$yh(a, b.containerInfo);
}
function $4d82739dd229d539$var$lj(a, b, c, d, e) {
    $4d82739dd229d539$var$Ig();
    $4d82739dd229d539$var$Jg(e);
    b.flags |= 256;
    $4d82739dd229d539$var$Xi(a, b, c, d);
    return b.child;
}
var $4d82739dd229d539$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $4d82739dd229d539$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $4d82739dd229d539$var$oj(a, b, c) {
    var d = b.pendingProps, e = $4d82739dd229d539$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$L, e & 1);
    if (null === a) {
        $4d82739dd229d539$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $4d82739dd229d539$var$pj(g, d, 0, null), a = $4d82739dd229d539$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $4d82739dd229d539$var$nj(c), b.memoizedState = $4d82739dd229d539$var$mj, a) : $4d82739dd229d539$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $4d82739dd229d539$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $4d82739dd229d539$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $4d82739dd229d539$var$Pg(h, f) : (f = $4d82739dd229d539$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $4d82739dd229d539$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $4d82739dd229d539$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $4d82739dd229d539$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $4d82739dd229d539$var$qj(a, b) {
    b = $4d82739dd229d539$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $4d82739dd229d539$var$sj(a, b, c, d) {
    null !== d && $4d82739dd229d539$var$Jg(d);
    $4d82739dd229d539$var$Ug(b, a.child, null, c);
    a = $4d82739dd229d539$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $4d82739dd229d539$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(422))), $4d82739dd229d539$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $4d82739dd229d539$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $4d82739dd229d539$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $4d82739dd229d539$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $4d82739dd229d539$var$nj(g);
        b.memoizedState = $4d82739dd229d539$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $4d82739dd229d539$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($4d82739dd229d539$var$p(419));
        d = $4d82739dd229d539$var$Ki(f, d, void 0);
        return $4d82739dd229d539$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($4d82739dd229d539$var$dh || h) {
        d = $4d82739dd229d539$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $4d82739dd229d539$var$ih(a, e), $4d82739dd229d539$var$gi(d, a, e, -1));
        }
        $4d82739dd229d539$var$tj();
        d = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(421)));
        return $4d82739dd229d539$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $4d82739dd229d539$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(e.nextSibling);
    $4d82739dd229d539$var$xg = b;
    $4d82739dd229d539$var$I = !0;
    $4d82739dd229d539$var$zg = null;
    null !== a && ($4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg, $4d82739dd229d539$var$rg = a.id, $4d82739dd229d539$var$sg = a.overflow, $4d82739dd229d539$var$qg = b);
    b = $4d82739dd229d539$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $4d82739dd229d539$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $4d82739dd229d539$var$bh(a.return, b, c);
}
function $4d82739dd229d539$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $4d82739dd229d539$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $4d82739dd229d539$var$Xi(a, b, d.children, c);
    d = $4d82739dd229d539$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $4d82739dd229d539$var$vj(a, c, b);
            else if (19 === a.tag) $4d82739dd229d539$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $4d82739dd229d539$var$G($4d82739dd229d539$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $4d82739dd229d539$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $4d82739dd229d539$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $4d82739dd229d539$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $4d82739dd229d539$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $4d82739dd229d539$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $4d82739dd229d539$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $4d82739dd229d539$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($4d82739dd229d539$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $4d82739dd229d539$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $4d82739dd229d539$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $4d82739dd229d539$var$kj(b);
            $4d82739dd229d539$var$Ig();
            break;
        case 5:
            $4d82739dd229d539$var$Ah(b);
            break;
        case 1:
            $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$cg(b);
            break;
        case 4:
            $4d82739dd229d539$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $4d82739dd229d539$var$oj(a, b, c);
                $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1);
                a = $4d82739dd229d539$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $4d82739dd229d539$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $4d82739dd229d539$var$dj(a, b, c);
    }
    return $4d82739dd229d539$var$Zi(a, b, c);
}
var $4d82739dd229d539$var$zj, $4d82739dd229d539$var$Aj, $4d82739dd229d539$var$Bj, $4d82739dd229d539$var$Cj;
$4d82739dd229d539$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$4d82739dd229d539$var$Aj = function() {};
$4d82739dd229d539$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $4d82739dd229d539$var$Ya(a, e);
                d = $4d82739dd229d539$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $4d82739dd229d539$var$A({}, e, {
                    value: void 0
                });
                d = $4d82739dd229d539$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $4d82739dd229d539$var$gb(a, e);
                d = $4d82739dd229d539$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
        }
        $4d82739dd229d539$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $4d82739dd229d539$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$4d82739dd229d539$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $4d82739dd229d539$var$Dj(a, b) {
    if (!$4d82739dd229d539$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $4d82739dd229d539$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $4d82739dd229d539$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $4d82739dd229d539$var$S(b), null;
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 3:
            d = b.stateNode;
            $4d82739dd229d539$var$zh();
            $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
            $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
            $4d82739dd229d539$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $4d82739dd229d539$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Fj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null));
            $4d82739dd229d539$var$Aj(a, b);
            $4d82739dd229d539$var$S(b);
            return null;
        case 5:
            $4d82739dd229d539$var$Bh(b);
            var e = $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $4d82739dd229d539$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                    $4d82739dd229d539$var$S(b);
                    return null;
                }
                a = $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    d[$4d82739dd229d539$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $4d82739dd229d539$var$D("cancel", d);
                            $4d82739dd229d539$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], d);
                            break;
                        case "source":
                            $4d82739dd229d539$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $4d82739dd229d539$var$D("error", d);
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "details":
                            $4d82739dd229d539$var$D("toggle", d);
                            break;
                        case "input":
                            $4d82739dd229d539$var$Za(d, f);
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$hb(d, f), $4d82739dd229d539$var$D("invalid", d);
                    }
                    $4d82739dd229d539$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $4d82739dd229d539$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $4d82739dd229d539$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $4d82739dd229d539$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $4d82739dd229d539$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$4d82739dd229d539$var$Of] = b;
                    a[$4d82739dd229d539$var$Pf] = d;
                    $4d82739dd229d539$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $4d82739dd229d539$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $4d82739dd229d539$var$D("cancel", a);
                                $4d82739dd229d539$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $4d82739dd229d539$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $4d82739dd229d539$var$D("error", a);
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $4d82739dd229d539$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $4d82739dd229d539$var$Za(a, d);
                                e = $4d82739dd229d539$var$Ya(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $4d82739dd229d539$var$A({}, d, {
                                    value: void 0
                                });
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$hb(a, d);
                                e = $4d82739dd229d539$var$gb(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $4d82739dd229d539$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $4d82739dd229d539$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $4d82739dd229d539$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $4d82739dd229d539$var$ob(a, k) : "number" === typeof k && $4d82739dd229d539$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($4d82739dd229d539$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $4d82739dd229d539$var$D("scroll", a) : null != k && $4d82739dd229d539$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $4d82739dd229d539$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $4d82739dd229d539$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $4d82739dd229d539$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $4d82739dd229d539$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                c = $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
                $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $4d82739dd229d539$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$4d82739dd229d539$var$Of] = b, b.stateNode = d;
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($4d82739dd229d539$var$I && null !== $4d82739dd229d539$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $4d82739dd229d539$var$Hg(), $4d82739dd229d539$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $4d82739dd229d539$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($4d82739dd229d539$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($4d82739dd229d539$var$p(317));
                        f[$4d82739dd229d539$var$Of] = b;
                    } else $4d82739dd229d539$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $4d82739dd229d539$var$S(b);
                    f = !1;
                } else null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Fj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($4d82739dd229d539$var$L.current & 1) ? 0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 3) : $4d82739dd229d539$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $4d82739dd229d539$var$S(b);
            return null;
        case 4:
            return $4d82739dd229d539$var$zh(), $4d82739dd229d539$var$Aj(a, b), null === a && $4d82739dd229d539$var$sf(b.stateNode.containerInfo), $4d82739dd229d539$var$S(b), null;
        case 10:
            return $4d82739dd229d539$var$ah(b.type._context), $4d82739dd229d539$var$S(b), null;
        case 17:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 19:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            f = b.memoizedState;
            if (null === f) return $4d82739dd229d539$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $4d82739dd229d539$var$Dj(f, !1);
                else {
                    if (0 !== $4d82739dd229d539$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $4d82739dd229d539$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $4d82739dd229d539$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $4d82739dd229d539$var$B() > $4d82739dd229d539$var$Gj && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $4d82739dd229d539$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $4d82739dd229d539$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$4d82739dd229d539$var$I) return $4d82739dd229d539$var$S(b), null;
                    } else 2 * $4d82739dd229d539$var$B() - f.renderingStartTime > $4d82739dd229d539$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $4d82739dd229d539$var$B(), b.sibling = null, c = $4d82739dd229d539$var$L.current, $4d82739dd229d539$var$G($4d82739dd229d539$var$L, d ? c & 1 | 2 : c & 1), b;
            $4d82739dd229d539$var$S(b);
            return null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($4d82739dd229d539$var$fj & 1073741824) && ($4d82739dd229d539$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $4d82739dd229d539$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
}
function $4d82739dd229d539$var$Ij(a, b) {
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $4d82739dd229d539$var$zh(), $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $4d82739dd229d539$var$Bh(b), null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($4d82739dd229d539$var$p(340));
                $4d82739dd229d539$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $4d82739dd229d539$var$E($4d82739dd229d539$var$L), null;
        case 4:
            return $4d82739dd229d539$var$zh(), null;
        case 10:
            return $4d82739dd229d539$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$Jj = !1, $4d82739dd229d539$var$U = !1, $4d82739dd229d539$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $4d82739dd229d539$var$V = null;
function $4d82739dd229d539$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $4d82739dd229d539$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $4d82739dd229d539$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $4d82739dd229d539$var$W(a, b, d);
    }
}
var $4d82739dd229d539$var$Nj = !1;
function $4d82739dd229d539$var$Oj(a, b) {
    $4d82739dd229d539$var$Cf = $4d82739dd229d539$var$dd;
    a = $4d82739dd229d539$var$Me();
    if ($4d82739dd229d539$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $4d82739dd229d539$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $4d82739dd229d539$var$dd = !1;
    for($4d82739dd229d539$var$V = b; null !== $4d82739dd229d539$var$V;)if (b = $4d82739dd229d539$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $4d82739dd229d539$var$V = a;
    else for(; null !== $4d82739dd229d539$var$V;){
        b = $4d82739dd229d539$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $4d82739dd229d539$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(163));
            }
        } catch (F) {
            $4d82739dd229d539$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $4d82739dd229d539$var$V = a;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
    n = $4d82739dd229d539$var$Nj;
    $4d82739dd229d539$var$Nj = !1;
    return n;
}
function $4d82739dd229d539$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $4d82739dd229d539$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $4d82739dd229d539$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $4d82739dd229d539$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $4d82739dd229d539$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $4d82739dd229d539$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$4d82739dd229d539$var$Of], delete b[$4d82739dd229d539$var$Pf], delete b[$4d82739dd229d539$var$of], delete b[$4d82739dd229d539$var$Qf], delete b[$4d82739dd229d539$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $4d82739dd229d539$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $4d82739dd229d539$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $4d82739dd229d539$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $4d82739dd229d539$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $4d82739dd229d539$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Vj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Vj(a, b, c), a = a.sibling;
}
function $4d82739dd229d539$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Wj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Wj(a, b, c), a = a.sibling;
}
var $4d82739dd229d539$var$X = null, $4d82739dd229d539$var$Xj = !1;
function $4d82739dd229d539$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$4d82739dd229d539$var$Zj(a, b, c), c = c.sibling;
}
function $4d82739dd229d539$var$Zj(a, b, c) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberUnmount) try {
        $4d82739dd229d539$var$lc.onCommitFiberUnmount($4d82739dd229d539$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $4d82739dd229d539$var$U || $4d82739dd229d539$var$Lj(c, b);
        case 6:
            var d = $4d82739dd229d539$var$X, e = $4d82739dd229d539$var$Xj;
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Yj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Xj = e;
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Xj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $4d82739dd229d539$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Xj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? $4d82739dd229d539$var$Kf(a.parentNode, c) : 1 === a.nodeType && $4d82739dd229d539$var$Kf(a, c), $4d82739dd229d539$var$bd(a)) : $4d82739dd229d539$var$Kf($4d82739dd229d539$var$X, c.stateNode));
            break;
        case 4:
            d = $4d82739dd229d539$var$X;
            e = $4d82739dd229d539$var$Xj;
            $4d82739dd229d539$var$X = c.stateNode.containerInfo;
            $4d82739dd229d539$var$Xj = !0;
            $4d82739dd229d539$var$Yj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$4d82739dd229d539$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $4d82739dd229d539$var$Mj(c, b, g) : 0 !== (f & 4) && $4d82739dd229d539$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 1:
            if (!$4d82739dd229d539$var$U && ($4d82739dd229d539$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $4d82739dd229d539$var$W(c, b, h);
            }
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 21:
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($4d82739dd229d539$var$U = (d = $4d82739dd229d539$var$U) || null !== c.memoizedState, $4d82739dd229d539$var$Yj(a, b, c), $4d82739dd229d539$var$U = d) : $4d82739dd229d539$var$Yj(a, b, c);
            break;
        default:
            $4d82739dd229d539$var$Yj(a, b, c);
    }
}
function $4d82739dd229d539$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $4d82739dd229d539$var$Kj);
        b.forEach(function(b) {
            var d = $4d82739dd229d539$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $4d82739dd229d539$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $4d82739dd229d539$var$X = h.stateNode;
                        $4d82739dd229d539$var$Xj = !1;
                        break a;
                    case 3:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Xj = !0;
                        break a;
                    case 4:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $4d82739dd229d539$var$X) throw Error($4d82739dd229d539$var$p(160));
            $4d82739dd229d539$var$Zj(f, g, e);
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $4d82739dd229d539$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$4d82739dd229d539$var$dk(b, a), b = b.sibling;
}
function $4d82739dd229d539$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4) {
                try {
                    $4d82739dd229d539$var$Pj(3, a, a.return), $4d82739dd229d539$var$Qj(3, a);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
                try {
                    $4d82739dd229d539$var$Pj(5, a, a.return);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Lj(c, c.return);
            break;
        case 5:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $4d82739dd229d539$var$ob(e, "");
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $4d82739dd229d539$var$ab(e, f);
                    $4d82739dd229d539$var$vb(h, g);
                    var l = $4d82739dd229d539$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $4d82739dd229d539$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $4d82739dd229d539$var$nb(e, q) : "children" === m ? $4d82739dd229d539$var$ob(e, q) : $4d82739dd229d539$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $4d82739dd229d539$var$bb(e, f);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $4d82739dd229d539$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $4d82739dd229d539$var$fb(e, !!f.multiple, f.defaultValue, !0) : $4d82739dd229d539$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$4d82739dd229d539$var$Pf] = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($4d82739dd229d539$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $4d82739dd229d539$var$bd(b.containerInfo);
            } catch (t) {
                $4d82739dd229d539$var$W(a, a.return, t);
            }
            break;
        case 4:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            break;
        case 13:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($4d82739dd229d539$var$fk = $4d82739dd229d539$var$B()));
            d & 4 && $4d82739dd229d539$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($4d82739dd229d539$var$U = (l = $4d82739dd229d539$var$U) || m, $4d82739dd229d539$var$ck(b, a), $4d82739dd229d539$var$U = l) : $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($4d82739dd229d539$var$V = a, m = a.child; null !== m;){
                    for(q = $4d82739dd229d539$var$V = m; null !== $4d82739dd229d539$var$V;){
                        r = $4d82739dd229d539$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $4d82739dd229d539$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $4d82739dd229d539$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $4d82739dd229d539$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $4d82739dd229d539$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $4d82739dd229d539$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $4d82739dd229d539$var$V = y) : $4d82739dd229d539$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $4d82739dd229d539$var$rb("display", g));
                            } catch (t) {
                                $4d82739dd229d539$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $4d82739dd229d539$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 4 && $4d82739dd229d539$var$ak(a);
            break;
        case 21:
            break;
        default:
            $4d82739dd229d539$var$ck(b, a), $4d82739dd229d539$var$ek(a);
    }
}
function $4d82739dd229d539$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($4d82739dd229d539$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($4d82739dd229d539$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($4d82739dd229d539$var$ob(e, ""), d.flags &= -33);
                    var f = $4d82739dd229d539$var$Uj(a);
                    $4d82739dd229d539$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $4d82739dd229d539$var$Uj(a);
                    $4d82739dd229d539$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(161));
            }
        } catch (k) {
            $4d82739dd229d539$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $4d82739dd229d539$var$hk(a, b, c) {
    $4d82739dd229d539$var$V = a;
    $4d82739dd229d539$var$ik(a, b, c);
}
function $4d82739dd229d539$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $4d82739dd229d539$var$V;){
        var e = $4d82739dd229d539$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $4d82739dd229d539$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $4d82739dd229d539$var$U;
                h = $4d82739dd229d539$var$Jj;
                var l = $4d82739dd229d539$var$U;
                $4d82739dd229d539$var$Jj = g;
                if (($4d82739dd229d539$var$U = k) && !l) for($4d82739dd229d539$var$V = e; null !== $4d82739dd229d539$var$V;)g = $4d82739dd229d539$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $4d82739dd229d539$var$jk(e) : null !== k ? (k.return = g, $4d82739dd229d539$var$V = k) : $4d82739dd229d539$var$jk(e);
                for(; null !== f;)$4d82739dd229d539$var$V = f, $4d82739dd229d539$var$ik(f, b, c), f = f.sibling;
                $4d82739dd229d539$var$V = e;
                $4d82739dd229d539$var$Jj = h;
                $4d82739dd229d539$var$U = l;
            }
            $4d82739dd229d539$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $4d82739dd229d539$var$V = f) : $4d82739dd229d539$var$kk(a, b, c);
    }
}
function $4d82739dd229d539$var$kk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $4d82739dd229d539$var$U || $4d82739dd229d539$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$4d82739dd229d539$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $4d82739dd229d539$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $4d82739dd229d539$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $4d82739dd229d539$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $4d82739dd229d539$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($4d82739dd229d539$var$p(163));
                }
                $4d82739dd229d539$var$U || b.flags & 512 && $4d82739dd229d539$var$Rj(b);
            } catch (r) {
                $4d82739dd229d539$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$gk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$jk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $4d82739dd229d539$var$Qj(4, b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $4d82739dd229d539$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $4d82739dd229d539$var$Rj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $4d82739dd229d539$var$Rj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $4d82739dd229d539$var$W(b, b.return, k);
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $4d82739dd229d539$var$V = h;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
var $4d82739dd229d539$var$lk = Math.ceil, $4d82739dd229d539$var$mk = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$nk = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$ok = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$K = 0, $4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Y = null, $4d82739dd229d539$var$Z = 0, $4d82739dd229d539$var$fj = 0, $4d82739dd229d539$var$ej = $4d82739dd229d539$var$Uf(0), $4d82739dd229d539$var$T = 0, $4d82739dd229d539$var$pk = null, $4d82739dd229d539$var$rh = 0, $4d82739dd229d539$var$qk = 0, $4d82739dd229d539$var$rk = 0, $4d82739dd229d539$var$sk = null, $4d82739dd229d539$var$tk = null, $4d82739dd229d539$var$fk = 0, $4d82739dd229d539$var$Gj = Infinity, $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Oi = !1, $4d82739dd229d539$var$Pi = null, $4d82739dd229d539$var$Ri = null, $4d82739dd229d539$var$vk = !1, $4d82739dd229d539$var$wk = null, $4d82739dd229d539$var$xk = 0, $4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = null, $4d82739dd229d539$var$Ak = -1, $4d82739dd229d539$var$Bk = 0;
function $4d82739dd229d539$var$R() {
    return 0 !== ($4d82739dd229d539$var$K & 6) ? $4d82739dd229d539$var$B() : -1 !== $4d82739dd229d539$var$Ak ? $4d82739dd229d539$var$Ak : $4d82739dd229d539$var$Ak = $4d82739dd229d539$var$B();
}
function $4d82739dd229d539$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($4d82739dd229d539$var$K & 2) && 0 !== $4d82739dd229d539$var$Z) return $4d82739dd229d539$var$Z & -$4d82739dd229d539$var$Z;
    if (null !== $4d82739dd229d539$var$Kg.transition) return 0 === $4d82739dd229d539$var$Bk && ($4d82739dd229d539$var$Bk = $4d82739dd229d539$var$yc()), $4d82739dd229d539$var$Bk;
    a = $4d82739dd229d539$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $4d82739dd229d539$var$jd(a.type);
    return a;
}
function $4d82739dd229d539$var$gi(a, b, c, d) {
    if (50 < $4d82739dd229d539$var$yk) throw $4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = null, Error($4d82739dd229d539$var$p(185));
    $4d82739dd229d539$var$Ac(a, c, d);
    if (0 === ($4d82739dd229d539$var$K & 2) || a !== $4d82739dd229d539$var$Q) a === $4d82739dd229d539$var$Q && (0 === ($4d82739dd229d539$var$K & 2) && ($4d82739dd229d539$var$qk |= c), 4 === $4d82739dd229d539$var$T && $4d82739dd229d539$var$Ck(a, $4d82739dd229d539$var$Z)), $4d82739dd229d539$var$Dk(a, d), 1 === c && 0 === $4d82739dd229d539$var$K && 0 === (b.mode & 1) && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
}
function $4d82739dd229d539$var$Dk(a, b) {
    var c = a.callbackNode;
    $4d82739dd229d539$var$wc(a, b);
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$Q ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) null !== c && $4d82739dd229d539$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $4d82739dd229d539$var$bc(c);
        if (1 === b) 0 === a.tag ? $4d82739dd229d539$var$ig($4d82739dd229d539$var$Ek.bind(null, a)) : $4d82739dd229d539$var$hg($4d82739dd229d539$var$Ek.bind(null, a)), $4d82739dd229d539$var$Jf(function() {
            0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
        }), c = null;
        else {
            switch($4d82739dd229d539$var$Dc(d)){
                case 1:
                    c = $4d82739dd229d539$var$fc;
                    break;
                case 4:
                    c = $4d82739dd229d539$var$gc;
                    break;
                case 16:
                    c = $4d82739dd229d539$var$hc;
                    break;
                case 536870912:
                    c = $4d82739dd229d539$var$jc;
                    break;
                default:
                    c = $4d82739dd229d539$var$hc;
            }
            c = $4d82739dd229d539$var$Fk(c, $4d82739dd229d539$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $4d82739dd229d539$var$Gk(a, b) {
    $4d82739dd229d539$var$Ak = -1;
    $4d82739dd229d539$var$Bk = 0;
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    var c = a.callbackNode;
    if ($4d82739dd229d539$var$Hk() && a.callbackNode !== c) return null;
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$Q ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $4d82739dd229d539$var$Ik(a, d);
    else {
        b = d;
        var e = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 2;
        var f = $4d82739dd229d539$var$Jk();
        if ($4d82739dd229d539$var$Q !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$Kk(a, b);
        for(;;)try {
            $4d82739dd229d539$var$Lk();
            break;
        } catch (h) {
            $4d82739dd229d539$var$Mk(a, h);
        }
        $4d82739dd229d539$var$$g();
        $4d82739dd229d539$var$mk.current = f;
        $4d82739dd229d539$var$K = e;
        null !== $4d82739dd229d539$var$Y ? b = 0 : ($4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Z = 0, b = $4d82739dd229d539$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $4d82739dd229d539$var$xc(a), 0 !== e && (d = e, b = $4d82739dd229d539$var$Nk(a, e)));
        if (1 === b) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, d), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
        if (6 === b) $4d82739dd229d539$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$4d82739dd229d539$var$Ok(e) && (b = $4d82739dd229d539$var$Ik(a, d), 2 === b && (f = $4d82739dd229d539$var$xc(a), 0 !== f && (d = f, b = $4d82739dd229d539$var$Nk(a, f))), 1 === b)) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, d), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($4d82739dd229d539$var$p(345));
                case 2:
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 3:
                    $4d82739dd229d539$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $4d82739dd229d539$var$fk + 500 - $4d82739dd229d539$var$B(), 10 < b)) {
                        if (0 !== $4d82739dd229d539$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $4d82739dd229d539$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Pk.bind(null, a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk), b);
                        break;
                    }
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 4:
                    $4d82739dd229d539$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $4d82739dd229d539$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $4d82739dd229d539$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $4d82739dd229d539$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Pk.bind(null, a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk), d);
                        break;
                    }
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 5:
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(329));
            }
        }
    }
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    return a.callbackNode === c ? $4d82739dd229d539$var$Gk.bind(null, a) : null;
}
function $4d82739dd229d539$var$Nk(a, b) {
    var c = $4d82739dd229d539$var$sk;
    a.current.memoizedState.isDehydrated && ($4d82739dd229d539$var$Kk(a, b).flags |= 256);
    a = $4d82739dd229d539$var$Ik(a, b);
    2 !== a && (b = $4d82739dd229d539$var$tk, $4d82739dd229d539$var$tk = c, null !== b && $4d82739dd229d539$var$Fj(b));
    return a;
}
function $4d82739dd229d539$var$Fj(a) {
    null === $4d82739dd229d539$var$tk ? $4d82739dd229d539$var$tk = a : $4d82739dd229d539$var$tk.push.apply($4d82739dd229d539$var$tk, a);
}
function $4d82739dd229d539$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$4d82739dd229d539$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $4d82739dd229d539$var$Ck(a, b) {
    b &= ~$4d82739dd229d539$var$rk;
    b &= ~$4d82739dd229d539$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $4d82739dd229d539$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $4d82739dd229d539$var$Ek(a) {
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    $4d82739dd229d539$var$Hk();
    var b = $4d82739dd229d539$var$uc(a, 0);
    if (0 === (b & 1)) return $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), null;
    var c = $4d82739dd229d539$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $4d82739dd229d539$var$xc(a);
        0 !== d && (b = d, c = $4d82739dd229d539$var$Nk(a, d));
    }
    if (1 === c) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, b), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
    if (6 === c) throw Error($4d82739dd229d539$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    return null;
}
function $4d82739dd229d539$var$Qk(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    try {
        return a(b);
    } finally{
        $4d82739dd229d539$var$K = c, 0 === $4d82739dd229d539$var$K && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
    }
}
function $4d82739dd229d539$var$Rk(a) {
    null !== $4d82739dd229d539$var$wk && 0 === $4d82739dd229d539$var$wk.tag && 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$Hk();
    var b = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    var c = $4d82739dd229d539$var$ok.transition, d = $4d82739dd229d539$var$C;
    try {
        if ($4d82739dd229d539$var$ok.transition = null, $4d82739dd229d539$var$C = 1, a) return a();
    } finally{
        $4d82739dd229d539$var$C = d, $4d82739dd229d539$var$ok.transition = c, $4d82739dd229d539$var$K = b, 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
    }
}
function $4d82739dd229d539$var$Hj() {
    $4d82739dd229d539$var$fj = $4d82739dd229d539$var$ej.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$ej);
}
function $4d82739dd229d539$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $4d82739dd229d539$var$Gf(c));
    if (null !== $4d82739dd229d539$var$Y) for(c = $4d82739dd229d539$var$Y.return; null !== c;){
        var d = c;
        $4d82739dd229d539$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $4d82739dd229d539$var$$f();
                break;
            case 3:
                $4d82739dd229d539$var$zh();
                $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
                $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
                $4d82739dd229d539$var$Eh();
                break;
            case 5:
                $4d82739dd229d539$var$Bh(d);
                break;
            case 4:
                $4d82739dd229d539$var$zh();
                break;
            case 13:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
                break;
            case 19:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
                break;
            case 10:
                $4d82739dd229d539$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $4d82739dd229d539$var$Hj();
        }
        c = c.return;
    }
    $4d82739dd229d539$var$Q = a;
    $4d82739dd229d539$var$Y = a = $4d82739dd229d539$var$Pg(a.current, null);
    $4d82739dd229d539$var$Z = $4d82739dd229d539$var$fj = b;
    $4d82739dd229d539$var$T = 0;
    $4d82739dd229d539$var$pk = null;
    $4d82739dd229d539$var$rk = $4d82739dd229d539$var$qk = $4d82739dd229d539$var$rh = 0;
    $4d82739dd229d539$var$tk = $4d82739dd229d539$var$sk = null;
    if (null !== $4d82739dd229d539$var$fh) {
        for(b = 0; b < $4d82739dd229d539$var$fh.length; b++)if (c = $4d82739dd229d539$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $4d82739dd229d539$var$fh = null;
    }
    return a;
}
function $4d82739dd229d539$var$Mk(a, b) {
    do {
        var c = $4d82739dd229d539$var$Y;
        try {
            $4d82739dd229d539$var$$g();
            $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Rh;
            if ($4d82739dd229d539$var$Ih) {
                for(var d = $4d82739dd229d539$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $4d82739dd229d539$var$Ih = !1;
            }
            $4d82739dd229d539$var$Hh = 0;
            $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = $4d82739dd229d539$var$M = null;
            $4d82739dd229d539$var$Jh = !1;
            $4d82739dd229d539$var$Kh = 0;
            $4d82739dd229d539$var$nk.current = null;
            if (null === c || null === c.return) {
                $4d82739dd229d539$var$T = 1;
                $4d82739dd229d539$var$pk = b;
                $4d82739dd229d539$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $4d82739dd229d539$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $4d82739dd229d539$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $4d82739dd229d539$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $4d82739dd229d539$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $4d82739dd229d539$var$Si(f, l, b);
                            $4d82739dd229d539$var$tj();
                            break a;
                        }
                        k = Error($4d82739dd229d539$var$p(426));
                    }
                } else if ($4d82739dd229d539$var$I && h.mode & 1) {
                    var J = $4d82739dd229d539$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $4d82739dd229d539$var$Vi(J, g, h, f, b);
                        $4d82739dd229d539$var$Jg($4d82739dd229d539$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $4d82739dd229d539$var$Ji(k, h);
                4 !== $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 2);
                null === $4d82739dd229d539$var$sk ? $4d82739dd229d539$var$sk = [
                    f
                ] : $4d82739dd229d539$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $4d82739dd229d539$var$Ni(f, k, b);
                            $4d82739dd229d539$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $4d82739dd229d539$var$Ri || !$4d82739dd229d539$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $4d82739dd229d539$var$Qi(f, h, b);
                                $4d82739dd229d539$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $4d82739dd229d539$var$Sk(c);
        } catch (na) {
            b = na;
            $4d82739dd229d539$var$Y === c && null !== c && ($4d82739dd229d539$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $4d82739dd229d539$var$Jk() {
    var a = $4d82739dd229d539$var$mk.current;
    $4d82739dd229d539$var$mk.current = $4d82739dd229d539$var$Rh;
    return null === a ? $4d82739dd229d539$var$Rh : a;
}
function $4d82739dd229d539$var$tj() {
    if (0 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T || 2 === $4d82739dd229d539$var$T) $4d82739dd229d539$var$T = 4;
    null === $4d82739dd229d539$var$Q || 0 === ($4d82739dd229d539$var$rh & 268435455) && 0 === ($4d82739dd229d539$var$qk & 268435455) || $4d82739dd229d539$var$Ck($4d82739dd229d539$var$Q, $4d82739dd229d539$var$Z);
}
function $4d82739dd229d539$var$Ik(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 2;
    var d = $4d82739dd229d539$var$Jk();
    if ($4d82739dd229d539$var$Q !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Kk(a, b);
    for(;;)try {
        $4d82739dd229d539$var$Tk();
        break;
    } catch (e) {
        $4d82739dd229d539$var$Mk(a, e);
    }
    $4d82739dd229d539$var$$g();
    $4d82739dd229d539$var$K = c;
    $4d82739dd229d539$var$mk.current = d;
    if (null !== $4d82739dd229d539$var$Y) throw Error($4d82739dd229d539$var$p(261));
    $4d82739dd229d539$var$Q = null;
    $4d82739dd229d539$var$Z = 0;
    return $4d82739dd229d539$var$T;
}
function $4d82739dd229d539$var$Tk() {
    for(; null !== $4d82739dd229d539$var$Y;)$4d82739dd229d539$var$Uk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Lk() {
    for(; null !== $4d82739dd229d539$var$Y && !$4d82739dd229d539$var$cc();)$4d82739dd229d539$var$Uk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Uk(a) {
    var b = $4d82739dd229d539$var$Vk(a.alternate, a, $4d82739dd229d539$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $4d82739dd229d539$var$Sk(a) : $4d82739dd229d539$var$Y = b;
    $4d82739dd229d539$var$nk.current = null;
}
function $4d82739dd229d539$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $4d82739dd229d539$var$Ej(c, b, $4d82739dd229d539$var$fj), null !== c) {
                $4d82739dd229d539$var$Y = c;
                return;
            }
        } else {
            c = $4d82739dd229d539$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $4d82739dd229d539$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $4d82739dd229d539$var$T = 6;
                $4d82739dd229d539$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $4d82739dd229d539$var$Y = b;
            return;
        }
        $4d82739dd229d539$var$Y = b = a;
    }while (null !== b);
    0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 5);
}
function $4d82739dd229d539$var$Pk(a, b, c) {
    var d = $4d82739dd229d539$var$C, e = $4d82739dd229d539$var$ok.transition;
    try {
        $4d82739dd229d539$var$ok.transition = null, $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$Wk(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$ok.transition = e, $4d82739dd229d539$var$C = d;
    }
    return null;
}
function $4d82739dd229d539$var$Wk(a, b, c, d) {
    do $4d82739dd229d539$var$Hk();
    while (null !== $4d82739dd229d539$var$wk);
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($4d82739dd229d539$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $4d82739dd229d539$var$Bc(a, f);
    a === $4d82739dd229d539$var$Q && ($4d82739dd229d539$var$Y = $4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $4d82739dd229d539$var$vk || ($4d82739dd229d539$var$vk = !0, $4d82739dd229d539$var$Fk($4d82739dd229d539$var$hc, function() {
        $4d82739dd229d539$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $4d82739dd229d539$var$ok.transition;
        $4d82739dd229d539$var$ok.transition = null;
        var g = $4d82739dd229d539$var$C;
        $4d82739dd229d539$var$C = 1;
        var h = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 4;
        $4d82739dd229d539$var$nk.current = null;
        $4d82739dd229d539$var$Oj(a, c);
        $4d82739dd229d539$var$dk(c, a);
        $4d82739dd229d539$var$Oe($4d82739dd229d539$var$Df);
        $4d82739dd229d539$var$dd = !!$4d82739dd229d539$var$Cf;
        $4d82739dd229d539$var$Df = $4d82739dd229d539$var$Cf = null;
        a.current = c;
        $4d82739dd229d539$var$hk(c, a, e);
        $4d82739dd229d539$var$dc();
        $4d82739dd229d539$var$K = h;
        $4d82739dd229d539$var$C = g;
        $4d82739dd229d539$var$ok.transition = f;
    } else a.current = c;
    $4d82739dd229d539$var$vk && ($4d82739dd229d539$var$vk = !1, $4d82739dd229d539$var$wk = a, $4d82739dd229d539$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($4d82739dd229d539$var$Ri = null);
    $4d82739dd229d539$var$mc(c.stateNode, d);
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($4d82739dd229d539$var$Oi) throw $4d82739dd229d539$var$Oi = !1, a = $4d82739dd229d539$var$Pi, $4d82739dd229d539$var$Pi = null, a;
    0 !== ($4d82739dd229d539$var$xk & 1) && 0 !== a.tag && $4d82739dd229d539$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $4d82739dd229d539$var$zk ? $4d82739dd229d539$var$yk++ : ($4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = a) : $4d82739dd229d539$var$yk = 0;
    $4d82739dd229d539$var$jg();
    return null;
}
function $4d82739dd229d539$var$Hk() {
    if (null !== $4d82739dd229d539$var$wk) {
        var a = $4d82739dd229d539$var$Dc($4d82739dd229d539$var$xk), b = $4d82739dd229d539$var$ok.transition, c = $4d82739dd229d539$var$C;
        try {
            $4d82739dd229d539$var$ok.transition = null;
            $4d82739dd229d539$var$C = 16 > a ? 16 : a;
            if (null === $4d82739dd229d539$var$wk) var d = !1;
            else {
                a = $4d82739dd229d539$var$wk;
                $4d82739dd229d539$var$wk = null;
                $4d82739dd229d539$var$xk = 0;
                if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(331));
                var e = $4d82739dd229d539$var$K;
                $4d82739dd229d539$var$K |= 4;
                for($4d82739dd229d539$var$V = a.current; null !== $4d82739dd229d539$var$V;){
                    var f = $4d82739dd229d539$var$V, g = f.child;
                    if (0 !== ($4d82739dd229d539$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($4d82739dd229d539$var$V = l; null !== $4d82739dd229d539$var$V;){
                                    var m = $4d82739dd229d539$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $4d82739dd229d539$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $4d82739dd229d539$var$V = q;
                                    else for(; null !== $4d82739dd229d539$var$V;){
                                        m = $4d82739dd229d539$var$V;
                                        var r = m.sibling, y = m.return;
                                        $4d82739dd229d539$var$Sj(m);
                                        if (m === l) {
                                            $4d82739dd229d539$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $4d82739dd229d539$var$V = r;
                                            break;
                                        }
                                        $4d82739dd229d539$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $4d82739dd229d539$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $4d82739dd229d539$var$V = g;
                    else b: for(; null !== $4d82739dd229d539$var$V;){
                        f = $4d82739dd229d539$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $4d82739dd229d539$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $4d82739dd229d539$var$V = x;
                            break b;
                        }
                        $4d82739dd229d539$var$V = f.return;
                    }
                }
                var w = a.current;
                for($4d82739dd229d539$var$V = w; null !== $4d82739dd229d539$var$V;){
                    g = $4d82739dd229d539$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $4d82739dd229d539$var$V = u;
                    else b: for(g = w; null !== $4d82739dd229d539$var$V;){
                        h = $4d82739dd229d539$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $4d82739dd229d539$var$Qj(9, h);
                            }
                        } catch (na) {
                            $4d82739dd229d539$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $4d82739dd229d539$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $4d82739dd229d539$var$V = F;
                            break b;
                        }
                        $4d82739dd229d539$var$V = h.return;
                    }
                }
                $4d82739dd229d539$var$K = e;
                $4d82739dd229d539$var$jg();
                if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onPostCommitFiberRoot) try {
                    $4d82739dd229d539$var$lc.onPostCommitFiberRoot($4d82739dd229d539$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$ok.transition = b;
        }
    }
    return !1;
}
function $4d82739dd229d539$var$Xk(a, b, c) {
    b = $4d82739dd229d539$var$Ji(c, b);
    b = $4d82739dd229d539$var$Ni(a, b, 1);
    a = $4d82739dd229d539$var$nh(a, b, 1);
    b = $4d82739dd229d539$var$R();
    null !== a && ($4d82739dd229d539$var$Ac(a, 1, b), $4d82739dd229d539$var$Dk(a, b));
}
function $4d82739dd229d539$var$W(a, b, c) {
    if (3 === a.tag) $4d82739dd229d539$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $4d82739dd229d539$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $4d82739dd229d539$var$Ri || !$4d82739dd229d539$var$Ri.has(d))) {
                a = $4d82739dd229d539$var$Ji(c, a);
                a = $4d82739dd229d539$var$Qi(b, a, 1);
                b = $4d82739dd229d539$var$nh(b, a, 1);
                a = $4d82739dd229d539$var$R();
                null !== b && ($4d82739dd229d539$var$Ac(b, 1, a), $4d82739dd229d539$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $4d82739dd229d539$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $4d82739dd229d539$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $4d82739dd229d539$var$Q === a && ($4d82739dd229d539$var$Z & c) === c && (4 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$Z & 130023424) === $4d82739dd229d539$var$Z && 500 > $4d82739dd229d539$var$B() - $4d82739dd229d539$var$fk ? $4d82739dd229d539$var$Kk(a, 0) : $4d82739dd229d539$var$rk |= c);
    $4d82739dd229d539$var$Dk(a, b);
}
function $4d82739dd229d539$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $4d82739dd229d539$var$sc, $4d82739dd229d539$var$sc <<= 1, 0 === ($4d82739dd229d539$var$sc & 130023424) && ($4d82739dd229d539$var$sc = 4194304)));
    var c = $4d82739dd229d539$var$R();
    a = $4d82739dd229d539$var$ih(a, b);
    null !== a && ($4d82739dd229d539$var$Ac(a, b, c), $4d82739dd229d539$var$Dk(a, c));
}
function $4d82739dd229d539$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $4d82739dd229d539$var$Yk(a, c);
}
function $4d82739dd229d539$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($4d82739dd229d539$var$p(314));
    }
    null !== d && d.delete(b);
    $4d82739dd229d539$var$Yk(a, c);
}
var $4d82739dd229d539$var$Vk;
$4d82739dd229d539$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $4d82739dd229d539$var$Wf.current) $4d82739dd229d539$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $4d82739dd229d539$var$dh = !1, $4d82739dd229d539$var$yj(a, b, c);
            $4d82739dd229d539$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $4d82739dd229d539$var$dh = !1, $4d82739dd229d539$var$I && 0 !== (b.flags & 1048576) && $4d82739dd229d539$var$ug(b, $4d82739dd229d539$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $4d82739dd229d539$var$ij(a, b);
            a = b.pendingProps;
            var e = $4d82739dd229d539$var$Yf(b, $4d82739dd229d539$var$H.current);
            $4d82739dd229d539$var$ch(b, c);
            e = $4d82739dd229d539$var$Nh(null, b, d, a, e, c);
            var f = $4d82739dd229d539$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $4d82739dd229d539$var$Zf(d) ? (f = !0, $4d82739dd229d539$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $4d82739dd229d539$var$kh(b), e.updater = $4d82739dd229d539$var$Ei, b.stateNode = e, e._reactInternals = b, $4d82739dd229d539$var$Ii(b, d, a, c), b = $4d82739dd229d539$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $4d82739dd229d539$var$I && f && $4d82739dd229d539$var$vg(b), $4d82739dd229d539$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $4d82739dd229d539$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $4d82739dd229d539$var$Zk(d);
                a = $4d82739dd229d539$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $4d82739dd229d539$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $4d82739dd229d539$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $4d82739dd229d539$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $4d82739dd229d539$var$$i(null, b, d, $4d82739dd229d539$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($4d82739dd229d539$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $4d82739dd229d539$var$kj(b);
                if (null === a) throw Error($4d82739dd229d539$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $4d82739dd229d539$var$lh(a, b);
                $4d82739dd229d539$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $4d82739dd229d539$var$Ji(Error($4d82739dd229d539$var$p(423)), b);
                        b = $4d82739dd229d539$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $4d82739dd229d539$var$Ji(Error($4d82739dd229d539$var$p(424)), b);
                        b = $4d82739dd229d539$var$lj(a, b, d, c, e);
                        break a;
                    } else for($4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.stateNode.containerInfo.firstChild), $4d82739dd229d539$var$xg = b, $4d82739dd229d539$var$I = !0, $4d82739dd229d539$var$zg = null, c = $4d82739dd229d539$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $4d82739dd229d539$var$Ig();
                    if (d === e) {
                        b = $4d82739dd229d539$var$Zi(a, b, c);
                        break a;
                    }
                    $4d82739dd229d539$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $4d82739dd229d539$var$Ah(b), null === a && $4d82739dd229d539$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $4d82739dd229d539$var$Ef(d, e) ? g = null : null !== f && $4d82739dd229d539$var$Ef(d, f) && (b.flags |= 32), $4d82739dd229d539$var$gj(a, b), $4d82739dd229d539$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $4d82739dd229d539$var$Eg(b), null;
        case 13:
            return $4d82739dd229d539$var$oj(a, b, c);
        case 4:
            return $4d82739dd229d539$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $4d82739dd229d539$var$Ug(b, null, d, c) : $4d82739dd229d539$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$Yi(a, b, d, e, c);
        case 7:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $4d82739dd229d539$var$G($4d82739dd229d539$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($4d82739dd229d539$var$He(f.value, g)) {
                        if (f.children === e.children && !$4d82739dd229d539$var$Wf.current) {
                            b = $4d82739dd229d539$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $4d82739dd229d539$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $4d82739dd229d539$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($4d82739dd229d539$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $4d82739dd229d539$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $4d82739dd229d539$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $4d82739dd229d539$var$ch(b, c), e = $4d82739dd229d539$var$eh(e), d = d(e), b.flags |= 1, $4d82739dd229d539$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $4d82739dd229d539$var$Ci(d, b.pendingProps), e = $4d82739dd229d539$var$Ci(d.type, e), $4d82739dd229d539$var$$i(a, b, d, e, c);
        case 15:
            return $4d82739dd229d539$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$ij(a, b), b.tag = 1, $4d82739dd229d539$var$Zf(d) ? (a = !0, $4d82739dd229d539$var$cg(b)) : a = !1, $4d82739dd229d539$var$ch(b, c), $4d82739dd229d539$var$Gi(b, d, e), $4d82739dd229d539$var$Ii(b, d, e, c), $4d82739dd229d539$var$jj(null, b, d, !0, a, c);
        case 19:
            return $4d82739dd229d539$var$xj(a, b, c);
        case 22:
            return $4d82739dd229d539$var$dj(a, b, c);
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
};
function $4d82739dd229d539$var$Fk(a, b) {
    return $4d82739dd229d539$var$ac(a, b);
}
function $4d82739dd229d539$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $4d82739dd229d539$var$Bg(a, b, c, d) {
    return new $4d82739dd229d539$var$$k(a, b, c, d);
}
function $4d82739dd229d539$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $4d82739dd229d539$var$Zk(a) {
    if ("function" === typeof a) return $4d82739dd229d539$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $4d82739dd229d539$var$Da) return 11;
        if (a === $4d82739dd229d539$var$Ga) return 14;
    }
    return 2;
}
function $4d82739dd229d539$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $4d82739dd229d539$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $4d82739dd229d539$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $4d82739dd229d539$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $4d82739dd229d539$var$ya:
            return $4d82739dd229d539$var$Tg(c.children, e, f, b);
        case $4d82739dd229d539$var$za:
            g = 8;
            e |= 8;
            break;
        case $4d82739dd229d539$var$Aa:
            return a = $4d82739dd229d539$var$Bg(12, c, b, e | 2), a.elementType = $4d82739dd229d539$var$Aa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ea:
            return a = $4d82739dd229d539$var$Bg(13, c, b, e), a.elementType = $4d82739dd229d539$var$Ea, a.lanes = f, a;
        case $4d82739dd229d539$var$Fa:
            return a = $4d82739dd229d539$var$Bg(19, c, b, e), a.elementType = $4d82739dd229d539$var$Fa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ia:
            return $4d82739dd229d539$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $4d82739dd229d539$var$Ba:
                    g = 10;
                    break a;
                case $4d82739dd229d539$var$Ca:
                    g = 9;
                    break a;
                case $4d82739dd229d539$var$Da:
                    g = 11;
                    break a;
                case $4d82739dd229d539$var$Ga:
                    g = 14;
                    break a;
                case $4d82739dd229d539$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($4d82739dd229d539$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $4d82739dd229d539$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $4d82739dd229d539$var$Tg(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$pj(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(22, a, d, b);
    a.elementType = $4d82739dd229d539$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $4d82739dd229d539$var$Qg(a, b, c) {
    a = $4d82739dd229d539$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$Sg(a, b, c) {
    b = $4d82739dd229d539$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $4d82739dd229d539$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $4d82739dd229d539$var$zc(0);
    this.expirationTimes = $4d82739dd229d539$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $4d82739dd229d539$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $4d82739dd229d539$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $4d82739dd229d539$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $4d82739dd229d539$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $4d82739dd229d539$var$kh(f);
    return a;
}
function $4d82739dd229d539$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4d82739dd229d539$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $4d82739dd229d539$var$dl(a) {
    if (!a) return $4d82739dd229d539$var$Vf;
    a = a._reactInternals;
    a: {
        if ($4d82739dd229d539$var$Vb(a) !== a || 1 !== a.tag) throw Error($4d82739dd229d539$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($4d82739dd229d539$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($4d82739dd229d539$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($4d82739dd229d539$var$Zf(c)) return $4d82739dd229d539$var$bg(a, c, b);
    }
    return b;
}
function $4d82739dd229d539$var$el(a, b, c, d, e, f, g, h, k) {
    a = $4d82739dd229d539$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $4d82739dd229d539$var$dl(null);
    c = a.current;
    d = $4d82739dd229d539$var$R();
    e = $4d82739dd229d539$var$yi(c);
    f = $4d82739dd229d539$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $4d82739dd229d539$var$nh(c, f, e);
    a.current.lanes = e;
    $4d82739dd229d539$var$Ac(a, e, d);
    $4d82739dd229d539$var$Dk(a, d);
    return a;
}
function $4d82739dd229d539$var$fl(a, b, c, d) {
    var e = b.current, f = $4d82739dd229d539$var$R(), g = $4d82739dd229d539$var$yi(e);
    c = $4d82739dd229d539$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $4d82739dd229d539$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $4d82739dd229d539$var$nh(e, b, g);
    null !== a && ($4d82739dd229d539$var$gi(a, e, g, f), $4d82739dd229d539$var$oh(a, e, g));
    return g;
}
function $4d82739dd229d539$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $4d82739dd229d539$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $4d82739dd229d539$var$il(a, b) {
    $4d82739dd229d539$var$hl(a, b);
    (a = a.alternate) && $4d82739dd229d539$var$hl(a, b);
}
function $4d82739dd229d539$var$jl() {
    return null;
}
var $4d82739dd229d539$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $4d82739dd229d539$var$ll(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$ml.prototype.render = $4d82739dd229d539$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($4d82739dd229d539$var$p(409));
    $4d82739dd229d539$var$fl(a, b, null, null);
};
$4d82739dd229d539$var$ml.prototype.unmount = $4d82739dd229d539$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $4d82739dd229d539$var$Rk(function() {
            $4d82739dd229d539$var$fl(null, a, null, null);
        });
        b[$4d82739dd229d539$var$uf] = null;
    }
};
function $4d82739dd229d539$var$ml(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $4d82739dd229d539$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $4d82739dd229d539$var$Qc.length && 0 !== b && b < $4d82739dd229d539$var$Qc[c].priority; c++);
        $4d82739dd229d539$var$Qc.splice(c, 0, a);
        0 === c && $4d82739dd229d539$var$Vc(a);
    }
};
function $4d82739dd229d539$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $4d82739dd229d539$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $4d82739dd229d539$var$pl() {}
function $4d82739dd229d539$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $4d82739dd229d539$var$gl(g);
                f.call(a);
            };
        }
        var g = $4d82739dd229d539$var$el(b, d, a, 0, null, !1, !1, "", $4d82739dd229d539$var$pl);
        a._reactRootContainer = g;
        a[$4d82739dd229d539$var$uf] = g.current;
        $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
        $4d82739dd229d539$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $4d82739dd229d539$var$gl(k);
            h.call(a);
        };
    }
    var k = $4d82739dd229d539$var$bl(a, 0, !1, null, null, !1, !1, "", $4d82739dd229d539$var$pl);
    a._reactRootContainer = k;
    a[$4d82739dd229d539$var$uf] = k.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    $4d82739dd229d539$var$Rk(function() {
        $4d82739dd229d539$var$fl(b, k, c, d);
    });
    return k;
}
function $4d82739dd229d539$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $4d82739dd229d539$var$gl(g);
                h.call(a);
            };
        }
        $4d82739dd229d539$var$fl(b, g, a, e);
    } else g = $4d82739dd229d539$var$ql(c, b, a, e, d);
    return $4d82739dd229d539$var$gl(g);
}
$4d82739dd229d539$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $4d82739dd229d539$var$tc(b.pendingLanes);
                0 !== c && ($4d82739dd229d539$var$Cc(b, c | 1), $4d82739dd229d539$var$Dk(b, $4d82739dd229d539$var$B()), 0 === ($4d82739dd229d539$var$K & 6) && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$jg()));
            }
            break;
        case 13:
            $4d82739dd229d539$var$Rk(function() {
                var b = $4d82739dd229d539$var$ih(a, 1);
                if (null !== b) {
                    var c = $4d82739dd229d539$var$R();
                    $4d82739dd229d539$var$gi(b, a, 1, c);
                }
            }), $4d82739dd229d539$var$il(a, 1);
    }
};
$4d82739dd229d539$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$ih(a, 134217728);
        if (null !== b) {
            var c = $4d82739dd229d539$var$R();
            $4d82739dd229d539$var$gi(b, a, 134217728, c);
        }
        $4d82739dd229d539$var$il(a, 134217728);
    }
};
$4d82739dd229d539$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$yi(a), c = $4d82739dd229d539$var$ih(a, b);
        if (null !== c) {
            var d = $4d82739dd229d539$var$R();
            $4d82739dd229d539$var$gi(c, a, b, d);
        }
        $4d82739dd229d539$var$il(a, b);
    }
};
$4d82739dd229d539$var$Hc = function() {
    return $4d82739dd229d539$var$C;
};
$4d82739dd229d539$var$Ic = function(a, b) {
    var c = $4d82739dd229d539$var$C;
    try {
        return $4d82739dd229d539$var$C = a, b();
    } finally{
        $4d82739dd229d539$var$C = c;
    }
};
$4d82739dd229d539$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $4d82739dd229d539$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $4d82739dd229d539$var$Db(d);
                        if (!e) throw Error($4d82739dd229d539$var$p(90));
                        $4d82739dd229d539$var$Wa(d);
                        $4d82739dd229d539$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $4d82739dd229d539$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $4d82739dd229d539$var$fb(a, !!c.multiple, b, !1);
    }
};
$4d82739dd229d539$var$Gb = $4d82739dd229d539$var$Qk;
$4d82739dd229d539$var$Hb = $4d82739dd229d539$var$Rk;
var $4d82739dd229d539$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $4d82739dd229d539$var$Cb,
        $4d82739dd229d539$var$ue,
        $4d82739dd229d539$var$Db,
        $4d82739dd229d539$var$Eb,
        $4d82739dd229d539$var$Fb,
        $4d82739dd229d539$var$Qk
    ]
}, $4d82739dd229d539$var$tl = {
    findFiberByHostInstance: $4d82739dd229d539$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $4d82739dd229d539$var$ul = {
    bundleType: $4d82739dd229d539$var$tl.bundleType,
    version: $4d82739dd229d539$var$tl.version,
    rendererPackageName: $4d82739dd229d539$var$tl.rendererPackageName,
    rendererConfig: $4d82739dd229d539$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $4d82739dd229d539$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $4d82739dd229d539$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $4d82739dd229d539$var$tl.findFiberByHostInstance || $4d82739dd229d539$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $4d82739dd229d539$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$4d82739dd229d539$var$vl.isDisabled && $4d82739dd229d539$var$vl.supportsFiber) try {
        $4d82739dd229d539$var$kc = $4d82739dd229d539$var$vl.inject($4d82739dd229d539$var$ul), $4d82739dd229d539$var$lc = $4d82739dd229d539$var$vl;
    } catch (a) {}
}
$4d82739dd229d539$export$ae55be85d98224ed = $4d82739dd229d539$var$sl;
$4d82739dd229d539$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$4d82739dd229d539$var$nl(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$cl(a, b, null, c);
};
$4d82739dd229d539$export$882461b6382ed46c = function(a, b) {
    if (!$4d82739dd229d539$var$nl(a)) throw Error($4d82739dd229d539$var$p(299));
    var c = !1, d = "", e = $4d82739dd229d539$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $4d82739dd229d539$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $4d82739dd229d539$var$ll(b);
};
$4d82739dd229d539$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($4d82739dd229d539$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($4d82739dd229d539$var$p(268, a));
    }
    a = $4d82739dd229d539$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$4d82739dd229d539$export$cd75ccfd720a3cd4 = function(a) {
    return $4d82739dd229d539$var$Rk(a);
};
$4d82739dd229d539$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$4d82739dd229d539$var$ol(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$rl(null, a, b, !0, c);
};
$4d82739dd229d539$export$757ceba2d55c277e = function(a, b, c) {
    if (!$4d82739dd229d539$var$nl(a)) throw Error($4d82739dd229d539$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $4d82739dd229d539$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $4d82739dd229d539$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $4d82739dd229d539$var$ml(b);
};
$4d82739dd229d539$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$4d82739dd229d539$var$ol(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$rl(null, a, b, !1, c);
};
$4d82739dd229d539$export$502457920280e6be = function(a) {
    if (!$4d82739dd229d539$var$ol(a)) throw Error($4d82739dd229d539$var$p(40));
    return a._reactRootContainer ? ($4d82739dd229d539$var$Rk(function() {
        $4d82739dd229d539$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$4d82739dd229d539$var$uf] = null;
        });
    }), !0) : !1;
};
$4d82739dd229d539$export$c78a37762a8d58e1 = $4d82739dd229d539$var$Qk;
$4d82739dd229d539$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$4d82739dd229d539$var$ol(c)) throw Error($4d82739dd229d539$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($4d82739dd229d539$var$p(38));
    return $4d82739dd229d539$var$rl(a, b, c, !1, d);
};
$4d82739dd229d539$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("33s19", function(module, exports) {
'use strict';

module.exports = (parcelRequire("a0C75"));

});
parcelRegister("a0C75", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $749777fefd570b40$export$c4744153514ff05d; }, function (v) { return $749777fefd570b40$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $749777fefd570b40$export$3e506c1ccc9cc1a7; }, function (v) { return $749777fefd570b40$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $749777fefd570b40$export$e26fe2ed2fa76875; }, function (v) { return $749777fefd570b40$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $749777fefd570b40$export$502329bbf4b505b1; }, function (v) { return $749777fefd570b40$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $749777fefd570b40$export$6e3807111c4874c4; }, function (v) { return $749777fefd570b40$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $749777fefd570b40$export$c27134553091fb3a; }, function (v) { return $749777fefd570b40$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $749777fefd570b40$export$33ee1acdc04fd2a2; }, function (v) { return $749777fefd570b40$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $749777fefd570b40$export$b00a404bbd5edef2; }, function (v) { return $749777fefd570b40$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $749777fefd570b40$export$8352ce38b91d0c62; }, function (v) { return $749777fefd570b40$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $749777fefd570b40$export$d66a1c1c77bd778b; }, function (v) { return $749777fefd570b40$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $749777fefd570b40$export$d3dfb8e4810cb555; }, function (v) { return $749777fefd570b40$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $749777fefd570b40$export$839f9183b0465a69; }, function (v) { return $749777fefd570b40$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $749777fefd570b40$export$72fdf0e06517287b; }, function (v) { return $749777fefd570b40$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $749777fefd570b40$export$4b844e58a3e414b4; }, function (v) { return $749777fefd570b40$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $749777fefd570b40$export$816d2913ae6b83b1; }, function (v) { return $749777fefd570b40$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $749777fefd570b40$export$61bcfe829111a1d0; }, function (v) { return $749777fefd570b40$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $749777fefd570b40$export$7ee8c9beb337bc3f; }, function (v) { return $749777fefd570b40$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $749777fefd570b40$export$b5836b71941fa3ed; }, function (v) { return $749777fefd570b40$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $749777fefd570b40$export$cf845f2c119da08a; }, function (v) { return $749777fefd570b40$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $749777fefd570b40$export$c4744153514ff05d;
var $749777fefd570b40$export$3e506c1ccc9cc1a7;
var $749777fefd570b40$export$e26fe2ed2fa76875;
var $749777fefd570b40$export$502329bbf4b505b1;
var $749777fefd570b40$export$6e3807111c4874c4;
var $749777fefd570b40$export$c27134553091fb3a;
var $749777fefd570b40$export$33ee1acdc04fd2a2;
var $749777fefd570b40$export$b00a404bbd5edef2;
var $749777fefd570b40$export$8352ce38b91d0c62;
var $749777fefd570b40$export$d66a1c1c77bd778b;
var $749777fefd570b40$export$d3dfb8e4810cb555;
var $749777fefd570b40$export$839f9183b0465a69;
var $749777fefd570b40$export$72fdf0e06517287b;
var $749777fefd570b40$export$4b844e58a3e414b4;
var $749777fefd570b40$export$816d2913ae6b83b1;
var $749777fefd570b40$export$61bcfe829111a1d0;
var $749777fefd570b40$export$7ee8c9beb337bc3f;
var $749777fefd570b40$export$b5836b71941fa3ed;
var $749777fefd570b40$export$cf845f2c119da08a;
'use strict';
function $749777fefd570b40$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $749777fefd570b40$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $749777fefd570b40$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $749777fefd570b40$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $749777fefd570b40$var$g(C, c)) n < e && 0 > $749777fefd570b40$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $749777fefd570b40$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $749777fefd570b40$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $749777fefd570b40$var$l = performance;
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$l.now();
    };
} else {
    var $749777fefd570b40$var$p = Date, $749777fefd570b40$var$q = $749777fefd570b40$var$p.now();
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$p.now() - $749777fefd570b40$var$q;
    };
}
var $749777fefd570b40$var$r = [], $749777fefd570b40$var$t = [], $749777fefd570b40$var$u = 1, $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = 3, $749777fefd570b40$var$z = !1, $749777fefd570b40$var$A = !1, $749777fefd570b40$var$B = !1, $749777fefd570b40$var$D = "function" === typeof setTimeout ? setTimeout : null, $749777fefd570b40$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $749777fefd570b40$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $749777fefd570b40$var$G(a) {
    for(var b = $749777fefd570b40$var$h($749777fefd570b40$var$t); null !== b;){
        if (null === b.callback) $749777fefd570b40$var$k($749777fefd570b40$var$t);
        else if (b.startTime <= a) $749777fefd570b40$var$k($749777fefd570b40$var$t), b.sortIndex = b.expirationTime, $749777fefd570b40$var$f($749777fefd570b40$var$r, b);
        else break;
        b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
    }
}
function $749777fefd570b40$var$H(a) {
    $749777fefd570b40$var$B = !1;
    $749777fefd570b40$var$G(a);
    if (!$749777fefd570b40$var$A) {
        if (null !== $749777fefd570b40$var$h($749777fefd570b40$var$r)) $749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J);
        else {
            var b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== b && $749777fefd570b40$var$K($749777fefd570b40$var$H, b.startTime - a);
        }
    }
}
function $749777fefd570b40$var$J(a, b) {
    $749777fefd570b40$var$A = !1;
    $749777fefd570b40$var$B && ($749777fefd570b40$var$B = !1, $749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1);
    $749777fefd570b40$var$z = !0;
    var c = $749777fefd570b40$var$y;
    try {
        $749777fefd570b40$var$G(b);
        for($749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r); null !== $749777fefd570b40$var$v && (!($749777fefd570b40$var$v.expirationTime > b) || a && !$749777fefd570b40$var$M());){
            var d = $749777fefd570b40$var$v.callback;
            if ("function" === typeof d) {
                $749777fefd570b40$var$v.callback = null;
                $749777fefd570b40$var$y = $749777fefd570b40$var$v.priorityLevel;
                var e = d($749777fefd570b40$var$v.expirationTime <= b);
                b = $749777fefd570b40$export$c4744153514ff05d();
                "function" === typeof e ? $749777fefd570b40$var$v.callback = e : $749777fefd570b40$var$v === $749777fefd570b40$var$h($749777fefd570b40$var$r) && $749777fefd570b40$var$k($749777fefd570b40$var$r);
                $749777fefd570b40$var$G(b);
            } else $749777fefd570b40$var$k($749777fefd570b40$var$r);
            $749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r);
        }
        if (null !== $749777fefd570b40$var$v) var w = !0;
        else {
            var m = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== m && $749777fefd570b40$var$K($749777fefd570b40$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = c, $749777fefd570b40$var$z = !1;
    }
}
var $749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null, $749777fefd570b40$var$L = -1, $749777fefd570b40$var$P = 5, $749777fefd570b40$var$Q = -1;
function $749777fefd570b40$var$M() {
    return $749777fefd570b40$export$c4744153514ff05d() - $749777fefd570b40$var$Q < $749777fefd570b40$var$P ? !1 : !0;
}
function $749777fefd570b40$var$R() {
    if (null !== $749777fefd570b40$var$O) {
        var a = $749777fefd570b40$export$c4744153514ff05d();
        $749777fefd570b40$var$Q = a;
        var b = !0;
        try {
            b = $749777fefd570b40$var$O(!0, a);
        } finally{
            b ? $749777fefd570b40$var$S() : ($749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null);
        }
    } else $749777fefd570b40$var$N = !1;
}
var $749777fefd570b40$var$S;
if ("function" === typeof $749777fefd570b40$var$F) $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$F($749777fefd570b40$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $749777fefd570b40$var$T = new MessageChannel, $749777fefd570b40$var$U = $749777fefd570b40$var$T.port2;
    $749777fefd570b40$var$T.port1.onmessage = $749777fefd570b40$var$R;
    $749777fefd570b40$var$S = function() {
        $749777fefd570b40$var$U.postMessage(null);
    };
} else $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$D($749777fefd570b40$var$R, 0);
};
function $749777fefd570b40$var$I(a) {
    $749777fefd570b40$var$O = a;
    $749777fefd570b40$var$N || ($749777fefd570b40$var$N = !0, $749777fefd570b40$var$S());
}
function $749777fefd570b40$var$K(a, b) {
    $749777fefd570b40$var$L = $749777fefd570b40$var$D(function() {
        a($749777fefd570b40$export$c4744153514ff05d());
    }, b);
}
$749777fefd570b40$export$3e506c1ccc9cc1a7 = 5;
$749777fefd570b40$export$e26fe2ed2fa76875 = 1;
$749777fefd570b40$export$502329bbf4b505b1 = 4;
$749777fefd570b40$export$6e3807111c4874c4 = 3;
$749777fefd570b40$export$c27134553091fb3a = null;
$749777fefd570b40$export$33ee1acdc04fd2a2 = 2;
$749777fefd570b40$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$749777fefd570b40$export$8352ce38b91d0c62 = function() {
    $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J));
};
$749777fefd570b40$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $749777fefd570b40$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$749777fefd570b40$export$d3dfb8e4810cb555 = function() {
    return $749777fefd570b40$var$y;
};
$749777fefd570b40$export$839f9183b0465a69 = function() {
    return $749777fefd570b40$var$h($749777fefd570b40$var$r);
};
$749777fefd570b40$export$72fdf0e06517287b = function(a) {
    switch($749777fefd570b40$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $749777fefd570b40$var$y;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = b;
    try {
        return a();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$4b844e58a3e414b4 = function() {};
$749777fefd570b40$export$816d2913ae6b83b1 = function() {};
$749777fefd570b40$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = a;
    try {
        return b();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $749777fefd570b40$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $749777fefd570b40$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $749777fefd570b40$var$f($749777fefd570b40$var$t, a), null === $749777fefd570b40$var$h($749777fefd570b40$var$r) && a === $749777fefd570b40$var$h($749777fefd570b40$var$t) && ($749777fefd570b40$var$B ? ($749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1) : $749777fefd570b40$var$B = !0, $749777fefd570b40$var$K($749777fefd570b40$var$H, c - d))) : (a.sortIndex = e, $749777fefd570b40$var$f($749777fefd570b40$var$r, a), $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J)));
    return a;
};
$749777fefd570b40$export$b5836b71941fa3ed = $749777fefd570b40$var$M;
$749777fefd570b40$export$cf845f2c119da08a = function(a) {
    var b = $749777fefd570b40$var$y;
    return function() {
        var c = $749777fefd570b40$var$y;
        $749777fefd570b40$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $749777fefd570b40$var$y = c;
        }
    };
};

});




parcelRegister("CVsbx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07501dd010058a02$export$2e2bcd8739ae039; });
function $07501dd010058a02$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $07501dd010058a02$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $07501dd010058a02$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $07501dd010058a02$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $07501dd010058a02$export$2e2bcd8739ae039 = $07501dd010058a02$export$4f5d2d50c9deca37;

});

parcelRegister("5PDlY", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $43f03df0ac8edf90$export$dbf350e5966cf602; });
let $43f03df0ac8edf90$var$e = {
    data: ""
}, $43f03df0ac8edf90$var$t = (t)=>{
    if ("object" == typeof window) {
        let e = (t ? t.querySelector("#_goober") : window._goober) || Object.assign(document.createElement("style"), {
            innerHTML: " ",
            id: "_goober"
        });
        return e.nonce = window.__nonce__, e.parentNode || (t || document.head).appendChild(e), e.firstChild;
    }
    return t || $43f03df0ac8edf90$var$e;
}, $43f03df0ac8edf90$export$54aba348a7896325 = (e)=>{
    let r = $43f03df0ac8edf90$var$t(e), a = r.data;
    return r.data = "", a;
}, $43f03df0ac8edf90$var$a = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $43f03df0ac8edf90$var$l = /\/\*[^]*?\*\/|  +/g, $43f03df0ac8edf90$var$n = /\n+/g, $43f03df0ac8edf90$var$o = (e, t)=>{
    let r = "", a = "", l = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : a += "f" == n[1] ? $43f03df0ac8edf90$var$o(c, n) : n + "{" + $43f03df0ac8edf90$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? a += $43f03df0ac8edf90$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = "-" == n[1] ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), l += $43f03df0ac8edf90$var$o.p ? $43f03df0ac8edf90$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && l ? t + "{" + l + "}" : l) + a;
}, $43f03df0ac8edf90$var$c = {}, $43f03df0ac8edf90$var$i = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $43f03df0ac8edf90$var$i(e[r]);
        return t;
    }
    return e;
}, $43f03df0ac8edf90$var$s = (e, t, r, s, p)=>{
    let u = $43f03df0ac8edf90$var$i(e), d = $43f03df0ac8edf90$var$c[u] || ($43f03df0ac8edf90$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$43f03df0ac8edf90$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $43f03df0ac8edf90$var$a.exec(e.replace($43f03df0ac8edf90$var$l, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($43f03df0ac8edf90$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($43f03df0ac8edf90$var$n, " ").trim();
            return o[0];
        })(e);
        $43f03df0ac8edf90$var$c[d] = $43f03df0ac8edf90$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $43f03df0ac8edf90$var$c.g;
    return r && ($43f03df0ac8edf90$var$c.g = $43f03df0ac8edf90$var$c[d]), ((e, t, r, a)=>{
        a ? t.data = t.data.replace(a, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($43f03df0ac8edf90$var$c[d], t, s, f), d;
}, $43f03df0ac8edf90$var$p = (e, t, r)=>e.reduce((e, a, l)=>{
        let n = t[l];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $43f03df0ac8edf90$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + a + (null == n ? "" : n);
    }, "");
function $43f03df0ac8edf90$export$dbf350e5966cf602(e) {
    let r = this || {}, a = e.call ? e(r.p) : e;
    return $43f03df0ac8edf90$var$s(a.unshift ? a.raw ? $43f03df0ac8edf90$var$p(a, [].slice.call(arguments, 1), r.p) : a.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : a, $43f03df0ac8edf90$var$t(r.target), r.g, r.o, r.k);
}
let $43f03df0ac8edf90$var$d, $43f03df0ac8edf90$var$f, $43f03df0ac8edf90$var$g, $43f03df0ac8edf90$export$442f1a04865e4790 = $43f03df0ac8edf90$export$dbf350e5966cf602.bind({
    g: 1
}), $43f03df0ac8edf90$export$d25ddfdf17c3ad3e = $43f03df0ac8edf90$export$dbf350e5966cf602.bind({
    k: 1
});
function $43f03df0ac8edf90$export$de27182ff8187d6c(e, t, r, a) {
    $43f03df0ac8edf90$var$o.p = t, $43f03df0ac8edf90$var$d = e, $43f03df0ac8edf90$var$f = r, $43f03df0ac8edf90$var$g = a;
}
function $43f03df0ac8edf90$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let a = arguments;
        function l(n, o) {
            let c = Object.assign({}, n), i = c.className || l.className;
            r.p = Object.assign({
                theme: $43f03df0ac8edf90$var$f && $43f03df0ac8edf90$var$f()
            }, c), r.o = /go\d/.test(i), c.className = $43f03df0ac8edf90$export$dbf350e5966cf602.apply(r, a) + (i ? " " + i : ""), t && (c.ref = o);
            let s = e;
            return e[0] && (s = c.as || e, delete c.as), $43f03df0ac8edf90$var$g && s[0] && $43f03df0ac8edf90$var$g(c), $43f03df0ac8edf90$var$d(s, c);
        }
        return t ? t(l) : l;
    };
}

});


parcelRegister("kRISp", function(module, exports) {

$parcel$export(module.exports, "shallowEqual", function () { return $f30b917334351296$export$d36bdfa510afb180; });
$parcel$export(module.exports, "connect", function () { return $f30b917334351296$export$64605811ab45167f; });
$parcel$export(module.exports, "Provider", function () { return $f30b917334351296$export$2881499e37b75b9a; });
$parcel$export(module.exports, "useDispatch", function () { return $f30b917334351296$export$8ad76b76a4c905f8; });
$parcel$export(module.exports, "useSelector", function () { return $f30b917334351296$export$2105062e25df4afe; });

var $7fPBF = parcelRequire("7fPBF");

var $gDt46 = parcelRequire("gDt46");
var $f30b917334351296$var$__defProp = Object.defineProperty;
var $f30b917334351296$var$__defProps = Object.defineProperties;
var $f30b917334351296$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $f30b917334351296$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $f30b917334351296$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f30b917334351296$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $f30b917334351296$var$__defNormalProp = (obj, key, value)=>key in obj ? $f30b917334351296$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $f30b917334351296$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($f30b917334351296$var$__hasOwnProp.call(b, prop)) $f30b917334351296$var$__defNormalProp(a, prop, b[prop]);
    if ($f30b917334351296$var$__getOwnPropSymbols) {
        for (var prop of $f30b917334351296$var$__getOwnPropSymbols(b))if ($f30b917334351296$var$__propIsEnum.call(b, prop)) $f30b917334351296$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $f30b917334351296$var$__spreadProps = (a, b)=>$f30b917334351296$var$__defProps(a, $f30b917334351296$var$__getOwnPropDescs(b));
var $f30b917334351296$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($f30b917334351296$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $f30b917334351296$var$__getOwnPropSymbols) {
        for (var prop of $f30b917334351296$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $f30b917334351296$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $f30b917334351296$var$IS_REACT_19 = /* @__PURE__ */ $7fPBF.version.startsWith("19");
var $f30b917334351296$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($f30b917334351296$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $f30b917334351296$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $f30b917334351296$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $f30b917334351296$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $f30b917334351296$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $f30b917334351296$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $f30b917334351296$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $f30b917334351296$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $f30b917334351296$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $f30b917334351296$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $f30b917334351296$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $f30b917334351296$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $f30b917334351296$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $f30b917334351296$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $f30b917334351296$var$ForwardRef = $f30b917334351296$var$REACT_FORWARD_REF_TYPE;
var $f30b917334351296$var$Memo = $f30b917334351296$var$REACT_MEMO_TYPE;
function $f30b917334351296$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $f30b917334351296$var$REACT_FRAGMENT_TYPE || type === $f30b917334351296$var$REACT_PROFILER_TYPE || type === $f30b917334351296$var$REACT_STRICT_MODE_TYPE || type === $f30b917334351296$var$REACT_SUSPENSE_TYPE || type === $f30b917334351296$var$REACT_SUSPENSE_LIST_TYPE || type === $f30b917334351296$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $f30b917334351296$var$REACT_LAZY_TYPE || type.$$typeof === $f30b917334351296$var$REACT_MEMO_TYPE || type.$$typeof === $f30b917334351296$var$REACT_CONTEXT_TYPE || type.$$typeof === $f30b917334351296$var$REACT_CONSUMER_TYPE || type.$$typeof === $f30b917334351296$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $f30b917334351296$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $f30b917334351296$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $f30b917334351296$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $f30b917334351296$var$REACT_FRAGMENT_TYPE:
                    case $f30b917334351296$var$REACT_PROFILER_TYPE:
                    case $f30b917334351296$var$REACT_STRICT_MODE_TYPE:
                    case $f30b917334351296$var$REACT_SUSPENSE_TYPE:
                    case $f30b917334351296$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $f30b917334351296$var$REACT_CONTEXT_TYPE:
                            case $f30b917334351296$var$REACT_FORWARD_REF_TYPE:
                            case $f30b917334351296$var$REACT_LAZY_TYPE:
                            case $f30b917334351296$var$REACT_MEMO_TYPE:
                                return object;
                            case $f30b917334351296$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $f30b917334351296$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $f30b917334351296$var$isContextConsumer(object) {
    return $f30b917334351296$var$IS_REACT_19 ? $f30b917334351296$var$typeOf(object) === $f30b917334351296$var$REACT_CONSUMER_TYPE : $f30b917334351296$var$typeOf(object) === $f30b917334351296$var$REACT_CONTEXT_TYPE;
}
function $f30b917334351296$var$isMemo(object) {
    return $f30b917334351296$var$typeOf(object) === $f30b917334351296$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $f30b917334351296$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $f30b917334351296$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $f30b917334351296$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $f30b917334351296$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $f30b917334351296$var$verify(mapStateToProps, "mapStateToProps");
    $f30b917334351296$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $f30b917334351296$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $f30b917334351296$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $f30b917334351296$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $f30b917334351296$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $f30b917334351296$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $f30b917334351296$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $f30b917334351296$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $f30b917334351296$var$verifyPlainObject(value, displayName, methodName) {
    if (!$f30b917334351296$var$isPlainObject(value)) $f30b917334351296$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $f30b917334351296$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $f30b917334351296$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $f30b917334351296$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $f30b917334351296$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $f30b917334351296$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $f30b917334351296$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $f30b917334351296$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $f30b917334351296$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $f30b917334351296$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $f30b917334351296$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $f30b917334351296$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $f30b917334351296$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $f30b917334351296$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $f30b917334351296$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $f30b917334351296$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $f30b917334351296$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $f30b917334351296$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $f30b917334351296$var$__spreadValues($f30b917334351296$var$__spreadValues($f30b917334351296$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $f30b917334351296$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $f30b917334351296$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$f30b917334351296$var$defaultMergeProps : typeof mergeProps === "function" ? $f30b917334351296$var$wrapMergePropsFunc(mergeProps) : $f30b917334351296$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $f30b917334351296$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $f30b917334351296$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $f30b917334351296$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $f30b917334351296$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $f30b917334351296$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $f30b917334351296$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $f30b917334351296$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $f30b917334351296$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $f30b917334351296$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $f30b917334351296$var$isDOM = /* @__PURE__ */ $f30b917334351296$var$canUseDOM();
var $f30b917334351296$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $f30b917334351296$var$isReactNative = /* @__PURE__ */ $f30b917334351296$var$isRunningInReactNative();
var $f30b917334351296$var$getUseIsomorphicLayoutEffect = ()=>$f30b917334351296$var$isDOM || $f30b917334351296$var$isReactNative ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
var $f30b917334351296$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $f30b917334351296$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $f30b917334351296$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $f30b917334351296$export$d36bdfa510afb180(objA, objB) {
    if ($f30b917334351296$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$f30b917334351296$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $f30b917334351296$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $f30b917334351296$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $f30b917334351296$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $f30b917334351296$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $f30b917334351296$var$TYPE_STATICS = {
    [$f30b917334351296$var$ForwardRef]: $f30b917334351296$var$FORWARD_REF_STATICS,
    [$f30b917334351296$var$Memo]: $f30b917334351296$var$MEMO_STATICS
};
function $f30b917334351296$var$getStatics(component) {
    if ($f30b917334351296$var$isMemo(component)) return $f30b917334351296$var$MEMO_STATICS;
    return $f30b917334351296$var$TYPE_STATICS[component["$$typeof"]] || $f30b917334351296$var$REACT_STATICS;
}
var $f30b917334351296$var$defineProperty = Object.defineProperty;
var $f30b917334351296$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $f30b917334351296$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f30b917334351296$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $f30b917334351296$var$getPrototypeOf = Object.getPrototypeOf;
var $f30b917334351296$var$objectPrototype = Object.prototype;
function $f30b917334351296$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($f30b917334351296$var$objectPrototype) {
            const inheritedComponent = $f30b917334351296$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $f30b917334351296$var$objectPrototype) $f30b917334351296$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $f30b917334351296$var$getOwnPropertyNames(sourceComponent);
        if ($f30b917334351296$var$getOwnPropertySymbols) keys = keys.concat($f30b917334351296$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $f30b917334351296$var$getStatics(targetComponent);
        const sourceStatics = $f30b917334351296$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$f30b917334351296$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $f30b917334351296$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $f30b917334351296$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $f30b917334351296$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $f30b917334351296$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $f30b917334351296$var$getContext() {
    var _a;
    if (!$7fPBF.createContext) return {};
    const contextMap = (_a = $f30b917334351296$var$gT[$f30b917334351296$var$ContextKey]) != null ? _a : $f30b917334351296$var$gT[$f30b917334351296$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($7fPBF.createContext);
    if (!realContext) {
        realContext = $7fPBF.createContext(null);
        contextMap.set($7fPBF.createContext, realContext);
    }
    return realContext;
}
var $f30b917334351296$export$cc80c08dc91f1c00 = /* @__PURE__ */ $f30b917334351296$var$getContext();
// src/components/connect.tsx
var $f30b917334351296$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $f30b917334351296$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $f30b917334351296$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $f30b917334351296$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $f30b917334351296$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $f30b917334351296$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $f30b917334351296$var$strictEqual(a, b) {
    return a === b;
}
var $f30b917334351296$var$hasWarnedAboutDeprecatedPureOption = false;
function $f30b917334351296$var$_connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $f30b917334351296$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $f30b917334351296$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $f30b917334351296$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $f30b917334351296$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $f30b917334351296$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $f30b917334351296$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $f30b917334351296$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $f30b917334351296$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $7fPBF.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $f30b917334351296$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $7fPBF.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $7fPBF.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $7fPBF.useMemo(()=>{
                return $f30b917334351296$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $7fPBF.useMemo(()=>{
                if (!shouldHandleStateChanges) return $f30b917334351296$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $f30b917334351296$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $7fPBF.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $f30b917334351296$var$__spreadProps($f30b917334351296$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $7fPBF.useRef(void 0);
            const lastWrapperProps = $7fPBF.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $7fPBF.useRef(void 0);
            const renderIsScheduled = $7fPBF.useRef(false);
            const isMounted = $7fPBF.useRef(false);
            const latestSubscriptionCallbackError = $7fPBF.useRef(void 0);
            $f30b917334351296$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $7fPBF.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $7fPBF.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $f30b917334351296$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $f30b917334351296$var$useIsomorphicLayoutEffectWithArgs($f30b917334351296$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $7fPBF.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $f30b917334351296$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $7fPBF.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $7fPBF.createElement(WrappedComponent, $f30b917334351296$var$__spreadProps($f30b917334351296$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $7fPBF.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $7fPBF.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $7fPBF.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $7fPBF.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $7fPBF.createElement(Connect, $f30b917334351296$var$__spreadProps($f30b917334351296$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $f30b917334351296$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $f30b917334351296$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $f30b917334351296$export$64605811ab45167f = $f30b917334351296$var$_connect;
var $f30b917334351296$export$8807b5ba46f9d0b7 = $f30b917334351296$var$_connect;
// src/components/Provider.tsx
function $f30b917334351296$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $7fPBF.useMemo(()=>{
        const subscription = $f30b917334351296$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $7fPBF.useMemo(()=>store.getState(), [
        store
    ]);
    $f30b917334351296$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $f30b917334351296$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $7fPBF.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $f30b917334351296$export$2881499e37b75b9a = $f30b917334351296$var$Provider;
// src/hooks/useReduxContext.ts
function $f30b917334351296$var$createReduxContextHook(context = $f30b917334351296$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $7fPBF.useContext(context);
        return contextValue;
    };
}
var $f30b917334351296$var$useReduxContext = /* @__PURE__ */ $f30b917334351296$var$createReduxContextHook();
// src/hooks/useStore.ts
function $f30b917334351296$export$671dba69185d0304(context = $f30b917334351296$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $f30b917334351296$export$cc80c08dc91f1c00 ? $f30b917334351296$var$useReduxContext : // @ts-ignore
    $f30b917334351296$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $f30b917334351296$export$6ccbb43953eebf8 = /* @__PURE__ */ $f30b917334351296$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $f30b917334351296$export$bc9b55530897c558(context = $f30b917334351296$export$cc80c08dc91f1c00) {
    const useStore2 = context === $f30b917334351296$export$cc80c08dc91f1c00 ? $f30b917334351296$export$6ccbb43953eebf8 : $f30b917334351296$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $f30b917334351296$export$8ad76b76a4c905f8 = /* @__PURE__ */ $f30b917334351296$export$bc9b55530897c558();
var $f30b917334351296$var$refEquality = (a, b)=>a === b;
function $f30b917334351296$export$2b53f90d2bd1cbfb(context = $f30b917334351296$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $f30b917334351296$export$cc80c08dc91f1c00 ? $f30b917334351296$var$useReduxContext : $f30b917334351296$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $f30b917334351296$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $7fPBF.useRef(true);
        const wrappedSelector = $7fPBF.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $gDt46.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $7fPBF.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $f30b917334351296$export$2105062e25df4afe = /* @__PURE__ */ $f30b917334351296$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $f30b917334351296$export$712ea50be43a7858 = $f30b917334351296$var$defaultNoopBatch;

});
parcelRegister("gDt46", function(module, exports) {
'use strict';

module.exports = (parcelRequire("i5uoL"));

});
parcelRegister("i5uoL", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $d2b0461a7763531f$export$bf730a2d8bf68b42; }, function (v) { return $d2b0461a7763531f$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d2b0461a7763531f$export$bf730a2d8bf68b42;
"use strict";

var $7fPBF = parcelRequire("7fPBF");
function $d2b0461a7763531f$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $d2b0461a7763531f$var$objectIs = "function" === typeof Object.is ? Object.is : $d2b0461a7763531f$var$is, $d2b0461a7763531f$var$useSyncExternalStore = $7fPBF.useSyncExternalStore, $d2b0461a7763531f$var$useRef = $7fPBF.useRef, $d2b0461a7763531f$var$useEffect = $7fPBF.useEffect, $d2b0461a7763531f$var$useMemo = $7fPBF.useMemo, $d2b0461a7763531f$var$useDebugValue = $7fPBF.useDebugValue;
$d2b0461a7763531f$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $d2b0461a7763531f$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $d2b0461a7763531f$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($d2b0461a7763531f$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $d2b0461a7763531f$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $d2b0461a7763531f$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $d2b0461a7763531f$var$useDebugValue(value);
    return value;
};

});



parcelRegister("hDF5a", function(module, exports) {

$parcel$export(module.exports, "updateLangFromUser", function () { return $a23744eec8a25876$export$e653a6c8772357ba; });
$parcel$export(module.exports, "default", function () { return $a23744eec8a25876$export$2e2bcd8739ae039; });
// https://dev.to/adrai/how-to-properly-internationalize-a-react-application-using-i18next-3hdb#getting-started

var $2Bwgd = parcelRequire("2Bwgd");

var $le5Xr = parcelRequire("le5Xr");

var $lHdDM = parcelRequire("lHdDM");
parcelRequire("3GBGj");
var $NDJJg = parcelRequire("NDJJg");

var $cSUCP = parcelRequire("cSUCP");

var $1a3s7 = parcelRequire("1a3s7");

var $k1O7N = parcelRequire("k1O7N");
(0, $2Bwgd.default).use((0, $lHdDM.default)).use((0, $le5Xr.default)).use((0, $NDJJg.initReactI18next)).init({
    //debug: true, // Uncomment to troubleshoot
    returnNull: false,
    // ignoring localStorage and cookies for the detection order lets the user change languages
    // more easily (just switch in the browser and reload, instead of clearing all site data)
    detection: {
        order: [
            "queryString",
            "path",
            "navigator"
        ]
    },
    supportedLngs: (0, $k1O7N.i18nLangs),
    // "languageOnly" means use only the language part (first subtag) of the full language tag;
    // e.g., if the user's browser is set to 'es-MX', we just use 'es'
    load: "languageOnly",
    fallbackLng: (0, $k1O7N.i18nFallbacks),
    interpolation: {
        escapeValue: false
    }
}, $a23744eec8a25876$var$setDir // Callback after i18n has initialized
);
/** Sets the text direction ("ltr" or "rtl") based on the current language. */ function $a23744eec8a25876$var$setDir() {
    document.body.dir = (0, $2Bwgd.default).dir();
}
async function $a23744eec8a25876$export$e653a6c8772357ba() {
    const uiLang = (0, $1a3s7.getCurrentUser)()?.uiLang;
    let updated = false;
    if (uiLang && uiLang !== (0, $2Bwgd.default).resolvedLanguage) {
        await (0, $2Bwgd.default).changeLanguage(uiLang, $a23744eec8a25876$var$setDir);
        updated = true;
    }
    // Log the UI language even if not changed, because we don't log it on i18n
    // init or before login (to avoid having languages different from a user's
    // preference cluttering the analytics).
    (0, $cSUCP.uiLanguage)((0, $2Bwgd.default).resolvedLanguage ?? "").catch((err)=>console.warn("Failed to log UI language:", err));
    return updated;
}
var $a23744eec8a25876$export$2e2bcd8739ae039 = (0, $2Bwgd.default);

});
parcelRegister("2Bwgd", function(module, exports) {

$parcel$export(module.exports, "keyFromSelector", function () { return $1e580fbd50c9e2d3$export$ec2cccc18ab4c2ae; });
$parcel$export(module.exports, "default", function () { return $1e580fbd50c9e2d3$export$2e2bcd8739ae039; });
const $1e580fbd50c9e2d3$var$isString = (obj)=>typeof obj === 'string';
const $1e580fbd50c9e2d3$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $1e580fbd50c9e2d3$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $1e580fbd50c9e2d3$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $1e580fbd50c9e2d3$var$lastOfPathSeparatorRegExp = /###/g;
const $1e580fbd50c9e2d3$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($1e580fbd50c9e2d3$var$lastOfPathSeparatorRegExp, '.') : key;
const $1e580fbd50c9e2d3$var$canNotTraverseDeeper = (object)=>!object || $1e580fbd50c9e2d3$var$isString(object);
const $1e580fbd50c9e2d3$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$1e580fbd50c9e2d3$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($1e580fbd50c9e2d3$var$canNotTraverseDeeper(object)) return {};
        const key = $1e580fbd50c9e2d3$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($1e580fbd50c9e2d3$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $1e580fbd50c9e2d3$var$cleanKey(stack[stackIndex])
    };
};
const $1e580fbd50c9e2d3$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $1e580fbd50c9e2d3$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $1e580fbd50c9e2d3$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $1e580fbd50c9e2d3$var$getLastOfPath(object, p, Object);
        if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $1e580fbd50c9e2d3$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $1e580fbd50c9e2d3$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $1e580fbd50c9e2d3$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $1e580fbd50c9e2d3$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $1e580fbd50c9e2d3$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $1e580fbd50c9e2d3$var$getPath(data, key);
    if (value !== undefined) return value;
    return $1e580fbd50c9e2d3$var$getPath(defaultData, key);
};
const $1e580fbd50c9e2d3$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($1e580fbd50c9e2d3$var$isString(target[prop]) || target[prop] instanceof String || $1e580fbd50c9e2d3$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $1e580fbd50c9e2d3$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $1e580fbd50c9e2d3$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $1e580fbd50c9e2d3$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $1e580fbd50c9e2d3$var$escape = (data)=>{
    if ($1e580fbd50c9e2d3$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$1e580fbd50c9e2d3$var$_entityMap[s]);
    return data;
};
class $1e580fbd50c9e2d3$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $1e580fbd50c9e2d3$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $1e580fbd50c9e2d3$var$looksLikeObjectPathRegExpCache = new $1e580fbd50c9e2d3$var$RegExpCache(20);
const $1e580fbd50c9e2d3$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $1e580fbd50c9e2d3$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $1e580fbd50c9e2d3$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $1e580fbd50c9e2d3$var$deepFind = (obj, path, keySeparator = '.')=>{
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $1e580fbd50c9e2d3$var$getCleanedCode = (code)=>code?.replace(/_/g, '-');
const $1e580fbd50c9e2d3$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        console?.[type]?.apply?.(console, args);
    }
};
class $1e580fbd50c9e2d3$var$Logger {
    constructor(concreteLogger, options = {}){
        this.init(concreteLogger, options);
    }
    init(concreteLogger, options = {}) {
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $1e580fbd50c9e2d3$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log(...args) {
        return this.forward(args, 'log', '', true);
    }
    warn(...args) {
        return this.forward(args, 'warn', '', true);
    }
    error(...args) {
        return this.forward(args, 'error', '');
    }
    deprecate(...args) {
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($1e580fbd50c9e2d3$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $1e580fbd50c9e2d3$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $1e580fbd50c9e2d3$var$Logger(this.logger, options);
    }
}
var $1e580fbd50c9e2d3$var$baseLogger = new $1e580fbd50c9e2d3$var$Logger();
class $1e580fbd50c9e2d3$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event, ...args) {
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
class $1e580fbd50c9e2d3$var$ResourceStore extends $1e580fbd50c9e2d3$var$EventEmitter {
    constructor(data, options = {
        ns: [
            'translation'
        ],
        defaultNS: 'translation'
    }){
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key, options = {}) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($1e580fbd50c9e2d3$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $1e580fbd50c9e2d3$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$1e580fbd50c9e2d3$var$isString(key)) return result;
        return $1e580fbd50c9e2d3$var$deepFind(this.data?.[lng]?.[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value, options = {
        silent: false
    }) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $1e580fbd50c9e2d3$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources, options = {
        silent: false
    }) {
        for(const m in resources)if ($1e580fbd50c9e2d3$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite, options = {
        silent: false,
        skipCopy: false
    }) {
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $1e580fbd50c9e2d3$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $1e580fbd50c9e2d3$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $1e580fbd50c9e2d3$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $1e580fbd50c9e2d3$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            value = this.processors[processor]?.process(value, key, options, translator) ?? value;
        });
        return value;
    }
};
const $1e580fbd50c9e2d3$var$PATH_KEY = Symbol('i18next/PATH_KEY');
function $1e580fbd50c9e2d3$var$createProxy() {
    const state = [];
    const handler = Object.create(null);
    let proxy;
    handler.get = (target, key)=>{
        proxy?.revoke?.();
        if (key === $1e580fbd50c9e2d3$var$PATH_KEY) return state;
        state.push(key);
        proxy = Proxy.revocable(target, handler);
        return proxy.proxy;
    };
    return Proxy.revocable(Object.create(null), handler).proxy;
}
function $1e580fbd50c9e2d3$export$ec2cccc18ab4c2ae(selector, opts) {
    const { [$1e580fbd50c9e2d3$var$PATH_KEY]: path } = selector($1e580fbd50c9e2d3$var$createProxy());
    const keySeparator = opts?.keySeparator ?? '.';
    const nsSeparator = opts?.nsSeparator ?? ':';
    if (path.length > 1 && nsSeparator) {
        const ns = opts?.ns;
        const nsArray = Array.isArray(ns) ? ns : null;
        if (nsArray && nsArray.length > 1 && nsArray.slice(1).includes(path[0])) return `${path[0]}${nsSeparator}${path.slice(1).join(keySeparator)}`;
    }
    return path.join(keySeparator);
}
const $1e580fbd50c9e2d3$var$checkedLoadedFor = {};
const $1e580fbd50c9e2d3$var$shouldHandleAsObject = (res)=>!$1e580fbd50c9e2d3$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $1e580fbd50c9e2d3$var$Translator extends $1e580fbd50c9e2d3$var$EventEmitter {
    constructor(services, options = {}){
        super();
        $1e580fbd50c9e2d3$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key, o = {
        interpolation: {}
    }) {
        const opt = {
            ...o
        };
        if (key == null) return false;
        const resolved = this.resolve(key, opt);
        if (resolved?.res === undefined) return false;
        const isObject = $1e580fbd50c9e2d3$var$shouldHandleAsObject(resolved.res);
        if (opt.returnObjects === false && isObject) return false;
        return true;
    }
    extractFromKey(key, opt) {
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        let namespaces = opt.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !$1e580fbd50c9e2d3$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $1e580fbd50c9e2d3$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $1e580fbd50c9e2d3$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, o, lastKey) {
        let opt = typeof o === 'object' ? {
            ...o
        } : o;
        if (typeof opt !== 'object' && this.options.overloadTranslationOptionHandler) opt = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof opt === 'object') opt = {
            ...opt
        };
        if (!opt) opt = {};
        if (keys == null) return '';
        if (typeof keys === 'function') keys = $1e580fbd50c9e2d3$export$ec2cccc18ab4c2ae(keys, {
            ...this.options,
            ...opt
        });
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        keys = keys.map((k)=>typeof k === 'function' ? $1e580fbd50c9e2d3$export$ec2cccc18ab4c2ae(k, {
                ...this.options,
                ...opt
            }) : String(k));
        const returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], opt);
        const namespace = namespaces[namespaces.length - 1];
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const lng = opt.lng || this.language;
        const appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng?.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(opt)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(opt)
            };
            return key;
        }
        const resolved = this.resolve(keys, opt);
        let res = resolved?.res;
        const resUsedKey = resolved?.usedKey || key;
        const resExactUsedKey = resolved?.exactUsedKey || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = opt.count !== undefined && !$1e580fbd50c9e2d3$var$isString(opt.count);
        const hasDefaultValue = $1e580fbd50c9e2d3$var$Translator.hasDefaultValue(opt);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
        const defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
        const defaultValue = needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] || opt[`defaultValue${defaultValueSuffix}`] || opt[`defaultValue${defaultValueSuffixOrdinalFallback}`] || opt.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $1e580fbd50c9e2d3$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && noObject.indexOf(resType) < 0 && !($1e580fbd50c9e2d3$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!opt.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
                    ...opt,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(opt);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, {
                        ...opt,
                        defaultValue: $1e580fbd50c9e2d3$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    });
                    else copy[m] = this.translate(deepKey, {
                        ...opt,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $1e580fbd50c9e2d3$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, opt, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...opt,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
                else lngs.push(opt.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
                    else if (this.backendConnector?.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, opt);
                        if (needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, opt[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, opt, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}${nsSeparator}${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}${nsSeparator}${key}` : key, usedDefault ? res : undefined, opt);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(opt);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, opt, resolved, lastKey) {
        if (this.i18nFormat?.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...opt
        }, opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!opt.skipInterpolation) {
            if (opt.interpolation) this.interpolator.init({
                ...opt,
                interpolation: {
                    ...this.options.interpolation,
                    ...opt.interpolation
                }
            });
            const skipOnVariables = $1e580fbd50c9e2d3$var$isString(res) && (opt?.interpolation?.skipOnVariables !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = opt.replace && !$1e580fbd50c9e2d3$var$isString(opt.replace) ? opt.replace : opt;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) opt.nest = false;
            }
            if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
            if (opt.nest !== false) res = this.interpolator.nest(res, (...args)=>{
                if (lastKey?.[0] === args[0] && !opt.context) {
                    this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return this.translate(...args, key);
            }, opt);
            if (opt.interpolation) this.interpolator.reset();
        }
        const postProcess = opt.postProcess || this.options.postProcess;
        const postProcessorNames = $1e580fbd50c9e2d3$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && postProcessorNames?.length && opt.applyPostProcessor !== false) res = $1e580fbd50c9e2d3$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(opt)
            },
            ...opt
        } : opt, this);
        return res;
    }
    resolve(keys, opt = {}) {
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($1e580fbd50c9e2d3$var$isString(keys)) keys = [
            keys
        ];
        if (Array.isArray(keys)) keys = keys.map((k)=>typeof k === 'function' ? $1e580fbd50c9e2d3$export$ec2cccc18ab4c2ae(k, {
                ...this.options,
                ...opt
            }) : k);
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, opt);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = opt.count !== undefined && !$1e580fbd50c9e2d3$var$isString(opt.count);
            const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
            const needsContextHandling = opt.context !== undefined && ($1e580fbd50c9e2d3$var$isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
            const codes = opt.lngs ? opt.lngs : this.languageUtils.toResolveHierarchy(opt.lng || this.language, opt.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$1e580fbd50c9e2d3$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
                    $1e580fbd50c9e2d3$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat?.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, opt.count, opt);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            finalKeys.push(key + pluralSuffix);
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator || '_'}${opt.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                finalKeys.push(contextKey + pluralSuffix);
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, opt);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key, options = {}) {
        if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails(options = {}) {
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$1e580fbd50c9e2d3$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
class $1e580fbd50c9e2d3$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $1e580fbd50c9e2d3$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $1e580fbd50c9e2d3$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($1e580fbd50c9e2d3$var$isString(code) && code.indexOf('-') > -1) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngScOnly = this.getScriptPartFromCode(code);
            if (this.isSupportedCode(lngScOnly)) return found = lngScOnly;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($1e580fbd50c9e2d3$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes((fallbackCode === false ? [] : fallbackCode) || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($1e580fbd50c9e2d3$var$isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($1e580fbd50c9e2d3$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
const $1e580fbd50c9e2d3$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $1e580fbd50c9e2d3$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $1e580fbd50c9e2d3$var$PluralResolver {
    constructor(languageUtils, options = {}){
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code, options = {}) {
        const cleanedCode = $1e580fbd50c9e2d3$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (typeof Intl === 'undefined') {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $1e580fbd50c9e2d3$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $1e580fbd50c9e2d3$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        return rule?.resolvedOptions().pluralCategories.length > 1;
    }
    getPluralFormsOfKey(code, key, options = {}) {
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$1e580fbd50c9e2d3$var$suffixesOrder[pluralCategory1] - $1e580fbd50c9e2d3$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count, options = {}) {
        const rule = this.getRule(code, options);
        if (rule) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options);
    }
}
const $1e580fbd50c9e2d3$var$deepFindWithDefaults = (data, defaultData, key, keySeparator = '.', ignoreJSONStructure = true)=>{
    let path = $1e580fbd50c9e2d3$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $1e580fbd50c9e2d3$var$isString(key)) {
        path = $1e580fbd50c9e2d3$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $1e580fbd50c9e2d3$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $1e580fbd50c9e2d3$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $1e580fbd50c9e2d3$var$Interpolator {
    constructor(options = {}){
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options?.interpolation?.format || ((value)=>value);
        this.init(options);
    }
    init(options = {}) {
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $1e580fbd50c9e2d3$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $1e580fbd50c9e2d3$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $1e580fbd50c9e2d3$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $1e580fbd50c9e2d3$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $1e580fbd50c9e2d3$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $1e580fbd50c9e2d3$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $1e580fbd50c9e2d3$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp?.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $1e580fbd50c9e2d3$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($1e580fbd50c9e2d3$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options?.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$1e580fbd50c9e2d3$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $1e580fbd50c9e2d3$var$regexSafe(this.escape(val)) : $1e580fbd50c9e2d3$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $1e580fbd50c9e2d3$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$1e580fbd50c9e2d3$var$isString(value) && !this.useRawValueToEscape) value = $1e580fbd50c9e2d3$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc, options = {}) {
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${$1e580fbd50c9e2d3$var$regexEscape(sep)}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || (matchedDoubleQuotes?.length ?? 0) % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$1e580fbd50c9e2d3$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            const keyEndIndex = /{.*}/.test(match[1]) ? match[1].lastIndexOf('}') + 1 : match[1].indexOf(this.formatSeparator);
            if (keyEndIndex !== -1) {
                formatters = match[1].slice(keyEndIndex).split(this.formatSeparator).map((elem)=>elem.trim()).filter(Boolean);
                match[1] = match[1].slice(0, keyEndIndex);
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$1e580fbd50c9e2d3$var$isString(value)) return value;
            if (!$1e580fbd50c9e2d3$var$isString(value)) value = $1e580fbd50c9e2d3$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (formatters.length) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $1e580fbd50c9e2d3$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $1e580fbd50c9e2d3$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (v, l, o)=>{
        let optForCache = o;
        if (o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey]) optForCache = {
            ...optForCache,
            [o.interpolationkey]: undefined
        };
        const key = l + JSON.stringify(optForCache);
        let frm = cache[key];
        if (!frm) {
            frm = fn($1e580fbd50c9e2d3$var$getCleanedCode(l), o);
            cache[key] = frm;
        }
        return frm(v);
    };
};
const $1e580fbd50c9e2d3$var$createNonCachedFormatter = (fn)=>(v, l, o)=>fn($1e580fbd50c9e2d3$var$getCleanedCode(l), o)(v);
class $1e580fbd50c9e2d3$var$Formatter {
    constructor(options = {}){
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create('formatter');
        this.options = options;
        this.init(options);
    }
    init(services, options = {
        interpolation: {}
    }) {
        this.formatSeparator = options.interpolation.formatSeparator || ',';
        const cf = options.cacheInBuiltFormats ? $1e580fbd50c9e2d3$var$createCachedFormatter : $1e580fbd50c9e2d3$var$createNonCachedFormatter;
        this.formats = {
            number: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: cf((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: cf((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: cf((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $1e580fbd50c9e2d3$var$createCachedFormatter(fc);
    }
    format(value, format, lng, options = {}) {
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $1e580fbd50c9e2d3$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options?.formatParams?.[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $1e580fbd50c9e2d3$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $1e580fbd50c9e2d3$var$Connector extends $1e580fbd50c9e2d3$var$EventEmitter {
    constructor(backend, store, services, options = {}){
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        this.backend?.init?.(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $1e580fbd50c9e2d3$var$pushPath(q.loaded, [
                lng
            ], ns);
            $1e580fbd50c9e2d3$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName, tried = 0, wait = this.retryTimeout, callback) {
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces, options = {}, callback) {
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($1e580fbd50c9e2d3$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($1e580fbd50c9e2d3$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name, prefix = '') {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate, options = {}, clb = ()=>{}) {
        if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend?.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $1e580fbd50c9e2d3$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($1e580fbd50c9e2d3$var$isString(args[1])) ret.defaultValue = args[1];
            if ($1e580fbd50c9e2d3$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        },
        cacheInBuiltFormats: true
    });
const $1e580fbd50c9e2d3$var$transformOptions = (options)=>{
    if ($1e580fbd50c9e2d3$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($1e580fbd50c9e2d3$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($1e580fbd50c9e2d3$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs?.indexOf?.('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    if (typeof options.initImmediate === 'boolean') options.initAsync = options.initImmediate;
    return options;
};
const $1e580fbd50c9e2d3$var$noop = ()=>{};
const $1e580fbd50c9e2d3$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
const $1e580fbd50c9e2d3$var$SUPPORT_NOTICE_KEY = '__i18next_supportNoticeShown';
const $1e580fbd50c9e2d3$var$getSupportNoticeShown = ()=>{
    if (typeof globalThis !== 'undefined' && !!globalThis[$1e580fbd50c9e2d3$var$SUPPORT_NOTICE_KEY]) return true;
    return false;
};
const $1e580fbd50c9e2d3$var$setSupportNoticeShown = ()=>{
    if (typeof globalThis !== 'undefined') globalThis[$1e580fbd50c9e2d3$var$SUPPORT_NOTICE_KEY] = true;
};
const $1e580fbd50c9e2d3$var$usesLocize = (inst)=>{
    if (inst?.modules?.backend?.name?.indexOf('Locize') > 0) return true;
    if (inst?.modules?.backend?.constructor?.name?.indexOf('Locize') > 0) return true;
    if (inst?.options?.backend?.backends) {
        if (inst.options.backend.backends.some((b)=>b?.name?.indexOf('Locize') > 0 || b?.constructor?.name?.indexOf('Locize') > 0)) return true;
    }
    if (inst?.options?.backend?.projectId) return true;
    if (inst?.options?.backend?.backendOptions) {
        if (inst.options.backend.backendOptions.some((b)=>b?.projectId)) return true;
    }
    return false;
};
class $1e580fbd50c9e2d3$var$I18n extends $1e580fbd50c9e2d3$var$EventEmitter {
    constructor(options = {}, callback){
        super();
        this.options = $1e580fbd50c9e2d3$var$transformOptions(options);
        this.services = {};
        this.logger = $1e580fbd50c9e2d3$var$baseLogger;
        this.modules = {
            external: []
        };
        $1e580fbd50c9e2d3$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initAsync) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init(options = {}, callback) {
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (options.defaultNS == null && options.ns) {
            if ($1e580fbd50c9e2d3$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $1e580fbd50c9e2d3$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$1e580fbd50c9e2d3$var$transformOptions(options)
        };
        this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        if (typeof this.options.overloadTranslationOptionHandler !== 'function') this.options.overloadTranslationOptionHandler = defOpts.overloadTranslationOptionHandler;
        if (this.options.showSupportNotice !== false && !$1e580fbd50c9e2d3$var$usesLocize(this) && !$1e580fbd50c9e2d3$var$getSupportNoticeShown()) {
            if (typeof console !== 'undefined' && typeof console.info !== 'undefined') console.info("\uD83C\uDF10 i18next is made possible by our own product, Locize \u2014 consider powering your project with managed localization (AI, CDN, integrations): https://locize.com \uD83D\uDC99");
            $1e580fbd50c9e2d3$var$setSupportNoticeShown();
        }
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $1e580fbd50c9e2d3$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $1e580fbd50c9e2d3$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $1e580fbd50c9e2d3$var$Formatter;
            const lu = new $1e580fbd50c9e2d3$var$LanguageUtil(this.options);
            this.store = new $1e580fbd50c9e2d3$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $1e580fbd50c9e2d3$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $1e580fbd50c9e2d3$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            const usingLegacyFormatFunction = this.options.interpolation.format && this.options.interpolation.format !== defOpts.interpolation.format;
            if (usingLegacyFormatFunction) this.logger.deprecate(`init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting`);
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                if (s.formatter.init) s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $1e580fbd50c9e2d3$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $1e580fbd50c9e2d3$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $1e580fbd50c9e2d3$var$Translator(this.services, this.options);
            this.translator.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $1e580fbd50c9e2d3$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = (...args)=>this.store[fcName](...args);
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = (...args)=>{
                this.store[fcName](...args);
                return this;
            };
        });
        const deferred = $1e580fbd50c9e2d3$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language, callback = $1e580fbd50c9e2d3$var$noop) {
        let usedCallback = callback;
        const usedLng = $1e580fbd50c9e2d3$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            this.options.preload?.forEach?.((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $1e580fbd50c9e2d3$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $1e580fbd50c9e2d3$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $1e580fbd50c9e2d3$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
        if (!this.resolvedLanguage && this.languages.indexOf(l) < 0 && this.store.hasLanguageSomeTranslations(l)) {
            this.resolvedLanguage = l;
            this.languages.unshift(l);
        }
    }
    changeLanguage(lng, callback) {
        this.isLanguageChangingTo = lng;
        const deferred = $1e580fbd50c9e2d3$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                if (this.isLanguageChangingTo === lng) {
                    setLngProps(l);
                    this.translator.changeLanguage(l);
                    this.isLanguageChangingTo = undefined;
                    this.emit('languageChanged', l);
                    this.logger.log('languageChanged', l);
                }
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve((...args)=>this.t(...args));
            if (callback) callback(err, (...args)=>this.t(...args));
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const fl = $1e580fbd50c9e2d3$var$isString(lngs) ? lngs : lngs && lngs[0];
            const l = this.store.hasLanguageSomeTranslations(fl) ? fl : this.services.languageUtils.getBestMatchFromCodes($1e580fbd50c9e2d3$var$isString(lngs) ? [
                lngs
            ] : lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                this.services.languageDetector?.cacheUserLanguage?.(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        const fixedT = (key, opts, ...rest)=>{
            let o;
            if (typeof opts !== 'object') o = this.options.overloadTranslationOptionHandler([
                key,
                opts
            ].concat(rest));
            else o = {
                ...opts
            };
            o.lng = o.lng || fixedT.lng;
            o.lngs = o.lngs || fixedT.lngs;
            o.ns = o.ns || fixedT.ns;
            if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const selectorOpts = {
                ...this.options,
                ...o
            };
            if (typeof o.keyPrefix === 'function') o.keyPrefix = $1e580fbd50c9e2d3$export$ec2cccc18ab4c2ae(o.keyPrefix, selectorOpts);
            const keySeparator = this.options.keySeparator || '.';
            let resultKey;
            if (o.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>{
                if (typeof k === 'function') k = $1e580fbd50c9e2d3$export$ec2cccc18ab4c2ae(k, selectorOpts);
                return `${o.keyPrefix}${keySeparator}${k}`;
            });
            else {
                if (typeof key === 'function') key = $1e580fbd50c9e2d3$export$ec2cccc18ab4c2ae(key, selectorOpts);
                resultKey = o.keyPrefix ? `${o.keyPrefix}${keySeparator}${key}` : key;
            }
            return this.t(resultKey, o);
        };
        if ($1e580fbd50c9e2d3$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t(...args) {
        return this.translator?.translate(...args);
    }
    exists(...args) {
        return this.translator?.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns, options = {}) {
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $1e580fbd50c9e2d3$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($1e580fbd50c9e2d3$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $1e580fbd50c9e2d3$var$defer();
        if ($1e580fbd50c9e2d3$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        try {
            const l = new Intl.Locale(lng);
            if (l && l.getTextInfo) {
                const ti = l.getTextInfo();
                if (ti && ti.direction) return ti.direction;
            }
        } catch (e) {}
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services?.languageUtils || new $1e580fbd50c9e2d3$var$LanguageUtil($1e580fbd50c9e2d3$var$get());
        if (lng.toLowerCase().indexOf('-latn') > 1) return 'ltr';
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance(options = {}, callback) {
        const instance = new $1e580fbd50c9e2d3$var$I18n(options, callback);
        instance.createInstance = $1e580fbd50c9e2d3$var$I18n.createInstance;
        return instance;
    }
    cloneInstance(options = {}, callback = $1e580fbd50c9e2d3$var$noop) {
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $1e580fbd50c9e2d3$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const clonedData = Object.keys(this.store.data).reduce((prev, l)=>{
                prev[l] = {
                    ...this.store.data[l]
                };
                prev[l] = Object.keys(prev[l]).reduce((acc, n)=>{
                    acc[n] = {
                        ...prev[l][n]
                    };
                    return acc;
                }, prev[l]);
                return prev;
            }, {});
            clone.store = new $1e580fbd50c9e2d3$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        if (options.interpolation) {
            const defOpts = $1e580fbd50c9e2d3$var$get();
            const mergedInterpolation = {
                ...defOpts.interpolation,
                ...this.options.interpolation,
                ...options.interpolation
            };
            const mergedForInterpolator = {
                ...mergedOptions,
                interpolation: mergedInterpolation
            };
            clone.services.interpolator = new $1e580fbd50c9e2d3$var$Interpolator(mergedForInterpolator);
        }
        clone.translator = new $1e580fbd50c9e2d3$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', (event, ...args)=>{
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $1e580fbd50c9e2d3$export$2e2bcd8739ae039 = $1e580fbd50c9e2d3$var$I18n.createInstance();
const $1e580fbd50c9e2d3$export$99152e8d49ca4e7d = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.createInstance;
const $1e580fbd50c9e2d3$export$147ec2801e896265 = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.dir;
const $1e580fbd50c9e2d3$export$2cd8252107eb640b = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.init;
const $1e580fbd50c9e2d3$export$d3d08d944062d7e = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.loadResources;
const $1e580fbd50c9e2d3$export$a5d9bf5d83fcab09 = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.reloadResources;
const $1e580fbd50c9e2d3$export$1f96ae73734a86cc = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.use;
const $1e580fbd50c9e2d3$export$61465194746e7fd2 = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.changeLanguage;
const $1e580fbd50c9e2d3$export$f90d180fc7da3b3b = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.getFixedT;
const $1e580fbd50c9e2d3$export$625550452a3fa3ec = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.t;
const $1e580fbd50c9e2d3$export$f7e9f41ea797a17 = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.exists;
const $1e580fbd50c9e2d3$export$2b4b218e406d2d00 = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.setDefaultNamespace;
const $1e580fbd50c9e2d3$export$93d9ee97c1ad3f31 = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.hasLoadedNamespace;
const $1e580fbd50c9e2d3$export$83be934b53fff43b = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.loadNamespaces;
const $1e580fbd50c9e2d3$export$8cd7e7a54fa865bc = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.loadLanguages;

});

parcelRegister("le5Xr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f73f86de2138df56$export$2e2bcd8739ae039; });
const { slice: $f73f86de2138df56$var$slice, forEach: $f73f86de2138df56$var$forEach } = [];
function $f73f86de2138df56$var$defaults(obj) {
    $f73f86de2138df56$var$forEach.call($f73f86de2138df56$var$slice.call(arguments, 1), (source)=>{
        if (source) {
            for(const prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $f73f86de2138df56$var$hasXSS(input) {
    if (typeof input !== 'string') return false;
    // Common XSS attack patterns
    const xssPatterns = [
        /<\s*script.*?>/i,
        /<\s*\/\s*script\s*>/i,
        /<\s*img.*?on\w+\s*=/i,
        /<\s*\w+\s*on\w+\s*=.*?>/i,
        /javascript\s*:/i,
        /vbscript\s*:/i,
        /expression\s*\(/i,
        /eval\s*\(/i,
        /alert\s*\(/i,
        /document\.cookie/i,
        /document\.write\s*\(/i,
        /window\.location/i,
        /innerHTML/i
    ];
    return xssPatterns.some((pattern)=>pattern.test(input));
}
// eslint-disable-next-line no-control-regex
const $f73f86de2138df56$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
const $f73f86de2138df56$var$serializeCookie = function(name, val) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        path: '/'
    };
    const opt = options;
    const value = encodeURIComponent(val);
    let str = `${name}=${value}`;
    if (opt.maxAge > 0) {
        const maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += `; Max-Age=${Math.floor(maxAge)}`;
    }
    if (opt.domain) {
        if (!$f73f86de2138df56$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += `; Domain=${opt.domain}`;
    }
    if (opt.path) {
        if (!$f73f86de2138df56$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += `; Path=${opt.path}`;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += `; Expires=${opt.expires.toUTCString()}`;
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        const sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    if (opt.partitioned) str += '; Partitioned';
    return str;
};
const $f73f86de2138df56$var$cookie = {
    create (name, value, minutes, domain) {
        let cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $f73f86de2138df56$var$serializeCookie(name, value, cookieOptions);
    },
    read (name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove (name, domain) {
        this.create(name, '', -1, domain);
    }
};
var $f73f86de2138df56$var$cookie$1 = {
    name: 'cookie',
    // Deconstruct the options object and extract the lookupCookie property
    lookup (_ref) {
        let { lookupCookie: lookupCookie } = _ref;
        if (lookupCookie && typeof document !== 'undefined') return $f73f86de2138df56$var$cookie.read(lookupCookie) || undefined;
        return undefined;
    },
    // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
    cacheUserLanguage (lng, _ref2) {
        let { lookupCookie: lookupCookie, cookieMinutes: cookieMinutes, cookieDomain: cookieDomain, cookieOptions: cookieOptions } = _ref2;
        if (lookupCookie && typeof document !== 'undefined') $f73f86de2138df56$var$cookie.create(lookupCookie, lng, cookieMinutes, cookieDomain, cookieOptions);
    }
};
var $f73f86de2138df56$var$querystring = {
    name: 'querystring',
    // Deconstruct the options object and extract the lookupQuerystring property
    lookup (_ref) {
        let { lookupQuerystring: lookupQuerystring } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            let { search: search } = window.location;
            if (!window.location.search && window.location.hash?.indexOf('?') > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            const query = search.substring(1);
            const params = query.split('&');
            for(let i = 0; i < params.length; i++){
                const pos = params[i].indexOf('=');
                if (pos > 0) {
                    const key = params[i].substring(0, pos);
                    if (key === lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $f73f86de2138df56$var$hash = {
    name: 'hash',
    // Deconstruct the options object and extract the lookupHash property and the lookupFromHashIndex property
    lookup (_ref) {
        let { lookupHash: lookupHash, lookupFromHashIndex: lookupFromHashIndex } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            const { hash: hash } = window.location;
            if (hash && hash.length > 2) {
                const query = hash.substring(1);
                if (lookupHash) {
                    const params = query.split('&');
                    for(let i = 0; i < params.length; i++){
                        const pos = params[i].indexOf('=');
                        if (pos > 0) {
                            const key = params[i].substring(0, pos);
                            if (key === lookupHash) found = params[i].substring(pos + 1);
                        }
                    }
                }
                if (found) return found;
                if (!found && lookupFromHashIndex > -1) {
                    const language = hash.match(/\/([a-zA-Z-]*)/g);
                    if (!Array.isArray(language)) return undefined;
                    const index = typeof lookupFromHashIndex === 'number' ? lookupFromHashIndex : 0;
                    return language[index]?.replace('/', '');
                }
            }
        }
        return found;
    }
};
let $f73f86de2138df56$var$hasLocalStorageSupport = null;
const $f73f86de2138df56$var$localStorageAvailable = ()=>{
    if ($f73f86de2138df56$var$hasLocalStorageSupport !== null) return $f73f86de2138df56$var$hasLocalStorageSupport;
    try {
        $f73f86de2138df56$var$hasLocalStorageSupport = typeof window !== 'undefined' && window.localStorage !== null;
        if (!$f73f86de2138df56$var$hasLocalStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $f73f86de2138df56$var$hasLocalStorageSupport = false;
    }
    return $f73f86de2138df56$var$hasLocalStorageSupport;
};
var $f73f86de2138df56$var$localStorage = {
    name: 'localStorage',
    // Deconstruct the options object and extract the lookupLocalStorage property
    lookup (_ref) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref;
        if (lookupLocalStorage && $f73f86de2138df56$var$localStorageAvailable()) return window.localStorage.getItem(lookupLocalStorage) || undefined; // Undefined ensures type consistency with the previous version of this function
        return undefined;
    },
    // Deconstruct the options object and extract the lookupLocalStorage property
    cacheUserLanguage (lng, _ref2) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref2;
        if (lookupLocalStorage && $f73f86de2138df56$var$localStorageAvailable()) window.localStorage.setItem(lookupLocalStorage, lng);
    }
};
let $f73f86de2138df56$var$hasSessionStorageSupport = null;
const $f73f86de2138df56$var$sessionStorageAvailable = ()=>{
    if ($f73f86de2138df56$var$hasSessionStorageSupport !== null) return $f73f86de2138df56$var$hasSessionStorageSupport;
    try {
        $f73f86de2138df56$var$hasSessionStorageSupport = typeof window !== 'undefined' && window.sessionStorage !== null;
        if (!$f73f86de2138df56$var$hasSessionStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $f73f86de2138df56$var$hasSessionStorageSupport = false;
    }
    return $f73f86de2138df56$var$hasSessionStorageSupport;
};
var $f73f86de2138df56$var$sessionStorage = {
    name: 'sessionStorage',
    lookup (_ref) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref;
        if (lookupSessionStorage && $f73f86de2138df56$var$sessionStorageAvailable()) return window.sessionStorage.getItem(lookupSessionStorage) || undefined;
        return undefined;
    },
    cacheUserLanguage (lng, _ref2) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref2;
        if (lookupSessionStorage && $f73f86de2138df56$var$sessionStorageAvailable()) window.sessionStorage.setItem(lookupSessionStorage, lng);
    }
};
var $f73f86de2138df56$var$navigator$1 = {
    name: 'navigator',
    lookup (options) {
        const found = [];
        if (typeof navigator !== 'undefined') {
            const { languages: languages, userLanguage: userLanguage, language: language } = navigator;
            if (languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(let i = 0; i < languages.length; i++)found.push(languages[i]);
            if (userLanguage) found.push(userLanguage);
            if (language) found.push(language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $f73f86de2138df56$var$htmlTag = {
    name: 'htmlTag',
    // Deconstruct the options object and extract the htmlTag property
    lookup (_ref) {
        let { htmlTag: htmlTag } = _ref;
        let found;
        const internalHtmlTag = htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (internalHtmlTag && typeof internalHtmlTag.getAttribute === 'function') found = internalHtmlTag.getAttribute('lang');
        return found;
    }
};
var $f73f86de2138df56$var$path = {
    name: 'path',
    // Deconstruct the options object and extract the lookupFromPathIndex property
    lookup (_ref) {
        let { lookupFromPathIndex: lookupFromPathIndex } = _ref;
        if (typeof window === 'undefined') return undefined;
        const language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
        if (!Array.isArray(language)) return undefined;
        const index = typeof lookupFromPathIndex === 'number' ? lookupFromPathIndex : 0;
        return language[index]?.replace('/', '');
    }
};
var $f73f86de2138df56$var$subdomain = {
    name: 'subdomain',
    lookup (_ref) {
        let { lookupFromSubdomainIndex: lookupFromSubdomainIndex } = _ref;
        // If given get the subdomain index else 1
        const internalLookupFromSubdomainIndex = typeof lookupFromSubdomainIndex === 'number' ? lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group match which should be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        const language = typeof window !== 'undefined' && window.location?.hostname?.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[internalLookupFromSubdomainIndex];
    }
};
// some environments, throws when accessing document.cookie
let $f73f86de2138df56$var$canCookies = false;
try {
    // eslint-disable-next-line no-unused-expressions
    document.cookie;
    $f73f86de2138df56$var$canCookies = true;
// eslint-disable-next-line no-empty
} catch (e) {}
const $f73f86de2138df56$var$order = [
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'htmlTag'
];
if (!$f73f86de2138df56$var$canCookies) $f73f86de2138df56$var$order.splice(1, 1);
const $f73f86de2138df56$var$getDefaults = ()=>({
        order: $f73f86de2138df56$var$order,
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: (l)=>l
    });
class $f73f86de2138df56$export$2e2bcd8739ae039 {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    init() {
        let services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            languageUtils: {}
        };
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.services = services;
        this.options = $f73f86de2138df56$var$defaults(options, this.options || {}, $f73f86de2138df56$var$getDefaults());
        if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) this.options.convertDetectedLanguage = (l)=>l.replace('-', '_');
        // backwards compatibility
        if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
        this.i18nOptions = i18nOptions;
        this.addDetector($f73f86de2138df56$var$cookie$1);
        this.addDetector($f73f86de2138df56$var$querystring);
        this.addDetector($f73f86de2138df56$var$localStorage);
        this.addDetector($f73f86de2138df56$var$sessionStorage);
        this.addDetector($f73f86de2138df56$var$navigator$1);
        this.addDetector($f73f86de2138df56$var$htmlTag);
        this.addDetector($f73f86de2138df56$var$path);
        this.addDetector($f73f86de2138df56$var$subdomain);
        this.addDetector($f73f86de2138df56$var$hash);
    }
    addDetector(detector) {
        this.detectors[detector.name] = detector;
        return this;
    }
    detect() {
        let detectionOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.order;
        let detected = [];
        detectionOrder.forEach((detectorName)=>{
            if (this.detectors[detectorName]) {
                let lookup = this.detectors[detectorName].lookup(this.options);
                if (lookup && typeof lookup === 'string') lookup = [
                    lookup
                ];
                if (lookup) detected = detected.concat(lookup);
            }
        });
        detected = detected.filter((d)=>d !== undefined && d !== null && !$f73f86de2138df56$var$hasXSS(d)).map((d)=>this.options.convertDetectedLanguage(d));
        if (this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
        return detected.length > 0 ? detected[0] : null; // a little backward compatibility
    }
    cacheUserLanguage(lng) {
        let caches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.caches;
        if (!caches) return;
        if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
        caches.forEach((cacheName)=>{
            if (this.detectors[cacheName]) this.detectors[cacheName].cacheUserLanguage(lng, this.options);
        });
    }
}
$f73f86de2138df56$export$2e2bcd8739ae039.type = 'languageDetector';

});

parcelRegister("lHdDM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fcb831e2a23edeea$export$2e2bcd8739ae039; });

var $87siJ = parcelRequire("87siJ");

var $1uneS = parcelRequire("1uneS");
function $fcb831e2a23edeea$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fcb831e2a23edeea$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fcb831e2a23edeea$var$_typeof(o);
}
function $fcb831e2a23edeea$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fcb831e2a23edeea$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fcb831e2a23edeea$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fcb831e2a23edeea$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fcb831e2a23edeea$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fcb831e2a23edeea$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $fcb831e2a23edeea$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $fcb831e2a23edeea$var$_toPropertyKey(o.key), o);
    }
}
function $fcb831e2a23edeea$var$_createClass(e, r, t) {
    return r && $fcb831e2a23edeea$var$_defineProperties(e.prototype, r), t && $fcb831e2a23edeea$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $fcb831e2a23edeea$var$_defineProperty(e, r, t) {
    return (r = $fcb831e2a23edeea$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fcb831e2a23edeea$var$_toPropertyKey(t) {
    var i = $fcb831e2a23edeea$var$_toPrimitive(t, "string");
    return "symbol" == $fcb831e2a23edeea$var$_typeof(i) ? i : i + "";
}
function $fcb831e2a23edeea$var$_toPrimitive(t, r) {
    if ("object" != $fcb831e2a23edeea$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $fcb831e2a23edeea$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $fcb831e2a23edeea$var$getDefaults = function getDefaults() {
    return {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
        addPath: '/locales/add/{{lng}}/{{ns}}',
        parse: function parse(data) {
            return JSON.parse(data);
        },
        stringify: JSON.stringify,
        parsePayload: function parsePayload(namespace, key, fallbackValue) {
            return $fcb831e2a23edeea$var$_defineProperty({}, key, fallbackValue || '');
        },
        parseLoadPayload: function parseLoadPayload(languages, namespaces) {
            return undefined;
        },
        request: (0, $1uneS.default),
        reloadInterval: typeof window !== 'undefined' ? false : 3600000,
        customHeaders: {},
        queryStringParams: {},
        crossDomain: false,
        withCredentials: false,
        overrideMimeType: false,
        requestOptions: {
            mode: 'cors',
            credentials: 'same-origin',
            cache: 'default'
        }
    };
};
var $fcb831e2a23edeea$var$Backend = function() {
    function Backend(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $fcb831e2a23edeea$var$_classCallCheck(this, Backend);
        this.services = services;
        this.options = options;
        this.allOptions = allOptions;
        this.type = 'backend';
        this.init(services, options, allOptions);
    }
    return $fcb831e2a23edeea$var$_createClass(Backend, [
        {
            key: "init",
            value: function init(services) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $fcb831e2a23edeea$var$_objectSpread($fcb831e2a23edeea$var$_objectSpread($fcb831e2a23edeea$var$_objectSpread({}, $fcb831e2a23edeea$var$getDefaults()), this.options || {}), options);
                this.allOptions = allOptions;
                if (this.services && this.options.reloadInterval) {
                    var timer = setInterval(function() {
                        return _this.reload();
                    }, this.options.reloadInterval);
                    if ($fcb831e2a23edeea$var$_typeof(timer) === 'object' && typeof timer.unref === 'function') timer.unref();
                }
            }
        },
        {
            key: "readMulti",
            value: function readMulti(languages, namespaces, callback) {
                this._readAny(languages, languages, namespaces, namespaces, callback);
            }
        },
        {
            key: "read",
            value: function read(language, namespace, callback) {
                this._readAny([
                    language
                ], language, [
                    namespace
                ], namespace, callback);
            }
        },
        {
            key: "_readAny",
            value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
                var _this2 = this;
                var loadPath = this.options.loadPath;
                if (typeof this.options.loadPath === 'function') loadPath = this.options.loadPath(languages, namespaces);
                loadPath = (0, $87siJ.makePromise)(loadPath);
                loadPath.then(function(resolvedLoadPath) {
                    if (!resolvedLoadPath) return callback(null, {});
                    var url = (0, $87siJ.interpolateUrl)(resolvedLoadPath, {
                        lng: languages.join('+'),
                        ns: namespaces.join('+')
                    });
                    if (url == null) {
                        var safeLngs = languages.map((0, $87siJ.sanitizeLogValue)).join(', ');
                        var safeNss = namespaces.map((0, $87siJ.sanitizeLogValue)).join(', ');
                        return callback(new Error("i18next-http-backend: unsafe lng/ns value \u2014 refusing to build request URL for languages=[" + safeLngs + '] namespaces=[' + safeNss + ']'), false);
                    }
                    _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
                });
            }
        },
        {
            key: "loadUrl",
            value: function loadUrl(url, callback, languages, namespaces) {
                var _this3 = this;
                var lng = typeof languages === 'string' ? [
                    languages
                ] : languages;
                var ns = typeof namespaces === 'string' ? [
                    namespaces
                ] : namespaces;
                var payload = this.options.parseLoadPayload(lng, ns);
                var safeUrl = (0, $87siJ.sanitizeLogValue)((0, $87siJ.redactUrlCredentials)(url));
                this.options.request(this.options, url, payload, function(err, res) {
                    if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback('failed loading ' + safeUrl + '; status code: ' + res.status, true);
                    if (res && res.status >= 400 && res.status < 500) return callback('failed loading ' + safeUrl + '; status code: ' + res.status, false);
                    if (!res && err && err.message) {
                        var errorMessage = err.message.toLowerCase();
                        var isNetworkError = [
                            'failed',
                            'fetch',
                            'network',
                            'load'
                        ].find(function(term) {
                            return errorMessage.indexOf(term) > -1;
                        });
                        if (isNetworkError) return callback('failed loading ' + safeUrl + ': ' + (0, $87siJ.sanitizeLogValue)(err.message), true);
                    }
                    if (err) return callback(err, false);
                    var ret, parseErr;
                    try {
                        if (typeof res.data === 'string') ret = _this3.options.parse(res.data, languages, namespaces);
                        else ret = res.data;
                    } catch (e) {
                        parseErr = 'failed parsing ' + safeUrl + ' to json';
                    }
                    if (parseErr) return callback(parseErr, false);
                    callback(null, ret);
                });
            }
        },
        {
            key: "create",
            value: function create(languages, namespace, key, fallbackValue, callback) {
                var _this4 = this;
                if (!this.options.addPath) return;
                if (typeof languages === 'string') languages = [
                    languages
                ];
                var payload = this.options.parsePayload(namespace, key, fallbackValue);
                var finished = 0;
                var dataArray = [];
                var resArray = [];
                languages.forEach(function(lng) {
                    var addPath = _this4.options.addPath;
                    if (typeof _this4.options.addPath === 'function') addPath = _this4.options.addPath(lng, namespace);
                    var url = (0, $87siJ.interpolateUrl)(addPath, {
                        lng: lng,
                        ns: namespace
                    });
                    if (url == null) {
                        finished += 1;
                        if (callback && finished === languages.length) callback(dataArray, resArray);
                        return;
                    }
                    _this4.options.request(_this4.options, url, payload, function(data, res) {
                        finished += 1;
                        dataArray.push(data);
                        resArray.push(res);
                        if (finished === languages.length) {
                            if (typeof callback === 'function') callback(dataArray, resArray);
                        }
                    });
                });
            }
        },
        {
            key: "reload",
            value: function reload() {
                var _this5 = this;
                var _this$services = this.services, backendConnector = _this$services.backendConnector, languageUtils = _this$services.languageUtils, logger = _this$services.logger;
                var currentLanguage = backendConnector.language;
                if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return;
                var toLoad = [];
                var append = function append(lng) {
                    var lngs = languageUtils.toResolveHierarchy(lng);
                    lngs.forEach(function(l) {
                        if (toLoad.indexOf(l) < 0) toLoad.push(l);
                    });
                };
                append(currentLanguage);
                if (this.allOptions.preload) this.allOptions.preload.forEach(function(l) {
                    return append(l);
                });
                toLoad.forEach(function(lng) {
                    _this5.allOptions.ns.forEach(function(ns) {
                        backendConnector.read(lng, ns, 'read', null, null, function(err, data) {
                            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
                            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
                            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
                        });
                    });
                });
            }
        }
    ]);
}();
$fcb831e2a23edeea$var$Backend.type = 'backend';
var $fcb831e2a23edeea$export$2e2bcd8739ae039 = $fcb831e2a23edeea$var$Backend;

});
parcelRegister("87siJ", function(module, exports) {

$parcel$export(module.exports, "sanitizeLogValue", function () { return $5e94ee2b5c33482b$export$b5ba5937b9227ae9; });
$parcel$export(module.exports, "redactUrlCredentials", function () { return $5e94ee2b5c33482b$export$fee0a5152e4c950b; });
$parcel$export(module.exports, "hasXMLHttpRequest", function () { return $5e94ee2b5c33482b$export$87022daa49baf612; });
$parcel$export(module.exports, "makePromise", function () { return $5e94ee2b5c33482b$export$1625492ec82002b9; });
$parcel$export(module.exports, "interpolateUrl", function () { return $5e94ee2b5c33482b$export$538bd54113066b32; });
function $5e94ee2b5c33482b$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $5e94ee2b5c33482b$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $5e94ee2b5c33482b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5e94ee2b5c33482b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5e94ee2b5c33482b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $5e94ee2b5c33482b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $5e94ee2b5c33482b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5e94ee2b5c33482b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5e94ee2b5c33482b$var$_typeof(o);
}
var $5e94ee2b5c33482b$var$arr = [];
var $5e94ee2b5c33482b$var$each = $5e94ee2b5c33482b$var$arr.forEach;
var $5e94ee2b5c33482b$var$slice = $5e94ee2b5c33482b$var$arr.slice;
var $5e94ee2b5c33482b$var$UNSAFE_KEYS = [
    '__proto__',
    'constructor',
    'prototype'
];
function $5e94ee2b5c33482b$export$ebe90cb607ad99e(obj) {
    $5e94ee2b5c33482b$var$each.call($5e94ee2b5c33482b$var$slice.call(arguments, 1), function(source) {
        if (source) for(var _i = 0, _Object$keys = Object.keys(source); _i < _Object$keys.length; _i++){
            var prop = _Object$keys[_i];
            if ($5e94ee2b5c33482b$var$UNSAFE_KEYS.indexOf(prop) > -1) continue;
            if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $5e94ee2b5c33482b$var$isSafeUrlSegmentBase(v) {
    if (typeof v !== 'string') return false;
    if (v.length === 0 || v.length > 128) return false;
    if ($5e94ee2b5c33482b$var$UNSAFE_KEYS.indexOf(v) > -1) return false;
    if (v.indexOf('..') > -1) return false;
    if (v.indexOf('\\') > -1) return false;
    if (/[?#%\s@]/.test(v)) return false;
    if (/[\x00-\x1F\x7F]/.test(v)) return false;
    return true;
}
function $5e94ee2b5c33482b$export$d4b1d5d3c7993bfa(v) {
    if (!$5e94ee2b5c33482b$var$isSafeUrlSegmentBase(v)) return false;
    if (v.indexOf('/') > -1) return false;
    return true;
}
function $5e94ee2b5c33482b$export$d8513ff071200f5b(v) {
    return $5e94ee2b5c33482b$var$isSafeUrlSegmentBase(v);
}
var $5e94ee2b5c33482b$export$fcec0b7704220ff2 = $5e94ee2b5c33482b$export$d4b1d5d3c7993bfa;
var $5e94ee2b5c33482b$var$SAFETY_CHECK_BY_KEY = {
    lng: $5e94ee2b5c33482b$export$d4b1d5d3c7993bfa,
    ns: $5e94ee2b5c33482b$export$d8513ff071200f5b
};
function $5e94ee2b5c33482b$export$b5ba5937b9227ae9(v) {
    if (typeof v !== 'string') return v;
    return v.replace(/[\r\n\x00-\x1F\x7F]/g, ' ');
}
function $5e94ee2b5c33482b$export$fee0a5152e4c950b(u) {
    if (typeof u !== 'string' || u.length === 0) return u;
    try {
        var parsed = new URL(u);
        if (parsed.username || parsed.password) {
            parsed.username = '';
            parsed.password = '';
            return parsed.toString();
        }
        return u;
    } catch (e) {
        return u.replace(/(\/\/)[^/@\s]+@/g, '$1');
    }
}
function $5e94ee2b5c33482b$export$87022daa49baf612() {
    return typeof XMLHttpRequest === 'function' || (typeof XMLHttpRequest === "undefined" ? "undefined" : $5e94ee2b5c33482b$var$_typeof(XMLHttpRequest)) === 'object';
}
function $5e94ee2b5c33482b$var$isPromise(maybePromise) {
    return !!maybePromise && typeof maybePromise.then === 'function';
}
function $5e94ee2b5c33482b$export$1625492ec82002b9(maybePromise) {
    if ($5e94ee2b5c33482b$var$isPromise(maybePromise)) return maybePromise;
    return Promise.resolve(maybePromise);
}
var $5e94ee2b5c33482b$var$interpolationRegexp = /\{\{(.+?)\}\}/g;
function $5e94ee2b5c33482b$export$89e29e4ab65e70a9(str, data) {
    return str.replace($5e94ee2b5c33482b$var$interpolationRegexp, function(match, key) {
        var k = key.trim();
        if ($5e94ee2b5c33482b$var$UNSAFE_KEYS.indexOf(k) > -1) return match;
        var value = data[k];
        return value != null ? value : match;
    });
}
function $5e94ee2b5c33482b$export$538bd54113066b32(str, data) {
    var unsafe = false;
    var result = str.replace($5e94ee2b5c33482b$var$interpolationRegexp, function(match, key) {
        var k = key.trim();
        if ($5e94ee2b5c33482b$var$UNSAFE_KEYS.indexOf(k) > -1) return match;
        var value = data[k];
        if (value == null) return match;
        var check = $5e94ee2b5c33482b$var$SAFETY_CHECK_BY_KEY[k] || $5e94ee2b5c33482b$export$d4b1d5d3c7993bfa;
        var segments = String(value).split('+');
        var _iterator = $5e94ee2b5c33482b$var$_createForOfIteratorHelper(segments), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var seg = _step.value;
                if (!check(seg)) {
                    unsafe = true;
                    return match;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return segments.join('+');
    });
    return unsafe ? null : result;
}

});

parcelRegister("1uneS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $115a9e8b8151a003$export$2e2bcd8739ae039; });

var $87siJ = parcelRequire("87siJ");
function $115a9e8b8151a003$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $115a9e8b8151a003$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $115a9e8b8151a003$var$ownKeys(Object(t), !0).forEach(function(r) {
            $115a9e8b8151a003$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $115a9e8b8151a003$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $115a9e8b8151a003$var$_defineProperty(e, r, t) {
    return (r = $115a9e8b8151a003$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $115a9e8b8151a003$var$_toPropertyKey(t) {
    var i = $115a9e8b8151a003$var$_toPrimitive(t, "string");
    return "symbol" == $115a9e8b8151a003$var$_typeof(i) ? i : i + "";
}
function $115a9e8b8151a003$var$_toPrimitive(t, r) {
    if ("object" != $115a9e8b8151a003$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $115a9e8b8151a003$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $115a9e8b8151a003$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $115a9e8b8151a003$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $115a9e8b8151a003$var$_typeof(o);
}
var $115a9e8b8151a003$var$fetchApi = typeof fetch === 'function' ? fetch : undefined;
if (typeof $parcel$global !== 'undefined' && $parcel$global.fetch) $115a9e8b8151a003$var$fetchApi = $parcel$global.fetch;
else if (typeof window !== 'undefined' && window.fetch) $115a9e8b8151a003$var$fetchApi = window.fetch;
var $115a9e8b8151a003$var$XmlHttpRequestApi;
if ((0, $87siJ.hasXMLHttpRequest)()) {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.XMLHttpRequest) $115a9e8b8151a003$var$XmlHttpRequestApi = $parcel$global.XMLHttpRequest;
    else if (typeof window !== 'undefined' && window.XMLHttpRequest) $115a9e8b8151a003$var$XmlHttpRequestApi = window.XMLHttpRequest;
}
var $115a9e8b8151a003$var$ActiveXObjectApi;
if (typeof ActiveXObject === 'function') {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.ActiveXObject) $115a9e8b8151a003$var$ActiveXObjectApi = $parcel$global.ActiveXObject;
    else if (typeof window !== 'undefined' && window.ActiveXObject) $115a9e8b8151a003$var$ActiveXObjectApi = window.ActiveXObject;
}
if (typeof $115a9e8b8151a003$var$fetchApi !== 'function') $115a9e8b8151a003$var$fetchApi = undefined;

if (!$115a9e8b8151a003$var$fetchApi && !$115a9e8b8151a003$var$XmlHttpRequestApi && !$115a9e8b8151a003$var$ActiveXObjectApi) try {
    (parcelRequire("gLh28")).then(function(mod) {
        $115a9e8b8151a003$var$fetchApi = mod.default;
    }).catch(function() {});
} catch (e) {}
var $115a9e8b8151a003$var$UNSAFE_KEYS = [
    '__proto__',
    'constructor',
    'prototype'
];
var $115a9e8b8151a003$var$addQueryString = function addQueryString(url, params) {
    if (params && $115a9e8b8151a003$var$_typeof(params) === 'object') {
        var queryString = '';
        for(var _i = 0, _Object$keys = Object.keys(params); _i < _Object$keys.length; _i++){
            var paramName = _Object$keys[_i];
            if ($115a9e8b8151a003$var$UNSAFE_KEYS.indexOf(paramName) > -1) continue;
            queryString += '&' + encodeURIComponent(paramName) + '=' + encodeURIComponent(params[paramName]);
        }
        if (!queryString) return url;
        url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
    }
    return url;
};
var $115a9e8b8151a003$var$fetchIt = function fetchIt(url, fetchOptions, callback, altFetch) {
    var resolver = function resolver(response) {
        if (!response.ok) return callback(response.statusText || 'Error', {
            status: response.status
        });
        response.text().then(function(data) {
            callback(null, {
                status: response.status,
                data: data
            });
        }).catch(callback);
    };
    if (altFetch) {
        var altResponse = altFetch(url, fetchOptions);
        if (altResponse instanceof Promise) {
            altResponse.then(resolver).catch(callback);
            return;
        }
    }
    if (typeof fetch === 'function') fetch(url, fetchOptions).then(resolver).catch(callback);
    else $115a9e8b8151a003$var$fetchApi(url, fetchOptions).then(resolver).catch(callback);
};
var $115a9e8b8151a003$var$requestWithFetch = function requestWithFetch(options, url, payload, callback) {
    if (options.queryStringParams) url = $115a9e8b8151a003$var$addQueryString(url, options.queryStringParams);
    var headers = $115a9e8b8151a003$var$_objectSpread({}, typeof options.customHeaders === 'function' ? options.customHeaders() : options.customHeaders);
    if (typeof window === 'undefined' && typeof $parcel$global !== 'undefined' && typeof $parcel$global.process !== 'undefined' && $parcel$global.process.versions && $parcel$global.process.versions.node) headers['User-Agent'] = "i18next-http-backend (node/".concat($parcel$global.process.version, "; ").concat($parcel$global.process.platform, " ").concat($parcel$global.process.arch, ")");
    if (payload) headers['Content-Type'] = 'application/json';
    var reqOptions = typeof options.requestOptions === 'function' ? options.requestOptions(payload) : options.requestOptions;
    var fetchOptions = $115a9e8b8151a003$var$_objectSpread({
        method: payload ? 'POST' : 'GET',
        body: payload ? options.stringify(payload) : undefined,
        headers: headers
    }, options._omitFetchOptions ? {} : reqOptions);
    var altFetch = typeof options.alternateFetch === 'function' && options.alternateFetch.length >= 1 ? options.alternateFetch : undefined;
    try {
        $115a9e8b8151a003$var$fetchIt(url, fetchOptions, callback, altFetch);
    } catch (e) {
        if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf('not implemented') < 0) return callback(e);
        try {
            Object.keys(reqOptions).forEach(function(opt) {
                delete fetchOptions[opt];
            });
            $115a9e8b8151a003$var$fetchIt(url, fetchOptions, callback, altFetch);
            options._omitFetchOptions = true;
        } catch (err) {
            callback(err);
        }
    }
};
var $115a9e8b8151a003$var$requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
    if (payload && $115a9e8b8151a003$var$_typeof(payload) === 'object') payload = $115a9e8b8151a003$var$addQueryString('', payload).slice(1);
    if (options.queryStringParams) url = $115a9e8b8151a003$var$addQueryString(url, options.queryStringParams);
    try {
        var x = $115a9e8b8151a003$var$XmlHttpRequestApi ? new $115a9e8b8151a003$var$XmlHttpRequestApi() : new $115a9e8b8151a003$var$ActiveXObjectApi('MSXML2.XMLHTTP.3.0');
        x.open(payload ? 'POST' : 'GET', url, 1);
        if (!options.crossDomain) x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        x.withCredentials = !!options.withCredentials;
        if (payload) x.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        if (x.overrideMimeType) x.overrideMimeType('application/json');
        var h = options.customHeaders;
        h = typeof h === 'function' ? h() : h;
        if (h) for(var _i2 = 0, _Object$keys2 = Object.keys(h); _i2 < _Object$keys2.length; _i2++){
            var i = _Object$keys2[_i2];
            if ($115a9e8b8151a003$var$UNSAFE_KEYS.indexOf(i) > -1) continue;
            x.setRequestHeader(i, h[i]);
        }
        x.onreadystatechange = function() {
            x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
                status: x.status,
                data: x.responseText
            });
        };
        x.send(payload);
    } catch (e) {
        console && console.log(e);
    }
};
var $115a9e8b8151a003$var$request = function request(options, url, payload, callback) {
    if (typeof payload === 'function') {
        callback = payload;
        payload = undefined;
    }
    callback = callback || function() {};
    if ($115a9e8b8151a003$var$fetchApi && url.indexOf('file:') !== 0) return $115a9e8b8151a003$var$requestWithFetch(options, url, payload, callback);
    if ((0, $87siJ.hasXMLHttpRequest)() || typeof ActiveXObject === 'function') return $115a9e8b8151a003$var$requestWithXmlHttpRequest(options, url, payload, callback);
    callback(new Error('No fetch and no xhr implementation found!'));
};
var $115a9e8b8151a003$export$2e2bcd8739ae039 = $115a9e8b8151a003$var$request;

});
parcelRegister("gLh28", function(module, exports) {
module.exports = import("5yiMq").then(()=>parcelRequire('fVMg8'));

});



parcelRegister("3GBGj", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return (parcelRequire("91Jfg")).Trans; });
$parcel$export(module.exports, "useTranslation", function () { return (parcelRequire("doyfp")).useTranslation; });
$parcel$export(module.exports, "initReactI18next", function () { return (parcelRequire("NDJJg")).initReactI18next; });
$parcel$export(module.exports, "getI18n", function () { return (parcelRequire("cvg5R")).getI18n; });

var $91Jfg = parcelRequire("91Jfg");

var $2ocZR = parcelRequire("2ocZR");

var $5GXoA = parcelRequire("5GXoA");

var $cTpiV = parcelRequire("cTpiV");

var $doyfp = parcelRequire("doyfp");

var $2mZbw = parcelRequire("2mZbw");

var $1teFb = parcelRequire("1teFb");

var $kX5ZB = parcelRequire("kX5ZB");

var $3fGol = parcelRequire("3fGol");

var $9ql4S = parcelRequire("9ql4S");

var $NDJJg = parcelRequire("NDJJg");

var $fYpGK = parcelRequire("fYpGK");

var $cvg5R = parcelRequire("cvg5R");

var $beOCj = parcelRequire("beOCj");
const $2af286126fb112dc$export$324d90190a8b822a = ()=>'';
const $2af286126fb112dc$export$2da9be4cfdb689b1 = ()=>'';
const $2af286126fb112dc$export$98e628dec113755e = ()=>'';
const $2af286126fb112dc$export$2e6c959c16ff56b8 = ()=>'';
const $2af286126fb112dc$export$4e35d5c922a95490 = ()=>'';
const $2af286126fb112dc$export$720a3b9db04b7a0f = ()=>'';

});
parcelRegister("91Jfg", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce; });

var $7fPBF = parcelRequire("7fPBF");

var $2ocZR = parcelRequire("2ocZR");
parcelRequire("beOCj");
var $cvg5R = parcelRequire("cvg5R");
var $beOCj = parcelRequire("beOCj");
function $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $7fPBF.useContext)((0, $beOCj.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $cvg5R.getI18n)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $2ocZR.Trans)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}

});
parcelRegister("2ocZR", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return $1bd7e790a57f14c4$export$8d6a9236f2e3f2ce; });

var $7fPBF = parcelRequire("7fPBF");

var $2Bwgd = parcelRequire("2Bwgd");

var $58Q0I = parcelRequire("58Q0I");

var $5RTF6 = parcelRequire("5RTF6");

var $fYpGK = parcelRequire("fYpGK");

var $cvg5R = parcelRequire("cvg5R");

var $iRLKp = parcelRequire("iRLKp");
const $1bd7e790a57f14c4$var$hasChildren = (node, checkLength)=>{
    if (!node) return false;
    const base = node.props?.children ?? node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $1bd7e790a57f14c4$var$getChildren = (node)=>{
    if (!node) return [];
    const children = node.props?.children ?? node.children;
    return node.props?.i18nIsDynamicList ? $1bd7e790a57f14c4$var$getAsArray(children) : children;
};
const $1bd7e790a57f14c4$var$hasValidReactChildren = (children)=>Array.isArray(children) && children.every((0, $7fPBF.isValidElement));
const $1bd7e790a57f14c4$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $1bd7e790a57f14c4$var$mergeProps = (source, target)=>{
    const newTarget = {
        ...target
    };
    newTarget.props = {
        ...target.props,
        ...source.props
    };
    return newTarget;
};
const $1bd7e790a57f14c4$var$getValuesFromChildren = (children)=>{
    const values = {};
    if (!children) return values;
    const getData = (childs)=>{
        const childrenArray = $1bd7e790a57f14c4$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $5RTF6.isString)(child)) return;
            if ($1bd7e790a57f14c4$var$hasChildren(child)) getData($1bd7e790a57f14c4$var$getChildren(child));
            else if ((0, $5RTF6.isObject)(child) && !(0, $7fPBF.isValidElement)(child)) Object.assign(values, child);
        });
    };
    getData(children);
    return values;
};
const $1bd7e790a57f14c4$export$4f7a36dd898f1267 = (children, i18nOptions, i18n, i18nKey)=>{
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $1bd7e790a57f14c4$var$getAsArray(children);
    const keepArray = i18nOptions?.transSupportBasicHtmlNodes ? i18nOptions.transKeepBasicHtmlNodesFor ?? [] : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, $5RTF6.isString)(child)) {
            stringNode += `${child}`;
            return;
        }
        if ((0, $7fPBF.isValidElement)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) {
                stringNode += `<${type}/>`;
                return;
            }
            if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) {
                stringNode += `<${childIndex}></${childIndex}>`;
                return;
            }
            if (shouldKeepChild && childPropsCount === 1 && (0, $5RTF6.isString)(childChildren)) {
                stringNode += `<${type}>${childChildren}</${type}>`;
                return;
            }
            const content = $1bd7e790a57f14c4$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
            stringNode += `<${childIndex}>${content}</${childIndex}>`;
            return;
        }
        if (child === null) {
            (0, $5RTF6.warn)(i18n, 'TRANS_NULL_VALUE', `Passed in a null value as child`, {
                i18nKey: i18nKey
            });
            return;
        }
        if ((0, $5RTF6.isObject)(child)) {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
                return;
            }
            (0, $5RTF6.warn)(i18n, 'TRANS_INVALID_OBJ', `Invalid child - Object should only have keys {{ value, format }} (format is optional).`, {
                i18nKey: i18nKey,
                child: child
            });
            return;
        }
        (0, $5RTF6.warn)(i18n, 'TRANS_INVALID_VAR', `Passed in a variable like {number} - pass variables for interpolation as full objects like {{number}}.`, {
            i18nKey: i18nKey,
            child: child
        });
    });
    return stringNode;
};
const $1bd7e790a57f14c4$var$escapeLiteralLessThan = (str, keepArray = [], knownComponentsMap = {})=>{
    if (!str) return str;
    const knownNames = Object.keys(knownComponentsMap);
    const allValidNames = [
        ...keepArray,
        ...knownNames
    ];
    let result = '';
    let i = 0;
    while(i < str.length)if (str[i] === '<') {
        let isValidTag = false;
        const closingMatch = str.slice(i).match(/^<\/(\d+|[a-zA-Z][a-zA-Z0-9_-]*)>/);
        if (closingMatch) {
            const tagName = closingMatch[1];
            if (/^\d+$/.test(tagName) || allValidNames.includes(tagName)) {
                isValidTag = true;
                result += closingMatch[0];
                i += closingMatch[0].length;
            }
        }
        if (!isValidTag) {
            const openingMatch = str.slice(i).match(/^<(\d+|[a-zA-Z][a-zA-Z0-9_-]*)(\s+[\w-]+(?:=(?:"[^"]*"|'[^']*'|[^\s>]+))?)*\s*(\/)?>/);
            if (openingMatch) {
                const tagName = openingMatch[1];
                if (/^\d+$/.test(tagName) || allValidNames.includes(tagName)) {
                    isValidTag = true;
                    result += openingMatch[0];
                    i += openingMatch[0].length;
                }
            }
        }
        if (!isValidTag) {
            result += '&lt;';
            i += 1;
        }
    } else {
        result += str[i];
        i += 1;
    }
    return result;
};
const $1bd7e790a57f14c4$var$renderNodes = (children, knownComponentsMap, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !knownComponentsMap && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = knownComponentsMap ?? {};
    const getData = (childs)=>{
        const childrenArray = $1bd7e790a57f14c4$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $5RTF6.isString)(child)) return;
            if ($1bd7e790a57f14c4$var$hasChildren(child)) getData($1bd7e790a57f14c4$var$getChildren(child));
            else if ((0, $5RTF6.isObject)(child) && !(0, $7fPBF.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const escapedString = $1bd7e790a57f14c4$var$escapeLiteralLessThan(targetString, keepArray, data);
    const ast = (0, $58Q0I.default).parse(`<0>${escapedString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    const renderInner = (child, node, rootReactNode)=>{
        const childs = $1bd7e790a57f14c4$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $1bd7e790a57f14c4$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props?.i18nIsDynamicList ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $7fPBF.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $7fPBF.Children).map([
            child
        ], (c)=>{
            const INTERNAL_DYNAMIC_MARKER = 'data-i18n-is-dynamic-list';
            const override = {
                key: i,
                [INTERNAL_DYNAMIC_MARKER]: undefined
            };
            if (c && c.props) Object.keys(c.props).forEach((k)=>{
                if (k === 'ref' || k === 'children' || k === 'i18nIsDynamicList' || k === INTERNAL_DYNAMIC_MARKER) return;
                override[k] = c.props[k];
            });
            return (0, $7fPBF.cloneElement)(c, override, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $1bd7e790a57f14c4$var$getAsArray(reactNode);
        const astNodes = $1bd7e790a57f14c4$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children?.[0]?.content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && knownComponentsMap) tmp = knownComponentsMap[node.name];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const props = {
                    ...node.attrs
                };
                if (shouldUnescape) Object.keys(props).forEach((p)=>{
                    const val = props[p];
                    if ((0, $5RTF6.isString)(val)) props[p] = (0, $iRLKp.unescape)(val);
                });
                const child = Object.keys(props).length !== 0 ? $1bd7e790a57f14c4$var$mergeProps({
                    props: props
                }, tmp) : tmp;
                const isElement = (0, $7fPBF.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $1bd7e790a57f14c4$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $5RTF6.isObject)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, $5RTF6.isObject)(knownComponentsMap) && Object.hasOwnProperty.call(knownComponentsMap, node.name);
                if ((0, $5RTF6.isString)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($1bd7e790a57f14c4$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $7fPBF.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $7fPBF.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, $5RTF6.isObject)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const unescapeFn = typeof i18nOptions.unescape === 'function' ? i18nOptions.unescape : (0, $fYpGK.getDefaults)().unescape;
                const content = shouldUnescape ? unescapeFn(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $7fPBF.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $1bd7e790a57f14c4$var$getAsArray(children || []));
    return $1bd7e790a57f14c4$var$getChildren(result[0]);
};
const $1bd7e790a57f14c4$var$fixComponentProps = (component, index, translation)=>{
    const componentKey = component.key || index;
    const comp = (0, $7fPBF.cloneElement)(component, {
        key: componentKey
    });
    if (!comp.props || !comp.props.children || translation.indexOf(`${index}/>`) < 0 && translation.indexOf(`${index} />`) < 0) return comp;
    function Componentized() {
        return (0, $7fPBF.createElement)((0, $7fPBF.Fragment), null, comp);
    }
    return (0, $7fPBF.createElement)(Componentized, {
        key: componentKey
    });
};
const $1bd7e790a57f14c4$var$generateArrayComponents = (components, translation)=>components.map((c, index)=>$1bd7e790a57f14c4$var$fixComponentProps(c, index, translation));
const $1bd7e790a57f14c4$var$generateObjectComponents = (components, translation)=>{
    const componentMap = {};
    Object.keys(components).forEach((c)=>{
        Object.assign(componentMap, {
            [c]: $1bd7e790a57f14c4$var$fixComponentProps(components[c], c, translation)
        });
    });
    return componentMap;
};
const $1bd7e790a57f14c4$var$generateComponents = (components, translation, i18n, i18nKey)=>{
    if (!components) return null;
    if (Array.isArray(components)) return $1bd7e790a57f14c4$var$generateArrayComponents(components, translation);
    if ((0, $5RTF6.isObject)(components)) return $1bd7e790a57f14c4$var$generateObjectComponents(components, translation);
    (0, $5RTF6.warnOnce)(i18n, 'TRANS_INVALID_COMPONENTS', `<Trans /> "components" prop expects an object or array`, {
        i18nKey: i18nKey
    });
    return null;
};
const $1bd7e790a57f14c4$var$isComponentsMap = (object)=>{
    if (!(0, $5RTF6.isObject)(object)) return false;
    if (Array.isArray(object)) return false;
    return Object.keys(object).reduce((acc, key)=>acc && Number.isNaN(Number.parseFloat(key)), true);
};
function $1bd7e790a57f14c4$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const i18n = i18nFromProps || (0, $cvg5R.getI18n)();
    if (!i18n) {
        (0, $5RTF6.warnOnce)(i18n, 'NO_I18NEXT_INSTANCE', `Trans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, $fYpGK.getDefaults)(),
        ...i18n.options?.react
    };
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $5RTF6.isString)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const { transDefaultProps: transDefaultProps } = reactI18nextOptions;
    const mergedTOptions = transDefaultProps?.tOptions ? {
        ...transDefaultProps.tOptions,
        ...tOptions
    } : tOptions;
    const mergedShouldUnescape = shouldUnescape ?? transDefaultProps?.shouldUnescape;
    const mergedValues = transDefaultProps?.values ? {
        ...transDefaultProps.values,
        ...values
    } : values;
    const mergedComponents = transDefaultProps?.components ? {
        ...transDefaultProps.components,
        ...components
    } : components;
    const nodeAsString = $1bd7e790a57f14c4$export$4f7a36dd898f1267(children, reactI18nextOptions, i18n, i18nKey);
    const defaultValue = defaults || mergedTOptions?.defaultValue || nodeAsString || reactI18nextOptions.transEmptyNodeValue || (typeof i18nKey === 'function' ? (0, $2Bwgd.keyFromSelector)(i18nKey) : i18nKey);
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options?.interpolation?.defaultVariables) values = mergedValues && Object.keys(mergedValues).length > 0 ? {
        ...mergedValues,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    else values = mergedValues;
    const valuesFromChildren = $1bd7e790a57f14c4$var$getValuesFromChildren(children);
    if (valuesFromChildren && typeof valuesFromChildren.count === 'number' && count === undefined) count = valuesFromChildren.count;
    const interpolationOverride = values || count !== undefined && !i18n.options?.interpolation?.alwaysFormat || !children ? mergedTOptions.interpolation : {
        interpolation: {
            ...mergedTOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...mergedTOptions,
        context: context || mergedTOptions.context,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    let translation = key ? t(key, combinedTOpts) : defaultValue;
    if (translation === key && defaultValue) translation = defaultValue;
    const generatedComponents = $1bd7e790a57f14c4$var$generateComponents(mergedComponents, translation, i18n, i18nKey);
    let indexedChildren = generatedComponents || children;
    let componentsMap = null;
    if ($1bd7e790a57f14c4$var$isComponentsMap(generatedComponents)) {
        componentsMap = generatedComponents;
        indexedChildren = children;
    }
    const content = $1bd7e790a57f14c4$var$renderNodes(indexedChildren, componentsMap, translation, i18n, reactI18nextOptions, combinedTOpts, mergedShouldUnescape);
    const useAsParent = parent ?? reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $7fPBF.createElement)(useAsParent, additionalProps, content) : content;
}

});
parcelRegister("58Q0I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3be60b4f29d3a6e3$export$2e2bcd8739ae039; });

var $kLNeb = parcelRequire("kLNeb");
var $3be60b4f29d3a6e3$var$e = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?("[^"]*"|'[^']*')/g;
function $3be60b4f29d3a6e3$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($kLNeb)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($3be60b4f29d3a6e3$var$e), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var l = c[1].trim(), o = [
                l,
                ""
            ];
            l.indexOf("=") > -1 && (o = l.split("=")), r.attrs[o[0]] = o[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $3be60b4f29d3a6e3$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $3be60b4f29d3a6e3$var$i = /^\s*$/, $3be60b4f29d3a6e3$var$s = Object.create(null);
function $3be60b4f29d3a6e3$var$a(t, e) {
    switch(e.type){
        case "text":
            return t + e.content;
        case "tag":
            return t += "<" + e.name + (e.attrs ? function(t) {
                var e = [];
                for(var n in t)e.push(n + '="' + t[n] + '"');
                return e.length ? " " + e.join(" ") : "";
            }(e.attrs) : "") + (e.voidElement ? "/>" : ">"), e.voidElement ? t : t + e.children.reduce($3be60b4f29d3a6e3$var$a, "") + "</" + e.name + ">";
        case "comment":
            return t + "\x3c!--" + e.comment + "--\x3e";
    }
}
var $3be60b4f29d3a6e3$var$c = {
    parse: function(t, e) {
        e || (e = {}), e.components || (e.components = $3be60b4f29d3a6e3$var$s);
        var a, c = [], l = [], o = -1, u = !1;
        if (0 !== t.indexOf("<")) {
            var h = t.indexOf("<");
            c.push({
                type: "text",
                content: -1 === h ? t : t.substring(0, h)
            });
        }
        for(var v, f = []; v = $3be60b4f29d3a6e3$var$r.exec(t);)f.push(v);
        return f.forEach(function(t, e) {
            var n = t[0];
            if (n && !n.startsWith("\x3c!--")) {
                for(var r = 0, i = 0, s = -1, a = null, c = 0; c < n.length; c++){
                    var l = n.charAt(c);
                    a ? l === a && (a = null) : '"' === l || "'" === l ? a = l : "<" === l ? 2 == ++r && (s = c) : ">" === l && i++;
                }
                var o = s > -1 && /[a-zA-Z0-9\-!/]/.test(n.charAt(s + 1));
                if (r > i && o) {
                    var u = n.substring(0, s), h = n.substring(u.length);
                    f[e][0] = h, f[e].index += u.length;
                }
            }
        }), f.forEach(function(r, s) {
            var h = r[0];
            if (h) {
                var v = r.index;
                if (u) {
                    if (h !== "</" + a.name + ">") return;
                    u = !1;
                }
                var m, d, p = "/" !== h.charAt(1), x = h.startsWith("\x3c!--"), g = v + h.length, y = t.charAt(g), E = f[s + 1];
                if ("<" === y && E) {
                    var A = t.substring(g, E.index);
                    m = A.split("<").length > A.split(">").length;
                }
                if (x) {
                    var b = $3be60b4f29d3a6e3$var$n(h);
                    if (o < 0) return c.push(b), c;
                    (d = l[o]).children.push(b);
                    var O = t.slice(g, E ? E.index : void 0);
                    return O.length > 0 && d.children.push({
                        type: "text",
                        content: O
                    }), c;
                }
                if (p && (o++, "tag" === (a = $3be60b4f29d3a6e3$var$n(h)).type && e.components[a.name] && (a.type = "component", u = !0), a.voidElement || u || !y || "<" === y || a.children.push({
                    type: "text",
                    content: t.slice(g, E ? E.index : void 0)
                }), 0 === o && c.push(a), (d = l[o - 1]) && d.children.push(a), l[o] = a), (!p || a.voidElement) && (o > -1 && (a.voidElement || a.name === h.slice(2, -1)) && (o--, a = -1 === o ? c : l[o]), !u && ("<" !== y || m) && y)) {
                    d = -1 === o ? c : l[o].children;
                    var W = E ? E.index : -1, j = t.slice(g, -1 === W ? void 0 : W);
                    $3be60b4f29d3a6e3$var$i.test(j) && (j = " "), (W > -1 && o + d.length >= 0 || " " !== j) && d.push({
                        type: "text",
                        content: j
                    });
                }
            }
        }), c;
    },
    stringify: function(t) {
        return t.reduce(function(t, e) {
            return t + $3be60b4f29d3a6e3$var$a("", e);
        }, "");
    }
};
var $3be60b4f29d3a6e3$export$2e2bcd8739ae039 = $3be60b4f29d3a6e3$var$c;

});
parcelRegister("kLNeb", function(module, exports) {
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ module.exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};

});


parcelRegister("5RTF6", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $445d14444882807b$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "isString", function () { return $445d14444882807b$export$844ec244b1367d54; });
$parcel$export(module.exports, "warnOnce", function () { return $445d14444882807b$export$5b28268982f175ba; });
$parcel$export(module.exports, "loadNamespaces", function () { return $445d14444882807b$export$83be934b53fff43b; });
$parcel$export(module.exports, "loadLanguages", function () { return $445d14444882807b$export$8cd7e7a54fa865bc; });
$parcel$export(module.exports, "hasLoadedNamespace", function () { return $445d14444882807b$export$93d9ee97c1ad3f31; });
$parcel$export(module.exports, "getDisplayName", function () { return $445d14444882807b$export$be63e0664592e141; });
$parcel$export(module.exports, "isObject", function () { return $445d14444882807b$export$a6cdc56e425d0d0a; });
const $445d14444882807b$export$c106dd0671a0fc2d = (i18n, code, msg, rest)=>{
    const args = [
        msg,
        {
            code: code,
            ...rest || {}
        }
    ];
    if (i18n?.services?.logger?.forward) return i18n.services.logger.forward(args, 'warn', 'react-i18next::', true);
    if ($445d14444882807b$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
    if (i18n?.services?.logger?.warn) i18n.services.logger.warn(...args);
    else if (console?.warn) console.warn(...args);
};
const $445d14444882807b$var$alreadyWarned = {};
const $445d14444882807b$export$5b28268982f175ba = (i18n, code, msg, rest)=>{
    if ($445d14444882807b$export$844ec244b1367d54(msg) && $445d14444882807b$var$alreadyWarned[msg]) return;
    if ($445d14444882807b$export$844ec244b1367d54(msg)) $445d14444882807b$var$alreadyWarned[msg] = new Date();
    $445d14444882807b$export$c106dd0671a0fc2d(i18n, code, msg, rest);
};
const $445d14444882807b$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const $445d14444882807b$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $445d14444882807b$var$loadedClb(i18n, cb));
};
const $445d14444882807b$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($445d14444882807b$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return $445d14444882807b$export$83be934b53fff43b(i18n, ns, cb);
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $445d14444882807b$var$loadedClb(i18n, cb));
};
const $445d14444882807b$export$93d9ee97c1ad3f31 = (ns, i18n, options = {})=>{
    if (!i18n.languages || !i18n.languages.length) {
        $445d14444882807b$export$5b28268982f175ba(i18n, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
            languages: i18n.languages
        });
        return true;
    }
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $445d14444882807b$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($445d14444882807b$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : 'Unknown');
const $445d14444882807b$export$844ec244b1367d54 = (obj)=>typeof obj === 'string';
const $445d14444882807b$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'object' && obj !== null;

});

parcelRegister("fYpGK", function(module, exports) {

$parcel$export(module.exports, "setDefaults", function () { return $ba1062cc0d1f4b93$export$2e2366488d12e20d; });
$parcel$export(module.exports, "getDefaults", function () { return $ba1062cc0d1f4b93$export$212bb2fc580a90a8; });

var $iRLKp = parcelRequire("iRLKp");
let $ba1062cc0d1f4b93$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $iRLKp.unescape,
    transDefaultProps: undefined
};
const $ba1062cc0d1f4b93$export$2e2366488d12e20d = (options = {})=>{
    $ba1062cc0d1f4b93$var$defaultOptions = {
        ...$ba1062cc0d1f4b93$var$defaultOptions,
        ...options
    };
};
const $ba1062cc0d1f4b93$export$212bb2fc580a90a8 = ()=>$ba1062cc0d1f4b93$var$defaultOptions;

});
parcelRegister("iRLKp", function(module, exports) {

$parcel$export(module.exports, "unescape", function () { return $dbc236e0ae4b1bc0$export$e8bacd2802a88316; });
const $dbc236e0ae4b1bc0$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $dbc236e0ae4b1bc0$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $dbc236e0ae4b1bc0$var$unescapeHtmlEntity = (m)=>$dbc236e0ae4b1bc0$var$htmlEntities[m];
const $dbc236e0ae4b1bc0$export$e8bacd2802a88316 = (text)=>text.replace($dbc236e0ae4b1bc0$var$matchHtmlEntity, $dbc236e0ae4b1bc0$var$unescapeHtmlEntity);

});


parcelRegister("cvg5R", function(module, exports) {

$parcel$export(module.exports, "setI18n", function () { return $91a4dd25d142fe34$export$a039134f2fc7e0; });
$parcel$export(module.exports, "getI18n", function () { return $91a4dd25d142fe34$export$64af334f494c2f47; });
let $91a4dd25d142fe34$var$i18nInstance;
const $91a4dd25d142fe34$export$a039134f2fc7e0 = (instance)=>{
    $91a4dd25d142fe34$var$i18nInstance = instance;
};
const $91a4dd25d142fe34$export$64af334f494c2f47 = ()=>$91a4dd25d142fe34$var$i18nInstance;

});


parcelRegister("beOCj", function(module, exports) {

$parcel$export(module.exports, "I18nContext", function () { return $021c8539c0651064$export$5603ab5ced17ce64; });
$parcel$export(module.exports, "ReportNamespaces", function () { return $021c8539c0651064$export$ea171b67e3820290; });
$parcel$export(module.exports, "composeInitialProps", function () { return $021c8539c0651064$export$30ff0342ccf735a; });
$parcel$export(module.exports, "getDefaults", function () { return (parcelRequire("fYpGK")).getDefaults; });
$parcel$export(module.exports, "getI18n", function () { return (parcelRequire("cvg5R")).getI18n; });

var $7fPBF = parcelRequire("7fPBF");

var $fYpGK = parcelRequire("fYpGK");

var $cvg5R = parcelRequire("cvg5R");

var $NDJJg = parcelRequire("NDJJg");
const $021c8539c0651064$export$5603ab5ced17ce64 = (0, $7fPBF.createContext)();
class $021c8539c0651064$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
const $021c8539c0651064$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        const componentsInitialProps = await ForComponent.getInitialProps?.(ctx) ?? {};
        const i18nInitialProps = $021c8539c0651064$export$704200e5d0b9e8f();
        return {
            ...componentsInitialProps,
            ...i18nInitialProps
        };
    };
const $021c8539c0651064$export$704200e5d0b9e8f = ()=>{
    const i18n = (0, $cvg5R.getI18n)();
    if (!i18n) {
        console.warn('react-i18next:: getInitialProps: You will need to pass in an i18next instance by using initReactI18next');
        return {};
    }
    const namespaces = i18n.reportNamespaces?.getUsedNamespaces() ?? [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};

});
parcelRegister("NDJJg", function(module, exports) {

$parcel$export(module.exports, "initReactI18next", function () { return $09536692873e4879$export$ae7e14d40d89f296; });

var $fYpGK = parcelRequire("fYpGK");

var $cvg5R = parcelRequire("cvg5R");
const $09536692873e4879$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $fYpGK.setDefaults)(instance.options.react);
        (0, $cvg5R.setI18n)(instance);
    }
};

});



parcelRegister("5GXoA", function(module, exports) {

var $7fPBF = parcelRequire("7fPBF");

var $cTpiV = parcelRequire("cTpiV");
parcelRequire("beOCj");
var $cvg5R = parcelRequire("cvg5R");
var $beOCj = parcelRequire("beOCj");
function $424ef2b2cfbf3440$export$c8b7e2ca8249a4be({ i18nKey: i18nKey, defaultTranslation: defaultTranslation, content: content, ns: ns, values: values = {}, i18n: i18nFromProps, t: tFromProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $7fPBF.useContext)((0, $beOCj.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $cvg5R.getI18n)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $cTpiV.IcuTransWithoutContext)({
        i18nKey: i18nKey,
        defaultTranslation: defaultTranslation,
        content: content,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        values: values,
        i18n: i18n,
        t: tFromProps
    });
}
$424ef2b2cfbf3440$export$c8b7e2ca8249a4be.displayName = 'IcuTrans';

});
parcelRegister("cTpiV", function(module, exports) {

$parcel$export(module.exports, "IcuTransWithoutContext", function () { return $962e4001c44da5c5$export$c70a6545d92ee1d4; });

var $7fPBF = parcelRequire("7fPBF");

var $5RTF6 = parcelRequire("5RTF6");

var $cvg5R = parcelRequire("cvg5R");
parcelRequire("jiH2D");
var $86Ica = parcelRequire("86Ica");
function $962e4001c44da5c5$export$c70a6545d92ee1d4({ i18nKey: i18nKey, defaultTranslation: defaultTranslation, content: content, ns: ns, values: values = {}, i18n: i18nFromProps, t: tFromProps }) {
    const i18n = i18nFromProps || (0, $cvg5R.getI18n)();
    if (!i18n) {
        (0, $5RTF6.warnOnce)(i18n, 'NO_I18NEXT_INSTANCE', `IcuTrans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, {}, defaultTranslation);
    }
    const t = tFromProps || i18n.t?.bind(i18n) || ((k)=>k);
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $5RTF6.isString)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    let mergedValues = values;
    if (i18n.options?.interpolation?.defaultVariables) mergedValues = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const translation = t(i18nKey, {
        defaultValue: defaultTranslation,
        ...mergedValues,
        ns: namespaces
    });
    try {
        const rendered = (0, $86Ica.renderTranslation)(translation, content);
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, {}, ...rendered);
    } catch (error) {
        (0, $5RTF6.warn)(i18n, 'ICU_TRANS_RENDER_ERROR', `IcuTrans component error for key "${i18nKey}": ${error.message}`, {
            i18nKey: i18nKey,
            error: error
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, {}, translation);
    }
}
$962e4001c44da5c5$export$c70a6545d92ee1d4.displayName = 'IcuTransWithoutContext';

});
parcelRegister("jiH2D", function(module, exports) {
$parcel$export(module.exports, "renderTranslation", function () { return (parcelRequire("86Ica")).renderTranslation; });
parcelRequire("gVZl1");
parcelRequire("6c5SV");
parcelRequire("5Yn7V");
parcelRequire("86Ica");

});
parcelRegister("gVZl1", function(module, exports) {

$parcel$export(module.exports, "TranslationParserError", function () { return $c5418ca6fb55c4c6$export$aa9e222d9ffc5d1b; });
class $c5418ca6fb55c4c6$export$aa9e222d9ffc5d1b extends Error {
    constructor(message, position, translationString){
        super(message);
        this.name = 'TranslationParserError';
        this.position = position;
        this.translationString = translationString;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $c5418ca6fb55c4c6$export$aa9e222d9ffc5d1b);
    }
}

});

parcelRegister("6c5SV", function(module, exports) {

$parcel$export(module.exports, "decodeHtmlEntities", function () { return $48286dae5f4c3dad$export$5cfeaa4af6841c8f; });
const $48286dae5f4c3dad$var$commonEntities = {
    '&nbsp;': '\u00A0',
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&apos;': "'",
    '&copy;': "\xa9",
    '&reg;': "\xae",
    '&trade;': "\u2122",
    '&hellip;': "\u2026",
    '&ndash;': "\u2013",
    '&mdash;': "\u2014",
    '&lsquo;': '\u2018',
    '&rsquo;': '\u2019',
    '&sbquo;': '\u201A',
    '&ldquo;': '\u201C',
    '&rdquo;': '\u201D',
    '&bdquo;': '\u201E',
    '&dagger;': "\u2020",
    '&Dagger;': "\u2021",
    '&bull;': "\u2022",
    '&prime;': "\u2032",
    '&Prime;': "\u2033",
    '&lsaquo;': "\u2039",
    '&rsaquo;': "\u203A",
    '&sect;': "\xa7",
    '&para;': "\xb6",
    '&middot;': "\xb7",
    '&ensp;': '\u2002',
    '&emsp;': '\u2003',
    '&thinsp;': '\u2009',
    '&euro;': "\u20AC",
    '&pound;': "\xa3",
    '&yen;': "\xa5",
    '&cent;': "\xa2",
    '&curren;': "\xa4",
    '&times;': "\xd7",
    '&divide;': "\xf7",
    '&minus;': "\u2212",
    '&plusmn;': "\xb1",
    '&ne;': "\u2260",
    '&le;': "\u2264",
    '&ge;': "\u2265",
    '&asymp;': "\u2248",
    '&equiv;': "\u2261",
    '&infin;': "\u221E",
    '&int;': "\u222B",
    '&sum;': "\u2211",
    '&prod;': "\u220F",
    '&radic;': "\u221A",
    '&part;': "\u2202",
    '&permil;': "\u2030",
    '&deg;': "\xb0",
    '&micro;': "\xb5",
    '&larr;': "\u2190",
    '&uarr;': "\u2191",
    '&rarr;': "\u2192",
    '&darr;': "\u2193",
    '&harr;': "\u2194",
    '&crarr;': "\u21B5",
    '&lArr;': "\u21D0",
    '&uArr;': "\u21D1",
    '&rArr;': "\u21D2",
    '&dArr;': "\u21D3",
    '&hArr;': "\u21D4",
    '&alpha;': "\u03B1",
    '&beta;': "\u03B2",
    '&gamma;': "\u03B3",
    '&delta;': "\u03B4",
    '&epsilon;': "\u03B5",
    '&zeta;': "\u03B6",
    '&eta;': "\u03B7",
    '&theta;': "\u03B8",
    '&iota;': "\u03B9",
    '&kappa;': "\u03BA",
    '&lambda;': "\u03BB",
    '&mu;': "\u03BC",
    '&nu;': "\u03BD",
    '&xi;': "\u03BE",
    '&omicron;': "\u03BF",
    '&pi;': "\u03C0",
    '&rho;': "\u03C1",
    '&sigma;': "\u03C3",
    '&tau;': "\u03C4",
    '&upsilon;': "\u03C5",
    '&phi;': "\u03C6",
    '&chi;': "\u03C7",
    '&psi;': "\u03C8",
    '&omega;': "\u03C9",
    '&Alpha;': "\u0391",
    '&Beta;': "\u0392",
    '&Gamma;': "\u0393",
    '&Delta;': "\u0394",
    '&Epsilon;': "\u0395",
    '&Zeta;': "\u0396",
    '&Eta;': "\u0397",
    '&Theta;': "\u0398",
    '&Iota;': "\u0399",
    '&Kappa;': "\u039A",
    '&Lambda;': "\u039B",
    '&Mu;': "\u039C",
    '&Nu;': "\u039D",
    '&Xi;': "\u039E",
    '&Omicron;': "\u039F",
    '&Pi;': "\u03A0",
    '&Rho;': "\u03A1",
    '&Sigma;': "\u03A3",
    '&Tau;': "\u03A4",
    '&Upsilon;': "\u03A5",
    '&Phi;': "\u03A6",
    '&Chi;': "\u03A7",
    '&Psi;': "\u03A8",
    '&Omega;': "\u03A9",
    '&Agrave;': "\xc0",
    '&Aacute;': "\xc1",
    '&Acirc;': "\xc2",
    '&Atilde;': "\xc3",
    '&Auml;': "\xc4",
    '&Aring;': "\xc5",
    '&AElig;': "\xc6",
    '&Ccedil;': "\xc7",
    '&Egrave;': "\xc8",
    '&Eacute;': "\xc9",
    '&Ecirc;': "\xca",
    '&Euml;': "\xcb",
    '&Igrave;': "\xcc",
    '&Iacute;': "\xcd",
    '&Icirc;': "\xce",
    '&Iuml;': "\xcf",
    '&ETH;': "\xd0",
    '&Ntilde;': "\xd1",
    '&Ograve;': "\xd2",
    '&Oacute;': "\xd3",
    '&Ocirc;': "\xd4",
    '&Otilde;': "\xd5",
    '&Ouml;': "\xd6",
    '&Oslash;': "\xd8",
    '&Ugrave;': "\xd9",
    '&Uacute;': "\xda",
    '&Ucirc;': "\xdb",
    '&Uuml;': "\xdc",
    '&Yacute;': "\xdd",
    '&THORN;': "\xde",
    '&szlig;': "\xdf",
    '&agrave;': "\xe0",
    '&aacute;': "\xe1",
    '&acirc;': "\xe2",
    '&atilde;': "\xe3",
    '&auml;': "\xe4",
    '&aring;': "\xe5",
    '&aelig;': "\xe6",
    '&ccedil;': "\xe7",
    '&egrave;': "\xe8",
    '&eacute;': "\xe9",
    '&ecirc;': "\xea",
    '&euml;': "\xeb",
    '&igrave;': "\xec",
    '&iacute;': "\xed",
    '&icirc;': "\xee",
    '&iuml;': "\xef",
    '&eth;': "\xf0",
    '&ntilde;': "\xf1",
    '&ograve;': "\xf2",
    '&oacute;': "\xf3",
    '&ocirc;': "\xf4",
    '&otilde;': "\xf5",
    '&ouml;': "\xf6",
    '&oslash;': "\xf8",
    '&ugrave;': "\xf9",
    '&uacute;': "\xfa",
    '&ucirc;': "\xfb",
    '&uuml;': "\xfc",
    '&yacute;': "\xfd",
    '&thorn;': "\xfe",
    '&yuml;': "\xff",
    '&iexcl;': "\xa1",
    '&iquest;': "\xbf",
    '&fnof;': "\u0192",
    '&circ;': "\u02C6",
    '&tilde;': "\u02DC",
    '&OElig;': "\u0152",
    '&oelig;': "\u0153",
    '&Scaron;': "\u0160",
    '&scaron;': "\u0161",
    '&Yuml;': "\u0178",
    '&ordf;': "\xaa",
    '&ordm;': "\xba",
    '&macr;': "\xaf",
    '&acute;': "\xb4",
    '&cedil;': "\xb8",
    '&sup1;': "\xb9",
    '&sup2;': "\xb2",
    '&sup3;': "\xb3",
    '&frac14;': "\xbc",
    '&frac12;': "\xbd",
    '&frac34;': "\xbe",
    '&spades;': "\u2660",
    '&clubs;': "\u2663",
    '&hearts;': "\u2665",
    '&diams;': "\u2666",
    '&loz;': "\u25CA",
    '&oline;': "\u203E",
    '&frasl;': "\u2044",
    '&weierp;': "\u2118",
    '&image;': "\u2111",
    '&real;': "\u211C",
    '&alefsym;': "\u2135"
};
const $48286dae5f4c3dad$var$entityPattern = new RegExp(Object.keys($48286dae5f4c3dad$var$commonEntities).map((entity)=>entity.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|'), 'g');
const $48286dae5f4c3dad$export$5cfeaa4af6841c8f = (text)=>text.replace($48286dae5f4c3dad$var$entityPattern, (match)=>$48286dae5f4c3dad$var$commonEntities[match]).replace(/&#(\d+);/g, (_, num)=>String.fromCharCode(parseInt(num, 10))).replace(/&#x([0-9a-fA-F]+);/g, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));

});

parcelRegister("5Yn7V", function(module, exports) {

$parcel$export(module.exports, "tokenize", function () { return $45947edc0057df9f$export$660b2ee2d4fb4eff; });
const $45947edc0057df9f$export$660b2ee2d4fb4eff = (translation)=>{
    const tokens = [];
    let position = 0;
    let currentText = '';
    const flushText = ()=>{
        if (currentText) {
            tokens.push({
                type: 'Text',
                value: currentText,
                position: position - currentText.length
            });
            currentText = '';
        }
    };
    while(position < translation.length){
        const char = translation[position];
        if (char === '<') {
            const tagMatch = translation.slice(position).match(/^<(\d+)>/);
            if (tagMatch) {
                flushText();
                tokens.push({
                    type: 'TagOpen',
                    value: tagMatch[0],
                    position: position,
                    tagNumber: parseInt(tagMatch[1], 10)
                });
                position += tagMatch[0].length;
            } else {
                const closeTagMatch = translation.slice(position).match(/^<\/(\d+)>/);
                if (closeTagMatch) {
                    flushText();
                    tokens.push({
                        type: 'TagClose',
                        value: closeTagMatch[0],
                        position: position,
                        tagNumber: parseInt(closeTagMatch[1], 10)
                    });
                    position += closeTagMatch[0].length;
                } else {
                    currentText += char;
                    position += 1;
                }
            }
        } else {
            currentText += char;
            position += 1;
        }
    }
    flushText();
    return tokens;
};

});

parcelRegister("86Ica", function(module, exports) {

$parcel$export(module.exports, "renderTranslation", function () { return $5e712a8a2c442d0c$export$1038df9fa5e5f35f; });

var $7fPBF = parcelRequire("7fPBF");

var $gVZl1 = parcelRequire("gVZl1");

var $5Yn7V = parcelRequire("5Yn7V");

var $6c5SV = parcelRequire("6c5SV");
const $5e712a8a2c442d0c$var$renderDeclarationNode = (declaration, children, childDeclarations)=>{
    const { type: type, props: props = {} } = declaration;
    if (props.children && Array.isArray(props.children) && childDeclarations) {
        const { children: _childrenToRemove, ...propsWithoutChildren } = props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(type, propsWithoutChildren, ...children);
    }
    if (children.length === 0) return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(type, props);
    if (children.length === 1) return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(type, props, children[0]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(type, props, ...children);
};
const $5e712a8a2c442d0c$export$1038df9fa5e5f35f = (translation, declarations = [])=>{
    if (!translation) return [];
    const tokens = (0, $5Yn7V.tokenize)(translation);
    const result = [];
    const stack = [];
    const literalTagNumbers = new Set();
    const getCurrentDeclarations = ()=>{
        if (stack.length === 0) return declarations;
        const parentFrame = stack[stack.length - 1];
        if (parentFrame.declaration.props?.children && Array.isArray(parentFrame.declaration.props.children)) return parentFrame.declaration.props.children;
        return parentFrame.declarations;
    };
    tokens.forEach((token)=>{
        switch(token.type){
            case 'Text':
                {
                    const decoded = (0, $6c5SV.decodeHtmlEntities)(token.value);
                    const targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    targetArray.push(decoded);
                }
                break;
            case 'TagOpen':
                {
                    const { tagNumber: tagNumber } = token;
                    const currentDeclarations = getCurrentDeclarations();
                    const declaration = currentDeclarations[tagNumber];
                    if (!declaration) {
                        literalTagNumbers.add(tagNumber);
                        const literalText = `<${tagNumber}>`;
                        const targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        targetArray.push(literalText);
                        break;
                    }
                    stack.push({
                        tagNumber: tagNumber,
                        children: [],
                        position: token.position,
                        declaration: declaration,
                        declarations: currentDeclarations
                    });
                }
                break;
            case 'TagClose':
                {
                    const { tagNumber: tagNumber } = token;
                    if (literalTagNumbers.has(tagNumber)) {
                        const literalText = `</${tagNumber}>`;
                        const literalTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        literalTargetArray.push(literalText);
                        literalTagNumbers.delete(tagNumber);
                        break;
                    }
                    if (stack.length === 0) throw new (0, $gVZl1.TranslationParserError)(`Unexpected closing tag </${tagNumber}> at position ${token.position}`, token.position, translation);
                    const frame = stack.pop();
                    if (frame.tagNumber !== tagNumber) throw new (0, $gVZl1.TranslationParserError)(`Mismatched tags: expected </${frame.tagNumber}> but got </${tagNumber}> at position ${token.position}`, token.position, translation);
                    const element = $5e712a8a2c442d0c$var$renderDeclarationNode(frame.declaration, frame.children, frame.declarations);
                    const elementTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    elementTargetArray.push(element);
                }
                break;
        }
    });
    if (stack.length > 0) {
        const unclosed = stack[stack.length - 1];
        throw new (0, $gVZl1.TranslationParserError)(`Unclosed tag <${unclosed.tagNumber}> at position ${unclosed.position}`, unclosed.position, translation);
    }
    return result;
};

});




parcelRegister("doyfp", function(module, exports) {

$parcel$export(module.exports, "useTranslation", function () { return $9c081519ec78392c$export$9fc83ad70ead8663; });

var $7fPBF = parcelRequire("7fPBF");

var $hL6ll = parcelRequire("hL6ll");
parcelRequire("beOCj");
var $fYpGK = parcelRequire("fYpGK");
var $cvg5R = parcelRequire("cvg5R");
var $beOCj = parcelRequire("beOCj");

var $5RTF6 = parcelRequire("5RTF6");
const $9c081519ec78392c$var$notReadyT = (k, optsOrDefaultValue)=>{
    if ((0, $5RTF6.isString)(optsOrDefaultValue)) return optsOrDefaultValue;
    if ((0, $5RTF6.isObject)(optsOrDefaultValue) && (0, $5RTF6.isString)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
    if (typeof k === 'function') return '';
    if (Array.isArray(k)) {
        const last = k[k.length - 1];
        return typeof last === 'function' ? '' : last;
    }
    return k;
};
const $9c081519ec78392c$var$notReadySnapshot = {
    t: $9c081519ec78392c$var$notReadyT,
    ready: false
};
const $9c081519ec78392c$var$dummySubscribe = ()=>()=>{};
const $9c081519ec78392c$export$9fc83ad70ead8663 = (ns, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $7fPBF.useContext)((0, $beOCj.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $cvg5R.getI18n)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $beOCj.ReportNamespaces)();
    if (!i18n) (0, $5RTF6.warnOnce)(i18n, 'NO_I18NEXT_INSTANCE', 'useTranslation: You will need to pass in an i18next instance by using initReactI18next');
    const i18nOptions = (0, $7fPBF.useMemo)(()=>({
            ...(0, $fYpGK.getDefaults)(),
            ...i18n?.options?.react,
            ...props
        }), [
        i18n,
        props
    ]);
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    const nsOrContext = ns || defaultNSFromContext || i18n?.options?.defaultNS;
    const unstableNamespaces = (0, $5RTF6.isString)(nsOrContext) ? [
        nsOrContext
    ] : nsOrContext || [
        'translation'
    ];
    const namespaces = (0, $7fPBF.useMemo)(()=>unstableNamespaces, unstableNamespaces);
    i18n?.reportNamespaces?.addUsedNamespaces?.(namespaces);
    const revisionRef = (0, $7fPBF.useRef)(0);
    const subscribe = (0, $7fPBF.useCallback)((callback)=>{
        if (!i18n) return $9c081519ec78392c$var$dummySubscribe;
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        const wrappedCallback = ()=>{
            revisionRef.current += 1;
            callback();
        };
        if (bindI18n) i18n.on(bindI18n, wrappedCallback);
        if (bindI18nStore) i18n.store.on(bindI18nStore, wrappedCallback);
        return ()=>{
            if (bindI18n) bindI18n.split(' ').forEach((e)=>i18n.off(e, wrappedCallback));
            if (bindI18nStore) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, wrappedCallback));
        };
    }, [
        i18n,
        i18nOptions
    ]);
    const snapshotRef = (0, $7fPBF.useRef)();
    const getSnapshot = (0, $7fPBF.useCallback)(()=>{
        if (!i18n) return $9c081519ec78392c$var$notReadySnapshot;
        const calculatedReady = !!(i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $5RTF6.hasLoadedNamespace)(n, i18n, i18nOptions));
        const currentLng = props.lng || i18n.language;
        const currentRevision = revisionRef.current;
        const lastSnapshot = snapshotRef.current;
        if (lastSnapshot && lastSnapshot.ready === calculatedReady && lastSnapshot.lng === currentLng && lastSnapshot.keyPrefix === keyPrefix && lastSnapshot.revision === currentRevision) return lastSnapshot;
        const calculatedT = i18n.getFixedT(currentLng, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
        const newSnapshot = {
            t: calculatedT,
            ready: calculatedReady,
            lng: currentLng,
            keyPrefix: keyPrefix,
            revision: currentRevision
        };
        snapshotRef.current = newSnapshot;
        return newSnapshot;
    }, [
        i18n,
        namespaces,
        keyPrefix,
        i18nOptions,
        props.lng
    ]);
    const [loadCount, setLoadCount] = (0, $7fPBF.useState)(0);
    const { t: t, ready: ready } = (0, $hL6ll.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    (0, $7fPBF.useEffect)(()=>{
        if (i18n && !ready && !useSuspense) {
            const onLoaded = ()=>setLoadCount((c)=>c + 1);
            if (props.lng) (0, $5RTF6.loadLanguages)(i18n, props.lng, namespaces, onLoaded);
            else (0, $5RTF6.loadNamespaces)(i18n, namespaces, onLoaded);
        }
    }, [
        i18n,
        props.lng,
        namespaces,
        ready,
        useSuspense,
        loadCount
    ]);
    const finalI18n = i18n || {};
    const wrapperRef = (0, $7fPBF.useRef)(null);
    const wrapperLangRef = (0, $7fPBF.useRef)();
    const createI18nWrapper = (original)=>{
        const descriptors = Object.getOwnPropertyDescriptors(original);
        if (descriptors.__original) delete descriptors.__original;
        const wrapper = Object.create(Object.getPrototypeOf(original), descriptors);
        if (!Object.prototype.hasOwnProperty.call(wrapper, '__original')) try {
            Object.defineProperty(wrapper, '__original', {
                value: original,
                writable: false,
                enumerable: false,
                configurable: false
            });
        } catch (_) {}
        return wrapper;
    };
    const ret = (0, $7fPBF.useMemo)(()=>{
        const original = finalI18n;
        const lang = original?.language;
        let i18nWrapper = original;
        if (original) {
            if (wrapperRef.current && wrapperRef.current.__original === original) {
                if (wrapperLangRef.current !== lang) {
                    i18nWrapper = createI18nWrapper(original);
                    wrapperRef.current = i18nWrapper;
                    wrapperLangRef.current = lang;
                } else i18nWrapper = wrapperRef.current;
            } else {
                i18nWrapper = createI18nWrapper(original);
                wrapperRef.current = i18nWrapper;
                wrapperLangRef.current = lang;
            }
        }
        const effectiveT = !ready && !useSuspense ? (...args)=>{
            (0, $5RTF6.warnOnce)(i18n, 'USE_T_BEFORE_READY', 'useTranslation: t was called before ready. When using useSuspense: false, make sure to check the ready flag before using t.');
            return t(...args);
        } : t;
        const arr = [
            effectiveT,
            i18nWrapper,
            ready
        ];
        arr.t = effectiveT;
        arr.i18n = i18nWrapper;
        arr.ready = ready;
        return arr;
    }, [
        t,
        finalI18n,
        ready,
        finalI18n.resolvedLanguage,
        finalI18n.language,
        finalI18n.languages
    ]);
    if (i18n && useSuspense && !ready) throw new Promise((resolve)=>{
        const onLoaded = ()=>resolve();
        if (props.lng) (0, $5RTF6.loadLanguages)(i18n, props.lng, namespaces, onLoaded);
        else (0, $5RTF6.loadNamespaces)(i18n, namespaces, onLoaded);
    });
    return ret;
};

});
parcelRegister("hL6ll", function(module, exports) {
'use strict';

module.exports = (parcelRequire("a1Cvm"));

});
parcelRegister("a1Cvm", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $74c7dda075bc8f04$export$306c0aa65ff9ec16; }, function (v) { return $74c7dda075bc8f04$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $74c7dda075bc8f04$export$306c0aa65ff9ec16;
"use strict";

var $7fPBF = parcelRequire("7fPBF");
function $74c7dda075bc8f04$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $74c7dda075bc8f04$var$objectIs = "function" === typeof Object.is ? Object.is : $74c7dda075bc8f04$var$is, $74c7dda075bc8f04$var$useState = $7fPBF.useState, $74c7dda075bc8f04$var$useEffect = $7fPBF.useEffect, $74c7dda075bc8f04$var$useLayoutEffect = $7fPBF.useLayoutEffect, $74c7dda075bc8f04$var$useDebugValue = $7fPBF.useDebugValue;
function $74c7dda075bc8f04$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $74c7dda075bc8f04$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $74c7dda075bc8f04$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $74c7dda075bc8f04$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $74c7dda075bc8f04$var$useEffect(function() {
        $74c7dda075bc8f04$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $74c7dda075bc8f04$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $74c7dda075bc8f04$var$useDebugValue(value);
    return value;
}
function $74c7dda075bc8f04$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$74c7dda075bc8f04$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $74c7dda075bc8f04$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $74c7dda075bc8f04$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $74c7dda075bc8f04$var$useSyncExternalStore$1 : $74c7dda075bc8f04$var$useSyncExternalStore$2;
$74c7dda075bc8f04$export$306c0aa65ff9ec16 = void 0 !== $7fPBF.useSyncExternalStore ? $7fPBF.useSyncExternalStore : $74c7dda075bc8f04$var$shim;

});



parcelRegister("2mZbw", function(module, exports) {

var $7fPBF = parcelRequire("7fPBF");

var $doyfp = parcelRequire("doyfp");

var $5RTF6 = parcelRequire("5RTF6");
const $1b9d18dce12af9e0$export$2dcb0053efd21124 = (ns, options = {})=>function Extend(WrappedComponent) {
        function I18nextWithTranslation({ forwardedRef: forwardedRef, ...rest }) {
            const [t, i18n, ready] = (0, $doyfp.useTranslation)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $7fPBF.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $5RTF6.getDisplayName)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $7fPBF.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $7fPBF.forwardRef)(forwardRef) : I18nextWithTranslation;
    };

});

parcelRegister("1teFb", function(module, exports) {

var $doyfp = parcelRequire("doyfp");
const $1123dfab2acde046$export$b63289fbda65eed1 = ({ ns: ns, children: children, ...options })=>{
    const [t, i18n, ready] = (0, $doyfp.useTranslation)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n?.language
    }, ready);
};

});

parcelRegister("kX5ZB", function(module, exports) {

var $7fPBF = parcelRequire("7fPBF");

var $beOCj = parcelRequire("beOCj");
function $f40df753886fac13$export$1325e8699caa160f({ i18n: i18n, defaultNS: defaultNS, children: children }) {
    const value = (0, $7fPBF.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $7fPBF.createElement)((0, $beOCj.I18nContext).Provider, {
        value: value
    }, children);
}

});

parcelRegister("3fGol", function(module, exports) {

var $7fPBF = parcelRequire("7fPBF");

var $9ql4S = parcelRequire("9ql4S");

var $beOCj = parcelRequire("beOCj");

var $5RTF6 = parcelRequire("5RTF6");
const $25e3a7ece768866e$export$80dfa519af1c8605 = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR({ initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest }) {
            (0, $9ql4S.useSSR)(initialI18nStore, initialLanguage);
            return (0, $7fPBF.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $beOCj.composeInitialProps)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $5RTF6.getDisplayName)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };

});
parcelRegister("9ql4S", function(module, exports) {

$parcel$export(module.exports, "useSSR", function () { return $6dc6e4594d06aae3$export$3526fb65ade8d8b7; });

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("beOCj");
var $cvg5R = parcelRequire("cvg5R");
var $beOCj = parcelRequire("beOCj");

var $5RTF6 = parcelRequire("5RTF6");
const $6dc6e4594d06aae3$export$3526fb65ade8d8b7 = (initialI18nStore, initialLanguage, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $7fPBF.useContext)((0, $beOCj.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $cvg5R.getI18n)();
    if (!i18n) {
        (0, $5RTF6.warnOnce)(i18n, 'NO_I18NEXT_INSTANCE', 'useSSR: You will need to pass in an i18next instance by using initReactI18next or by passing it via props or context. In monorepo setups, make sure there is only one instance of react-i18next.');
        return;
    }
    if (i18n.options?.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        if (!i18n.services?.resourceStore) {
            (0, $5RTF6.warnOnce)(i18n, 'I18N_NOT_INITIALIZED', "useSSR: i18n instance was found but not initialized (services.resourceStore is missing). Make sure you call i18next.init() before using useSSR \u2014 e.g. at module level, not only in getStaticProps/getServerSideProps.");
            return;
        }
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};

});



parcelRegister("cSUCP", function(module, exports) {

$parcel$export(module.exports, "baseURL", function () { return $ceb7bad1ae7574b2$export$e0588e7b8006558e; });
$parcel$export(module.exports, "uploadAudio", function () { return $ceb7bad1ae7574b2$export$ed11b2e4d1315d4a; });
$parcel$export(module.exports, "deleteAudio", function () { return $ceb7bad1ae7574b2$export$71cb1bf60bb4f74e; });
$parcel$export(module.exports, "getAudioUrl", function () { return $ceb7bad1ae7574b2$export$4cdf8ed2d52aaf7e; });
$parcel$export(module.exports, "uploadAvatar", function () { return $ceb7bad1ae7574b2$export$db6dcff2e77846b2; });
$parcel$export(module.exports, "avatarSrc", function () { return $ceb7bad1ae7574b2$export$e064c5ceb096338b; });
$parcel$export(module.exports, "getBannerText", function () { return $ceb7bad1ae7574b2$export$aeb2e0ad31f71842; });
$parcel$export(module.exports, "updateBanner", function () { return $ceb7bad1ae7574b2$export$9ebbcadb541b09bc; });
$parcel$export(module.exports, "requestEmailVerify", function () { return $ceb7bad1ae7574b2$export$b40c5025e5bd3d85; });
$parcel$export(module.exports, "verifyEmail", function () { return $ceb7bad1ae7574b2$export$1a974f1e1986c706; });
$parcel$export(module.exports, "emailInviteToProject", function () { return $ceb7bad1ae7574b2$export$31f39dbc9385bf1; });
$parcel$export(module.exports, "validateInviteToken", function () { return $ceb7bad1ae7574b2$export$c98ecf3ca1315165; });
$parcel$export(module.exports, "uploadLiftAndGetWritingSystems", function () { return $ceb7bad1ae7574b2$export$fb4d10ea55848e4d; });
$parcel$export(module.exports, "finishUploadLift", function () { return $ceb7bad1ae7574b2$export$b49dd67a4c2d4ab4; });
$parcel$export(module.exports, "deleteFrontierAndFinishUploadLift", function () { return $ceb7bad1ae7574b2$export$97180780329c769f; });
$parcel$export(module.exports, "exportLift", function () { return $ceb7bad1ae7574b2$export$17a76ec17b590f9d; });
$parcel$export(module.exports, "cancelExport", function () { return $ceb7bad1ae7574b2$export$bf3f4b18d4c25ecc; });
$parcel$export(module.exports, "downloadLift", function () { return $ceb7bad1ae7574b2$export$fa84c40c5aed6a1e; });
$parcel$export(module.exports, "deleteLift", function () { return $ceb7bad1ae7574b2$export$a8f51ca44e031e76; });
$parcel$export(module.exports, "mergeWords", function () { return $ceb7bad1ae7574b2$export$8fb79eb15721eed0; });
$parcel$export(module.exports, "undoMerge", function () { return $ceb7bad1ae7574b2$export$6e126a7b0cd88a7f; });
$parcel$export(module.exports, "blacklistAdd", function () { return $ceb7bad1ae7574b2$export$b45e0d3ed240ef73; });
$parcel$export(module.exports, "graylistAdd", function () { return $ceb7bad1ae7574b2$export$95ed691a4ca2aabb; });
$parcel$export(module.exports, "findIdenticalDuplicates", function () { return $ceb7bad1ae7574b2$export$5f4023a68bf0cf6a; });
$parcel$export(module.exports, "findSimilarDuplicates", function () { return $ceb7bad1ae7574b2$export$14cb678121f43771; });
$parcel$export(module.exports, "retrieveDuplicates", function () { return $ceb7bad1ae7574b2$export$c762cb30b12d84e8; });
$parcel$export(module.exports, "hasGraylistEntries", function () { return $ceb7bad1ae7574b2$export$8e66dc005e9b23c9; });
$parcel$export(module.exports, "getGraylistEntries", function () { return $ceb7bad1ae7574b2$export$ba44ca2ad92b1d19; });
$parcel$export(module.exports, "resetPasswordRequest", function () { return $ceb7bad1ae7574b2$export$3b6a3f2cea60b7e2; });
$parcel$export(module.exports, "validateResetToken", function () { return $ceb7bad1ae7574b2$export$43e246eb3db6f02c; });
$parcel$export(module.exports, "resetPassword", function () { return $ceb7bad1ae7574b2$export$dc726c8e334dd814; });
$parcel$export(module.exports, "getAllProjects", function () { return $ceb7bad1ae7574b2$export$f5eb721ef78be29f; });
$parcel$export(module.exports, "getAllProjectUsers", function () { return $ceb7bad1ae7574b2$export$786f7ec3c66c6071; });
$parcel$export(module.exports, "createProject", function () { return $ceb7bad1ae7574b2$export$fbb34fdd2a7bb43f; });
$parcel$export(module.exports, "getAllActiveProjects", function () { return $ceb7bad1ae7574b2$export$681f7f7825d26fe; });
$parcel$export(module.exports, "getProject", function () { return $ceb7bad1ae7574b2$export$637b60a42bb03f06; });
$parcel$export(module.exports, "getProjectName", function () { return $ceb7bad1ae7574b2$export$2cd058184eb75757; });
$parcel$export(module.exports, "updateProject", function () { return $ceb7bad1ae7574b2$export$33a767575887529b; });
$parcel$export(module.exports, "archiveProject", function () { return $ceb7bad1ae7574b2$export$f05691f0b790c6e8; });
$parcel$export(module.exports, "restoreProject", function () { return $ceb7bad1ae7574b2$export$f3e59f9357075f9d; });
$parcel$export(module.exports, "projectDuplicateCheck", function () { return $ceb7bad1ae7574b2$export$e0bad73aa0f26cfc; });
$parcel$export(module.exports, "getAllSemanticDomainNames", function () { return $ceb7bad1ae7574b2$export$8306efddc8436793; });
$parcel$export(module.exports, "getSemanticDomainFull", function () { return $ceb7bad1ae7574b2$export$ba6ef63c6d2953b6; });
$parcel$export(module.exports, "getSemanticDomainTreeNode", function () { return $ceb7bad1ae7574b2$export$9cff044ea4c53eff; });
$parcel$export(module.exports, "getSemanticDomainTreeNodeByName", function () { return $ceb7bad1ae7574b2$export$9195fb4b5ef508c7; });
$parcel$export(module.exports, "getAllSpeakers", function () { return $ceb7bad1ae7574b2$export$d6e37d512171cf1e; });
$parcel$export(module.exports, "getSpeaker", function () { return $ceb7bad1ae7574b2$export$8ce0bff9600153bf; });
$parcel$export(module.exports, "createSpeaker", function () { return $ceb7bad1ae7574b2$export$fc0d162fe7ffad6e; });
$parcel$export(module.exports, "deleteSpeaker", function () { return $ceb7bad1ae7574b2$export$ab03a949abc44d63; });
$parcel$export(module.exports, "removeConsent", function () { return $ceb7bad1ae7574b2$export$a39027a9de0890b6; });
$parcel$export(module.exports, "updateSpeakerName", function () { return $ceb7bad1ae7574b2$export$33853a5958198e99; });
$parcel$export(module.exports, "uploadConsent", function () { return $ceb7bad1ae7574b2$export$4d648acc35eb466d; });
$parcel$export(module.exports, "getConsentUrl", function () { return $ceb7bad1ae7574b2$export$c23dbfe8dfb36c1b; });
$parcel$export(module.exports, "getConsentImageSrc", function () { return $ceb7bad1ae7574b2$export$40e7b0c8feae254f; });
$parcel$export(module.exports, "getSemanticDomainCounts", function () { return $ceb7bad1ae7574b2$export$e107eb2b061b2d4; });
$parcel$export(module.exports, "getSemanticDomainUserCount", function () { return $ceb7bad1ae7574b2$export$e6a420b997fa2ef5; });
$parcel$export(module.exports, "getLineChartRootData", function () { return $ceb7bad1ae7574b2$export$a45989e0d70045fc; });
$parcel$export(module.exports, "getProgressEstimationLineChartRoot", function () { return $ceb7bad1ae7574b2$export$486f5ec93deb6867; });
$parcel$export(module.exports, "verifyCaptchaToken", function () { return $ceb7bad1ae7574b2$export$b89e63fa6c67fe0f; });
$parcel$export(module.exports, "addUser", function () { return $ceb7bad1ae7574b2$export$7ee7664ce5ce7d6; });
$parcel$export(module.exports, "isEmailOrUsernameAvailable", function () { return $ceb7bad1ae7574b2$export$b1993f67671d7dcc; });
$parcel$export(module.exports, "authenticateUser", function () { return $ceb7bad1ae7574b2$export$e26cc1c6402d3f41; });
$parcel$export(module.exports, "uiLanguage", function () { return $ceb7bad1ae7574b2$export$f5cf216682cba7f3; });
$parcel$export(module.exports, "getAllUsers", function () { return $ceb7bad1ae7574b2$export$69093b9c569a5b5b; });
$parcel$export(module.exports, "getUsersByFilter", function () { return $ceb7bad1ae7574b2$export$f3597a0f87696993; });
$parcel$export(module.exports, "getUser", function () { return $ceb7bad1ae7574b2$export$7cbf767827cd68ba; });
$parcel$export(module.exports, "getUserIdByEmailOrUsername", function () { return $ceb7bad1ae7574b2$export$fa9f627115315430; });
$parcel$export(module.exports, "updateUser", function () { return $ceb7bad1ae7574b2$export$e3ac7a5d19605772; });
$parcel$export(module.exports, "deleteUser", function () { return $ceb7bad1ae7574b2$export$7d0f10f273c0438a; });
$parcel$export(module.exports, "getUserProjects", function () { return $ceb7bad1ae7574b2$export$19788fd3f63b8f42; });
$parcel$export(module.exports, "isEmailOkay", function () { return $ceb7bad1ae7574b2$export$fbde34b9d3a53a19; });
$parcel$export(module.exports, "addGoalToUserEdit", function () { return $ceb7bad1ae7574b2$export$f98b2ec9bc3b723f; });
$parcel$export(module.exports, "addStepToGoal", function () { return $ceb7bad1ae7574b2$export$65046ea8b56ef306; });
$parcel$export(module.exports, "createUserEdit", function () { return $ceb7bad1ae7574b2$export$e0312044bf7b987b; });
$parcel$export(module.exports, "getUserEditById", function () { return $ceb7bad1ae7574b2$export$d1fb174f5e519b79; });
$parcel$export(module.exports, "getUserRoles", function () { return $ceb7bad1ae7574b2$export$2c9de0a1c6b83fdc; });
$parcel$export(module.exports, "getCurrentPermissions", function () { return $ceb7bad1ae7574b2$export$61dfac2c0035513c; });
$parcel$export(module.exports, "hasPermission", function () { return $ceb7bad1ae7574b2$export$b325ec6732b039cf; });
$parcel$export(module.exports, "addOrUpdateUserRole", function () { return $ceb7bad1ae7574b2$export$55dc6f7972c4423c; });
$parcel$export(module.exports, "removeUserRole", function () { return $ceb7bad1ae7574b2$export$174d5d250cb25750; });
$parcel$export(module.exports, "changeProjectOwner", function () { return $ceb7bad1ae7574b2$export$4b5427e3e34ed686; });
$parcel$export(module.exports, "areInFrontier", function () { return $ceb7bad1ae7574b2$export$dbd111105437a26e; });
$parcel$export(module.exports, "createWord", function () { return $ceb7bad1ae7574b2$export$9c1c4323e9b9cd5; });
$parcel$export(module.exports, "deleteFrontierWord", function () { return $ceb7bad1ae7574b2$export$8858fc2bb0574dca; });
$parcel$export(module.exports, "getDuplicateId", function () { return $ceb7bad1ae7574b2$export$639fd189dcff6d20; });
$parcel$export(module.exports, "getFrontierCount", function () { return $ceb7bad1ae7574b2$export$e8ad12cad898f9eb; });
$parcel$export(module.exports, "getFrontierWords", function () { return $ceb7bad1ae7574b2$export$a464527ade717ae4; });
$parcel$export(module.exports, "getWord", function () { return $ceb7bad1ae7574b2$export$2a0aca99b7df069d; });
$parcel$export(module.exports, "hasFrontierWords", function () { return $ceb7bad1ae7574b2$export$ada37671e022ab11; });
$parcel$export(module.exports, "isInFrontier", function () { return $ceb7bad1ae7574b2$export$71807f0725847295; });
$parcel$export(module.exports, "restoreWord", function () { return $ceb7bad1ae7574b2$export$172d4f3fdc40fa9d; });
$parcel$export(module.exports, "revertWords", function () { return $ceb7bad1ae7574b2$export$2139d739a28ae4cd; });
$parcel$export(module.exports, "updateDuplicate", function () { return $ceb7bad1ae7574b2$export$a94c28b8cf2316f7; });
$parcel$export(module.exports, "updateWord", function () { return $ceb7bad1ae7574b2$export$9ea78232820799d; });
$parcel$export(module.exports, "getDomainWordCount", function () { return $ceb7bad1ae7574b2$export$2140cff8f5d5194a; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $a1NKN = parcelRequire("a1NKN");

var $aU4vn = parcelRequire("aU4vn");

var $jIH9a = parcelRequire("jIH9a");
parcelRequire("j3TTJ");
var $aeizo = parcelRequire("aeizo");
var $hEs1E = parcelRequire("hEs1E");
var $hfe5D = parcelRequire("hfe5D");
var $alNT7 = parcelRequire("alNT7");
var $iLqPm = parcelRequire("iLqPm");
var $a3Fts = parcelRequire("a3Fts");
var $2zofI = parcelRequire("2zofI");
var $7G8xv = parcelRequire("7G8xv");
var $eAW08 = parcelRequire("eAW08");
var $6aen1 = parcelRequire("6aen1");
var $jzwjE = parcelRequire("jzwjE");
var $iIUoD = parcelRequire("iIUoD");
var $fAwTT = parcelRequire("fAwTT");
var $8x916 = parcelRequire("8x916");
var $kAOhX = parcelRequire("kAOhX");
var $9Nnrr = parcelRequire("9Nnrr");
var $iL4qK = parcelRequire("iL4qK");

var $11MtC = parcelRequire("11MtC");

var $1a3s7 = parcelRequire("1a3s7");

var $18Taw = parcelRequire("18Taw");

var $fKxk8 = parcelRequire("fKxk8");

var $9Ihvc = parcelRequire("9Ihvc");

var $6PJp8 = parcelRequire("6PJp8");

var $2VP0e = parcelRequire("2VP0e");

var $k1O7N = parcelRequire("k1O7N");

var $2yihM = parcelRequire("2yihM");
const $ceb7bad1ae7574b2$export$e0588e7b8006558e = `${(0, $2VP0e.RuntimeConfig).getInstance().baseUrl()}`;
const $ceb7bad1ae7574b2$var$apiBaseURL = `${$ceb7bad1ae7574b2$export$e0588e7b8006558e}/v1`;
const $ceb7bad1ae7574b2$var$config_parameters = {
    basePath: $ceb7bad1ae7574b2$export$e0588e7b8006558e
};
const $ceb7bad1ae7574b2$var$config = new $alNT7.Configuration($ceb7bad1ae7574b2$var$config_parameters);
/** A list of URL patterns for which user analytics should not be collected. */ const $ceb7bad1ae7574b2$var$authenticationUrls = [
    "/users/authenticate",
    "/users/create",
    "/users/email",
    "/users/forgot",
    "/users/password"
];
/** A list of URL patterns for which the frontend explicitly handles errors
 * and the blanket error pop-ups should be suppressed.*/ const $ceb7bad1ae7574b2$var$whiteListedErrorUrls = [
    "/merge/retrievedups",
    "/speakers/create",
    "/speakers/update/",
    "/users/authenticate",
    "/users/captcha/",
    "/users/uilanguage"
];
// Create an axios instance to allow for attaching interceptors to it.
const $ceb7bad1ae7574b2$var$axiosInstance = (0, $a04va.default).create({
    baseURL: $ceb7bad1ae7574b2$var$apiBaseURL
});
$ceb7bad1ae7574b2$var$axiosInstance.interceptors.request.use((config)=>{
    const consent = $1a3s7.getCurrentUser()?.analyticsOn;
    const url = config.url;
    if (consent === false || $ceb7bad1ae7574b2$var$authenticationUrls.some((u)=>url?.includes(u))) config.headers.analyticsOn = `${false}`;
    else {
        config.headers.analyticsOn = `${true}`;
        config.headers.sessionId = (0, $18Taw.getSessionId)();
    }
    return config;
});
$ceb7bad1ae7574b2$var$axiosInstance.interceptors.response.use(undefined, (err)=>{
    // Any status codes that falls outside the range of 2xx cause this function to
    // trigger.
    if (err.config === undefined) return Promise.reject(err);
    const url = err.config.url;
    const response = err.response;
    if (response) {
        const status = response.status;
        if (status === (0, $a1NKN.StatusCodes).UNAUTHORIZED) (0, $9Ihvc.default).navigate((0, $6PJp8.Path).Login);
        // Suppress error pop-ups for URLs the frontend already explicitly handles.
        if (url && $ceb7bad1ae7574b2$var$whiteListedErrorUrls.some((u)=>url.includes(u))) return Promise.reject(err);
        // Check for fatal errors (400+).
        if (status >= (0, $a1NKN.StatusCodes).BAD_REQUEST) {
            console.error(err);
            (0, $jIH9a.enqueueSnackbar)(`${status} ${response.statusText}\n${err.config.url}`);
        }
    } else {
        // Handle if backend is not reachable.
        console.error(err);
        (0, $jIH9a.enqueueSnackbar)(`Unable to connect to server. Check your network settings.\n${url}`);
    }
    return Promise.reject(err);
});
// Configured OpenAPI interfaces.
const $ceb7bad1ae7574b2$var$audioApi = new $aeizo.AudioApi($ceb7bad1ae7574b2$var$config, (0, $11MtC.BASE_PATH), $ceb7bad1ae7574b2$var$axiosInstance);
const $ceb7bad1ae7574b2$var$avatarApi = new $hEs1E.AvatarApi($ceb7bad1ae7574b2$var$config, (0, $11MtC.BASE_PATH), $ceb7bad1ae7574b2$var$axiosInstance);
const $ceb7bad1ae7574b2$var$bannerApi = new $hfe5D.BannerApi($ceb7bad1ae7574b2$var$config, (0, $11MtC.BASE_PATH), $ceb7bad1ae7574b2$var$axiosInstance);
const $ceb7bad1ae7574b2$var$emailVerifyApi = new $iLqPm.EmailVerifyApi($ceb7bad1ae7574b2$var$config, (0, $11MtC.BASE_PATH), $ceb7bad1ae7574b2$var$axiosInstance);
const $ceb7bad1ae7574b2$var$inviteApi = new $a3Fts.InviteApi($ceb7bad1ae7574b2$var$config, (0, $11MtC.BASE_PATH), $ceb7bad1ae7574b2$var$axiosInstance);
const $ceb7bad1ae7574b2$var$liftApi = new $2zofI.LiftApi($ceb7bad1ae7574b2$var$config, (0, $11MtC.BASE_PATH), $ceb7bad1ae7574b2$var$axiosInstance);
const $ceb7bad1ae7574b2$var$mergeApi = new $7G8xv.MergeApi($ceb7bad1ae7574b2$var$config, (0, $11MtC.BASE_PATH), $ceb7bad1ae7574b2$var$axiosInstance);
const $ceb7bad1ae7574b2$var$passwordResetApi = new $eAW08.PasswordResetApi($ceb7bad1ae7574b2$var$config, (0, $11MtC.BASE_PATH), $ceb7bad1ae7574b2$var$axiosInstance);
const $ceb7bad1ae7574b2$var$projectApi = new $6aen1.ProjectApi($ceb7bad1ae7574b2$var$config, (0, $11MtC.BASE_PATH), $ceb7bad1ae7574b2$var$axiosInstance);
const $ceb7bad1ae7574b2$var$semanticDomainApi = new $jzwjE.SemanticDomainApi($ceb7bad1ae7574b2$var$config, (0, $11MtC.BASE_PATH), $ceb7bad1ae7574b2$var$axiosInstance);
const $ceb7bad1ae7574b2$var$speakerApi = new $iIUoD.SpeakerApi($ceb7bad1ae7574b2$var$config, (0, $11MtC.BASE_PATH), $ceb7bad1ae7574b2$var$axiosInstance);
const $ceb7bad1ae7574b2$var$statisticsApi = new $fAwTT.StatisticsApi($ceb7bad1ae7574b2$var$config, (0, $11MtC.BASE_PATH), $ceb7bad1ae7574b2$var$axiosInstance);
const $ceb7bad1ae7574b2$var$userApi = new $8x916.UserApi($ceb7bad1ae7574b2$var$config, (0, $11MtC.BASE_PATH), $ceb7bad1ae7574b2$var$axiosInstance);
const $ceb7bad1ae7574b2$var$userEditApi = new $kAOhX.UserEditApi($ceb7bad1ae7574b2$var$config, (0, $11MtC.BASE_PATH), $ceb7bad1ae7574b2$var$axiosInstance);
const $ceb7bad1ae7574b2$var$userRoleApi = new $9Nnrr.UserRoleApi($ceb7bad1ae7574b2$var$config, (0, $11MtC.BASE_PATH), $ceb7bad1ae7574b2$var$axiosInstance);
const $ceb7bad1ae7574b2$var$wordApi = new $iL4qK.WordApi($ceb7bad1ae7574b2$var$config, (0, $11MtC.BASE_PATH), $ceb7bad1ae7574b2$var$axiosInstance);
function $ceb7bad1ae7574b2$var$defaultOptions() {
    return {
        headers: (0, $fKxk8.default)()
    };
}
function $ceb7bad1ae7574b2$var$fileUploadOptions() {
    return {
        headers: {
            ...(0, $fKxk8.default)(),
            "content-type": "multipart/form-data"
        }
    };
}
async function $ceb7bad1ae7574b2$export$ed11b2e4d1315d4a(wordId, file) {
    const projectId = $1a3s7.getProjectId();
    const speakerId = file.speakerId ?? "";
    const params = {
        projectId: projectId,
        wordId: wordId,
        file: file
    };
    const options = $ceb7bad1ae7574b2$var$fileUploadOptions();
    const promise = speakerId ? $ceb7bad1ae7574b2$var$audioApi.uploadAudioFileWithSpeaker({
        ...params,
        speakerId: speakerId
    }, options) : $ceb7bad1ae7574b2$var$audioApi.uploadAudioFile(params, options);
    return (await promise).data;
}
async function $ceb7bad1ae7574b2$export$71cb1bf60bb4f74e(wordId, fileName) {
    const params = {
        projectId: $1a3s7.getProjectId(),
        wordId: wordId,
        fileName: fileName
    };
    return (await $ceb7bad1ae7574b2$var$audioApi.deleteAudioFile(params, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
function $ceb7bad1ae7574b2$export$4cdf8ed2d52aaf7e(wordId, fileName) {
    return `${$ceb7bad1ae7574b2$var$apiBaseURL}/projects/${$1a3s7.getProjectId()}/words/${wordId}/audio/download/${fileName}`;
}
async function $ceb7bad1ae7574b2$export$db6dcff2e77846b2(file) {
    // Backend ignores userId and gets current user from HttpContext,
    // but userId is still required in the url and helpful for analytics.
    const userId = $1a3s7.getUserId();
    await $ceb7bad1ae7574b2$var$avatarApi.uploadAvatar({
        userId: userId,
        file: file
    }, $ceb7bad1ae7574b2$var$fileUploadOptions());
    $1a3s7.setAvatar(await $ceb7bad1ae7574b2$export$e064c5ceb096338b(userId));
}
async function $ceb7bad1ae7574b2$export$e064c5ceb096338b(userId) {
    const options = {
        headers: (0, $fKxk8.default)(),
        responseType: "arraybuffer"
    };
    try {
        const resp = await $ceb7bad1ae7574b2$var$avatarApi.downloadAvatar({
            userId: userId
        }, options);
        const image = (0, $aU4vn.Base64).btoa(new Uint8Array(resp.data).reduce((data, byte)=>data + String.fromCharCode(byte), ""));
        return `data:${String(resp.headers["content-type"]).toLowerCase()};base64,${image}`;
    } catch (err) {
        // Avatar fetching can fail if hasAvatar=True but the avatar path is broken.
        // Avoid opening a toast because a different user's avatar could cause this
        // issue, which is not actionable by the current user. The toast could
        // block further UI actions.
        console.error(err);
        return "";
    }
}
async function $ceb7bad1ae7574b2$export$aeb2e0ad31f71842(type) {
    return (await $ceb7bad1ae7574b2$var$bannerApi.getBanner({
        type: type
    })).data.text;
}
async function $ceb7bad1ae7574b2$export$9ebbcadb541b09bc(siteBanner) {
    return (await $ceb7bad1ae7574b2$var$bannerApi.updateBanner({
        siteBanner: siteBanner
    }, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$b40c5025e5bd3d85(email) {
    await $ceb7bad1ae7574b2$var$emailVerifyApi.requestEmailVerify({
        body: email
    }, $ceb7bad1ae7574b2$var$defaultOptions());
}
async function $ceb7bad1ae7574b2$export$1a974f1e1986c706(token) {
    return (await $ceb7bad1ae7574b2$var$emailVerifyApi.validateEmailToken({
        token: token
    })).data;
}
async function $ceb7bad1ae7574b2$export$31f39dbc9385bf1(projectId, role, emailAddress, message) {
    const resp = await $ceb7bad1ae7574b2$var$inviteApi.emailInviteToProject({
        emailInviteData: {
            emailAddress: emailAddress,
            message: message,
            projectId: projectId,
            role: role
        }
    }, $ceb7bad1ae7574b2$var$defaultOptions());
    return resp.data;
}
async function $ceb7bad1ae7574b2$export$c98ecf3ca1315165(projectId, token) {
    return (await $ceb7bad1ae7574b2$var$inviteApi.validateInviteToken({
        projectId: projectId,
        token: token
    }, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$fb4d10ea55848e4d(file) {
    const resp = await $ceb7bad1ae7574b2$var$liftApi.uploadLiftFileAndGetWritingSystems(/* The backend deletes by user, not by project,
     * but a nonempty projectId in the url is still required. */ {
        projectId: "nonempty",
        file: file
    }, $ceb7bad1ae7574b2$var$fileUploadOptions());
    return resp.data;
}
async function $ceb7bad1ae7574b2$export$b49dd67a4c2d4ab4(projectId) {
    const options = {
        headers: (0, $fKxk8.default)()
    };
    return (await $ceb7bad1ae7574b2$var$liftApi.finishUploadLiftFile({
        projectId: projectId
    }, options)).data;
}
async function $ceb7bad1ae7574b2$export$97180780329c769f(projectId) {
    const options = {
        headers: (0, $fKxk8.default)()
    };
    return (await $ceb7bad1ae7574b2$var$liftApi.deleteFrontierAndFinishUploadLiftFile({
        projectId: projectId
    }, options)).data;
}
async function $ceb7bad1ae7574b2$export$17a76ec17b590f9d(projectId) {
    return (await $ceb7bad1ae7574b2$var$liftApi.exportLiftFile({
        projectId: projectId
    }, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$bf3f4b18d4c25ecc() {
    /* The backend deletes by user, not by project,
   * but a nonempty projectId in the url is still required. */ const params = {
        projectId: "nonempty"
    };
    return (await $ceb7bad1ae7574b2$var$liftApi.cancelLiftExport(params, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$fa84c40c5aed6a1e(projectId) {
    /** For details on how to download binary files with axios, see:
   *  https://github.com/axios/axios/issues/1392#issuecomment-447263985  */ const headers = {
        ...(0, $fKxk8.default)(),
        Accept: "application/zip"
    };
    const resp = await $ceb7bad1ae7574b2$var$liftApi.downloadLiftFile({
        projectId: projectId
    }, {
        headers: headers,
        responseType: "blob"
    });
    return URL.createObjectURL(new Blob([
        resp.request.response
    ], {
        type: "application/zip"
    }));
}
async function $ceb7bad1ae7574b2$export$a8f51ca44e031e76() {
    /* The backend deletes by user, not by project,
   * but a nonempty projectId in the url is still required. */ await $ceb7bad1ae7574b2$var$liftApi.deleteLiftFile({
        projectId: "nonempty"
    }, $ceb7bad1ae7574b2$var$defaultOptions());
}
async function $ceb7bad1ae7574b2$export$8fb79eb15721eed0(mergeWords) {
    const params = {
        projectId: $1a3s7.getProjectId(),
        mergeWords: mergeWords
    };
    return (await $ceb7bad1ae7574b2$var$mergeApi.mergeWords(params, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$6e126a7b0cd88a7f(wordIds) {
    const params = {
        projectId: $1a3s7.getProjectId(),
        mergeUndoIds: wordIds
    };
    await $ceb7bad1ae7574b2$var$mergeApi.undoMerge(params, $ceb7bad1ae7574b2$var$defaultOptions());
}
async function $ceb7bad1ae7574b2$export$b45e0d3ed240ef73(wordIds) {
    await $ceb7bad1ae7574b2$var$mergeApi.blacklistAdd({
        projectId: $1a3s7.getProjectId(),
        requestBody: wordIds
    }, $ceb7bad1ae7574b2$var$defaultOptions());
}
async function $ceb7bad1ae7574b2$export$95ed691a4ca2aabb(wordIds) {
    await $ceb7bad1ae7574b2$var$mergeApi.graylistAdd({
        projectId: $1a3s7.getProjectId(),
        requestBody: wordIds
    }, $ceb7bad1ae7574b2$var$defaultOptions());
}
async function $ceb7bad1ae7574b2$export$5f4023a68bf0cf6a(maxInList, maxLists, ignoreProtected = false) {
    const projectId = $1a3s7.getProjectId();
    const resp = await $ceb7bad1ae7574b2$var$mergeApi.findIdenticalPotentialDuplicates({
        ignoreProtected: ignoreProtected,
        maxInList: maxInList,
        maxLists: maxLists,
        projectId: projectId
    }, $ceb7bad1ae7574b2$var$defaultOptions());
    return resp.data;
}
async function $ceb7bad1ae7574b2$export$14cb678121f43771(maxInList, maxLists, ignoreProtected = false) {
    const projectId = $1a3s7.getProjectId();
    await $ceb7bad1ae7574b2$var$mergeApi.findPotentialDuplicates({
        ignoreProtected: ignoreProtected,
        maxInList: maxInList,
        maxLists: maxLists,
        projectId: projectId
    }, $ceb7bad1ae7574b2$var$defaultOptions());
}
async function $ceb7bad1ae7574b2$export$c762cb30b12d84e8() {
    const resp = await $ceb7bad1ae7574b2$var$mergeApi.retrievePotentialDuplicates({
        projectId: $1a3s7.getProjectId()
    }, $ceb7bad1ae7574b2$var$defaultOptions());
    return resp.data;
}
async function $ceb7bad1ae7574b2$export$8e66dc005e9b23c9() {
    const projectId = $1a3s7.getProjectId();
    const userId = $1a3s7.getUserId();
    const resp = await $ceb7bad1ae7574b2$var$mergeApi.hasGraylistEntries({
        projectId: projectId,
        userId: userId
    }, $ceb7bad1ae7574b2$var$defaultOptions());
    return resp.data;
}
async function $ceb7bad1ae7574b2$export$ba44ca2ad92b1d19(maxLists) {
    const projectId = $1a3s7.getProjectId();
    const userId = $1a3s7.getUserId();
    const resp = await $ceb7bad1ae7574b2$var$mergeApi.getGraylistEntries({
        projectId: projectId,
        maxLists: maxLists,
        userId: userId
    }, $ceb7bad1ae7574b2$var$defaultOptions());
    return resp.data;
}
async function $ceb7bad1ae7574b2$export$3b6a3f2cea60b7e2(emailOrUsername) {
    return await $ceb7bad1ae7574b2$var$passwordResetApi.resetPasswordRequest({
        body: emailOrUsername
    }).then(()=>true).catch(()=>false);
}
async function $ceb7bad1ae7574b2$export$43e246eb3db6f02c(token) {
    return (await $ceb7bad1ae7574b2$var$passwordResetApi.validateResetToken({
        token: token
    })).data;
}
async function $ceb7bad1ae7574b2$export$dc726c8e334dd814(token, newPassword) {
    return await $ceb7bad1ae7574b2$var$passwordResetApi.resetPassword({
        passwordResetData: {
            token: token,
            newPassword: newPassword
        }
    }).then(()=>true).catch(()=>false);
}
async function $ceb7bad1ae7574b2$export$f5eb721ef78be29f() {
    return (await $ceb7bad1ae7574b2$var$projectApi.getAllProjects($ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$786f7ec3c66c6071(projId) {
    const params = {
        projectId: projId ?? $1a3s7.getProjectId()
    };
    return (await $ceb7bad1ae7574b2$var$projectApi.getAllProjectUsers(params, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$fbb34fdd2a7bb43f(project) {
    const resp = await $ceb7bad1ae7574b2$var$projectApi.createProject({
        project: project
    }, $ceb7bad1ae7574b2$var$defaultOptions());
    const user = resp.data.user;
    if (user.id === $1a3s7.getUserId()) $1a3s7.setCurrentUser(user);
    return resp.data.project;
}
async function $ceb7bad1ae7574b2$export$681f7f7825d26fe() {
    const projects = [];
    for (const projectId of Object.keys((await $ceb7bad1ae7574b2$export$e5432d4c8eb97ea7()).projectRoles))try {
        await $ceb7bad1ae7574b2$export$637b60a42bb03f06(projectId).then((project)=>project.isActive && projects.push(project));
    } catch (err) {
        /** If there was an error, the project probably was manually deleted
       from the database or is ill-formatted. */ console.error(err);
        (0, $jIH9a.enqueueSnackbar)(`Unable to fetch Project: ${projectId}`);
    }
    return projects;
}
async function $ceb7bad1ae7574b2$export$637b60a42bb03f06(projectId) {
    projectId = projectId ? projectId : $1a3s7.getProjectId();
    return (await $ceb7bad1ae7574b2$var$projectApi.getProject({
        projectId: projectId
    }, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$2cd058184eb75757(projectId) {
    return (await $ceb7bad1ae7574b2$export$637b60a42bb03f06(projectId)).name;
}
async function $ceb7bad1ae7574b2$export$33a767575887529b(project) {
    const params = {
        projectId: project.id,
        project: project
    };
    await $ceb7bad1ae7574b2$var$projectApi.updateProject(params, $ceb7bad1ae7574b2$var$defaultOptions());
}
async function $ceb7bad1ae7574b2$export$f05691f0b790c6e8(projectId) {
    const project = await $ceb7bad1ae7574b2$export$637b60a42bb03f06(projectId);
    project.isActive = false;
    await $ceb7bad1ae7574b2$export$33a767575887529b(project);
}
async function $ceb7bad1ae7574b2$export$f3e59f9357075f9d(projectId) {
    const project = await $ceb7bad1ae7574b2$export$637b60a42bb03f06(projectId);
    project.isActive = true;
    await $ceb7bad1ae7574b2$export$33a767575887529b(project);
}
async function $ceb7bad1ae7574b2$export$e0bad73aa0f26cfc(projectName) {
    return (await $ceb7bad1ae7574b2$var$projectApi.projectDuplicateCheck({
        projectName: projectName
    }, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$8306efddc8436793(lang = "") {
    const resp = await $ceb7bad1ae7574b2$var$semanticDomainApi.getAllSemanticDomainNames({
        lang: lang
    }, $ceb7bad1ae7574b2$var$defaultOptions());
    return resp.data;
}
async function $ceb7bad1ae7574b2$export$ba6ef63c6d2953b6(id, lang) {
    const response = await $ceb7bad1ae7574b2$var$semanticDomainApi.getSemanticDomainFull({
        id: id,
        lang: lang ? lang : (0, $k1O7N.Bcp47Code).Default
    }, $ceb7bad1ae7574b2$var$defaultOptions());
    // The backend response for this methods returns null rather than undefined.
    return response.data ?? undefined;
}
async function $ceb7bad1ae7574b2$export$9cff044ea4c53eff(id, lang) {
    const response = await $ceb7bad1ae7574b2$var$semanticDomainApi.getSemanticDomainTreeNode({
        id: id,
        lang: lang ? lang : (0, $k1O7N.Bcp47Code).Default
    }, $ceb7bad1ae7574b2$var$defaultOptions());
    // The backend response for this methods returns null rather than undefined.
    return response.data ?? undefined;
}
async function $ceb7bad1ae7574b2$export$9195fb4b5ef508c7(name, lang) {
    const response = await $ceb7bad1ae7574b2$var$semanticDomainApi.getSemanticDomainTreeNodeByName({
        name: name,
        lang: lang ? lang : (0, $k1O7N.Bcp47Code).Default
    }, $ceb7bad1ae7574b2$var$defaultOptions());
    // The backend response for this methods returns null rather than undefined.
    return response.data ?? undefined;
}
async function $ceb7bad1ae7574b2$export$d6e37d512171cf1e(projectId) {
    const params = {
        projectId: projectId || $1a3s7.getProjectId()
    };
    const resp = await $ceb7bad1ae7574b2$var$speakerApi.getProjectSpeakers(params, $ceb7bad1ae7574b2$var$defaultOptions());
    return resp.data.sort((a, b)=>a.name.localeCompare(b.name));
}
async function $ceb7bad1ae7574b2$export$8ce0bff9600153bf(speakerId, projectId) {
    projectId = projectId || $1a3s7.getProjectId();
    const params = {
        projectId: projectId,
        speakerId: speakerId
    };
    return (await $ceb7bad1ae7574b2$var$speakerApi.getSpeaker(params, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$fc0d162fe7ffad6e(name, projectId) {
    projectId = projectId || $1a3s7.getProjectId();
    const params = {
        body: name,
        projectId: projectId
    };
    return (await $ceb7bad1ae7574b2$var$speakerApi.createSpeaker(params, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$ab03a949abc44d63(speakerId, projectId) {
    projectId = projectId || $1a3s7.getProjectId();
    const params = {
        projectId: projectId,
        speakerId: speakerId
    };
    return (await $ceb7bad1ae7574b2$var$speakerApi.deleteSpeaker(params, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$a39027a9de0890b6(speaker) {
    const projectId = speaker.projectId || $1a3s7.getProjectId();
    const params = {
        projectId: projectId,
        speakerId: speaker.id
    };
    await $ceb7bad1ae7574b2$var$speakerApi.removeConsent(params, $ceb7bad1ae7574b2$var$defaultOptions());
}
async function $ceb7bad1ae7574b2$export$33853a5958198e99(speakerId, name, projectId) {
    projectId = projectId || $1a3s7.getProjectId();
    const params = {
        body: name,
        projectId: projectId,
        speakerId: speakerId
    };
    await $ceb7bad1ae7574b2$var$speakerApi.updateSpeakerName(params, $ceb7bad1ae7574b2$var$defaultOptions());
}
async function $ceb7bad1ae7574b2$export$4d648acc35eb466d(speaker, file) {
    const { id: id, projectId: projectId } = speaker;
    const params = {
        projectId: projectId,
        speakerId: id,
        file: file
    };
    return (await $ceb7bad1ae7574b2$var$speakerApi.uploadConsent(params, $ceb7bad1ae7574b2$var$fileUploadOptions())).data;
}
function $ceb7bad1ae7574b2$export$c23dbfe8dfb36c1b(speaker) {
    return `${$ceb7bad1ae7574b2$var$apiBaseURL}/projects/${speaker.projectId}/speakers/consent/${speaker.id}`;
}
async function $ceb7bad1ae7574b2$export$40e7b0c8feae254f(speaker) {
    const params = {
        projectId: speaker.projectId,
        speakerId: speaker.id
    };
    const options = {
        headers: (0, $fKxk8.default)(),
        responseType: "arraybuffer"
    };
    const resp = await $ceb7bad1ae7574b2$var$speakerApi.downloadConsent(params, options);
    const image = (0, $aU4vn.Base64).btoa(new Uint8Array(resp.data).reduce((data, byte)=>data + String.fromCharCode(byte), ""));
    return `data:${String(resp.headers["content-type"]).toLowerCase()};base64,${image}`;
}
async function $ceb7bad1ae7574b2$export$e107eb2b061b2d4(projectId, lang) {
    const response = await $ceb7bad1ae7574b2$var$statisticsApi.getSemanticDomainCounts({
        projectId: projectId,
        lang: lang ? lang : (0, $k1O7N.Bcp47Code).Default
    }, $ceb7bad1ae7574b2$var$defaultOptions());
    // The backend response for this methods returns null rather than undefined.
    return response.data ?? undefined;
}
async function $ceb7bad1ae7574b2$export$e6a420b997fa2ef5(projectId) {
    const response = await $ceb7bad1ae7574b2$var$statisticsApi.getSemanticDomainUserCounts({
        projectId: projectId
    }, $ceb7bad1ae7574b2$var$defaultOptions());
    // The backend response for this methods returns null rather than undefined.
    return response.data ?? undefined;
}
async function $ceb7bad1ae7574b2$export$a45989e0d70045fc(projectId) {
    const response = await $ceb7bad1ae7574b2$var$statisticsApi.getLineChartRootData({
        projectId: projectId
    }, $ceb7bad1ae7574b2$var$defaultOptions());
    // The backend response for this methods returns null rather than undefined.
    return response.data ?? undefined;
}
async function $ceb7bad1ae7574b2$export$486f5ec93deb6867(projectId) {
    const response = await $ceb7bad1ae7574b2$var$statisticsApi.getProgressEstimationLineChartRoot({
        projectId: projectId
    }, $ceb7bad1ae7574b2$var$defaultOptions());
    // The backend response for this methods returns null rather than undefined.
    return response.data ?? undefined;
}
async function $ceb7bad1ae7574b2$export$b89e63fa6c67fe0f(token) {
    return await $ceb7bad1ae7574b2$var$userApi.verifyCaptchaToken({
        token: token
    }).then(()=>true).catch(()=>false);
}
async function $ceb7bad1ae7574b2$export$7ee7664ce5ce7d6(user) {
    const resp = await $ceb7bad1ae7574b2$var$userApi.createUser({
        user: user
    }, $ceb7bad1ae7574b2$var$defaultOptions());
    return {
        ...user,
        id: resp.data
    };
}
async function $ceb7bad1ae7574b2$export$b1993f67671d7dcc(emailOrUsername) {
    return (await $ceb7bad1ae7574b2$var$userApi.isEmailOrUsernameAvailable({
        body: emailOrUsername
    })).data;
}
async function $ceb7bad1ae7574b2$export$e26cc1c6402d3f41(emailOrUsername, password) {
    const resp = await $ceb7bad1ae7574b2$var$userApi.authenticate({
        credentials: {
            emailOrUsername: emailOrUsername,
            password: password
        }
    }, $ceb7bad1ae7574b2$var$defaultOptions());
    const user = resp.data;
    $1a3s7.setCurrentUser(user);
    if (user.hasAvatar) $1a3s7.setAvatar(await $ceb7bad1ae7574b2$export$e064c5ceb096338b(user.id));
    return user;
}
async function $ceb7bad1ae7574b2$export$f5cf216682cba7f3(uilang) {
    await $ceb7bad1ae7574b2$var$userApi.uiLanguage({
        body: uilang
    }, $ceb7bad1ae7574b2$var$defaultOptions());
}
async function $ceb7bad1ae7574b2$export$69093b9c569a5b5b() {
    return (await $ceb7bad1ae7574b2$var$userApi.getAllUsers($ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$f3597a0f87696993(filter) {
    return (await $ceb7bad1ae7574b2$var$userApi.getUsersByFilter({
        filter: filter
    }, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$e5432d4c8eb97ea7() {
    return (await $ceb7bad1ae7574b2$var$userApi.getCurrentUser($ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$7cbf767827cd68ba(userId) {
    return (await $ceb7bad1ae7574b2$var$userApi.getUser({
        userId: userId
    }, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$fa9f627115315430(emailOrUsername) {
    const params = {
        body: emailOrUsername
    };
    return (await $ceb7bad1ae7574b2$var$userApi.getUserIdByEmailOrUsername(params, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$e3ac7a5d19605772(user) {
    await $ceb7bad1ae7574b2$var$userApi.updateUser({
        userId: user.id,
        user: user
    }, $ceb7bad1ae7574b2$var$defaultOptions());
    if (user.id === $1a3s7.getUserId()) $1a3s7.setCurrentUser(user);
}
async function $ceb7bad1ae7574b2$export$7d0f10f273c0438a(userId) {
    await $ceb7bad1ae7574b2$var$userApi.deleteUser({
        userId: userId
    }, $ceb7bad1ae7574b2$var$defaultOptions());
}
async function $ceb7bad1ae7574b2$export$19788fd3f63b8f42(userId) {
    return (await $ceb7bad1ae7574b2$var$userApi.getUserProjects({
        userId: userId
    }, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$fbde34b9d3a53a19(email) {
    const user = await $ceb7bad1ae7574b2$export$e5432d4c8eb97ea7();
    return email === user.email || await $ceb7bad1ae7574b2$export$b1993f67671d7dcc(email) || await $ceb7bad1ae7574b2$export$fa9f627115315430(email) === user.id;
}
async function $ceb7bad1ae7574b2$export$f98b2ec9bc3b723f(userEditId, goal) {
    const edit = (0, $2yihM.convertGoalToEdit)(goal);
    await $ceb7bad1ae7574b2$var$userEditApi.updateUserEditGoal({
        projectId: $1a3s7.getProjectId(),
        userEditId: userEditId,
        edit: edit
    }, $ceb7bad1ae7574b2$var$defaultOptions());
}
async function $ceb7bad1ae7574b2$export$65046ea8b56ef306(userEditId, editGuid, step, stepIndex// If undefined, step will be added to end.
) {
    const projectId = $1a3s7.getProjectId();
    const stepString = JSON.stringify(step);
    const userEditStepWrapper = {
        editGuid: editGuid,
        stepString: stepString,
        stepIndex: stepIndex
    };
    const resp = await $ceb7bad1ae7574b2$var$userEditApi.updateUserEditStep({
        projectId: projectId,
        userEditId: userEditId,
        userEditStepWrapper: userEditStepWrapper
    }, $ceb7bad1ae7574b2$var$defaultOptions());
    return resp.data;
}
async function $ceb7bad1ae7574b2$export$e0312044bf7b987b() {
    const resp = await $ceb7bad1ae7574b2$var$userEditApi.createUserEdit({
        projectId: $1a3s7.getProjectId()
    }, $ceb7bad1ae7574b2$var$defaultOptions());
    const user = resp.data;
    $1a3s7.setCurrentUser(user);
    return user;
}
async function $ceb7bad1ae7574b2$export$d1fb174f5e519b79(projectId, userEditId) {
    return (await $ceb7bad1ae7574b2$var$userEditApi.getUserEdit({
        projectId: projectId,
        userEditId: userEditId
    }, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$2c9de0a1c6b83fdc(projectId) {
    const params = {
        projectId: projectId ?? $1a3s7.getProjectId()
    };
    return (await $ceb7bad1ae7574b2$var$userRoleApi.getProjectUserRoles(params, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$61dfac2c0035513c() {
    const params = {
        projectId: $1a3s7.getProjectId()
    };
    return (await $ceb7bad1ae7574b2$var$userRoleApi.getCurrentPermissions(params, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$b325ec6732b039cf(perm) {
    const params = {
        body: perm,
        projectId: $1a3s7.getProjectId()
    };
    return (await $ceb7bad1ae7574b2$var$userRoleApi.hasPermission(params, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$55dc6f7972c4423c(projectId, role, userId) {
    const projectRole = {
        projectId: projectId,
        role: role
    };
    const params = {
        projectId: projectId,
        projectRole: projectRole,
        userId: userId
    };
    await $ceb7bad1ae7574b2$var$userRoleApi.updateUserRole(params, $ceb7bad1ae7574b2$var$defaultOptions());
}
async function $ceb7bad1ae7574b2$export$174d5d250cb25750(projectId, userId) {
    const params = {
        projectId: projectId,
        userId: userId
    };
    await $ceb7bad1ae7574b2$var$userRoleApi.deleteUserRole(params, $ceb7bad1ae7574b2$var$defaultOptions());
}
async function $ceb7bad1ae7574b2$export$4b5427e3e34ed686(projectId, oldUserId, newUserId) {
    const params = {
        projectId: projectId,
        oldUserId: oldUserId,
        newUserId: newUserId
    };
    await $ceb7bad1ae7574b2$var$userRoleApi.changeOwner(params, $ceb7bad1ae7574b2$var$defaultOptions());
}
async function $ceb7bad1ae7574b2$export$dbd111105437a26e(wordIds, projectId) {
    projectId ||= $1a3s7.getProjectId();
    const params = {
        projectId: projectId,
        requestBody: wordIds
    };
    return (await $ceb7bad1ae7574b2$var$wordApi.areInFrontier(params, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$9c1c4323e9b9cd5(word) {
    const params = {
        projectId: $1a3s7.getProjectId(),
        word: word
    };
    word.id = (await $ceb7bad1ae7574b2$var$wordApi.createWord(params, $ceb7bad1ae7574b2$var$defaultOptions())).data;
    return word;
}
async function $ceb7bad1ae7574b2$export$8858fc2bb0574dca(wordId) {
    const params = {
        projectId: $1a3s7.getProjectId(),
        wordId: wordId
    };
    await $ceb7bad1ae7574b2$var$wordApi.deleteFrontierWord(params, $ceb7bad1ae7574b2$var$defaultOptions());
}
async function $ceb7bad1ae7574b2$export$639fd189dcff6d20(word) {
    const params = {
        projectId: $1a3s7.getProjectId(),
        word: word
    };
    return (await $ceb7bad1ae7574b2$var$wordApi.getDuplicateId(params, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$e8ad12cad898f9eb() {
    const params = {
        projectId: $1a3s7.getProjectId()
    };
    return (await $ceb7bad1ae7574b2$var$wordApi.getFrontierCount(params, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$a464527ade717ae4() {
    const params = {
        projectId: $1a3s7.getProjectId()
    };
    return (await $ceb7bad1ae7574b2$var$wordApi.getProjectFrontierWords(params, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$2a0aca99b7df069d(wordId) {
    const params = {
        projectId: $1a3s7.getProjectId(),
        wordId: wordId
    };
    return (await $ceb7bad1ae7574b2$var$wordApi.getWord(params, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$ada37671e022ab11(projectId) {
    const params = {
        projectId: projectId ?? $1a3s7.getProjectId()
    };
    return (await $ceb7bad1ae7574b2$var$wordApi.hasFrontierWords(params, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$71807f0725847295(wordId, projectId) {
    projectId ||= $1a3s7.getProjectId();
    const params = {
        projectId: projectId,
        wordId: wordId
    };
    return (await $ceb7bad1ae7574b2$var$wordApi.isInFrontier(params, $ceb7bad1ae7574b2$var$defaultOptions())).data;
}
async function $ceb7bad1ae7574b2$export$172d4f3fdc40fa9d(wordId, projectId) {
    projectId ||= $1a3s7.getProjectId();
    await $ceb7bad1ae7574b2$var$wordApi.restoreWord({
        projectId: projectId,
        wordId: wordId
    }, $ceb7bad1ae7574b2$var$defaultOptions());
}
async function $ceb7bad1ae7574b2$export$2139d739a28ae4cd(ids) {
    const params = {
        projectId: $1a3s7.getProjectId(),
        requestBody: ids
    };
    const resp = await $ceb7bad1ae7574b2$var$wordApi.revertWords(params, $ceb7bad1ae7574b2$var$defaultOptions());
    return resp.data;
}
async function $ceb7bad1ae7574b2$export$a94c28b8cf2316f7(dupId, word) {
    const params = {
        projectId: $1a3s7.getProjectId(),
        dupId: dupId,
        word: word
    };
    const resp = await $ceb7bad1ae7574b2$var$wordApi.updateDuplicate(params, $ceb7bad1ae7574b2$var$defaultOptions());
    return await $ceb7bad1ae7574b2$export$2a0aca99b7df069d(resp.data);
}
async function $ceb7bad1ae7574b2$export$9ea78232820799d(word) {
    const resp = await $ceb7bad1ae7574b2$var$wordApi.updateWord({
        projectId: $1a3s7.getProjectId(),
        wordId: word.id,
        word: word
    }, $ceb7bad1ae7574b2$var$defaultOptions());
    return {
        ...word,
        id: resp.data
    };
}
async function $ceb7bad1ae7574b2$export$2140cff8f5d5194a(domainId) {
    const response = await $ceb7bad1ae7574b2$var$wordApi.getDomainWordCount({
        projectId: $1a3s7.getProjectId(),
        domainId: domainId
    }, $ceb7bad1ae7574b2$var$defaultOptions());
    return response.data;
}

});
parcelRegister("h3OEn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("a04va")).default; });

var $a04va = parcelRequire("a04va");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $c6ba0193c6fadd6f$export$1c00760e9e5a4e95, AxiosError: $c6ba0193c6fadd6f$export$c1fbed17c2f6a328, CanceledError: $c6ba0193c6fadd6f$export$1ab0c6b20d94fa14, isCancel: $c6ba0193c6fadd6f$export$3b22524397b493c6, CancelToken: $c6ba0193c6fadd6f$export$fd08e3cb425f0d61, VERSION: $c6ba0193c6fadd6f$export$a4ad2735b021c132, all: $c6ba0193c6fadd6f$export$84bf76cd7afc7469, Cancel: $c6ba0193c6fadd6f$export$848c9b7ead0df967, isAxiosError: $c6ba0193c6fadd6f$export$fbafdbe06a5b5a9a, spread: $c6ba0193c6fadd6f$export$3ae0fd4797ed47c8, toFormData: $c6ba0193c6fadd6f$export$10ae0d317ea97f8b, AxiosHeaders: $c6ba0193c6fadd6f$export$4e7d6ff0f3e6520, HttpStatusCode: $c6ba0193c6fadd6f$export$a972f69c851492b3, formToJSON: $c6ba0193c6fadd6f$export$86d7c59254d6a2c9, getAdapter: $c6ba0193c6fadd6f$export$17ddc20a97d669e2, mergeConfig: $c6ba0193c6fadd6f$export$7ec1ebcfa9d8bd6a, create: $c6ba0193c6fadd6f$export$185802fd694ee1f5 } = (0, $a04va.default);

});
parcelRegister("a04va", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $747d656b899e6115$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $6zjya = parcelRequire("6zjya");

var $8PZpp = parcelRequire("8PZpp");

var $5f6d7 = parcelRequire("5f6d7");

var $ef5jC = parcelRequire("ef5jC");

var $3aVh3 = parcelRequire("3aVh3");

var $lb2qV = parcelRequire("lb2qV");

var $kZZD0 = parcelRequire("kZZD0");

var $4IsRW = parcelRequire("4IsRW");

var $cR4ZD = parcelRequire("cR4ZD");

var $29a93 = parcelRequire("29a93");

var $fX03H = parcelRequire("fX03H");

var $b676K = parcelRequire("b676K");

var $kgiwQ = parcelRequire("kgiwQ");

var $ha7aM = parcelRequire("ha7aM");

var $gv9ju = parcelRequire("gv9ju");

var $ewGK1 = parcelRequire("ewGK1");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $747d656b899e6115$var$createInstance(defaultConfig) {
    const context = new (0, $8PZpp.default)(defaultConfig);
    const instance = (0, $6zjya.default)((0, $8PZpp.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $adReO.default).extend(instance, (0, $8PZpp.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $adReO.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $747d656b899e6115$var$createInstance((0, $5f6d7.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $747d656b899e6115$var$axios = $747d656b899e6115$var$createInstance((0, $ef5jC.default));
// Expose Axios class to allow class inheritance
$747d656b899e6115$var$axios.Axios = (0, $8PZpp.default);
// Expose Cancel & CancelToken
$747d656b899e6115$var$axios.CanceledError = (0, $lb2qV.default);
$747d656b899e6115$var$axios.CancelToken = (0, $kZZD0.default);
$747d656b899e6115$var$axios.isCancel = (0, $4IsRW.default);
$747d656b899e6115$var$axios.VERSION = (0, $cR4ZD.VERSION);
$747d656b899e6115$var$axios.toFormData = (0, $29a93.default);
// Expose AxiosError class
$747d656b899e6115$var$axios.AxiosError = (0, $fX03H.default);
// alias for CanceledError for backward compatibility
$747d656b899e6115$var$axios.Cancel = $747d656b899e6115$var$axios.CanceledError;
// Expose all/spread
$747d656b899e6115$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$747d656b899e6115$var$axios.spread = (0, $b676K.default);
// Expose isAxiosError
$747d656b899e6115$var$axios.isAxiosError = (0, $kgiwQ.default);
// Expose mergeConfig
$747d656b899e6115$var$axios.mergeConfig = (0, $5f6d7.default);
$747d656b899e6115$var$axios.AxiosHeaders = (0, $ha7aM.default);
$747d656b899e6115$var$axios.formToJSON = (thing)=>(0, $3aVh3.default)((0, $adReO.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$747d656b899e6115$var$axios.getAdapter = (0, $gv9ju.default).getAdapter;
$747d656b899e6115$var$axios.HttpStatusCode = (0, $ewGK1.default);
$747d656b899e6115$var$axios.default = $747d656b899e6115$var$axios;
var // this module should only have a default export
$747d656b899e6115$export$2e2bcd8739ae039 = $747d656b899e6115$var$axios;

});
parcelRegister("adReO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77146a31cb578292$export$2e2bcd8739ae039; });

var $6zjya = parcelRequire("6zjya");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $77146a31cb578292$var$toString } = Object.prototype;
const { getPrototypeOf: $77146a31cb578292$var$getPrototypeOf } = Object;
const { iterator: $77146a31cb578292$var$iterator, toStringTag: $77146a31cb578292$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $77146a31cb578292$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
const $77146a31cb578292$var$isUnsafeObjectKey = (prop)=>typeof prop === 'string' && (prop === '__proto__' || prop === 'constructor' || prop === 'prototype');
/**
 * Determine whether an inherited object must be treated as a shared-prototype
 * boundary. Cross-realm Object.prototype objects cannot be distinguished
 * reliably from application-created null-prototype objects because their
 * properties are mutable, so all inherited terminal prototypes are excluded
 * as a fail-closed boundary. A null-prototype source still keeps its own
 * properties, as produced by mergeConfig and other safe materialization paths.
 *
 * @param {*} obj The object to inspect
 * @param {*} prototype The object's prototype
 * @param {boolean} source Whether obj is the original traversal source
 *
 * @returns {boolean} True when obj is a safe prototype traversal boundary
 */ const $77146a31cb578292$var$isPrototypeBoundary = (obj, prototype, source)=>obj === Object.prototype || !source && prototype === null;
/**
 * Determine whether an object can retain its identity through code paths that
 * add, replace, and remove config properties without bypassing unsafe-key
 * filtering. Immutable objects, unsafe-key-bearing objects, and objects with
 * accessor or restricted data properties must be materialized instead.
 *
 * @param {*} obj The object to inspect
 *
 * @returns {boolean} True when every own property is safe and fully mutable
 */ const $77146a31cb578292$var$isSafeAndFullyMutable = (obj)=>{
    if (!Object.isExtensible(obj)) return false;
    const props = Object.getOwnPropertyNames(obj);
    if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(obj));
    return props.every((prop)=>{
        if ($77146a31cb578292$var$isUnsafeObjectKey(prop)) return false;
        const descriptor = Object.getOwnPropertyDescriptor(obj, prop);
        return !!descriptor && descriptor.configurable && descriptor.writable === true;
    });
};
/**
 * Walk the prototype chain (excluding the source realm's Object.prototype)
 * looking for an own `prop`. This distinguishes genuine own/inherited members
 * — including class accessors and template prototypes — from members injected
 * via Object.prototype pollution (e.g. `Object.prototype.username = '...'`),
 * which live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $77146a31cb578292$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        const prototype = $77146a31cb578292$var$getPrototypeOf(obj);
        if ($77146a31cb578292$var$isPrototypeBoundary(obj, prototype, obj === thing)) return false;
        if ($77146a31cb578292$var$hasOwnProperty(obj, prop)) return true;
        obj = prototype;
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $77146a31cb578292$var$getSafeProp = (obj, prop)=>obj != null && $77146a31cb578292$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
/**
 * Flatten an object and its application-defined prototype chain into a
 * null-prototype object. Members inherited only from the source realm's
 * Object.prototype are deliberately excluded, while class/template members
 * below that boundary are preserved.
 *
 * @param {*} thing The value to flatten
 *
 * @returns {*} A null-prototype copy, or the original value when it is already
 * structurally safe or is not an object
 */ const $77146a31cb578292$var$toSafeFlatObject = (thing)=>{
    if (thing == null || typeof thing !== 'object' && typeof thing !== 'function') return thing;
    const sourcePrototype = $77146a31cb578292$var$getPrototypeOf(thing);
    if (sourcePrototype === null && $77146a31cb578292$var$isSafeAndFullyMutable(thing)) return thing;
    const result = Object.create(null);
    const merged = Object.create(null);
    const seen = [];
    let current = thing;
    while(current != null){
        if (seen.indexOf(current) !== -1) break;
        seen.push(current);
        const prototype = current === thing ? sourcePrototype : $77146a31cb578292$var$getPrototypeOf(current);
        if ($77146a31cb578292$var$isPrototypeBoundary(current, prototype, current === thing)) break;
        const props = Object.getOwnPropertyNames(current);
        if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(current));
        for (const prop of props){
            if ($77146a31cb578292$var$isUnsafeObjectKey(prop)) continue;
            if (!$77146a31cb578292$var$hasOwnProperty(merged, prop)) {
                result[prop] = thing[prop];
                merged[prop] = true;
            }
        }
        current = prototype;
    }
    return result;
};
const $77146a31cb578292$var$kindOf = ((cache)=>(thing)=>{
        const str = $77146a31cb578292$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $77146a31cb578292$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$77146a31cb578292$var$kindOf(thing) === type;
};
const $77146a31cb578292$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $77146a31cb578292$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $77146a31cb578292$var$isUndefined = $77146a31cb578292$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $77146a31cb578292$var$isBuffer(val) {
    return val !== null && !$77146a31cb578292$var$isUndefined(val) && val.constructor !== null && !$77146a31cb578292$var$isUndefined(val.constructor) && $77146a31cb578292$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $77146a31cb578292$var$isArrayBuffer = $77146a31cb578292$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $77146a31cb578292$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $77146a31cb578292$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $77146a31cb578292$var$isString = $77146a31cb578292$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $77146a31cb578292$var$isFunction = $77146a31cb578292$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $77146a31cb578292$var$isNumber = $77146a31cb578292$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $77146a31cb578292$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $77146a31cb578292$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $77146a31cb578292$var$isPlainObject = (val)=>{
    if (!$77146a31cb578292$var$isObject(val)) return false;
    const prototype = $77146a31cb578292$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $77146a31cb578292$var$getPrototypeOf(prototype) === null) && // Treat safe own/inherited Symbol.toStringTag or Symbol.iterator members as
    // evidence the value is tagged/iterable, while ignoring members reachable
    // only through shared or terminal prototype boundaries.
    !$77146a31cb578292$var$hasOwnInPrototypeChain(val, $77146a31cb578292$var$toStringTag) && !$77146a31cb578292$var$hasOwnInPrototypeChain(val, $77146a31cb578292$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $77146a31cb578292$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$77146a31cb578292$var$isObject(val) || $77146a31cb578292$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $77146a31cb578292$var$isDate = $77146a31cb578292$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $77146a31cb578292$var$isFile = $77146a31cb578292$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $77146a31cb578292$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $77146a31cb578292$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $77146a31cb578292$var$isBlob = $77146a31cb578292$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $77146a31cb578292$var$isFileList = $77146a31cb578292$var$kindOfTest('FileList');
const $77146a31cb578292$var$isSet = $77146a31cb578292$var$kindOfTest('Set');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $77146a31cb578292$var$isStream = (val)=>$77146a31cb578292$var$isObject(val) && $77146a31cb578292$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $77146a31cb578292$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $77146a31cb578292$var$G = $77146a31cb578292$var$getGlobal();
const $77146a31cb578292$var$FormDataCtor = typeof $77146a31cb578292$var$G.FormData !== 'undefined' ? $77146a31cb578292$var$G.FormData : undefined;
const $77146a31cb578292$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($77146a31cb578292$var$FormDataCtor && thing instanceof $77146a31cb578292$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $77146a31cb578292$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$77146a31cb578292$var$isFunction(thing.append)) return false;
    const kind = $77146a31cb578292$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $77146a31cb578292$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $77146a31cb578292$var$isURLSearchParams = $77146a31cb578292$var$kindOfTest('URLSearchParams');
const [$77146a31cb578292$var$isReadableStream, $77146a31cb578292$var$isRequest, $77146a31cb578292$var$isResponse, $77146a31cb578292$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($77146a31cb578292$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $77146a31cb578292$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $77146a31cb578292$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($77146a31cb578292$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($77146a31cb578292$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $77146a31cb578292$var$findKey(obj, key) {
    if ($77146a31cb578292$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $77146a31cb578292$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $77146a31cb578292$var$isContextDefined = (context)=>!$77146a31cb578292$var$isUndefined(context) && context !== $77146a31cb578292$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $77146a31cb578292$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $77146a31cb578292$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $77146a31cb578292$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $77146a31cb578292$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($77146a31cb578292$var$isPlainObject(existing) && $77146a31cb578292$var$isPlainObject(val)) result[targetKey] = $77146a31cb578292$var$merge(existing, val);
        else if ($77146a31cb578292$var$isPlainObject(val)) result[targetKey] = $77146a31cb578292$var$merge({}, val);
        else if ($77146a31cb578292$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$77146a31cb578292$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $77146a31cb578292$var$isBuffer(source)) continue;
        $77146a31cb578292$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $77146a31cb578292$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($77146a31cb578292$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $77146a31cb578292$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $77146a31cb578292$var$forEach(b, (val, key)=>{
        if (thisArg && $77146a31cb578292$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $6zjya.default)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $77146a31cb578292$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $77146a31cb578292$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $77146a31cb578292$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $77146a31cb578292$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $77146a31cb578292$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $77146a31cb578292$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($77146a31cb578292$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$77146a31cb578292$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $77146a31cb578292$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $77146a31cb578292$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $77146a31cb578292$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$77146a31cb578292$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $77146a31cb578292$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $77146a31cb578292$var$isHTMLForm = $77146a31cb578292$var$kindOfTest('HTMLFormElement');
const $77146a31cb578292$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $77146a31cb578292$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $77146a31cb578292$var$isRegExp = $77146a31cb578292$var$kindOfTest('RegExp');
const $77146a31cb578292$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $77146a31cb578292$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $77146a31cb578292$var$freezeMethods = (obj)=>{
    $77146a31cb578292$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($77146a31cb578292$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$77146a31cb578292$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $77146a31cb578292$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $77146a31cb578292$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $77146a31cb578292$var$noop = ()=>{};
const $77146a31cb578292$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $77146a31cb578292$var$isSpecCompliantForm(thing) {
    return !!(thing && $77146a31cb578292$var$isFunction(thing.append) && thing[$77146a31cb578292$var$toStringTag] === 'FormData' && thing[$77146a31cb578292$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $77146a31cb578292$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($77146a31cb578292$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($77146a31cb578292$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                let target;
                if ($77146a31cb578292$var$isSet(source)) {
                    target = [];
                    for (const value of source){
                        const reducedValue = visit(value);
                        !$77146a31cb578292$var$isUndefined(reducedValue) && target.push(reducedValue);
                    }
                } else {
                    target = $77146a31cb578292$var$isArray(source) ? [] : {};
                    $77146a31cb578292$var$forEach(source, (value, key)=>{
                        const reducedValue = visit(value);
                        !$77146a31cb578292$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                    });
                }
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $77146a31cb578292$var$isAsyncFn = $77146a31cb578292$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $77146a31cb578292$var$isThenable = (thing)=>thing && ($77146a31cb578292$var$isObject(thing) || $77146a31cb578292$var$isFunction(thing)) && $77146a31cb578292$var$isFunction(thing.then) && $77146a31cb578292$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $77146a31cb578292$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $77146a31cb578292$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $77146a31cb578292$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $77146a31cb578292$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $77146a31cb578292$var$isFunction($77146a31cb578292$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $77146a31cb578292$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($77146a31cb578292$var$_global) : $77146a31cb578292$var$_setImmediate;
// *********************
const $77146a31cb578292$var$isIterable = (thing)=>thing != null && $77146a31cb578292$var$isFunction(thing[$77146a31cb578292$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $77146a31cb578292$var$isSafeIterable = (thing)=>thing != null && $77146a31cb578292$var$hasOwnInPrototypeChain(thing, $77146a31cb578292$var$iterator) && $77146a31cb578292$var$isIterable(thing);
var $77146a31cb578292$export$2e2bcd8739ae039 = {
    isArray: $77146a31cb578292$var$isArray,
    isArrayBuffer: $77146a31cb578292$var$isArrayBuffer,
    isBuffer: $77146a31cb578292$var$isBuffer,
    isFormData: $77146a31cb578292$var$isFormData,
    isArrayBufferView: $77146a31cb578292$var$isArrayBufferView,
    isString: $77146a31cb578292$var$isString,
    isNumber: $77146a31cb578292$var$isNumber,
    isBoolean: $77146a31cb578292$var$isBoolean,
    isObject: $77146a31cb578292$var$isObject,
    isPlainObject: $77146a31cb578292$var$isPlainObject,
    isEmptyObject: $77146a31cb578292$var$isEmptyObject,
    isReadableStream: $77146a31cb578292$var$isReadableStream,
    isRequest: $77146a31cb578292$var$isRequest,
    isResponse: $77146a31cb578292$var$isResponse,
    isHeaders: $77146a31cb578292$var$isHeaders,
    isUndefined: $77146a31cb578292$var$isUndefined,
    isDate: $77146a31cb578292$var$isDate,
    isFile: $77146a31cb578292$var$isFile,
    isReactNativeBlob: $77146a31cb578292$var$isReactNativeBlob,
    isReactNative: $77146a31cb578292$var$isReactNative,
    isBlob: $77146a31cb578292$var$isBlob,
    isRegExp: $77146a31cb578292$var$isRegExp,
    isFunction: $77146a31cb578292$var$isFunction,
    isStream: $77146a31cb578292$var$isStream,
    isURLSearchParams: $77146a31cb578292$var$isURLSearchParams,
    isTypedArray: $77146a31cb578292$var$isTypedArray,
    isFileList: $77146a31cb578292$var$isFileList,
    forEach: $77146a31cb578292$var$forEach,
    merge: $77146a31cb578292$var$merge,
    extend: $77146a31cb578292$var$extend,
    trim: $77146a31cb578292$var$trim,
    stripBOM: $77146a31cb578292$var$stripBOM,
    inherits: $77146a31cb578292$var$inherits,
    toFlatObject: $77146a31cb578292$var$toFlatObject,
    kindOf: $77146a31cb578292$var$kindOf,
    kindOfTest: $77146a31cb578292$var$kindOfTest,
    endsWith: $77146a31cb578292$var$endsWith,
    toArray: $77146a31cb578292$var$toArray,
    forEachEntry: $77146a31cb578292$var$forEachEntry,
    matchAll: $77146a31cb578292$var$matchAll,
    isHTMLForm: $77146a31cb578292$var$isHTMLForm,
    hasOwnProperty: $77146a31cb578292$var$hasOwnProperty,
    hasOwnProp: $77146a31cb578292$var$hasOwnProperty,
    hasOwnInPrototypeChain: $77146a31cb578292$var$hasOwnInPrototypeChain,
    getSafeProp: $77146a31cb578292$var$getSafeProp,
    toSafeFlatObject: $77146a31cb578292$var$toSafeFlatObject,
    reduceDescriptors: $77146a31cb578292$var$reduceDescriptors,
    freezeMethods: $77146a31cb578292$var$freezeMethods,
    toObjectSet: $77146a31cb578292$var$toObjectSet,
    toCamelCase: $77146a31cb578292$var$toCamelCase,
    noop: $77146a31cb578292$var$noop,
    toFiniteNumber: $77146a31cb578292$var$toFiniteNumber,
    findKey: $77146a31cb578292$var$findKey,
    global: $77146a31cb578292$var$_global,
    isContextDefined: $77146a31cb578292$var$isContextDefined,
    isSpecCompliantForm: $77146a31cb578292$var$isSpecCompliantForm,
    toJSONObject: $77146a31cb578292$var$toJSONObject,
    isAsyncFn: $77146a31cb578292$var$isAsyncFn,
    isThenable: $77146a31cb578292$var$isThenable,
    setImmediate: $77146a31cb578292$var$_setImmediate,
    asap: $77146a31cb578292$var$asap,
    isIterable: $77146a31cb578292$var$isIterable,
    isSafeIterable: $77146a31cb578292$var$isSafeIterable
};

});
parcelRegister("6zjya", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c852d2f6a5a0387$export$2e2bcd8739ae039; });
'use strict';
function $4c852d2f6a5a0387$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("8PZpp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66f2b8a41463d1e8$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $6nvAH = parcelRequire("6nvAH");

var $khPLX = parcelRequire("khPLX");

var $eystn = parcelRequire("eystn");

var $5f6d7 = parcelRequire("5f6d7");

var $40T1q = parcelRequire("40T1q");

var $hxzPz = parcelRequire("hxzPz");

var $2iR5D = parcelRequire("2iR5D");

var $ha7aM = parcelRequire("ha7aM");

var $aP7qx = parcelRequire("aP7qx");
'use strict';
const $66f2b8a41463d1e8$var$validators = (0, $2iR5D.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $66f2b8a41463d1e8$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $khPLX.default)(),
            response: new (0, $khPLX.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) try {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                const dummyStack = dummy.stack;
                let stack = '';
                // slice off the Error: ... line
                if (typeof dummyStack === 'string') {
                    const firstNewlineIndex = dummyStack.indexOf('\n');
                    stack = firstNewlineIndex === -1 ? '' : dummyStack.slice(firstNewlineIndex + 1);
                }
                if (!err.stack) err.stack = stack;
                else if (stack) {
                    const firstNewlineIndex = stack.indexOf('\n');
                    const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                    const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                    if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                }
            } catch (e) {
            // Ignore failures from custom stack hooks or un-writable stack properties.
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $5f6d7.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $2iR5D.default).assertOptions(transitional, {
            silentJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            forcedJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            clarifyTimeoutError: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            legacyInterceptorReqResOrdering: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            advertiseZstdAcceptEncoding: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            validateStatusUndefinedResolves: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $adReO.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $2iR5D.default).assertOptions(paramsSerializer, {
                encode: $66f2b8a41463d1e8$var$validators.function,
                serialize: $66f2b8a41463d1e8$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $2iR5D.default).assertOptions(config, {
            baseUrl: $66f2b8a41463d1e8$var$validators.spelling('baseURL'),
            withXsrfToken: $66f2b8a41463d1e8$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = ((0, $adReO.default).getSafeProp(config, 'method') || (0, $adReO.default).getSafeProp(this.defaults, 'method') || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $adReO.default).merge(headers.common, headers[config.method]);
        headers && (0, $adReO.default).forEach((0, $hxzPz.default).concat('common'), (method)=>{
            delete headers[method];
        });
        config.headers = (0, $ha7aM.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $aP7qx.default);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $eystn.default).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
            } catch (error) {
                if (!onRejected) {
                    promise = Promise.reject(error);
                    break;
                }
                try {
                    const rejectedResult = onRejected.call(this, error);
                    if ((0, $adReO.default).isThenable(rejectedResult)) promise = Promise.resolve(rejectedResult).then(()=>(0, $eystn.default).call(this, newConfig));
                } catch (rejectedError) {
                    promise = Promise.reject(rejectedError);
                }
                break;
            }
        }
        if (!promise) try {
            promise = (0, $eystn.default).call(this, newConfig);
        } catch (error) {
            promise = Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $5f6d7.default)(this.defaults, config);
        const fullPath = (0, $40T1q.default)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $6nvAH.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $adReO.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $66f2b8a41463d1e8$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $5f6d7.default)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $adReO.default).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $adReO.default).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $5f6d7.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $66f2b8a41463d1e8$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $66f2b8a41463d1e8$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $66f2b8a41463d1e8$export$2e2bcd8739ae039 = $66f2b8a41463d1e8$var$Axios;

});
parcelRegister("6nvAH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a4d655613ae826e$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $dWNM1 = parcelRequire("dWNM1");
'use strict';
function $4a4d655613ae826e$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $4a4d655613ae826e$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = (0, $adReO.default).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $adReO.default).getSafeProp(_options, 'encode') || $4a4d655613ae826e$export$c564cdbbe6da493;
    const serializeFn = (0, $adReO.default).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $adReO.default).isURLSearchParams(params) ? params.toString() : new (0, $dWNM1.default)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("dWNM1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2774d1dd3bec636$export$2e2bcd8739ae039; });

var $29a93 = parcelRequire("29a93");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $a2774d1dd3bec636$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $a2774d1dd3bec636$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $29a93.default)(params, this, options);
}
const $a2774d1dd3bec636$var$prototype = $a2774d1dd3bec636$var$AxiosURLSearchParams.prototype;
$a2774d1dd3bec636$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$a2774d1dd3bec636$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $a2774d1dd3bec636$var$encode) : $a2774d1dd3bec636$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $a2774d1dd3bec636$export$2e2bcd8739ae039 = $a2774d1dd3bec636$var$AxiosURLSearchParams;

});
parcelRegister("29a93", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_FORM_DATA_MAX_DEPTH", function () { return $19044a9fa7281693$export$659081b45d03227d; });
$parcel$export(module.exports, "default", function () { return $19044a9fa7281693$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $fX03H = parcelRequire("fX03H");

var $4htkn = parcelRequire("4htkn");

var $4htkn = parcelRequire("4htkn");
'use strict';
const $19044a9fa7281693$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $19044a9fa7281693$var$isVisitable(thing) {
    return (0, $adReO.default).isPlainObject(thing) || (0, $adReO.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $19044a9fa7281693$var$removeBrackets(key) {
    return (0, $adReO.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $19044a9fa7281693$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $19044a9fa7281693$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $19044a9fa7281693$var$isFlatArray(arr) {
    return (0, $adReO.default).isArray(arr) && !arr.some($19044a9fa7281693$var$isVisitable);
}
const $19044a9fa7281693$var$predicates = (0, $adReO.default).toFlatObject((0, $adReO.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $19044a9fa7281693$var$toFormData(obj, formData, options) {
    if (!(0, $adReO.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4htkn.default) || FormData)();
    const option = (name, fallback)=>{
        const value = (0, $adReO.default).getSafeProp(options, name);
        return (0, $adReO.default).isUndefined(value) ? fallback : value;
    };
    const metaTokens = option('metaTokens', true);
    // eslint-disable-next-line no-use-before-define
    const visitor = option('visitor') || defaultVisitor;
    const dots = option('dots', false);
    const indexes = option('indexes', false);
    const _Blob = option('Blob') || typeof Blob !== 'undefined' && Blob;
    const maxDepth = option('maxDepth', $19044a9fa7281693$export$659081b45d03227d);
    const useBlob = _Blob && (0, $adReO.default).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $adReO.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $adReO.default).isDate(value)) return value.toISOString();
        if ((0, $adReO.default).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $adReO.default).isBlob(value)) throw new (0, $fX03H.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $adReO.default).isArrayBuffer(value) || (0, $adReO.default).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if ((0, $4htkn.default) && (0, $4htkn.default).isBufferAvailable()) return (0, $4htkn.default).from(value);
            throw new (0, $fX03H.default)('Blob is not supported. Use a Buffer instead.', (0, $fX03H.default).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $fX03H.default)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $fX03H.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $adReO.default).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $adReO.default).isReactNative(formData) && (0, $adReO.default).isReactNativeBlob(value)) {
            formData.append($19044a9fa7281693$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $adReO.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $adReO.default).isArray(value) && $19044a9fa7281693$var$isFlatArray(value) || ((0, $adReO.default).isFileList(value) || (0, $adReO.default).endsWith(key, '[]')) && (arr = (0, $adReO.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $19044a9fa7281693$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $adReO.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $19044a9fa7281693$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($19044a9fa7281693$var$isVisitable(value)) return true;
        formData.append($19044a9fa7281693$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($19044a9fa7281693$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $19044a9fa7281693$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $adReO.default).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $adReO.default).forEach(value, function each(el, key) {
            const result = !((0, $adReO.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $adReO.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $adReO.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $19044a9fa7281693$export$2e2bcd8739ae039 = $19044a9fa7281693$var$toFormData;

});
parcelRegister("fX03H", function(module, exports) {

$parcel$export(module.exports, "REDACTED", function () { return $b9cc6960093b095e$export$6acd2efa8ac62a1b; });
$parcel$export(module.exports, "default", function () { return $b9cc6960093b095e$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $ha7aM = parcelRequire("ha7aM");
'use strict';
const $b9cc6960093b095e$export$6acd2efa8ac62a1b = '[REDACTED ****]';
function $b9cc6960093b095e$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $adReO.default).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $adReO.default).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $b9cc6960093b095e$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $adReO.default).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $ha7aM.default)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $adReO.default).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $adReO.default).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $adReO.default).isPlainObject(source) && $b9cc6960093b095e$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $b9cc6960093b095e$export$6acd2efa8ac62a1b : visit(value);
                if (!(0, $adReO.default).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
function $b9cc6960093b095e$var$stringifySafely(value) {
    try {
        return String(value);
    } catch (err) {
        return '';
    }
}
function $b9cc6960093b095e$var$aggregateErrorMessage(error) {
    const message = error.errors.map((entry)=>{
        try {
            return entry && entry.message ? $b9cc6960093b095e$var$stringifySafely(entry.message) : $b9cc6960093b095e$var$stringifySafely(entry);
        } catch (err) {
            return '';
        }
    }).filter(Boolean).join('; ');
    return message || error.name || 'AggregateError';
}
class $b9cc6960093b095e$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        // `AggregateError` (thrown by Node on dual-stack/Happy-Eyeballs connection
        // failures) has an empty `message`; its detail lives in `errors[]`. Without
        // this, the wrapped error surfaces with a blank message (see #6721).
        let message = error.message;
        if (!message && (0, $adReO.default).isArray(error.errors) && error.errors.length) message = $b9cc6960093b095e$var$aggregateErrorMessage(error);
        const axiosError = new $b9cc6960093b095e$var$AxiosError(message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $adReO.default).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $adReO.default).isArray(redactKeys) && redactKeys.length > 0 ? $b9cc6960093b095e$var$redactConfig(config, redactKeys) : (0, $adReO.default).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$b9cc6960093b095e$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$b9cc6960093b095e$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$b9cc6960093b095e$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$b9cc6960093b095e$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$b9cc6960093b095e$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$b9cc6960093b095e$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$b9cc6960093b095e$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$b9cc6960093b095e$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$b9cc6960093b095e$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$b9cc6960093b095e$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$b9cc6960093b095e$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$b9cc6960093b095e$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$b9cc6960093b095e$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$b9cc6960093b095e$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $b9cc6960093b095e$export$2e2bcd8739ae039 = $b9cc6960093b095e$var$AxiosError;

});
parcelRegister("ha7aM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7e8ef3e2bb241a6$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $hMzvi = parcelRequire("hMzvi");

var $kFIA2 = parcelRequire("kFIA2");
'use strict';
const $c7e8ef3e2bb241a6$var$$internals = Symbol('internals');
function $c7e8ef3e2bb241a6$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $c7e8ef3e2bb241a6$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $adReO.default).isArray(value) ? value.map($c7e8ef3e2bb241a6$var$normalizeValue) : (0, $kFIA2.sanitizeHeaderValue)(String(value));
}
function $c7e8ef3e2bb241a6$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $c7e8ef3e2bb241a6$var$parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function $c7e8ef3e2bb241a6$var$trimOWS(value) {
    let start = 0;
    let end = value.length;
    while(start < end){
        const code = value.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = value.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
}
function $c7e8ef3e2bb241a6$var$decodeQuotedString(value) {
    const last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 0x22 || value.charCodeAt(last) !== 0x22) return value;
    let decoded = '';
    for(let i = 1; i < last; i++){
        const code = value.charCodeAt(i);
        if (code === 0x22) return value;
        if (code === 0x5c) {
            i += 1;
            if (i >= last) return value;
        }
        decoded += value[i];
    }
    return decoded;
}
function $c7e8ef3e2bb241a6$var$parseParameters(value) {
    const parameters = Object.create(null);
    const str = String(value);
    let start = 0;
    let quoted = false;
    let escaped = false;
    function parseParameter(end) {
        const part = $c7e8ef3e2bb241a6$var$trimOWS(str.slice(start, end));
        const equals = part.indexOf('=');
        if (equals < 1) return;
        const name = $c7e8ef3e2bb241a6$var$trimOWS(part.slice(0, equals));
        if (!$c7e8ef3e2bb241a6$var$parameterNameRE.test(name)) return;
        const normalizedName = name.toLowerCase();
        if (normalizedName === '__proto__' || normalizedName === 'constructor' || normalizedName === 'prototype') return;
        const parameterValue = $c7e8ef3e2bb241a6$var$trimOWS(part.slice(equals + 1));
        parameters[normalizedName] = $c7e8ef3e2bb241a6$var$decodeQuotedString(parameterValue);
    }
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        if (quoted) {
            if (escaped) escaped = false;
            else if (code === 0x5c) escaped = true;
            else if (code === 0x22) quoted = false;
        } else if (code === 0x22) quoted = true;
        else if (code === 0x2c || code === 0x3b) {
            parseParameter(i);
            start = i + 1;
        }
    }
    parseParameter(str.length);
    return parameters;
}
const $c7e8ef3e2bb241a6$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $c7e8ef3e2bb241a6$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $adReO.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $adReO.default).isString(value)) return;
    if ((0, $adReO.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $adReO.default).isRegExp(filter)) return filter.test(value);
}
function $c7e8ef3e2bb241a6$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $c7e8ef3e2bb241a6$var$buildAccessors(obj, header) {
    const accessorName = (0, $adReO.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $c7e8ef3e2bb241a6$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $adReO.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $c7e8ef3e2bb241a6$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $adReO.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $adReO.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $adReO.default).isString(header) && (header = header.trim()) && !$c7e8ef3e2bb241a6$var$isValidHeaderName(header)) setHeaders((0, $hMzvi.default)(header), valueOrRewrite);
        else if ((0, $adReO.default).isObject(header) && (0, $adReO.default).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $adReO.default).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, $adReO.default).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $adReO.default).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $c7e8ef3e2bb241a6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $adReO.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $c7e8ef3e2bb241a6$var$parseTokens(value);
                if ((0, $adReO.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $adReO.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $c7e8ef3e2bb241a6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $adReO.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $adReO.default).findKey(self, _header);
                if (key && (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $adReO.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $adReO.default).forEach(this, (value, header)=>{
            const key = (0, $adReO.default).findKey(headers, header);
            if (key) {
                self[key] = $c7e8ef3e2bb241a6$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $c7e8ef3e2bb241a6$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $c7e8ef3e2bb241a6$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $adReO.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $adReO.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        const value = this.get('set-cookie');
        return (0, $adReO.default).isArray(value) ? value : value == null || value === false ? [] : [
            value
        ];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static parseParameters(value) {
        return $c7e8ef3e2bb241a6$var$parseParameters(value);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$c7e8ef3e2bb241a6$var$$internals] = this[$c7e8ef3e2bb241a6$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $c7e8ef3e2bb241a6$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $adReO.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$c7e8ef3e2bb241a6$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $adReO.default).reduceDescriptors($c7e8ef3e2bb241a6$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $adReO.default).freezeMethods($c7e8ef3e2bb241a6$var$AxiosHeaders);
var $c7e8ef3e2bb241a6$export$2e2bcd8739ae039 = $c7e8ef3e2bb241a6$var$AxiosHeaders;

});
parcelRegister("hMzvi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf2275aca40d6d88$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $cf2275aca40d6d88$var$ignoreDuplicateOf = (0, $adReO.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $cf2275aca40d6d88$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        const hasKey = (0, $adReO.default).hasOwnProp(parsed, key);
        if (!key || hasKey && (0, $adReO.default).hasOwnProp($cf2275aca40d6d88$var$ignoreDuplicateOf, key)) return;
        if (key === 'set-cookie') {
            if (hasKey) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = hasKey ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});

parcelRegister("kFIA2", function(module, exports) {

$parcel$export(module.exports, "sanitizeHeaderValue", function () { return $f0ca37af3d81c31b$export$9e344cffce061a22; });
$parcel$export(module.exports, "toByteStringHeaderObject", function () { return $f0ca37af3d81c31b$export$c30c72bb7e677d54; });

var $adReO = parcelRequire("adReO");
'use strict';
function $f0ca37af3d81c31b$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $f0ca37af3d81c31b$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $f0ca37af3d81c31b$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $f0ca37af3d81c31b$var$sanitizeValue(value, invalidChars) {
    if ((0, $adReO.default).isArray(value)) return value.map((item)=>$f0ca37af3d81c31b$var$sanitizeValue(item, invalidChars));
    return $f0ca37af3d81c31b$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $f0ca37af3d81c31b$export$9e344cffce061a22 = (value)=>$f0ca37af3d81c31b$var$sanitizeValue(value, $f0ca37af3d81c31b$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $f0ca37af3d81c31b$export$59dd66c2a12d8f62 = (value)=>$f0ca37af3d81c31b$var$sanitizeValue(value, $f0ca37af3d81c31b$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $f0ca37af3d81c31b$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $adReO.default).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $f0ca37af3d81c31b$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}

});



parcelRegister("4htkn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31df7fcb8acaa73a$export$2e2bcd8739ae039; });
// eslint-disable-next-line strict
var $31df7fcb8acaa73a$export$2e2bcd8739ae039 = null;

});




parcelRegister("khPLX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec4d8e24b0699790$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");
'use strict';
const $ec4d8e24b0699790$var$$internals = Symbol('internals');
// `handlers` is public and may be replaced with a nullish value by user code;
// `clear()` has always tolerated that. Treat it as an empty stack rather than
// dereferencing it.
function $ec4d8e24b0699790$var$countHandlers(handlers) {
    return handlers ? handlers.length : 0;
}
function $ec4d8e24b0699790$var$trimHandlers(handlers) {
    if (!handlers) return;
    while(handlers.length && handlers[handlers.length - 1] === null)handlers.pop();
}
function $ec4d8e24b0699790$var$syncHandlerEntries(manager, internals) {
    const handlers = manager.handlers;
    const length = $ec4d8e24b0699790$var$countHandlers(handlers);
    if (handlers !== internals.handlersRef) {
        internals.handlersRef = handlers;
        internals.handlerEntries.clear();
    } else if (length !== internals.handlersLength) {
        if (!length) internals.handlerEntries.clear();
        else internals.handlerEntries.forEach(function removeStaleEntry(entry, id) {
            if (handlers[entry.index] !== entry.handler) internals.handlerEntries.delete(id);
        });
    }
    internals.handlersLength = length;
}
class $ec4d8e24b0699790$var$InterceptorManager {
    constructor(){
        this.handlers = [];
        this[$ec4d8e24b0699790$var$$internals] = {
            handlersRef: this.handlers,
            handlersLength: this.handlers.length,
            handlerEntries: new Map(),
            iterationDepth: 0,
            nextId: 0
        };
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        const handler = {
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        };
        const internals = this[$ec4d8e24b0699790$var$$internals];
        if (this.handlers == null) this.handlers = [];
        $ec4d8e24b0699790$var$syncHandlerEntries(this, internals);
        const id = internals.nextId++;
        this.handlers.push(handler);
        internals.handlerEntries.set(id, {
            handler: handler,
            index: this.handlers.length - 1
        });
        internals.handlersLength = this.handlers.length;
        return id;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        const internals = this[$ec4d8e24b0699790$var$$internals];
        $ec4d8e24b0699790$var$syncHandlerEntries(this, internals);
        const entry = internals.handlerEntries.get(id);
        if (entry) {
            internals.handlerEntries.delete(id);
            // Ignore IDs invalidated by clear or direct replacement of handlers.
            if (this.handlers[entry.index] !== entry.handler) return;
            this.handlers[entry.index] = null;
            // Do not reuse an index while forEach is walking its length snapshot.
            if (!internals.iterationDepth) {
                $ec4d8e24b0699790$var$trimHandlers(this.handlers);
                internals.handlersLength = this.handlers.length;
            }
        }
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) {
            this.handlers = [];
            $ec4d8e24b0699790$var$syncHandlerEntries(this, this[$ec4d8e24b0699790$var$$internals]);
        }
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        const internals = this[$ec4d8e24b0699790$var$$internals];
        $ec4d8e24b0699790$var$syncHandlerEntries(this, internals);
        internals.iterationDepth++;
        try {
            (0, $adReO.default).forEach(this.handlers, function forEachHandler(h) {
                if (h !== null) fn(h);
            });
        } finally{
            if (!--internals.iterationDepth) {
                $ec4d8e24b0699790$var$syncHandlerEntries(this, internals);
                $ec4d8e24b0699790$var$trimHandlers(this.handlers);
                internals.handlersLength = $ec4d8e24b0699790$var$countHandlers(this.handlers);
            }
        }
    }
}
var $ec4d8e24b0699790$export$2e2bcd8739ae039 = $ec4d8e24b0699790$var$InterceptorManager;

});

parcelRegister("eystn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a98a53c8a75f9db0$export$2e2bcd8739ae039; });

var $15ANS = parcelRequire("15ANS");

var $4IsRW = parcelRequire("4IsRW");

var $ef5jC = parcelRequire("ef5jC");

var $lb2qV = parcelRequire("lb2qV");

var $ha7aM = parcelRequire("ha7aM");

var $gv9ju = parcelRequire("gv9ju");

var $adReO = parcelRequire("adReO");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $a98a53c8a75f9db0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $lb2qV.default)(null, config);
}
function $a98a53c8a75f9db0$export$2e2bcd8739ae039(_config) {
    // Interceptors may replace the merged config with an ordinary object. Flatten
    // it at the dispatch boundary so shared prototype members cannot become
    // request behavior, while preserving intentional template/class members.
    const config = (0, $adReO.default).toSafeFlatObject(_config);
    $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
    config.headers = (0, $ha7aM.default).from((0, $adReO.default).getSafeProp(config, 'headers'));
    // Transform request data
    config.data = (0, $15ANS.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $gv9ju.default).getAdapter(config.adapter || (0, $ef5jC.default).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $15ANS.default).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $ha7aM.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $4IsRW.default)(reason)) {
            $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $15ANS.default).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $ha7aM.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("15ANS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cb2ce7608ace114$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $ef5jC = parcelRequire("ef5jC");

var $ha7aM = parcelRequire("ha7aM");
'use strict';
function $0cb2ce7608ace114$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $ef5jC.default);
    const context = response || config;
    const headers = (0, $ha7aM.default).from(context.headers);
    let data = context.data;
    (0, $adReO.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("ef5jC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5e696f232d0dc12$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $fX03H = parcelRequire("fX03H");

var $aP7qx = parcelRequire("aP7qx");

var $29a93 = parcelRequire("29a93");

var $kKiHJ = parcelRequire("kKiHJ");

var $lsAph = parcelRequire("lsAph");

var $3aVh3 = parcelRequire("3aVh3");

var $hxzPz = parcelRequire("hxzPz");
'use strict';
const $a5e696f232d0dc12$var$own = (obj, key)=>obj != null && (0, $adReO.default).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $a5e696f232d0dc12$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $adReO.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $adReO.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $a5e696f232d0dc12$var$defaults = {
    transitional: (0, $aP7qx.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $adReO.default).isObject(data);
            if (isObjectPayload && (0, $adReO.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $adReO.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $3aVh3.default)(data)) : data;
            if ((0, $adReO.default).isArrayBuffer(data) || (0, $adReO.default).isBuffer(data) || (0, $adReO.default).isStream(data) || (0, $adReO.default).isFile(data) || (0, $adReO.default).isBlob(data) || (0, $adReO.default).isReadableStream(data)) return data;
            if ((0, $adReO.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $adReO.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $a5e696f232d0dc12$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $kKiHJ.default)(data, formSerializer).toString();
                if ((isFileList = (0, $adReO.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $a5e696f232d0dc12$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $29a93.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $a5e696f232d0dc12$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $a5e696f232d0dc12$var$own(this, 'transitional') || $a5e696f232d0dc12$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $a5e696f232d0dc12$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $adReO.default).isResponse(data) || (0, $adReO.default).isReadableStream(data)) return data;
            if (data && (0, $adReO.default).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $a5e696f232d0dc12$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $fX03H.default).from(e, (0, $fX03H.default).ERR_BAD_RESPONSE, this, null, $a5e696f232d0dc12$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $lsAph.default).classes.FormData,
        Blob: (0, $lsAph.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $adReO.default).forEach((0, $hxzPz.default), (method)=>{
    $a5e696f232d0dc12$var$defaults.headers[method] = {};
});
var $a5e696f232d0dc12$export$2e2bcd8739ae039 = $a5e696f232d0dc12$var$defaults;

});
parcelRegister("aP7qx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e146da7bba06216$export$2e2bcd8739ae039; });
'use strict';
var $7e146da7bba06216$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};

});

parcelRegister("kKiHJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1a69cd24a140b61$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $29a93 = parcelRequire("29a93");

var $lsAph = parcelRequire("lsAph");
'use strict';
function $f1a69cd24a140b61$export$2e2bcd8739ae039(data, options) {
    return (0, $29a93.default)(data, new (0, $lsAph.default).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $lsAph.default).isNode && (0, $adReO.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}

});
parcelRegister("lsAph", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9f874191f496b63$export$2e2bcd8739ae039; });

var $jB9at = parcelRequire("jB9at");

var $2nF2h = parcelRequire("2nF2h");
var $f9f874191f496b63$export$2e2bcd8739ae039 = {
    ...$2nF2h,
    ...(0, $jB9at.default)
};

});
parcelRegister("jB9at", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4489594588108ef$export$2e2bcd8739ae039; });

var $de9wd = parcelRequire("de9wd");

var $1U9sr = parcelRequire("1U9sr");

var $8FSfW = parcelRequire("8FSfW");
var $e4489594588108ef$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $de9wd.default,
        FormData: $1U9sr.default,
        Blob: $8FSfW.default
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("de9wd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a13f762833a66d0$export$2e2bcd8739ae039; });

var $dWNM1 = parcelRequire("dWNM1");
'use strict';
var $9a13f762833a66d0$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $dWNM1.default);

});

parcelRegister("1U9sr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16325b87e107b4bc$export$2e2bcd8739ae039; });
'use strict';
var $16325b87e107b4bc$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("8FSfW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $650c3d387ae3fbd4$export$2e2bcd8739ae039; });
'use strict';
var $650c3d387ae3fbd4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("2nF2h", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", function () { return $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf; });
$parcel$export(module.exports, "navigator", function () { return $1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae; });
$parcel$export(module.exports, "hasStandardBrowserEnv", function () { return $1bbd8fa0325c4f9a$export$c0bcc9250309d66; });
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", function () { return $1bbd8fa0325c4f9a$export$c81692cf5af97dac; });
$parcel$export(module.exports, "origin", function () { return $1bbd8fa0325c4f9a$export$f710a83a91838a36; });
const $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $1bbd8fa0325c4f9a$export$c0bcc9250309d66 = $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf && (!$1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $1bbd8fa0325c4f9a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $1bbd8fa0325c4f9a$export$f710a83a91838a36 = $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("3aVh3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24febbb5d340c733$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $fX03H = parcelRequire("fX03H");

var $29a93 = parcelRequire("29a93");
'use strict';
const $24febbb5d340c733$var$MAX_DEPTH = (0, $29a93.DEFAULT_FORM_DATA_MAX_DEPTH);
function $24febbb5d340c733$var$throwIfDepthExceeded(index) {
    if (index > $24febbb5d340c733$var$MAX_DEPTH) throw new (0, $fX03H.default)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $24febbb5d340c733$var$MAX_DEPTH, (0, $fX03H.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $24febbb5d340c733$var$parsePropPath(name) {
    // foo[x][y][z] -> ['foo', 'x', 'y', 'z']
    // foo.x.y.z    -> ['foo', 'x', 'y', 'z']
    // A path is split on `.` and on `[...]` groups. A segment — whether written
    // in dot notation or captured inside brackets — may contain any character
    // except `.`, `[` and `]`, so a key like `user-name` or `user name` is kept
    // literal instead of being split (#5402). `.`, `[` and `]` keep their existing
    // meaning, e.g. `foo[bar.baz]` -> ['foo', 'bar', 'baz'] and `[]` is an array push.
    // Excluding `[` from the bracket group also makes the match fail fast at the
    // next `[`, so a malformed name cannot rescan to the end of the string from
    // every unmatched `[` — parsing stays linear in the length of the name.
    const path = [];
    const pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $24febbb5d340c733$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $24febbb5d340c733$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $24febbb5d340c733$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $24febbb5d340c733$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $adReO.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $adReO.default).hasOwnProp(target, name)) target[name] = (0, $adReO.default).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $adReO.default).hasOwnProp(target, name) || !(0, $adReO.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $adReO.default).isArray(target[name])) target[name] = $24febbb5d340c733$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $adReO.default).isFormData(formData) && (0, $adReO.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $adReO.default).forEachEntry(formData, (name, value)=>{
            buildPath($24febbb5d340c733$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $24febbb5d340c733$export$2e2bcd8739ae039 = $24febbb5d340c733$var$formDataToJSON;

});

parcelRegister("hxzPz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc515000d05f04f4$export$2e2bcd8739ae039; });
'use strict';
const $cc515000d05f04f4$var$methodList = Object.freeze([
    'get',
    'delete',
    'head',
    'options',
    'post',
    'put',
    'patch',
    'purge',
    'link',
    'unlink',
    'query'
]);
var $cc515000d05f04f4$export$2e2bcd8739ae039 = $cc515000d05f04f4$var$methodList;

});



parcelRegister("4IsRW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36f1aa490c1da053$export$2e2bcd8739ae039; });
'use strict';
function $36f1aa490c1da053$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("lb2qV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6ac833a4b31e3dc$export$2e2bcd8739ae039; });

var $fX03H = parcelRequire("fX03H");
'use strict';
class $f6ac833a4b31e3dc$var$CanceledError extends (0, $fX03H.default) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $fX03H.default).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $f6ac833a4b31e3dc$export$2e2bcd8739ae039 = $f6ac833a4b31e3dc$var$CanceledError;

});

parcelRegister("gv9ju", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c036c406f3928265$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $4htkn = parcelRequire("4htkn");

var $3PMHb = parcelRequire("3PMHb");

var $gFb9g = parcelRequire("gFb9g");

var $fX03H = parcelRequire("fX03H");
/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $c036c406f3928265$var$knownAdapters = {
    http: (0, $4htkn.default),
    xhr: (0, $3PMHb.default),
    fetch: {
        get: $gFb9g.getFetch
    }
};
// Assign adapter names for easier debugging and identification
(0, $adReO.default).forEach($c036c406f3928265$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $c036c406f3928265$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $c036c406f3928265$var$isResolvedHandle = (adapter)=>(0, $adReO.default).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $c036c406f3928265$var$getAdapter(adapters, config) {
    adapters = (0, $adReO.default).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$c036c406f3928265$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $c036c406f3928265$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $fX03H.default)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $adReO.default).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($c036c406f3928265$var$renderReason).join('\n') : ' ' + $c036c406f3928265$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $fX03H.default)(`There is no suitable adapter to dispatch the request ` + s, (0, $fX03H.default).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $c036c406f3928265$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $c036c406f3928265$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $c036c406f3928265$var$knownAdapters
};

});
parcelRegister("3PMHb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cabe869ce51dbf6$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $3PfpF = parcelRequire("3PfpF");

var $aP7qx = parcelRequire("aP7qx");

var $fX03H = parcelRequire("fX03H");

var $lb2qV = parcelRequire("lb2qV");

var $1pP5g = parcelRequire("1pP5g");

var $41as5 = parcelRequire("41as5");

var $lsAph = parcelRequire("lsAph");

var $ha7aM = parcelRequire("ha7aM");

var $j5Ofq = parcelRequire("j5Ofq");

var $f73QF = parcelRequire("f73QF");

var $kFIA2 = parcelRequire("kFIA2");
const $2cabe869ce51dbf6$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $2cabe869ce51dbf6$export$2e2bcd8739ae039 = $2cabe869ce51dbf6$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $f73QF.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $ha7aM.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload, flushDownloadWithEvent;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend(event) {
            if (!request) return;
            // Status 0 means no response was received, which onerror and onabort normally
            // reject before this runs. Firefox 152 fires only readystatechange and loadend for
            // navigation-canceled requests (https://bugzilla.mozilla.org/show_bug.cgi?id=1505389),
            // leaving settle() to resolve them as an empty success. ECONNABORTED is the error
            // onabort raised on Firefox 151. Reads over file:, which some environments report as
            // status 0 on success, are excluded by the request URL's scheme after browser-style
            // preprocessing, by the page origin's scheme for relative URLs (which inherit it), or
            // by responseURL where implemented.
            if (request.status === 0 && ((0, $41as5.default)((0, $1pP5g.default)(_config.url)) || (0, $41as5.default)((0, $lsAph.default).origin)) !== 'file' && !(request.responseURL && request.responseURL.startsWith('file:'))) {
                reject(new (0, $fX03H.default)('Request aborted', (0, $fX03H.default).ECONNABORTED, config, request));
                done();
                // Clean up request
                request = null;
                return;
            }
            // When loadend is still dispatching, flushing with it gives progress
            // listeners a final delivery whose event has a live target. The legacy
            // ready-state fallback has no event, so replay its pending progress.
            // A throwing listener must not block settlement; rethrow asynchronously,
            // matching how listener errors surface on the throttle timer path.
            try {
                if (event) flushDownloadWithEvent && flushDownloadWithEvent(event);
                else flushDownload && flushDownload();
            } catch (err) {
                setTimeout(()=>{
                    throw err;
                });
            }
            // A final progress callback can cancel the request synchronously.
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $ha7aM.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $3PfpF.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $fX03H.default)('Request aborted', (0, $fX03H.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $fX03H.default)(msg, (0, $fX03H.default).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $aP7qx.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $fX03H.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $fX03H.default).ETIMEDOUT : (0, $fX03H.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $adReO.default).forEach((0, $kFIA2.toByteStringHeaderObject)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $adReO.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload, flushDownloadWithEvent] = (0, $j5Ofq.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $j5Ofq.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $lb2qV.default)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $41as5.default)(_config.url);
        if (protocol && !(0, $lsAph.default).protocols.includes(protocol)) {
            reject(new (0, $fX03H.default)('Unsupported protocol ' + protocol + ':', (0, $fX03H.default).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("3PfpF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c92173995cdc070$export$2e2bcd8739ae039; });

var $fX03H = parcelRequire("fX03H");
'use strict';
function $2c92173995cdc070$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $fX03H.default)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $fX03H.default).ERR_BAD_REQUEST : (0, $fX03H.default).ERR_BAD_RESPONSE, response.config, response.request, response));
}

});

parcelRegister("1pP5g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $107fc072507f4068$export$2e2bcd8739ae039; });
'use strict';
const $107fc072507f4068$var$urlParserControlCharacters = /[\t\n\r]/g;
function $107fc072507f4068$export$2e2bcd8739ae039(url) {
    if (typeof url !== 'string') return url;
    let start = 0;
    while(start < url.length && url.charCodeAt(start) <= 0x20)start++;
    return url.slice(start).replace($107fc072507f4068$var$urlParserControlCharacters, '');
}

});

parcelRegister("41as5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ecf5cf4c0202afd$export$2e2bcd8739ae039; });
'use strict';
function $2ecf5cf4c0202afd$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}

});

parcelRegister("j5Ofq", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", function () { return $de65761df8a598af$export$c1b28109d46c3592; });
$parcel$export(module.exports, "progressEventDecorator", function () { return $de65761df8a598af$export$d9fadd12586c18d6; });
$parcel$export(module.exports, "asyncDecorator", function () { return $de65761df8a598af$export$5d35863c355a22a9; });

var $ikQjh = parcelRequire("ikQjh");

var $7nR3y = parcelRequire("7nR3y");

var $adReO = parcelRequire("adReO");
const $de65761df8a598af$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $ikQjh.default)(50, 250);
    return (0, $7nR3y.default)((e)=>{
        if (!e || !(0, $adReO.default).isNumber(e.loaded)) return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $de65761df8a598af$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $de65761df8a598af$export$5d35863c355a22a9 = (fn, scheduler = (0, $adReO.default).asap)=>(...args)=>scheduler(()=>fn(...args));

});
parcelRegister("ikQjh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d592abf0a04957f1$export$2e2bcd8739ae039; });
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $d592abf0a04957f1$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $d592abf0a04957f1$export$2e2bcd8739ae039 = $d592abf0a04957f1$var$speedometer;

});

parcelRegister("7nR3y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5603d643a9d93c92$export$2e2bcd8739ae039; });
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Array<Function>}
 */ function $5603d643a9d93c92$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    const flushWith = (...args)=>invoke(args);
    return [
        throttled,
        flush,
        flushWith
    ];
}
var $5603d643a9d93c92$export$2e2bcd8739ae039 = $5603d643a9d93c92$var$throttle;

});


parcelRegister("f73QF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b00a7ead3edff84a$export$2e2bcd8739ae039; });

var $lsAph = parcelRequire("lsAph");

var $adReO = parcelRequire("adReO");

var $fX03H = parcelRequire("fX03H");

var $besJL = parcelRequire("besJL");

var $79n0f = parcelRequire("79n0f");

var $40T1q = parcelRequire("40T1q");

var $5f6d7 = parcelRequire("5f6d7");

var $ha7aM = parcelRequire("ha7aM");

var $3VlFm = parcelRequire("3VlFm");

var $6nvAH = parcelRequire("6nvAH");
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $b00a7ead3edff84a$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $b00a7ead3edff84a$var$resolveConfig(config) {
    const newConfig = (0, $5f6d7.default)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $adReO.default).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $ha7aM.default).from(headers);
    newConfig.url = (0, $6nvAH.default)((0, $40T1q.default)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $adReO.default).getSafeProp(auth, 'username') || '';
        const password = (0, $adReO.default).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $b00a7ead3edff84a$var$encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, $fX03H.default).from(e, (0, $fX03H.default).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $adReO.default).isFormData(data)) {
        const getHeaders = (0, $adReO.default).getSafeProp(data, 'getHeaders');
        if ((0, $lsAph.default).hasStandardBrowserEnv || (0, $lsAph.default).hasStandardBrowserWebWorkerEnv || (0, $adReO.default).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $adReO.default).isFunction(getHeaders)) // Node.js FormData (like form-data package)
        (0, $3VlFm.default)(headers, getHeaders.call(data), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $lsAph.default).hasStandardBrowserEnv) {
        if ((0, $adReO.default).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $besJL.default)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $79n0f.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $b00a7ead3edff84a$export$2e2bcd8739ae039 = $b00a7ead3edff84a$var$resolveConfig;

});
parcelRegister("besJL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82d74b1a5a0a01da$export$2e2bcd8739ae039; });

var $lsAph = parcelRequire("lsAph");
var $82d74b1a5a0a01da$export$2e2bcd8739ae039 = (0, $lsAph.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $lsAph.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $lsAph.default).origin), (0, $lsAph.default).navigator && /(msie|trident)/i.test((0, $lsAph.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("79n0f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $534b3794da5c002d$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $lsAph = parcelRequire("lsAph");
var $534b3794da5c002d$export$2e2bcd8739ae039 = (0, $lsAph.default).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $adReO.default).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $adReO.default).isString(path)) cookie.push(`path=${path}`);
        if ((0, $adReO.default).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $adReO.default).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("40T1q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ec1d7b86495f966$export$2e2bcd8739ae039; });

var $fX03H = parcelRequire("fX03H");

var $1yk63 = parcelRequire("1yk63");

var $l45Ly = parcelRequire("l45Ly");

var $1pP5g = parcelRequire("1pP5g");
'use strict';
const $2ec1d7b86495f966$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
// Redact the parts of a URL that can carry secrets before it is embedded in an
// error message. AxiosError.toJSON() serializes `message` verbatim and errors
// are commonly logged, while the opt-in `config.redact` model only cleans
// config keys — it cannot reach the message. Redact only the genuinely
// sensitive substrings — userinfo (credentials), query parameter values and
// fragment contents — with the same REDACTED marker the config redaction uses,
// while keeping the scheme, host, path and parameter names so the offending
// request stays accurately identifiable.
function $2ec1d7b86495f966$var$redactFragment(fragment) {
    if (!fragment) return fragment;
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, (match, separator, parameterName = '')=>{
        return `${separator}${parameterName}${0, $fX03H.REDACTED}`;
    });
}
function $2ec1d7b86495f966$var$redactSensitiveURLParts(url) {
    const redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${(0, $fX03H.REDACTED)}@`);
    const fragmentIndex = redactedURL.indexOf('#');
    const urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    const redactedURLWithoutFragment = urlWithoutFragment.replace(/([?&][^=&#]*=)[^&#]*/g, `$1${(0, $fX03H.REDACTED)}`);
    if (fragmentIndex === -1) return redactedURLWithoutFragment;
    return `${redactedURLWithoutFragment}#${$2ec1d7b86495f966$var$redactFragment(redactedURL.slice(fragmentIndex + 1))}`;
}
function $2ec1d7b86495f966$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string') {
        const normalizedURL = (0, $1pP5g.default)(url);
        if ($2ec1d7b86495f966$var$malformedHttpProtocol.test(normalizedURL)) throw new (0, $fX03H.default)(`Invalid URL ${JSON.stringify($2ec1d7b86495f966$var$redactSensitiveURLParts(normalizedURL))}: missing "//" after protocol`, (0, $fX03H.default).ERR_INVALID_URL, config);
    }
}
function $2ec1d7b86495f966$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $2ec1d7b86495f966$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $1yk63.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $2ec1d7b86495f966$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $l45Ly.default)(baseURL, requestedURL);
    }
    return requestedURL;
}

});
parcelRegister("1yk63", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12188e34b7070552$export$2e2bcd8739ae039; });
'use strict';
function $12188e34b7070552$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("l45Ly", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f55e71b6c54c4376$export$2e2bcd8739ae039; });
'use strict';
function $f55e71b6c54c4376$export$2e2bcd8739ae039(baseURL, relativeURL) {
    if (!relativeURL) return baseURL;
    let end = baseURL.length;
    while(end > 0 && baseURL.charCodeAt(end - 1) === 47)end--;
    return baseURL.slice(0, end) + '/' + relativeURL.replace(/^\/+/, '');
}

});


parcelRegister("5f6d7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d132bbf7812485b$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $ha7aM = parcelRequire("ha7aM");
'use strict';
const $3d132bbf7812485b$var$headersToObject = (thing)=>thing instanceof (0, $ha7aM.default) ? {
        ...thing
    } : thing;
const $3d132bbf7812485b$var$ownEnumerableKeys = (thing)=>{
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) return Object.keys(thing).concat(Object.getOwnPropertySymbols(thing).filter((symbol)=>Object.getOwnPropertyDescriptor(thing, symbol).enumerable));
    return Object.keys(thing);
};
function $3d132bbf7812485b$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $adReO.default).isPlainObject(target) && (0, $adReO.default).isPlainObject(source)) return (0, $adReO.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $adReO.default).isPlainObject(source)) return (0, $adReO.default).merge({}, source);
        else if ((0, $adReO.default).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $adReO.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $adReO.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $adReO.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $adReO.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $adReO.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $adReO.default).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $adReO.default).isUndefined(transitional2)) {
            if ((0, $adReO.default).isPlainObject(transitional2)) {
                if ((0, $adReO.default).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $adReO.default).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $adReO.default).isPlainObject(transitional1) && (0, $adReO.default).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $adReO.default).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $adReO.default).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutErrorMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($3d132bbf7812485b$var$headersToObject(a), $3d132bbf7812485b$var$headersToObject(b), prop, true)
    };
    (0, $adReO.default).forEach($3d132bbf7812485b$var$ownEnumerableKeys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $adReO.default).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $adReO.default).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $adReO.default).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $adReO.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $adReO.default).hasOwnProp(config2, 'validateStatus') && (0, $adReO.default).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $adReO.default).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}

});

parcelRegister("3VlFm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2db7806979b02fe9$export$2e2bcd8739ae039; });
'use strict';
const $2db7806979b02fe9$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $2db7806979b02fe9$export$2e2bcd8739ae039(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($2db7806979b02fe9$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}

});



parcelRegister("gFb9g", function(module, exports) {

$parcel$export(module.exports, "getFetch", function () { return $c2191f87f9ef3849$export$3105c6651375d4fa; });

var $lsAph = parcelRequire("lsAph");

var $adReO = parcelRequire("adReO");

var $fX03H = parcelRequire("fX03H");

var $8tBgw = parcelRequire("8tBgw");

var $h0KLB = parcelRequire("h0KLB");

var $ha7aM = parcelRequire("ha7aM");

var $j5Ofq = parcelRequire("j5Ofq");

var $f73QF = parcelRequire("f73QF");

var $3PfpF = parcelRequire("3PfpF");

var $hoon5 = parcelRequire("hoon5");

var $cR4ZD = parcelRequire("cR4ZD");

var $kFIA2 = parcelRequire("kFIA2");
const $c2191f87f9ef3849$var$DEFAULT_CHUNK_SIZE = 65536;
const $c2191f87f9ef3849$var$DEFAULT_REQUEST_OPTIONS = {
    cache: 'default',
    redirect: 'follow',
    referrer: 'about:client',
    referrerPolicy: '',
    mode: 'cors',
    integrity: '',
    keepalive: false,
    priority: 'auto',
    window: null
};
const { isFunction: $c2191f87f9ef3849$var$isFunction } = (0, $adReO.default);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $c2191f87f9ef3849$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $c2191f87f9ef3849$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $adReO.default).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $c2191f87f9ef3849$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $c2191f87f9ef3849$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $c2191f87f9ef3849$var$factory = (env)=>{
    const globalObject = (0, $adReO.default).global !== undefined && (0, $adReO.default).global !== null ? (0, $adReO.default).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $adReO.default).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $c2191f87f9ef3849$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $c2191f87f9ef3849$var$isFunction(Request);
    const isResponseSupported = $c2191f87f9ef3849$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $c2191f87f9ef3849$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $c2191f87f9ef3849$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $lsAph.default).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $c2191f87f9ef3849$var$test(()=>(0, $adReO.default).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $fX03H.default)(`Response type '${type}' is not supported`, (0, $fX03H.default).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $adReO.default).isBlob(body)) return body.size;
        if ((0, $adReO.default).isSpecCompliantForm(body)) {
            const _request = new Request((0, $lsAph.default).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $adReO.default).isArrayBufferView(body) || (0, $adReO.default).isArrayBuffer(body)) return body.byteLength;
        if ((0, $adReO.default).isURLSearchParams(body)) body = body + '';
        if ((0, $adReO.default).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $adReO.default).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength, maxRedirects: maxRedirects } = (0, $f73QF.default)(config);
        const hasMaxContentLength = (0, $adReO.default).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $adReO.default).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $adReO.default).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $8tBgw.default)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $fX03H.default)('Request body larger than maxBodyLength limit', (0, $fX03H.default).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, $adReO.default).getSafeProp(configAuth, 'username') || '';
                const password = (0, $adReO.default).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($c2191f87f9ef3849$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $lsAph.default).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $c2191f87f9ef3849$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $c2191f87f9ef3849$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($c2191f87f9ef3849$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $hoon5.default)(url);
                if (estimated > maxContentLength) throw new (0, $fX03H.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $fX03H.default).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $adReO.default).isReadableStream(data) || (0, $adReO.default).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $h0KLB.trackStream)(stream, $c2191f87f9ef3849$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, $adReO.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $j5Ofq.progressEventDecorator)(requestContentLength, (0, $j5Ofq.progressEventReducer)((0, $j5Ofq.asyncDecorator)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $fX03H.default)('Stream request bodies are not supported by the current fetch implementation', (0, $fX03H.default).ERR_NOT_SUPPORT, config, request);
            if (!(0, $adReO.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $adReO.default).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $cR4ZD.VERSION), false);
            const safeFetchOptions = fetchOptions == null ? fetchOptions : Object.assign(Object.create(null), fetchOptions);
            if (safeFetchOptions) {
                // These options are owned by Axios and are already reflected in the
                // resolved Request passed to fetch.
                delete safeFetchOptions.body;
                delete safeFetchOptions.headers;
                delete safeFetchOptions.method;
                delete safeFetchOptions.signal;
                delete safeFetchOptions.duplex;
                delete safeFetchOptions.credentials;
            }
            const resolvedOptions = Object.assign(Object.create(null), safeFetchOptions, {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $kFIA2.toByteStringHeaderObject)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            });
            if (isRequestSupported) {
                (0, $adReO.default).forEach($c2191f87f9ef3849$var$DEFAULT_REQUEST_OPTIONS, (value, key)=>{
                    if (resolvedOptions[key] === undefined) resolvedOptions[key] = value;
                });
                if (resolvedOptions.signal === undefined) resolvedOptions.signal = null;
                if (resolvedOptions.body === undefined) resolvedOptions.body = null;
            }
            if (maxRedirects === 0) {
                resolvedOptions.redirect = 'manual';
                if (safeFetchOptions) safeFetchOptions.redirect = 'manual';
            }
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, safeFetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $ha7aM.default).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $adReO.default).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $fX03H.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $fX03H.default).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $adReO.default).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $j5Ofq.progressEventDecorator)(responseContentLength, (0, $j5Ofq.progressEventReducer)((0, $j5Ofq.asyncDecorator)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $fX03H.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $fX03H.default).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $h0KLB.trackStream)(response.body, $c2191f87f9ef3849$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $adReO.default).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $fX03H.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $fX03H.default).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $3PfpF.default)(resolve, reject, {
                    data: responseData,
                    headers: (0, $ha7aM.default).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $fX03H.default)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $fX03H.default)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $fX03H.default)('Network Error', (0, $fX03H.default).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $fX03H.default).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $c2191f87f9ef3849$var$seedCache = new Map();
const $c2191f87f9ef3849$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $c2191f87f9ef3849$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $c2191f87f9ef3849$var$factory(env));
        map = target;
    }
    return target;
};
const $c2191f87f9ef3849$var$adapter = $c2191f87f9ef3849$export$3105c6651375d4fa();
var $c2191f87f9ef3849$export$2e2bcd8739ae039 = $c2191f87f9ef3849$var$adapter;

});
parcelRegister("8tBgw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62bdf0498e608a4a$export$2e2bcd8739ae039; });

var $lb2qV = parcelRequire("lb2qV");

var $fX03H = parcelRequire("fX03H");

var $adReO = parcelRequire("adReO");
const $62bdf0498e608a4a$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $fX03H.default) ? err : new (0, $lb2qV.default)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $fX03H.default)(`timeout of ${timeout}ms exceeded`, (0, $fX03H.default).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>{
        if (aborted) return;
        if (signal.aborted) {
            onabort.call(signal);
            return;
        }
        signal.addEventListener('abort', onabort, {
            once: true
        });
    });
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $adReO.default).asap(unsubscribe);
    return signal;
};
var $62bdf0498e608a4a$export$2e2bcd8739ae039 = $62bdf0498e608a4a$var$composeSignals;

});

parcelRegister("h0KLB", function(module, exports) {

$parcel$export(module.exports, "trackStream", function () { return $c626b6acbc30fe14$export$b0119225647bd83; });
const $c626b6acbc30fe14$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c626b6acbc30fe14$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c626b6acbc30fe14$var$readStream(iterable))yield* $c626b6acbc30fe14$export$71b051935044bd5d(chunk, chunkSize);
};
const $c626b6acbc30fe14$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c626b6acbc30fe14$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c626b6acbc30fe14$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});

parcelRegister("hoon5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca979531ea712187$export$2e2bcd8739ae039; });
/**
 * Estimate data: URL byte lengths *without* allocating large buffers.
 * - Fetch percent-decodes a base64 body before decoding it.
 * - Node's Buffer.from(body, 'base64') sizes its backing allocation from the
 *   raw body, including ignored characters and content after padding.
 * - Non-base64 data is percent-decoded and then encoded as UTF-8.
 */ const $ca979531ea712187$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $ca979531ea712187$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $ca979531ea712187$var$isHexDigit(str.charCodeAt(i + 1)) && $ca979531ea712187$var$isHexDigit(str.charCodeAt(i + 2));
const $ca979531ea712187$var$hexValue = (charCode)=>charCode <= 57 ? charCode - 48 : (charCode & 0xdf) - 55;
const $ca979531ea712187$var$isBase64Char = (charCode)=>charCode >= 65 && charCode <= 90 || // A-Z
    charCode >= 97 && charCode <= 122 || // a-z
    charCode >= 48 && charCode <= 57 || // 0-9
    charCode === 43 || // +
    charCode === 47 || // /
    charCode === 45 || // - (base64url)
    charCode === 95; // _ (base64url)
const $ca979531ea712187$var$isBase64Whitespace = (charCode)=>charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
const $ca979531ea712187$var$base64Bytes = (significant)=>{
    const groups = Math.floor(significant / 4);
    const remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
};
// Buffer.byteLength(body, 'base64') uses the raw string length as an allocation
// upper bound even when Buffer.from later ignores characters or stops at '='.
const $ca979531ea712187$var$estimateBase64BufferAllocation = (body)=>{
    const len = body.length;
    let padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61 /* '=' */ ) {
        padding++;
        if (len > 1 && body.charCodeAt(len - 2) === 61 /* '=' */ ) padding++;
    }
    return Math.floor((len - padding) * 3 / 4);
};
const $ca979531ea712187$var$estimatePercentDecodedBase64Bytes = (body)=>{
    const len = body.length;
    let significant = 0;
    let padding = 0;
    let invalid = false;
    for(let i = 0; i < len; i++){
        let code = body.charCodeAt(i);
        if (code === 37 /* '%' */  && $ca979531ea712187$var$isPercentEncodedByte(body, i, len)) {
            code = $ca979531ea712187$var$hexValue(body.charCodeAt(i + 1)) * 16 + $ca979531ea712187$var$hexValue(body.charCodeAt(i + 2));
            i += 2;
        }
        if ($ca979531ea712187$var$isBase64Whitespace(code)) continue;
        if (code === 61 /* '=' */ ) {
            padding++;
            continue;
        }
        if (!$ca979531ea712187$var$isBase64Char(code) || padding > 0) {
            invalid = true;
            continue;
        }
        significant++;
    }
    // Fetch rejects malformed forgiving-base64 input. Returning the raw-size
    // allocation bound keeps that invalid input from becoming a pre-check bypass.
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) return $ca979531ea712187$var$estimateBase64BufferAllocation(body);
    return $ca979531ea712187$var$base64Bytes(significant);
};
const $ca979531ea712187$var$estimateDataURLBytes = (url, estimateBase64)=>{
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) return estimateBase64(body);
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $ca979531ea712187$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
};
function $ca979531ea712187$export$2e2bcd8739ae039(url) {
    // Fetch removes URL fragments before processing a data: URL.
    const fragmentIndex = typeof url === 'string' ? url.indexOf('#') : -1;
    return $ca979531ea712187$var$estimateDataURLBytes(fragmentIndex === -1 ? url : url.slice(0, fragmentIndex), $ca979531ea712187$var$estimatePercentDecodedBase64Bytes);
}
function $ca979531ea712187$export$1f39e64b554a246f(url) {
    return $ca979531ea712187$var$estimateDataURLBytes(url, $ca979531ea712187$var$estimateBase64BufferAllocation);
}

});

parcelRegister("cR4ZD", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $95be4ecd446de127$export$a4ad2735b021c132; });
const $95be4ecd446de127$export$a4ad2735b021c132 = "1.20.0";

});




parcelRegister("2iR5D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ad671c27810423e$export$2e2bcd8739ae039; });

var $cR4ZD = parcelRequire("cR4ZD");

var $fX03H = parcelRequire("fX03H");
'use strict';
const $1ad671c27810423e$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $1ad671c27810423e$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $1ad671c27810423e$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $1ad671c27810423e$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $cR4ZD.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $fX03H.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $fX03H.default).ERR_DEPRECATED);
        if (version && !$1ad671c27810423e$var$deprecatedWarnings[opt]) {
            $1ad671c27810423e$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$1ad671c27810423e$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $1ad671c27810423e$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new (0, $fX03H.default)('options must be an object', (0, $fX03H.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $fX03H.default)('option ' + opt + ' must be ' + result, (0, $fX03H.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $fX03H.default)('Unknown option ' + opt, (0, $fX03H.default).ERR_BAD_OPTION);
    }
}
var $1ad671c27810423e$export$2e2bcd8739ae039 = {
    assertOptions: $1ad671c27810423e$var$assertOptions,
    validators: $1ad671c27810423e$var$validators
};

});


parcelRegister("kZZD0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4994f37c883aea2$export$2e2bcd8739ae039; });

var $lb2qV = parcelRequire("lb2qV");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $f4994f37c883aea2$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $lb2qV.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $f4994f37c883aea2$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $f4994f37c883aea2$export$2e2bcd8739ae039 = $f4994f37c883aea2$var$CancelToken;

});

parcelRegister("b676K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8145c4b68bfee186$export$2e2bcd8739ae039; });
'use strict';
function $8145c4b68bfee186$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("kgiwQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec03acb464b74212$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");
'use strict';
function $ec03acb464b74212$export$2e2bcd8739ae039(payload) {
    return (0, $adReO.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("ewGK1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9353565c2e0947e$export$2e2bcd8739ae039; });
const $a9353565c2e0947e$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    /**
   * @deprecated Use `ContentTooLarge` instead.
   */ PayloadTooLarge: 413,
    ContentTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    /**
   * @deprecated Use `UnprocessableContent` instead.
   */ UnprocessableEntity: 422,
    UnprocessableContent: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($a9353565c2e0947e$var$HttpStatusCode).forEach(([key, value])=>{
    if ($a9353565c2e0947e$var$HttpStatusCode[value] === undefined) $a9353565c2e0947e$var$HttpStatusCode[value] = key;
});
var $a9353565c2e0947e$export$2e2bcd8739ae039 = $a9353565c2e0947e$var$HttpStatusCode;

});



parcelRegister("a1NKN", function(module, exports) {

$parcel$export(module.exports, "StatusCodes", function () { return $74d09775b34cce5b$export$efd5569f873811b1; });
// Generated file. Do not edit
var $74d09775b34cce5b$export$efd5569f873811b1;
(function(StatusCodes) {
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.2.1
     *
     * This interim response indicates that everything so far is OK and that the client should continue with the request or ignore it if it is already finished.
     */ StatusCodes[StatusCodes["CONTINUE"] = 100] = "CONTINUE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.2.2
     *
     * This code is sent in response to an Upgrade request header by the client, and indicates the protocol the server is switching too.
     */ StatusCodes[StatusCodes["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.1
     *
     * This code indicates that the server has received and is processing the request, but no response is available yet.
     */ StatusCodes[StatusCodes["PROCESSING"] = 102] = "PROCESSING";
    /**
     * Official Documentation @ https://www.rfc-editor.org/rfc/rfc8297#page-3
     *
     * This code indicates to the client that the server is likely to send a final response with the header fields included in the informational response.
     */ StatusCodes[StatusCodes["EARLY_HINTS"] = 103] = "EARLY_HINTS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.1
     *
     * The request has succeeded. The meaning of a success varies depending on the HTTP method:
     * GET: The resource has been fetched and is transmitted in the message body.
     * HEAD: The entity headers are in the message body.
     * POST: The resource describing the result of the action is transmitted in the message body.
     * TRACE: The message body contains the request message as received by the server
     */ StatusCodes[StatusCodes["OK"] = 200] = "OK";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.2
     *
     * The request has succeeded and a new resource has been created as a result of it. This is typically the response sent after a PUT request.
     */ StatusCodes[StatusCodes["CREATED"] = 201] = "CREATED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.3
     *
     * The request has been received but not yet acted upon. It is non-committal, meaning that there is no way in HTTP to later send an asynchronous response indicating the outcome of processing the request. It is intended for cases where another process or server handles the request, or for batch processing.
     */ StatusCodes[StatusCodes["ACCEPTED"] = 202] = "ACCEPTED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.4
     *
     * This response code means returned meta-information set is not exact set as available from the origin server, but collected from a local or a third party copy. Except this condition, 200 OK response should be preferred instead of this response.
     */ StatusCodes[StatusCodes["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.5
     *
     * There is no content to send for this request, but the headers may be useful. The user-agent may update its cached headers for this resource with the new ones.
     */ StatusCodes[StatusCodes["NO_CONTENT"] = 204] = "NO_CONTENT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.6
     *
     * This response code is sent after accomplishing request to tell user agent reset document view which sent this request.
     */ StatusCodes[StatusCodes["RESET_CONTENT"] = 205] = "RESET_CONTENT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7233#section-4.1
     *
     * This response code is used because of range header sent by the client to separate download into multiple streams.
     */ StatusCodes[StatusCodes["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.2
     *
     * A Multi-Status response conveys information about multiple resources in situations where multiple status codes might be appropriate.
     */ StatusCodes[StatusCodes["MULTI_STATUS"] = 207] = "MULTI_STATUS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.1
     *
     * The request has more than one possible responses. User-agent or user should choose one of them. There is no standardized way to choose one of the responses.
     */ StatusCodes[StatusCodes["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.2
     *
     * This response code means that URI of requested resource has been changed. Probably, new URI would be given in the response.
     */ StatusCodes[StatusCodes["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.3
     *
     * This response code means that URI of requested resource has been changed temporarily. New changes in the URI might be made in the future. Therefore, this same URI should be used by the client in future requests.
     */ StatusCodes[StatusCodes["MOVED_TEMPORARILY"] = 302] = "MOVED_TEMPORARILY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.4
     *
     * Server sent this response to directing client to get requested resource to another URI with an GET request.
     */ StatusCodes[StatusCodes["SEE_OTHER"] = 303] = "SEE_OTHER";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7232#section-4.1
     *
     * This is used for caching purposes. It is telling to client that response has not been modified. So, client can continue to use same cached version of response.
     */ StatusCodes[StatusCodes["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
    /**
     * @deprecated
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.6
     *
     * Was defined in a previous version of the HTTP specification to indicate that a requested response must be accessed by a proxy. It has been deprecated due to security concerns regarding in-band configuration of a proxy.
     */ StatusCodes[StatusCodes["USE_PROXY"] = 305] = "USE_PROXY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.7
     *
     * Server sent this response to directing client to get requested resource to another URI with same method that used prior request. This has the same semantic than the 302 Found HTTP response code, with the exception that the user agent must not change the HTTP method used: if a POST was used in the first request, a POST must be used in the second request.
     */ StatusCodes[StatusCodes["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7538#section-3
     *
     * This means that the resource is now permanently located at another URI, specified by the Location: HTTP Response header. This has the same semantics as the 301 Moved Permanently HTTP response code, with the exception that the user agent must not change the HTTP method used: if a POST was used in the first request, a POST must be used in the second request.
     */ StatusCodes[StatusCodes["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.1
     *
     * This response means that server could not understand the request due to invalid syntax.
     */ StatusCodes[StatusCodes["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7235#section-3.1
     *
     * Although the HTTP standard specifies "unauthorized", semantically this response means "unauthenticated". That is, the client must authenticate itself to get the requested response.
     */ StatusCodes[StatusCodes["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.2
     *
     * This response code is reserved for future use. Initial aim for creating this code was using it for digital payment systems however this is not used currently.
     */ StatusCodes[StatusCodes["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.3
     *
     * The client does not have access rights to the content, i.e. they are unauthorized, so server is rejecting to give proper response. Unlike 401, the client's identity is known to the server.
     */ StatusCodes[StatusCodes["FORBIDDEN"] = 403] = "FORBIDDEN";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.4
     *
     * The server can not find requested resource. In the browser, this means the URL is not recognized. In an API, this can also mean that the endpoint is valid but the resource itself does not exist. Servers may also send this response instead of 403 to hide the existence of a resource from an unauthorized client. This response code is probably the most famous one due to its frequent occurence on the web.
     */ StatusCodes[StatusCodes["NOT_FOUND"] = 404] = "NOT_FOUND";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.5
     *
     * The request method is known by the server but has been disabled and cannot be used. For example, an API may forbid DELETE-ing a resource. The two mandatory methods, GET and HEAD, must never be disabled and should not return this error code.
     */ StatusCodes[StatusCodes["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.6
     *
     * This response is sent when the web server, after performing server-driven content negotiation, doesn't find any content following the criteria given by the user agent.
     */ StatusCodes[StatusCodes["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7235#section-3.2
     *
     * This is similar to 401 but authentication is needed to be done by a proxy.
     */ StatusCodes[StatusCodes["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.7
     *
     * This response is sent on an idle connection by some servers, even without any previous request by the client. It means that the server would like to shut down this unused connection. This response is used much more since some browsers, like Chrome, Firefox 27+, or IE9, use HTTP pre-connection mechanisms to speed up surfing. Also note that some servers merely shut down the connection without sending this message.
     */ StatusCodes[StatusCodes["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.8
     *
     * This response is sent when a request conflicts with the current state of the server.
     */ StatusCodes[StatusCodes["CONFLICT"] = 409] = "CONFLICT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.9
     *
     * This response would be sent when the requested content has been permenantly deleted from server, with no forwarding address. Clients are expected to remove their caches and links to the resource. The HTTP specification intends this status code to be used for "limited-time, promotional services". APIs should not feel compelled to indicate resources that have been deleted with this status code.
     */ StatusCodes[StatusCodes["GONE"] = 410] = "GONE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.10
     *
     * The server rejected the request because the Content-Length header field is not defined and the server requires it.
     */ StatusCodes[StatusCodes["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7232#section-4.2
     *
     * The client has indicated preconditions in its headers which the server does not meet.
     */ StatusCodes[StatusCodes["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.11
     *
     * Request entity is larger than limits defined by server; the server might close the connection or return an Retry-After header field.
     */ StatusCodes[StatusCodes["REQUEST_TOO_LONG"] = 413] = "REQUEST_TOO_LONG";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.12
     *
     * The URI requested by the client is longer than the server is willing to interpret.
     */ StatusCodes[StatusCodes["REQUEST_URI_TOO_LONG"] = 414] = "REQUEST_URI_TOO_LONG";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.13
     *
     * The media format of the requested data is not supported by the server, so the server is rejecting the request.
     */ StatusCodes[StatusCodes["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7233#section-4.4
     *
     * The range specified by the Range header field in the request can't be fulfilled; it's possible that the range is outside the size of the target URI's data.
     */ StatusCodes[StatusCodes["REQUESTED_RANGE_NOT_SATISFIABLE"] = 416] = "REQUESTED_RANGE_NOT_SATISFIABLE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.14
     *
     * This response code means the expectation indicated by the Expect request header field can't be met by the server.
     */ StatusCodes[StatusCodes["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2324#section-2.3.2
     *
     * Any attempt to brew coffee with a teapot should result in the error code "418 I'm a teapot". The resulting entity body MAY be short and stout.
     */ StatusCodes[StatusCodes["IM_A_TEAPOT"] = 418] = "IM_A_TEAPOT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.6
     *
     * The 507 (Insufficient Storage) status code means the method could not be performed on the resource because the server is unable to store the representation needed to successfully complete the request. This condition is considered to be temporary. If the request which received this status code was the result of a user action, the request MUST NOT be repeated until it is requested by a separate user action.
     */ StatusCodes[StatusCodes["INSUFFICIENT_SPACE_ON_RESOURCE"] = 419] = "INSUFFICIENT_SPACE_ON_RESOURCE";
    /**
     * @deprecated
     * Official Documentation @ https://tools.ietf.org/rfcdiff?difftype=--hwdiff&url2=draft-ietf-webdav-protocol-06.txt
     *
     * A deprecated response used by the Spring Framework when a method has failed.
     */ StatusCodes[StatusCodes["METHOD_FAILURE"] = 420] = "METHOD_FAILURE";
    /**
     * Official Documentation @ https://datatracker.ietf.org/doc/html/rfc7540#section-9.1.2
     *
     * Defined in the specification of HTTP/2 to indicate that a server is not able to produce a response for the combination of scheme and authority that are included in the request URI.
     */ StatusCodes[StatusCodes["MISDIRECTED_REQUEST"] = 421] = "MISDIRECTED_REQUEST";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.3
     *
     * The request was well-formed but was unable to be followed due to semantic errors.
     */ StatusCodes[StatusCodes["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.4
     *
     * The resource that is being accessed is locked.
     */ StatusCodes[StatusCodes["LOCKED"] = 423] = "LOCKED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.5
     *
     * The request failed due to failure of a previous request.
     */ StatusCodes[StatusCodes["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
    /**
     * Official Documentation @ https://datatracker.ietf.org/doc/html/rfc7231#section-6.5.15
     *
     * The server refuses to perform the request using the current protocol but might be willing to do so after the client upgrades to a different protocol.
     */ StatusCodes[StatusCodes["UPGRADE_REQUIRED"] = 426] = "UPGRADE_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-3
     *
     * The origin server requires the request to be conditional. Intended to prevent the 'lost update' problem, where a client GETs a resource's state, modifies it, and PUTs it back to the server, when meanwhile a third party has modified the state on the server, leading to a conflict.
     */ StatusCodes[StatusCodes["PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-4
     *
     * The user has sent too many requests in a given amount of time ("rate limiting").
     */ StatusCodes[StatusCodes["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-5
     *
     * The server is unwilling to process the request because its header fields are too large. The request MAY be resubmitted after reducing the size of the request header fields.
     */ StatusCodes[StatusCodes["REQUEST_HEADER_FIELDS_TOO_LARGE"] = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7725
     *
     * The user-agent requested a resource that cannot legally be provided, such as a web page censored by a government.
     */ StatusCodes[StatusCodes["UNAVAILABLE_FOR_LEGAL_REASONS"] = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.1
     *
     * The server encountered an unexpected condition that prevented it from fulfilling the request.
     */ StatusCodes[StatusCodes["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.2
     *
     * The request method is not supported by the server and cannot be handled. The only methods that servers are required to support (and therefore that must not return this code) are GET and HEAD.
     */ StatusCodes[StatusCodes["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.3
     *
     * This error response means that the server, while working as a gateway to get a response needed to handle the request, got an invalid response.
     */ StatusCodes[StatusCodes["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.4
     *
     * The server is not ready to handle the request. Common causes are a server that is down for maintenance or that is overloaded. Note that together with this response, a user-friendly page explaining the problem should be sent. This responses should be used for temporary conditions and the Retry-After: HTTP header should, if possible, contain the estimated time before the recovery of the service. The webmaster must also take care about the caching-related headers that are sent along with this response, as these temporary condition responses should usually not be cached.
     */ StatusCodes[StatusCodes["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.5
     *
     * This error response is given when the server is acting as a gateway and cannot get a response in time.
     */ StatusCodes[StatusCodes["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.6
     *
     * The HTTP version used in the request is not supported by the server.
     */ StatusCodes[StatusCodes["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.6
     *
     * The server has an internal configuration error: the chosen variant resource is configured to engage in transparent content negotiation itself, and is therefore not a proper end point in the negotiation process.
     */ StatusCodes[StatusCodes["INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-6
     *
     * The 511 status code indicates that the client needs to authenticate to gain network access.
     */ StatusCodes[StatusCodes["NETWORK_AUTHENTICATION_REQUIRED"] = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})($74d09775b34cce5b$export$efd5569f873811b1 || ($74d09775b34cce5b$export$efd5569f873811b1 = {}));

});

parcelRegister("aU4vn", function(module, exports) {

$parcel$export(module.exports, "Base64", function () { return $21da20d2fc3ca230$export$f436b0c2107cbd35; });
/**
 *  base64.ts
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 *
 * @author Dan Kogai (https://github.com/dankogai)
 */ const $21da20d2fc3ca230$export$83d89fbfd8236492 = '3.9.4';
/**
 * @deprecated use lowercase `version`.
 */ const $21da20d2fc3ca230$export$a4ad2735b021c132 = $21da20d2fc3ca230$export$83d89fbfd8236492;
const $21da20d2fc3ca230$var$_TD = typeof TextDecoder === 'function' ? new TextDecoder('utf-8', {
    ignoreBOM: true
}) : undefined;
const $21da20d2fc3ca230$var$_TE = typeof TextEncoder === 'function' ? new TextEncoder() : undefined;
const $21da20d2fc3ca230$var$b64ch = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
const $21da20d2fc3ca230$var$b64chs = Array.prototype.slice.call($21da20d2fc3ca230$var$b64ch);
const $21da20d2fc3ca230$var$b64tab = ((a)=>{
    let tab = {};
    a.forEach((c, i)=>tab[c] = i);
    return tab;
})($21da20d2fc3ca230$var$b64chs);
const $21da20d2fc3ca230$var$b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
const $21da20d2fc3ca230$var$_fromCC = String.fromCharCode.bind(String);
const $21da20d2fc3ca230$var$_U8Afrom = typeof Uint8Array.from === 'function' ? Uint8Array.from.bind(Uint8Array) : (it)=>new Uint8Array(Array.prototype.slice.call(it, 0));
const $21da20d2fc3ca230$var$_mkUriSafe = (src)=>src.replace(/=/g, '').replace(/[+\/]/g, (m0)=>m0 == '+' ? '-' : '_');
const $21da20d2fc3ca230$var$_tidyB64 = (s)=>s.replace(/[^A-Za-z0-9\+\/]/g, '');
/**
 * polyfill version of `btoa`
 */ const $21da20d2fc3ca230$export$ec0fb543302ee251 = (bin)=>{
    // console.log('polyfilled');
    let u32, c0, c1, c2, asc = '';
    const pad = bin.length % 3;
    for(let i = 0; i < bin.length;){
        if ((c0 = bin.charCodeAt(i++)) > 255 || (c1 = bin.charCodeAt(i++)) > 255 || (c2 = bin.charCodeAt(i++)) > 255) throw new TypeError('invalid character found');
        u32 = c0 << 16 | c1 << 8 | c2;
        asc += $21da20d2fc3ca230$var$b64chs[u32 >> 18 & 63] + $21da20d2fc3ca230$var$b64chs[u32 >> 12 & 63] + $21da20d2fc3ca230$var$b64chs[u32 >> 6 & 63] + $21da20d2fc3ca230$var$b64chs[u32 & 63];
    }
    return pad ? asc.slice(0, pad - 3) + "===".substring(pad) : asc;
};
/**
 * does what `window.btoa` of web browsers do.
 * @param {String} bin binary string
 * @returns {string} Base64-encoded string
 */ const $21da20d2fc3ca230$export$a32219e24f8d1e2 = typeof btoa === 'function' ? (bin)=>btoa(bin) : $21da20d2fc3ca230$export$ec0fb543302ee251;
const $21da20d2fc3ca230$var$_fromUint8Array = typeof Uint8Array.prototype.toBase64 === 'function' ? (u8a)=>u8a.toBase64() : (u8a)=>{
    // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
    const maxargs = 0x1000;
    let strs = [];
    for(let i = 0, l = u8a.length; i < l; i += maxargs)strs.push($21da20d2fc3ca230$var$_fromCC.apply(null, u8a.subarray(i, i + maxargs)));
    return $21da20d2fc3ca230$export$a32219e24f8d1e2(strs.join(''));
};
/**
 * converts a Uint8Array to a Base64 string.
 * @param {boolean} [urlsafe] URL-and-filename-safe a la RFC4648 §5
 * @returns {string} Base64 string
 */ const $21da20d2fc3ca230$export$27bbb4e040978768 = (u8a, urlsafe = false)=>urlsafe ? $21da20d2fc3ca230$var$_mkUriSafe($21da20d2fc3ca230$var$_fromUint8Array(u8a)) : $21da20d2fc3ca230$var$_fromUint8Array(u8a);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const utob = (src: string) => unescape(encodeURIComponent(src));
// reverting good old fationed regexp
const $21da20d2fc3ca230$var$cb_utob = (c)=>{
    if (c.length < 2) {
        var cc = c.charCodeAt(0);
        return cc < 0x80 ? c : cc < 0x800 ? $21da20d2fc3ca230$var$_fromCC(0xc0 | cc >>> 6) + $21da20d2fc3ca230$var$_fromCC(0x80 | cc & 0x3f) : $21da20d2fc3ca230$var$_fromCC(0xe0 | cc >>> 12 & 0x0f) + $21da20d2fc3ca230$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $21da20d2fc3ca230$var$_fromCC(0x80 | cc & 0x3f);
    } else {
        var cc = 0x10000 + (c.charCodeAt(0) - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00);
        return $21da20d2fc3ca230$var$_fromCC(0xf0 | cc >>> 18 & 0x07) + $21da20d2fc3ca230$var$_fromCC(0x80 | cc >>> 12 & 0x3f) + $21da20d2fc3ca230$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $21da20d2fc3ca230$var$_fromCC(0x80 | cc & 0x3f);
    }
};
const $21da20d2fc3ca230$var$re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFF]|[^\x00-\x7F]/g;
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-8 string
 * @returns {string} UTF-16 string
 */ const $21da20d2fc3ca230$export$10d4b9bd20a66b0 = (u)=>u.replace($21da20d2fc3ca230$var$re_utob, $21da20d2fc3ca230$var$cb_utob);
//
const $21da20d2fc3ca230$var$_encode = $21da20d2fc3ca230$var$_TE ? (s)=>$21da20d2fc3ca230$var$_fromUint8Array($21da20d2fc3ca230$var$_TE.encode(s)) : (s)=>$21da20d2fc3ca230$export$a32219e24f8d1e2($21da20d2fc3ca230$export$10d4b9bd20a66b0(s));
/**
 * converts a UTF-8-encoded string to a Base64 string.
 * @param {boolean} [urlsafe] if `true` make the result URL-safe
 * @returns {string} Base64 string
 */ const $21da20d2fc3ca230$export$c564cdbbe6da493 = (src, urlsafe = false)=>urlsafe ? $21da20d2fc3ca230$var$_mkUriSafe($21da20d2fc3ca230$var$_encode(src)) : $21da20d2fc3ca230$var$_encode(src);
/**
 * converts a UTF-8-encoded string to URL-safe Base64 RFC4648 §5.
 * @returns {string} Base64 string
 */ const $21da20d2fc3ca230$export$90c31d5baa78df44 = (src)=>$21da20d2fc3ca230$export$c564cdbbe6da493(src, true);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const btou = (src: string) => decodeURIComponent(escape(src));
// reverting good old fationed regexp
const $21da20d2fc3ca230$var$re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
const $21da20d2fc3ca230$var$cb_btou = (cccc)=>{
    switch(cccc.length){
        case 4:
            var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3), offset = cp - 0x10000;
            return $21da20d2fc3ca230$var$_fromCC((offset >>> 10) + 0xD800) + $21da20d2fc3ca230$var$_fromCC((offset & 0x3FF) + 0xDC00);
        case 3:
            return $21da20d2fc3ca230$var$_fromCC((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));
        default:
            return $21da20d2fc3ca230$var$_fromCC((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
    }
};
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-16 string
 * @returns {string} UTF-8 string
 */ const $21da20d2fc3ca230$export$67e9defdeac3dd95 = (b)=>b.replace($21da20d2fc3ca230$var$re_btou, $21da20d2fc3ca230$var$cb_btou);
/**
 * polyfill version of `atob`
 */ const $21da20d2fc3ca230$export$7f16d8e674ddec24 = (asc)=>{
    // console.log('polyfilled');
    asc = asc.replace(/\s+/g, '');
    if (!$21da20d2fc3ca230$var$b64re.test(asc)) throw new TypeError('malformed base64.');
    asc += '=='.slice(2 - (asc.length & 3));
    let u24, r1, r2;
    let binArray = []; // use array to avoid minor gc in loop
    for(let i = 0; i < asc.length;){
        u24 = $21da20d2fc3ca230$var$b64tab[asc.charAt(i++)] << 18 | $21da20d2fc3ca230$var$b64tab[asc.charAt(i++)] << 12 | (r1 = $21da20d2fc3ca230$var$b64tab[asc.charAt(i++)]) << 6 | (r2 = $21da20d2fc3ca230$var$b64tab[asc.charAt(i++)]);
        if (r1 === 64) binArray.push($21da20d2fc3ca230$var$_fromCC(u24 >> 16 & 255));
        else if (r2 === 64) binArray.push($21da20d2fc3ca230$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255));
        else binArray.push($21da20d2fc3ca230$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255, u24 & 255));
    }
    return binArray.join('');
};
/**
 * does what `window.atob` of web browsers do.
 * @param {String} asc Base64-encoded string
 * @returns {string} binary string
 */ const $21da20d2fc3ca230$export$1406ac7a6dfd7b7a = typeof atob === 'function' ? (asc)=>atob($21da20d2fc3ca230$var$_tidyB64(asc)) : $21da20d2fc3ca230$export$7f16d8e674ddec24;
//
const $21da20d2fc3ca230$var$_toUint8Array = typeof Uint8Array.fromBase64 === 'function' ? (a)=>Uint8Array.fromBase64(a) : (a)=>$21da20d2fc3ca230$var$_U8Afrom($21da20d2fc3ca230$export$1406ac7a6dfd7b7a(a).split('').map((c)=>c.charCodeAt(0)));
/**
 * converts a Base64 string to a Uint8Array.
 */ const $21da20d2fc3ca230$export$73470fd2221e6aef = (a)=>$21da20d2fc3ca230$var$_toUint8Array($21da20d2fc3ca230$var$_unURI(a));
//
const $21da20d2fc3ca230$var$_decode = $21da20d2fc3ca230$var$_TD ? (a)=>$21da20d2fc3ca230$var$_TD.decode($21da20d2fc3ca230$var$_toUint8Array(a)) : (a)=>$21da20d2fc3ca230$export$67e9defdeac3dd95($21da20d2fc3ca230$export$1406ac7a6dfd7b7a(a));
const $21da20d2fc3ca230$var$_unURI = (a)=>$21da20d2fc3ca230$var$_tidyB64(a.replace(/[-_]/g, (m0)=>m0 == '-' ? '+' : '/'));
/**
 * converts a Base64 string to a UTF-8 string.
 * @param {String} src Base64 string.  Both normal and URL-safe are supported
 * @returns {string} UTF-8 string
 */ const $21da20d2fc3ca230$export$2f872c0f2117be69 = (src)=>$21da20d2fc3ca230$var$_decode($21da20d2fc3ca230$var$_unURI(src));
/**
 * check if a value is a valid Base64 string
 * @param {String} src a value to check
  */ const $21da20d2fc3ca230$export$1ea939691cdc45b8 = (src)=>{
    if (typeof src !== 'string') return false;
    const s = src.replace(/\s+/g, '').replace(/={0,2}$/, '');
    return !/[^\s0-9a-zA-Z\+/]/.test(s) || !/[^\s0-9a-zA-Z\-_]/.test(s);
};
//
const $21da20d2fc3ca230$var$_noEnum = (v)=>{
    return {
        value: v,
        enumerable: false,
        writable: true,
        configurable: true
    };
};
/**
 * extend String.prototype with relevant methods
 */ const $21da20d2fc3ca230$export$4678ebf2295c49b = function() {
    const _add = (name, body)=>Object.defineProperty(String.prototype, name, $21da20d2fc3ca230$var$_noEnum(body));
    _add('fromBase64', function() {
        return $21da20d2fc3ca230$export$2f872c0f2117be69(this);
    });
    _add('toBase64', function(urlsafe) {
        return $21da20d2fc3ca230$export$c564cdbbe6da493(this, urlsafe);
    });
    _add('toBase64URI', function() {
        return $21da20d2fc3ca230$export$c564cdbbe6da493(this, true);
    });
    _add('toBase64URL', function() {
        return $21da20d2fc3ca230$export$c564cdbbe6da493(this, true);
    });
    _add('toUint8Array', function() {
        return $21da20d2fc3ca230$export$73470fd2221e6aef(this);
    });
};
/**
 * extend Uint8Array.prototype with relevant methods
 */ const $21da20d2fc3ca230$export$a105d6a15258bd2 = function() {
    const _add = (name, body)=>Object.defineProperty(Uint8Array.prototype, name, $21da20d2fc3ca230$var$_noEnum(body));
    _add('toBase64', function(urlsafe) {
        return $21da20d2fc3ca230$export$27bbb4e040978768(this, urlsafe);
    });
    _add('toBase64URI', function() {
        return $21da20d2fc3ca230$export$27bbb4e040978768(this, true);
    });
    _add('toBase64URL', function() {
        return $21da20d2fc3ca230$export$27bbb4e040978768(this, true);
    });
};
/**
 * extend Builtin prototypes with relevant methods
 */ const $21da20d2fc3ca230$export$1abf1fe5ebfd5245 = ()=>{
    $21da20d2fc3ca230$export$4678ebf2295c49b();
    $21da20d2fc3ca230$export$a105d6a15258bd2();
};
const $21da20d2fc3ca230$export$f436b0c2107cbd35 = {
    version: $21da20d2fc3ca230$export$83d89fbfd8236492,
    VERSION: $21da20d2fc3ca230$export$a4ad2735b021c132,
    atob: $21da20d2fc3ca230$export$1406ac7a6dfd7b7a,
    atobPolyfill: $21da20d2fc3ca230$export$7f16d8e674ddec24,
    btoa: $21da20d2fc3ca230$export$a32219e24f8d1e2,
    btoaPolyfill: $21da20d2fc3ca230$export$ec0fb543302ee251,
    fromBase64: $21da20d2fc3ca230$export$2f872c0f2117be69,
    toBase64: $21da20d2fc3ca230$export$c564cdbbe6da493,
    encode: $21da20d2fc3ca230$export$c564cdbbe6da493,
    encodeURI: $21da20d2fc3ca230$export$90c31d5baa78df44,
    encodeURL: $21da20d2fc3ca230$export$90c31d5baa78df44,
    utob: $21da20d2fc3ca230$export$10d4b9bd20a66b0,
    btou: $21da20d2fc3ca230$export$67e9defdeac3dd95,
    decode: $21da20d2fc3ca230$export$2f872c0f2117be69,
    isValid: $21da20d2fc3ca230$export$1ea939691cdc45b8,
    fromUint8Array: $21da20d2fc3ca230$export$27bbb4e040978768,
    toUint8Array: $21da20d2fc3ca230$export$73470fd2221e6aef,
    extendString: $21da20d2fc3ca230$export$4678ebf2295c49b,
    extendUint8Array: $21da20d2fc3ca230$export$a105d6a15258bd2,
    extendBuiltins: $21da20d2fc3ca230$export$1abf1fe5ebfd5245
};

});

parcelRegister("j3TTJ", function(module, exports) {
$parcel$export(module.exports, "AudioApi", function () { return (parcelRequire("aeizo")).AudioApi; });
$parcel$export(module.exports, "AvatarApi", function () { return (parcelRequire("hEs1E")).AvatarApi; });
$parcel$export(module.exports, "BannerApi", function () { return (parcelRequire("hfe5D")).BannerApi; });
$parcel$export(module.exports, "EmailVerifyApi", function () { return (parcelRequire("iLqPm")).EmailVerifyApi; });
$parcel$export(module.exports, "InviteApi", function () { return (parcelRequire("a3Fts")).InviteApi; });
$parcel$export(module.exports, "LiftApi", function () { return (parcelRequire("2zofI")).LiftApi; });
$parcel$export(module.exports, "MergeApi", function () { return (parcelRequire("7G8xv")).MergeApi; });
$parcel$export(module.exports, "PasswordResetApi", function () { return (parcelRequire("eAW08")).PasswordResetApi; });
$parcel$export(module.exports, "ProjectApi", function () { return (parcelRequire("6aen1")).ProjectApi; });
$parcel$export(module.exports, "SemanticDomainApi", function () { return (parcelRequire("jzwjE")).SemanticDomainApi; });
$parcel$export(module.exports, "SpeakerApi", function () { return (parcelRequire("iIUoD")).SpeakerApi; });
$parcel$export(module.exports, "StatisticsApi", function () { return (parcelRequire("fAwTT")).StatisticsApi; });
$parcel$export(module.exports, "UserApi", function () { return (parcelRequire("8x916")).UserApi; });
$parcel$export(module.exports, "UserEditApi", function () { return (parcelRequire("kAOhX")).UserEditApi; });
$parcel$export(module.exports, "UserRoleApi", function () { return (parcelRequire("9Nnrr")).UserRoleApi; });
$parcel$export(module.exports, "WordApi", function () { return (parcelRequire("iL4qK")).WordApi; });
$parcel$export(module.exports, "Configuration", function () { return (parcelRequire("alNT7")).Configuration; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ parcelRequire("6om3P");
parcelRequire("alNT7");
parcelRequire("585vO");

});
parcelRegister("6om3P", function(module, exports) {
$parcel$export(module.exports, "AudioApi", function () { return (parcelRequire("aeizo")).AudioApi; });
$parcel$export(module.exports, "AvatarApi", function () { return (parcelRequire("hEs1E")).AvatarApi; });
$parcel$export(module.exports, "BannerApi", function () { return (parcelRequire("hfe5D")).BannerApi; });
$parcel$export(module.exports, "EmailVerifyApi", function () { return (parcelRequire("iLqPm")).EmailVerifyApi; });
$parcel$export(module.exports, "InviteApi", function () { return (parcelRequire("a3Fts")).InviteApi; });
$parcel$export(module.exports, "LiftApi", function () { return (parcelRequire("2zofI")).LiftApi; });
$parcel$export(module.exports, "MergeApi", function () { return (parcelRequire("7G8xv")).MergeApi; });
$parcel$export(module.exports, "PasswordResetApi", function () { return (parcelRequire("eAW08")).PasswordResetApi; });
$parcel$export(module.exports, "ProjectApi", function () { return (parcelRequire("6aen1")).ProjectApi; });
$parcel$export(module.exports, "SemanticDomainApi", function () { return (parcelRequire("jzwjE")).SemanticDomainApi; });
$parcel$export(module.exports, "SpeakerApi", function () { return (parcelRequire("iIUoD")).SpeakerApi; });
$parcel$export(module.exports, "StatisticsApi", function () { return (parcelRequire("fAwTT")).StatisticsApi; });
$parcel$export(module.exports, "UserApi", function () { return (parcelRequire("8x916")).UserApi; });
$parcel$export(module.exports, "UserEditApi", function () { return (parcelRequire("kAOhX")).UserEditApi; });
$parcel$export(module.exports, "UserRoleApi", function () { return (parcelRequire("9Nnrr")).UserRoleApi; });
$parcel$export(module.exports, "WordApi", function () { return (parcelRequire("iL4qK")).WordApi; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ parcelRequire("aeizo");
parcelRequire("hEs1E");
parcelRequire("hfe5D");
parcelRequire("iLqPm");
parcelRequire("a3Fts");
parcelRequire("2zofI");
parcelRequire("7G8xv");
parcelRequire("eAW08");
parcelRequire("6aen1");
parcelRequire("jzwjE");
parcelRequire("iIUoD");
parcelRequire("fAwTT");
parcelRequire("8x916");
parcelRequire("kAOhX");
parcelRequire("9Nnrr");
parcelRequire("iL4qK");

});
parcelRegister("aeizo", function(module, exports) {

$parcel$export(module.exports, "AudioApi", function () { return $cf88ab27c20a19fb$export$5d0ff7fcca35ccd5; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $lr1pu = parcelRequire("lr1pu");

var $11MtC = parcelRequire("11MtC");
const $cf88ab27c20a19fb$export$90dcef5f6f7f4470 = function(configuration) {
    return {
        /**
     *
     * @param {string} projectId
     * @param {string} wordId
     * @param {string} fileName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteAudioFile: async (projectId, wordId, fileName, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("deleteAudioFile", "projectId", projectId);
            // verify required parameter 'wordId' is not null or undefined
            (0, $lr1pu.assertParamExists)("deleteAudioFile", "wordId", wordId);
            // verify required parameter 'fileName' is not null or undefined
            (0, $lr1pu.assertParamExists)("deleteAudioFile", "fileName", fileName);
            const localVarPath = `/v1/projects/{projectId}/words/{wordId}/audio/delete/{fileName}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"wordId"}}`, encodeURIComponent(String(wordId))).replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "DELETE",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {string} fileName
     * @param {string} wordId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ downloadAudioFile: async (projectId, fileName, wordId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("downloadAudioFile", "projectId", projectId);
            // verify required parameter 'fileName' is not null or undefined
            (0, $lr1pu.assertParamExists)("downloadAudioFile", "fileName", fileName);
            // verify required parameter 'wordId' is not null or undefined
            (0, $lr1pu.assertParamExists)("downloadAudioFile", "wordId", wordId);
            const localVarPath = `/v1/projects/{projectId}/words/{wordId}/audio/download/{fileName}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"fileName"}}`, encodeURIComponent(String(fileName))).replace(`{${"wordId"}}`, encodeURIComponent(String(wordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {string} wordId
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ uploadAudioFile: async (projectId, wordId, file, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("uploadAudioFile", "projectId", projectId);
            // verify required parameter 'wordId' is not null or undefined
            (0, $lr1pu.assertParamExists)("uploadAudioFile", "wordId", wordId);
            const localVarPath = `/v1/projects/{projectId}/words/{wordId}/audio/upload`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"wordId"}}`, encodeURIComponent(String(wordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new (configuration && configuration.formDataCtor || FormData)();
            if (file !== undefined) localVarFormParams.append("file", file);
            localVarHeaderParameter["Content-Type"] = "multipart/form-data";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {string} wordId
     * @param {string} speakerId
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ uploadAudioFileWithSpeaker: async (projectId, wordId, speakerId, file, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("uploadAudioFileWithSpeaker", "projectId", projectId);
            // verify required parameter 'wordId' is not null or undefined
            (0, $lr1pu.assertParamExists)("uploadAudioFileWithSpeaker", "wordId", wordId);
            // verify required parameter 'speakerId' is not null or undefined
            (0, $lr1pu.assertParamExists)("uploadAudioFileWithSpeaker", "speakerId", speakerId);
            const localVarPath = `/v1/projects/{projectId}/words/{wordId}/audio/upload/{speakerId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"wordId"}}`, encodeURIComponent(String(wordId))).replace(`{${"speakerId"}}`, encodeURIComponent(String(speakerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new (configuration && configuration.formDataCtor || FormData)();
            if (file !== undefined) localVarFormParams.append("file", file);
            localVarHeaderParameter["Content-Type"] = "multipart/form-data";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $cf88ab27c20a19fb$export$4f03e33e63d03517 = function(configuration) {
    const localVarAxiosParamCreator = $cf88ab27c20a19fb$export$90dcef5f6f7f4470(configuration);
    return {
        /**
     *
     * @param {string} projectId
     * @param {string} wordId
     * @param {string} fileName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async deleteAudioFile (projectId, wordId, fileName, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAudioFile(projectId, wordId, fileName, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {string} fileName
     * @param {string} wordId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async downloadAudioFile (projectId, fileName, wordId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAudioFile(projectId, fileName, wordId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {string} wordId
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async uploadAudioFile (projectId, wordId, file, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAudioFile(projectId, wordId, file, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {string} wordId
     * @param {string} speakerId
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async uploadAudioFileWithSpeaker (projectId, wordId, speakerId, file, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAudioFileWithSpeaker(projectId, wordId, speakerId, file, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        }
    };
};
const $cf88ab27c20a19fb$export$717342b94777af81 = function(configuration, basePath, axios) {
    const localVarFp = $cf88ab27c20a19fb$export$4f03e33e63d03517(configuration);
    return {
        /**
     *
     * @param {string} projectId
     * @param {string} wordId
     * @param {string} fileName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteAudioFile (projectId, wordId, fileName, options) {
            return localVarFp.deleteAudioFile(projectId, wordId, fileName, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {string} fileName
     * @param {string} wordId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ downloadAudioFile (projectId, fileName, wordId, options) {
            return localVarFp.downloadAudioFile(projectId, fileName, wordId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {string} wordId
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ uploadAudioFile (projectId, wordId, file, options) {
            return localVarFp.uploadAudioFile(projectId, wordId, file, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {string} wordId
     * @param {string} speakerId
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ uploadAudioFileWithSpeaker (projectId, wordId, speakerId, file, options) {
            return localVarFp.uploadAudioFileWithSpeaker(projectId, wordId, speakerId, file, options).then((request)=>request(axios, basePath));
        }
    };
};
class $cf88ab27c20a19fb$export$5d0ff7fcca35ccd5 extends (0, $11MtC.BaseAPI) {
    /**
   *
   * @param {AudioApiDeleteAudioFileRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AudioApi
   */ deleteAudioFile(requestParameters, options) {
        return $cf88ab27c20a19fb$export$4f03e33e63d03517(this.configuration).deleteAudioFile(requestParameters.projectId, requestParameters.wordId, requestParameters.fileName, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {AudioApiDownloadAudioFileRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AudioApi
   */ downloadAudioFile(requestParameters, options) {
        return $cf88ab27c20a19fb$export$4f03e33e63d03517(this.configuration).downloadAudioFile(requestParameters.projectId, requestParameters.fileName, requestParameters.wordId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {AudioApiUploadAudioFileRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AudioApi
   */ uploadAudioFile(requestParameters, options) {
        return $cf88ab27c20a19fb$export$4f03e33e63d03517(this.configuration).uploadAudioFile(requestParameters.projectId, requestParameters.wordId, requestParameters.file, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {AudioApiUploadAudioFileWithSpeakerRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AudioApi
   */ uploadAudioFileWithSpeaker(requestParameters, options) {
        return $cf88ab27c20a19fb$export$4f03e33e63d03517(this.configuration).uploadAudioFileWithSpeaker(requestParameters.projectId, requestParameters.wordId, requestParameters.speakerId, requestParameters.file, options).then((request)=>request(this.axios, this.basePath));
    }
}

});
parcelRegister("lr1pu", function(module, exports) {

$parcel$export(module.exports, "DUMMY_BASE_URL", function () { return $f6aa9fa71a85a8e0$export$bab87540acad0d0; });
$parcel$export(module.exports, "assertParamExists", function () { return $f6aa9fa71a85a8e0$export$b808bc21dd4c7149; });
$parcel$export(module.exports, "setSearchParams", function () { return $f6aa9fa71a85a8e0$export$91091bc0d20fa6e5; });
$parcel$export(module.exports, "serializeDataIfNeeded", function () { return $f6aa9fa71a85a8e0$export$b907f2b388ae0bc5; });
$parcel$export(module.exports, "toPathString", function () { return $f6aa9fa71a85a8e0$export$acf74f2e6d333229; });
$parcel$export(module.exports, "createRequestFunction", function () { return $f6aa9fa71a85a8e0$export$2a2bdb6ca788ce6a; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
var $11MtC = parcelRequire("11MtC");
const $f6aa9fa71a85a8e0$export$bab87540acad0d0 = "https://example.com";
const $f6aa9fa71a85a8e0$export$b808bc21dd4c7149 = function(functionName, paramName, paramValue) {
    if (paramValue === null || paramValue === undefined) throw new (0, $11MtC.RequiredError)(paramName, `Required parameter ${paramName} was null or undefined when calling ${functionName}.`);
};
const $f6aa9fa71a85a8e0$export$ba2fb66974fedf0d = async function(object, keyParamName, configuration) {
    if (configuration && configuration.apiKey) {
        const localVarApiKeyValue = typeof configuration.apiKey === "function" ? await configuration.apiKey(keyParamName) : await configuration.apiKey;
        object[keyParamName] = localVarApiKeyValue;
    }
};
const $f6aa9fa71a85a8e0$export$81184285cad21fea = function(object, configuration) {
    if (configuration && (configuration.username || configuration.password)) object["auth"] = {
        username: configuration.username,
        password: configuration.password
    };
};
const $f6aa9fa71a85a8e0$export$d68afcc6f6294bfe = async function(object, configuration) {
    if (configuration && configuration.accessToken) {
        const accessToken = typeof configuration.accessToken === "function" ? await configuration.accessToken() : await configuration.accessToken;
        object["Authorization"] = "Bearer " + accessToken;
    }
};
const $f6aa9fa71a85a8e0$export$908325ca1dd77eba = async function(object, name, scopes, configuration) {
    if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue = typeof configuration.accessToken === "function" ? await configuration.accessToken(name, scopes) : await configuration.accessToken;
        object["Authorization"] = "Bearer " + localVarAccessTokenValue;
    }
};
const $f6aa9fa71a85a8e0$export$91091bc0d20fa6e5 = function(url, ...objects) {
    const searchParams = new URLSearchParams(url.search);
    for (const object of objects){
        for(const key in object)if (Array.isArray(object[key])) {
            searchParams.delete(key);
            for (const item of object[key])searchParams.append(key, item);
        } else searchParams.set(key, object[key]);
    }
    url.search = searchParams.toString();
};
const $f6aa9fa71a85a8e0$export$b907f2b388ae0bc5 = function(value, requestOptions, configuration) {
    const nonString = typeof value !== "string";
    const needsSerialization = nonString && configuration && configuration.isJsonMime ? configuration.isJsonMime(requestOptions.headers["Content-Type"]) : nonString;
    return needsSerialization ? JSON.stringify(value !== undefined ? value : {}) : value || "";
};
const $f6aa9fa71a85a8e0$export$acf74f2e6d333229 = function(url) {
    return url.pathname + url.search + url.hash;
};
const $f6aa9fa71a85a8e0$export$2a2bdb6ca788ce6a = function(axiosArgs, globalAxios, BASE_PATH, configuration) {
    return (axios = globalAxios, basePath = BASE_PATH)=>{
        const axiosRequestArgs = {
            ...axiosArgs.options,
            url: (configuration?.basePath || basePath) + axiosArgs.url
        };
        return axios.request(axiosRequestArgs);
    };
};

});
parcelRegister("11MtC", function(module, exports) {

$parcel$export(module.exports, "BASE_PATH", function () { return $47fe4a3c903a396b$export$2812a1fb15aca49c; });
$parcel$export(module.exports, "BaseAPI", function () { return $47fe4a3c903a396b$export$70edad7ad5bb3f5d; });
$parcel$export(module.exports, "RequiredError", function () { return $47fe4a3c903a396b$export$a27bea7cdb975d70; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");
const $47fe4a3c903a396b$export$2812a1fb15aca49c = "http://localhost".replace(/\/+$/, "");
const $47fe4a3c903a396b$export$83cb526776fb323d = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|"
};
class $47fe4a3c903a396b$export$70edad7ad5bb3f5d {
    constructor(configuration, basePath = $47fe4a3c903a396b$export$2812a1fb15aca49c, axios = (0, $a04va.default)){
        this.basePath = basePath;
        this.axios = axios;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}
class $47fe4a3c903a396b$export$a27bea7cdb975d70 extends Error {
    constructor(field, msg){
        super(msg), this.field = field, this.name = "RequiredError";
    }
}

});



parcelRegister("hEs1E", function(module, exports) {

$parcel$export(module.exports, "AvatarApi", function () { return $bc825359c66c1a8a$export$35ebcbc76ff5f1ef; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $lr1pu = parcelRequire("lr1pu");

var $11MtC = parcelRequire("11MtC");
const $bc825359c66c1a8a$export$ad1070eabe733f6d = function(configuration) {
    return {
        /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ downloadAvatar: async (userId, options = {})=>{
            // verify required parameter 'userId' is not null or undefined
            (0, $lr1pu.assertParamExists)("downloadAvatar", "userId", userId);
            const localVarPath = `/v1/users/{userId}/avatar/download`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} userId
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ uploadAvatar: async (userId, file, options = {})=>{
            // verify required parameter 'userId' is not null or undefined
            (0, $lr1pu.assertParamExists)("uploadAvatar", "userId", userId);
            const localVarPath = `/v1/users/{userId}/avatar/upload`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new (configuration && configuration.formDataCtor || FormData)();
            if (file !== undefined) localVarFormParams.append("file", file);
            localVarHeaderParameter["Content-Type"] = "multipart/form-data";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $bc825359c66c1a8a$export$df8f2db74ba52d38 = function(configuration) {
    const localVarAxiosParamCreator = $bc825359c66c1a8a$export$ad1070eabe733f6d(configuration);
    return {
        /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async downloadAvatar (userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAvatar(userId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} userId
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async uploadAvatar (userId, file, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAvatar(userId, file, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        }
    };
};
const $bc825359c66c1a8a$export$1b5698db7488f302 = function(configuration, basePath, axios) {
    const localVarFp = $bc825359c66c1a8a$export$df8f2db74ba52d38(configuration);
    return {
        /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ downloadAvatar (userId, options) {
            return localVarFp.downloadAvatar(userId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} userId
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ uploadAvatar (userId, file, options) {
            return localVarFp.uploadAvatar(userId, file, options).then((request)=>request(axios, basePath));
        }
    };
};
class $bc825359c66c1a8a$export$35ebcbc76ff5f1ef extends (0, $11MtC.BaseAPI) {
    /**
   *
   * @param {AvatarApiDownloadAvatarRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvatarApi
   */ downloadAvatar(requestParameters, options) {
        return $bc825359c66c1a8a$export$df8f2db74ba52d38(this.configuration).downloadAvatar(requestParameters.userId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {AvatarApiUploadAvatarRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvatarApi
   */ uploadAvatar(requestParameters, options) {
        return $bc825359c66c1a8a$export$df8f2db74ba52d38(this.configuration).uploadAvatar(requestParameters.userId, requestParameters.file, options).then((request)=>request(this.axios, this.basePath));
    }
}

});

parcelRegister("hfe5D", function(module, exports) {

$parcel$export(module.exports, "BannerApi", function () { return $c52e3e7ebcd1783a$export$c5ba558a1ce45a3c; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $lr1pu = parcelRequire("lr1pu");

var $11MtC = parcelRequire("11MtC");
const $c52e3e7ebcd1783a$export$8861e8e17e9b501 = function(configuration) {
    return {
        /**
     *
     * @param {BannerType} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getBanner: async (type, options = {})=>{
            const localVarPath = `/v1/banner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (type !== undefined) localVarQueryParameter["type"] = type;
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {SiteBanner} siteBanner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateBanner: async (siteBanner, options = {})=>{
            // verify required parameter 'siteBanner' is not null or undefined
            (0, $lr1pu.assertParamExists)("updateBanner", "siteBanner", siteBanner);
            const localVarPath = `/v1/banner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(siteBanner, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $c52e3e7ebcd1783a$export$3b093ee68ee24067 = function(configuration) {
    const localVarAxiosParamCreator = $c52e3e7ebcd1783a$export$8861e8e17e9b501(configuration);
    return {
        /**
     *
     * @param {BannerType} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getBanner (type, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBanner(type, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {SiteBanner} siteBanner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async updateBanner (siteBanner, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBanner(siteBanner, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        }
    };
};
const $c52e3e7ebcd1783a$export$2bebf88ff64aa9d3 = function(configuration, basePath, axios) {
    const localVarFp = $c52e3e7ebcd1783a$export$3b093ee68ee24067(configuration);
    return {
        /**
     *
     * @param {BannerType} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getBanner (type, options) {
            return localVarFp.getBanner(type, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {SiteBanner} siteBanner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateBanner (siteBanner, options) {
            return localVarFp.updateBanner(siteBanner, options).then((request)=>request(axios, basePath));
        }
    };
};
class $c52e3e7ebcd1783a$export$c5ba558a1ce45a3c extends (0, $11MtC.BaseAPI) {
    /**
   *
   * @param {BannerApiGetBannerRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BannerApi
   */ getBanner(requestParameters = {}, options) {
        return $c52e3e7ebcd1783a$export$3b093ee68ee24067(this.configuration).getBanner(requestParameters.type, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {BannerApiUpdateBannerRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BannerApi
   */ updateBanner(requestParameters, options) {
        return $c52e3e7ebcd1783a$export$3b093ee68ee24067(this.configuration).updateBanner(requestParameters.siteBanner, options).then((request)=>request(this.axios, this.basePath));
    }
}

});

parcelRegister("iLqPm", function(module, exports) {

$parcel$export(module.exports, "EmailVerifyApi", function () { return $003d4c9d434b9ec0$export$f2d2b7c570d711eb; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $lr1pu = parcelRequire("lr1pu");

var $11MtC = parcelRequire("11MtC");
const $003d4c9d434b9ec0$export$8ad289aa64bb4239 = function(configuration) {
    return {
        /**
     *
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ requestEmailVerify: async (body, options = {})=>{
            // verify required parameter 'body' is not null or undefined
            (0, $lr1pu.assertParamExists)("requestEmailVerify", "body", body);
            const localVarPath = `/v1/users/emailverify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ validateEmailToken: async (token, options = {})=>{
            // verify required parameter 'token' is not null or undefined
            (0, $lr1pu.assertParamExists)("validateEmailToken", "token", token);
            const localVarPath = `/v1/users/emailverify/validate/{token}`.replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $003d4c9d434b9ec0$export$8a0a77f0487d2c6f = function(configuration) {
    const localVarAxiosParamCreator = $003d4c9d434b9ec0$export$8ad289aa64bb4239(configuration);
    return {
        /**
     *
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async requestEmailVerify (body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestEmailVerify(body, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async validateEmailToken (token, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateEmailToken(token, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        }
    };
};
const $003d4c9d434b9ec0$export$e7c91e9471761954 = function(configuration, basePath, axios) {
    const localVarFp = $003d4c9d434b9ec0$export$8a0a77f0487d2c6f(configuration);
    return {
        /**
     *
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ requestEmailVerify (body, options) {
            return localVarFp.requestEmailVerify(body, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ validateEmailToken (token, options) {
            return localVarFp.validateEmailToken(token, options).then((request)=>request(axios, basePath));
        }
    };
};
class $003d4c9d434b9ec0$export$f2d2b7c570d711eb extends (0, $11MtC.BaseAPI) {
    /**
   *
   * @param {EmailVerifyApiRequestEmailVerifyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EmailVerifyApi
   */ requestEmailVerify(requestParameters, options) {
        return $003d4c9d434b9ec0$export$8a0a77f0487d2c6f(this.configuration).requestEmailVerify(requestParameters.body, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {EmailVerifyApiValidateEmailTokenRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EmailVerifyApi
   */ validateEmailToken(requestParameters, options) {
        return $003d4c9d434b9ec0$export$8a0a77f0487d2c6f(this.configuration).validateEmailToken(requestParameters.token, options).then((request)=>request(this.axios, this.basePath));
    }
}

});

parcelRegister("a3Fts", function(module, exports) {

$parcel$export(module.exports, "InviteApi", function () { return $a7381905c1e2f93c$export$a4ec9e5ed4e7eac8; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $lr1pu = parcelRequire("lr1pu");

var $11MtC = parcelRequire("11MtC");
const $a7381905c1e2f93c$export$63446593059464d5 = function(configuration) {
    return {
        /**
     *
     * @param {EmailInviteData} emailInviteData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ emailInviteToProject: async (emailInviteData, options = {})=>{
            // verify required parameter 'emailInviteData' is not null or undefined
            (0, $lr1pu.assertParamExists)("emailInviteToProject", "emailInviteData", emailInviteData);
            const localVarPath = `/v1/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(emailInviteData, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ validateInviteToken: async (projectId, token, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("validateInviteToken", "projectId", projectId);
            // verify required parameter 'token' is not null or undefined
            (0, $lr1pu.assertParamExists)("validateInviteToken", "token", token);
            const localVarPath = `/v1/invite/{projectId}/validate/{token}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $a7381905c1e2f93c$export$43a3fea6880fcc53 = function(configuration) {
    const localVarAxiosParamCreator = $a7381905c1e2f93c$export$63446593059464d5(configuration);
    return {
        /**
     *
     * @param {EmailInviteData} emailInviteData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async emailInviteToProject (emailInviteData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailInviteToProject(emailInviteData, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async validateInviteToken (projectId, token, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateInviteToken(projectId, token, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        }
    };
};
const $a7381905c1e2f93c$export$e70aa0b39c1e9bb5 = function(configuration, basePath, axios) {
    const localVarFp = $a7381905c1e2f93c$export$43a3fea6880fcc53(configuration);
    return {
        /**
     *
     * @param {EmailInviteData} emailInviteData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ emailInviteToProject (emailInviteData, options) {
            return localVarFp.emailInviteToProject(emailInviteData, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ validateInviteToken (projectId, token, options) {
            return localVarFp.validateInviteToken(projectId, token, options).then((request)=>request(axios, basePath));
        }
    };
};
class $a7381905c1e2f93c$export$a4ec9e5ed4e7eac8 extends (0, $11MtC.BaseAPI) {
    /**
   *
   * @param {InviteApiEmailInviteToProjectRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InviteApi
   */ emailInviteToProject(requestParameters, options) {
        return $a7381905c1e2f93c$export$43a3fea6880fcc53(this.configuration).emailInviteToProject(requestParameters.emailInviteData, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {InviteApiValidateInviteTokenRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InviteApi
   */ validateInviteToken(requestParameters, options) {
        return $a7381905c1e2f93c$export$43a3fea6880fcc53(this.configuration).validateInviteToken(requestParameters.projectId, requestParameters.token, options).then((request)=>request(this.axios, this.basePath));
    }
}

});

parcelRegister("2zofI", function(module, exports) {

$parcel$export(module.exports, "LiftApi", function () { return $43de273194c07691$export$f5d8f21b2f764083; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $lr1pu = parcelRequire("lr1pu");

var $11MtC = parcelRequire("11MtC");
const $43de273194c07691$export$353335b1ebeb491a = function(configuration) {
    return {
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ cancelLiftExport: async (projectId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("cancelLiftExport", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/lift/cancelexport`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteFrontierAndFinishUploadLiftFile: async (projectId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("deleteFrontierAndFinishUploadLiftFile", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/lift/deletefrontierandfinishupload`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteLiftFile: async (projectId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("deleteLiftFile", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/lift/deleteexport`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ downloadLiftFile: async (projectId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("downloadLiftFile", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/lift/download`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ exportLiftFile: async (projectId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("exportLiftFile", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/lift/export`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ finishUploadLiftFile: async (projectId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("finishUploadLiftFile", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/lift/finishupload`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ uploadLiftFile: async (projectId, file, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("uploadLiftFile", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/lift/upload`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new (configuration && configuration.formDataCtor || FormData)();
            if (file !== undefined) localVarFormParams.append("file", file);
            localVarHeaderParameter["Content-Type"] = "multipart/form-data";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ uploadLiftFileAndGetWritingSystems: async (projectId, file, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("uploadLiftFileAndGetWritingSystems", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/lift/uploadandgetwritingsystems`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new (configuration && configuration.formDataCtor || FormData)();
            if (file !== undefined) localVarFormParams.append("file", file);
            localVarHeaderParameter["Content-Type"] = "multipart/form-data";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $43de273194c07691$export$ff960f918c4100bd = function(configuration) {
    const localVarAxiosParamCreator = $43de273194c07691$export$353335b1ebeb491a(configuration);
    return {
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async cancelLiftExport (projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelLiftExport(projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async deleteFrontierAndFinishUploadLiftFile (projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFrontierAndFinishUploadLiftFile(projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async deleteLiftFile (projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLiftFile(projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async downloadLiftFile (projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadLiftFile(projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async exportLiftFile (projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportLiftFile(projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async finishUploadLiftFile (projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finishUploadLiftFile(projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async uploadLiftFile (projectId, file, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadLiftFile(projectId, file, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async uploadLiftFileAndGetWritingSystems (projectId, file, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadLiftFileAndGetWritingSystems(projectId, file, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        }
    };
};
const $43de273194c07691$export$3eff262150acbc18 = function(configuration, basePath, axios) {
    const localVarFp = $43de273194c07691$export$ff960f918c4100bd(configuration);
    return {
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ cancelLiftExport (projectId, options) {
            return localVarFp.cancelLiftExport(projectId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteFrontierAndFinishUploadLiftFile (projectId, options) {
            return localVarFp.deleteFrontierAndFinishUploadLiftFile(projectId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteLiftFile (projectId, options) {
            return localVarFp.deleteLiftFile(projectId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ downloadLiftFile (projectId, options) {
            return localVarFp.downloadLiftFile(projectId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ exportLiftFile (projectId, options) {
            return localVarFp.exportLiftFile(projectId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ finishUploadLiftFile (projectId, options) {
            return localVarFp.finishUploadLiftFile(projectId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ uploadLiftFile (projectId, file, options) {
            return localVarFp.uploadLiftFile(projectId, file, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ uploadLiftFileAndGetWritingSystems (projectId, file, options) {
            return localVarFp.uploadLiftFileAndGetWritingSystems(projectId, file, options).then((request)=>request(axios, basePath));
        }
    };
};
class $43de273194c07691$export$f5d8f21b2f764083 extends (0, $11MtC.BaseAPI) {
    /**
   *
   * @param {LiftApiCancelLiftExportRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LiftApi
   */ cancelLiftExport(requestParameters, options) {
        return $43de273194c07691$export$ff960f918c4100bd(this.configuration).cancelLiftExport(requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {LiftApiDeleteFrontierAndFinishUploadLiftFileRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LiftApi
   */ deleteFrontierAndFinishUploadLiftFile(requestParameters, options) {
        return $43de273194c07691$export$ff960f918c4100bd(this.configuration).deleteFrontierAndFinishUploadLiftFile(requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {LiftApiDeleteLiftFileRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LiftApi
   */ deleteLiftFile(requestParameters, options) {
        return $43de273194c07691$export$ff960f918c4100bd(this.configuration).deleteLiftFile(requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {LiftApiDownloadLiftFileRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LiftApi
   */ downloadLiftFile(requestParameters, options) {
        return $43de273194c07691$export$ff960f918c4100bd(this.configuration).downloadLiftFile(requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {LiftApiExportLiftFileRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LiftApi
   */ exportLiftFile(requestParameters, options) {
        return $43de273194c07691$export$ff960f918c4100bd(this.configuration).exportLiftFile(requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {LiftApiFinishUploadLiftFileRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LiftApi
   */ finishUploadLiftFile(requestParameters, options) {
        return $43de273194c07691$export$ff960f918c4100bd(this.configuration).finishUploadLiftFile(requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {LiftApiUploadLiftFileRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LiftApi
   */ uploadLiftFile(requestParameters, options) {
        return $43de273194c07691$export$ff960f918c4100bd(this.configuration).uploadLiftFile(requestParameters.projectId, requestParameters.file, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {LiftApiUploadLiftFileAndGetWritingSystemsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LiftApi
   */ uploadLiftFileAndGetWritingSystems(requestParameters, options) {
        return $43de273194c07691$export$ff960f918c4100bd(this.configuration).uploadLiftFileAndGetWritingSystems(requestParameters.projectId, requestParameters.file, options).then((request)=>request(this.axios, this.basePath));
    }
}

});

parcelRegister("7G8xv", function(module, exports) {

$parcel$export(module.exports, "MergeApi", function () { return $0f930aca3bf68ecf$export$5e11d7484d20600c; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $lr1pu = parcelRequire("lr1pu");

var $11MtC = parcelRequire("11MtC");
const $0f930aca3bf68ecf$export$709a78c4a8f4d15a = function(configuration) {
    return {
        /**
     *
     * @param {string} projectId
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blacklistAdd: async (projectId, requestBody, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("blacklistAdd", "projectId", projectId);
            // verify required parameter 'requestBody' is not null or undefined
            (0, $lr1pu.assertParamExists)("blacklistAdd", "requestBody", requestBody);
            const localVarPath = `/v1/projects/{projectId}/merge/blacklist/add`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {number} maxInList
     * @param {number} maxLists
     * @param {boolean} ignoreProtected
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ findIdenticalPotentialDuplicates: async (projectId, maxInList, maxLists, ignoreProtected, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("findIdenticalPotentialDuplicates", "projectId", projectId);
            // verify required parameter 'maxInList' is not null or undefined
            (0, $lr1pu.assertParamExists)("findIdenticalPotentialDuplicates", "maxInList", maxInList);
            // verify required parameter 'maxLists' is not null or undefined
            (0, $lr1pu.assertParamExists)("findIdenticalPotentialDuplicates", "maxLists", maxLists);
            // verify required parameter 'ignoreProtected' is not null or undefined
            (0, $lr1pu.assertParamExists)("findIdenticalPotentialDuplicates", "ignoreProtected", ignoreProtected);
            const localVarPath = `/v1/projects/{projectId}/merge/findidenticaldups/{maxInList}/{maxLists}/{ignoreProtected}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"maxInList"}}`, encodeURIComponent(String(maxInList))).replace(`{${"maxLists"}}`, encodeURIComponent(String(maxLists))).replace(`{${"ignoreProtected"}}`, encodeURIComponent(String(ignoreProtected)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {number} maxInList
     * @param {number} maxLists
     * @param {boolean} ignoreProtected
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ findPotentialDuplicates: async (projectId, maxInList, maxLists, ignoreProtected, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("findPotentialDuplicates", "projectId", projectId);
            // verify required parameter 'maxInList' is not null or undefined
            (0, $lr1pu.assertParamExists)("findPotentialDuplicates", "maxInList", maxInList);
            // verify required parameter 'maxLists' is not null or undefined
            (0, $lr1pu.assertParamExists)("findPotentialDuplicates", "maxLists", maxLists);
            // verify required parameter 'ignoreProtected' is not null or undefined
            (0, $lr1pu.assertParamExists)("findPotentialDuplicates", "ignoreProtected", ignoreProtected);
            const localVarPath = `/v1/projects/{projectId}/merge/finddups/{maxInList}/{maxLists}/{ignoreProtected}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"maxInList"}}`, encodeURIComponent(String(maxInList))).replace(`{${"maxLists"}}`, encodeURIComponent(String(maxLists))).replace(`{${"ignoreProtected"}}`, encodeURIComponent(String(ignoreProtected)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {number} maxLists
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getGraylistEntries: async (projectId, maxLists, userId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getGraylistEntries", "projectId", projectId);
            // verify required parameter 'maxLists' is not null or undefined
            (0, $lr1pu.assertParamExists)("getGraylistEntries", "maxLists", maxLists);
            // verify required parameter 'userId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getGraylistEntries", "userId", userId);
            const localVarPath = `/v1/projects/{projectId}/merge/getgraylist/{maxLists}/{userId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"maxLists"}}`, encodeURIComponent(String(maxLists))).replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ graylistAdd: async (projectId, requestBody, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("graylistAdd", "projectId", projectId);
            // verify required parameter 'requestBody' is not null or undefined
            (0, $lr1pu.assertParamExists)("graylistAdd", "requestBody", requestBody);
            const localVarPath = `/v1/projects/{projectId}/merge/graylist/add`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ hasGraylistEntries: async (projectId, userId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("hasGraylistEntries", "projectId", projectId);
            // verify required parameter 'userId' is not null or undefined
            (0, $lr1pu.assertParamExists)("hasGraylistEntries", "userId", userId);
            const localVarPath = `/v1/projects/{projectId}/merge/hasgraylist/{userId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {Array<MergeWords>} mergeWords
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ mergeWords: async (projectId, mergeWords, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("mergeWords", "projectId", projectId);
            // verify required parameter 'mergeWords' is not null or undefined
            (0, $lr1pu.assertParamExists)("mergeWords", "mergeWords", mergeWords);
            const localVarPath = `/v1/projects/{projectId}/merge`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(mergeWords, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ retrievePotentialDuplicates: async (projectId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("retrievePotentialDuplicates", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/merge/retrievedups`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {MergeUndoIds} mergeUndoIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ undoMerge: async (projectId, mergeUndoIds, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("undoMerge", "projectId", projectId);
            // verify required parameter 'mergeUndoIds' is not null or undefined
            (0, $lr1pu.assertParamExists)("undoMerge", "mergeUndoIds", mergeUndoIds);
            const localVarPath = `/v1/projects/{projectId}/merge/undo`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(mergeUndoIds, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $0f930aca3bf68ecf$export$65e16814120032c0 = function(configuration) {
    const localVarAxiosParamCreator = $0f930aca3bf68ecf$export$709a78c4a8f4d15a(configuration);
    return {
        /**
     *
     * @param {string} projectId
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async blacklistAdd (projectId, requestBody, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.blacklistAdd(projectId, requestBody, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {number} maxInList
     * @param {number} maxLists
     * @param {boolean} ignoreProtected
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async findIdenticalPotentialDuplicates (projectId, maxInList, maxLists, ignoreProtected, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findIdenticalPotentialDuplicates(projectId, maxInList, maxLists, ignoreProtected, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {number} maxInList
     * @param {number} maxLists
     * @param {boolean} ignoreProtected
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async findPotentialDuplicates (projectId, maxInList, maxLists, ignoreProtected, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findPotentialDuplicates(projectId, maxInList, maxLists, ignoreProtected, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {number} maxLists
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getGraylistEntries (projectId, maxLists, userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGraylistEntries(projectId, maxLists, userId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async graylistAdd (projectId, requestBody, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.graylistAdd(projectId, requestBody, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async hasGraylistEntries (projectId, userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hasGraylistEntries(projectId, userId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {Array<MergeWords>} mergeWords
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async mergeWords (projectId, mergeWords, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mergeWords(projectId, mergeWords, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async retrievePotentialDuplicates (projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrievePotentialDuplicates(projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {MergeUndoIds} mergeUndoIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async undoMerge (projectId, mergeUndoIds, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.undoMerge(projectId, mergeUndoIds, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        }
    };
};
const $0f930aca3bf68ecf$export$3b2422f847ca8f12 = function(configuration, basePath, axios) {
    const localVarFp = $0f930aca3bf68ecf$export$65e16814120032c0(configuration);
    return {
        /**
     *
     * @param {string} projectId
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blacklistAdd (projectId, requestBody, options) {
            return localVarFp.blacklistAdd(projectId, requestBody, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {number} maxInList
     * @param {number} maxLists
     * @param {boolean} ignoreProtected
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ findIdenticalPotentialDuplicates (projectId, maxInList, maxLists, ignoreProtected, options) {
            return localVarFp.findIdenticalPotentialDuplicates(projectId, maxInList, maxLists, ignoreProtected, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {number} maxInList
     * @param {number} maxLists
     * @param {boolean} ignoreProtected
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ findPotentialDuplicates (projectId, maxInList, maxLists, ignoreProtected, options) {
            return localVarFp.findPotentialDuplicates(projectId, maxInList, maxLists, ignoreProtected, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {number} maxLists
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getGraylistEntries (projectId, maxLists, userId, options) {
            return localVarFp.getGraylistEntries(projectId, maxLists, userId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ graylistAdd (projectId, requestBody, options) {
            return localVarFp.graylistAdd(projectId, requestBody, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ hasGraylistEntries (projectId, userId, options) {
            return localVarFp.hasGraylistEntries(projectId, userId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {Array<MergeWords>} mergeWords
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ mergeWords (projectId, mergeWords, options) {
            return localVarFp.mergeWords(projectId, mergeWords, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ retrievePotentialDuplicates (projectId, options) {
            return localVarFp.retrievePotentialDuplicates(projectId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {MergeUndoIds} mergeUndoIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ undoMerge (projectId, mergeUndoIds, options) {
            return localVarFp.undoMerge(projectId, mergeUndoIds, options).then((request)=>request(axios, basePath));
        }
    };
};
class $0f930aca3bf68ecf$export$5e11d7484d20600c extends (0, $11MtC.BaseAPI) {
    /**
   *
   * @param {MergeApiBlacklistAddRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MergeApi
   */ blacklistAdd(requestParameters, options) {
        return $0f930aca3bf68ecf$export$65e16814120032c0(this.configuration).blacklistAdd(requestParameters.projectId, requestParameters.requestBody, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {MergeApiFindIdenticalPotentialDuplicatesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MergeApi
   */ findIdenticalPotentialDuplicates(requestParameters, options) {
        return $0f930aca3bf68ecf$export$65e16814120032c0(this.configuration).findIdenticalPotentialDuplicates(requestParameters.projectId, requestParameters.maxInList, requestParameters.maxLists, requestParameters.ignoreProtected, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {MergeApiFindPotentialDuplicatesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MergeApi
   */ findPotentialDuplicates(requestParameters, options) {
        return $0f930aca3bf68ecf$export$65e16814120032c0(this.configuration).findPotentialDuplicates(requestParameters.projectId, requestParameters.maxInList, requestParameters.maxLists, requestParameters.ignoreProtected, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {MergeApiGetGraylistEntriesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MergeApi
   */ getGraylistEntries(requestParameters, options) {
        return $0f930aca3bf68ecf$export$65e16814120032c0(this.configuration).getGraylistEntries(requestParameters.projectId, requestParameters.maxLists, requestParameters.userId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {MergeApiGraylistAddRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MergeApi
   */ graylistAdd(requestParameters, options) {
        return $0f930aca3bf68ecf$export$65e16814120032c0(this.configuration).graylistAdd(requestParameters.projectId, requestParameters.requestBody, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {MergeApiHasGraylistEntriesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MergeApi
   */ hasGraylistEntries(requestParameters, options) {
        return $0f930aca3bf68ecf$export$65e16814120032c0(this.configuration).hasGraylistEntries(requestParameters.projectId, requestParameters.userId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {MergeApiMergeWordsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MergeApi
   */ mergeWords(requestParameters, options) {
        return $0f930aca3bf68ecf$export$65e16814120032c0(this.configuration).mergeWords(requestParameters.projectId, requestParameters.mergeWords, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {MergeApiRetrievePotentialDuplicatesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MergeApi
   */ retrievePotentialDuplicates(requestParameters, options) {
        return $0f930aca3bf68ecf$export$65e16814120032c0(this.configuration).retrievePotentialDuplicates(requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {MergeApiUndoMergeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MergeApi
   */ undoMerge(requestParameters, options) {
        return $0f930aca3bf68ecf$export$65e16814120032c0(this.configuration).undoMerge(requestParameters.projectId, requestParameters.mergeUndoIds, options).then((request)=>request(this.axios, this.basePath));
    }
}

});

parcelRegister("eAW08", function(module, exports) {

$parcel$export(module.exports, "PasswordResetApi", function () { return $fdb496f57e180fdc$export$56c62c68638a9ab4; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $lr1pu = parcelRequire("lr1pu");

var $11MtC = parcelRequire("11MtC");
const $fdb496f57e180fdc$export$8b122c2478708613 = function(configuration) {
    return {
        /**
     *
     * @param {PasswordResetData} passwordResetData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ resetPassword: async (passwordResetData, options = {})=>{
            // verify required parameter 'passwordResetData' is not null or undefined
            (0, $lr1pu.assertParamExists)("resetPassword", "passwordResetData", passwordResetData);
            const localVarPath = `/v1/users/forgot/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(passwordResetData, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ resetPasswordRequest: async (body, options = {})=>{
            // verify required parameter 'body' is not null or undefined
            (0, $lr1pu.assertParamExists)("resetPasswordRequest", "body", body);
            const localVarPath = `/v1/users/forgot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ validateResetToken: async (token, options = {})=>{
            // verify required parameter 'token' is not null or undefined
            (0, $lr1pu.assertParamExists)("validateResetToken", "token", token);
            const localVarPath = `/v1/users/forgot/reset/validate/{token}`.replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $fdb496f57e180fdc$export$a56dcec3f663e8c9 = function(configuration) {
    const localVarAxiosParamCreator = $fdb496f57e180fdc$export$8b122c2478708613(configuration);
    return {
        /**
     *
     * @param {PasswordResetData} passwordResetData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async resetPassword (passwordResetData, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(passwordResetData, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async resetPasswordRequest (body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPasswordRequest(body, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async validateResetToken (token, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateResetToken(token, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        }
    };
};
const $fdb496f57e180fdc$export$a8831d799022bbdc = function(configuration, basePath, axios) {
    const localVarFp = $fdb496f57e180fdc$export$a56dcec3f663e8c9(configuration);
    return {
        /**
     *
     * @param {PasswordResetData} passwordResetData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ resetPassword (passwordResetData, options) {
            return localVarFp.resetPassword(passwordResetData, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ resetPasswordRequest (body, options) {
            return localVarFp.resetPasswordRequest(body, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ validateResetToken (token, options) {
            return localVarFp.validateResetToken(token, options).then((request)=>request(axios, basePath));
        }
    };
};
class $fdb496f57e180fdc$export$56c62c68638a9ab4 extends (0, $11MtC.BaseAPI) {
    /**
   *
   * @param {PasswordResetApiResetPasswordRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PasswordResetApi
   */ resetPassword(requestParameters, options) {
        return $fdb496f57e180fdc$export$a56dcec3f663e8c9(this.configuration).resetPassword(requestParameters.passwordResetData, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {PasswordResetApiResetPasswordRequestRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PasswordResetApi
   */ resetPasswordRequest(requestParameters, options) {
        return $fdb496f57e180fdc$export$a56dcec3f663e8c9(this.configuration).resetPasswordRequest(requestParameters.body, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {PasswordResetApiValidateResetTokenRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PasswordResetApi
   */ validateResetToken(requestParameters, options) {
        return $fdb496f57e180fdc$export$a56dcec3f663e8c9(this.configuration).validateResetToken(requestParameters.token, options).then((request)=>request(this.axios, this.basePath));
    }
}

});

parcelRegister("6aen1", function(module, exports) {

$parcel$export(module.exports, "ProjectApi", function () { return $b84eb90e07303a9f$export$586c3c8cde325d1a; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $lr1pu = parcelRequire("lr1pu");

var $11MtC = parcelRequire("11MtC");
const $b84eb90e07303a9f$export$7a67b32e44c44c50 = function(configuration) {
    return {
        /**
     *
     * @param {Project} project
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createProject: async (project, options = {})=>{
            // verify required parameter 'project' is not null or undefined
            (0, $lr1pu.assertParamExists)("createProject", "project", project);
            const localVarPath = `/v1/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(project, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteProject: async (projectId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("deleteProject", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "DELETE",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAllProjectUsers: async (projectId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getAllProjectUsers", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/users`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAllProjects: async (options = {})=>{
            const localVarPath = `/v1/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getProject: async (projectId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getProject", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ projectDuplicateCheck: async (projectName, options = {})=>{
            // verify required parameter 'projectName' is not null or undefined
            (0, $lr1pu.assertParamExists)("projectDuplicateCheck", "projectName", projectName);
            const localVarPath = `/v1/projects/duplicate/{projectName}`.replace(`{${"projectName"}}`, encodeURIComponent(String(projectName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {Project} project
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ putChars: async (projectId, project, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("putChars", "projectId", projectId);
            // verify required parameter 'project' is not null or undefined
            (0, $lr1pu.assertParamExists)("putChars", "project", project);
            const localVarPath = `/v1/projects/{projectId}/characters`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(project, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {Project} project
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateProject: async (projectId, project, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("updateProject", "projectId", projectId);
            // verify required parameter 'project' is not null or undefined
            (0, $lr1pu.assertParamExists)("updateProject", "project", project);
            const localVarPath = `/v1/projects/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(project, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $b84eb90e07303a9f$export$209a9db89d03070e = function(configuration) {
    const localVarAxiosParamCreator = $b84eb90e07303a9f$export$7a67b32e44c44c50(configuration);
    return {
        /**
     *
     * @param {Project} project
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async createProject (project, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProject(project, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async deleteProject (projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProject(projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getAllProjectUsers (projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProjectUsers(projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getAllProjects (options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProjects(options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getProject (projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProject(projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async projectDuplicateCheck (projectName, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectDuplicateCheck(projectName, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {Project} project
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async putChars (projectId, project, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putChars(projectId, project, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {Project} project
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async updateProject (projectId, project, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProject(projectId, project, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        }
    };
};
const $b84eb90e07303a9f$export$189088ad9df11655 = function(configuration, basePath, axios) {
    const localVarFp = $b84eb90e07303a9f$export$209a9db89d03070e(configuration);
    return {
        /**
     *
     * @param {Project} project
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createProject (project, options) {
            return localVarFp.createProject(project, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteProject (projectId, options) {
            return localVarFp.deleteProject(projectId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAllProjectUsers (projectId, options) {
            return localVarFp.getAllProjectUsers(projectId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAllProjects (options) {
            return localVarFp.getAllProjects(options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getProject (projectId, options) {
            return localVarFp.getProject(projectId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ projectDuplicateCheck (projectName, options) {
            return localVarFp.projectDuplicateCheck(projectName, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {Project} project
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ putChars (projectId, project, options) {
            return localVarFp.putChars(projectId, project, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {Project} project
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateProject (projectId, project, options) {
            return localVarFp.updateProject(projectId, project, options).then((request)=>request(axios, basePath));
        }
    };
};
class $b84eb90e07303a9f$export$586c3c8cde325d1a extends (0, $11MtC.BaseAPI) {
    /**
   *
   * @param {ProjectApiCreateProjectRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectApi
   */ createProject(requestParameters, options) {
        return $b84eb90e07303a9f$export$209a9db89d03070e(this.configuration).createProject(requestParameters.project, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {ProjectApiDeleteProjectRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectApi
   */ deleteProject(requestParameters, options) {
        return $b84eb90e07303a9f$export$209a9db89d03070e(this.configuration).deleteProject(requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {ProjectApiGetAllProjectUsersRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectApi
   */ getAllProjectUsers(requestParameters, options) {
        return $b84eb90e07303a9f$export$209a9db89d03070e(this.configuration).getAllProjectUsers(requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectApi
   */ getAllProjects(options) {
        return $b84eb90e07303a9f$export$209a9db89d03070e(this.configuration).getAllProjects(options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {ProjectApiGetProjectRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectApi
   */ getProject(requestParameters, options) {
        return $b84eb90e07303a9f$export$209a9db89d03070e(this.configuration).getProject(requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {ProjectApiProjectDuplicateCheckRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectApi
   */ projectDuplicateCheck(requestParameters, options) {
        return $b84eb90e07303a9f$export$209a9db89d03070e(this.configuration).projectDuplicateCheck(requestParameters.projectName, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {ProjectApiPutCharsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectApi
   */ putChars(requestParameters, options) {
        return $b84eb90e07303a9f$export$209a9db89d03070e(this.configuration).putChars(requestParameters.projectId, requestParameters.project, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {ProjectApiUpdateProjectRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectApi
   */ updateProject(requestParameters, options) {
        return $b84eb90e07303a9f$export$209a9db89d03070e(this.configuration).updateProject(requestParameters.projectId, requestParameters.project, options).then((request)=>request(this.axios, this.basePath));
    }
}

});

parcelRegister("jzwjE", function(module, exports) {

$parcel$export(module.exports, "SemanticDomainApi", function () { return $b4befe57b8ef9d7d$export$660fbd4ba05a38fe; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $lr1pu = parcelRequire("lr1pu");

var $11MtC = parcelRequire("11MtC");
const $b4befe57b8ef9d7d$export$5ee2d45d75a36d8e = function(configuration) {
    return {
        /**
     *
     * @param {string} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAllSemanticDomainNames: async (lang, options = {})=>{
            const localVarPath = `/v1/semanticdomain/allDomainNames`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (lang !== undefined) localVarQueryParameter["lang"] = lang;
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAllSemanticDomainTreeNodes: async (lang, options = {})=>{
            const localVarPath = `/v1/semanticdomain/domainGetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (lang !== undefined) localVarQueryParameter["lang"] = lang;
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} [id]
     * @param {string} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSemanticDomainFull: async (id, lang, options = {})=>{
            const localVarPath = `/v1/semanticdomain/domainFull`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) localVarQueryParameter["id"] = id;
            if (lang !== undefined) localVarQueryParameter["lang"] = lang;
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} [id]
     * @param {string} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSemanticDomainTreeNode: async (id, lang, options = {})=>{
            const localVarPath = `/v1/semanticdomain/domainTreeNode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) localVarQueryParameter["id"] = id;
            if (lang !== undefined) localVarQueryParameter["lang"] = lang;
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} [name]
     * @param {string} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSemanticDomainTreeNodeByName: async (name, lang, options = {})=>{
            const localVarPath = `/v1/semanticdomain/domainByName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (name !== undefined) localVarQueryParameter["name"] = name;
            if (lang !== undefined) localVarQueryParameter["lang"] = lang;
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $b4befe57b8ef9d7d$export$468c8ad349e9bda4 = function(configuration) {
    const localVarAxiosParamCreator = $b4befe57b8ef9d7d$export$5ee2d45d75a36d8e(configuration);
    return {
        /**
     *
     * @param {string} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getAllSemanticDomainNames (lang, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSemanticDomainNames(lang, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getAllSemanticDomainTreeNodes (lang, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSemanticDomainTreeNodes(lang, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} [id]
     * @param {string} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getSemanticDomainFull (id, lang, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSemanticDomainFull(id, lang, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} [id]
     * @param {string} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getSemanticDomainTreeNode (id, lang, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSemanticDomainTreeNode(id, lang, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} [name]
     * @param {string} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getSemanticDomainTreeNodeByName (name, lang, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSemanticDomainTreeNodeByName(name, lang, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        }
    };
};
const $b4befe57b8ef9d7d$export$10082b3c44f0627e = function(configuration, basePath, axios) {
    const localVarFp = $b4befe57b8ef9d7d$export$468c8ad349e9bda4(configuration);
    return {
        /**
     *
     * @param {string} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAllSemanticDomainNames (lang, options) {
            return localVarFp.getAllSemanticDomainNames(lang, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAllSemanticDomainTreeNodes (lang, options) {
            return localVarFp.getAllSemanticDomainTreeNodes(lang, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} [id]
     * @param {string} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSemanticDomainFull (id, lang, options) {
            return localVarFp.getSemanticDomainFull(id, lang, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} [id]
     * @param {string} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSemanticDomainTreeNode (id, lang, options) {
            return localVarFp.getSemanticDomainTreeNode(id, lang, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} [name]
     * @param {string} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSemanticDomainTreeNodeByName (name, lang, options) {
            return localVarFp.getSemanticDomainTreeNodeByName(name, lang, options).then((request)=>request(axios, basePath));
        }
    };
};
class $b4befe57b8ef9d7d$export$660fbd4ba05a38fe extends (0, $11MtC.BaseAPI) {
    /**
   *
   * @param {SemanticDomainApiGetAllSemanticDomainNamesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SemanticDomainApi
   */ getAllSemanticDomainNames(requestParameters = {}, options) {
        return $b4befe57b8ef9d7d$export$468c8ad349e9bda4(this.configuration).getAllSemanticDomainNames(requestParameters.lang, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {SemanticDomainApiGetAllSemanticDomainTreeNodesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SemanticDomainApi
   */ getAllSemanticDomainTreeNodes(requestParameters = {}, options) {
        return $b4befe57b8ef9d7d$export$468c8ad349e9bda4(this.configuration).getAllSemanticDomainTreeNodes(requestParameters.lang, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {SemanticDomainApiGetSemanticDomainFullRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SemanticDomainApi
   */ getSemanticDomainFull(requestParameters = {}, options) {
        return $b4befe57b8ef9d7d$export$468c8ad349e9bda4(this.configuration).getSemanticDomainFull(requestParameters.id, requestParameters.lang, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {SemanticDomainApiGetSemanticDomainTreeNodeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SemanticDomainApi
   */ getSemanticDomainTreeNode(requestParameters = {}, options) {
        return $b4befe57b8ef9d7d$export$468c8ad349e9bda4(this.configuration).getSemanticDomainTreeNode(requestParameters.id, requestParameters.lang, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {SemanticDomainApiGetSemanticDomainTreeNodeByNameRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SemanticDomainApi
   */ getSemanticDomainTreeNodeByName(requestParameters = {}, options) {
        return $b4befe57b8ef9d7d$export$468c8ad349e9bda4(this.configuration).getSemanticDomainTreeNodeByName(requestParameters.name, requestParameters.lang, options).then((request)=>request(this.axios, this.basePath));
    }
}

});

parcelRegister("iIUoD", function(module, exports) {

$parcel$export(module.exports, "SpeakerApi", function () { return $ffc5f53796a88ddd$export$a9021c935efed21d; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $lr1pu = parcelRequire("lr1pu");

var $11MtC = parcelRequire("11MtC");
const $ffc5f53796a88ddd$export$6ccd1b24d33d5de9 = function(configuration) {
    return {
        /**
     *
     * @param {string} projectId
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createSpeaker: async (projectId, body, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("createSpeaker", "projectId", projectId);
            // verify required parameter 'body' is not null or undefined
            (0, $lr1pu.assertParamExists)("createSpeaker", "body", body);
            const localVarPath = `/v1/projects/{projectId}/speakers/create`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteProjectSpeakers: async (projectId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("deleteProjectSpeakers", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/speakers`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "DELETE",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {string} speakerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteSpeaker: async (projectId, speakerId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("deleteSpeaker", "projectId", projectId);
            // verify required parameter 'speakerId' is not null or undefined
            (0, $lr1pu.assertParamExists)("deleteSpeaker", "speakerId", speakerId);
            const localVarPath = `/v1/projects/{projectId}/speakers/{speakerId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"speakerId"}}`, encodeURIComponent(String(speakerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "DELETE",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} speakerId
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ downloadConsent: async (speakerId, projectId, options = {})=>{
            // verify required parameter 'speakerId' is not null or undefined
            (0, $lr1pu.assertParamExists)("downloadConsent", "speakerId", speakerId);
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("downloadConsent", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/speakers/consent/{speakerId}`.replace(`{${"speakerId"}}`, encodeURIComponent(String(speakerId))).replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getProjectSpeakers: async (projectId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getProjectSpeakers", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/speakers`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {string} speakerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSpeaker: async (projectId, speakerId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getSpeaker", "projectId", projectId);
            // verify required parameter 'speakerId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getSpeaker", "speakerId", speakerId);
            const localVarPath = `/v1/projects/{projectId}/speakers/{speakerId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"speakerId"}}`, encodeURIComponent(String(speakerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {string} speakerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ removeConsent: async (projectId, speakerId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("removeConsent", "projectId", projectId);
            // verify required parameter 'speakerId' is not null or undefined
            (0, $lr1pu.assertParamExists)("removeConsent", "speakerId", speakerId);
            const localVarPath = `/v1/projects/{projectId}/speakers/consent/{speakerId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"speakerId"}}`, encodeURIComponent(String(speakerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "DELETE",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {string} speakerId
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateSpeakerName: async (projectId, speakerId, body, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("updateSpeakerName", "projectId", projectId);
            // verify required parameter 'speakerId' is not null or undefined
            (0, $lr1pu.assertParamExists)("updateSpeakerName", "speakerId", speakerId);
            // verify required parameter 'body' is not null or undefined
            (0, $lr1pu.assertParamExists)("updateSpeakerName", "body", body);
            const localVarPath = `/v1/projects/{projectId}/speakers/update/{speakerId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"speakerId"}}`, encodeURIComponent(String(speakerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {string} speakerId
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ uploadConsent: async (projectId, speakerId, file, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("uploadConsent", "projectId", projectId);
            // verify required parameter 'speakerId' is not null or undefined
            (0, $lr1pu.assertParamExists)("uploadConsent", "speakerId", speakerId);
            const localVarPath = `/v1/projects/{projectId}/speakers/consent/{speakerId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"speakerId"}}`, encodeURIComponent(String(speakerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new (configuration && configuration.formDataCtor || FormData)();
            if (file !== undefined) localVarFormParams.append("file", file);
            localVarHeaderParameter["Content-Type"] = "multipart/form-data";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $ffc5f53796a88ddd$export$17ab639fa09b32de = function(configuration) {
    const localVarAxiosParamCreator = $ffc5f53796a88ddd$export$6ccd1b24d33d5de9(configuration);
    return {
        /**
     *
     * @param {string} projectId
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async createSpeaker (projectId, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSpeaker(projectId, body, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async deleteProjectSpeakers (projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProjectSpeakers(projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {string} speakerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async deleteSpeaker (projectId, speakerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSpeaker(projectId, speakerId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} speakerId
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async downloadConsent (speakerId, projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadConsent(speakerId, projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getProjectSpeakers (projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectSpeakers(projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {string} speakerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getSpeaker (projectId, speakerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSpeaker(projectId, speakerId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {string} speakerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async removeConsent (projectId, speakerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeConsent(projectId, speakerId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {string} speakerId
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async updateSpeakerName (projectId, speakerId, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSpeakerName(projectId, speakerId, body, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {string} speakerId
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async uploadConsent (projectId, speakerId, file, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadConsent(projectId, speakerId, file, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        }
    };
};
const $ffc5f53796a88ddd$export$25f4ed756a3192f0 = function(configuration, basePath, axios) {
    const localVarFp = $ffc5f53796a88ddd$export$17ab639fa09b32de(configuration);
    return {
        /**
     *
     * @param {string} projectId
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createSpeaker (projectId, body, options) {
            return localVarFp.createSpeaker(projectId, body, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteProjectSpeakers (projectId, options) {
            return localVarFp.deleteProjectSpeakers(projectId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {string} speakerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteSpeaker (projectId, speakerId, options) {
            return localVarFp.deleteSpeaker(projectId, speakerId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} speakerId
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ downloadConsent (speakerId, projectId, options) {
            return localVarFp.downloadConsent(speakerId, projectId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getProjectSpeakers (projectId, options) {
            return localVarFp.getProjectSpeakers(projectId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {string} speakerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSpeaker (projectId, speakerId, options) {
            return localVarFp.getSpeaker(projectId, speakerId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {string} speakerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ removeConsent (projectId, speakerId, options) {
            return localVarFp.removeConsent(projectId, speakerId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {string} speakerId
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateSpeakerName (projectId, speakerId, body, options) {
            return localVarFp.updateSpeakerName(projectId, speakerId, body, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {string} speakerId
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ uploadConsent (projectId, speakerId, file, options) {
            return localVarFp.uploadConsent(projectId, speakerId, file, options).then((request)=>request(axios, basePath));
        }
    };
};
class $ffc5f53796a88ddd$export$a9021c935efed21d extends (0, $11MtC.BaseAPI) {
    /**
   *
   * @param {SpeakerApiCreateSpeakerRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpeakerApi
   */ createSpeaker(requestParameters, options) {
        return $ffc5f53796a88ddd$export$17ab639fa09b32de(this.configuration).createSpeaker(requestParameters.projectId, requestParameters.body, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {SpeakerApiDeleteProjectSpeakersRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpeakerApi
   */ deleteProjectSpeakers(requestParameters, options) {
        return $ffc5f53796a88ddd$export$17ab639fa09b32de(this.configuration).deleteProjectSpeakers(requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {SpeakerApiDeleteSpeakerRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpeakerApi
   */ deleteSpeaker(requestParameters, options) {
        return $ffc5f53796a88ddd$export$17ab639fa09b32de(this.configuration).deleteSpeaker(requestParameters.projectId, requestParameters.speakerId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {SpeakerApiDownloadConsentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpeakerApi
   */ downloadConsent(requestParameters, options) {
        return $ffc5f53796a88ddd$export$17ab639fa09b32de(this.configuration).downloadConsent(requestParameters.speakerId, requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {SpeakerApiGetProjectSpeakersRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpeakerApi
   */ getProjectSpeakers(requestParameters, options) {
        return $ffc5f53796a88ddd$export$17ab639fa09b32de(this.configuration).getProjectSpeakers(requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {SpeakerApiGetSpeakerRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpeakerApi
   */ getSpeaker(requestParameters, options) {
        return $ffc5f53796a88ddd$export$17ab639fa09b32de(this.configuration).getSpeaker(requestParameters.projectId, requestParameters.speakerId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {SpeakerApiRemoveConsentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpeakerApi
   */ removeConsent(requestParameters, options) {
        return $ffc5f53796a88ddd$export$17ab639fa09b32de(this.configuration).removeConsent(requestParameters.projectId, requestParameters.speakerId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {SpeakerApiUpdateSpeakerNameRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpeakerApi
   */ updateSpeakerName(requestParameters, options) {
        return $ffc5f53796a88ddd$export$17ab639fa09b32de(this.configuration).updateSpeakerName(requestParameters.projectId, requestParameters.speakerId, requestParameters.body, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {SpeakerApiUploadConsentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpeakerApi
   */ uploadConsent(requestParameters, options) {
        return $ffc5f53796a88ddd$export$17ab639fa09b32de(this.configuration).uploadConsent(requestParameters.projectId, requestParameters.speakerId, requestParameters.file, options).then((request)=>request(this.axios, this.basePath));
    }
}

});

parcelRegister("fAwTT", function(module, exports) {

$parcel$export(module.exports, "StatisticsApi", function () { return $3eb23bfdfafad23c$export$603aa434206a17f8; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $lr1pu = parcelRequire("lr1pu");

var $11MtC = parcelRequire("11MtC");
const $3eb23bfdfafad23c$export$c631482437bb1a45 = function(configuration) {
    return {
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLineChartRootData: async (projectId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getLineChartRootData", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/statistics/GetLineChartRootData`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getProgressEstimationLineChartRoot: async (projectId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getProgressEstimationLineChartRoot", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/statistics/GetProgressEstimationLineChartRoot`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {string} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSemanticDomainCounts: async (projectId, lang, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getSemanticDomainCounts", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/statistics/GetSemanticDomainCounts`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (lang !== undefined) localVarQueryParameter["lang"] = lang;
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSemanticDomainUserCounts: async (projectId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getSemanticDomainUserCounts", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/statistics/GetSemanticDomainUserCounts`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getWordsPerDayPerUserCounts: async (projectId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getWordsPerDayPerUserCounts", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/statistics/GetWordsPerDayPerUserCounts`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $3eb23bfdfafad23c$export$cc97726943acd85d = function(configuration) {
    const localVarAxiosParamCreator = $3eb23bfdfafad23c$export$c631482437bb1a45(configuration);
    return {
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getLineChartRootData (projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLineChartRootData(projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getProgressEstimationLineChartRoot (projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProgressEstimationLineChartRoot(projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {string} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getSemanticDomainCounts (projectId, lang, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSemanticDomainCounts(projectId, lang, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getSemanticDomainUserCounts (projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSemanticDomainUserCounts(projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getWordsPerDayPerUserCounts (projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWordsPerDayPerUserCounts(projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        }
    };
};
const $3eb23bfdfafad23c$export$bb36491e64066a41 = function(configuration, basePath, axios) {
    const localVarFp = $3eb23bfdfafad23c$export$cc97726943acd85d(configuration);
    return {
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLineChartRootData (projectId, options) {
            return localVarFp.getLineChartRootData(projectId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getProgressEstimationLineChartRoot (projectId, options) {
            return localVarFp.getProgressEstimationLineChartRoot(projectId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {string} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSemanticDomainCounts (projectId, lang, options) {
            return localVarFp.getSemanticDomainCounts(projectId, lang, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSemanticDomainUserCounts (projectId, options) {
            return localVarFp.getSemanticDomainUserCounts(projectId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getWordsPerDayPerUserCounts (projectId, options) {
            return localVarFp.getWordsPerDayPerUserCounts(projectId, options).then((request)=>request(axios, basePath));
        }
    };
};
class $3eb23bfdfafad23c$export$603aa434206a17f8 extends (0, $11MtC.BaseAPI) {
    /**
   *
   * @param {StatisticsApiGetLineChartRootDataRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatisticsApi
   */ getLineChartRootData(requestParameters, options) {
        return $3eb23bfdfafad23c$export$cc97726943acd85d(this.configuration).getLineChartRootData(requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {StatisticsApiGetProgressEstimationLineChartRootRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatisticsApi
   */ getProgressEstimationLineChartRoot(requestParameters, options) {
        return $3eb23bfdfafad23c$export$cc97726943acd85d(this.configuration).getProgressEstimationLineChartRoot(requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {StatisticsApiGetSemanticDomainCountsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatisticsApi
   */ getSemanticDomainCounts(requestParameters, options) {
        return $3eb23bfdfafad23c$export$cc97726943acd85d(this.configuration).getSemanticDomainCounts(requestParameters.projectId, requestParameters.lang, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {StatisticsApiGetSemanticDomainUserCountsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatisticsApi
   */ getSemanticDomainUserCounts(requestParameters, options) {
        return $3eb23bfdfafad23c$export$cc97726943acd85d(this.configuration).getSemanticDomainUserCounts(requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {StatisticsApiGetWordsPerDayPerUserCountsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatisticsApi
   */ getWordsPerDayPerUserCounts(requestParameters, options) {
        return $3eb23bfdfafad23c$export$cc97726943acd85d(this.configuration).getWordsPerDayPerUserCounts(requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
}

});

parcelRegister("8x916", function(module, exports) {

$parcel$export(module.exports, "UserApi", function () { return $72e84457002ca94a$export$2a63ac7615f78125; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $lr1pu = parcelRequire("lr1pu");

var $11MtC = parcelRequire("11MtC");
const $72e84457002ca94a$export$c3cc06b4091011c4 = function(configuration) {
    return {
        /**
     *
     * @param {Credentials} credentials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ authenticate: async (credentials, options = {})=>{
            // verify required parameter 'credentials' is not null or undefined
            (0, $lr1pu.assertParamExists)("authenticate", "credentials", credentials);
            const localVarPath = `/v1/users/authenticate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(credentials, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {User} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUser: async (user, options = {})=>{
            // verify required parameter 'user' is not null or undefined
            (0, $lr1pu.assertParamExists)("createUser", "user", user);
            const localVarPath = `/v1/users/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(user, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteUser: async (userId, options = {})=>{
            // verify required parameter 'userId' is not null or undefined
            (0, $lr1pu.assertParamExists)("deleteUser", "userId", userId);
            const localVarPath = `/v1/users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "DELETE",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAllUsers: async (options = {})=>{
            const localVarPath = `/v1/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCurrentUser: async (options = {})=>{
            const localVarPath = `/v1/users/currentuser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUser: async (userId, options = {})=>{
            // verify required parameter 'userId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getUser", "userId", userId);
            const localVarPath = `/v1/users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserIdByEmailOrUsername: async (body, options = {})=>{
            // verify required parameter 'body' is not null or undefined
            (0, $lr1pu.assertParamExists)("getUserIdByEmailOrUsername", "body", body);
            const localVarPath = `/v1/users/getbyemailorusername`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserProjects: async (userId, options = {})=>{
            // verify required parameter 'userId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getUserProjects", "userId", userId);
            const localVarPath = `/v1/users/{userId}/projects`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUsersByFilter: async (filter, options = {})=>{
            // verify required parameter 'filter' is not null or undefined
            (0, $lr1pu.assertParamExists)("getUsersByFilter", "filter", filter);
            const localVarPath = `/v1/users/filter/{filter}`.replace(`{${"filter"}}`, encodeURIComponent(String(filter)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ isEmailOrUsernameAvailable: async (body, options = {})=>{
            // verify required parameter 'body' is not null or undefined
            (0, $lr1pu.assertParamExists)("isEmailOrUsernameAvailable", "body", body);
            const localVarPath = `/v1/users/isemailorusernameavailable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ uiLanguage: async (body, options = {})=>{
            // verify required parameter 'body' is not null or undefined
            (0, $lr1pu.assertParamExists)("uiLanguage", "body", body);
            const localVarPath = `/v1/users/uilanguage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} userId
     * @param {User} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUser: async (userId, user, options = {})=>{
            // verify required parameter 'userId' is not null or undefined
            (0, $lr1pu.assertParamExists)("updateUser", "userId", userId);
            // verify required parameter 'user' is not null or undefined
            (0, $lr1pu.assertParamExists)("updateUser", "user", user);
            const localVarPath = `/v1/users/updateuser/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(user, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ verifyCaptchaToken: async (token, options = {})=>{
            // verify required parameter 'token' is not null or undefined
            (0, $lr1pu.assertParamExists)("verifyCaptchaToken", "token", token);
            const localVarPath = `/v1/users/captcha/{token}`.replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $72e84457002ca94a$export$7b43f41e93e60955 = function(configuration) {
    const localVarAxiosParamCreator = $72e84457002ca94a$export$c3cc06b4091011c4(configuration);
    return {
        /**
     *
     * @param {Credentials} credentials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async authenticate (credentials, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticate(credentials, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {User} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async createUser (user, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(user, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async deleteUser (userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(userId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getAllUsers (options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUsers(options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getCurrentUser (options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUser(options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getUser (userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUser(userId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getUserIdByEmailOrUsername (body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserIdByEmailOrUsername(body, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getUserProjects (userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserProjects(userId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getUsersByFilter (filter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersByFilter(filter, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async isEmailOrUsernameAvailable (body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isEmailOrUsernameAvailable(body, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async uiLanguage (body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uiLanguage(body, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} userId
     * @param {User} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async updateUser (userId, user, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(userId, user, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async verifyCaptchaToken (token, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyCaptchaToken(token, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        }
    };
};
const $72e84457002ca94a$export$3d28cb048adea4bd = function(configuration, basePath, axios) {
    const localVarFp = $72e84457002ca94a$export$7b43f41e93e60955(configuration);
    return {
        /**
     *
     * @param {Credentials} credentials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ authenticate (credentials, options) {
            return localVarFp.authenticate(credentials, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {User} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUser (user, options) {
            return localVarFp.createUser(user, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteUser (userId, options) {
            return localVarFp.deleteUser(userId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAllUsers (options) {
            return localVarFp.getAllUsers(options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCurrentUser (options) {
            return localVarFp.getCurrentUser(options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUser (userId, options) {
            return localVarFp.getUser(userId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserIdByEmailOrUsername (body, options) {
            return localVarFp.getUserIdByEmailOrUsername(body, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserProjects (userId, options) {
            return localVarFp.getUserProjects(userId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUsersByFilter (filter, options) {
            return localVarFp.getUsersByFilter(filter, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ isEmailOrUsernameAvailable (body, options) {
            return localVarFp.isEmailOrUsernameAvailable(body, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ uiLanguage (body, options) {
            return localVarFp.uiLanguage(body, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} userId
     * @param {User} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUser (userId, user, options) {
            return localVarFp.updateUser(userId, user, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ verifyCaptchaToken (token, options) {
            return localVarFp.verifyCaptchaToken(token, options).then((request)=>request(axios, basePath));
        }
    };
};
class $72e84457002ca94a$export$2a63ac7615f78125 extends (0, $11MtC.BaseAPI) {
    /**
   *
   * @param {UserApiAuthenticateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ authenticate(requestParameters, options) {
        return $72e84457002ca94a$export$7b43f41e93e60955(this.configuration).authenticate(requestParameters.credentials, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {UserApiCreateUserRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ createUser(requestParameters, options) {
        return $72e84457002ca94a$export$7b43f41e93e60955(this.configuration).createUser(requestParameters.user, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {UserApiDeleteUserRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ deleteUser(requestParameters, options) {
        return $72e84457002ca94a$export$7b43f41e93e60955(this.configuration).deleteUser(requestParameters.userId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getAllUsers(options) {
        return $72e84457002ca94a$export$7b43f41e93e60955(this.configuration).getAllUsers(options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getCurrentUser(options) {
        return $72e84457002ca94a$export$7b43f41e93e60955(this.configuration).getCurrentUser(options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {UserApiGetUserRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getUser(requestParameters, options) {
        return $72e84457002ca94a$export$7b43f41e93e60955(this.configuration).getUser(requestParameters.userId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {UserApiGetUserIdByEmailOrUsernameRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getUserIdByEmailOrUsername(requestParameters, options) {
        return $72e84457002ca94a$export$7b43f41e93e60955(this.configuration).getUserIdByEmailOrUsername(requestParameters.body, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {UserApiGetUserProjectsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getUserProjects(requestParameters, options) {
        return $72e84457002ca94a$export$7b43f41e93e60955(this.configuration).getUserProjects(requestParameters.userId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {UserApiGetUsersByFilterRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getUsersByFilter(requestParameters, options) {
        return $72e84457002ca94a$export$7b43f41e93e60955(this.configuration).getUsersByFilter(requestParameters.filter, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {UserApiIsEmailOrUsernameAvailableRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ isEmailOrUsernameAvailable(requestParameters, options) {
        return $72e84457002ca94a$export$7b43f41e93e60955(this.configuration).isEmailOrUsernameAvailable(requestParameters.body, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {UserApiUiLanguageRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ uiLanguage(requestParameters, options) {
        return $72e84457002ca94a$export$7b43f41e93e60955(this.configuration).uiLanguage(requestParameters.body, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {UserApiUpdateUserRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ updateUser(requestParameters, options) {
        return $72e84457002ca94a$export$7b43f41e93e60955(this.configuration).updateUser(requestParameters.userId, requestParameters.user, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {UserApiVerifyCaptchaTokenRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ verifyCaptchaToken(requestParameters, options) {
        return $72e84457002ca94a$export$7b43f41e93e60955(this.configuration).verifyCaptchaToken(requestParameters.token, options).then((request)=>request(this.axios, this.basePath));
    }
}

});

parcelRegister("kAOhX", function(module, exports) {

$parcel$export(module.exports, "UserEditApi", function () { return $69f227618d7544a2$export$6d44c1ae4a943715; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $lr1pu = parcelRequire("lr1pu");

var $11MtC = parcelRequire("11MtC");
const $69f227618d7544a2$export$c58c20a20d27d51d = function(configuration) {
    return {
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUserEdit: async (projectId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("createUserEdit", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/useredits`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {string} userEditId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteUserEdit: async (projectId, userEditId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("deleteUserEdit", "projectId", projectId);
            // verify required parameter 'userEditId' is not null or undefined
            (0, $lr1pu.assertParamExists)("deleteUserEdit", "userEditId", userEditId);
            const localVarPath = `/v1/projects/{projectId}/useredits/{userEditId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"userEditId"}}`, encodeURIComponent(String(userEditId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "DELETE",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getProjectUserEdits: async (projectId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getProjectUserEdits", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/useredits`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {string} userEditId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserEdit: async (projectId, userEditId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getUserEdit", "projectId", projectId);
            // verify required parameter 'userEditId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getUserEdit", "userEditId", userEditId);
            const localVarPath = `/v1/projects/{projectId}/useredits/{userEditId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"userEditId"}}`, encodeURIComponent(String(userEditId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {string} userEditId
     * @param {Edit} edit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserEditGoal: async (projectId, userEditId, edit, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("updateUserEditGoal", "projectId", projectId);
            // verify required parameter 'userEditId' is not null or undefined
            (0, $lr1pu.assertParamExists)("updateUserEditGoal", "userEditId", userEditId);
            // verify required parameter 'edit' is not null or undefined
            (0, $lr1pu.assertParamExists)("updateUserEditGoal", "edit", edit);
            const localVarPath = `/v1/projects/{projectId}/useredits/{userEditId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"userEditId"}}`, encodeURIComponent(String(userEditId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(edit, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {string} userEditId
     * @param {UserEditStepWrapper} userEditStepWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserEditStep: async (projectId, userEditId, userEditStepWrapper, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("updateUserEditStep", "projectId", projectId);
            // verify required parameter 'userEditId' is not null or undefined
            (0, $lr1pu.assertParamExists)("updateUserEditStep", "userEditId", userEditId);
            // verify required parameter 'userEditStepWrapper' is not null or undefined
            (0, $lr1pu.assertParamExists)("updateUserEditStep", "userEditStepWrapper", userEditStepWrapper);
            const localVarPath = `/v1/projects/{projectId}/useredits/{userEditId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"userEditId"}}`, encodeURIComponent(String(userEditId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(userEditStepWrapper, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $69f227618d7544a2$export$812c8f58164795 = function(configuration) {
    const localVarAxiosParamCreator = $69f227618d7544a2$export$c58c20a20d27d51d(configuration);
    return {
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async createUserEdit (projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserEdit(projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {string} userEditId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async deleteUserEdit (projectId, userEditId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserEdit(projectId, userEditId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getProjectUserEdits (projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectUserEdits(projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {string} userEditId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getUserEdit (projectId, userEditId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserEdit(projectId, userEditId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {string} userEditId
     * @param {Edit} edit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async updateUserEditGoal (projectId, userEditId, edit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserEditGoal(projectId, userEditId, edit, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {string} userEditId
     * @param {UserEditStepWrapper} userEditStepWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async updateUserEditStep (projectId, userEditId, userEditStepWrapper, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserEditStep(projectId, userEditId, userEditStepWrapper, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        }
    };
};
const $69f227618d7544a2$export$d6a42be9e7ac13ca = function(configuration, basePath, axios) {
    const localVarFp = $69f227618d7544a2$export$812c8f58164795(configuration);
    return {
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUserEdit (projectId, options) {
            return localVarFp.createUserEdit(projectId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {string} userEditId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteUserEdit (projectId, userEditId, options) {
            return localVarFp.deleteUserEdit(projectId, userEditId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getProjectUserEdits (projectId, options) {
            return localVarFp.getProjectUserEdits(projectId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {string} userEditId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserEdit (projectId, userEditId, options) {
            return localVarFp.getUserEdit(projectId, userEditId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {string} userEditId
     * @param {Edit} edit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserEditGoal (projectId, userEditId, edit, options) {
            return localVarFp.updateUserEditGoal(projectId, userEditId, edit, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {string} userEditId
     * @param {UserEditStepWrapper} userEditStepWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserEditStep (projectId, userEditId, userEditStepWrapper, options) {
            return localVarFp.updateUserEditStep(projectId, userEditId, userEditStepWrapper, options).then((request)=>request(axios, basePath));
        }
    };
};
class $69f227618d7544a2$export$6d44c1ae4a943715 extends (0, $11MtC.BaseAPI) {
    /**
   *
   * @param {UserEditApiCreateUserEditRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserEditApi
   */ createUserEdit(requestParameters, options) {
        return $69f227618d7544a2$export$812c8f58164795(this.configuration).createUserEdit(requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {UserEditApiDeleteUserEditRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserEditApi
   */ deleteUserEdit(requestParameters, options) {
        return $69f227618d7544a2$export$812c8f58164795(this.configuration).deleteUserEdit(requestParameters.projectId, requestParameters.userEditId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {UserEditApiGetProjectUserEditsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserEditApi
   */ getProjectUserEdits(requestParameters, options) {
        return $69f227618d7544a2$export$812c8f58164795(this.configuration).getProjectUserEdits(requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {UserEditApiGetUserEditRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserEditApi
   */ getUserEdit(requestParameters, options) {
        return $69f227618d7544a2$export$812c8f58164795(this.configuration).getUserEdit(requestParameters.projectId, requestParameters.userEditId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {UserEditApiUpdateUserEditGoalRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserEditApi
   */ updateUserEditGoal(requestParameters, options) {
        return $69f227618d7544a2$export$812c8f58164795(this.configuration).updateUserEditGoal(requestParameters.projectId, requestParameters.userEditId, requestParameters.edit, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {UserEditApiUpdateUserEditStepRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserEditApi
   */ updateUserEditStep(requestParameters, options) {
        return $69f227618d7544a2$export$812c8f58164795(this.configuration).updateUserEditStep(requestParameters.projectId, requestParameters.userEditId, requestParameters.userEditStepWrapper, options).then((request)=>request(this.axios, this.basePath));
    }
}

});

parcelRegister("9Nnrr", function(module, exports) {

$parcel$export(module.exports, "UserRoleApi", function () { return $266efd85a1bcfb0a$export$2d5b15ca65c4aaef; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $lr1pu = parcelRequire("lr1pu");

var $11MtC = parcelRequire("11MtC");
const $266efd85a1bcfb0a$export$e57bc68b7f088ae9 = function(configuration) {
    return {
        /**
     *
     * @param {string} projectId
     * @param {string} oldUserId
     * @param {string} newUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ changeOwner: async (projectId, oldUserId, newUserId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("changeOwner", "projectId", projectId);
            // verify required parameter 'oldUserId' is not null or undefined
            (0, $lr1pu.assertParamExists)("changeOwner", "oldUserId", oldUserId);
            // verify required parameter 'newUserId' is not null or undefined
            (0, $lr1pu.assertParamExists)("changeOwner", "newUserId", newUserId);
            const localVarPath = `/v1/projects/{projectId}/userroles/changeowner/{oldUserId}/{newUserId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"oldUserId"}}`, encodeURIComponent(String(oldUserId))).replace(`{${"newUserId"}}`, encodeURIComponent(String(newUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {UserRole} userRole
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUserRole: async (projectId, userRole, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("createUserRole", "projectId", projectId);
            // verify required parameter 'userRole' is not null or undefined
            (0, $lr1pu.assertParamExists)("createUserRole", "userRole", userRole);
            const localVarPath = `/v1/projects/{projectId}/userroles`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(userRole, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteProjectUserRoles: async (projectId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("deleteProjectUserRoles", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/userroles`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "DELETE",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteUserRole: async (projectId, userId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("deleteUserRole", "projectId", projectId);
            // verify required parameter 'userId' is not null or undefined
            (0, $lr1pu.assertParamExists)("deleteUserRole", "userId", userId);
            const localVarPath = `/v1/projects/{projectId}/userroles/{userId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "DELETE",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCurrentPermissions: async (projectId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getCurrentPermissions", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/userroles/current`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getProjectUserRoles: async (projectId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getProjectUserRoles", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/userroles`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ hasPermission: async (projectId, body, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("hasPermission", "projectId", projectId);
            // verify required parameter 'body' is not null or undefined
            (0, $lr1pu.assertParamExists)("hasPermission", "body", body);
            const localVarPath = `/v1/projects/{projectId}/userroles/permission`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} userId
     * @param {string} projectId
     * @param {ProjectRole} projectRole
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserRole: async (userId, projectId, projectRole, options = {})=>{
            // verify required parameter 'userId' is not null or undefined
            (0, $lr1pu.assertParamExists)("updateUserRole", "userId", userId);
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("updateUserRole", "projectId", projectId);
            // verify required parameter 'projectRole' is not null or undefined
            (0, $lr1pu.assertParamExists)("updateUserRole", "projectRole", projectRole);
            const localVarPath = `/v1/projects/{projectId}/userroles/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(userId))).replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(projectRole, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $266efd85a1bcfb0a$export$9a3409e07a4d859b = function(configuration) {
    const localVarAxiosParamCreator = $266efd85a1bcfb0a$export$e57bc68b7f088ae9(configuration);
    return {
        /**
     *
     * @param {string} projectId
     * @param {string} oldUserId
     * @param {string} newUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async changeOwner (projectId, oldUserId, newUserId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeOwner(projectId, oldUserId, newUserId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {UserRole} userRole
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async createUserRole (projectId, userRole, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserRole(projectId, userRole, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async deleteProjectUserRoles (projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProjectUserRoles(projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async deleteUserRole (projectId, userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserRole(projectId, userId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getCurrentPermissions (projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentPermissions(projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getProjectUserRoles (projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectUserRoles(projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async hasPermission (projectId, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hasPermission(projectId, body, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} userId
     * @param {string} projectId
     * @param {ProjectRole} projectRole
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async updateUserRole (userId, projectId, projectRole, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserRole(userId, projectId, projectRole, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        }
    };
};
const $266efd85a1bcfb0a$export$71b7f55181867bb4 = function(configuration, basePath, axios) {
    const localVarFp = $266efd85a1bcfb0a$export$9a3409e07a4d859b(configuration);
    return {
        /**
     *
     * @param {string} projectId
     * @param {string} oldUserId
     * @param {string} newUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ changeOwner (projectId, oldUserId, newUserId, options) {
            return localVarFp.changeOwner(projectId, oldUserId, newUserId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {UserRole} userRole
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUserRole (projectId, userRole, options) {
            return localVarFp.createUserRole(projectId, userRole, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteProjectUserRoles (projectId, options) {
            return localVarFp.deleteProjectUserRoles(projectId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteUserRole (projectId, userId, options) {
            return localVarFp.deleteUserRole(projectId, userId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCurrentPermissions (projectId, options) {
            return localVarFp.getCurrentPermissions(projectId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getProjectUserRoles (projectId, options) {
            return localVarFp.getProjectUserRoles(projectId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ hasPermission (projectId, body, options) {
            return localVarFp.hasPermission(projectId, body, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} userId
     * @param {string} projectId
     * @param {ProjectRole} projectRole
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserRole (userId, projectId, projectRole, options) {
            return localVarFp.updateUserRole(userId, projectId, projectRole, options).then((request)=>request(axios, basePath));
        }
    };
};
class $266efd85a1bcfb0a$export$2d5b15ca65c4aaef extends (0, $11MtC.BaseAPI) {
    /**
   *
   * @param {UserRoleApiChangeOwnerRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserRoleApi
   */ changeOwner(requestParameters, options) {
        return $266efd85a1bcfb0a$export$9a3409e07a4d859b(this.configuration).changeOwner(requestParameters.projectId, requestParameters.oldUserId, requestParameters.newUserId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {UserRoleApiCreateUserRoleRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserRoleApi
   */ createUserRole(requestParameters, options) {
        return $266efd85a1bcfb0a$export$9a3409e07a4d859b(this.configuration).createUserRole(requestParameters.projectId, requestParameters.userRole, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {UserRoleApiDeleteProjectUserRolesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserRoleApi
   */ deleteProjectUserRoles(requestParameters, options) {
        return $266efd85a1bcfb0a$export$9a3409e07a4d859b(this.configuration).deleteProjectUserRoles(requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {UserRoleApiDeleteUserRoleRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserRoleApi
   */ deleteUserRole(requestParameters, options) {
        return $266efd85a1bcfb0a$export$9a3409e07a4d859b(this.configuration).deleteUserRole(requestParameters.projectId, requestParameters.userId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {UserRoleApiGetCurrentPermissionsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserRoleApi
   */ getCurrentPermissions(requestParameters, options) {
        return $266efd85a1bcfb0a$export$9a3409e07a4d859b(this.configuration).getCurrentPermissions(requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {UserRoleApiGetProjectUserRolesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserRoleApi
   */ getProjectUserRoles(requestParameters, options) {
        return $266efd85a1bcfb0a$export$9a3409e07a4d859b(this.configuration).getProjectUserRoles(requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {UserRoleApiHasPermissionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserRoleApi
   */ hasPermission(requestParameters, options) {
        return $266efd85a1bcfb0a$export$9a3409e07a4d859b(this.configuration).hasPermission(requestParameters.projectId, requestParameters.body, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {UserRoleApiUpdateUserRoleRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserRoleApi
   */ updateUserRole(requestParameters, options) {
        return $266efd85a1bcfb0a$export$9a3409e07a4d859b(this.configuration).updateUserRole(requestParameters.userId, requestParameters.projectId, requestParameters.projectRole, options).then((request)=>request(this.axios, this.basePath));
    }
}

});

parcelRegister("iL4qK", function(module, exports) {

$parcel$export(module.exports, "WordApi", function () { return $d80770538f963949$export$9ca0dfd5ef67d0f; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $lr1pu = parcelRequire("lr1pu");

var $11MtC = parcelRequire("11MtC");
const $d80770538f963949$export$3333e3927d6808d4 = function(configuration) {
    return {
        /**
     *
     * @param {string} projectId
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ areInFrontier: async (projectId, requestBody, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("areInFrontier", "projectId", projectId);
            // verify required parameter 'requestBody' is not null or undefined
            (0, $lr1pu.assertParamExists)("areInFrontier", "requestBody", requestBody);
            const localVarPath = `/v1/projects/{projectId}/words/areinfrontier`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {Word} word
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createWord: async (projectId, word, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("createWord", "projectId", projectId);
            // verify required parameter 'word' is not null or undefined
            (0, $lr1pu.assertParamExists)("createWord", "word", word);
            const localVarPath = `/v1/projects/{projectId}/words`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(word, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {string} wordId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteFrontierWord: async (projectId, wordId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("deleteFrontierWord", "projectId", projectId);
            // verify required parameter 'wordId' is not null or undefined
            (0, $lr1pu.assertParamExists)("deleteFrontierWord", "wordId", wordId);
            const localVarPath = `/v1/projects/{projectId}/words/frontier/{wordId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"wordId"}}`, encodeURIComponent(String(wordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "DELETE",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {string} domainId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getDomainWordCount: async (projectId, domainId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getDomainWordCount", "projectId", projectId);
            // verify required parameter 'domainId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getDomainWordCount", "domainId", domainId);
            const localVarPath = `/v1/projects/{projectId}/words/domainwordcount/{domainId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"domainId"}}`, encodeURIComponent(String(domainId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {Word} word
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getDuplicateId: async (projectId, word, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getDuplicateId", "projectId", projectId);
            // verify required parameter 'word' is not null or undefined
            (0, $lr1pu.assertParamExists)("getDuplicateId", "word", word);
            const localVarPath = `/v1/projects/{projectId}/words/getduplicateid`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(word, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFrontierCount: async (projectId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getFrontierCount", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/words/frontiercount`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getProjectFrontierWords: async (projectId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getProjectFrontierWords", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/words/frontier`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {string} wordId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getWord: async (projectId, wordId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getWord", "projectId", projectId);
            // verify required parameter 'wordId' is not null or undefined
            (0, $lr1pu.assertParamExists)("getWord", "wordId", wordId);
            const localVarPath = `/v1/projects/{projectId}/words/{wordId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"wordId"}}`, encodeURIComponent(String(wordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ hasFrontierWords: async (projectId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("hasFrontierWords", "projectId", projectId);
            const localVarPath = `/v1/projects/{projectId}/words/hasfrontierwords`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {string} wordId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ isInFrontier: async (projectId, wordId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("isInFrontier", "projectId", projectId);
            // verify required parameter 'wordId' is not null or undefined
            (0, $lr1pu.assertParamExists)("isInFrontier", "wordId", wordId);
            const localVarPath = `/v1/projects/{projectId}/words/isinfrontier/{wordId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"wordId"}}`, encodeURIComponent(String(wordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {string} wordId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ restoreWord: async (projectId, wordId, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("restoreWord", "projectId", projectId);
            // verify required parameter 'wordId' is not null or undefined
            (0, $lr1pu.assertParamExists)("restoreWord", "wordId", wordId);
            const localVarPath = `/v1/projects/{projectId}/words/restore/{wordId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"wordId"}}`, encodeURIComponent(String(wordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {{ [key: string]: string; }} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ revertWords: async (projectId, requestBody, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("revertWords", "projectId", projectId);
            // verify required parameter 'requestBody' is not null or undefined
            (0, $lr1pu.assertParamExists)("revertWords", "requestBody", requestBody);
            const localVarPath = `/v1/projects/{projectId}/words/revertwords`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {string} dupId
     * @param {Word} word
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateDuplicate: async (projectId, dupId, word, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("updateDuplicate", "projectId", projectId);
            // verify required parameter 'dupId' is not null or undefined
            (0, $lr1pu.assertParamExists)("updateDuplicate", "dupId", dupId);
            // verify required parameter 'word' is not null or undefined
            (0, $lr1pu.assertParamExists)("updateDuplicate", "word", word);
            const localVarPath = `/v1/projects/{projectId}/words/{dupId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"dupId"}}`, encodeURIComponent(String(dupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(word, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     *
     * @param {string} projectId
     * @param {string} wordId
     * @param {Word} word
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateWord: async (projectId, wordId, word, options = {})=>{
            // verify required parameter 'projectId' is not null or undefined
            (0, $lr1pu.assertParamExists)("updateWord", "projectId", projectId);
            // verify required parameter 'wordId' is not null or undefined
            (0, $lr1pu.assertParamExists)("updateWord", "wordId", wordId);
            // verify required parameter 'word' is not null or undefined
            (0, $lr1pu.assertParamExists)("updateWord", "word", word);
            const localVarPath = `/v1/projects/{projectId}/words/{wordId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(projectId))).replace(`{${"wordId"}}`, encodeURIComponent(String(wordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, (0, $lr1pu.DUMMY_BASE_URL));
            let baseOptions;
            if (configuration) baseOptions = configuration.baseOptions;
            const localVarRequestOptions = {
                method: "PUT",
                ...baseOptions,
                ...options
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, $lr1pu.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers
            };
            localVarRequestOptions.data = (0, $lr1pu.serializeDataIfNeeded)(word, localVarRequestOptions, configuration);
            return {
                url: (0, $lr1pu.toPathString)(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $d80770538f963949$export$35f6101c9bee1629 = function(configuration) {
    const localVarAxiosParamCreator = $d80770538f963949$export$3333e3927d6808d4(configuration);
    return {
        /**
     *
     * @param {string} projectId
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async areInFrontier (projectId, requestBody, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.areInFrontier(projectId, requestBody, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {Word} word
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async createWord (projectId, word, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWord(projectId, word, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {string} wordId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async deleteFrontierWord (projectId, wordId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFrontierWord(projectId, wordId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {string} domainId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getDomainWordCount (projectId, domainId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDomainWordCount(projectId, domainId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {Word} word
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getDuplicateId (projectId, word, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDuplicateId(projectId, word, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getFrontierCount (projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrontierCount(projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getProjectFrontierWords (projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectFrontierWords(projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {string} wordId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async getWord (projectId, wordId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWord(projectId, wordId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async hasFrontierWords (projectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hasFrontierWords(projectId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {string} wordId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async isInFrontier (projectId, wordId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isInFrontier(projectId, wordId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {string} wordId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async restoreWord (projectId, wordId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreWord(projectId, wordId, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {{ [key: string]: string; }} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async revertWords (projectId, requestBody, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revertWords(projectId, requestBody, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {string} dupId
     * @param {Word} word
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async updateDuplicate (projectId, dupId, word, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDuplicate(projectId, dupId, word, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        },
        /**
     *
     * @param {string} projectId
     * @param {string} wordId
     * @param {Word} word
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ async updateWord (projectId, wordId, word, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWord(projectId, wordId, word, options);
            return (0, $lr1pu.createRequestFunction)(localVarAxiosArgs, (0, $a04va.default), (0, $11MtC.BASE_PATH), configuration);
        }
    };
};
const $d80770538f963949$export$1d976094097a7d61 = function(configuration, basePath, axios) {
    const localVarFp = $d80770538f963949$export$35f6101c9bee1629(configuration);
    return {
        /**
     *
     * @param {string} projectId
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ areInFrontier (projectId, requestBody, options) {
            return localVarFp.areInFrontier(projectId, requestBody, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {Word} word
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createWord (projectId, word, options) {
            return localVarFp.createWord(projectId, word, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {string} wordId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteFrontierWord (projectId, wordId, options) {
            return localVarFp.deleteFrontierWord(projectId, wordId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {string} domainId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getDomainWordCount (projectId, domainId, options) {
            return localVarFp.getDomainWordCount(projectId, domainId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {Word} word
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getDuplicateId (projectId, word, options) {
            return localVarFp.getDuplicateId(projectId, word, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFrontierCount (projectId, options) {
            return localVarFp.getFrontierCount(projectId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getProjectFrontierWords (projectId, options) {
            return localVarFp.getProjectFrontierWords(projectId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {string} wordId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getWord (projectId, wordId, options) {
            return localVarFp.getWord(projectId, wordId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ hasFrontierWords (projectId, options) {
            return localVarFp.hasFrontierWords(projectId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {string} wordId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ isInFrontier (projectId, wordId, options) {
            return localVarFp.isInFrontier(projectId, wordId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {string} wordId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ restoreWord (projectId, wordId, options) {
            return localVarFp.restoreWord(projectId, wordId, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {{ [key: string]: string; }} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ revertWords (projectId, requestBody, options) {
            return localVarFp.revertWords(projectId, requestBody, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {string} dupId
     * @param {Word} word
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateDuplicate (projectId, dupId, word, options) {
            return localVarFp.updateDuplicate(projectId, dupId, word, options).then((request)=>request(axios, basePath));
        },
        /**
     *
     * @param {string} projectId
     * @param {string} wordId
     * @param {Word} word
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateWord (projectId, wordId, word, options) {
            return localVarFp.updateWord(projectId, wordId, word, options).then((request)=>request(axios, basePath));
        }
    };
};
class $d80770538f963949$export$9ca0dfd5ef67d0f extends (0, $11MtC.BaseAPI) {
    /**
   *
   * @param {WordApiAreInFrontierRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WordApi
   */ areInFrontier(requestParameters, options) {
        return $d80770538f963949$export$35f6101c9bee1629(this.configuration).areInFrontier(requestParameters.projectId, requestParameters.requestBody, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {WordApiCreateWordRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WordApi
   */ createWord(requestParameters, options) {
        return $d80770538f963949$export$35f6101c9bee1629(this.configuration).createWord(requestParameters.projectId, requestParameters.word, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {WordApiDeleteFrontierWordRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WordApi
   */ deleteFrontierWord(requestParameters, options) {
        return $d80770538f963949$export$35f6101c9bee1629(this.configuration).deleteFrontierWord(requestParameters.projectId, requestParameters.wordId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {WordApiGetDomainWordCountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WordApi
   */ getDomainWordCount(requestParameters, options) {
        return $d80770538f963949$export$35f6101c9bee1629(this.configuration).getDomainWordCount(requestParameters.projectId, requestParameters.domainId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {WordApiGetDuplicateIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WordApi
   */ getDuplicateId(requestParameters, options) {
        return $d80770538f963949$export$35f6101c9bee1629(this.configuration).getDuplicateId(requestParameters.projectId, requestParameters.word, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {WordApiGetFrontierCountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WordApi
   */ getFrontierCount(requestParameters, options) {
        return $d80770538f963949$export$35f6101c9bee1629(this.configuration).getFrontierCount(requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {WordApiGetProjectFrontierWordsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WordApi
   */ getProjectFrontierWords(requestParameters, options) {
        return $d80770538f963949$export$35f6101c9bee1629(this.configuration).getProjectFrontierWords(requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {WordApiGetWordRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WordApi
   */ getWord(requestParameters, options) {
        return $d80770538f963949$export$35f6101c9bee1629(this.configuration).getWord(requestParameters.projectId, requestParameters.wordId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {WordApiHasFrontierWordsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WordApi
   */ hasFrontierWords(requestParameters, options) {
        return $d80770538f963949$export$35f6101c9bee1629(this.configuration).hasFrontierWords(requestParameters.projectId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {WordApiIsInFrontierRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WordApi
   */ isInFrontier(requestParameters, options) {
        return $d80770538f963949$export$35f6101c9bee1629(this.configuration).isInFrontier(requestParameters.projectId, requestParameters.wordId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {WordApiRestoreWordRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WordApi
   */ restoreWord(requestParameters, options) {
        return $d80770538f963949$export$35f6101c9bee1629(this.configuration).restoreWord(requestParameters.projectId, requestParameters.wordId, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {WordApiRevertWordsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WordApi
   */ revertWords(requestParameters, options) {
        return $d80770538f963949$export$35f6101c9bee1629(this.configuration).revertWords(requestParameters.projectId, requestParameters.requestBody, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {WordApiUpdateDuplicateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WordApi
   */ updateDuplicate(requestParameters, options) {
        return $d80770538f963949$export$35f6101c9bee1629(this.configuration).updateDuplicate(requestParameters.projectId, requestParameters.dupId, requestParameters.word, options).then((request)=>request(this.axios, this.basePath));
    }
    /**
   *
   * @param {WordApiUpdateWordRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WordApi
   */ updateWord(requestParameters, options) {
        return $d80770538f963949$export$35f6101c9bee1629(this.configuration).updateWord(requestParameters.projectId, requestParameters.wordId, requestParameters.word, options).then((request)=>request(this.axios, this.basePath));
    }
}

});


parcelRegister("alNT7", function(module, exports) {

$parcel$export(module.exports, "Configuration", function () { return $65152b2f6c0f7459$export$fa89be98fe0936f2; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ class $65152b2f6c0f7459$export$fa89be98fe0936f2 {
    constructor(param = {}){
        this.apiKey = param.apiKey;
        this.username = param.username;
        this.password = param.password;
        this.accessToken = param.accessToken;
        this.basePath = param.basePath;
        this.baseOptions = param.baseOptions;
        this.formDataCtor = param.formDataCtor;
    }
    /**
   * Check if the given MIME is a JSON MIME.
   * JSON MIME examples:
   *   application/json
   *   application/json; charset=UTF8
   *   APPLICATION/JSON
   *   application/vnd.company+json
   * @param mime - MIME (Multipurpose Internet Mail Extensions)
   * @return True if the given MIME is JSON, false otherwise.
   */ isJsonMime(mime) {
        const jsonMime = new RegExp("^(application\/json|[^;/ \t]+\/[^;/ \t]+[+]json)[ \t]*(;.*)?$", "i");
        return mime !== null && (jsonMime.test(mime) || mime.toLowerCase() === "application/json-patch+json");
    }
}

});

parcelRegister("585vO", function(module, exports) {
$parcel$export(module.exports, "BannerType", function () { return (parcelRequire("aLuLa")).BannerType; });
$parcel$export(module.exports, "ConsentType", function () { return (parcelRequire("6MxFl")).ConsentType; });
$parcel$export(module.exports, "GramCatGroup", function () { return (parcelRequire("cx1Zj")).GramCatGroup; });
$parcel$export(module.exports, "OffOnSetting", function () { return (parcelRequire("7FuOy")).OffOnSetting; });
$parcel$export(module.exports, "Permission", function () { return (parcelRequire("6fdQP")).Permission; });
$parcel$export(module.exports, "ReasonType", function () { return (parcelRequire("2Eolh")).ReasonType; });
$parcel$export(module.exports, "Role", function () { return (parcelRequire("hIIb2")).Role; });
$parcel$export(module.exports, "Status", function () { return (parcelRequire("csqcy")).Status; });
parcelRequire("aLuLa");
parcelRequire("i9x96");
parcelRequire("6MxFl");
parcelRequire("eS72U");
parcelRequire("jHv5v");
parcelRequire("j9HY8");
parcelRequire("9vLz4");
parcelRequire("c30nE");
parcelRequire("9Kmje");
parcelRequire("cQMNH");
parcelRequire("8W0Pl");
parcelRequire("7WxUZ");
parcelRequire("cx1Zj");
parcelRequire("3skB0");
parcelRequire("e9aSg");
parcelRequire("gvnxe");
parcelRequire("DVEJe");
parcelRequire("fMV7m");
parcelRequire("7FuOy");
parcelRequire("jjkUs");
parcelRequire("6fdQP");
parcelRequire("c7uV5");
parcelRequire("9iRlR");
parcelRequire("5C5OW");
parcelRequire("8J7C6");
parcelRequire("2Eolh");
parcelRequire("hIIb2");
parcelRequire("1OuL7");
parcelRequire("6qh5m");
parcelRequire("jS1y4");
parcelRequire("duBDI");
parcelRequire("6p7Nu");
parcelRequire("6jHJa");
parcelRequire("4jBnZ");
parcelRequire("cDbIy");
parcelRequire("csqcy");
parcelRequire("9N4vb");
parcelRequire("kD3cb");
parcelRequire("eXKAR");
parcelRequire("gVlUl");
parcelRequire("5b9X8");
parcelRequire("8XVMa");
parcelRequire("cBJMu");
parcelRequire("kmS3y");
parcelRequire("cVVwL");
parcelRequire("fszBb");

});
parcelRegister("aLuLa", function(module, exports) {

$parcel$export(module.exports, "BannerType", function () { return $b8347226d6b4549e$export$d64159bfaa8703dd; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @enum {string}
 */ var $b8347226d6b4549e$export$d64159bfaa8703dd = /*#__PURE__*/ function(BannerType) {
    BannerType["None"] = "None";
    BannerType["Login"] = "Login";
    BannerType["Announcement"] = "Announcement";
    return BannerType;
}({});

});

parcelRegister("i9x96", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
});

parcelRegister("6MxFl", function(module, exports) {

$parcel$export(module.exports, "ConsentType", function () { return $26f78f275a75eeb2$export$ce3821381e8fd26d; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @enum {string}
 */ var $26f78f275a75eeb2$export$ce3821381e8fd26d = /*#__PURE__*/ function(ConsentType) {
    ConsentType["None"] = "None";
    ConsentType["Audio"] = "Audio";
    ConsentType["Image"] = "Image";
    return ConsentType;
}({});

});

parcelRegister("eS72U", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @interface Credentials
 */ 
});

parcelRegister("jHv5v", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @interface CustomField
 */ 
});

parcelRegister("j9HY8", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @interface Dataset
 */ 
});

parcelRegister("9vLz4", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @interface Definition
 */ 
});

parcelRegister("c30nE", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @interface Edit
 */ 
});

parcelRegister("9Kmje", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
});

parcelRegister("cQMNH", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @interface EmailInviteStatus
 */ 
});

parcelRegister("8W0Pl", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @interface Flag
 */ 
});

parcelRegister("7WxUZ", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @interface Gloss
 */ 
});

parcelRegister("cx1Zj", function(module, exports) {

$parcel$export(module.exports, "GramCatGroup", function () { return $26477221c24dfeaf$export$a9c39dbd4235db23; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @enum {string}
 */ var $26477221c24dfeaf$export$a9c39dbd4235db23 = /*#__PURE__*/ function(GramCatGroup) {
    GramCatGroup["Adjective"] = "Adjective";
    GramCatGroup["Adposition"] = "Adposition";
    GramCatGroup["Adverb"] = "Adverb";
    GramCatGroup["Classifier"] = "Classifier";
    GramCatGroup["Connective"] = "Connective";
    GramCatGroup["Determiner"] = "Determiner";
    GramCatGroup["ExistentialMarker"] = "ExistentialMarker";
    GramCatGroup["Expletive"] = "Expletive";
    GramCatGroup["Interjection"] = "Interjection";
    GramCatGroup["Noun"] = "Noun";
    GramCatGroup["Participle"] = "Participle";
    GramCatGroup["Particle"] = "Particle";
    GramCatGroup["Prenoun"] = "Prenoun";
    GramCatGroup["Preverb"] = "Preverb";
    GramCatGroup["ProForm"] = "ProForm";
    GramCatGroup["Verb"] = "Verb";
    GramCatGroup["Other"] = "Other";
    GramCatGroup["Unspecified"] = "Unspecified";
    return GramCatGroup;
}({});

});

parcelRegister("3skB0", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
});

parcelRegister("e9aSg", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @interface MergeSourceWord
 */ 
});

parcelRegister("gvnxe", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @interface MergeUndoIds
 */ 
});

parcelRegister("DVEJe", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
});

parcelRegister("fMV7m", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @interface Note
 */ 
});

parcelRegister("7FuOy", function(module, exports) {

$parcel$export(module.exports, "OffOnSetting", function () { return $11f431b342c1e4c5$export$4dc2005d6c6a930; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @enum {string}
 */ var $11f431b342c1e4c5$export$4dc2005d6c6a930 = /*#__PURE__*/ function(OffOnSetting) {
    OffOnSetting["Off"] = "Off";
    OffOnSetting["On"] = "On";
    return OffOnSetting;
}({});

});

parcelRegister("jjkUs", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @interface PasswordResetData
 */ 
});

parcelRegister("6fdQP", function(module, exports) {

$parcel$export(module.exports, "Permission", function () { return $1f14b7ca671869ad$export$a461eaf23bef603e; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @enum {string}
 */ var $1f14b7ca671869ad$export$a461eaf23bef603e = /*#__PURE__*/ function(Permission) {
    Permission["Archive"] = "Archive";
    Permission["CharacterInventory"] = "CharacterInventory";
    Permission["Import"] = "Import";
    Permission["Statistics"] = "Statistics";
    Permission["DeleteEditSettingsAndUsers"] = "DeleteEditSettingsAndUsers";
    Permission["Export"] = "Export";
    Permission["MergeAndReviewEntries"] = "MergeAndReviewEntries";
    Permission["WordEntry"] = "WordEntry";
    return Permission;
}({});

});

parcelRegister("c7uV5", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
});

parcelRegister("9iRlR", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
});

parcelRegister("5C5OW", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @interface Pronunciation
 */ 
});

parcelRegister("8J7C6", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
});

parcelRegister("2Eolh", function(module, exports) {

$parcel$export(module.exports, "ReasonType", function () { return $eb629b2240803731$export$78ba5a416d5b3104; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @enum {string}
 */ var $eb629b2240803731$export$78ba5a416d5b3104 = /*#__PURE__*/ function(ReasonType) {
    ReasonType["Annotations"] = "Annotations";
    ReasonType["Etymologies"] = "Etymologies";
    ReasonType["Examples"] = "Examples";
    ReasonType["Field"] = "Field";
    ReasonType["GramInfoTrait"] = "GramInfoTrait";
    ReasonType["Illustrations"] = "Illustrations";
    ReasonType["NoteWithType"] = "NoteWithType";
    ReasonType["Notes"] = "Notes";
    ReasonType["PronunciationWithoutUrl"] = "PronunciationWithoutUrl";
    ReasonType["Relations"] = "Relations";
    ReasonType["Reversals"] = "Reversals";
    ReasonType["Subsenses"] = "Subsenses";
    ReasonType["Trait"] = "Trait";
    ReasonType["TraitAnthroCode"] = "TraitAnthroCode";
    ReasonType["TraitDialectLabels"] = "TraitDialectLabels";
    ReasonType["TraitDomainType"] = "TraitDomainType";
    ReasonType["TraitDoNotPublishIn"] = "TraitDoNotPublishIn";
    ReasonType["TraitDoNotUseForParsing"] = "TraitDoNotUseForParsing";
    ReasonType["TraitEntryType"] = "TraitEntryType";
    ReasonType["TraitExcludeAsHeadword"] = "TraitExcludeAsHeadword";
    ReasonType["TraitMinorEntryCondition"] = "TraitMinorEntryCondition";
    ReasonType["TraitMorphType"] = "TraitMorphType";
    ReasonType["TraitPublishIn"] = "TraitPublishIn";
    ReasonType["TraitSenseType"] = "TraitSenseType";
    ReasonType["TraitStatus"] = "TraitStatus";
    ReasonType["TraitUsageType"] = "TraitUsageType";
    ReasonType["Variants"] = "Variants";
    return ReasonType;
}({});

});

parcelRegister("hIIb2", function(module, exports) {

$parcel$export(module.exports, "Role", function () { return $8bd6b0ddebcc3bdb$export$46919bad18fb2f76; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @enum {string}
 */ var $8bd6b0ddebcc3bdb$export$46919bad18fb2f76 = /*#__PURE__*/ function(Role) {
    Role["Owner"] = "Owner";
    Role["Administrator"] = "Administrator";
    Role["Editor"] = "Editor";
    Role["Harvester"] = "Harvester";
    Role["None"] = "None";
    return Role;
}({});

});

parcelRegister("1OuL7", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @interface SemanticDomain
 */ 
});

parcelRegister("6qh5m", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
});

parcelRegister("jS1y4", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @interface SemanticDomainFull
 */ 
});

parcelRegister("duBDI", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
});

parcelRegister("6p7Nu", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
});

parcelRegister("6jHJa", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
});

parcelRegister("4jBnZ", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
});

parcelRegister("cDbIy", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
});

parcelRegister("csqcy", function(module, exports) {

$parcel$export(module.exports, "Status", function () { return $e6b972f93c298d81$export$96e9906d6d93a972; });
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @enum {string}
 */ var $e6b972f93c298d81$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["Active"] = "Active";
    Status["Deleted"] = "Deleted";
    Status["Duplicate"] = "Duplicate";
    Status["Protected"] = "Protected";
    return Status;
}({});

});

parcelRegister("9N4vb", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
});

parcelRegister("kD3cb", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
});

parcelRegister("eXKAR", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
});

parcelRegister("gVlUl", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @interface UserEditStepWrapper
 */ 
});

parcelRegister("5b9X8", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
});

parcelRegister("8XVMa", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
});

parcelRegister("cBJMu", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @interface UserStub
 */ 
});

parcelRegister("kmS3y", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
});

parcelRegister("cVVwL", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @interface WordsPerDayPerUserCount
 */ 
});

parcelRegister("fszBb", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ /**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @interface WritingSystem
 */ 
});



parcelRegister("1a3s7", function(module, exports) {

$parcel$export(module.exports, "clearLocalStorage", function () { return $58734202b83f2160$export$c12b7b0e1d99a309; });
$parcel$export(module.exports, "getAvatar", function () { return $58734202b83f2160$export$4832dff6e2fcc91f; });
$parcel$export(module.exports, "setAvatar", function () { return $58734202b83f2160$export$3347c5960dca8b17; });
$parcel$export(module.exports, "getClosedBanner", function () { return $58734202b83f2160$export$ffe4892496743aa0; });
$parcel$export(module.exports, "setClosedBanner", function () { return $58734202b83f2160$export$6e93701a8ee48d2d; });
$parcel$export(module.exports, "getCurrentUser", function () { return $58734202b83f2160$export$e5432d4c8eb97ea7; });
$parcel$export(module.exports, "setCurrentUser", function () { return $58734202b83f2160$export$64e99e757b084e7c; });
$parcel$export(module.exports, "getProjectId", function () { return $58734202b83f2160$export$89040d072f281f85; });
$parcel$export(module.exports, "setProjectId", function () { return $58734202b83f2160$export$b3b5d26bd744f328; });
$parcel$export(module.exports, "getUserId", function () { return $58734202b83f2160$export$1617268687ac763c; });
var $58734202b83f2160$export$e9d9376124133876 = /*#__PURE__*/ function(LocalStorageKey) {
    LocalStorageKey["Avatar"] = "avatar";
    LocalStorageKey["ClosedBanner"] = "closedBanner";
    LocalStorageKey["ProjectId"] = "projectId";
    LocalStorageKey["User"] = "user";
    return LocalStorageKey;
}({});
function $58734202b83f2160$export$c12b7b0e1d99a309() {
    for(const keyString in $58734202b83f2160$export$e9d9376124133876){
        const key = keyString;
        $58734202b83f2160$export$cd7f480d6b8286c3($58734202b83f2160$export$e9d9376124133876[key]);
    }
}
function $58734202b83f2160$export$4832dff6e2fcc91f() {
    return localStorage.getItem("avatar") || "";
}
function $58734202b83f2160$export$3347c5960dca8b17(src) {
    localStorage.setItem("avatar", src);
}
function $58734202b83f2160$export$ffe4892496743aa0() {
    return localStorage.getItem("closedBanner") || "";
}
function $58734202b83f2160$export$6e93701a8ee48d2d(src) {
    localStorage.setItem("closedBanner", src);
}
function $58734202b83f2160$export$e5432d4c8eb97ea7() {
    const userString = localStorage.getItem("user");
    return userString ? JSON.parse(userString) : undefined;
}
function $58734202b83f2160$export$64e99e757b084e7c(user) {
    const userString = JSON.stringify({
        ...user,
        password: ""
    });
    localStorage.setItem("user", userString);
}
function $58734202b83f2160$export$89040d072f281f85() {
    return localStorage.getItem("projectId") || "";
}
function $58734202b83f2160$export$b3b5d26bd744f328(id = "") {
    localStorage.setItem("projectId", id);
}
function $58734202b83f2160$export$1617268687ac763c() {
    const user = $58734202b83f2160$export$e5432d4c8eb97ea7();
    return user ? user.id : "";
}
function $58734202b83f2160$export$cd7f480d6b8286c3(localStorageKey) {
    localStorage.removeItem(localStorageKey);
}

});

parcelRegister("18Taw", function(module, exports) {

$parcel$export(module.exports, "getSessionId", function () { return $7337344a3dc9eb19$export$b3739caaf2580dd; });
var $7337344a3dc9eb19$export$eea0367eee8273a1 = /*#__PURE__*/ function(SessionStorageKey) {
    SessionStorageKey["SessionId"] = "sessionId";
    return SessionStorageKey;
}({});
function $7337344a3dc9eb19$export$b3739caaf2580dd() {
    let id = sessionStorage.getItem("sessionId");
    if (!id) {
        id = crypto.randomUUID();
        sessionStorage.setItem("sessionId", id);
    }
    return id;
}

});

parcelRegister("fKxk8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85a2ed74c6645dd1$export$2e2bcd8739ae039; });

var $1a3s7 = parcelRequire("1a3s7");
function $85a2ed74c6645dd1$export$2e2bcd8739ae039() {
    const user = (0, $1a3s7.getCurrentUser)();
    if (user && user.token) return {
        authorization: "Bearer " + user.token
    };
    else return {};
}

});

parcelRegister("9Ihvc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e262a18ae5f21b64$export$2e2bcd8739ae039; });

var $gxpCl = parcelRequire("gxpCl");

var $fqXGH = parcelRequire("fqXGH");

var $easJz = parcelRequire("easJz");

var $l3fQU = parcelRequire("l3fQU");

var $6PJp8 = parcelRequire("6PJp8");
const $e262a18ae5f21b64$var$router = (0, $gxpCl.createBrowserRouter)((0, $easJz.appRoutes));
// set up analytics for page navigation
// *********** WARNING! ***********
// react-router v6+ no longer uses nor does it support the history package.
// In addition, its replacement for history.listen is the subscribe method.
// The subscribe method is currently marked as PRIVATE - DO NOT USE for
// the time being.  This functionality needs to be verified with future
// updates to the react-router-dom package.
$e262a18ae5f21b64$var$router.subscribe((routerState)=>{
    const pathname = routerState.location.pathname || (0, $6PJp8.Path).Root;
    (0, $fqXGH.store).dispatch((0, $l3fQU.changePage)(pathname));
});
var $e262a18ae5f21b64$export$2e2bcd8739ae039 = $e262a18ae5f21b64$var$router;

});
parcelRegister("gxpCl", function(module, exports) {

$parcel$export(module.exports, "useLocation", function () { return $469b705c8fa11364$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $469b705c8fa11364$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $469b705c8fa11364$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "RouterProvider", function () { return $469b705c8fa11364$export$323e4fc2fa4753fb; });
$parcel$export(module.exports, "Navigate", function () { return $469b705c8fa11364$export$444b3ab0cb9aec40; });
$parcel$export(module.exports, "Route", function () { return $469b705c8fa11364$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $469b705c8fa11364$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "createBrowserRouter", function () { return $469b705c8fa11364$export$1f3f55432a00e06d; });
/**
 * react-router v7.18.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");
var $469b705c8fa11364$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-OB3PAWPO.mjs"
});
var $469b705c8fa11364$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $469b705c8fa11364$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $469b705c8fa11364$var$__typeError("Cannot " + msg);
var $469b705c8fa11364$var$__privateGet = (obj, member, getter)=>($469b705c8fa11364$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $469b705c8fa11364$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $469b705c8fa11364$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $469b705c8fa11364$var$__privateSet = (obj, member, value, setter)=>($469b705c8fa11364$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
// lib/router/url.ts
var $469b705c8fa11364$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
var $469b705c8fa11364$export$825a82322d91916e = /^[\\/]{2}/;
function $469b705c8fa11364$var$normalizeProtocolRelativeUrl(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}
// lib/router/history.ts
var $469b705c8fa11364$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($469b705c8fa11364$export$e19cd5f9376f8cee || {});
var $469b705c8fa11364$var$PopStateEventType = "popstate";
function $469b705c8fa11364$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $469b705c8fa11364$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $469b705c8fa11364$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $469b705c8fa11364$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $469b705c8fa11364$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $469b705c8fa11364$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $469b705c8fa11364$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $469b705c8fa11364$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $469b705c8fa11364$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $469b705c8fa11364$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $469b705c8fa11364$export$fe53371bee54353d(to);
    }
    return $469b705c8fa11364$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $469b705c8fa11364$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $469b705c8fa11364$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $469b705c8fa11364$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $469b705c8fa11364$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $469b705c8fa11364$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $469b705c8fa11364$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $469b705c8fa11364$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $469b705c8fa11364$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $469b705c8fa11364$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $469b705c8fa11364$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $469b705c8fa11364$var$createLocation(current, to, state = null, key, mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $469b705c8fa11364$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $469b705c8fa11364$var$createKey(),
        mask: mask
    };
    return location;
}
function $469b705c8fa11364$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $469b705c8fa11364$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $469b705c8fa11364$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $469b705c8fa11364$var$isLocation(to) ? to : $469b705c8fa11364$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $469b705c8fa11364$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $469b705c8fa11364$var$isLocation(to) ? to : $469b705c8fa11364$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $469b705c8fa11364$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $469b705c8fa11364$var$createBrowserURLImpl(window2, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($469b705c8fa11364$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($469b705c8fa11364$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $469b705c8fa11364$var$createBrowserURLImpl(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $469b705c8fa11364$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $469b705c8fa11364$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && $469b705c8fa11364$export$825a82322d91916e.test(href)) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $469b705c8fa11364$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $469b705c8fa11364$var$_map;
var $469b705c8fa11364$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $469b705c8fa11364$var$__privateAdd(this, $469b705c8fa11364$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($469b705c8fa11364$var$__privateGet(this, $469b705c8fa11364$var$_map).has(context)) return $469b705c8fa11364$var$__privateGet(this, $469b705c8fa11364$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $469b705c8fa11364$var$__privateGet(this, $469b705c8fa11364$var$_map).set(context, value);
    }
};
$469b705c8fa11364$var$_map = new WeakMap();
var $469b705c8fa11364$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $469b705c8fa11364$var$isUnsupportedLazyRouteObjectKey(key) {
    return $469b705c8fa11364$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $469b705c8fa11364$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $469b705c8fa11364$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $469b705c8fa11364$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $469b705c8fa11364$var$isIndexRoute(route) {
    return route.index === true;
}
function $469b705c8fa11364$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $469b705c8fa11364$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $469b705c8fa11364$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($469b705c8fa11364$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $469b705c8fa11364$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $469b705c8fa11364$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $469b705c8fa11364$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $469b705c8fa11364$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $469b705c8fa11364$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $469b705c8fa11364$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $469b705c8fa11364$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let location = typeof locationArg === "string" ? $469b705c8fa11364$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $469b705c8fa11364$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $469b705c8fa11364$var$flattenAndRankRoutes(routes);
    let matches = null;
    let decoded = $469b705c8fa11364$var$decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $469b705c8fa11364$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $469b705c8fa11364$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $469b705c8fa11364$var$flattenAndRankRoutes(routes) {
    let branches = $469b705c8fa11364$var$flattenRoutes(routes);
    $469b705c8fa11364$var$rankRouteBranches(branches);
    return branches;
}
function $469b705c8fa11364$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $469b705c8fa11364$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $469b705c8fa11364$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $469b705c8fa11364$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $469b705c8fa11364$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $469b705c8fa11364$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta2, i)=>{
                let [matcher, params] = $469b705c8fa11364$var$compilePath(meta2.relativePath, meta2.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta2,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $469b705c8fa11364$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $469b705c8fa11364$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $469b705c8fa11364$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $469b705c8fa11364$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $469b705c8fa11364$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $469b705c8fa11364$var$paramRe = /^:[\w-]+$/;
var $469b705c8fa11364$var$dynamicSegmentValue = 3;
var $469b705c8fa11364$var$indexRouteValue = 2;
var $469b705c8fa11364$var$emptySegmentValue = 1;
var $469b705c8fa11364$var$staticSegmentValue = 10;
var $469b705c8fa11364$var$splatPenalty = -2;
var $469b705c8fa11364$var$isSplat = (s)=>s === "*";
function $469b705c8fa11364$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($469b705c8fa11364$var$isSplat)) initialScore += $469b705c8fa11364$var$splatPenalty;
    if (index) initialScore += $469b705c8fa11364$var$indexRouteValue;
    return segments.filter((s)=>!$469b705c8fa11364$var$isSplat(s)).reduce((score, segment)=>score + ($469b705c8fa11364$var$paramRe.test(segment) ? $469b705c8fa11364$var$dynamicSegmentValue : segment === "" ? $469b705c8fa11364$var$emptySegmentValue : $469b705c8fa11364$var$staticSegmentValue), initialScore);
}
function $469b705c8fa11364$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $469b705c8fa11364$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = // Use precomputed matcher if it exists
        meta.matcher && meta.compiledParams ? $469b705c8fa11364$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $469b705c8fa11364$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $469b705c8fa11364$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $469b705c8fa11364$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $469b705c8fa11364$var$normalizePathname($469b705c8fa11364$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $469b705c8fa11364$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $469b705c8fa11364$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $469b705c8fa11364$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $469b705c8fa11364$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $469b705c8fa11364$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $469b705c8fa11364$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    return $469b705c8fa11364$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $469b705c8fa11364$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = $469b705c8fa11364$var$removeTrailingSlash(matchedPathname, 1);
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = $469b705c8fa11364$var$removeTrailingSlash(matchedPathname.slice(0, matchedPathname.length - splatValue.length), 1);
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $469b705c8fa11364$var$compilePath(path, caseSensitive = false, end = true) {
    $469b705c8fa11364$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $469b705c8fa11364$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $469b705c8fa11364$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $469b705c8fa11364$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $469b705c8fa11364$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $469b705c8fa11364$var$joinPaths([
        basename,
        pathname
    ]);
}
var $469b705c8fa11364$var$isAbsoluteUrl = (url)=>$469b705c8fa11364$var$ABSOLUTE_URL_REGEX.test(url);
function $469b705c8fa11364$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $469b705c8fa11364$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $469b705c8fa11364$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/") || toPathname.startsWith("\\")) pathname = $469b705c8fa11364$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $469b705c8fa11364$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $469b705c8fa11364$var$normalizeSearch(search),
        hash: $469b705c8fa11364$var$normalizeHash(hash)
    };
}
function $469b705c8fa11364$var$resolvePathname(relativePath, fromPathname) {
    let segments = $469b705c8fa11364$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $469b705c8fa11364$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $469b705c8fa11364$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $469b705c8fa11364$var$getResolveToMatches(matches) {
    let pathMatches = $469b705c8fa11364$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $469b705c8fa11364$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $469b705c8fa11364$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $469b705c8fa11364$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $469b705c8fa11364$var$getInvalidPathError("?", "pathname", "search", to));
        $469b705c8fa11364$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $469b705c8fa11364$var$getInvalidPathError("#", "pathname", "hash", to));
        $469b705c8fa11364$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $469b705c8fa11364$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $469b705c8fa11364$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $469b705c8fa11364$var$removeDoubleSlashes = (path)=>path.replace(/[\\/]{2,}/g, "/");
var $469b705c8fa11364$var$joinPaths = (paths)=>$469b705c8fa11364$var$removeDoubleSlashes(paths.join("/"));
function $469b705c8fa11364$var$removeTrailingSlash(path, minLength = 0) {
    let end = path.length;
    while(end > minLength && path.charCodeAt(end - 1) === 47)end--;
    return end === path.length ? path : path.slice(0, end);
}
var $469b705c8fa11364$var$normalizePathname = (pathname)=>$469b705c8fa11364$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $469b705c8fa11364$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $469b705c8fa11364$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $469b705c8fa11364$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $469b705c8fa11364$export$4051a07651545597(data2, init) {
    return new $469b705c8fa11364$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $469b705c8fa11364$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $469b705c8fa11364$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $469b705c8fa11364$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $469b705c8fa11364$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $469b705c8fa11364$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $469b705c8fa11364$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $469b705c8fa11364$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $469b705c8fa11364$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $469b705c8fa11364$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $469b705c8fa11364$var$joinPaths(parts) || "/";
}
var $469b705c8fa11364$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $469b705c8fa11364$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$469b705c8fa11364$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($469b705c8fa11364$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = $469b705c8fa11364$export$825a82322d91916e.test(to) ? new URL($469b705c8fa11364$var$normalizeProtocolRelativeUrl(to, currentUrl.protocol)) : new URL(to);
        let path = $469b705c8fa11364$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $469b705c8fa11364$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $469b705c8fa11364$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $469b705c8fa11364$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $469b705c8fa11364$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $469b705c8fa11364$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$469b705c8fa11364$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $469b705c8fa11364$var$wrapImpl(aggregated[key], original, (...args)=>$469b705c8fa11364$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$469b705c8fa11364$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$469b705c8fa11364$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $469b705c8fa11364$var$wrapImpl(aggregated.middleware, original, (...args)=>$469b705c8fa11364$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$469b705c8fa11364$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $469b705c8fa11364$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$469b705c8fa11364$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $469b705c8fa11364$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $469b705c8fa11364$export$fe53371bee54353d(to) : ".",
                ...$469b705c8fa11364$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$469b705c8fa11364$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$469b705c8fa11364$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $469b705c8fa11364$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$469b705c8fa11364$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$469b705c8fa11364$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $469b705c8fa11364$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $469b705c8fa11364$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $469b705c8fa11364$var$getReadonlyRequest(request),
            context: context != null ? $469b705c8fa11364$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $469b705c8fa11364$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $469b705c8fa11364$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $469b705c8fa11364$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $469b705c8fa11364$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $469b705c8fa11364$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $469b705c8fa11364$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, pattern: pattern } = args;
    return {
        request: $469b705c8fa11364$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        pattern: pattern,
        context: $469b705c8fa11364$var$getReadonlyContext(context)
    };
}
function $469b705c8fa11364$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $469b705c8fa11364$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $469b705c8fa11364$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $469b705c8fa11364$var$getReadonlyContext(context) {
    if ($469b705c8fa11364$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $469b705c8fa11364$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $469b705c8fa11364$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $469b705c8fa11364$var$objectProtoNames;
}
// lib/router/navigation.ts
var $469b705c8fa11364$var$DEFAULT_NAVIGATION_URL = new URL("http://localhost");
function $469b705c8fa11364$var$getNavigatorCurrentUrl(navigator) {
    if (navigator.createURL) return navigator.createURL("/");
    try {
        return new URL(navigator.createHref("/"), $469b705c8fa11364$var$DEFAULT_NAVIGATION_URL);
    } catch  {
        return $469b705c8fa11364$var$DEFAULT_NAVIGATION_URL;
    }
}
function $469b705c8fa11364$var$isSameOrigin(a, b) {
    return a.origin === b.origin && (a.origin !== "null" || a.protocol === b.protocol && a.host === b.host);
}
function $469b705c8fa11364$var$isExplicitUrl(destination, target) {
    if (destination.startsWith("//")) return true;
    let protocol = target.protocol.toLowerCase();
    if (!destination.toLowerCase().startsWith(protocol)) return false;
    return target.host === "" || destination.slice(protocol.length).startsWith("//");
}
function $469b705c8fa11364$export$6c8e41f66e7aa990(original, resolved, currentUrl, externalPolicy) {
    let originalUrl = null;
    try {
        originalUrl = original == null ? null : new URL(original, currentUrl);
    } catch  {}
    let resolvedUrl = new URL(resolved, currentUrl);
    let originalIsExternal = originalUrl != null && !$469b705c8fa11364$var$isSameOrigin(originalUrl, currentUrl);
    let resolvedIsExternal = !$469b705c8fa11364$var$isSameOrigin(resolvedUrl, currentUrl);
    if (externalPolicy === "reject") {
        if (originalIsExternal || resolvedIsExternal) throw new Error("External navigation is not allowed");
    } else if (resolvedIsExternal) {
        if (originalUrl == null || !$469b705c8fa11364$var$isExplicitUrl(original, originalUrl) || !$469b705c8fa11364$var$isSameOrigin(originalUrl, resolvedUrl)) throw new Error("External navigation is not allowed");
    }
}
// lib/router/router.ts
var $469b705c8fa11364$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $469b705c8fa11364$var$validMutationMethods = new Set($469b705c8fa11364$var$validMutationMethodsArr);
var $469b705c8fa11364$var$validRequestMethodsArr = [
    "GET",
    ...$469b705c8fa11364$var$validMutationMethodsArr
];
var $469b705c8fa11364$var$validRequestMethods = new Set($469b705c8fa11364$var$validRequestMethodsArr);
var $469b705c8fa11364$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $469b705c8fa11364$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $469b705c8fa11364$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $469b705c8fa11364$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $469b705c8fa11364$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $469b705c8fa11364$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $469b705c8fa11364$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $469b705c8fa11364$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var $469b705c8fa11364$var$_routes, $469b705c8fa11364$var$_branches, $469b705c8fa11364$var$_hmrRoutes, $469b705c8fa11364$var$_hmrBranches;
var $469b705c8fa11364$var$DataRoutes = class {
    constructor(routes){
        $469b705c8fa11364$var$__privateAdd(this, $469b705c8fa11364$var$_routes);
        $469b705c8fa11364$var$__privateAdd(this, $469b705c8fa11364$var$_branches);
        $469b705c8fa11364$var$__privateAdd(this, $469b705c8fa11364$var$_hmrRoutes);
        $469b705c8fa11364$var$__privateAdd(this, $469b705c8fa11364$var$_hmrBranches);
        $469b705c8fa11364$var$__privateSet(this, $469b705c8fa11364$var$_routes, routes);
        $469b705c8fa11364$var$__privateSet(this, $469b705c8fa11364$var$_branches, $469b705c8fa11364$var$flattenAndRankRoutes(routes));
    }
    /** The stable route tree */ get stableRoutes() {
        return $469b705c8fa11364$var$__privateGet(this, $469b705c8fa11364$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return $469b705c8fa11364$var$__privateGet(this, $469b705c8fa11364$var$_hmrRoutes) ?? $469b705c8fa11364$var$__privateGet(this, $469b705c8fa11364$var$_routes);
    }
    /** Pre-computed branches */ get branches() {
        return $469b705c8fa11364$var$__privateGet(this, $469b705c8fa11364$var$_hmrBranches) ?? $469b705c8fa11364$var$__privateGet(this, $469b705c8fa11364$var$_branches);
    }
    get hasHMRRoutes() {
        return $469b705c8fa11364$var$__privateGet(this, $469b705c8fa11364$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        $469b705c8fa11364$var$__privateSet(this, $469b705c8fa11364$var$_routes, routes);
        $469b705c8fa11364$var$__privateSet(this, $469b705c8fa11364$var$_branches, $469b705c8fa11364$var$flattenAndRankRoutes(routes));
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        $469b705c8fa11364$var$__privateSet(this, $469b705c8fa11364$var$_hmrRoutes, routes);
        $469b705c8fa11364$var$__privateSet(this, $469b705c8fa11364$var$_hmrBranches, $469b705c8fa11364$var$flattenAndRankRoutes(routes));
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ($469b705c8fa11364$var$__privateGet(this, $469b705c8fa11364$var$_hmrRoutes)) {
            $469b705c8fa11364$var$__privateSet(this, $469b705c8fa11364$var$_routes, $469b705c8fa11364$var$__privateGet(this, $469b705c8fa11364$var$_hmrRoutes));
            $469b705c8fa11364$var$__privateSet(this, $469b705c8fa11364$var$_branches, $469b705c8fa11364$var$__privateGet(this, $469b705c8fa11364$var$_hmrBranches));
            $469b705c8fa11364$var$__privateSet(this, $469b705c8fa11364$var$_hmrRoutes, void 0);
            $469b705c8fa11364$var$__privateSet(this, $469b705c8fa11364$var$_hmrBranches, void 0);
        }
    }
};
$469b705c8fa11364$var$_routes = new WeakMap();
$469b705c8fa11364$var$_branches = new WeakMap();
$469b705c8fa11364$var$_hmrRoutes = new WeakMap();
$469b705c8fa11364$var$_hmrBranches = new WeakMap();
function $469b705c8fa11364$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $469b705c8fa11364$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $469b705c8fa11364$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$469b705c8fa11364$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $469b705c8fa11364$var$DataRoutes($469b705c8fa11364$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $469b705c8fa11364$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $469b705c8fa11364$export$5c7b09132f833c25(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $469b705c8fa11364$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $469b705c8fa11364$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$469b705c8fa11364$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $469b705c8fa11364$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $469b705c8fa11364$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $469b705c8fa11364$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $469b705c8fa11364$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $469b705c8fa11364$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$469b705c8fa11364$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $469b705c8fa11364$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $469b705c8fa11364$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $469b705c8fa11364$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $469b705c8fa11364$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */  && !isUninterruptedRevalidation && location !== state.location) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $469b705c8fa11364$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $469b705c8fa11364$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $469b705c8fa11364$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $469b705c8fa11364$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? $469b705c8fa11364$export$8ccf933b0513f8d0(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: partialPath.pathname ?? "",
                search: partialPath.search ?? "",
                hash: partialPath.hash ?? ""
            };
            if ($469b705c8fa11364$export$825a82322d91916e.test(maskPath.pathname)) throw new Error("External navigation is not allowed");
            else if (maskPath.pathname.startsWith("\\")) maskPath.pathname = maskPath.pathname.replace(/^\\+/, "/");
            $469b705c8fa11364$export$6c8e41f66e7aa990(typeof opts.mask === "string" ? opts.mask : $469b705c8fa11364$export$fe53371bee54353d(opts.mask), $469b705c8fa11364$export$fe53371bee54353d(maskPath), init.history.createURL("/"), "reject");
        }
        let currentLocation = state.location;
        let nextLocation = $469b705c8fa11364$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        $469b705c8fa11364$export$6c8e41f66e7aa990(to == null ? init.history.createHref(state.location) : typeof to === "string" ? to : $469b705c8fa11364$export$fe53371bee54353d(to), init.history.createHref(nextLocation.mask || nextLocation), init.history.createURL("/"), "reject");
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $469b705c8fa11364$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $469b705c8fa11364$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $469b705c8fa11364$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $469b705c8fa11364$export$5c7b09132f833c25(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $469b705c8fa11364$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $469b705c8fa11364$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $469b705c8fa11364$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $469b705c8fa11364$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $469b705c8fa11364$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $469b705c8fa11364$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($469b705c8fa11364$var$isErrorResult(result) && $469b705c8fa11364$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $469b705c8fa11364$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $469b705c8fa11364$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$469b705c8fa11364$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $469b705c8fa11364$var$getSubmittingNavigation(location, matches, historyAction, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $469b705c8fa11364$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $469b705c8fa11364$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $469b705c8fa11364$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $469b705c8fa11364$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $469b705c8fa11364$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($469b705c8fa11364$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $469b705c8fa11364$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($469b705c8fa11364$var$isErrorResult(result)) {
            let boundaryMatch = $469b705c8fa11364$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $469b705c8fa11364$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $469b705c8fa11364$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $469b705c8fa11364$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $469b705c8fa11364$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $469b705c8fa11364$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers2 = new Map(state.fetchers);
            let didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $469b705c8fa11364$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$469b705c8fa11364$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects2 ? {
                    fetchers: workingFetchers2
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $469b705c8fa11364$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $469b705c8fa11364$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $469b705c8fa11364$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$469b705c8fa11364$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $469b705c8fa11364$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $469b705c8fa11364$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $469b705c8fa11364$export$5c7b09132f833c25(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $469b705c8fa11364$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $469b705c8fa11364$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $469b705c8fa11364$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $469b705c8fa11364$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $469b705c8fa11364$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $469b705c8fa11364$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $469b705c8fa11364$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $469b705c8fa11364$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $469b705c8fa11364$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $469b705c8fa11364$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($469b705c8fa11364$var$isRedirectResult(actionResult) || $469b705c8fa11364$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $469b705c8fa11364$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($469b705c8fa11364$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $469b705c8fa11364$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $469b705c8fa11364$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($469b705c8fa11364$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $469b705c8fa11364$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? $469b705c8fa11364$export$5c7b09132f833c25(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        $469b705c8fa11364$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $469b705c8fa11364$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $469b705c8fa11364$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = workingFetchers.get(staleKey);
            let revalidatingFetcher = $469b705c8fa11364$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers2 = new Map(s.fetchers);
            workingFetchers2.set(key, $469b705c8fa11364$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers2
            };
        };
        let redirect2 = $469b705c8fa11364$var$findRedirect(loaderResults);
        if (redirect2) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect2 = $469b705c8fa11364$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $469b705c8fa11364$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $469b705c8fa11364$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $469b705c8fa11364$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $469b705c8fa11364$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $469b705c8fa11364$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $469b705c8fa11364$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $469b705c8fa11364$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $469b705c8fa11364$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $469b705c8fa11364$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $469b705c8fa11364$var$getDoneFetcher(void 0));
            return;
        }
        if ($469b705c8fa11364$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $469b705c8fa11364$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($469b705c8fa11364$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $469b705c8fa11364$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $469b705c8fa11364$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        let originalLocation = location;
        let currentUrl = new URL(request.url);
        location = $469b705c8fa11364$var$normalizeRedirectLocation(location, currentUrl, basename, init.history);
        $469b705c8fa11364$export$6c8e41f66e7aa990(originalLocation, location, currentUrl, "allow-explicit");
        let redirectLocation = $469b705c8fa11364$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($469b705c8fa11364$var$isAbsoluteUrl(location)) {
                const url = $469b705c8fa11364$var$createBrowserURLImpl(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $469b705c8fa11364$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $469b705c8fa11364$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($469b705c8fa11364$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $469b705c8fa11364$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $469b705c8fa11364$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $469b705c8fa11364$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$469b705c8fa11364$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($469b705c8fa11364$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $469b705c8fa11364$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $469b705c8fa11364$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $469b705c8fa11364$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $469b705c8fa11364$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $469b705c8fa11364$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $469b705c8fa11364$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            $469b705c8fa11364$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $469b705c8fa11364$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            $469b705c8fa11364$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            $469b705c8fa11364$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $469b705c8fa11364$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $469b705c8fa11364$export$386d57f03f0b2883;
        $469b705c8fa11364$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $469b705c8fa11364$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $469b705c8fa11364$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $469b705c8fa11364$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $469b705c8fa11364$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$469b705c8fa11364$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) {
                let fogMatches = $469b705c8fa11364$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $469b705c8fa11364$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $469b705c8fa11364$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = $469b705c8fa11364$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $469b705c8fa11364$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $469b705c8fa11364$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes($469b705c8fa11364$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $469b705c8fa11364$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        createURL: (to)=>init.history.createURL(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = $469b705c8fa11364$var$instrumentClientSideRouter(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $469b705c8fa11364$export$3336b097a6fbc59a(routes, opts) {
    $469b705c8fa11364$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $469b705c8fa11364$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        ...opts?.future
    };
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$469b705c8fa11364$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $469b705c8fa11364$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    let routeBranches = $469b705c8fa11364$var$flattenAndRankRoutes(dataRoutes);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $469b705c8fa11364$var$defaultNormalizePath;
        let method = request.method;
        let location = $469b705c8fa11364$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $469b705c8fa11364$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $469b705c8fa11364$export$b8d3e69d4b3eff04();
        if (!$469b705c8fa11364$var$isValidMethod(method) && method !== "HEAD") {
            let error = $469b705c8fa11364$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $469b705c8fa11364$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $469b705c8fa11364$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $469b705c8fa11364$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $469b705c8fa11364$export$f5708dca728d7177(requestContext instanceof $469b705c8fa11364$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $469b705c8fa11364$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $469b705c8fa11364$var$runServerMiddlewarePipeline({
                    request: request,
                    url: $469b705c8fa11364$var$createDataFunctionUrl(request, location),
                    pattern: $469b705c8fa11364$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($469b705c8fa11364$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($469b705c8fa11364$export$6e80290866a84dd4(error)) return error;
                    if ($469b705c8fa11364$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $469b705c8fa11364$export$f2680fa305b734ca(error.status, error.statusText, await $469b705c8fa11364$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($469b705c8fa11364$export$e0163cfdf7bc9cfa(error)) error = $469b705c8fa11364$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $469b705c8fa11364$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $469b705c8fa11364$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $469b705c8fa11364$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $469b705c8fa11364$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $469b705c8fa11364$export$f5708dca728d7177($469b705c8fa11364$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($469b705c8fa11364$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($469b705c8fa11364$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $469b705c8fa11364$var$defaultNormalizePath;
        let method = request.method;
        let location = $469b705c8fa11364$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $469b705c8fa11364$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $469b705c8fa11364$export$b8d3e69d4b3eff04();
        if (!$469b705c8fa11364$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $469b705c8fa11364$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $469b705c8fa11364$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $469b705c8fa11364$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $469b705c8fa11364$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $469b705c8fa11364$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $469b705c8fa11364$export$f5708dca728d7177(requestContext instanceof $469b705c8fa11364$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $469b705c8fa11364$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $469b705c8fa11364$var$runServerMiddlewarePipeline({
                request: request,
                url: $469b705c8fa11364$var$createDataFunctionUrl(request, location),
                pattern: $469b705c8fa11364$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $469b705c8fa11364$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($469b705c8fa11364$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($469b705c8fa11364$var$dataWithResponseInitToResponse(error));
                if ($469b705c8fa11364$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($469b705c8fa11364$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $469b705c8fa11364$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($469b705c8fa11364$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $469b705c8fa11364$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $469b705c8fa11364$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($469b705c8fa11364$var$isDataStrategyResult(e) && $469b705c8fa11364$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($469b705c8fa11364$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $469b705c8fa11364$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $469b705c8fa11364$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $469b705c8fa11364$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($469b705c8fa11364$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($469b705c8fa11364$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($469b705c8fa11364$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $469b705c8fa11364$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $469b705c8fa11364$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($469b705c8fa11364$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $469b705c8fa11364$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $469b705c8fa11364$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $469b705c8fa11364$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $469b705c8fa11364$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $469b705c8fa11364$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $469b705c8fa11364$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $469b705c8fa11364$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $469b705c8fa11364$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $469b705c8fa11364$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $469b705c8fa11364$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $469b705c8fa11364$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $469b705c8fa11364$var$callDataStrategyImpl(dataStrategy || $469b705c8fa11364$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($469b705c8fa11364$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $469b705c8fa11364$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($469b705c8fa11364$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($469b705c8fa11364$export$e0163cfdf7bc9cfa(result.result)) throw $469b705c8fa11364$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $469b705c8fa11364$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function $469b705c8fa11364$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $469b705c8fa11364$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $469b705c8fa11364$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $469b705c8fa11364$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $469b705c8fa11364$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $469b705c8fa11364$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $469b705c8fa11364$var$resolveTo(to ? to : ".", $469b705c8fa11364$var$getResolveToMatches(contextualMatches), $469b705c8fa11364$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $469b705c8fa11364$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $469b705c8fa11364$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $469b705c8fa11364$export$fe53371bee54353d(path);
}
function $469b705c8fa11364$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$469b705c8fa11364$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$469b705c8fa11364$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $469b705c8fa11364$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $469b705c8fa11364$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $469b705c8fa11364$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$469b705c8fa11364$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$469b705c8fa11364$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $469b705c8fa11364$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $469b705c8fa11364$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $469b705c8fa11364$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $469b705c8fa11364$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $469b705c8fa11364$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($469b705c8fa11364$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $469b705c8fa11364$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $469b705c8fa11364$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $469b705c8fa11364$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $469b705c8fa11364$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $469b705c8fa11364$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $469b705c8fa11364$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $469b705c8fa11364$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$469b705c8fa11364$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $469b705c8fa11364$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($469b705c8fa11364$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $469b705c8fa11364$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($469b705c8fa11364$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $469b705c8fa11364$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $469b705c8fa11364$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $469b705c8fa11364$export$5c7b09132f833c25(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $469b705c8fa11364$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $469b705c8fa11364$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $469b705c8fa11364$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $469b705c8fa11364$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($469b705c8fa11364$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $469b705c8fa11364$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $469b705c8fa11364$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $469b705c8fa11364$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$469b705c8fa11364$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $469b705c8fa11364$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $469b705c8fa11364$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $469b705c8fa11364$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $469b705c8fa11364$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $469b705c8fa11364$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$469b705c8fa11364$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $469b705c8fa11364$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $469b705c8fa11364$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $469b705c8fa11364$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$469b705c8fa11364$var$isSameRoute(aChild, bChild))) ?? false;
}
var $469b705c8fa11364$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $469b705c8fa11364$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $469b705c8fa11364$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $469b705c8fa11364$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $469b705c8fa11364$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $469b705c8fa11364$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $469b705c8fa11364$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $469b705c8fa11364$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $469b705c8fa11364$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $469b705c8fa11364$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $469b705c8fa11364$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $469b705c8fa11364$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $469b705c8fa11364$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $469b705c8fa11364$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $469b705c8fa11364$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $469b705c8fa11364$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $469b705c8fa11364$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $469b705c8fa11364$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $469b705c8fa11364$var$isNonNullable(value) {
    return value !== void 0;
}
function $469b705c8fa11364$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $469b705c8fa11364$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($469b705c8fa11364$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $469b705c8fa11364$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $469b705c8fa11364$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $469b705c8fa11364$var$defaultDataStrategy(args);
    return $469b705c8fa11364$var$runClientMiddlewarePipeline(args, ()=>$469b705c8fa11364$var$defaultDataStrategy(args));
}
function $469b705c8fa11364$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $469b705c8fa11364$var$runMiddlewarePipeline(args, handler, processResult, $469b705c8fa11364$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $469b705c8fa11364$export$e0163cfdf7bc9cfa(result) ? $469b705c8fa11364$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $469b705c8fa11364$var$runClientMiddlewarePipeline(args, handler) {
    return $469b705c8fa11364$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($469b705c8fa11364$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $469b705c8fa11364$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $469b705c8fa11364$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $469b705c8fa11364$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $469b705c8fa11364$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $469b705c8fa11364$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $469b705c8fa11364$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $469b705c8fa11364$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $469b705c8fa11364$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $469b705c8fa11364$var$loadLazyRoute(match.route, $469b705c8fa11364$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $469b705c8fa11364$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $469b705c8fa11364$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $469b705c8fa11364$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $469b705c8fa11364$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $469b705c8fa11364$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$469b705c8fa11364$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($469b705c8fa11364$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $469b705c8fa11364$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $469b705c8fa11364$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $469b705c8fa11364$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $469b705c8fa11364$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $469b705c8fa11364$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $469b705c8fa11364$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: $469b705c8fa11364$var$createDataFunctionUrl(request, path),
        pattern: $469b705c8fa11364$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $469b705c8fa11364$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $469b705c8fa11364$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $469b705c8fa11364$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: $469b705c8fa11364$var$createDataFunctionUrl(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $469b705c8fa11364$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $469b705c8fa11364$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $469b705c8fa11364$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $469b705c8fa11364$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($469b705c8fa11364$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $469b705c8fa11364$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $469b705c8fa11364$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($469b705c8fa11364$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $469b705c8fa11364$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $469b705c8fa11364$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $469b705c8fa11364$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($469b705c8fa11364$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $469b705c8fa11364$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $469b705c8fa11364$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$469b705c8fa11364$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $469b705c8fa11364$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $469b705c8fa11364$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $469b705c8fa11364$export$961a3ef7a4da3a39(location) {
    try {
        return $469b705c8fa11364$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $469b705c8fa11364$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($469b705c8fa11364$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = $469b705c8fa11364$export$825a82322d91916e.test(normalizedLocation) ? new URL($469b705c8fa11364$var$normalizeProtocolRelativeUrl(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($469b705c8fa11364$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = $469b705c8fa11364$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $469b705c8fa11364$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($469b705c8fa11364$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $469b705c8fa11364$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($469b705c8fa11364$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $469b705c8fa11364$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $469b705c8fa11364$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $469b705c8fa11364$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $469b705c8fa11364$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $469b705c8fa11364$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $469b705c8fa11364$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $469b705c8fa11364$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $469b705c8fa11364$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $469b705c8fa11364$export$f5708dca728d7177(!$469b705c8fa11364$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($469b705c8fa11364$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $469b705c8fa11364$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $469b705c8fa11364$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $469b705c8fa11364$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $469b705c8fa11364$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $469b705c8fa11364$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $469b705c8fa11364$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($469b705c8fa11364$var$isErrorResult(result)) {
            let boundaryMatch = $469b705c8fa11364$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($469b705c8fa11364$var$isRedirectResult(result)) $469b705c8fa11364$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $469b705c8fa11364$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $469b705c8fa11364$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $469b705c8fa11364$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $469b705c8fa11364$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $469b705c8fa11364$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $469b705c8fa11364$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $469b705c8fa11364$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $469b705c8fa11364$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $469b705c8fa11364$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $469b705c8fa11364$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($469b705c8fa11364$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $469b705c8fa11364$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $469b705c8fa11364$export$8ccf933b0513f8d0(path) : path;
    return $469b705c8fa11364$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $469b705c8fa11364$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $469b705c8fa11364$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $469b705c8fa11364$var$dataWithResponseInitToErrorResponse(data2) {
    return new $469b705c8fa11364$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $469b705c8fa11364$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $469b705c8fa11364$var$isDataStrategyResult(value));
}
function $469b705c8fa11364$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $469b705c8fa11364$var$isRedirectDataStrategyResult(result) {
    return $469b705c8fa11364$export$3f1eb41d9a6a6a27(result.result) && $469b705c8fa11364$var$redirectStatusCodes.has(result.result.status);
}
function $469b705c8fa11364$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $469b705c8fa11364$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $469b705c8fa11364$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $469b705c8fa11364$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $469b705c8fa11364$export$794b2760043cf8cd(statusCode) {
    return $469b705c8fa11364$var$redirectStatusCodes.has(statusCode);
}
function $469b705c8fa11364$export$6e80290866a84dd4(result) {
    return $469b705c8fa11364$export$3f1eb41d9a6a6a27(result) && $469b705c8fa11364$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $469b705c8fa11364$var$isValidMethod(method) {
    return $469b705c8fa11364$var$validRequestMethods.has(method.toUpperCase());
}
function $469b705c8fa11364$export$cbae47800eb95bc3(method) {
    return $469b705c8fa11364$var$validMutationMethods.has(method.toUpperCase());
}
function $469b705c8fa11364$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $469b705c8fa11364$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $469b705c8fa11364$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $469b705c8fa11364$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $469b705c8fa11364$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $469b705c8fa11364$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $469b705c8fa11364$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $469b705c8fa11364$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $469b705c8fa11364$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $469b705c8fa11364$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $469b705c8fa11364$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $469b705c8fa11364$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($469b705c8fa11364$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $469b705c8fa11364$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($469b705c8fa11364$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $469b705c8fa11364$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $469b705c8fa11364$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $469b705c8fa11364$export$2eeee58951ff3c1c = $7fPBF.createContext(null);
$469b705c8fa11364$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $469b705c8fa11364$export$315e3ffb01f217 = $7fPBF.createContext(null);
$469b705c8fa11364$export$315e3ffb01f217.displayName = "DataRouterState";
var $469b705c8fa11364$export$717f757c655223f1 = $7fPBF.createContext(false);
function $469b705c8fa11364$var$useIsRSCRouterContext() {
    return $7fPBF.useContext($469b705c8fa11364$export$717f757c655223f1);
}
var $469b705c8fa11364$export$3681f408decb40d1 = $7fPBF.createContext({
    isTransitioning: false
});
$469b705c8fa11364$export$3681f408decb40d1.displayName = "ViewTransition";
var $469b705c8fa11364$export$cb3f1df1bef00a39 = $7fPBF.createContext(/* @__PURE__ */ new Map());
$469b705c8fa11364$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $469b705c8fa11364$var$AwaitContext = $7fPBF.createContext(null);
$469b705c8fa11364$var$AwaitContext.displayName = "Await";
var $469b705c8fa11364$export$2666c20e15407622 = (props)=>$7fPBF.createElement($469b705c8fa11364$var$AwaitContext.Provider, props);
var $469b705c8fa11364$export$3044ab7fdabeaee6 = $7fPBF.createContext(null);
$469b705c8fa11364$export$3044ab7fdabeaee6.displayName = "Navigation";
var $469b705c8fa11364$export$e6a44b110a0c44d3 = $7fPBF.createContext(null);
$469b705c8fa11364$export$e6a44b110a0c44d3.displayName = "Location";
var $469b705c8fa11364$export$aac280ed165a4397 = $7fPBF.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$469b705c8fa11364$export$aac280ed165a4397.displayName = "Route";
var $469b705c8fa11364$var$RouteErrorContext = $7fPBF.createContext(null);
$469b705c8fa11364$var$RouteErrorContext.displayName = "RouteError";
var $469b705c8fa11364$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $469b705c8fa11364$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $469b705c8fa11364$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $469b705c8fa11364$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $469b705c8fa11364$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$469b705c8fa11364$var$ERROR_DIGEST_BASE}:${$469b705c8fa11364$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $469b705c8fa11364$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$469b705c8fa11364$var$ERROR_DIGEST_BASE}:${$469b705c8fa11364$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $469b705c8fa11364$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $469b705c8fa11364$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $469b705c8fa11364$export$f5708dca728d7177($469b705c8fa11364$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $469b705c8fa11364$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $469b705c8fa11364$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $469b705c8fa11364$export$9c954a9d03d32f4a() {
    return $7fPBF.useContext($469b705c8fa11364$export$e6a44b110a0c44d3) != null;
}
function $469b705c8fa11364$export$45d76561a5302f2b() {
    $469b705c8fa11364$export$f5708dca728d7177($469b705c8fa11364$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $7fPBF.useContext($469b705c8fa11364$export$e6a44b110a0c44d3).location;
}
function $469b705c8fa11364$export$1b3f31771c5d07c() {
    return $7fPBF.useContext($469b705c8fa11364$export$e6a44b110a0c44d3).navigationType;
}
function $469b705c8fa11364$export$6c330e8992e8a295(pattern) {
    $469b705c8fa11364$export$f5708dca728d7177($469b705c8fa11364$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $469b705c8fa11364$export$45d76561a5302f2b();
    return $7fPBF.useMemo(()=>$469b705c8fa11364$export$81336c211d5ff295(pattern, $469b705c8fa11364$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $469b705c8fa11364$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $469b705c8fa11364$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6).static;
    if (!isStatic) $7fPBF.useLayoutEffect(cb);
}
function $469b705c8fa11364$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $7fPBF.useContext($469b705c8fa11364$export$aac280ed165a4397);
    return isDataRoute ? $469b705c8fa11364$var$useNavigateStable() : $469b705c8fa11364$var$useNavigateUnstable();
}
function $469b705c8fa11364$var$useNavigateUnstable() {
    $469b705c8fa11364$export$f5708dca728d7177($469b705c8fa11364$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $7fPBF.useContext($469b705c8fa11364$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6);
    let { matches: matches } = $7fPBF.useContext($469b705c8fa11364$export$aac280ed165a4397);
    let { pathname: locationPathname } = $469b705c8fa11364$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($469b705c8fa11364$var$getResolveToMatches(matches));
    let activeRef = $7fPBF.useRef(false);
    $469b705c8fa11364$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback((to, options = {})=>{
        $469b705c8fa11364$var$warning(activeRef.current, $469b705c8fa11364$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $469b705c8fa11364$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $469b705c8fa11364$var$joinPaths([
            basename,
            path.pathname
        ]);
        $469b705c8fa11364$export$6c8e41f66e7aa990(typeof to === "string" ? to : $469b705c8fa11364$export$fe53371bee54353d(to), navigator.createHref(path), $469b705c8fa11364$var$getNavigatorCurrentUrl(navigator), "reject");
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $469b705c8fa11364$var$OutletContext = $7fPBF.createContext(null);
function $469b705c8fa11364$export$4138103a3ae699cc() {
    return $7fPBF.useContext($469b705c8fa11364$var$OutletContext);
}
function $469b705c8fa11364$export$a3be3530d8e40d0b(context) {
    let outlet = $7fPBF.useContext($469b705c8fa11364$export$aac280ed165a4397).outlet;
    return $7fPBF.useMemo(()=>outlet && /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $469b705c8fa11364$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $7fPBF.useContext($469b705c8fa11364$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $469b705c8fa11364$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $7fPBF.useContext($469b705c8fa11364$export$aac280ed165a4397);
    let { pathname: locationPathname } = $469b705c8fa11364$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($469b705c8fa11364$var$getResolveToMatches(matches));
    return $7fPBF.useMemo(()=>$469b705c8fa11364$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $469b705c8fa11364$export$5d3fca4a98652595(routes, locationArg) {
    return $469b705c8fa11364$var$useRoutesImpl(routes, locationArg);
}
function $469b705c8fa11364$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $469b705c8fa11364$export$f5708dca728d7177($469b705c8fa11364$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $7fPBF.useContext($469b705c8fa11364$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($469b705c8fa11364$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $469b705c8fa11364$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $469b705c8fa11364$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $469b705c8fa11364$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $469b705c8fa11364$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : $469b705c8fa11364$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($469b705c8fa11364$export$945fecf35a8ef089) {
        $469b705c8fa11364$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $469b705c8fa11364$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $469b705c8fa11364$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $469b705c8fa11364$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $469b705c8fa11364$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $469b705c8fa11364$var$DefaultErrorComponent() {
    let error = $469b705c8fa11364$export$ed527bf60f6e05f2();
    let message = $469b705c8fa11364$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($469b705c8fa11364$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $7fPBF.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $7fPBF.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $7fPBF.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $7fPBF.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $7fPBF.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $469b705c8fa11364$var$defaultErrorElement = /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$DefaultErrorComponent, null);
var $469b705c8fa11364$var$RenderErrorBoundary = class extends $7fPBF.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $469b705c8fa11364$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$469b705c8fa11364$var$RenderErrorBoundary.contextType = $469b705c8fa11364$export$717f757c655223f1;
var $469b705c8fa11364$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $469b705c8fa11364$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $469b705c8fa11364$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $469b705c8fa11364$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $469b705c8fa11364$var$parseToInfo(redirect2.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            $469b705c8fa11364$export$6c8e41f66e7aa990(redirect2.location, target, $469b705c8fa11364$var$getNavigatorCurrentUrl(navigator), "allow-explicit");
            if ($469b705c8fa11364$export$961a3ef7a4da3a39(target)) throw new Error("Invalid redirect location");
            if ($469b705c8fa11364$var$isBrowser && !$469b705c8fa11364$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $469b705c8fa11364$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $7fPBF.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $469b705c8fa11364$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $7fPBF.useContext($469b705c8fa11364$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $469b705c8fa11364$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $469b705c8fa11364$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: $469b705c8fa11364$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $469b705c8fa11364$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $469b705c8fa11364$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $7fPBF.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $469b705c8fa11364$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $469b705c8fa11364$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext($469b705c8fa11364$export$2eeee58951ff3c1c);
    $469b705c8fa11364$export$f5708dca728d7177(ctx, $469b705c8fa11364$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $469b705c8fa11364$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext($469b705c8fa11364$export$315e3ffb01f217);
    $469b705c8fa11364$export$f5708dca728d7177(state, $469b705c8fa11364$var$getDataRouterConsoleError(hookName));
    return state;
}
function $469b705c8fa11364$var$useRouteContext(hookName) {
    let route = $7fPBF.useContext($469b705c8fa11364$export$aac280ed165a4397);
    $469b705c8fa11364$export$f5708dca728d7177(route, $469b705c8fa11364$var$getDataRouterConsoleError(hookName));
    return route;
}
function $469b705c8fa11364$var$useCurrentRouteId(hookName) {
    let route = $469b705c8fa11364$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $469b705c8fa11364$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $469b705c8fa11364$var$useRouteId() {
    return $469b705c8fa11364$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $469b705c8fa11364$export$d0fd4b7106de2769() {
    let state = $469b705c8fa11364$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return $7fPBF.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
function $469b705c8fa11364$export$600dc272ed516c15() {
    let dataRouterContext = $469b705c8fa11364$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $469b705c8fa11364$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $7fPBF.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $7fPBF.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $469b705c8fa11364$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $469b705c8fa11364$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $7fPBF.useMemo(()=>matches.map((m)=>$469b705c8fa11364$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $469b705c8fa11364$export$1448a5050d252c4d() {
    let state = $469b705c8fa11364$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $469b705c8fa11364$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $469b705c8fa11364$export$fd5d37484eab868d(routeId) {
    let state = $469b705c8fa11364$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $469b705c8fa11364$export$fdc00f3f26066d5e() {
    let state = $469b705c8fa11364$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $469b705c8fa11364$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $469b705c8fa11364$export$ed527bf60f6e05f2() {
    let error = $7fPBF.useContext($469b705c8fa11364$var$RouteErrorContext);
    let state = $469b705c8fa11364$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $469b705c8fa11364$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $469b705c8fa11364$export$78a72ddb39bdd145() {
    let value = $7fPBF.useContext($469b705c8fa11364$var$AwaitContext);
    return value?._data;
}
function $469b705c8fa11364$export$17f53340677d5831() {
    let value = $7fPBF.useContext($469b705c8fa11364$var$AwaitContext);
    return value?._error;
}
var $469b705c8fa11364$var$blockerId = 0;
function $469b705c8fa11364$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $469b705c8fa11364$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $469b705c8fa11364$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $7fPBF.useState("");
    let blockerFunction = $7fPBF.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $469b705c8fa11364$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $469b705c8fa11364$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $7fPBF.useEffect(()=>{
        let key = String(++$469b705c8fa11364$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $7fPBF.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $469b705c8fa11364$export$386d57f03f0b2883;
}
function $469b705c8fa11364$var$useNavigateStable() {
    let { router: router } = $469b705c8fa11364$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $469b705c8fa11364$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $7fPBF.useRef(false);
    $469b705c8fa11364$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(async (to, options = {})=>{
        $469b705c8fa11364$var$warning(activeRef.current, $469b705c8fa11364$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $469b705c8fa11364$var$alreadyWarned = {};
function $469b705c8fa11364$var$warningOnce(key, cond, message) {
    if (!cond && !$469b705c8fa11364$var$alreadyWarned[key]) {
        $469b705c8fa11364$var$alreadyWarned[key] = true;
        $469b705c8fa11364$var$warning(false, message);
    }
}
function $469b705c8fa11364$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $469b705c8fa11364$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $469b705c8fa11364$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $469b705c8fa11364$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function $469b705c8fa11364$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $469b705c8fa11364$var$useDataRouterState("unstable_useRouterState" /* UseRouterState */ );
    let active = $7fPBF.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$469b705c8fa11364$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $7fPBF.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$469b705c8fa11364$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $7fPBF.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var $469b705c8fa11364$var$alreadyWarned2 = {};
function $469b705c8fa11364$export$5b28268982f175ba(condition, message) {
    if (!condition && !$469b705c8fa11364$var$alreadyWarned2[message]) {
        $469b705c8fa11364$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $469b705c8fa11364$var$USE_OPTIMISTIC = "useOptimistic";
var $469b705c8fa11364$var$useOptimisticImpl = $7fPBF[$469b705c8fa11364$var$USE_OPTIMISTIC];
var $469b705c8fa11364$var$stableUseOptimisticSetter = ()=>void 0;
function $469b705c8fa11364$var$useOptimisticSafe(val) {
    if ($469b705c8fa11364$var$useOptimisticImpl) return $469b705c8fa11364$var$useOptimisticImpl(val);
    else return [
        val,
        $469b705c8fa11364$var$stableUseOptimisticSetter
    ];
}
function $469b705c8fa11364$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($469b705c8fa11364$export$945fecf35a8ef089) {
            if (route.element) $469b705c8fa11364$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $7fPBF.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($469b705c8fa11364$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $469b705c8fa11364$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $7fPBF.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($469b705c8fa11364$export$945fecf35a8ef089) {
            if (route.errorElement) $469b705c8fa11364$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $7fPBF.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $469b705c8fa11364$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $469b705c8fa11364$export$f30f7e456d254e83(routes, opts) {
    return $469b705c8fa11364$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $469b705c8fa11364$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $469b705c8fa11364$export$e2fd2c03906469db,
        mapRouteProperties: $469b705c8fa11364$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $469b705c8fa11364$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $469b705c8fa11364$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    let unstable_rsc = $469b705c8fa11364$var$useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    let [_state, setStateImpl] = $7fPBF.useState(router.state);
    let [state, setOptimisticState] = $469b705c8fa11364$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $7fPBF.useState();
    let [vtContext, setVtContext] = $7fPBF.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $7fPBF.useState();
    let [transition, setTransition] = $7fPBF.useState();
    let [interruption, setInterruption] = $7fPBF.useState();
    let fetcherData = $7fPBF.useRef(/* @__PURE__ */ new Map());
    let setState = $7fPBF.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: $469b705c8fa11364$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $469b705c8fa11364$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $469b705c8fa11364$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $7fPBF.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$469b705c8fa11364$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $7fPBF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $7fPBF.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $469b705c8fa11364$var$Deferred());
    }, [
        vtContext
    ]);
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $7fPBF.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$469b705c8fa11364$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $7fPBF.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            createURL: router.createURL,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7fPBF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $469b705c8fa11364$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $469b705c8fa11364$var$MemoizedDataRoutes = $7fPBF.memo($469b705c8fa11364$var$DataRoutes2);
function $469b705c8fa11364$var$DataRoutes2({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $469b705c8fa11364$var$useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $469b705c8fa11364$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = $469b705c8fa11364$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7fPBF.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7fPBF.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $469b705c8fa11364$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $469b705c8fa11364$export$f5708dca728d7177($469b705c8fa11364$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic, navigator: navigator } = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6);
    $469b705c8fa11364$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $7fPBF.useContext($469b705c8fa11364$export$aac280ed165a4397);
    let { pathname: locationPathname } = $469b705c8fa11364$export$45d76561a5302f2b();
    let navigate = $469b705c8fa11364$export$9770f232ac06a008();
    let path = $469b705c8fa11364$var$resolveTo(to, $469b705c8fa11364$var$getResolveToMatches(matches), locationPathname, relative === "path");
    $469b705c8fa11364$export$6c8e41f66e7aa990(typeof to === "string" ? to : $469b705c8fa11364$export$fe53371bee54353d(to), navigator.createHref(path), $469b705c8fa11364$var$getNavigatorCurrentUrl(navigator), "reject");
    let jsonPath = JSON.stringify(path);
    $7fPBF.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $469b705c8fa11364$export$910ae8079b2c2852(props) {
    return $469b705c8fa11364$export$a3be3530d8e40d0b(props.context);
}
function $469b705c8fa11364$export$e7b0ac011bb776c6(props) {
    $469b705c8fa11364$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $469b705c8fa11364$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    $469b705c8fa11364$export$f5708dca728d7177(!$469b705c8fa11364$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $7fPBF.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $469b705c8fa11364$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $7fPBF.useMemo(()=>{
        let trailingPathname = $469b705c8fa11364$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    $469b705c8fa11364$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $469b705c8fa11364$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $469b705c8fa11364$export$5d3fca4a98652595($469b705c8fa11364$export$16da398f5434bdec(children), location);
}
function $469b705c8fa11364$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $7fPBF.useContext($469b705c8fa11364$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $7fPBF.useContext($469b705c8fa11364$export$315e3ffb01f217);
    let onError = $7fPBF.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: $469b705c8fa11364$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$ResolveAwait, null, children));
}
var $469b705c8fa11364$var$AwaitErrorBoundary = class extends $7fPBF.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $469b705c8fa11364$var$ResolveAwait({ children: children }) {
    let data2 = $469b705c8fa11364$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, toRender);
}
function $469b705c8fa11364$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $7fPBF.Children.forEach(children, (element, index)=>{
        if (!$7fPBF.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $7fPBF.Fragment) {
            routes.push.apply(routes, $469b705c8fa11364$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $469b705c8fa11364$export$f5708dca728d7177(element.type === $469b705c8fa11364$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $469b705c8fa11364$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $469b705c8fa11364$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $469b705c8fa11364$export$9b5b6d122dea0c88 = $469b705c8fa11364$export$16da398f5434bdec;
function $469b705c8fa11364$export$daf73786167a7f72(matches) {
    return $469b705c8fa11364$var$_renderMatches(matches);
}
function $469b705c8fa11364$var$useRouteComponentProps() {
    return {
        params: $469b705c8fa11364$export$99eaa27ddbbb95ef(),
        loaderData: $469b705c8fa11364$export$1448a5050d252c4d(),
        actionData: $469b705c8fa11364$export$fdc00f3f26066d5e(),
        matches: $469b705c8fa11364$export$2378eb7f5ff86053()
    };
}
function $469b705c8fa11364$export$6c4f3826290c37af({ children: children }) {
    const props = $469b705c8fa11364$var$useRouteComponentProps();
    return $7fPBF.cloneElement(children, props);
}
function $469b705c8fa11364$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $469b705c8fa11364$var$useRouteComponentProps();
        return $7fPBF.createElement(Component4, props);
    };
}
function $469b705c8fa11364$var$useHydrateFallbackProps() {
    return {
        params: $469b705c8fa11364$export$99eaa27ddbbb95ef(),
        loaderData: $469b705c8fa11364$export$1448a5050d252c4d(),
        actionData: $469b705c8fa11364$export$fdc00f3f26066d5e()
    };
}
function $469b705c8fa11364$export$f8cff34f39c1932a({ children: children }) {
    const props = $469b705c8fa11364$var$useHydrateFallbackProps();
    return $7fPBF.cloneElement(children, props);
}
function $469b705c8fa11364$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $469b705c8fa11364$var$useHydrateFallbackProps();
        return $7fPBF.createElement(HydrateFallback, props);
    };
}
function $469b705c8fa11364$var$useErrorBoundaryProps() {
    return {
        params: $469b705c8fa11364$export$99eaa27ddbbb95ef(),
        loaderData: $469b705c8fa11364$export$1448a5050d252c4d(),
        actionData: $469b705c8fa11364$export$fdc00f3f26066d5e(),
        error: $469b705c8fa11364$export$ed527bf60f6e05f2()
    };
}
function $469b705c8fa11364$export$e5afde5c4b6d747b({ children: children }) {
    const props = $469b705c8fa11364$var$useErrorBoundaryProps();
    return $7fPBF.cloneElement(children, props);
}
function $469b705c8fa11364$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $469b705c8fa11364$var$useErrorBoundaryProps();
        return $7fPBF.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $469b705c8fa11364$var$defaultMethod = "get";
var $469b705c8fa11364$var$defaultEncType = "application/x-www-form-urlencoded";
function $469b705c8fa11364$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $469b705c8fa11364$var$isButtonElement(object) {
    return $469b705c8fa11364$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $469b705c8fa11364$var$isFormElement(object) {
    return $469b705c8fa11364$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $469b705c8fa11364$var$isInputElement(object) {
    return $469b705c8fa11364$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $469b705c8fa11364$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $469b705c8fa11364$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$469b705c8fa11364$var$isModifiedEvent(event);
}
function $469b705c8fa11364$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $469b705c8fa11364$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $469b705c8fa11364$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $469b705c8fa11364$var$_formDataSupportsSubmitter = null;
function $469b705c8fa11364$var$isFormDataSubmitterSupported() {
    if ($469b705c8fa11364$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $469b705c8fa11364$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $469b705c8fa11364$var$_formDataSupportsSubmitter = true;
    }
    return $469b705c8fa11364$var$_formDataSupportsSubmitter;
}
var $469b705c8fa11364$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $469b705c8fa11364$var$getFormEncType(encType) {
    if (encType != null && !$469b705c8fa11364$var$supportedFormEncTypes.has(encType)) {
        $469b705c8fa11364$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$469b705c8fa11364$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $469b705c8fa11364$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($469b705c8fa11364$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $469b705c8fa11364$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $469b705c8fa11364$var$defaultMethod;
        encType = $469b705c8fa11364$var$getFormEncType(target.getAttribute("enctype")) || $469b705c8fa11364$var$defaultEncType;
        formData = new FormData(target);
    } else if ($469b705c8fa11364$var$isButtonElement(target) || $469b705c8fa11364$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $469b705c8fa11364$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $469b705c8fa11364$var$defaultMethod;
        encType = $469b705c8fa11364$var$getFormEncType(target.getAttribute("formenctype")) || $469b705c8fa11364$var$getFormEncType(form.getAttribute("enctype")) || $469b705c8fa11364$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$469b705c8fa11364$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($469b705c8fa11364$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $469b705c8fa11364$var$defaultMethod;
        action = null;
        encType = $469b705c8fa11364$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $469b705c8fa11364$var$HOLE = -1;
var $469b705c8fa11364$var$NAN = -2;
var $469b705c8fa11364$var$NEGATIVE_INFINITY = -3;
var $469b705c8fa11364$var$NEGATIVE_ZERO = -4;
var $469b705c8fa11364$var$NULL = -5;
var $469b705c8fa11364$var$POSITIVE_INFINITY = -6;
var $469b705c8fa11364$var$UNDEFINED = -7;
var $469b705c8fa11364$var$TYPE_BIGINT = "B";
var $469b705c8fa11364$var$TYPE_DATE = "D";
var $469b705c8fa11364$var$TYPE_ERROR = "E";
var $469b705c8fa11364$var$TYPE_MAP = "M";
var $469b705c8fa11364$var$TYPE_NULL_OBJECT = "N";
var $469b705c8fa11364$var$TYPE_PROMISE = "P";
var $469b705c8fa11364$var$TYPE_REGEXP = "R";
var $469b705c8fa11364$var$TYPE_SET = "S";
var $469b705c8fa11364$var$TYPE_SYMBOL = "Y";
var $469b705c8fa11364$var$TYPE_URL = "U";
var $469b705c8fa11364$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $469b705c8fa11364$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $469b705c8fa11364$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $469b705c8fa11364$var$TIME_LIMIT_MS = 1;
var $469b705c8fa11364$var$getNow = ()=>Date.now();
var $469b705c8fa11364$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $469b705c8fa11364$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $469b705c8fa11364$var$UNDEFINED;
    if (input === null) return $469b705c8fa11364$var$NULL;
    if (Number.isNaN(input)) return $469b705c8fa11364$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $469b705c8fa11364$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $469b705c8fa11364$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $469b705c8fa11364$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $469b705c8fa11364$var$stringify.call(this, stack);
    return index;
}
async function $469b705c8fa11364$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $469b705c8fa11364$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $469b705c8fa11364$var$UNDEFINED;
        if (value === null) return $469b705c8fa11364$var$NULL;
        if (Number.isNaN(value)) return $469b705c8fa11364$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $469b705c8fa11364$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $469b705c8fa11364$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $469b705c8fa11364$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $469b705c8fa11364$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $469b705c8fa11364$var$TIME_LIMIT_MS) {
            await $469b705c8fa11364$var$yieldToMain();
            lastYieldTime = $469b705c8fa11364$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$469b705c8fa11364$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$469b705c8fa11364$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$469b705c8fa11364$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $469b705c8fa11364$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$469b705c8fa11364$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$469b705c8fa11364$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$469b705c8fa11364$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$469b705c8fa11364$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$469b705c8fa11364$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$469b705c8fa11364$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$469b705c8fa11364$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$469b705c8fa11364$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$469b705c8fa11364$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$469b705c8fa11364$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($469b705c8fa11364$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $469b705c8fa11364$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $469b705c8fa11364$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $469b705c8fa11364$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $469b705c8fa11364$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $469b705c8fa11364$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $469b705c8fa11364$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $469b705c8fa11364$var$hydrate.call(this, startIndex);
}
function $469b705c8fa11364$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $469b705c8fa11364$var$UNDEFINED:
                set(void 0);
                continue;
            case $469b705c8fa11364$var$NULL:
                set(null);
                continue;
            case $469b705c8fa11364$var$NAN:
                set(NaN);
                continue;
            case $469b705c8fa11364$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $469b705c8fa11364$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $469b705c8fa11364$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $469b705c8fa11364$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $469b705c8fa11364$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $469b705c8fa11364$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $469b705c8fa11364$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $469b705c8fa11364$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $469b705c8fa11364$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $469b705c8fa11364$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $469b705c8fa11364$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $469b705c8fa11364$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $469b705c8fa11364$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $469b705c8fa11364$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $469b705c8fa11364$var$globalObj && $469b705c8fa11364$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $469b705c8fa11364$var$globalObj && typeof $469b705c8fa11364$var$globalObj[errorType] === "function" ? new $469b705c8fa11364$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $469b705c8fa11364$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $469b705c8fa11364$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $469b705c8fa11364$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $469b705c8fa11364$var$Deferred2();
    const reader = readable.pipeThrough($469b705c8fa11364$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $469b705c8fa11364$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $469b705c8fa11364$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $469b705c8fa11364$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $469b705c8fa11364$var$unflatten.call(this, line)
    };
}
async function $469b705c8fa11364$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $469b705c8fa11364$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $469b705c8fa11364$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $469b705c8fa11364$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $469b705c8fa11364$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $469b705c8fa11364$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $469b705c8fa11364$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $469b705c8fa11364$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$469b705c8fa11364$var$TYPE_PROMISE}${deferredId}:[["${$469b705c8fa11364$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$469b705c8fa11364$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$469b705c8fa11364$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $469b705c8fa11364$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$469b705c8fa11364$var$TYPE_ERROR}${deferredId}:[["${$469b705c8fa11364$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$469b705c8fa11364$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$469b705c8fa11364$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $469b705c8fa11364$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $469b705c8fa11364$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $469b705c8fa11364$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $469b705c8fa11364$export$4cf11838cdc2a8a8(html) {
    return html.replace($469b705c8fa11364$var$ESCAPE_REGEX, (match)=>$469b705c8fa11364$var$ESCAPE_LOOKUP[match]);
}
function $469b705c8fa11364$export$30330f3d5eb70e11(value) {
    return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
// lib/dom/ssr/invariant.ts
function $469b705c8fa11364$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $469b705c8fa11364$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $469b705c8fa11364$var$SingleFetchNoResultError = class extends Error {
};
var $469b705c8fa11364$export$ae9272e641ead836 = 202;
var $469b705c8fa11364$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $469b705c8fa11364$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $7fPBF.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$469b705c8fa11364$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, scriptTag, /* @__PURE__ */ $7fPBF.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, scriptTag, /* @__PURE__ */ $7fPBF.createElement($7fPBF.Suspense, null, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $469b705c8fa11364$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $469b705c8fa11364$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $469b705c8fa11364$var$invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $469b705c8fa11364$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $469b705c8fa11364$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $469b705c8fa11364$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $469b705c8fa11364$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $469b705c8fa11364$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $469b705c8fa11364$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $469b705c8fa11364$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $469b705c8fa11364$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $469b705c8fa11364$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($469b705c8fa11364$export$3f1eb41d9a6a6a27(result.result) || $469b705c8fa11364$export$972111febbeef05b(result.result) || $469b705c8fa11364$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $469b705c8fa11364$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $469b705c8fa11364$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $469b705c8fa11364$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $469b705c8fa11364$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$469b705c8fa11364$var$createDeferred2());
    let singleFetchDfd = $469b705c8fa11364$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $469b705c8fa11364$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $469b705c8fa11364$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $469b705c8fa11364$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $469b705c8fa11364$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $469b705c8fa11364$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $469b705c8fa11364$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $469b705c8fa11364$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $469b705c8fa11364$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $469b705c8fa11364$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $469b705c8fa11364$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $469b705c8fa11364$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$469b705c8fa11364$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$469b705c8fa11364$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $469b705c8fa11364$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $469b705c8fa11364$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $469b705c8fa11364$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $469b705c8fa11364$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $469b705c8fa11364$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $469b705c8fa11364$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($469b705c8fa11364$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $469b705c8fa11364$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $469b705c8fa11364$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($469b705c8fa11364$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$469b705c8fa11364$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $469b705c8fa11364$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $469b705c8fa11364$export$4023ad4ecd4126a2(body, global) {
    return $469b705c8fa11364$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $469b705c8fa11364$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $469b705c8fa11364$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$469b705c8fa11364$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $469b705c8fa11364$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $469b705c8fa11364$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $469b705c8fa11364$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $469b705c8fa11364$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $469b705c8fa11364$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $469b705c8fa11364$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $469b705c8fa11364$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $469b705c8fa11364$var$getModuleLinkHrefs(matches, manifest);
    return $469b705c8fa11364$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $469b705c8fa11364$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $469b705c8fa11364$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $469b705c8fa11364$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($469b705c8fa11364$var$prefetchStyleLink));
}
async function $469b705c8fa11364$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$469b705c8fa11364$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$469b705c8fa11364$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$469b705c8fa11364$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($469b705c8fa11364$var$prefetchStyleLink));
}
async function $469b705c8fa11364$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $469b705c8fa11364$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $469b705c8fa11364$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $469b705c8fa11364$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $469b705c8fa11364$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $469b705c8fa11364$var$dedupeLinkDescriptors(links.flat(1).filter($469b705c8fa11364$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $469b705c8fa11364$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $469b705c8fa11364$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $469b705c8fa11364$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $469b705c8fa11364$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $469b705c8fa11364$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $469b705c8fa11364$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$469b705c8fa11364$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($469b705c8fa11364$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $469b705c8fa11364$var$_isPreloadSupported;
function $469b705c8fa11364$var$isPreloadSupported() {
    if ($469b705c8fa11364$var$_isPreloadSupported !== void 0) return $469b705c8fa11364$var$_isPreloadSupported;
    let el = document.createElement("link");
    $469b705c8fa11364$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $469b705c8fa11364$var$_isPreloadSupported;
}
function $469b705c8fa11364$var$RemixRootDefaultHydrateFallback() {
    let { nonce: nonce } = $469b705c8fa11364$var$useFrameworkContext();
    return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $469b705c8fa11364$export$945fecf35a8ef089 ? /* @__PURE__ */ $7fPBF.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $469b705c8fa11364$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $469b705c8fa11364$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $469b705c8fa11364$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $469b705c8fa11364$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$RemixRootDefaultErrorBoundary, {
            error: $469b705c8fa11364$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $7fPBF.createElement(routeModule.Layout, null, /* @__PURE__ */ $7fPBF.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $7fPBF.createElement(routeModule.Layout, null, /* @__PURE__ */ $7fPBF.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $7fPBF.createElement(routeModule.Layout, null, /* @__PURE__ */ $7fPBF.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $469b705c8fa11364$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $469b705c8fa11364$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $469b705c8fa11364$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$469b705c8fa11364$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $469b705c8fa11364$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $469b705c8fa11364$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $469b705c8fa11364$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $469b705c8fa11364$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $469b705c8fa11364$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $469b705c8fa11364$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $469b705c8fa11364$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $469b705c8fa11364$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $469b705c8fa11364$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $469b705c8fa11364$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $469b705c8fa11364$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $469b705c8fa11364$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $469b705c8fa11364$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$469b705c8fa11364$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $469b705c8fa11364$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                let result = await prefetchStylesAndCallHandler(async ()=>{
                    $469b705c8fa11364$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $469b705c8fa11364$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
                return result;
            };
            dataRoute.loader.hydrate = $469b705c8fa11364$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $469b705c8fa11364$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $469b705c8fa11364$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $469b705c8fa11364$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $469b705c8fa11364$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $469b705c8fa11364$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $469b705c8fa11364$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $469b705c8fa11364$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $469b705c8fa11364$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $469b705c8fa11364$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $469b705c8fa11364$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $469b705c8fa11364$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $469b705c8fa11364$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $469b705c8fa11364$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $469b705c8fa11364$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $469b705c8fa11364$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $469b705c8fa11364$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $469b705c8fa11364$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $469b705c8fa11364$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $469b705c8fa11364$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $469b705c8fa11364$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $469b705c8fa11364$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $469b705c8fa11364$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $469b705c8fa11364$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $469b705c8fa11364$var$nextPaths = /* @__PURE__ */ new Set();
var $469b705c8fa11364$var$discoveredPathsMaxSize = 1e3;
var $469b705c8fa11364$var$discoveredPaths = /* @__PURE__ */ new Set();
var $469b705c8fa11364$export$b5915cf27fa06b9f = 7680;
function $469b705c8fa11364$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $469b705c8fa11364$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $469b705c8fa11364$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $469b705c8fa11364$export$5c7b09132f833c25(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $469b705c8fa11364$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$469b705c8fa11364$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($469b705c8fa11364$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $469b705c8fa11364$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $469b705c8fa11364$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $469b705c8fa11364$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $7fPBF.useEffect(()=>{
        if (!$469b705c8fa11364$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$469b705c8fa11364$var$discoveredPaths.has(pathname)) $469b705c8fa11364$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($469b705c8fa11364$var$nextPaths.keys()).filter((path)=>{
                if ($469b705c8fa11364$var$discoveredPaths.has(path)) {
                    $469b705c8fa11364$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $469b705c8fa11364$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $469b705c8fa11364$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $469b705c8fa11364$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $469b705c8fa11364$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $469b705c8fa11364$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $469b705c8fa11364$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    paths = $469b705c8fa11364$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($469b705c8fa11364$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $469b705c8fa11364$export$b5915cf27fa06b9f) {
        $469b705c8fa11364$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($469b705c8fa11364$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($469b705c8fa11364$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($469b705c8fa11364$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$469b705c8fa11364$var$addToFifoQueue(p, $469b705c8fa11364$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $469b705c8fa11364$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $469b705c8fa11364$var$addToFifoQueue(path, queue) {
    if (queue.size >= $469b705c8fa11364$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $469b705c8fa11364$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $469b705c8fa11364$var$useDataRouterContext2() {
    let context = $7fPBF.useContext($469b705c8fa11364$export$2eeee58951ff3c1c);
    $469b705c8fa11364$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $469b705c8fa11364$var$useDataRouterStateContext() {
    let context = $7fPBF.useContext($469b705c8fa11364$export$315e3ffb01f217);
    $469b705c8fa11364$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $469b705c8fa11364$export$208d6a3bc3aa62bd = $7fPBF.createContext(void 0);
$469b705c8fa11364$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $469b705c8fa11364$var$useFrameworkContext() {
    let context = $7fPBF.useContext($469b705c8fa11364$export$208d6a3bc3aa62bd);
    $469b705c8fa11364$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $469b705c8fa11364$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $7fPBF.useContext($469b705c8fa11364$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $7fPBF.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $7fPBF.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $7fPBF.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $469b705c8fa11364$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $469b705c8fa11364$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $469b705c8fa11364$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $469b705c8fa11364$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $469b705c8fa11364$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $469b705c8fa11364$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $469b705c8fa11364$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$469b705c8fa11364$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $469b705c8fa11364$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $469b705c8fa11364$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $469b705c8fa11364$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $469b705c8fa11364$var$useDataRouterStateContext();
    let matches = $469b705c8fa11364$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $7fPBF.useMemo(()=>$469b705c8fa11364$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $7fPBF.createElement("style", {
        [$469b705c8fa11364$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $7fPBF.createElement("link", {
        [$469b705c8fa11364$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$469b705c8fa11364$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $7fPBF.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $469b705c8fa11364$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $469b705c8fa11364$var$useIsRSCRouterContext();
    let { nonce: contextNonce } = $469b705c8fa11364$var$useFrameworkContext();
    let { router: router } = $469b705c8fa11364$var$useDataRouterContext2();
    let matches = $7fPBF.useMemo(()=>$469b705c8fa11364$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $469b705c8fa11364$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $469b705c8fa11364$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $7fPBF.useState([]);
    $7fPBF.useEffect(()=>{
        let interrupted = false;
        $469b705c8fa11364$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $469b705c8fa11364$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $469b705c8fa11364$export$45d76561a5302f2b();
    let { future: future } = $469b705c8fa11364$var$useFrameworkContext();
    let { basename: basename } = $469b705c8fa11364$var$useDataRouterContext2();
    let dataHrefs = $7fPBF.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $469b705c8fa11364$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $7fPBF.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $469b705c8fa11364$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $469b705c8fa11364$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $469b705c8fa11364$var$useFrameworkContext();
    let { basename: basename } = $469b705c8fa11364$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $469b705c8fa11364$var$useDataRouterStateContext();
    let newMatchesForData = $7fPBF.useMemo(()=>$469b705c8fa11364$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $7fPBF.useMemo(()=>$469b705c8fa11364$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $7fPBF.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $469b705c8fa11364$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $7fPBF.useMemo(()=>$469b705c8fa11364$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $469b705c8fa11364$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $7fPBF.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $7fPBF.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $7fPBF.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $469b705c8fa11364$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $469b705c8fa11364$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $469b705c8fa11364$var$useDataRouterStateContext();
    let location = $469b705c8fa11364$export$45d76561a5302f2b();
    let _matches = $469b705c8fa11364$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$469b705c8fa11364$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $7fPBF.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $7fPBF.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $7fPBF.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $7fPBF.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $469b705c8fa11364$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $7fPBF.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $469b705c8fa11364$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $469b705c8fa11364$var$isHydrated = false;
function $469b705c8fa11364$export$3be068dde909e563() {
    $469b705c8fa11364$var$isHydrated = true;
}
function $469b705c8fa11364$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $469b705c8fa11364$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $469b705c8fa11364$var$useDataRouterContext2();
    let { matches: routerMatches } = $469b705c8fa11364$var$useDataRouterStateContext();
    let isRSCRouterContext = $469b705c8fa11364$var$useIsRSCRouterContext();
    let enableFogOfWar = $469b705c8fa11364$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $469b705c8fa11364$var$getActiveMatches(routerMatches, null, isSpaMode);
    $7fPBF.useEffect(()=>{
        $469b705c8fa11364$export$3be068dde909e563();
    }, []);
    let initialScripts = $7fPBF.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $469b705c8fa11364$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($469b705c8fa11364$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $7fPBF.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $469b705c8fa11364$var$isHydrated || isRSCRouterContext ? [] : [
        // Dedupe through a Set
        ...new Set(manifest.entry.imports.concat($469b705c8fa11364$var$getModuleLinkHrefs(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $469b705c8fa11364$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $469b705c8fa11364$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $7fPBF.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $7fPBF.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $7fPBF.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $7fPBF.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $469b705c8fa11364$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $469b705c8fa11364$export$32e57f52df4b6e34 = class extends $7fPBF.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $469b705c8fa11364$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = $469b705c8fa11364$var$useFrameworkContext();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $7fPBF.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($469b705c8fa11364$export$972111febbeef05b(error)) return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $7fPBF.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $469b705c8fa11364$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $7fPBF.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $7fPBF.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $469b705c8fa11364$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $469b705c8fa11364$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $7fPBF.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $7fPBF.createElement("head", null, /* @__PURE__ */ $7fPBF.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $7fPBF.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $7fPBF.createElement("title", null, title)), /* @__PURE__ */ $7fPBF.createElement("body", null, /* @__PURE__ */ $7fPBF.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$ff0bf87698939488, null) : null)));
}
var $469b705c8fa11364$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($469b705c8fa11364$var$isBrowser2) window.__reactRouterVersion = "7.18.4";
} catch (e) {}
function $469b705c8fa11364$export$1f3f55432a00e06d(routes, opts) {
    return $469b705c8fa11364$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $469b705c8fa11364$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $469b705c8fa11364$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $469b705c8fa11364$export$9269a41d8c4635e,
        hydrationRouteProperties: $469b705c8fa11364$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $469b705c8fa11364$export$1ba7ed8a3a7b3765(routes, opts) {
    return $469b705c8fa11364$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $469b705c8fa11364$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $469b705c8fa11364$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $469b705c8fa11364$export$9269a41d8c4635e,
        hydrationRouteProperties: $469b705c8fa11364$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $469b705c8fa11364$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $469b705c8fa11364$var$deserializeErrors(state.errors)
    };
    return state;
}
function $469b705c8fa11364$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $469b705c8fa11364$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (typeof val.__subType === "string" && $469b705c8fa11364$var$SUPPORTED_ERROR_TYPES.includes(val.__subType)) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $469b705c8fa11364$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = $469b705c8fa11364$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7fPBF.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7fPBF.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $469b705c8fa11364$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = $469b705c8fa11364$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7fPBF.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7fPBF.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $469b705c8fa11364$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7fPBF.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7fPBF.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$469b705c8fa11364$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $469b705c8fa11364$export$a6c7ac8248d6e38a = $7fPBF.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $469b705c8fa11364$var$ABSOLUTE_URL_REGEX.test(to);
    let parsed = $469b705c8fa11364$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $469b705c8fa11364$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $469b705c8fa11364$export$45d76561a5302f2b();
    let maskedHref = null;
    if (mask) {
        let resolved = $469b705c8fa11364$var$resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $469b705c8fa11364$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $469b705c8fa11364$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $469b705c8fa11364$export$67621102c14d847(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $7fPBF.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $469b705c8fa11364$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, link, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$469b705c8fa11364$export$a6c7ac8248d6e38a.displayName = "Link";
var $469b705c8fa11364$export$b0d92dbee9b5b60d = $7fPBF.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $469b705c8fa11364$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $469b705c8fa11364$export$45d76561a5302f2b();
    let routerState = $7fPBF.useContext($469b705c8fa11364$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $469b705c8fa11364$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $469b705c8fa11364$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$469b705c8fa11364$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $469b705c8fa11364$export$a7fed597f4b8afd8 = $7fPBF.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $469b705c8fa11364$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6);
    let submit = $469b705c8fa11364$export$47c85c6e3a081d3();
    let formAction = $469b705c8fa11364$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $469b705c8fa11364$var$ABSOLUTE_URL_REGEX.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $7fPBF.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $7fPBF.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$469b705c8fa11364$export$a7fed597f4b8afd8.displayName = "Form";
function $469b705c8fa11364$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $7fPBF.useContext($469b705c8fa11364$export$208d6a3bc3aa62bd);
    let { basename: basename } = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6);
    let location = $469b705c8fa11364$export$45d76561a5302f2b();
    let matches = $469b705c8fa11364$export$2378eb7f5ff86053();
    $469b705c8fa11364$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $7fPBF.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $469b705c8fa11364$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $7fPBF.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$469b705c8fa11364$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $469b705c8fa11364$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$469b705c8fa11364$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$469b705c8fa11364$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $469b705c8fa11364$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $469b705c8fa11364$var$useDataRouterContext3(hookName) {
    let ctx = $7fPBF.useContext($469b705c8fa11364$export$2eeee58951ff3c1c);
    $469b705c8fa11364$export$f5708dca728d7177(ctx, $469b705c8fa11364$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $469b705c8fa11364$var$useDataRouterState2(hookName) {
    let state = $7fPBF.useContext($469b705c8fa11364$export$315e3ffb01f217);
    $469b705c8fa11364$export$f5708dca728d7177(state, $469b705c8fa11364$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $469b705c8fa11364$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = $469b705c8fa11364$export$9770f232ac06a008();
    let location = $469b705c8fa11364$export$45d76561a5302f2b();
    let path = $469b705c8fa11364$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $7fPBF.useCallback((event)=>{
        if ($469b705c8fa11364$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $469b705c8fa11364$export$fe53371bee54353d(location) === $469b705c8fa11364$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $7fPBF.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function $469b705c8fa11364$export$f1a78c17382fe22a(defaultInit) {
    $469b705c8fa11364$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $7fPBF.useRef($469b705c8fa11364$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $7fPBF.useRef(false);
    let location = $469b705c8fa11364$export$45d76561a5302f2b();
    let searchParams = $7fPBF.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $469b705c8fa11364$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $469b705c8fa11364$export$9770f232ac06a008();
    let setSearchParams = $7fPBF.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $469b705c8fa11364$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $469b705c8fa11364$var$fetcherId = 0;
var $469b705c8fa11364$var$getUniqueFetcherId = ()=>`__${String(++$469b705c8fa11364$var$fetcherId)}__`;
function $469b705c8fa11364$export$47c85c6e3a081d3() {
    let { router: router } = $469b705c8fa11364$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6);
    let currentRouteId = $469b705c8fa11364$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $7fPBF.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $469b705c8fa11364$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $469b705c8fa11364$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                defaultShouldRevalidate: options.defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $469b705c8fa11364$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6);
    let routeContext = $7fPBF.useContext($469b705c8fa11364$export$aac280ed165a4397);
    $469b705c8fa11364$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$469b705c8fa11364$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $469b705c8fa11364$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $469b705c8fa11364$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $469b705c8fa11364$export$fe53371bee54353d(path);
}
function $469b705c8fa11364$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $469b705c8fa11364$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $469b705c8fa11364$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $7fPBF.useContext($469b705c8fa11364$export$cb3f1df1bef00a39);
    let route = $7fPBF.useContext($469b705c8fa11364$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $469b705c8fa11364$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $469b705c8fa11364$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $469b705c8fa11364$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $7fPBF.useId();
    let [fetcherKey, setFetcherKey] = $7fPBF.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $7fPBF.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $7fPBF.useCallback(async (href, opts)=>{
        $469b705c8fa11364$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $469b705c8fa11364$export$47c85c6e3a081d3();
    let submit = $7fPBF.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $7fPBF.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $7fPBF.useMemo(()=>{
        let FetcherForm2 = $7fPBF.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $469b705c8fa11364$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $7fPBF.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $469b705c8fa11364$export$fa996778a3a31087() {
    let state = $469b705c8fa11364$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $7fPBF.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
var $469b705c8fa11364$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $469b705c8fa11364$var$savedScrollPositions = {};
function $469b705c8fa11364$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $469b705c8fa11364$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $469b705c8fa11364$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $469b705c8fa11364$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $469b705c8fa11364$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6);
    let location = $469b705c8fa11364$export$45d76561a5302f2b();
    let matches = $469b705c8fa11364$export$2378eb7f5ff86053();
    let navigation = $469b705c8fa11364$export$d0fd4b7106de2769();
    $7fPBF.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $469b705c8fa11364$var$usePageHide($7fPBF.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $469b705c8fa11364$var$getScrollRestorationKey(location, matches, basename, getKey);
            $469b705c8fa11364$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $469b705c8fa11364$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($469b705c8fa11364$var$savedScrollPositions));
        } catch (error) {
            $469b705c8fa11364$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $7fPBF.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $469b705c8fa11364$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $469b705c8fa11364$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $7fPBF.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($469b705c8fa11364$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$469b705c8fa11364$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $7fPBF.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $469b705c8fa11364$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $469b705c8fa11364$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $469b705c8fa11364$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $469b705c8fa11364$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $469b705c8fa11364$export$b273b3273281a049(when);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $469b705c8fa11364$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $7fPBF.useContext($469b705c8fa11364$export$3681f408decb40d1);
    $469b705c8fa11364$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $469b705c8fa11364$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $469b705c8fa11364$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $469b705c8fa11364$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $469b705c8fa11364$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $469b705c8fa11364$export$81336c211d5ff295(path.pathname, nextPath) != null || $469b705c8fa11364$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $469b705c8fa11364$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $469b705c8fa11364$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    let staticNavigator = $469b705c8fa11364$var$getStatelessNavigator();
    return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function $469b705c8fa11364$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $469b705c8fa11364$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $469b705c8fa11364$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $469b705c8fa11364$var$serializeErrors(context.errors)
        };
        let json = $469b705c8fa11364$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $7fPBF.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $469b705c8fa11364$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($469b705c8fa11364$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $469b705c8fa11364$var$getStatelessNavigator() {
    return {
        createHref: $469b705c8fa11364$var$createHref,
        encodeLocation: $469b705c8fa11364$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $469b705c8fa11364$export$69163f0b72ec60d9(routes, opts) {
    return $469b705c8fa11364$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $469b705c8fa11364$export$9269a41d8c4635e
    });
}
function $469b705c8fa11364$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $469b705c8fa11364$export$87cb1a9238dc3fba(routes, $469b705c8fa11364$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                v8_passThroughRequests: false,
                v8_trailingSlashAwareDataRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $469b705c8fa11364$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $469b705c8fa11364$var$createHref,
        encodeLocation: $469b705c8fa11364$var$encodeLocation,
        getFetcher () {
            return $469b705c8fa11364$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $469b705c8fa11364$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $469b705c8fa11364$var$createHref(to) {
    return typeof to === "string" ? to : $469b705c8fa11364$export$fe53371bee54353d(to);
}
function $469b705c8fa11364$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $469b705c8fa11364$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $469b705c8fa11364$var$ABSOLUTE_URL_REGEX.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}

});

parcelRegister("fqXGH", function(module, exports) {

$parcel$export(module.exports, "store", function () { return $7392b318f6fb940f$export$6f57813fe9f31bf9; });
$parcel$export(module.exports, "persistor", function () { return $7392b318f6fb940f$export$7b682ac9934ca3e4; });

var $1SirA = parcelRequire("1SirA");
parcelRequire("64HYc");
var $9BbB1 = parcelRequire("9BbB1");
var $gpGPq = parcelRequire("gpGPq");

var $5t2s4 = parcelRequire("5t2s4");

var $5VgIe = parcelRequire("5VgIe");
const $7392b318f6fb940f$var$persistConfig = {
    key: "root",
    storage: $5t2s4.default
};
const $7392b318f6fb940f$var$persistedReducer = (0, $9BbB1.default)($7392b318f6fb940f$var$persistConfig, (0, $5VgIe.rootReducer));
// In development and test, immutability check enabled for the Redux reducers
const $7392b318f6fb940f$var$immutableCheckConfig = false;
const $7392b318f6fb940f$export$281a42ec42dc777b = (preloadedState)=>{
    return (0, $1SirA.configureStore)({
        reducer: $7392b318f6fb940f$var$persistedReducer,
        // for each of the default middleware items set to:
        //  - true to include with the default options
        //  - false to exclude
        //  - an object with specific options for the middleware
        //    see https://redux-toolkit.js.org/api/getDefaultMiddleware
        middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
                thunk: true,
                immutableCheck: $7392b318f6fb940f$var$immutableCheckConfig,
                serializableCheck: false
            }),
        devTools: false,
        preloadedState: preloadedState
    });
};
const $7392b318f6fb940f$export$6f57813fe9f31bf9 = $7392b318f6fb940f$export$281a42ec42dc777b();
const $7392b318f6fb940f$export$7b682ac9934ca3e4 = (0, $gpGPq.default)($7392b318f6fb940f$export$6f57813fe9f31bf9);

});
parcelRegister("1SirA", function(module, exports) {

$parcel$export(module.exports, "configureStore", function () { return $15d924278321bdfd$export$7d8a5b498da695ac; });
$parcel$export(module.exports, "createSlice", function () { return $15d924278321bdfd$export$4d8d9bd83c24ae8b; });

var $alMr3 = parcelRequire("alMr3");

var $aMwRj = parcelRequire("aMwRj");

var $b2vZA = parcelRequire("b2vZA");

var $dMpb7 = parcelRequire("dMpb7");
//#region src/createDraftSafeSelector.ts
const $15d924278321bdfd$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector = (0, $b2vZA.createSelectorCreator)(...args);
    const createDraftSafeSelector = Object.assign((...args)=>{
        const selector = createSelector(...args);
        const wrappedSelector = (value, ...rest)=>selector((0, $aMwRj.isDraft)(value) ? (0, $aMwRj.current)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector
    });
    return createDraftSafeSelector;
};
const $15d924278321bdfd$export$a5d3c27355e35910 = /* @__PURE__ */ $15d924278321bdfd$export$aab6de9e3dbb1473((0, $b2vZA.weakMapMemoize));
//#endregion
//#region src/devtoolsExtension.ts
const $15d924278321bdfd$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $alMr3.compose;
    return (0, $alMr3.compose).apply(null, arguments);
};
typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__;
//#endregion
//#region src/tsHelpers.ts
const $15d924278321bdfd$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/typeof.js
function $15d924278321bdfd$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $15d924278321bdfd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $15d924278321bdfd$var$_typeof(o);
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/toPrimitive.js
function $15d924278321bdfd$var$toPrimitive(t, r) {
    if ("object" != $15d924278321bdfd$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $15d924278321bdfd$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/toPropertyKey.js
function $15d924278321bdfd$var$toPropertyKey(t) {
    var i = $15d924278321bdfd$var$toPrimitive(t, "string");
    return "symbol" == $15d924278321bdfd$var$_typeof(i) ? i : i + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/defineProperty.js
function $15d924278321bdfd$var$_defineProperty(e, r, t) {
    return (r = $15d924278321bdfd$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/objectSpread2.js
function $15d924278321bdfd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $15d924278321bdfd$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $15d924278321bdfd$var$ownKeys(Object(t), !0).forEach(function(r) {
            $15d924278321bdfd$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $15d924278321bdfd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
//#endregion
//#region src/createAction.ts
function $15d924278321bdfd$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($15d924278321bdfd$export$378fa86b259c0280(0));
            return $15d924278321bdfd$var$_objectSpread2($15d924278321bdfd$var$_objectSpread2({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $alMr3.isAction)(action) && action.type === type;
    return actionCreator;
}
function $15d924278321bdfd$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $15d924278321bdfd$var$hasMatchFunction(action);
}
function $15d924278321bdfd$export$ebd532f9034651f3(action) {
    return (0, $alMr3.isAction)(action) && Object.keys(action).every($15d924278321bdfd$var$isValidKey);
}
function $15d924278321bdfd$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
//#endregion
//#region src/actionCreatorInvariantMiddleware.ts
function $15d924278321bdfd$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched.
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $15d924278321bdfd$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
//#endregion
//#region src/utils.ts
function $15d924278321bdfd$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                elapsed += Date.now() - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $15d924278321bdfd$export$1908877435b1d5e9 = class Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, Tuple.prototype);
    }
    static get [Symbol.species]() {
        return Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new Tuple(...arr[0].concat(this));
        return new Tuple(...arr.concat(this));
    }
};
function $15d924278321bdfd$var$freezeDraftable(val) {
    return (0, $aMwRj.isDraftable)(val) ? (0, $aMwRj.produce)(val, ()=>{}) : val;
}
function $15d924278321bdfd$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
//#endregion
//#region src/immutableStateInvariantMiddleware.ts
function $15d924278321bdfd$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $15d924278321bdfd$var$trackForMutations(isImmutable, ignoredPaths, obj) {
    const trackedProperties = $15d924278321bdfd$var$trackProperties(isImmutable, ignoredPaths, obj);
    return {
        detectMutations () {
            return $15d924278321bdfd$var$detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
        }
    };
}
function $15d924278321bdfd$var$trackProperties(isImmutable, ignoredPaths = [], obj, path = "", inProgress = /* @__PURE__ */ new Map()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj)) {
        const alreadyInProgress = inProgress.get(obj);
        if (alreadyInProgress) return alreadyInProgress;
        tracked.children = {};
        inProgress.set(obj, tracked);
        const hasIgnoredPaths = ignoredPaths.length > 0;
        for(const key in obj){
            const nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                if (ignoredPaths.some((ignored)=>{
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                })) continue;
            }
            tracked.children[key] = $15d924278321bdfd$var$trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath, inProgress);
        }
        inProgress.delete(obj);
    }
    return tracked;
}
function $15d924278321bdfd$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "", seen = /* @__PURE__ */ new Map()) {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    let seenValues = seen.get(trackedProperty);
    if (!seenValues) {
        seenValues = /* @__PURE__ */ new Set();
        seen.set(trackedProperty, seenValues);
    } else if (seenValues.has(obj)) return {
        wasMutated: false
    };
    seenValues.add(obj);
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            if (ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            })) continue;
        }
        const result = $15d924278321bdfd$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath, seen);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $15d924278321bdfd$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
//#endregion
//#region src/serializableStateInvariantMiddleware.ts
function $15d924278321bdfd$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $alMr3.isPlainObject)(val);
}
function $15d924278321bdfd$export$ada5dca0b571bc7(value, path = "", isSerializable = $15d924278321bdfd$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache === null || cache === void 0 ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            if (ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            })) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $15d924278321bdfd$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $15d924278321bdfd$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $15d924278321bdfd$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$15d924278321bdfd$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $15d924278321bdfd$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
//#endregion
//#region src/getDefaultMiddleware.ts
function $15d924278321bdfd$var$isBoolean(x) {
    return typeof x === "boolean";
}
const $15d924278321bdfd$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk$1 = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options !== null && options !== void 0 ? options : {};
        let middlewareArray = new $15d924278321bdfd$export$1908877435b1d5e9();
        if (thunk$1) {
            if ($15d924278321bdfd$var$isBoolean(thunk$1)) middlewareArray.push((0, $dMpb7.thunk));
            else middlewareArray.push((0, $dMpb7.withExtraArgument)(thunk$1.extraArgument));
        }
        return middlewareArray;
    };
//#endregion
//#region src/autoBatchEnhancer.ts
const $15d924278321bdfd$export$8fb31c0f05df007b = "RTK_autoBatch";
const $15d924278321bdfd$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$15d924278321bdfd$export$8fb31c0f05df007b]: true
            }
        });
const $15d924278321bdfd$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
const $15d924278321bdfd$var$createRafWithFallbackTimer = (raf, timeout)=>{
    return (notify)=>{
        let called = false;
        let rafId;
        let timerId;
        const callback = ()=>{
            if (called) return;
            called = true;
            cancelAnimationFrame(rafId);
            clearTimeout(timerId);
            notify();
        };
        rafId = raf(callback);
        timerId = setTimeout(callback, timeout);
    };
};
const $15d924278321bdfd$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? typeof window !== "undefined" && window.requestAnimationFrame ? $15d924278321bdfd$var$createRafWithFallbackTimer(window.requestAnimationFrame, 100) : $15d924278321bdfd$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $15d924278321bdfd$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                subscribe (listener) {
                    const wrappedListener = ()=>notifying && listener();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener);
                    };
                },
                dispatch (action) {
                    try {
                        var _action$meta;
                        notifying = !(action === null || action === void 0 || (_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : _action$meta[$15d924278321bdfd$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
//#endregion
//#region src/getDefaultEnhancers.ts
const $15d924278321bdfd$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options !== null && options !== void 0 ? options : {};
        let enhancerArray = new $15d924278321bdfd$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($15d924278321bdfd$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
//#endregion
//#region src/configureStore.ts
function $15d924278321bdfd$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $15d924278321bdfd$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $alMr3.isPlainObject)(reducer)) rootReducer = (0, $alMr3.combineReducers)(reducer);
    else throw new Error($15d924278321bdfd$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware1;
    let finalCompose = (0, $alMr3.compose);
    if (devTools) finalCompose = $15d924278321bdfd$var$composeWithDevTools($15d924278321bdfd$var$_objectSpread2({
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $alMr3.applyMiddleware)(...finalMiddleware);
    const getDefaultEnhancers = $15d924278321bdfd$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $alMr3.createStore)(rootReducer, preloadedState, composedEnhancer);
}
//#endregion
//#region src/mapBuilders.ts
function $15d924278321bdfd$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($15d924278321bdfd$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($15d924278321bdfd$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addAsyncThunk (asyncThunk, reducers) {
            if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
            if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
            if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
            if (reducers.settled) actionMatchers.push({
                matcher: asyncThunk.settled,
                reducer: reducers.settled
            });
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
//#endregion
//#region src/createReducer.ts
function $15d924278321bdfd$var$isStateFunction(x) {
    return typeof x === "function";
}
function $15d924278321bdfd$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $15d924278321bdfd$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($15d924278321bdfd$var$isStateFunction(initialState)) getInitialState = ()=>$15d924278321bdfd$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $15d924278321bdfd$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer })=>reducer)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $aMwRj.isDraft)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $aMwRj.isDraftable)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($15d924278321bdfd$export$378fa86b259c0280(9));
                    }
                    return result;
                } else return (0, $aMwRj.produce)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
//#endregion
//#region src/matchers.ts
const $15d924278321bdfd$var$matches = (matcher, action)=>{
    if ($15d924278321bdfd$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $15d924278321bdfd$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$15d924278321bdfd$var$matches(matcher, action));
    };
}
function $15d924278321bdfd$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$15d924278321bdfd$var$matches(matcher, action));
    };
}
function $15d924278321bdfd$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $15d924278321bdfd$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $15d924278321bdfd$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$15d924278321bdfd$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$15d924278321bdfd$var$isAsyncThunkArray(asyncThunks)) return $15d924278321bdfd$export$872dec21e9a69476()(asyncThunks[0]);
    return $15d924278321bdfd$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $15d924278321bdfd$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$15d924278321bdfd$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$15d924278321bdfd$var$isAsyncThunkArray(asyncThunks)) return $15d924278321bdfd$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $15d924278321bdfd$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $15d924278321bdfd$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $15d924278321bdfd$export$9dd1fb32974da385($15d924278321bdfd$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$15d924278321bdfd$var$isAsyncThunkArray(asyncThunks)) return $15d924278321bdfd$export$fcc3388fb56de601()(asyncThunks[0]);
    return $15d924278321bdfd$export$9dd1fb32974da385($15d924278321bdfd$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $15d924278321bdfd$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$15d924278321bdfd$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$15d924278321bdfd$var$isAsyncThunkArray(asyncThunks)) return $15d924278321bdfd$export$1da80a6ef1307441()(asyncThunks[0]);
    return $15d924278321bdfd$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $15d924278321bdfd$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$15d924278321bdfd$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$15d924278321bdfd$var$isAsyncThunkArray(asyncThunks)) return $15d924278321bdfd$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $15d924278321bdfd$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
//#endregion
//#region src/nanoid.ts
let $15d924278321bdfd$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
let $15d924278321bdfd$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $15d924278321bdfd$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
//#endregion
//#region src/createAsyncThunk.ts
const $15d924278321bdfd$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $15d924278321bdfd$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        $15d924278321bdfd$var$_defineProperty(this, "_type", void 0);
    }
};
var $15d924278321bdfd$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        $15d924278321bdfd$var$_defineProperty(this, "_type", void 0);
    }
};
const $15d924278321bdfd$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $15d924278321bdfd$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
const $15d924278321bdfd$var$externalAbortMessage = "External signal was aborted";
const $15d924278321bdfd$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk(typePrefix, payloadCreator, options) {
        const fulfilled = $15d924278321bdfd$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $15d924278321bdfd$var$_objectSpread2($15d924278321bdfd$var$_objectSpread2({}, meta || {}), {}, {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $15d924278321bdfd$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $15d924278321bdfd$var$_objectSpread2($15d924278321bdfd$var$_objectSpread2({}, meta || {}), {}, {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $15d924278321bdfd$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $15d924278321bdfd$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $15d924278321bdfd$var$_objectSpread2($15d924278321bdfd$var$_objectSpread2({}, meta || {}), {}, {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: payload !== void 0,
                    requestStatus: "rejected",
                    aborted: (error === null || error === void 0 ? void 0 : error.name) === "AbortError",
                    condition: (error === null || error === void 0 ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options === null || options === void 0 ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $15d924278321bdfd$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($15d924278321bdfd$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($15d924278321bdfd$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    let finalAction;
                    try {
                        var _options$condition, _options$getPendingMe;
                        let conditionResult = options === null || options === void 0 || (_options$condition = options.condition) === null || _options$condition === void 0 ? void 0 : _options$condition.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($15d924278321bdfd$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        if (abortController.signal.aborted) throw {
                            name: "AbortError",
                            message: abortReason || "Aborted"
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler, {
                                once: true
                            });
                        });
                        dispatch(pending(requestId, arg, options === null || options === void 0 || (_options$getPendingMe = options.getPendingMeta) === null || _options$getPendingMe === void 0 ? void 0 : _options$getPendingMe.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $15d924278321bdfd$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $15d924278321bdfd$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $15d924278321bdfd$var$RejectWithValue) throw result;
                                if (result instanceof $15d924278321bdfd$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $15d924278321bdfd$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    if (!(options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition)) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($15d924278321bdfd$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $15d924278321bdfd$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk.withTypes = ()=>createAsyncThunk;
    return createAsyncThunk;
})();
function $15d924278321bdfd$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $15d924278321bdfd$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/objectWithoutPropertiesLoose.js
function $15d924278321bdfd$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/objectWithoutProperties.js
function $15d924278321bdfd$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $15d924278321bdfd$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
//#endregion
//#region src/createSlice.ts
const $15d924278321bdfd$var$_excluded = [
    "reducerPath"
];
const $15d924278321bdfd$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
const $15d924278321bdfd$export$343355ed40c51c46 = {
    [$15d924278321bdfd$var$asyncThunkSymbol]: $15d924278321bdfd$export$6abd22dc03e5063f
};
let $15d924278321bdfd$export$23a094319a4b586 = /* @__PURE__ */ function(ReducerType) {
    ReducerType["reducer"] = "reducer";
    ReducerType["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType["asyncThunk"] = "asyncThunk";
    return ReducerType;
}({});
function $15d924278321bdfd$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $15d924278321bdfd$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _creators$asyncThunk;
    const cAT = creators === null || creators === void 0 || (_creators$asyncThunk = creators.asyncThunk) === null || _creators$asyncThunk === void 0 ? void 0 : _creators$asyncThunk[$15d924278321bdfd$var$asyncThunkSymbol];
    return function createSlice(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($15d924278321bdfd$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($15d924278321bdfd$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($15d924278321bdfd$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($15d924278321bdfd$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer;
                return contextMethods;
            },
            addMatcher (matcher, reducer) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer
                });
                return contextMethods;
            },
            exposeAction (name, actionCreator) {
                context.actionCreators[name] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name, reducer) {
                context.sliceCaseReducersByName[name] = reducer;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $15d924278321bdfd$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($15d924278321bdfd$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $15d924278321bdfd$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $15d924278321bdfd$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $15d924278321bdfd$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $15d924278321bdfd$var$_objectSpread2($15d924278321bdfd$var$_objectSpread2({}, extraReducers), context.sliceCaseReducersByType);
            return $15d924278321bdfd$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $15d924278321bdfd$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                return $15d924278321bdfd$var$getOrInsertComputed($15d924278321bdfd$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap()), selectState, ()=>{
                    var _options$selectors;
                    const map = {};
                    for (const [name, selector] of Object.entries((_options$selectors = options.selectors) !== null && _options$selectors !== void 0 ? _options$selectors : {}))map[name] = $15d924278321bdfd$var$wrapSelector(selector, selectState, ()=>$15d924278321bdfd$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $15d924278321bdfd$var$_objectSpread2($15d924278321bdfd$var$_objectSpread2({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {}, {
            injectInto (injectable, _ref = {}) {
                let { reducerPath: pathOpt } = _ref, config = $15d924278321bdfd$var$_objectWithoutProperties(_ref, $15d924278321bdfd$var$_excluded);
                const newReducerPath = pathOpt !== null && pathOpt !== void 0 ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $15d924278321bdfd$var$_objectSpread2($15d924278321bdfd$var$_objectSpread2({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $15d924278321bdfd$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
const $15d924278321bdfd$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $15d924278321bdfd$export$affdea4146de9cf5();
function $15d924278321bdfd$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $15d924278321bdfd$var$_objectSpread2({
            _reducerDefinitionType: "asyncThunk",
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer"
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare",
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $15d924278321bdfd$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$15d924278321bdfd$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($15d924278321bdfd$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $15d924278321bdfd$export$309c7a02b0b0bc62(type, prepareCallback) : $15d924278321bdfd$export$309c7a02b0b0bc62(type));
}
function $15d924278321bdfd$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk";
}
function $15d924278321bdfd$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare";
}
function $15d924278321bdfd$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($15d924278321bdfd$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $15d924278321bdfd$var$noop$1,
        pending: pending || $15d924278321bdfd$var$noop$1,
        rejected: rejected || $15d924278321bdfd$var$noop$1,
        settled: settled || $15d924278321bdfd$var$noop$1
    });
}
function $15d924278321bdfd$var$noop$1() {}
//#endregion
//#region src/entities/entity_state.ts
function $15d924278321bdfd$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $15d924278321bdfd$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($15d924278321bdfd$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
//#endregion
//#region src/entities/state_selectors.ts
function $15d924278321bdfd$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector = $15d924278321bdfd$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector(selectState, selectEntities);
        return {
            selectIds: createSelector(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector(selectState, selectAll),
            selectTotal: createSelector(selectState, selectTotal),
            selectById: createSelector(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
//#endregion
//#region src/entities/state_adapter.ts
const $15d924278321bdfd$var$isDraftTyped = (0, $aMwRj.isDraft);
function $15d924278321bdfd$var$createSingleArgumentStateOperator(mutator) {
    const operator = $15d924278321bdfd$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $15d924278321bdfd$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg) {
            return $15d924278321bdfd$export$ebd532f9034651f3(arg);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($15d924278321bdfd$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $aMwRj.produce)(state, runMutator);
    };
}
//#endregion
//#region src/entities/utils.ts
function $15d924278321bdfd$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $15d924278321bdfd$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $15d924278321bdfd$var$getCurrent(value) {
    return (0, $aMwRj.isDraft)(value) ? (0, $aMwRj.current)(value) : value;
}
function $15d924278321bdfd$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $15d924278321bdfd$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $15d924278321bdfd$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
//#endregion
//#region src/entities/unsorted_state_adapter.ts
function $15d924278321bdfd$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $15d924278321bdfd$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $15d924278321bdfd$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        setManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original = state.entities[update.id];
        if (original === void 0) return false;
        const updated = Object.assign({}, original, update.changes);
        const newKey = $15d924278321bdfd$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            if (update.id in state.entities) {
                var _updatesPerEntity$upd;
                updatesPerEntity[update.id] = {
                    id: update.id,
                    changes: $15d924278321bdfd$var$_objectSpread2($15d924278321bdfd$var$_objectSpread2({}, (_updatesPerEntity$upd = updatesPerEntity[update.id]) === null || _updatesPerEntity$upd === void 0 ? void 0 : _updatesPerEntity$upd.changes), update.changes)
                };
            }
        });
        updates = Object.values(updatesPerEntity);
        if (updates.length > 0) {
            if (updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0) state.ids = Object.values(state.entities).map((e)=>$15d924278321bdfd$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $15d924278321bdfd$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $15d924278321bdfd$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $15d924278321bdfd$var$createStateOperator(addOneMutably),
        addMany: $15d924278321bdfd$var$createStateOperator(addManyMutably),
        setOne: $15d924278321bdfd$var$createStateOperator(setOneMutably),
        setMany: $15d924278321bdfd$var$createStateOperator(setManyMutably),
        setAll: $15d924278321bdfd$var$createStateOperator(setAllMutably),
        updateOne: $15d924278321bdfd$var$createStateOperator(updateOneMutably),
        updateMany: $15d924278321bdfd$var$createStateOperator(updateManyMutably),
        upsertOne: $15d924278321bdfd$var$createStateOperator(upsertOneMutably),
        upsertMany: $15d924278321bdfd$var$createStateOperator(upsertManyMutably),
        removeOne: $15d924278321bdfd$var$createStateOperator(removeOneMutably),
        removeMany: $15d924278321bdfd$var$createStateOperator(removeManyMutably)
    };
}
//#endregion
//#region src/entities/sorted_state_adapter.ts
function $15d924278321bdfd$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        if (comparisonFunction(item, currentItem) >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $15d924278321bdfd$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $15d924278321bdfd$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $15d924278321bdfd$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $15d924278321bdfd$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds !== null && existingIds !== void 0 ? existingIds : $15d924278321bdfd$var$getCurrent(state.ids));
        const addedKeys = /* @__PURE__ */ new Set();
        const models = newEntities.filter((model)=>{
            const modelId = $15d924278321bdfd$var$selectIdValue(model, selectId);
            const notAdded = !addedKeys.has(modelId);
            if (notAdded) addedKeys.add(modelId);
            return !existingKeys.has(modelId) && notAdded;
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        let deduplicatedEntities = {};
        newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities){
                const entityId = selectId(item);
                deduplicatedEntities[entityId] = item;
                delete state.entities[entityId];
            }
            newEntities = $15d924278321bdfd$var$ensureEntitiesArray(deduplicatedEntities);
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        setManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        const updatesPerEntity = {};
        for (const update of updates)if (update.id in state.entities) {
            var _updatesPerEntity$upd;
            updatesPerEntity[update.id] = {
                id: update.id,
                changes: $15d924278321bdfd$var$_objectSpread2($15d924278321bdfd$var$_objectSpread2({}, (_updatesPerEntity$upd = updatesPerEntity[update.id]) === null || _updatesPerEntity$upd === void 0 ? void 0 : _updatesPerEntity$upd.changes), update.changes)
            };
        }
        for (const update of Object.values(updatesPerEntity)){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $15d924278321bdfd$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function mergeFunction(state, addedItems, appliedUpdates, replacedIds) {
        const currentEntities = $15d924278321bdfd$var$getCurrent(state.entities);
        const currentIds = $15d924278321bdfd$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $15d924278321bdfd$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $15d924278321bdfd$var$createStateOperator(addOneMutably),
        updateOne: $15d924278321bdfd$var$createStateOperator(updateOneMutably),
        upsertOne: $15d924278321bdfd$var$createStateOperator(upsertOneMutably),
        setOne: $15d924278321bdfd$var$createStateOperator(setOneMutably),
        setMany: $15d924278321bdfd$var$createStateOperator(setManyMutably),
        setAll: $15d924278321bdfd$var$createStateOperator(setAllMutably),
        addMany: $15d924278321bdfd$var$createStateOperator(addManyMutably),
        updateMany: $15d924278321bdfd$var$createStateOperator(updateManyMutably),
        upsertMany: $15d924278321bdfd$var$createStateOperator(upsertManyMutably)
    };
}
//#endregion
//#region src/entities/create_adapter.ts
function $15d924278321bdfd$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $15d924278321bdfd$var$_objectSpread2({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $15d924278321bdfd$var$createSortedStateAdapter(selectId, sortComparer) : $15d924278321bdfd$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $15d924278321bdfd$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $15d924278321bdfd$var$createSelectorsFactory();
    return $15d924278321bdfd$var$_objectSpread2($15d924278321bdfd$var$_objectSpread2($15d924278321bdfd$var$_objectSpread2({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
//#endregion
//#region src/listenerMiddleware/exceptions.ts
const $15d924278321bdfd$var$task = "task";
const $15d924278321bdfd$var$listener = "listener";
const $15d924278321bdfd$var$completed = "completed";
const $15d924278321bdfd$var$cancelled = "cancelled";
const $15d924278321bdfd$var$taskCancelled = `task-${$15d924278321bdfd$var$cancelled}`;
const $15d924278321bdfd$var$taskCompleted = `task-${$15d924278321bdfd$var$completed}`;
const $15d924278321bdfd$var$listenerCancelled = `${$15d924278321bdfd$var$listener}-${$15d924278321bdfd$var$cancelled}`;
const $15d924278321bdfd$var$listenerCompleted = `${$15d924278321bdfd$var$listener}-${$15d924278321bdfd$var$completed}`;
var $15d924278321bdfd$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $15d924278321bdfd$var$_defineProperty(this, "name", "TaskAbortError");
        $15d924278321bdfd$var$_defineProperty(this, "message", void 0);
        this.message = `${$15d924278321bdfd$var$task} ${$15d924278321bdfd$var$cancelled} (reason: ${code})`;
    }
};
//#endregion
//#region src/listenerMiddleware/utils.ts
const $15d924278321bdfd$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($15d924278321bdfd$export$378fa86b259c0280(32));
};
const $15d924278321bdfd$var$noop = ()=>{};
const $15d924278321bdfd$var$catchRejection = (promise, onError = $15d924278321bdfd$var$noop)=>{
    promise.catch(onError);
    return promise;
};
const $15d924278321bdfd$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
//#endregion
//#region src/listenerMiddleware/task.ts
const $15d924278321bdfd$var$validateActive = (signal)=>{
    if (signal.aborted) throw new $15d924278321bdfd$export$cb1bdac908fed7f(signal.reason);
};
function $15d924278321bdfd$var$raceWithSignal(signal, promise) {
    let cleanup = $15d924278321bdfd$var$noop;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $15d924278321bdfd$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $15d924278321bdfd$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $15d924278321bdfd$var$noop;
    });
}
const $15d924278321bdfd$var$runTask = async (task, cleanUp)=>{
    try {
        await Promise.resolve();
        return {
            status: "ok",
            value: await task()
        };
    } catch (error) {
        return {
            status: error instanceof $15d924278321bdfd$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp === null || cleanUp === void 0 || cleanUp();
    }
};
const $15d924278321bdfd$var$createPause = (signal)=>{
    return (promise)=>{
        return $15d924278321bdfd$var$catchRejection($15d924278321bdfd$var$raceWithSignal(signal, promise).then((output)=>{
            $15d924278321bdfd$var$validateActive(signal);
            return output;
        }));
    };
};
const $15d924278321bdfd$var$createDelay = (signal)=>{
    const pause = $15d924278321bdfd$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
//#endregion
//#region src/listenerMiddleware/index.ts
const { assign: $15d924278321bdfd$var$assign } = Object;
const $15d924278321bdfd$var$INTERNAL_NIL_TOKEN = {};
const $15d924278321bdfd$var$alm = "listenerMiddleware";
const $15d924278321bdfd$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$15d924278321bdfd$var$addAbortSignalListener(parentAbortSignal, ()=>controller.abort(parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $15d924278321bdfd$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $15d924278321bdfd$var$runTask(async ()=>{
            $15d924278321bdfd$var$validateActive(parentAbortSignal);
            $15d924278321bdfd$var$validateActive(childAbortController.signal);
            const result = await taskExecutor({
                pause: $15d924278321bdfd$var$createPause(childAbortController.signal),
                delay: $15d924278321bdfd$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $15d924278321bdfd$var$validateActive(childAbortController.signal);
            return result;
        }, ()=>childAbortController.abort($15d924278321bdfd$var$taskCompleted));
        if (opts === null || opts === void 0 ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($15d924278321bdfd$var$noop));
        return {
            result: $15d924278321bdfd$var$createPause(parentAbortSignal)(result),
            cancel () {
                childAbortController.abort($15d924278321bdfd$var$taskCancelled);
            }
        };
    };
};
const $15d924278321bdfd$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $15d924278321bdfd$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const promises = [
            new Promise((resolve, reject)=>{
                let stopListening = startListening({
                    predicate: predicate,
                    effect: (action, listenerApi)=>{
                        listenerApi.unsubscribe();
                        resolve([
                            action,
                            listenerApi.getState(),
                            listenerApi.getOriginalState()
                        ]);
                    }
                });
                unsubscribe = ()=>{
                    stopListening();
                    reject();
                };
            })
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $15d924278321bdfd$var$raceWithSignal(signal, Promise.race(promises));
            $15d924278321bdfd$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$15d924278321bdfd$var$catchRejection(take(predicate, timeout));
};
const $15d924278321bdfd$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $15d924278321bdfd$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($15d924278321bdfd$export$378fa86b259c0280(21));
    $15d924278321bdfd$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
const $15d924278321bdfd$var$createListenerEntry = /* @__PURE__ */ $15d924278321bdfd$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $15d924278321bdfd$var$getListenerEntryPropsFrom(options);
    return {
        id: $15d924278321bdfd$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($15d924278321bdfd$export$378fa86b259c0280(22));
        }
    };
}, {
    withTypes: ()=>$15d924278321bdfd$var$createListenerEntry
});
const $15d924278321bdfd$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $15d924278321bdfd$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        return (typeof type === "string" ? entry.type === type : entry.predicate === predicate) && entry.effect === effect;
    });
};
const $15d924278321bdfd$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        controller.abort($15d924278321bdfd$var$listenerCancelled);
    });
};
const $15d924278321bdfd$var$createClearListenerMiddleware = (listenerMap, executingListeners)=>{
    return ()=>{
        for (const listener of executingListeners.keys())$15d924278321bdfd$var$cancelActiveListeners(listener);
        listenerMap.clear();
    };
};
const $15d924278321bdfd$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
const $15d924278321bdfd$export$f03a6b845d3fb58b = /* @__PURE__ */ $15d924278321bdfd$var$assign(/* @__PURE__ */ $15d924278321bdfd$export$309c7a02b0b0bc62(`${$15d924278321bdfd$var$alm}/add`), {
    withTypes: ()=>$15d924278321bdfd$export$f03a6b845d3fb58b
});
const $15d924278321bdfd$export$b1b8022855fb2b71 = /* @__PURE__ */ $15d924278321bdfd$export$309c7a02b0b0bc62(`${$15d924278321bdfd$var$alm}/removeAll`);
const $15d924278321bdfd$export$b03e9483f936dccb = /* @__PURE__ */ $15d924278321bdfd$var$assign(/* @__PURE__ */ $15d924278321bdfd$export$309c7a02b0b0bc62(`${$15d924278321bdfd$var$alm}/remove`), {
    withTypes: ()=>$15d924278321bdfd$export$b03e9483f936dccb
});
const $15d924278321bdfd$var$defaultErrorHandler = (...args)=>{
    console.error(`${$15d924278321bdfd$var$alm}/error`, ...args);
};
const $15d924278321bdfd$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const executingListeners = /* @__PURE__ */ new Map();
    const trackExecutingListener = (entry)=>{
        var _executingListeners$g;
        const count = (_executingListeners$g = executingListeners.get(entry)) !== null && _executingListeners$g !== void 0 ? _executingListeners$g : 0;
        executingListeners.set(entry, count + 1);
    };
    const untrackExecutingListener = (entry)=>{
        var _executingListeners$g2;
        const count = (_executingListeners$g2 = executingListeners.get(entry)) !== null && _executingListeners$g2 !== void 0 ? _executingListeners$g2 : 1;
        if (count === 1) executingListeners.delete(entry);
        else executingListeners.set(entry, count - 1);
    };
    const { extra: extra, onError: onError = $15d924278321bdfd$var$defaultErrorHandler } = middlewareOptions;
    $15d924278321bdfd$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions === null || cancelOptions === void 0 ? void 0 : cancelOptions.cancelActive) $15d924278321bdfd$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _findListenerEntry;
        const entry = (_findListenerEntry = $15d924278321bdfd$var$findListenerEntry(listenerMap, options)) !== null && _findListenerEntry !== void 0 ? _findListenerEntry : $15d924278321bdfd$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $15d924278321bdfd$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $15d924278321bdfd$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $15d924278321bdfd$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $15d924278321bdfd$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $15d924278321bdfd$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            trackExecutingListener(entry);
            await Promise.resolve(entry.effect(action, $15d924278321bdfd$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $15d924278321bdfd$var$createDelay(internalTaskController.signal),
                pause: $15d924278321bdfd$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $15d924278321bdfd$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            controller.abort($15d924278321bdfd$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    internalTaskController.abort($15d924278321bdfd$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $15d924278321bdfd$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $15d924278321bdfd$export$cb1bdac908fed7f)) $15d924278321bdfd$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            internalTaskController.abort($15d924278321bdfd$var$listenerCompleted);
            untrackExecutingListener(entry);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $15d924278321bdfd$var$createClearListenerMiddleware(listenerMap, executingListeners);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $alMr3.isAction)(action)) return next(action);
                if ($15d924278321bdfd$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($15d924278321bdfd$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($15d924278321bdfd$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $15d924278321bdfd$var$INTERNAL_NIL_TOKEN) throw new Error($15d924278321bdfd$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $15d924278321bdfd$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $15d924278321bdfd$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
//#endregion
//#region src/dynamicMiddleware/index.ts
const $15d924278321bdfd$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
const $15d924278321bdfd$var$matchInstance = (instanceId)=>(action)=>{
        var _action$meta;
        return (action === null || action === void 0 || (_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : _action$meta.instanceId) === instanceId;
    };
const $15d924278321bdfd$export$4bb1606a79445586 = ()=>{
    const instanceId = $15d924278321bdfd$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    let middlewareVersion = 0;
    const withMiddleware = Object.assign($15d924278321bdfd$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware(...middlewares) {
        const previousSize = middlewareMap.size;
        middlewares.forEach((middleware)=>{
            $15d924278321bdfd$var$getOrInsertComputed(middlewareMap, middleware, $15d924278321bdfd$var$createMiddlewareEntry);
        });
        if (middlewareMap.size !== previousSize) middlewareVersion++;
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$15d924278321bdfd$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $alMr3.compose)(...appliedMiddleware);
    };
    const isWithMiddleware = $15d924278321bdfd$export$9dd1fb32974da385(withMiddleware, $15d924278321bdfd$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>{
            let appliedVersion = -1;
            let dispatch = next;
            return (action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                if (appliedVersion !== middlewareVersion) {
                    dispatch = getFinalMiddleware(api)(next);
                    appliedVersion = middlewareVersion;
                }
                return dispatch(action);
            };
        };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
//#endregion
//#region src/combineSlices.ts
const $15d924278321bdfd$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
const $15d924278321bdfd$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$15d924278321bdfd$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
const $15d924278321bdfd$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
const $15d924278321bdfd$var$isStateProxy = (value)=>!!value && !!value[$15d924278321bdfd$var$ORIGINAL_STATE];
const $15d924278321bdfd$var$createStateProxy = (stateProxyMap, state, reducerMap, initialStateCache)=>$15d924278321bdfd$var$getOrInsertComputed(stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $15d924278321bdfd$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $15d924278321bdfd$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($15d924278321bdfd$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
const $15d924278321bdfd$var$original$1 = (state)=>{
    if (!$15d924278321bdfd$var$isStateProxy(state)) throw new Error($15d924278321bdfd$export$378fa86b259c0280(25));
    return state[$15d924278321bdfd$var$ORIGINAL_STATE];
};
const $15d924278321bdfd$var$emptyObject = {};
const $15d924278321bdfd$var$noopReducer = (state = $15d924278321bdfd$var$emptyObject)=>state;
function $15d924278321bdfd$export$a3734c7614660b9(...slices) {
    const stateProxyMap = /* @__PURE__ */ new WeakMap();
    const reducerMap = Object.fromEntries($15d924278321bdfd$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $alMr3.combineReducers)(reducerMap) : $15d924278321bdfd$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector(state, ...args) {
            return selectorFn($15d924278321bdfd$var$createStateProxy(stateProxyMap, selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $15d924278321bdfd$var$original$1
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
//#endregion
//#region src/formatProdErrorMessage.ts
function $15d924278321bdfd$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

});
parcelRegister("alMr3", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $78916fc80cd27125$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "createStore", function () { return $78916fc80cd27125$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "combineReducers", function () { return $78916fc80cd27125$export$66e4520cdb265d18; });
$parcel$export(module.exports, "bindActionCreators", function () { return $78916fc80cd27125$export$aea084d96e84da92; });
$parcel$export(module.exports, "compose", function () { return $78916fc80cd27125$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "applyMiddleware", function () { return $78916fc80cd27125$export$9ff26e0402cc7b7; });
$parcel$export(module.exports, "isAction", function () { return $78916fc80cd27125$export$b956e38827fca970; });
// src/utils/formatProdErrorMessage.ts
function $78916fc80cd27125$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $78916fc80cd27125$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $78916fc80cd27125$var$symbol_observable_default = $78916fc80cd27125$var$$$observable;
// src/utils/actionTypes.ts
var $78916fc80cd27125$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $78916fc80cd27125$var$ActionTypes = {
    INIT: `@@redux/INIT${$78916fc80cd27125$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$78916fc80cd27125$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$78916fc80cd27125$var$randomString()}`
};
var $78916fc80cd27125$export$4219e499db7ca678 = $78916fc80cd27125$var$ActionTypes;
// src/utils/isPlainObject.ts
function $78916fc80cd27125$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $78916fc80cd27125$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($78916fc80cd27125$var$isDate(val)) return "date";
    if ($78916fc80cd27125$var$isError(val)) return "error";
    const constructorName = $78916fc80cd27125$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $78916fc80cd27125$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $78916fc80cd27125$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $78916fc80cd27125$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $78916fc80cd27125$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $78916fc80cd27125$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(1));
        return enhancer($78916fc80cd27125$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$78916fc80cd27125$export$53b83ca8eaab0383(action)) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $78916fc80cd27125$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$78916fc80cd27125$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $78916fc80cd27125$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$78916fc80cd27125$var$symbol_observable_default]: observable
    };
    return store;
}
function $78916fc80cd27125$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $78916fc80cd27125$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $78916fc80cd27125$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $78916fc80cd27125$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $78916fc80cd27125$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$78916fc80cd27125$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$78916fc80cd27125$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $78916fc80cd27125$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $78916fc80cd27125$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $78916fc80cd27125$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $78916fc80cd27125$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(13));
    });
}
function $78916fc80cd27125$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $78916fc80cd27125$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($78916fc80cd27125$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $78916fc80cd27125$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $78916fc80cd27125$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $78916fc80cd27125$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $78916fc80cd27125$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $78916fc80cd27125$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $78916fc80cd27125$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($78916fc80cd27125$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $78916fc80cd27125$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $78916fc80cd27125$export$b956e38827fca970(action) {
    return $78916fc80cd27125$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}

});

parcelRegister("aMwRj", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return $7d97e02cb028d0b8$export$541ac630993a4c84; });
$parcel$export(module.exports, "isDraftable", function () { return $7d97e02cb028d0b8$export$16e3aed3edb85946; });
$parcel$export(module.exports, "current", function () { return $7d97e02cb028d0b8$export$97aac956da55dae9; });
$parcel$export(module.exports, "produce", function () { return $7d97e02cb028d0b8$export$b46cabe22e78bc00; });
var $7d97e02cb028d0b8$var$__defProp = Object.defineProperty;
var $7d97e02cb028d0b8$var$__defProps = Object.defineProperties;
var $7d97e02cb028d0b8$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $7d97e02cb028d0b8$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7d97e02cb028d0b8$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7d97e02cb028d0b8$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7d97e02cb028d0b8$var$__defNormalProp = (obj, key, value)=>key in obj ? $7d97e02cb028d0b8$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7d97e02cb028d0b8$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($7d97e02cb028d0b8$var$__hasOwnProp.call(b, prop)) $7d97e02cb028d0b8$var$__defNormalProp(a, prop, b[prop]);
    if ($7d97e02cb028d0b8$var$__getOwnPropSymbols) {
        for (var prop of $7d97e02cb028d0b8$var$__getOwnPropSymbols(b))if ($7d97e02cb028d0b8$var$__propIsEnum.call(b, prop)) $7d97e02cb028d0b8$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $7d97e02cb028d0b8$var$__spreadProps = (a, b)=>$7d97e02cb028d0b8$var$__defProps(a, $7d97e02cb028d0b8$var$__getOwnPropDescs(b));
// src/utils/env.ts
var $7d97e02cb028d0b8$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $7d97e02cb028d0b8$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $7d97e02cb028d0b8$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $7d97e02cb028d0b8$var$errors = [];
function $7d97e02cb028d0b8$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $7d97e02cb028d0b8$var$O = Object;
var $7d97e02cb028d0b8$var$getPrototypeOf = $7d97e02cb028d0b8$var$O.getPrototypeOf;
var $7d97e02cb028d0b8$var$CONSTRUCTOR = "constructor";
var $7d97e02cb028d0b8$var$PROTOTYPE = "prototype";
var $7d97e02cb028d0b8$var$CONFIGURABLE = "configurable";
var $7d97e02cb028d0b8$var$ENUMERABLE = "enumerable";
var $7d97e02cb028d0b8$var$WRITABLE = "writable";
var $7d97e02cb028d0b8$var$VALUE = "value";
var $7d97e02cb028d0b8$export$541ac630993a4c84 = (value)=>!!value && !!value[$7d97e02cb028d0b8$var$DRAFT_STATE];
function $7d97e02cb028d0b8$export$f9ded33a1a6c97c7(value) {
    if (!$7d97e02cb028d0b8$export$541ac630993a4c84(value)) return false;
    return value[$7d97e02cb028d0b8$var$DRAFT_STATE].modified_;
}
function $7d97e02cb028d0b8$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $7d97e02cb028d0b8$var$isPlainObject(value) || $7d97e02cb028d0b8$var$isArray(value) || !!value[$7d97e02cb028d0b8$export$6ee2082928bcb0ee] || !!((_a = value[$7d97e02cb028d0b8$var$CONSTRUCTOR]) == null ? void 0 : _a[$7d97e02cb028d0b8$export$6ee2082928bcb0ee]) || $7d97e02cb028d0b8$var$isMap(value) || $7d97e02cb028d0b8$var$isSet(value);
}
var $7d97e02cb028d0b8$var$objectCtorString = $7d97e02cb028d0b8$var$O[$7d97e02cb028d0b8$var$PROTOTYPE][$7d97e02cb028d0b8$var$CONSTRUCTOR].toString();
var $7d97e02cb028d0b8$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $7d97e02cb028d0b8$var$isPlainObject(value) {
    if (!value || !$7d97e02cb028d0b8$var$isObjectish(value)) return false;
    const proto = $7d97e02cb028d0b8$var$getPrototypeOf(value);
    if (proto === null || proto === $7d97e02cb028d0b8$var$O[$7d97e02cb028d0b8$var$PROTOTYPE]) return true;
    const Ctor = $7d97e02cb028d0b8$var$O.hasOwnProperty.call(proto, $7d97e02cb028d0b8$var$CONSTRUCTOR) && proto[$7d97e02cb028d0b8$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$7d97e02cb028d0b8$var$isFunction(Ctor)) return false;
    let ctorString = $7d97e02cb028d0b8$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $7d97e02cb028d0b8$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $7d97e02cb028d0b8$var$objectCtorString;
}
function $7d97e02cb028d0b8$export$22e8af3f75a010e3(value) {
    if (!$7d97e02cb028d0b8$export$541ac630993a4c84(value)) $7d97e02cb028d0b8$var$die(15, value);
    return value[$7d97e02cb028d0b8$var$DRAFT_STATE].base_;
}
function $7d97e02cb028d0b8$var$each(obj, iter, strict = true) {
    if ($7d97e02cb028d0b8$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $7d97e02cb028d0b8$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $7d97e02cb028d0b8$var$getArchtype(thing) {
    const state = thing[$7d97e02cb028d0b8$var$DRAFT_STATE];
    return state ? state.type_ : $7d97e02cb028d0b8$var$isArray(thing) ? 1 /* Array */  : $7d97e02cb028d0b8$var$isMap(thing) ? 2 /* Map */  : $7d97e02cb028d0b8$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $7d97e02cb028d0b8$var$has = (thing, prop, type = $7d97e02cb028d0b8$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $7d97e02cb028d0b8$var$O[$7d97e02cb028d0b8$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $7d97e02cb028d0b8$var$get = (thing, prop, type = $7d97e02cb028d0b8$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $7d97e02cb028d0b8$var$set = (thing, propOrOldValue, value, type = $7d97e02cb028d0b8$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $7d97e02cb028d0b8$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $7d97e02cb028d0b8$var$isArray = Array.isArray;
var $7d97e02cb028d0b8$var$isMap = (target)=>target instanceof Map;
var $7d97e02cb028d0b8$var$isSet = (target)=>target instanceof Set;
var $7d97e02cb028d0b8$var$isObjectish = (target)=>typeof target === "object";
var $7d97e02cb028d0b8$var$isFunction = (target)=>typeof target === "function";
var $7d97e02cb028d0b8$var$isBoolean = (target)=>typeof target === "boolean";
function $7d97e02cb028d0b8$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $7d97e02cb028d0b8$var$getProxyDraft = (value)=>{
    if (!$7d97e02cb028d0b8$var$isObjectish(value)) return null;
    return value == null ? void 0 : value[$7d97e02cb028d0b8$var$DRAFT_STATE];
};
var $7d97e02cb028d0b8$var$latest = (state)=>state.copy_ || state.base_;
var $7d97e02cb028d0b8$var$getValue = (value)=>{
    const proxyDraft = $7d97e02cb028d0b8$var$getProxyDraft(value);
    return proxyDraft ? $7d97e02cb028d0b8$var$getFinalValue(proxyDraft) : value;
};
var $7d97e02cb028d0b8$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $7d97e02cb028d0b8$var$shallowCopy(base, strict) {
    if ($7d97e02cb028d0b8$var$isMap(base)) return new Map(base);
    if ($7d97e02cb028d0b8$var$isSet(base)) return new Set(base);
    if ($7d97e02cb028d0b8$var$isArray(base)) return Array[$7d97e02cb028d0b8$var$PROTOTYPE].slice.call(base);
    const isPlain = $7d97e02cb028d0b8$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $7d97e02cb028d0b8$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$7d97e02cb028d0b8$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$7d97e02cb028d0b8$var$WRITABLE] === false) {
                desc[$7d97e02cb028d0b8$var$WRITABLE] = true;
                desc[$7d97e02cb028d0b8$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$7d97e02cb028d0b8$var$CONFIGURABLE]: true,
                [$7d97e02cb028d0b8$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$7d97e02cb028d0b8$var$ENUMERABLE]: desc[$7d97e02cb028d0b8$var$ENUMERABLE],
                [$7d97e02cb028d0b8$var$VALUE]: base[key]
            };
        }
        return $7d97e02cb028d0b8$var$O.create($7d97e02cb028d0b8$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $7d97e02cb028d0b8$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $7d97e02cb028d0b8$var$__spreadValues({}, base);
        const obj = $7d97e02cb028d0b8$var$O.create(proto);
        return $7d97e02cb028d0b8$var$O.assign(obj, base);
    }
}
function $7d97e02cb028d0b8$export$792f3d81ea979f55(obj, deep = false) {
    if ($7d97e02cb028d0b8$var$isFrozen(obj) || $7d97e02cb028d0b8$export$541ac630993a4c84(obj) || !$7d97e02cb028d0b8$export$16e3aed3edb85946(obj)) return obj;
    if ($7d97e02cb028d0b8$var$getArchtype(obj) > 1) $7d97e02cb028d0b8$var$O.defineProperties(obj, {
        set: $7d97e02cb028d0b8$var$dontMutateMethodOverride,
        add: $7d97e02cb028d0b8$var$dontMutateMethodOverride,
        clear: $7d97e02cb028d0b8$var$dontMutateMethodOverride,
        delete: $7d97e02cb028d0b8$var$dontMutateMethodOverride
    });
    $7d97e02cb028d0b8$var$O.freeze(obj);
    if (deep) $7d97e02cb028d0b8$var$each(obj, (_key, value)=>{
        $7d97e02cb028d0b8$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $7d97e02cb028d0b8$var$dontMutateFrozenCollections() {
    $7d97e02cb028d0b8$var$die(2);
}
var $7d97e02cb028d0b8$var$dontMutateMethodOverride = {
    [$7d97e02cb028d0b8$var$VALUE]: $7d97e02cb028d0b8$var$dontMutateFrozenCollections
};
function $7d97e02cb028d0b8$var$isFrozen(obj) {
    if (obj === null || !$7d97e02cb028d0b8$var$isObjectish(obj)) return true;
    return $7d97e02cb028d0b8$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $7d97e02cb028d0b8$var$PluginMapSet = "MapSet";
var $7d97e02cb028d0b8$var$PluginPatches = "Patches";
var $7d97e02cb028d0b8$var$PluginArrayMethods = "ArrayMethods";
var $7d97e02cb028d0b8$var$plugins = {};
function $7d97e02cb028d0b8$var$getPlugin(pluginKey) {
    const plugin = $7d97e02cb028d0b8$var$plugins[pluginKey];
    if (!plugin) $7d97e02cb028d0b8$var$die(0, pluginKey);
    return plugin;
}
var $7d97e02cb028d0b8$var$isPluginLoaded = (pluginKey)=>!!$7d97e02cb028d0b8$var$plugins[pluginKey];
function $7d97e02cb028d0b8$var$loadPlugin(pluginKey, implementation) {
    if (!$7d97e02cb028d0b8$var$plugins[pluginKey]) $7d97e02cb028d0b8$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $7d97e02cb028d0b8$var$currentScope;
var $7d97e02cb028d0b8$var$getCurrentScope = ()=>$7d97e02cb028d0b8$var$currentScope;
var $7d97e02cb028d0b8$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $7d97e02cb028d0b8$var$isPluginLoaded($7d97e02cb028d0b8$var$PluginMapSet) ? $7d97e02cb028d0b8$var$getPlugin($7d97e02cb028d0b8$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $7d97e02cb028d0b8$var$isPluginLoaded($7d97e02cb028d0b8$var$PluginArrayMethods) ? $7d97e02cb028d0b8$var$getPlugin($7d97e02cb028d0b8$var$PluginArrayMethods) : void 0
    });
function $7d97e02cb028d0b8$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $7d97e02cb028d0b8$var$getPlugin($7d97e02cb028d0b8$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $7d97e02cb028d0b8$var$revokeScope(scope) {
    $7d97e02cb028d0b8$var$leaveScope(scope);
    scope.drafts_.forEach($7d97e02cb028d0b8$var$revokeDraft);
    scope.drafts_ = null;
}
function $7d97e02cb028d0b8$var$leaveScope(scope) {
    if (scope === $7d97e02cb028d0b8$var$currentScope) $7d97e02cb028d0b8$var$currentScope = scope.parent_;
}
var $7d97e02cb028d0b8$var$enterScope = (immer2)=>$7d97e02cb028d0b8$var$currentScope = $7d97e02cb028d0b8$var$createScope($7d97e02cb028d0b8$var$currentScope, immer2);
function $7d97e02cb028d0b8$var$revokeDraft(draft) {
    const state = draft[$7d97e02cb028d0b8$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $7d97e02cb028d0b8$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$7d97e02cb028d0b8$var$DRAFT_STATE].modified_) {
            $7d97e02cb028d0b8$var$revokeScope(scope);
            $7d97e02cb028d0b8$var$die(4);
        }
        if ($7d97e02cb028d0b8$export$16e3aed3edb85946(result)) result = $7d97e02cb028d0b8$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$7d97e02cb028d0b8$var$DRAFT_STATE].base_, result, scope);
    } else result = $7d97e02cb028d0b8$var$finalize(scope, baseDraft);
    $7d97e02cb028d0b8$var$maybeFreeze(scope, result, true);
    $7d97e02cb028d0b8$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $7d97e02cb028d0b8$export$45b790e32b2810ee ? result : void 0;
}
function $7d97e02cb028d0b8$var$finalize(rootScope, value) {
    if ($7d97e02cb028d0b8$var$isFrozen(value)) return value;
    const state = value[$7d97e02cb028d0b8$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $7d97e02cb028d0b8$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$7d97e02cb028d0b8$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $7d97e02cb028d0b8$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $7d97e02cb028d0b8$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $7d97e02cb028d0b8$export$792f3d81ea979f55(value, deep);
}
function $7d97e02cb028d0b8$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $7d97e02cb028d0b8$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $7d97e02cb028d0b8$var$EMPTY_LOCATIONS_RESULT = [];
function $7d97e02cb028d0b8$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    var _a;
    const parentCopy = $7d97e02cb028d0b8$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $7d97e02cb028d0b8$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $7d97e02cb028d0b8$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $7d97e02cb028d0b8$var$each(parentCopy, (key, value)=>{
            if ($7d97e02cb028d0b8$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = (_a = parent.draftLocations_.get(draftValue)) != null ? _a : $7d97e02cb028d0b8$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$7d97e02cb028d0b8$var$set(parentCopy, location, finalizedValue, parentType);
}
function $7d97e02cb028d0b8$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        var _a, _b;
        const state = child;
        if (!state || !$7d97e02cb028d0b8$var$isSameScope(state, rootScope)) return;
        (_a = rootScope.mapSetPlugin_) == null || _a.fixSetContents(state);
        const finalizedValue = $7d97e02cb028d0b8$var$getFinalValue(state);
        $7d97e02cb028d0b8$var$updateDraftInParent(parent, (_b = state.draft_) != null ? _b : state, finalizedValue, key);
        $7d97e02cb028d0b8$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $7d97e02cb028d0b8$var$generatePatchesAndFinalize(state, rootScope) {
    var _a, _b;
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || ((_b = (_a = state.assigned_) == null ? void 0 : _a.size) != null ? _b : 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $7d97e02cb028d0b8$var$markStateFinalized(state);
    }
}
function $7d97e02cb028d0b8$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($7d97e02cb028d0b8$export$541ac630993a4c84(value)) {
        const state = value[$7d97e02cb028d0b8$var$DRAFT_STATE];
        if ($7d97e02cb028d0b8$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $7d97e02cb028d0b8$var$prepareCopy(target);
            const finalizedValue = $7d97e02cb028d0b8$var$getFinalValue(state);
            $7d97e02cb028d0b8$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($7d97e02cb028d0b8$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        var _a;
        const targetCopy = $7d97e02cb028d0b8$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $7d97e02cb028d0b8$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($7d97e02cb028d0b8$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && ((_a = target.assigned_.get(key)) != null ? _a : false) === true && target.copy_) $7d97e02cb028d0b8$var$handleValue($7d97e02cb028d0b8$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $7d97e02cb028d0b8$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($7d97e02cb028d0b8$export$541ac630993a4c84(target) || handledSet.has(target) || !$7d97e02cb028d0b8$export$16e3aed3edb85946(target) || $7d97e02cb028d0b8$var$isFrozen(target)) return target;
    handledSet.add(target);
    $7d97e02cb028d0b8$var$each(target, (key, value)=>{
        if ($7d97e02cb028d0b8$export$541ac630993a4c84(value)) {
            const state = value[$7d97e02cb028d0b8$var$DRAFT_STATE];
            if ($7d97e02cb028d0b8$var$isSameScope(state, rootScope)) {
                const updatedValue = $7d97e02cb028d0b8$var$getFinalValue(state);
                $7d97e02cb028d0b8$var$set(target, key, updatedValue, target.type_);
                $7d97e02cb028d0b8$var$markStateFinalized(state);
            }
        } else if ($7d97e02cb028d0b8$export$16e3aed3edb85946(value)) $7d97e02cb028d0b8$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $7d97e02cb028d0b8$var$createProxyProxy(base, parent) {
    const baseIsArray = $7d97e02cb028d0b8$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $7d97e02cb028d0b8$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $7d97e02cb028d0b8$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $7d97e02cb028d0b8$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $7d97e02cb028d0b8$var$objectTraps = {
    get (state, prop) {
        if (prop === $7d97e02cb028d0b8$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin == null ? void 0 : arrayPlugin.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $7d97e02cb028d0b8$var$latest(state);
        if (!$7d97e02cb028d0b8$var$has(source, prop, state.type_)) return $7d97e02cb028d0b8$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$7d97e02cb028d0b8$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && (arrayPlugin == null ? void 0 : arrayPlugin.isMutatingArrayMethod(state.operationMethod)) && $7d97e02cb028d0b8$var$isArrayIndex(prop)) return value;
        if (value === $7d97e02cb028d0b8$var$peek(state.base_, prop) || $7d97e02cb028d0b8$var$isRelocatedBaseRef(state, prop, value)) {
            $7d97e02cb028d0b8$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $7d97e02cb028d0b8$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $7d97e02cb028d0b8$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($7d97e02cb028d0b8$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $7d97e02cb028d0b8$var$getDescriptorFromProto($7d97e02cb028d0b8$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $7d97e02cb028d0b8$var$peek($7d97e02cb028d0b8$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$7d97e02cb028d0b8$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.delete(prop);
                return true;
            }
            if ($7d97e02cb028d0b8$var$is(value, current2) && (value !== void 0 || $7d97e02cb028d0b8$var$has(state.base_, prop, state.type_))) return true;
            $7d97e02cb028d0b8$var$prepareCopy(state);
            $7d97e02cb028d0b8$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || $7d97e02cb028d0b8$var$has(state.copy_, prop, state.type_)) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $7d97e02cb028d0b8$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $7d97e02cb028d0b8$var$prepareCopy(state);
        if ($7d97e02cb028d0b8$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $7d97e02cb028d0b8$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $7d97e02cb028d0b8$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$7d97e02cb028d0b8$var$WRITABLE]: true,
            [$7d97e02cb028d0b8$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$7d97e02cb028d0b8$var$ENUMERABLE]: desc[$7d97e02cb028d0b8$var$ENUMERABLE],
            [$7d97e02cb028d0b8$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $7d97e02cb028d0b8$var$die(11);
    },
    getPrototypeOf (state) {
        return $7d97e02cb028d0b8$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $7d97e02cb028d0b8$var$die(12);
    }
};
var $7d97e02cb028d0b8$var$arrayTraps = {};
for(let key in $7d97e02cb028d0b8$var$objectTraps){
    let fn = $7d97e02cb028d0b8$var$objectTraps[key];
    $7d97e02cb028d0b8$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$7d97e02cb028d0b8$var$arrayTraps.deleteProperty = function(state, prop) {
    return $7d97e02cb028d0b8$var$arrayTraps.set.call(this, state, prop, void 0);
};
$7d97e02cb028d0b8$var$arrayTraps.set = function(state, prop, value) {
    return $7d97e02cb028d0b8$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $7d97e02cb028d0b8$var$peek(draft, prop) {
    const state = draft[$7d97e02cb028d0b8$var$DRAFT_STATE];
    const source = state ? $7d97e02cb028d0b8$var$latest(state) : draft;
    return source[prop];
}
function $7d97e02cb028d0b8$var$isRelocatedBaseRef(state, prop, value) {
    if (state.type_ !== 1 /* Array */  || !state.allIndicesReassigned_ || !$7d97e02cb028d0b8$export$16e3aed3edb85946(value) || value[$7d97e02cb028d0b8$var$DRAFT_STATE]) return false;
    return state.baseRefs_.has(value);
}
function $7d97e02cb028d0b8$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $7d97e02cb028d0b8$var$getDescriptorFromProto(source, prop);
    return desc ? $7d97e02cb028d0b8$var$VALUE in desc ? desc[$7d97e02cb028d0b8$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $7d97e02cb028d0b8$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $7d97e02cb028d0b8$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $7d97e02cb028d0b8$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $7d97e02cb028d0b8$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $7d97e02cb028d0b8$var$markChanged(state.parent_);
    }
}
function $7d97e02cb028d0b8$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $7d97e02cb028d0b8$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $7d97e02cb028d0b8$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($7d97e02cb028d0b8$var$isFunction(base) && !$7d97e02cb028d0b8$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$7d97e02cb028d0b8$var$isFunction(recipe)) $7d97e02cb028d0b8$var$die(6);
            if (patchListener !== void 0 && !$7d97e02cb028d0b8$var$isFunction(patchListener)) $7d97e02cb028d0b8$var$die(7);
            let result;
            if ($7d97e02cb028d0b8$export$16e3aed3edb85946(base)) {
                const scope = $7d97e02cb028d0b8$var$enterScope(this);
                const proxy = $7d97e02cb028d0b8$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $7d97e02cb028d0b8$var$revokeScope(scope);
                    else $7d97e02cb028d0b8$var$leaveScope(scope);
                }
                $7d97e02cb028d0b8$var$usePatchesInScope(scope, patchListener);
                return $7d97e02cb028d0b8$var$processResult(result, scope);
            } else if (!base || !$7d97e02cb028d0b8$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $7d97e02cb028d0b8$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $7d97e02cb028d0b8$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $7d97e02cb028d0b8$var$getPlugin($7d97e02cb028d0b8$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $7d97e02cb028d0b8$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($7d97e02cb028d0b8$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($7d97e02cb028d0b8$var$isBoolean(config == null ? void 0 : config.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($7d97e02cb028d0b8$var$isBoolean(config == null ? void 0 : config.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($7d97e02cb028d0b8$var$isBoolean(config == null ? void 0 : config.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$7d97e02cb028d0b8$export$16e3aed3edb85946(base)) $7d97e02cb028d0b8$var$die(8);
        if ($7d97e02cb028d0b8$export$541ac630993a4c84(base)) base = $7d97e02cb028d0b8$export$97aac956da55dae9(base);
        const scope = $7d97e02cb028d0b8$var$enterScope(this);
        const proxy = $7d97e02cb028d0b8$var$createProxy(scope, base, void 0);
        proxy[$7d97e02cb028d0b8$var$DRAFT_STATE].isManual_ = true;
        $7d97e02cb028d0b8$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$7d97e02cb028d0b8$var$DRAFT_STATE];
        if (!state || !state.isManual_) $7d97e02cb028d0b8$var$die(9);
        const { scope_: scope } = state;
        $7d97e02cb028d0b8$var$usePatchesInScope(scope, patchListener);
        return $7d97e02cb028d0b8$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $7d97e02cb028d0b8$var$getPlugin($7d97e02cb028d0b8$var$PluginPatches).applyPatches_;
        if ($7d97e02cb028d0b8$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $7d97e02cb028d0b8$var$createProxy(rootScope, value, parent, key) {
    var _a, _b;
    const [draft, state] = $7d97e02cb028d0b8$var$isMap(value) ? $7d97e02cb028d0b8$var$getPlugin($7d97e02cb028d0b8$var$PluginMapSet).proxyMap_(value, parent) : $7d97e02cb028d0b8$var$isSet(value) ? $7d97e02cb028d0b8$var$getPlugin($7d97e02cb028d0b8$var$PluginMapSet).proxySet_(value, parent) : $7d97e02cb028d0b8$var$createProxyProxy(value, parent);
    const scope = (_a = parent == null ? void 0 : parent.scope_) != null ? _a : $7d97e02cb028d0b8$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = (_b = parent == null ? void 0 : parent.callbacks_) != null ? _b : [];
    state.key_ = key;
    if (parent && key !== void 0) $7d97e02cb028d0b8$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        var _a2;
        (_a2 = rootScope2.mapSetPlugin_) == null || _a2.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $7d97e02cb028d0b8$export$97aac956da55dae9(value) {
    if (!$7d97e02cb028d0b8$export$541ac630993a4c84(value)) $7d97e02cb028d0b8$var$die(10, value);
    return $7d97e02cb028d0b8$var$currentImpl(value);
}
function $7d97e02cb028d0b8$var$currentImpl(value) {
    if (!$7d97e02cb028d0b8$export$16e3aed3edb85946(value) || $7d97e02cb028d0b8$var$isFrozen(value)) return value;
    const state = value[$7d97e02cb028d0b8$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $7d97e02cb028d0b8$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $7d97e02cb028d0b8$var$shallowCopy(value, true);
    const source = copy;
    if ($7d97e02cb028d0b8$var$isSet(copy)) copy = /* @__PURE__ */ new Set();
    $7d97e02cb028d0b8$var$each(source, (key, childValue)=>{
        $7d97e02cb028d0b8$var$set(copy, key, $7d97e02cb028d0b8$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $7d97e02cb028d0b8$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        var _a;
        if (state.key_ !== void 0) {
            const parentCopy = (_a = state.parent_.copy_) != null ? _a : state.parent_.base_;
            const proxyDraft = $7d97e02cb028d0b8$var$getProxyDraft($7d97e02cb028d0b8$var$get(parentCopy, state.key_));
            const valueAtKey = $7d97e02cb028d0b8$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $7d97e02cb028d0b8$var$has(parentCopy, key))) return null;
            if (state.parent_.type_ === 1 /* Array */  && state.parent_.allIndicesReassigned_) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $7d97e02cb028d0b8$var$get(current2, key);
            if (!$7d97e02cb028d0b8$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || (assigned_ == null ? void 0 : assigned_.get(i.toString()));
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem == null ? void 0 : copiedItem[$7d97e02cb028d0b8$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $7d97e02cb028d0b8$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $7d97e02cb028d0b8$var$get(base_, key, type_);
            const value = $7d97e02cb028d0b8$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $7d97e02cb028d0b8$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $7d97e02cb028d0b8$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $7d97e02cb028d0b8$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $7d97e02cb028d0b8$var$CONSTRUCTOR)) $7d97e02cb028d0b8$var$die(errorOffset + 3);
                if ($7d97e02cb028d0b8$var$isFunction(base) && p === $7d97e02cb028d0b8$var$PROTOTYPE) $7d97e02cb028d0b8$var$die(errorOffset + 3);
                base = $7d97e02cb028d0b8$var$get(base, p);
                if (base === null || !$7d97e02cb028d0b8$var$isObjectish(base)) $7d97e02cb028d0b8$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $7d97e02cb028d0b8$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $7d97e02cb028d0b8$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $7d97e02cb028d0b8$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$7d97e02cb028d0b8$export$16e3aed3edb85946(obj)) return obj;
        if ($7d97e02cb028d0b8$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($7d97e02cb028d0b8$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($7d97e02cb028d0b8$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($7d97e02cb028d0b8$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($7d97e02cb028d0b8$var$has(obj, $7d97e02cb028d0b8$export$6ee2082928bcb0ee)) cloned[$7d97e02cb028d0b8$export$6ee2082928bcb0ee] = obj[$7d97e02cb028d0b8$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($7d97e02cb028d0b8$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $7d97e02cb028d0b8$var$loadPlugin($7d97e02cb028d0b8$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
var $7d97e02cb028d0b8$var$_globalIterator = globalThis.Iterator;
var $7d97e02cb028d0b8$var$hasIteratorFrom = typeof ($7d97e02cb028d0b8$var$_globalIterator == null ? void 0 : $7d97e02cb028d0b8$var$_globalIterator.from) === "function";
function $7d97e02cb028d0b8$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$7d97e02cb028d0b8$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $7d97e02cb028d0b8$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            return $7d97e02cb028d0b8$var$latest(state).size;
        }
        has(key) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            return $7d97e02cb028d0b8$var$latest(state).has(key);
        }
        set(key, value) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$7d97e02cb028d0b8$var$latest(state).has(key) || $7d97e02cb028d0b8$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $7d97e02cb028d0b8$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $7d97e02cb028d0b8$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $7d97e02cb028d0b8$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($7d97e02cb028d0b8$var$latest(state).size) {
                prepareMapCopy(state);
                $7d97e02cb028d0b8$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $7d97e02cb028d0b8$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $7d97e02cb028d0b8$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $7d97e02cb028d0b8$var$latest(state).get(key);
            if (state.finalized_ || !$7d97e02cb028d0b8$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $7d97e02cb028d0b8$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            return $7d97e02cb028d0b8$var$latest(state).keys();
        }
        values() {
            const iterator = this.keys();
            return iteratorFrom({
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            });
        }
        entries() {
            const iterator = this.keys();
            return iteratorFrom({
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            });
        }
        [($7d97e02cb028d0b8$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function iteratorFrom(iterable) {
        if ($7d97e02cb028d0b8$var$hasIteratorFrom) return $7d97e02cb028d0b8$var$_globalIterator.from(iterable);
        const iterator = $7d97e02cb028d0b8$var$__spreadProps($7d97e02cb028d0b8$var$__spreadValues({}, iterable), {
            [Symbol.iterator]: ()=>iterator
        });
        return iterator;
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$7d97e02cb028d0b8$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$7d97e02cb028d0b8$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $7d97e02cb028d0b8$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            return $7d97e02cb028d0b8$var$latest(state).size;
        }
        has(value) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $7d97e02cb028d0b8$var$markChanged(state);
                state.copy_.add(value);
                $7d97e02cb028d0b8$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $7d97e02cb028d0b8$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($7d97e02cb028d0b8$var$latest(state).size) {
                prepareSetCopy(state);
                $7d97e02cb028d0b8$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($7d97e02cb028d0b8$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$7d97e02cb028d0b8$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($7d97e02cb028d0b8$export$16e3aed3edb85946(value)) {
                    const draft = $7d97e02cb028d0b8$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $7d97e02cb028d0b8$var$die(3, JSON.stringify($7d97e02cb028d0b8$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($7d97e02cb028d0b8$var$getValue(value));
            });
        }
    }
    $7d97e02cb028d0b8$var$loadPlugin($7d97e02cb028d0b8$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $7d97e02cb028d0b8$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $7d97e02cb028d0b8$var$prepareCopy(state);
        const result = operation();
        markArrayChanged(state, markLength);
        return result;
    }
    function markArrayChanged(state, markLength = true) {
        $7d97e02cb028d0b8$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
        state.baseRefs_ = new Set(state.base_);
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleInsertedValues(state, startIndex, values) {
        for(let i = 0; i < values.length; i++){
            const index = "" + (startIndex + i);
            state.assigned_.set(index, true);
            $7d97e02cb028d0b8$var$handleCrossReference(state, index, values[i]);
        }
    }
    function handleSimpleOperation(state, method, args) {
        const isInsert = method === "push" || method === "unshift";
        if (isInsert ? args.length === 0 : $7d97e02cb028d0b8$var$latest(state).length === 0) return isInsert ? $7d97e02cb028d0b8$var$latest(state).length : void 0;
        $7d97e02cb028d0b8$var$prepareCopy(state);
        const lengthBefore = state.copy_.length;
        const result = state.copy_[method](...args);
        markArrayChanged(state);
        if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
        if (method === "push") handleInsertedValues(state, lengthBefore, args);
        else if (method === "unshift") handleInsertedValues(state, 0, args);
        return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
    }
    function handleReorderingOperation(state, method, args) {
        if ($7d97e02cb028d0b8$var$latest(state).length <= 1) return state.draft_;
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            var _a, _b;
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const insertCount = args.length > 2 ? args.length - 2 : 0;
                        if (insertCount === 0) {
                            const length = $7d97e02cb028d0b8$var$latest(state).length;
                            if (args.length === 0 || normalizeSliceIndex((_a = args[0]) != null ? _a : 0, length) === length || args.length > 1 && !(args[1] >= 1)) return [];
                        }
                        $7d97e02cb028d0b8$var$prepareCopy(state);
                        const lengthBefore = state.copy_.length;
                        const res = state.copy_.splice(...args);
                        if (res.length === 0 && insertCount === 0) return res;
                        markArrayChanged(state);
                        markAllIndicesReassigned(state);
                        if (insertCount > 0) {
                            const startIndex = normalizeSliceIndex((_b = args[0]) != null ? _b : 0, lengthBefore);
                            handleInsertedValues(state, startIndex, args.slice(2));
                        }
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        var _a, _b;
        const source = $7d97e02cb028d0b8$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const thisArg = args[1];
            const result = [];
            const length = source.length;
            for(let i = 0; i < length; i++)if (predicate.call(thisArg, source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const thisArg = args[1];
            const length = source.length;
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : length - 1;
            for(let i = start; i >= 0 && i < length; i += step){
                if (predicate.call(thisArg, source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = (_a = args[0]) != null ? _a : 0;
            const rawEnd = (_b = args[1]) != null ? _b : source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $7d97e02cb028d0b8$var$loadPlugin($7d97e02cb028d0b8$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $7d97e02cb028d0b8$var$immer = new $7d97e02cb028d0b8$export$aaadc6ff0f822719();
var $7d97e02cb028d0b8$export$b46cabe22e78bc00 = $7d97e02cb028d0b8$var$immer.produce;
var $7d97e02cb028d0b8$export$4da66d41c9492c78 = /* @__PURE__ */ $7d97e02cb028d0b8$var$immer.produceWithPatches.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$573f26f60825c493 = /* @__PURE__ */ $7d97e02cb028d0b8$var$immer.setAutoFreeze.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$333ce65961cbe047 = /* @__PURE__ */ $7d97e02cb028d0b8$var$immer.setUseStrictShallowCopy.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$1045b3be3904c489 = /* @__PURE__ */ $7d97e02cb028d0b8$var$immer.setUseStrictIteration.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $7d97e02cb028d0b8$var$immer.applyPatches.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$3c3214997190395f = /* @__PURE__ */ $7d97e02cb028d0b8$var$immer.createDraft.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$c60f5e69c521b528 = /* @__PURE__ */ $7d97e02cb028d0b8$var$immer.finishDraft.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$c05b21e3257751e5 = (value)=>value;
var $7d97e02cb028d0b8$export$20f911b3f8cf0b74 = (value)=>value;

});

parcelRegister("b2vZA", function(module, exports) {

$parcel$export(module.exports, "weakMapMemoize", function () { return $8098b29b64296697$export$8402dc26d96f6902; });
$parcel$export(module.exports, "createSelectorCreator", function () { return $8098b29b64296697$export$5943f4447f6ef248; });
$parcel$export(module.exports, "createSelector", function () { return $8098b29b64296697$export$595d22ed68ca2841; });
var $8098b29b64296697$var$__defProp = Object.defineProperty;
var $8098b29b64296697$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8098b29b64296697$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8098b29b64296697$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8098b29b64296697$var$__defNormalProp = (obj, key, value)=>key in obj ? $8098b29b64296697$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8098b29b64296697$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($8098b29b64296697$var$__hasOwnProp.call(b, prop)) $8098b29b64296697$var$__defNormalProp(a, prop, b[prop]);
    if ($8098b29b64296697$var$__getOwnPropSymbols) {
        for (var prop of $8098b29b64296697$var$__getOwnPropSymbols(b))if ($8098b29b64296697$var$__propIsEnum.call(b, prop)) $8098b29b64296697$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/devModeChecks/cacheSizeCheck.ts
var $8098b29b64296697$var$CACHE_SIZE_CHECK_THRESHOLD = 1e3;
var $8098b29b64296697$var$runCacheSizeCheck = (cacheSize, funcName)=>{
    let stack = void 0;
    try {
        throw new Error();
    } catch (e) {
        ({ stack: stack } = e);
    }
    console.warn(`A function memoized with weakMapMemoize${funcName ? ` (\`${funcName}\`)` : ""} has seen over ${cacheSize} distinct values for the same primitive argument position.
Results keyed by primitive arguments are held strongly and are only released by \`clearCache()\`, so this cache will keep growing for as long as the function keeps seeing new values.
If it is called with ever-changing primitives (ids, offsets, timestamps), pass the \`maxSize\` option to bound the cache, switch to \`lruMemoize\`, or call \`.clearCache()\` at a suitable point.
See https://reselect.js.org/api/development-only-checks#cachesizecheck for details.`, {
        stack: stack
    });
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $8098b29b64296697$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once",
    cacheSizeCheck: "once"
};
var $8098b29b64296697$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($8098b29b64296697$var$globalDevModeChecks, devModeChecks);
};
// src/weakMapMemoize.ts
var $8098b29b64296697$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $8098b29b64296697$var$getWeakRef = ()=>typeof WeakRef === "undefined" ? $8098b29b64296697$var$StrongRef : WeakRef;
var $8098b29b64296697$var$Ref = /* @__PURE__ */ $8098b29b64296697$var$getWeakRef();
var $8098b29b64296697$var$UNTERMINATED = 0;
var $8098b29b64296697$var$TERMINATED = 1;
function $8098b29b64296697$var$createCacheNode() {
    return {
        s: $8098b29b64296697$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $8098b29b64296697$var$maybeDeref(r) {
    if (r instanceof $8098b29b64296697$var$Ref) return r.deref();
    return r;
}
function $8098b29b64296697$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $8098b29b64296697$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck, maxSize: maxSize } = options;
    const useGenerations = maxSize !== void 0;
    if (useGenerations && (!Number.isInteger(maxSize) || maxSize < 1)) throw new TypeError(`maxSize must be a positive integer, received: ${maxSize}`);
    let prevNode = null;
    let insertionCount = 0;
    let lastResult;
    let resultsCount = 0;
    let hasWarnedAboutCacheSize = false;
    function maybeFlipGenerations() {
        if (insertionCount >= maxSize) {
            prevNode = fnNode;
            fnNode = $8098b29b64296697$var$createCacheNode();
            insertionCount = 0;
        }
    }
    function memoized() {
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $8098b29b64296697$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $8098b29b64296697$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                    insertionCount++;
                } else cacheNode = primitiveNode;
            }
        }
        if (cacheNode.s === $8098b29b64296697$var$TERMINATED) return cacheNode.v;
        if (prevNode !== null) {
            let prevCacheNode = prevNode;
            for(let i = 0, l = length; i < l; i++){
                const arg = arguments[i];
                let next;
                if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                    const prevObjectCache = prevCacheNode.o;
                    next = prevObjectCache !== null ? prevObjectCache.get(arg) : void 0;
                } else {
                    const prevPrimitiveCache = prevCacheNode.p;
                    next = prevPrimitiveCache !== null ? prevPrimitiveCache.get(arg) : void 0;
                }
                if (next === void 0) {
                    prevCacheNode = null;
                    break;
                }
                prevCacheNode = next;
            }
            if (prevCacheNode !== null && prevCacheNode.s === $8098b29b64296697$var$TERMINATED) {
                const promotedNode = cacheNode;
                promotedNode.s = $8098b29b64296697$var$TERMINATED;
                promotedNode.v = prevCacheNode.v;
                maybeFlipGenerations();
                return prevCacheNode.v;
            }
        }
        const terminatedNode = cacheNode;
        let result = func.apply(null, arguments);
        resultsCount++;
        if (resultEqualityCheck) {
            const lastResultValue = $8098b29b64296697$var$maybeDeref(lastResult);
            if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                result = lastResultValue;
                resultsCount !== 0 && resultsCount--;
            }
            const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
            lastResult = needsWeakRef ? /* @__PURE__ */ new $8098b29b64296697$var$Ref(result) : result;
        }
        terminatedNode.s = $8098b29b64296697$var$TERMINATED;
        terminatedNode.v = result;
        if (useGenerations) maybeFlipGenerations();
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $8098b29b64296697$var$createCacheNode();
        prevNode = null;
        insertionCount = 0;
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/devModeChecks/identityFunctionCheck.ts
var $8098b29b64296697$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $8098b29b64296697$var$withoutResultEqualityCheck = (option)=>{
    if (option === null || typeof option !== "object" || !("resultEqualityCheck" in option)) return option;
    const optionCopy = $8098b29b64296697$var$__spreadValues({}, option);
    delete optionCopy.resultEqualityCheck;
    return optionCopy;
};
var $8098b29b64296697$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const probeMemoizeOptions = [];
    const { length: length } = memoizeOptions;
    for(let i = 0; i < length; i++)probeMemoizeOptions.push($8098b29b64296697$var$withoutResultEqualityCheck(memoizeOptions[i]));
    const createAnEmptyObject = memoize(()=>({}), ...probeMemoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/utils.ts
var $8098b29b64296697$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $8098b29b64296697$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $8098b29b64296697$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $8098b29b64296697$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $8098b29b64296697$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $8098b29b64296697$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $8098b29b64296697$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $8098b29b64296697$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
// src/createSelectorCreator.ts
function $8098b29b64296697$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $8098b29b64296697$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $8098b29b64296697$var$__spreadValues($8098b29b64296697$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $8098b29b64296697$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [] } = combinedOptions;
        const finalMemoizeOptions = $8098b29b64296697$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $8098b29b64296697$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $8098b29b64296697$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const { length: length } = dependencies;
            const inputSelectorResults = new Array(length);
            for(let i = 0; i < length; i++)inputSelectorResults[i] = dependencies[i].apply(null, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $8098b29b64296697$export$595d22ed68ca2841 = /* @__PURE__ */ $8098b29b64296697$export$5943f4447f6ef248($8098b29b64296697$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $8098b29b64296697$export$75979cfcd91bf38f = /* @__PURE__ */ Object.assign((inputSelectorsObject, selectorCreator = $8098b29b64296697$export$595d22ed68ca2841)=>{
    $8098b29b64296697$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$8098b29b64296697$export$75979cfcd91bf38f
});
// src/lruMemoize.ts
function $8098b29b64296697$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $8098b29b64296697$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        findMatchingEntry (value, resultEqualityCheck) {
            const current = entry;
            return current !== void 0 && resultEqualityCheck(current.value, value) ? current : void 0;
        },
        clear () {
            entry = void 0;
        }
    };
}
function $8098b29b64296697$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(entry.key, key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $8098b29b64296697$var$NOT_FOUND;
    }
    function put(key, value) {
        entries.unshift({
            key: key,
            value: value
        });
        if (entries.length > maxSize) entries.pop();
    }
    function findMatchingEntry(value, resultEqualityCheck) {
        const currentEntries = entries;
        const { length: length } = currentEntries;
        for(let i = 0; i < length; i++){
            const entry = currentEntries[i];
            if (resultEqualityCheck(entry.value, value)) return entry;
        }
        return void 0;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        findMatchingEntry: findMatchingEntry,
        clear: clear
    };
}
var $8098b29b64296697$export$3f025202a230c6dd = (a, b)=>a === b;
function $8098b29b64296697$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $8098b29b64296697$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $8098b29b64296697$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $8098b29b64296697$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $8098b29b64296697$var$createSingletonCache(comparator) : $8098b29b64296697$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $8098b29b64296697$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const matchingEntry = cache.findMatchingEntry(value, resultEqualityCheck);
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}

});

parcelRegister("dMpb7", function(module, exports) {

$parcel$export(module.exports, "thunk", function () { return $a08349f8b4900e5d$export$dd164f5517779f15; });
$parcel$export(module.exports, "withExtraArgument", function () { return $a08349f8b4900e5d$export$16d06542a1949d9e; });
// src/index.ts
function $a08349f8b4900e5d$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $a08349f8b4900e5d$export$dd164f5517779f15 = $a08349f8b4900e5d$var$createThunkMiddleware();
var $a08349f8b4900e5d$export$16d06542a1949d9e = $a08349f8b4900e5d$var$createThunkMiddleware;

});


parcelRegister("64HYc", function(module, exports) {

$parcel$export(module.exports, "persistReducer", function () { return (parcelRequire("9BbB1")).default; });
$parcel$export(module.exports, "persistStore", function () { return (parcelRequire("gpGPq")).default; });

var $9BbB1 = parcelRequire("9BbB1");

var $7ezCr = parcelRequire("7ezCr");

var $gpGPq = parcelRequire("gpGPq");

var $k86Dz = parcelRequire("k86Dz");

var $6EUA4 = parcelRequire("6EUA4");

var $7Zoga = parcelRequire("7Zoga");

var $2H8gX = parcelRequire("2H8gX");

var $9zx3g = parcelRequire("9zx3g");
parcelRequire("7BJap");

});
parcelRegister("9BbB1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fd09082c01c3412$export$2e2bcd8739ae039; });

var $7BJap = parcelRequire("7BJap");

var $kd6KN = parcelRequire("kd6KN");

var $2H8gX = parcelRequire("2H8gX");

var $7Zoga = parcelRequire("7Zoga");

var $9zx3g = parcelRequire("9zx3g");
function $6fd09082c01c3412$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6fd09082c01c3412$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $6fd09082c01c3412$var$ownKeys(source, true).forEach(function(key) {
            $6fd09082c01c3412$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $6fd09082c01c3412$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6fd09082c01c3412$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6fd09082c01c3412$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6fd09082c01c3412$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6fd09082c01c3412$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $6fd09082c01c3412$var$DEFAULT_TIMEOUT = 5000;
function $6fd09082c01c3412$export$2e2bcd8739ae039(config, baseReducer) {
    var version = config.version !== undefined ? config.version : (0, $7BJap.DEFAULT_VERSION);
    var debug = config.debug || false;
    var stateReconciler = config.stateReconciler === undefined ? (0, $kd6KN.default) : config.stateReconciler;
    var getStoredState = config.getStoredState || (0, $7Zoga.default);
    var timeout = config.timeout !== undefined ? config.timeout : $6fd09082c01c3412$var$DEFAULT_TIMEOUT;
    var _persistoid = null;
    var _purge = false;
    var _paused = true;
    var conditionalUpdate = function conditionalUpdate(state) {
        // update the persistoid only if we are rehydrated and not paused
        state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
        return state;
    };
    return function(state, action) {
        var _ref = state || {}, _persist = _ref._persist, rest = $6fd09082c01c3412$var$_objectWithoutProperties(_ref, [
            "_persist"
        ]); // $FlowIgnore need to update State type
        var restState = rest;
        if (action.type === (0, $7BJap.PERSIST)) {
            var _sealed = false;
            var _rehydrate = function _rehydrate(payload, err) {
                if (!_sealed) {
                    action.rehydrate(config.key, payload, err);
                    _sealed = true;
                }
            };
            timeout && setTimeout(function() {
                !_sealed && _rehydrate(undefined, new Error("redux-persist: persist timed out for persist key \"".concat(config.key, "\"")));
            }, timeout); // @NOTE PERSIST resumes if paused.
            _paused = false; // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
            if (!_persistoid) _persistoid = (0, $2H8gX.default)(config); // @NOTE PERSIST can be called multiple times, noop after the first
            if (_persist) // We still need to call the base reducer because there might be nested
            // uses of persistReducer which need to be aware of the PERSIST action
            return $6fd09082c01c3412$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
            if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');
            action.register(config.key);
            getStoredState(config).then(function(restoredState) {
                var migrate = config.migrate || function(s, v) {
                    return Promise.resolve(s);
                };
                migrate(restoredState, version).then(function(migratedState) {
                    _rehydrate(migratedState);
                }, function(migrateErr) {
                    _rehydrate(undefined, migrateErr);
                });
            }, function(err) {
                _rehydrate(undefined, err);
            });
            return $6fd09082c01c3412$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: {
                    version: version,
                    rehydrated: false
                }
            });
        } else if (action.type === (0, $7BJap.PURGE)) {
            _purge = true;
            action.result((0, $9zx3g.default)(config));
            return $6fd09082c01c3412$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $7BJap.FLUSH)) {
            action.result(_persistoid && _persistoid.flush());
            return $6fd09082c01c3412$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $7BJap.PAUSE)) _paused = true;
        else if (action.type === (0, $7BJap.REHYDRATE)) {
            // noop on restState if purging
            if (_purge) return $6fd09082c01c3412$var$_objectSpread({}, restState, {
                _persist: $6fd09082c01c3412$var$_objectSpread({}, _persist, {
                    rehydrated: true
                }) // @NOTE if key does not match, will continue to default else below
            });
            if (action.key === config.key) {
                var reducedState = baseReducer(restState, action);
                var inboundState = action.payload; // only reconcile state if stateReconciler and inboundState are both defined
                var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;
                var _newState = $6fd09082c01c3412$var$_objectSpread({}, reconciledRest, {
                    _persist: $6fd09082c01c3412$var$_objectSpread({}, _persist, {
                        rehydrated: true
                    })
                });
                return conditionalUpdate(_newState);
            }
        } // if we have not already handled PERSIST, straight passthrough
        if (!_persist) return baseReducer(state, action); // run base reducer:
        // is state modified ? return original : return updated
        var newState = baseReducer(restState, action);
        if (newState === restState) return state;
        return conditionalUpdate($6fd09082c01c3412$var$_objectSpread({}, newState, {
            _persist: _persist
        }));
    };
}

});
parcelRegister("7BJap", function(module, exports) {

$parcel$export(module.exports, "KEY_PREFIX", function () { return $589f0650814c8d79$export$711117ad6ad27992; });
$parcel$export(module.exports, "FLUSH", function () { return $589f0650814c8d79$export$2aaee4793dd13a52; });
$parcel$export(module.exports, "REHYDRATE", function () { return $589f0650814c8d79$export$1647ef958242c4e2; });
$parcel$export(module.exports, "PAUSE", function () { return $589f0650814c8d79$export$dd1033c27a16bbd3; });
$parcel$export(module.exports, "PERSIST", function () { return $589f0650814c8d79$export$913fe0e161ed92a2; });
$parcel$export(module.exports, "PURGE", function () { return $589f0650814c8d79$export$5514fc3b4067675f; });
$parcel$export(module.exports, "REGISTER", function () { return $589f0650814c8d79$export$51e82cdd7353a0e1; });
$parcel$export(module.exports, "DEFAULT_VERSION", function () { return $589f0650814c8d79$export$363ebe89e6e7aeef; });
var $589f0650814c8d79$export$711117ad6ad27992 = 'persist:';
var $589f0650814c8d79$export$2aaee4793dd13a52 = 'persist/FLUSH';
var $589f0650814c8d79$export$1647ef958242c4e2 = 'persist/REHYDRATE';
var $589f0650814c8d79$export$dd1033c27a16bbd3 = 'persist/PAUSE';
var $589f0650814c8d79$export$913fe0e161ed92a2 = 'persist/PERSIST';
var $589f0650814c8d79$export$5514fc3b4067675f = 'persist/PURGE';
var $589f0650814c8d79$export$51e82cdd7353a0e1 = 'persist/REGISTER';
var $589f0650814c8d79$export$363ebe89e6e7aeef = -1;

});

parcelRegister("kd6KN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb6a42baecd5eb76$export$2e2bcd8739ae039; });
function $eb6a42baecd5eb76$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $eb6a42baecd5eb76$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $eb6a42baecd5eb76$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $eb6a42baecd5eb76$var$_typeof(obj);
}
function $eb6a42baecd5eb76$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $eb6a42baecd5eb76$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $eb6a42baecd5eb76$var$ownKeys(source, true).forEach(function(key) {
            $eb6a42baecd5eb76$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $eb6a42baecd5eb76$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $eb6a42baecd5eb76$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $eb6a42baecd5eb76$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $eb6a42baecd5eb76$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $eb6a42baecd5eb76$var$_typeof(inboundState) === 'object') Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
         // otherwise hard set the new value
        newState[key] = inboundState[key];
    });
    return newState;
}

});

parcelRegister("2H8gX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f6603aed1789adf$export$2e2bcd8739ae039; });

var $7BJap = parcelRequire("7BJap");
function $1f6603aed1789adf$export$2e2bcd8739ae039(config) {
    // defaults
    var blacklist = config.blacklist || null;
    var whitelist = config.whitelist || null;
    var transforms = config.transforms || [];
    var throttle = config.throttle || 0;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $7BJap.KEY_PREFIX)).concat(config.key);
    var storage = config.storage;
    var serialize;
    if (config.serialize === false) serialize = function serialize(x) {
        return x;
    };
    else if (typeof config.serialize === 'function') serialize = config.serialize;
    else serialize = $1f6603aed1789adf$var$defaultSerialize;
    var writeFailHandler = config.writeFailHandler || null; // initialize stateful values
    var lastState = {};
    var stagedState = {};
    var keysToProcess = [];
    var timeIterator = null;
    var writePromise = null;
    var update = function update(state) {
        // add any changed keys to the queue
        Object.keys(state).forEach(function(key) {
            if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
            if (lastState[key] === state[key]) return; // value unchanged? noop
            if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
            keysToProcess.push(key); // add key to queue
        }); //if any key is missing in the new state which was present in the lastState,
        //add it for processing too
        Object.keys(lastState).forEach(function(key) {
            if (state[key] === undefined && passWhitelistBlacklist(key) && keysToProcess.indexOf(key) === -1 && lastState[key] !== undefined) keysToProcess.push(key);
        }); // start the time iterator if not running (read: throttle)
        if (timeIterator === null) timeIterator = setInterval(processNextKey, throttle);
        lastState = state;
    };
    function processNextKey() {
        if (keysToProcess.length === 0) {
            if (timeIterator) clearInterval(timeIterator);
            timeIterator = null;
            return;
        }
        var key = keysToProcess.shift();
        var endState = transforms.reduce(function(subState, transformer) {
            return transformer.in(subState, key, lastState);
        }, lastState[key]);
        if (endState !== undefined) try {
            stagedState[key] = serialize(endState);
        } catch (err) {
            console.error('redux-persist/createPersistoid: error serializing state', err);
        }
        else //if the endState is undefined, no need to persist the existing serialized content
        delete stagedState[key];
        if (keysToProcess.length === 0) writeStagedState();
    }
    function writeStagedState() {
        // cleanup any removed keys just before write.
        Object.keys(stagedState).forEach(function(key) {
            if (lastState[key] === undefined) delete stagedState[key];
        });
        writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
    }
    function passWhitelistBlacklist(key) {
        if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
        if (blacklist && blacklist.indexOf(key) !== -1) return false;
        return true;
    }
    function onWriteFail(err) {
        // @TODO add fail handlers (typically storage full)
        if (writeFailHandler) writeFailHandler(err);
    }
    var flush = function flush() {
        while(keysToProcess.length !== 0)processNextKey();
        return writePromise || Promise.resolve();
    }; // return `persistoid`
    return {
        update: update,
        flush: flush
    };
} // @NOTE in the future this may be exposed via config
function $1f6603aed1789adf$var$defaultSerialize(data) {
    return JSON.stringify(data);
}

});

parcelRegister("7Zoga", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d110c6aa63cd5c9$export$2e2bcd8739ae039; });

var $7BJap = parcelRequire("7BJap");
function $5d110c6aa63cd5c9$export$2e2bcd8739ae039(config) {
    var transforms = config.transforms || [];
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $7BJap.KEY_PREFIX)).concat(config.key);
    var storage = config.storage;
    var debug = config.debug;
    var deserialize;
    if (config.deserialize === false) deserialize = function deserialize(x) {
        return x;
    };
    else if (typeof config.deserialize === 'function') deserialize = config.deserialize;
    else deserialize = $5d110c6aa63cd5c9$var$defaultDeserialize;
    return storage.getItem(storageKey).then(function(serialized) {
        if (!serialized) return undefined;
        else try {
            var state = {};
            var rawState = deserialize(serialized);
            Object.keys(rawState).forEach(function(key) {
                state[key] = transforms.reduceRight(function(subState, transformer) {
                    return transformer.out(subState, key, rawState);
                }, deserialize(rawState[key]));
            });
            return state;
        } catch (err) {
            throw err;
        }
    });
}
function $5d110c6aa63cd5c9$var$defaultDeserialize(serial) {
    return JSON.parse(serial);
}

});

parcelRegister("9zx3g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f81054c51f86b99$export$2e2bcd8739ae039; });

var $7BJap = parcelRequire("7BJap");
function $6f81054c51f86b99$export$2e2bcd8739ae039(config) {
    var storage = config.storage;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $7BJap.KEY_PREFIX)).concat(config.key);
    return storage.removeItem(storageKey, $6f81054c51f86b99$var$warnIfRemoveError);
}
function $6f81054c51f86b99$var$warnIfRemoveError(err) {}

});


parcelRegister("7ezCr", function(module, exports) {

var $alMr3 = parcelRequire("alMr3");

var $9BbB1 = parcelRequire("9BbB1");

var $PBL1N = parcelRequire("PBL1N");
function $54457869066e44cf$export$2e2bcd8739ae039(config, reducers) {
    config.stateReconciler = config.stateReconciler === undefined ? (0, $PBL1N.default) : config.stateReconciler;
    return (0, $9BbB1.default)(config, (0, $alMr3.combineReducers)(reducers));
}

});
parcelRegister("PBL1N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09b20d64038ca612$export$2e2bcd8739ae039; });
function $09b20d64038ca612$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $09b20d64038ca612$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $09b20d64038ca612$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $09b20d64038ca612$var$_typeof(obj);
}
function $09b20d64038ca612$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $09b20d64038ca612$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $09b20d64038ca612$var$ownKeys(source, true).forEach(function(key) {
            $09b20d64038ca612$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $09b20d64038ca612$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $09b20d64038ca612$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $09b20d64038ca612$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $09b20d64038ca612$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $09b20d64038ca612$var$_typeof(inboundState) === 'object') Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
        if ($09b20d64038ca612$var$isPlainEnoughObject(reducedState[key])) {
            // if object is plain enough shallow merge the new values (hence "Level2")
            newState[key] = $09b20d64038ca612$var$_objectSpread({}, newState[key], {}, inboundState[key]);
            return;
        } // otherwise hard set
        newState[key] = inboundState[key];
    });
    return newState;
}
function $09b20d64038ca612$var$isPlainEnoughObject(o) {
    return o !== null && !Array.isArray(o) && $09b20d64038ca612$var$_typeof(o) === 'object';
}

});


parcelRegister("gpGPq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf3034007235e05d$export$2e2bcd8739ae039; });

var $alMr3 = parcelRequire("alMr3");

var $7BJap = parcelRequire("7BJap");
function $bf3034007235e05d$var$_toConsumableArray(arr) {
    return $bf3034007235e05d$var$_arrayWithoutHoles(arr) || $bf3034007235e05d$var$_iterableToArray(arr) || $bf3034007235e05d$var$_nonIterableSpread();
}
function $bf3034007235e05d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $bf3034007235e05d$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $bf3034007235e05d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $bf3034007235e05d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bf3034007235e05d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $bf3034007235e05d$var$ownKeys(source, true).forEach(function(key) {
            $bf3034007235e05d$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $bf3034007235e05d$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bf3034007235e05d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $bf3034007235e05d$var$initialState = {
    registry: [],
    bootstrapped: false
};
var $bf3034007235e05d$var$persistorReducer = function persistorReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $bf3034007235e05d$var$initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $7BJap.REGISTER:
            return $bf3034007235e05d$var$_objectSpread({}, state, {
                registry: [].concat($bf3034007235e05d$var$_toConsumableArray(state.registry), [
                    action.key
                ])
            });
        case 0, $7BJap.REHYDRATE:
            var firstIndex = state.registry.indexOf(action.key);
            var registry = $bf3034007235e05d$var$_toConsumableArray(state.registry);
            registry.splice(firstIndex, 1);
            return $bf3034007235e05d$var$_objectSpread({}, state, {
                registry: registry,
                bootstrapped: registry.length === 0
            });
        default:
            return state;
    }
};
function $bf3034007235e05d$export$2e2bcd8739ae039(store, options, cb) {
    var optionsToTest, bannedKeys;
    var boostrappedCb = cb || false;
    var _pStore = (0, $alMr3.createStore)($bf3034007235e05d$var$persistorReducer, $bf3034007235e05d$var$initialState, options && options.enhancer ? options.enhancer : undefined);
    var register = function register(key) {
        _pStore.dispatch({
            type: (0, $7BJap.REGISTER),
            key: key
        });
    };
    var rehydrate = function rehydrate(key, payload, err) {
        var rehydrateAction = {
            type: (0, $7BJap.REHYDRATE),
            payload: payload,
            err: err,
            key: key // dispatch to `store` to rehydrate and `persistor` to track result
        };
        store.dispatch(rehydrateAction);
        _pStore.dispatch(rehydrateAction);
        if (boostrappedCb && persistor.getState().bootstrapped) {
            boostrappedCb();
            boostrappedCb = false;
        }
    };
    var persistor = $bf3034007235e05d$var$_objectSpread({}, _pStore, {
        purge: function purge() {
            var results = [];
            store.dispatch({
                type: (0, $7BJap.PURGE),
                result: function result(purgeResult) {
                    results.push(purgeResult);
                }
            });
            return Promise.all(results);
        },
        flush: function flush() {
            var results = [];
            store.dispatch({
                type: (0, $7BJap.FLUSH),
                result: function result(flushResult) {
                    results.push(flushResult);
                }
            });
            return Promise.all(results);
        },
        pause: function pause() {
            store.dispatch({
                type: (0, $7BJap.PAUSE)
            });
        },
        persist: function persist() {
            store.dispatch({
                type: (0, $7BJap.PERSIST),
                register: register,
                rehydrate: rehydrate
            });
        }
    });
    if (!(options && options.manualPersist)) persistor.persist();
    return persistor;
}

});

parcelRegister("k86Dz", function(module, exports) {

var $7BJap = parcelRequire("7BJap");
function $ea79b404fd049af8$export$2e2bcd8739ae039(migrations, config) {
    var _ref = config || {}, debug = _ref.debug;
    return function(state, currentVersion) {
        if (!state) return Promise.resolve(undefined);
        var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : (0, $7BJap.DEFAULT_VERSION);
        if (inboundVersion === currentVersion) return Promise.resolve(state);
        if (inboundVersion > currentVersion) return Promise.resolve(state);
        var migrationKeys = Object.keys(migrations).map(function(ver) {
            return parseInt(ver);
        }).filter(function(key) {
            return currentVersion >= key && key > inboundVersion;
        }).sort(function(a, b) {
            return a - b;
        });
        try {
            var migratedState = migrationKeys.reduce(function(state, versionKey) {
                return migrations[versionKey](state);
            }, state);
            return Promise.resolve(migratedState);
        } catch (err) {
            return Promise.reject(err);
        }
    };
}

});

parcelRegister("6EUA4", function(module, exports) {
function $4d925e429f12a459$export$2e2bcd8739ae039(inbound, outbound) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var whitelist = config.whitelist || null;
    var blacklist = config.blacklist || null;
    function whitelistBlacklistCheck(key) {
        if (whitelist && whitelist.indexOf(key) === -1) return true;
        if (blacklist && blacklist.indexOf(key) !== -1) return true;
        return false;
    }
    return {
        in: function _in(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
        },
        out: function out(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
        }
    };
}

});


parcelRegister("5t2s4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fb190068f512d56$export$2e2bcd8739ae039; }, function (v) { return $3fb190068f512d56$export$2e2bcd8739ae039 = v; });
var $3fb190068f512d56$export$1e511d4a378977f5;
var $3fb190068f512d56$export$2e2bcd8739ae039;
"use strict";
$3fb190068f512d56$export$1e511d4a378977f5 = true;
$3fb190068f512d56$export$2e2bcd8739ae039 = void 0;

var $3fb190068f512d56$var$_createWebStorage = $3fb190068f512d56$var$_interopRequireDefault((parcelRequire("dJcPy")));
function $3fb190068f512d56$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3fb190068f512d56$var$_default = (0, $3fb190068f512d56$var$_createWebStorage.default)('local');
$3fb190068f512d56$export$2e2bcd8739ae039 = $3fb190068f512d56$var$_default;

});
parcelRegister("dJcPy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $9fe96e30d01da42a$export$1e511d4a378977f5; }, function (v) { return $9fe96e30d01da42a$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $9fe96e30d01da42a$export$2e2bcd8739ae039; }, function (v) { return $9fe96e30d01da42a$export$2e2bcd8739ae039 = v; });
var $9fe96e30d01da42a$export$1e511d4a378977f5;
var $9fe96e30d01da42a$export$2e2bcd8739ae039;
"use strict";
$9fe96e30d01da42a$export$1e511d4a378977f5 = true;
$9fe96e30d01da42a$export$2e2bcd8739ae039 = $9fe96e30d01da42a$var$createWebStorage;

var $9fe96e30d01da42a$var$_getStorage = $9fe96e30d01da42a$var$_interopRequireDefault((parcelRequire("vUMjv")));
function $9fe96e30d01da42a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9fe96e30d01da42a$var$createWebStorage(type) {
    var storage = (0, $9fe96e30d01da42a$var$_getStorage.default)(type);
    return {
        getItem: function getItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.getItem(key));
            });
        },
        setItem: function setItem(key, item) {
            return new Promise(function(resolve, reject) {
                resolve(storage.setItem(key, item));
            });
        },
        removeItem: function removeItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.removeItem(key));
            });
        }
    };
}

});
parcelRegister("vUMjv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $05fef057c8112c5e$export$1e511d4a378977f5; }, function (v) { return $05fef057c8112c5e$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $05fef057c8112c5e$export$2e2bcd8739ae039; }, function (v) { return $05fef057c8112c5e$export$2e2bcd8739ae039 = v; });
var $05fef057c8112c5e$export$1e511d4a378977f5;
var $05fef057c8112c5e$export$2e2bcd8739ae039;
"use strict";
$05fef057c8112c5e$export$1e511d4a378977f5 = true;
$05fef057c8112c5e$export$2e2bcd8739ae039 = $05fef057c8112c5e$var$getStorage;
function $05fef057c8112c5e$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $05fef057c8112c5e$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $05fef057c8112c5e$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $05fef057c8112c5e$var$_typeof(obj);
}
function $05fef057c8112c5e$var$noop() {}
var $05fef057c8112c5e$var$noopStorage = {
    getItem: $05fef057c8112c5e$var$noop,
    setItem: $05fef057c8112c5e$var$noop,
    removeItem: $05fef057c8112c5e$var$noop
};
function $05fef057c8112c5e$var$hasStorage(storageType) {
    if ((typeof self === "undefined" ? "undefined" : $05fef057c8112c5e$var$_typeof(self)) !== 'object' || !(storageType in self)) return false;
    try {
        var storage = self[storageType];
        var testKey = "redux-persist ".concat(storageType, " test");
        storage.setItem(testKey, 'test');
        storage.getItem(testKey);
        storage.removeItem(testKey);
    } catch (e) {
        return false;
    }
    return true;
}
function $05fef057c8112c5e$var$getStorage(type) {
    var storageType = "".concat(type, "Storage");
    if ($05fef057c8112c5e$var$hasStorage(storageType)) return self[storageType];
    else return $05fef057c8112c5e$var$noopStorage;
}

});



parcelRegister("5VgIe", function(module, exports) {

$parcel$export(module.exports, "rootReducer", function () { return $19cb4e9af597e13e$export$a8a69c316169e623; });

var $alMr3 = parcelRequire("alMr3");

var $7Th0Y = parcelRequire("7Th0Y");

var $4gqmO = parcelRequire("4gqmO");

var $4jgI5 = parcelRequire("4jgI5");

var $9CmlZ = parcelRequire("9CmlZ");

var $Gqrrr = parcelRequire("Gqrrr");

var $7qclf = parcelRequire("7qclf");

var $i3ZTD = parcelRequire("i3ZTD");

var $ckMxe = parcelRequire("ckMxe");

var $l3fQU = parcelRequire("l3fQU");
const $19cb4e9af597e13e$export$a8a69c316169e623 = (0, $alMr3.combineReducers)({
    //login and signup
    loginState: (0, $7Th0Y.default),
    //project
    currentProjectState: (0, $4gqmO.default),
    exportProjectState: (0, $4jgI5.default),
    //data entry and review entries goal
    treeViewState: (0, $Gqrrr.default),
    pronunciationsState: (0, $9CmlZ.default),
    //goal timeline and current goal
    goalsState: (0, $ckMxe.default),
    //merge duplicates goal and review deferred duplicates goal
    mergeDuplicateGoal: (0, $i3ZTD.default),
    //character inventory goal
    characterInventoryState: (0, $7qclf.default),
    //analytics state
    analyticsState: (0, $l3fQU.default)
});

});
parcelRegister("7Th0Y", function(module, exports) {

$parcel$export(module.exports, "setIsAdminTrueAction", function () { return $8cec0f32a207591e$export$ed3d8e19ff494897; });
$parcel$export(module.exports, "setIsEmailVerifiedTrueAction", function () { return $8cec0f32a207591e$export$c2af637815a38dd6; });
$parcel$export(module.exports, "setLoginAttemptAction", function () { return $8cec0f32a207591e$export$7043bd66194835ee; });
$parcel$export(module.exports, "setLoginFailureAction", function () { return $8cec0f32a207591e$export$f88320e098c92178; });
$parcel$export(module.exports, "setLoginSuccessAction", function () { return $8cec0f32a207591e$export$b46b3d73926b9f39; });
$parcel$export(module.exports, "setSignupAttemptAction", function () { return $8cec0f32a207591e$export$17db6f9c3ba2a94a; });
$parcel$export(module.exports, "setSignupFailureAction", function () { return $8cec0f32a207591e$export$2a25376888f85143; });
$parcel$export(module.exports, "setSignupSuccessAction", function () { return $8cec0f32a207591e$export$664873e2cc4e0341; });
$parcel$export(module.exports, "default", function () { return $8cec0f32a207591e$export$2e2bcd8739ae039; });

var $1SirA = parcelRequire("1SirA");

var $i3Fzs = parcelRequire("i3Fzs");

var $3oQOj = parcelRequire("3oQOj");
const $8cec0f32a207591e$var$loginSlice = (0, $1SirA.createSlice)({
    name: "loginState",
    initialState: (0, $i3Fzs.defaultState),
    reducers: {
        setIsAdminTrueAction: (state)=>{
            state.isAdmin = true;
        },
        setIsEmailVerifiedTrueAction: (state)=>{
            state.isEmailVerified = true;
        },
        setLoginAttemptAction: (state, action)=>{
            state.error = "";
            state.loginStatus = (0, $i3Fzs.LoginStatus).InProgress;
            state.signupStatus = (0, $i3Fzs.LoginStatus).Default;
            state.username = action.payload;
        },
        setLoginFailureAction: (state, action)=>{
            state.error = action.payload;
            state.loginStatus = (0, $i3Fzs.LoginStatus).Failure;
        },
        setLoginSuccessAction: (state)=>{
            state.loginStatus = (0, $i3Fzs.LoginStatus).Success;
        },
        setSignupAttemptAction: (state, action)=>{
            state.error = "";
            state.loginStatus = (0, $i3Fzs.LoginStatus).Default;
            state.signupStatus = (0, $i3Fzs.LoginStatus).InProgress;
            state.username = action.payload;
        },
        setSignupFailureAction: (state, action)=>{
            state.error = action.payload;
            state.signupStatus = (0, $i3Fzs.LoginStatus).Failure;
        },
        setSignupSuccessAction: (state)=>{
            state.signupStatus = (0, $i3Fzs.LoginStatus).Success;
        }
    },
    extraReducers: (builder)=>builder.addCase((0, $3oQOj.StoreActionTypes).RESET, ()=>(0, $i3Fzs.defaultState))
});
const { setIsAdminTrueAction: $8cec0f32a207591e$export$ed3d8e19ff494897, setIsEmailVerifiedTrueAction: $8cec0f32a207591e$export$c2af637815a38dd6, setLoginAttemptAction: $8cec0f32a207591e$export$7043bd66194835ee, setLoginFailureAction: $8cec0f32a207591e$export$f88320e098c92178, setLoginSuccessAction: $8cec0f32a207591e$export$b46b3d73926b9f39, setSignupAttemptAction: $8cec0f32a207591e$export$17db6f9c3ba2a94a, setSignupFailureAction: $8cec0f32a207591e$export$2a25376888f85143, setSignupSuccessAction: $8cec0f32a207591e$export$664873e2cc4e0341 } = $8cec0f32a207591e$var$loginSlice.actions;
var $8cec0f32a207591e$export$2e2bcd8739ae039 = $8cec0f32a207591e$var$loginSlice.reducer;

});
parcelRegister("i3Fzs", function(module, exports) {

$parcel$export(module.exports, "LoginStatus", function () { return $1f8a328b11fe2e1f$export$877db50210ba1eb8; });
$parcel$export(module.exports, "defaultState", function () { return $1f8a328b11fe2e1f$export$49d5fc8cba920a0; });
var $1f8a328b11fe2e1f$export$877db50210ba1eb8 = /*#__PURE__*/ function(LoginStatus) {
    LoginStatus["Default"] = "Default";
    LoginStatus["Failure"] = "Failure";
    LoginStatus["InProgress"] = "InProgress";
    LoginStatus["Success"] = "Success";
    return LoginStatus;
}({});
const $1f8a328b11fe2e1f$export$49d5fc8cba920a0 = {
    error: "",
    isAdmin: false,
    isEmailVerified: false,
    loginStatus: "Default",
    signupStatus: "Default",
    username: ""
};

});

parcelRegister("3oQOj", function(module, exports) {

$parcel$export(module.exports, "StoreActionTypes", function () { return $3b3f1a4bd866ed44$export$cad558d055dfe73b; });
$parcel$export(module.exports, "reset", function () { return $3b3f1a4bd866ed44$export$aad8462122ac592b; });

var $1a3s7 = parcelRequire("1a3s7");
var $3b3f1a4bd866ed44$export$cad558d055dfe73b = /*#__PURE__*/ function(StoreActionTypes) {
    StoreActionTypes["RESET"] = "RESET";
    return StoreActionTypes;
}({});
function $3b3f1a4bd866ed44$export$aad8462122ac592b() {
    (0, $1a3s7.clearLocalStorage)();
    return {
        type: "RESET"
    };
}

});


parcelRegister("4gqmO", function(module, exports) {

$parcel$export(module.exports, "resetAction", function () { return $086d1a88bf4b709d$export$2e78289a93d130a3; });
$parcel$export(module.exports, "setColumnOrderAction", function () { return $086d1a88bf4b709d$export$9d0812aae501c473; });
$parcel$export(module.exports, "setColumnVisibilityAction", function () { return $086d1a88bf4b709d$export$bee4faced8592a; });
$parcel$export(module.exports, "setProjectAction", function () { return $086d1a88bf4b709d$export$baebdcdae33c1b81; });
$parcel$export(module.exports, "setSemanticDomainsAction", function () { return $086d1a88bf4b709d$export$ebf8cfd08cc7e0ee; });
$parcel$export(module.exports, "setSpeakerAction", function () { return $086d1a88bf4b709d$export$6794d91415943410; });
$parcel$export(module.exports, "setUsersAction", function () { return $086d1a88bf4b709d$export$a1178cce71c4f0bf; });
$parcel$export(module.exports, "default", function () { return $086d1a88bf4b709d$export$2e2bcd8739ae039; });

var $1SirA = parcelRequire("1SirA");

var $398qk = parcelRequire("398qk");

var $3oQOj = parcelRequire("3oQOj");
const $086d1a88bf4b709d$var$projectSlice = (0, $1SirA.createSlice)({
    name: "currentProjectState",
    initialState: (0, $398qk.defaultState),
    reducers: {
        resetAction: ()=>(0, $398qk.defaultState),
        setColumnOrderAction: (state, action)=>{
            const columns = state.reviewEntriesColumns;
            // Payload is a state updater, which can either be a new state
            // or a function that takes the previous state and returns a new state.
            if (typeof action.payload === "function") columns.columnOrder = action.payload(columns.columnOrder);
            else columns.columnOrder = action.payload;
        },
        setColumnVisibilityAction: (state, action)=>{
            const columns = state.reviewEntriesColumns;
            // Payload is a state updater, which can either be a new state
            // or a function that takes the previous state and returns a new state.
            if (typeof action.payload === "function") columns.columnVisibility = action.payload(columns.columnVisibility);
            else columns.columnVisibility = action.payload;
        },
        setProjectAction: (state, action)=>{
            if (state.project.id !== action.payload.id) {
                state.reviewEntriesColumns = (0, $398qk.defaultState).reviewEntriesColumns;
                state.speaker = undefined;
                state.users = [];
            }
            state.project = action.payload;
        },
        setSemanticDomainsAction: (state, action)=>{
            state.semanticDomains = action.payload;
        },
        setSpeakerAction: (state, action)=>{
            state.speaker = action.payload;
        },
        setUsersAction: (state, action)=>{
            state.users = action.payload;
        }
    },
    extraReducers: (builder)=>builder.addCase((0, $3oQOj.StoreActionTypes).RESET, ()=>(0, $398qk.defaultState))
});
const { resetAction: $086d1a88bf4b709d$export$2e78289a93d130a3, setColumnOrderAction: $086d1a88bf4b709d$export$9d0812aae501c473, setColumnVisibilityAction: $086d1a88bf4b709d$export$bee4faced8592a, setProjectAction: $086d1a88bf4b709d$export$baebdcdae33c1b81, setSemanticDomainsAction: $086d1a88bf4b709d$export$ebf8cfd08cc7e0ee, setSpeakerAction: $086d1a88bf4b709d$export$6794d91415943410, setUsersAction: $086d1a88bf4b709d$export$a1178cce71c4f0bf } = $086d1a88bf4b709d$var$projectSlice.actions;
var $086d1a88bf4b709d$export$2e2bcd8739ae039 = $086d1a88bf4b709d$var$projectSlice.reducer;

});
parcelRegister("398qk", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $e58351912d842929$export$49d5fc8cba920a0; });

var $5DEjs = parcelRequire("5DEjs");
const $e58351912d842929$export$49d5fc8cba920a0 = {
    project: (0, $5DEjs.newProject)(),
    reviewEntriesColumns: {
        columnOrder: [],
        columnVisibility: {}
    },
    users: []
};

});
parcelRegister("5DEjs", function(module, exports) {

$parcel$export(module.exports, "newProject", function () { return $516d345f721a5513$export$5dbac6ca1d81f28; });
parcelRequire("585vO");
var $6MxFl = parcelRequire("6MxFl");
var $7FuOy = parcelRequire("7FuOy");

var $k1O7N = parcelRequire("k1O7N");

var $jQSAt = parcelRequire("jQSAt");
function $516d345f721a5513$export$5dbac6ca1d81f28(name = "") {
    return {
        id: "",
        name: name,
        isActive: true,
        liftImported: false,
        definitionsEnabled: false,
        grammaticalInfoEnabled: false,
        autocompleteSetting: (0, $7FuOy.OffOnSetting).On,
        harvesterReviewEntriesEnabled: (0, $7FuOy.OffOnSetting).Off,
        protectedDataMergeAvoidEnabled: (0, $7FuOy.OffOnSetting).Off,
        protectedDataOverrideEnabled: (0, $7FuOy.OffOnSetting).Off,
        semanticDomains: [],
        semDomWritingSystem: (0, $k1O7N.newWritingSystem)(),
        vernacularWritingSystem: (0, $k1O7N.newWritingSystem)(),
        analysisWritingSystems: [
            (0, $k1O7N.newWritingSystem)()
        ],
        validCharacters: [],
        rejectedCharacters: []
    };
}
function $516d345f721a5513$export$dbc38c8f8306ed97() {
    const project = $516d345f721a5513$export$5dbac6ca1d81f28((0, $jQSAt.randomIntString)());
    project.id = (0, $jQSAt.randomIntString)();
    project.isActive = Math.random() < 0.5;
    return project;
}
function $516d345f721a5513$export$9d9a56d7014d3ae4() {
    return {
        id: (0, $jQSAt.randomIntString)(),
        projectId: (0, $jQSAt.randomIntString)(),
        name: (0, $jQSAt.randomIntString)(),
        consent: (0, $6MxFl.ConsentType).None
    };
}

});
parcelRegister("k1O7N", function(module, exports) {

$parcel$export(module.exports, "Bcp47Code", function () { return $93bde7c1584804e5$export$f42664650f423cb; });
$parcel$export(module.exports, "newWritingSystem", function () { return $93bde7c1584804e5$export$cc779828b1882bfc; });
$parcel$export(module.exports, "defaultWritingSystem", function () { return $93bde7c1584804e5$export$e58b7da1d20be627; });
$parcel$export(module.exports, "uiWritingSystems", function () { return $93bde7c1584804e5$export$fc246d98301018ed; });
$parcel$export(module.exports, "semDomWritingSystems", function () { return $93bde7c1584804e5$export$457b08fde35314ed; });
$parcel$export(module.exports, "i18nFallbacks", function () { return $93bde7c1584804e5$export$98a4ca4f03ebae5a; });
$parcel$export(module.exports, "i18nLangs", function () { return $93bde7c1584804e5$export$574fd182070e83a3; });
var $93bde7c1584804e5$export$f42664650f423cb = /*#__PURE__*/ function(Bcp47Code) {
    Bcp47Code["Default"] = "en";
    Bcp47Code["Ar"] = "ar";
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    Bcp47Code["En"] = "en";
    Bcp47Code["Es"] = "es";
    Bcp47Code["Fr"] = "fr";
    Bcp47Code["Hi"] = "hi";
    Bcp47Code["Id"] = "id";
    Bcp47Code["Ml"] = "ml";
    Bcp47Code["My"] = "my";
    Bcp47Code["Pt"] = "pt";
    Bcp47Code["Ru"] = "ru";
    Bcp47Code["Sw"] = "sw";
    Bcp47Code["Te"] = "te";
    Bcp47Code["Zh"] = "zh";
    return Bcp47Code;
}({});
const $93bde7c1584804e5$var$writingSystem = {
    ["ar"]: $93bde7c1584804e5$export$cc779828b1882bfc("ar", "\u0627\u064E\u0644\u0652\u0639\u064E\u0631\u064E\u0628\u0650\u064A\u064E\u0651\u0629\u064F"),
    ["en"]: $93bde7c1584804e5$export$cc779828b1882bfc("en", "English"),
    ["es"]: $93bde7c1584804e5$export$cc779828b1882bfc("es", "Espa\xf1ol"),
    ["fr"]: $93bde7c1584804e5$export$cc779828b1882bfc("fr", "Fran\xe7ais"),
    ["hi"]: $93bde7c1584804e5$export$cc779828b1882bfc("hi", "\u0939\u093F\u0928\u094D\u0926\u0940"),
    ["id"]: $93bde7c1584804e5$export$cc779828b1882bfc("id", "Bahasa Indonesia"),
    ["ml"]: $93bde7c1584804e5$export$cc779828b1882bfc("ml", "\u0D2E\u0D32\u0D2F\u0D3E\u0D33\u0D02"),
    ["my"]: $93bde7c1584804e5$export$cc779828b1882bfc("my", "\u1019\u103C\u1014\u103A\u1019\u102C\u1005\u102C"),
    ["pt"]: $93bde7c1584804e5$export$cc779828b1882bfc("pt", "Portugu\xeas"),
    ["ru"]: $93bde7c1584804e5$export$cc779828b1882bfc("ru", "\u0440\u0443\u0441\u0441\u043A\u0438\u0439 \u044F\u0437\u044B\u043A"),
    ["sw"]: $93bde7c1584804e5$export$cc779828b1882bfc("sw", "Kiswahili"),
    ["te"]: $93bde7c1584804e5$export$cc779828b1882bfc("te", "\u0C24\u0C46\u0C32\u0C41\u0C17\u0C41"),
    ["zh"]: $93bde7c1584804e5$export$cc779828b1882bfc("zh", "\u4E2D\u6587")
};
const $93bde7c1584804e5$export$e58b7da1d20be627 = $93bde7c1584804e5$var$writingSystem["en"];
const $93bde7c1584804e5$export$fc246d98301018ed = [
    $93bde7c1584804e5$var$writingSystem["ar"],
    $93bde7c1584804e5$var$writingSystem["en"],
    $93bde7c1584804e5$var$writingSystem["es"],
    $93bde7c1584804e5$var$writingSystem["fr"],
    $93bde7c1584804e5$var$writingSystem["id"],
    $93bde7c1584804e5$var$writingSystem["pt"],
    $93bde7c1584804e5$var$writingSystem["zh"]
];
const $93bde7c1584804e5$export$457b08fde35314ed = [
    $93bde7c1584804e5$var$writingSystem["ar"],
    $93bde7c1584804e5$var$writingSystem["en"],
    $93bde7c1584804e5$var$writingSystem["es"],
    $93bde7c1584804e5$var$writingSystem["fr"],
    $93bde7c1584804e5$var$writingSystem["hi"],
    $93bde7c1584804e5$var$writingSystem["id"],
    $93bde7c1584804e5$var$writingSystem["ml"],
    $93bde7c1584804e5$var$writingSystem["my"],
    $93bde7c1584804e5$var$writingSystem["pt"],
    $93bde7c1584804e5$var$writingSystem["ru"],
    $93bde7c1584804e5$var$writingSystem["sw"],
    $93bde7c1584804e5$var$writingSystem["te"],
    $93bde7c1584804e5$var$writingSystem["zh"]
];
const $93bde7c1584804e5$export$98a4ca4f03ebae5a = {
    // Example for how to add non-English fallbacks:
    //  it: [Bcp47Code.Es, Bcp47Code.Pt, Bcp47Code.Default],
    default: [
        "en"
    ]
};
const $93bde7c1584804e5$export$574fd182070e83a3 = $93bde7c1584804e5$export$fc246d98301018ed.map((ws)=>ws.bcp47); //.concat(["it"]);
function $93bde7c1584804e5$export$cc779828b1882bfc(bcp47 = "", name = "", font = "", rtl) {
    if (rtl) return {
        bcp47: bcp47,
        name: name,
        font: font,
        rtl: rtl
    };
    return {
        bcp47: bcp47,
        name: name,
        font: font
    };
}

});

parcelRegister("jQSAt", function(module, exports) {

$parcel$export(module.exports, "randomIntString", function () { return $f6f7f86f472cec17$export$5835d71d0d5164bc; });
$parcel$export(module.exports, "getDateTimeString", function () { return $f6f7f86f472cec17$export$ccba155cdbfa7cb5; });
$parcel$export(module.exports, "getLocalizedDateTimeString", function () { return $f6f7f86f472cec17$export$cb343707b2370ab9; });
$parcel$export(module.exports, "LevenshteinDistance", function () { return $f6f7f86f472cec17$export$9bbe71f0ff68a23; });
$parcel$export(module.exports, "distinctColors", function () { return $f6f7f86f472cec17$export$ba7d5c9cd512282e; });
$parcel$export(module.exports, "getDuplicates", function () { return $f6f7f86f472cec17$export$1a47093b60e54e96; });

var $gs8xE = parcelRequire("gs8xE");
function $f6f7f86f472cec17$export$3ee86a19c825afb6(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}
function $f6f7f86f472cec17$export$5835d71d0d5164bc() {
    return Math.floor(Math.random() * 9999999).toString();
}
const $f6f7f86f472cec17$var$pathSep = {
    date: "-",
    dateTime: "_",
    time: "-"
};
function $f6f7f86f472cec17$export$ccba155cdbfa7cb5(utcString, sep) {
    const date = new Date(utcString ?? Date.now());
    const vals = [
        date.getFullYear(),
        // Date.getMonth() starts at 0 for January.
        date.getMonth() + 1,
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
    ];
    const strs = vals.map((value)=>value < 10 ? `0${value}` : `${value}`);
    const dateString = strs.slice(0, 3).join(sep?.date ?? $f6f7f86f472cec17$var$pathSep.date);
    const timeString = strs.slice(3, 6).join(sep?.time ?? $f6f7f86f472cec17$var$pathSep.time);
    return `${dateString}${sep?.dateTime ?? $f6f7f86f472cec17$var$pathSep.dateTime}${timeString}`;
}
function $f6f7f86f472cec17$export$cb343707b2370ab9(utcString, lang) {
    return new Date(utcString ?? Date.now()).toLocaleString(lang, {
        day: "numeric",
        hour: "numeric",
        hour12: true,
        minute: "2-digit",
        month: "short",
        weekday: "short",
        year: "numeric"
    });
}
const $f6f7f86f472cec17$export$214117b191ca1807 = {
    delCost: 1,
    insCost: 1,
    subCost: 1
};
class $f6f7f86f472cec17$export$9bbe71f0ff68a23 {
    constructor(params = $f6f7f86f472cec17$export$214117b191ca1807){
        this.deletionCost = params.delCost;
        this.insertionCost = params.insCost;
        this.substitutionCost = params.subCost;
    }
    getDistance(a, b) {
        const matrix = [];
        for(let i = 0; i <= a.length; i++){
            matrix[i] = [];
            for(let j = 0; j <= b.length; j++){
                // Populate first row & column.
                if (i === 0 || j === 0) {
                    matrix[i][j] = i * this.deletionCost + j * this.insertionCost;
                    continue;
                }
                // Recursively compute other entries.
                const tempSubCost = a[i - 1] === b[j - 1] ? 0 : this.substitutionCost;
                matrix[i][j] = Math.min(matrix[i - 1][j] + this.deletionCost, matrix[i][j - 1] + this.insertionCost, matrix[i - 1][j - 1] + tempSubCost);
            }
        }
        return matrix[a.length][b.length];
    }
}
/** Computes similarity of two 2-digit hex strings:
 * - 0 means identical
 * - 1 means `00` and `ff` */ function $f6f7f86f472cec17$var$compareHexPairs(a, b) {
    return Math.abs(parseInt(a, 16) - parseInt(b, 16)) / 255;
}
/** Computes similarity of two rbg hex strings:
 * - 0 means identical
 * - 1 means #000000 and #ffffff */ function $f6f7f86f472cec17$var$compareColors(a, b) {
    const rDiff = $f6f7f86f472cec17$var$compareHexPairs(a.slice(1, 3), b.slice(1, 3));
    const gDiff = $f6f7f86f472cec17$var$compareHexPairs(a.slice(3, 5), b.slice(3, 5));
    const bDiff = $f6f7f86f472cec17$var$compareHexPairs(a.slice(5, 7), b.slice(5, 7));
    return (rDiff + gDiff + bDiff) / 3;
}
const $f6f7f86f472cec17$var$black = "#000000";
const $f6f7f86f472cec17$var$white = "#ffffff";
function $f6f7f86f472cec17$export$ba7d5c9cd512282e(n, include = [
    $f6f7f86f472cec17$var$black,
    ...Object.values((0, $gs8xE.colorblindSafePalette))
], avoid = [
    $f6f7f86f472cec17$var$white
], threshold = 0.15) {
    if (n < 1) return [];
    if (n > 40) throw new Error(`distinctColors(n) cannot handle n = ${n} (> 40)`);
    const colors = [
        ...include
    ];
    while(colors.length < n){
        const randHexInt = Math.trunc(Math.random() * 0x1000000);
        const col = `#${randHexInt.toString(16).padStart(6, "0")}`;
        if ([
            ...colors,
            ...avoid
        ].every((c)=>$f6f7f86f472cec17$var$compareColors(c, col) > threshold)) colors.push(col);
    }
    return colors.slice(0, n);
}
function $f6f7f86f472cec17$export$1a47093b60e54e96(ids) {
    const counts = ids.reduce((map, id)=>{
        map.set(id, (map.get(id) ?? 0) + 1);
        return map;
    }, new Map());
    return Array.from(counts.entries()).filter(([, count])=>count > 1).map(([id])=>id);
}

});
parcelRegister("gs8xE", function(module, exports) {

$parcel$export(module.exports, "themeColors", function () { return $9437252018d371a9$export$4aa0a1b480cdb1b6; });
$parcel$export(module.exports, "default", function () { return $9437252018d371a9$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "colorblindSafePalette", function () { return $9437252018d371a9$export$ca60ad536d5e5af5; });

var $gal31 = parcelRequire("gal31");
var $hnm6Q = parcelRequire("hnm6Q");
var $2nhXL = parcelRequire("2nhXL");
var $5WQac = parcelRequire("5WQac");
var $9PTBs = parcelRequire("9PTBs");
var $eu5DW = parcelRequire("eu5DW");

var $hmhHQ = parcelRequire("hmhHQ");
var $eQjLE = parcelRequire("eQjLE");
const $9437252018d371a9$export$4aa0a1b480cdb1b6 = {
    primary: (0, $gal31.default)[600],
    secondary: (0, $2nhXL.default)[200],
    error: (0, $9PTBs.default)[600],
    warning: (0, $5WQac.default)[300],
    success: (0, $hnm6Q.default)[600],
    highlight: (0, $eu5DW.default)[200],
    lightShade: (0, $gal31.default)[700],
    darkShade: (0, $gal31.default)[900],
    recordIdle: (0, $9PTBs.default)[500],
    recordActive: (0, $9PTBs.default)[900]
};
// Constants used in multiple themes
const $9437252018d371a9$var$palette = {
    primary: {
        main: $9437252018d371a9$export$4aa0a1b480cdb1b6.primary
    },
    secondary: {
        main: $9437252018d371a9$export$4aa0a1b480cdb1b6.secondary
    },
    error: {
        main: $9437252018d371a9$export$4aa0a1b480cdb1b6.error
    },
    warning: {
        main: $9437252018d371a9$export$4aa0a1b480cdb1b6.warning
    },
    success: {
        main: $9437252018d371a9$export$4aa0a1b480cdb1b6.success
    },
    background: {
        default: $9437252018d371a9$export$4aa0a1b480cdb1b6.secondary
    },
    contrastThreshold: 3,
    tonalOffset: 0.2
};
const $9437252018d371a9$var$fontFamily = [
    "'Noto Sans'",
    "'Open Sans'",
    "Roboto",
    "Helvetica",
    "Arial",
    "sans-serif"
].join(",");
const $9437252018d371a9$var$dynamicFontParams = {
    factor: 2
};
// Theme for the entire project
const $9437252018d371a9$var$baseTheme = (0, $hmhHQ.default)({
    components: {
        MuiButton: {
            styleOverrides: {
                endIcon: {
                    marginInlineEnd: -4,
                    marginInlineStart: 8
                },
                startIcon: {
                    marginInlineEnd: 8,
                    marginInlineStart: -4
                }
            }
        },
        MuiButtonBase: {
            styleOverrides: {
                root: {
                    disableRipple: false
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: ".8em"
                }
            }
        }
    },
    palette: $9437252018d371a9$var$palette,
    spacing: 8,
    typography: {
        button: {
            textTransform: "none"
        },
        fontFamily: $9437252018d371a9$var$fontFamily
    }
});
var // Can have a number of additional options passed in; here, sticks with defaults
$9437252018d371a9$export$2e2bcd8739ae039 = (0, $eQjLE.default)($9437252018d371a9$var$baseTheme, $9437252018d371a9$var$dynamicFontParams);
const $9437252018d371a9$export$ca60ad536d5e5af5 = {
    1: "#f3c300",
    2: "#875692",
    3: "#f38400",
    4: "#a1caf1",
    5: "#be0032",
    6: "#c2b280",
    7: "#848482",
    8: "#008856",
    9: "#e68fac",
    10: "#0067a5",
    11: "#f99379",
    12: "#604e97",
    13: "#f6a600",
    14: "#b3446c",
    15: "#dcd300",
    16: "#882d17",
    17: "#8db600",
    18: "#654522",
    19: "#e25822",
    20: "#2b3d26"
};

});
parcelRegister("eu5DW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8b83ea61f9e7299$export$2e2bcd8739ae039; });
const $a8b83ea61f9e7299$var$yellow = {
    50: '#fffde7',
    100: '#fff9c4',
    200: '#fff59d',
    300: '#fff176',
    400: '#ffee58',
    500: '#ffeb3b',
    600: '#fdd835',
    700: '#fbc02d',
    800: '#f9a825',
    900: '#f57f17',
    A100: '#ffff8d',
    A200: '#ffff00',
    A400: '#ffea00',
    A700: '#ffd600'
};
var $a8b83ea61f9e7299$export$2e2bcd8739ae039 = $a8b83ea61f9e7299$var$yellow;

});

parcelRegister("eQjLE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ace541721e7c5460$export$2e2bcd8739ae039; });

var $diYUK = parcelRequire("diYUK");

var $lvsHI = parcelRequire("lvsHI");
function $ace541721e7c5460$export$2e2bcd8739ae039(themeInput, options = {}) {
    const { breakpoints: breakpoints = [
        'sm',
        'md',
        'lg'
    ], disableAlign: disableAlign = false, factor: factor = 2, variants: variants = [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'subtitle1',
        'subtitle2',
        'body1',
        'body2',
        'caption',
        'button',
        'overline'
    ] } = options;
    const theme = {
        ...themeInput
    };
    theme.typography = {
        ...theme.typography
    };
    const typography = theme.typography;
    // Convert between CSS lengths e.g. em->px or px->rem
    // Set the baseFontSize for your project. Defaults to 16px (also the browser default).
    const convert = (0, $lvsHI.convertLength)(typography.htmlFontSize);
    const breakpointValues = breakpoints.map((x)=>theme.breakpoints.values[x]);
    variants.forEach((variant)=>{
        const style = typography[variant];
        if (!style) return;
        const remFontSize = parseFloat(convert(style.fontSize, 'rem'));
        if (remFontSize <= 1) return;
        const maxFontSize = remFontSize;
        const minFontSize = 1 + (maxFontSize - 1) / factor;
        let { lineHeight: lineHeight } = style;
        if (!(0, $lvsHI.isUnitless)(lineHeight) && !disableAlign) throw new Error((0, $diYUK.default)(6));
        if (!(0, $lvsHI.isUnitless)(lineHeight)) // make it unitless
        lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
        let transform = null;
        if (!disableAlign) transform = (value)=>(0, $lvsHI.alignProperty)({
                size: value,
                grid: (0, $lvsHI.fontGrid)({
                    pixels: 4,
                    lineHeight: lineHeight,
                    htmlFontSize: typography.htmlFontSize
                })
            });
        typography[variant] = {
            ...style,
            ...(0, $lvsHI.responsiveProperty)({
                cssProperty: 'fontSize',
                min: minFontSize,
                max: maxFontSize,
                unit: 'rem',
                breakpoints: breakpointValues,
                transform: transform
            })
        };
    });
    return theme;
}

});
parcelRegister("lvsHI", function(module, exports) {

$parcel$export(module.exports, "isUnitless", function () { return $fa82c24039cb02ec$export$9623ad5dc13f2eaa; });
$parcel$export(module.exports, "getUnit", function () { return $fa82c24039cb02ec$export$65f2564e9a9b9222; });
$parcel$export(module.exports, "toUnitless", function () { return $fa82c24039cb02ec$export$8af1d214c6c2f0f1; });
$parcel$export(module.exports, "convertLength", function () { return $fa82c24039cb02ec$export$ea1536a749e80563; });
$parcel$export(module.exports, "alignProperty", function () { return $fa82c24039cb02ec$export$aec9aaffd8096b21; });
$parcel$export(module.exports, "fontGrid", function () { return $fa82c24039cb02ec$export$63653082df276400; });
$parcel$export(module.exports, "responsiveProperty", function () { return $fa82c24039cb02ec$export$26a139329f9dd721; });
function $fa82c24039cb02ec$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $fa82c24039cb02ec$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
function $fa82c24039cb02ec$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $fa82c24039cb02ec$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $fa82c24039cb02ec$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $fa82c24039cb02ec$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = $fa82c24039cb02ec$export$8af1d214c6c2f0f1(length) * $fa82c24039cb02ec$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === 'rem') pxLength = $fa82c24039cb02ec$export$8af1d214c6c2f0f1(length) * $fa82c24039cb02ec$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / $fa82c24039cb02ec$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / $fa82c24039cb02ec$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $fa82c24039cb02ec$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $fa82c24039cb02ec$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $fa82c24039cb02ec$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = 'rem', breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}

});







parcelRegister("4jgI5", function(module, exports) {

$parcel$export(module.exports, "downloadingAction", function () { return $dc23ea150e9cbdaa$export$a5b0924f87156bf7; });
$parcel$export(module.exports, "exportingAction", function () { return $dc23ea150e9cbdaa$export$9ced16de77ee85b2; });
$parcel$export(module.exports, "failureAction", function () { return $dc23ea150e9cbdaa$export$346838377ba4b35c; });
$parcel$export(module.exports, "resetExportAction", function () { return $dc23ea150e9cbdaa$export$c2bacee5481aff2d; });
$parcel$export(module.exports, "successAction", function () { return $dc23ea150e9cbdaa$export$67309878e25ff70e; });
$parcel$export(module.exports, "default", function () { return $dc23ea150e9cbdaa$export$2e2bcd8739ae039; });

var $1SirA = parcelRequire("1SirA");

var $d6fIw = parcelRequire("d6fIw");

var $3oQOj = parcelRequire("3oQOj");
const $dc23ea150e9cbdaa$var$exportProjectSlice = (0, $1SirA.createSlice)({
    name: "exportProjectState",
    initialState: (0, $d6fIw.defaultState),
    reducers: {
        downloadingAction: (state, action)=>{
            state.projectId = action.payload;
            state.status = (0, $d6fIw.ExportStatus).Downloading;
        },
        exportingAction: (state, action)=>{
            state.projectId = action.payload;
            state.status = (0, $d6fIw.ExportStatus).Exporting;
        },
        failureAction: (state, action)=>{
            state.projectId = action.payload;
            state.status = (0, $d6fIw.ExportStatus).Failure;
        },
        resetExportAction: ()=>(0, $d6fIw.defaultState),
        successAction: (state, action)=>{
            state.projectId = action.payload;
            state.status = (0, $d6fIw.ExportStatus).Success;
        }
    },
    extraReducers: (builder)=>builder.addCase((0, $3oQOj.StoreActionTypes).RESET, ()=>(0, $d6fIw.defaultState))
});
const { downloadingAction: $dc23ea150e9cbdaa$export$a5b0924f87156bf7, exportingAction: $dc23ea150e9cbdaa$export$9ced16de77ee85b2, failureAction: $dc23ea150e9cbdaa$export$346838377ba4b35c, resetExportAction: $dc23ea150e9cbdaa$export$c2bacee5481aff2d, successAction: $dc23ea150e9cbdaa$export$67309878e25ff70e } = $dc23ea150e9cbdaa$var$exportProjectSlice.actions;
var $dc23ea150e9cbdaa$export$2e2bcd8739ae039 = $dc23ea150e9cbdaa$var$exportProjectSlice.reducer;

});
parcelRegister("d6fIw", function(module, exports) {

$parcel$export(module.exports, "ExportStatus", function () { return $a7d1c786a2a19497$export$602981314f6adf1a; });
$parcel$export(module.exports, "defaultState", function () { return $a7d1c786a2a19497$export$49d5fc8cba920a0; });
var $a7d1c786a2a19497$export$602981314f6adf1a = /*#__PURE__*/ function(ExportStatus) {
    ExportStatus["Default"] = "DEFAULT";
    ExportStatus["Exporting"] = "EXPORTING";
    ExportStatus["Downloading"] = "DOWNLOADING";
    ExportStatus["Success"] = "SUCCESS";
    ExportStatus["Failure"] = "FAILURE";
    return ExportStatus;
}({});
const $a7d1c786a2a19497$export$49d5fc8cba920a0 = {
    projectId: "",
    status: "DEFAULT"
};

});


parcelRegister("9CmlZ", function(module, exports) {

$parcel$export(module.exports, "resetAction", function () { return $947a95a0b13ddccd$export$2e78289a93d130a3; });
$parcel$export(module.exports, "setPlayingAction", function () { return $947a95a0b13ddccd$export$7f5b068b4d47a226; });
$parcel$export(module.exports, "setRecordingAction", function () { return $947a95a0b13ddccd$export$d1bfc36ce3d17d2b; });
$parcel$export(module.exports, "default", function () { return $947a95a0b13ddccd$export$2e2bcd8739ae039; });

var $1SirA = parcelRequire("1SirA");

var $68fUN = parcelRequire("68fUN");

var $3oQOj = parcelRequire("3oQOj");
const $947a95a0b13ddccd$var$pronunciationsSlice = (0, $1SirA.createSlice)({
    name: "pronunciationsState",
    initialState: (0, $68fUN.defaultState),
    reducers: {
        resetAction: ()=>(0, $68fUN.defaultState),
        setPlayingAction: (state, action)=>{
            state.fileName = action.payload;
            state.status = (0, $68fUN.PronunciationsStatus).Playing;
            state.wordId = "";
        },
        setRecordingAction: (state, action)=>{
            state.fileName = "";
            state.status = (0, $68fUN.PronunciationsStatus).Recording;
            state.wordId = action.payload;
        }
    },
    extraReducers: (builder)=>builder.addCase((0, $3oQOj.StoreActionTypes).RESET, ()=>(0, $68fUN.defaultState))
});
const { resetAction: $947a95a0b13ddccd$export$2e78289a93d130a3, setPlayingAction: $947a95a0b13ddccd$export$7f5b068b4d47a226, setRecordingAction: $947a95a0b13ddccd$export$d1bfc36ce3d17d2b } = $947a95a0b13ddccd$var$pronunciationsSlice.actions;
var $947a95a0b13ddccd$export$2e2bcd8739ae039 = $947a95a0b13ddccd$var$pronunciationsSlice.reducer;

});
parcelRegister("68fUN", function(module, exports) {

$parcel$export(module.exports, "PronunciationsStatus", function () { return $6f0c33380de15ae5$export$49b019e2d6b0ab14; });
$parcel$export(module.exports, "defaultState", function () { return $6f0c33380de15ae5$export$49d5fc8cba920a0; });
var $6f0c33380de15ae5$export$49b019e2d6b0ab14 = /*#__PURE__*/ function(PronunciationsStatus) {
    PronunciationsStatus["Inactive"] = "INACTIVE";
    PronunciationsStatus["Playing"] = "PLAYING";
    PronunciationsStatus["Recording"] = "RECORDING";
    return PronunciationsStatus;
}({});
const $6f0c33380de15ae5$export$49d5fc8cba920a0 = {
    fileName: "",
    status: "INACTIVE",
    wordId: ""
};

});


parcelRegister("Gqrrr", function(module, exports) {

$parcel$export(module.exports, "resetTreeAction", function () { return $fdc96307f0caac34$export$6e09a6076977007; });
$parcel$export(module.exports, "setCurrentDomainAction", function () { return $fdc96307f0caac34$export$f7054e3bd69cb024; });
$parcel$export(module.exports, "setDomainLanguageAction", function () { return $fdc96307f0caac34$export$273b48008e007ffb; });
$parcel$export(module.exports, "setTreeOpenAction", function () { return $fdc96307f0caac34$export$bab948e62dcc5d3c; });
$parcel$export(module.exports, "default", function () { return $fdc96307f0caac34$export$2e2bcd8739ae039; });

var $1SirA = parcelRequire("1SirA");

var $6knxE = parcelRequire("6knxE");

var $3oQOj = parcelRequire("3oQOj");
const $fdc96307f0caac34$var$treeViewSlice = (0, $1SirA.createSlice)({
    name: "treeViewState",
    initialState: (0, $6knxE.defaultState),
    reducers: {
        resetTreeAction: ()=>(0, $6knxE.defaultState),
        setCurrentDomainAction: (state, action)=>{
            state.currentDomain = action.payload;
        },
        setDomainLanguageAction: (state, action)=>{
            state.currentDomain.lang = action.payload;
            state.language = action.payload;
        },
        setTreeOpenAction: (state, action)=>{
            state.open = action.payload;
        }
    },
    extraReducers: (builder)=>builder.addCase((0, $3oQOj.StoreActionTypes).RESET, ()=>(0, $6knxE.defaultState))
});
const { resetTreeAction: $fdc96307f0caac34$export$6e09a6076977007, setCurrentDomainAction: $fdc96307f0caac34$export$f7054e3bd69cb024, setDomainLanguageAction: $fdc96307f0caac34$export$273b48008e007ffb, setTreeOpenAction: $fdc96307f0caac34$export$bab948e62dcc5d3c } = $fdc96307f0caac34$var$treeViewSlice.actions;
var $fdc96307f0caac34$export$2e2bcd8739ae039 = $fdc96307f0caac34$var$treeViewSlice.reducer;

});
parcelRegister("6knxE", function(module, exports) {

$parcel$export(module.exports, "defaultTreeNode", function () { return $fb86541893b0ea61$export$450ae500a1b671c3; });
$parcel$export(module.exports, "defaultState", function () { return $fb86541893b0ea61$export$49d5fc8cba920a0; });

var $1RQxh = parcelRequire("1RQxh");
const $fb86541893b0ea61$export$450ae500a1b671c3 = (0, $1RQxh.newSemanticDomainTreeNode)((0, $1RQxh.rootId));
const $fb86541893b0ea61$export$49d5fc8cba920a0 = {
    language: "",
    open: false,
    currentDomain: $fb86541893b0ea61$export$450ae500a1b671c3
};

});
parcelRegister("1RQxh", function(module, exports) {

$parcel$export(module.exports, "rootId", function () { return $a12ec4753bf5482a$export$e30830ab5f6ae58d; });
$parcel$export(module.exports, "newSemanticDomain", function () { return $a12ec4753bf5482a$export$9b07f3ac903a8f84; });
$parcel$export(module.exports, "newSemanticDomainForMongoDB", function () { return $a12ec4753bf5482a$export$f246474dfab5fab9; });
$parcel$export(module.exports, "newSemanticDomainTreeNode", function () { return $a12ec4753bf5482a$export$85ee18ee491f7fb8; });
$parcel$export(module.exports, "treeNodeFromSemDom", function () { return $a12ec4753bf5482a$export$5fba33639f81bed9; });

var $1a3s7 = parcelRequire("1a3s7");

var $k1O7N = parcelRequire("k1O7N");
const $a12ec4753bf5482a$export$e30830ab5f6ae58d = "Sem";
function $a12ec4753bf5482a$export$9b07f3ac903a8f84(id = "", name = "", lang = (0, $k1O7N.Bcp47Code).Default) {
    return {
        guid: crypto.randomUUID(),
        id: id,
        name: name,
        lang: lang,
        description: "",
        parentId: "",
        questions: []
    };
}
function $a12ec4753bf5482a$export$f246474dfab5fab9(dom) {
    const { mongoId: mongoId, guid: guid, name: name, id: id } = dom;
    const lang = dom.lang || (0, $k1O7N.Bcp47Code).Default;
    const userId = (0, $1a3s7.getUserId)();
    const created = new Date().toISOString();
    return {
        mongoId: mongoId,
        guid: guid,
        name: name,
        id: id,
        lang: lang,
        userId: userId,
        created: created
    };
}
function $a12ec4753bf5482a$export$85ee18ee491f7fb8(id = "", name = "", lang = (0, $k1O7N.Bcp47Code).Default) {
    return {
        parent: undefined,
        previous: undefined,
        next: undefined,
        children: [],
        id: id,
        name: name,
        lang: lang,
        guid: crypto.randomUUID()
    };
}
function $a12ec4753bf5482a$export$875566f38567287b(domainSet = new Set()) {
    return {
        id: "",
        domainSet: domainSet
    };
}
function $a12ec4753bf5482a$export$47a75e842001521c(semanticDomainTreeNode, count = 0) {
    return {
        semanticDomainTreeNode: semanticDomainTreeNode,
        count: count
    };
}
function $a12ec4753bf5482a$export$12c99207a98ddf8c(node) {
    const dom = $a12ec4753bf5482a$export$9b07f3ac903a8f84(node.id, node.name, node.lang);
    return {
        ...dom,
        guid: node.guid
    };
}
function $a12ec4753bf5482a$export$5fba33639f81bed9(dom) {
    const node = $a12ec4753bf5482a$export$85ee18ee491f7fb8(dom.id, dom.name, dom.lang);
    return {
        ...node,
        guid: dom.guid
    };
}

});



parcelRegister("7qclf", function(module, exports) {

$parcel$export(module.exports, "addRejectedCharacterAction", function () { return $c6ae914eba05f881$export$f8b649e4b962df5a; });
$parcel$export(module.exports, "addValidCharacterAction", function () { return $c6ae914eba05f881$export$9e8932c8675b8661; });
$parcel$export(module.exports, "resetCharInvAction", function () { return $c6ae914eba05f881$export$e1f481ec438f85a8; });
$parcel$export(module.exports, "setAllWordsAction", function () { return $c6ae914eba05f881$export$26c7e64e93a5c22c; });
$parcel$export(module.exports, "setCharacterSetAction", function () { return $c6ae914eba05f881$export$74465046ee4d4000; });
$parcel$export(module.exports, "setRejectedCharactersAction", function () { return $c6ae914eba05f881$export$1be1e5c2a8abf240; });
$parcel$export(module.exports, "setSelectedCharacterAction", function () { return $c6ae914eba05f881$export$f50ef3c7f39d4fb9; });
$parcel$export(module.exports, "setValidCharactersAction", function () { return $c6ae914eba05f881$export$155d8b97b569d533; });
$parcel$export(module.exports, "default", function () { return $c6ae914eba05f881$export$2e2bcd8739ae039; });

var $1SirA = parcelRequire("1SirA");

var $kODQb = parcelRequire("kODQb");

var $3oQOj = parcelRequire("3oQOj");
const $c6ae914eba05f881$var$characterInventorySlice = (0, $1SirA.createSlice)({
    name: "characterInventoryState",
    initialState: (0, $kODQb.defaultState),
    reducers: {
        addRejectedCharacterAction: (state, action)=>{
            if (!state.rejectedCharacters.includes(action.payload)) state.rejectedCharacters.push(action.payload);
            const index = state.validCharacters.findIndex((c)=>c == action.payload);
            if (index > -1) state.validCharacters.splice(index, 1);
            const entry = state.characterSet.find((e)=>e.character === action.payload);
            if (entry) entry.status = (0, $kODQb.getCharacterStatus)(entry.character, state.validCharacters, state.rejectedCharacters);
        },
        addValidCharacterAction: (state, action)=>{
            if (!state.validCharacters.includes(action.payload)) state.validCharacters.push(action.payload);
            const index = state.rejectedCharacters.findIndex((c)=>c == action.payload);
            if (index > -1) state.rejectedCharacters.splice(index, 1);
            const entry = state.characterSet.find((e)=>e.character === action.payload);
            if (entry) entry.status = (0, $kODQb.getCharacterStatus)(entry.character, state.validCharacters, state.rejectedCharacters);
        },
        resetCharInvAction: ()=>(0, $kODQb.defaultState),
        setAllWordsAction: (state, action)=>{
            state.allWords = action.payload;
        },
        setCharacterSetAction: (state, action)=>{
            if (action.payload) state.characterSet = action.payload;
        },
        setRejectedCharactersAction: (state, action)=>{
            state.rejectedCharacters = [
                ...new Set(action.payload)
            ];
            state.validCharacters = state.validCharacters.filter((char)=>!state.rejectedCharacters.includes(char));
            for (const entry of state.characterSet)entry.status = (0, $kODQb.getCharacterStatus)(entry.character, state.validCharacters, state.rejectedCharacters);
        },
        setSelectedCharacterAction: (state, action)=>{
            state.selectedCharacter = action.payload;
        },
        setValidCharactersAction: (state, action)=>{
            state.validCharacters = [
                ...new Set(action.payload)
            ];
            state.rejectedCharacters = state.rejectedCharacters.filter((char)=>!state.validCharacters.includes(char));
            for (const entry of state.characterSet)entry.status = (0, $kODQb.getCharacterStatus)(entry.character, state.validCharacters, state.rejectedCharacters);
        }
    },
    extraReducers: (builder)=>builder.addCase((0, $3oQOj.StoreActionTypes).RESET, ()=>(0, $kODQb.defaultState))
});
const { addRejectedCharacterAction: $c6ae914eba05f881$export$f8b649e4b962df5a, addValidCharacterAction: $c6ae914eba05f881$export$9e8932c8675b8661, resetCharInvAction: $c6ae914eba05f881$export$e1f481ec438f85a8, setAllWordsAction: $c6ae914eba05f881$export$26c7e64e93a5c22c, setCharacterSetAction: $c6ae914eba05f881$export$74465046ee4d4000, setRejectedCharactersAction: $c6ae914eba05f881$export$1be1e5c2a8abf240, setSelectedCharacterAction: $c6ae914eba05f881$export$f50ef3c7f39d4fb9, setValidCharactersAction: $c6ae914eba05f881$export$155d8b97b569d533 } = $c6ae914eba05f881$var$characterInventorySlice.actions;
var $c6ae914eba05f881$export$2e2bcd8739ae039 = $c6ae914eba05f881$var$characterInventorySlice.reducer;

});
parcelRegister("kODQb", function(module, exports) {

$parcel$export(module.exports, "getCharacterStatus", function () { return $3e570819cbb2d6d1$export$327f27f0fb852396; });
$parcel$export(module.exports, "defaultState", function () { return $3e570819cbb2d6d1$export$49d5fc8cba920a0; });

var $3tDFg = parcelRequire("3tDFg");
function $3e570819cbb2d6d1$export$327f27f0fb852396(char, validChars, rejectedChars) {
    if (validChars.includes(char)) return (0, $3tDFg.CharacterStatus).Accepted;
    if (rejectedChars.includes(char)) return (0, $3tDFg.CharacterStatus).Rejected;
    return (0, $3tDFg.CharacterStatus).Undecided;
}
const $3e570819cbb2d6d1$export$49d5fc8cba920a0 = {
    validCharacters: [],
    rejectedCharacters: [],
    allWords: [],
    selectedCharacter: "",
    characterSet: []
};
function $3e570819cbb2d6d1$export$b633b2704b6469fa(character) {
    return {
        character: character,
        occurrences: 0,
        status: (0, $3tDFg.CharacterStatus).Undecided
    };
}

});
parcelRegister("3tDFg", function(module, exports) {

$parcel$export(module.exports, "CreateCharInv", function () { return $bfbbe765cac7efde$export$82baddc68d3b2855; });
$parcel$export(module.exports, "CharacterStatus", function () { return $bfbbe765cac7efde$export$8aa5aa332581390d; });
$parcel$export(module.exports, "defaultCharInvChanges", function () { return $bfbbe765cac7efde$export$4a2402cb8814fb50; });

var $eY0YF = parcelRequire("eY0YF");
class $bfbbe765cac7efde$export$82baddc68d3b2855 extends (0, $eY0YF.Goal) {
    constructor(steps = [
        {
            inventory: []
        }
    ], data = {
        inventory: [
            []
        ]
    }){
        super((0, $eY0YF.GoalType).CreateCharInv, (0, $eY0YF.GoalName).CreateCharInv, steps, data);
    }
}
var $bfbbe765cac7efde$export$8aa5aa332581390d = /*#__PURE__*/ function(CharacterStatus) {
    CharacterStatus["Accepted"] = "accepted";
    CharacterStatus["Rejected"] = "rejected";
    CharacterStatus["Undecided"] = "undecided";
    return CharacterStatus;
}({});
const $bfbbe765cac7efde$export$4a2402cb8814fb50 = {
    charChanges: [],
    wordChanges: []
};

});
parcelRegister("eY0YF", function(module, exports) {

$parcel$export(module.exports, "GoalType", function () { return $06b411bf46b50d09$export$8120b812875adc53; });
$parcel$export(module.exports, "GoalName", function () { return $06b411bf46b50d09$export$4427fb3cde8dd0cf; });
$parcel$export(module.exports, "GoalStatus", function () { return $06b411bf46b50d09$export$617443c5f198a389; });
$parcel$export(module.exports, "Goal", function () { return $06b411bf46b50d09$export$462e530a9b3886e4; });
var $06b411bf46b50d09$export$8120b812875adc53 = /*#__PURE__*/ function(GoalType) {
    GoalType[GoalType["Default"] = -1] = "Default";
    GoalType[GoalType["CreateCharInv"] = 0] = "CreateCharInv";
    GoalType[GoalType["CreateStrWordInv"] = 2] = "CreateStrWordInv";
    GoalType[GoalType["HandleFlags"] = 7] = "HandleFlags";
    GoalType[GoalType["MergeDups"] = 4] = "MergeDups";
    GoalType[GoalType["ReviewDeferredDups"] = 8] = "ReviewDeferredDups";
    GoalType[GoalType["ReviewEntries"] = 6] = "ReviewEntries";
    GoalType[GoalType["SpellCheckGloss"] = 5] = "SpellCheckGloss";
    GoalType[GoalType["ValidateChars"] = 1] = "ValidateChars";
    GoalType[GoalType["ValidateStrWords"] = 3] = "ValidateStrWords";
    return GoalType;
}({});
var $06b411bf46b50d09$export$4427fb3cde8dd0cf = /*#__PURE__*/ function(GoalName) {
    GoalName["Default"] = "default";
    GoalName["CreateCharInv"] = "charInventory";
    GoalName["CreateStrWordInv"] = "createStrWordInv";
    GoalName["HandleFlags"] = "handleFlags";
    GoalName["MergeDups"] = "mergeDups";
    GoalName["ReviewDeferredDups"] = "reviewDeferredDups";
    GoalName["ReviewEntries"] = "reviewEntries";
    GoalName["SpellCheckGloss"] = "spellCheckGloss";
    GoalName["ValidateChars"] = "validateChars";
    GoalName["ValidateStrWords"] = "validateStrWords";
    return GoalName;
}({});
var $06b411bf46b50d09$export$617443c5f198a389 = /*#__PURE__*/ function(GoalStatus) {
    GoalStatus["Loading"] = "LOADING";
    GoalStatus["InProgress"] = "IN_PROGRESS";
    GoalStatus["Completed"] = "COMPLETED";
    return GoalStatus;
}({});
class $06b411bf46b50d09$export$462e530a9b3886e4 {
    constructor(type = -1, name = "default", steps = [
        {}
    ], data){
        this.guid = crypto.randomUUID();
        this.goalType = type;
        this.name = name;
        this.steps = steps;
        this.numSteps = 1;
        this.currentStep = 0;
        this.data = data;
        this.status = "LOADING";
    }
}

});




parcelRegister("i3ZTD", function(module, exports) {

$parcel$export(module.exports, "clearMergeWordsAction", function () { return $fc04f64d96ddbd69$export$5136620ac892ddf7; });
$parcel$export(module.exports, "clearTreeAction", function () { return $fc04f64d96ddbd69$export$77fa9fdcc4d7ee0; });
$parcel$export(module.exports, "combineSenseAction", function () { return $fc04f64d96ddbd69$export$3cc2317805b51b14; });
$parcel$export(module.exports, "deleteSenseAction", function () { return $fc04f64d96ddbd69$export$2e0f83b204ec839c; });
$parcel$export(module.exports, "flagWordAction", function () { return $fc04f64d96ddbd69$export$33f7bc8190d0f3a4; });
$parcel$export(module.exports, "getMergeWordsAction", function () { return $fc04f64d96ddbd69$export$9a051982ef39276f; });
$parcel$export(module.exports, "moveDuplicateAction", function () { return $fc04f64d96ddbd69$export$594351f4af7c6aaa; });
$parcel$export(module.exports, "moveSenseAction", function () { return $fc04f64d96ddbd69$export$e3f6299142b59d2f; });
$parcel$export(module.exports, "orderDuplicateAction", function () { return $fc04f64d96ddbd69$export$39b2957690a358c4; });
$parcel$export(module.exports, "orderSenseAction", function () { return $fc04f64d96ddbd69$export$9eb884de1a3601ee; });
$parcel$export(module.exports, "resetTreeToInitialAction", function () { return $fc04f64d96ddbd69$export$21e2e0289ddbfc00; });
$parcel$export(module.exports, "setDataAction", function () { return $fc04f64d96ddbd69$export$d874377755626307; });
$parcel$export(module.exports, "setSidebarAction", function () { return $fc04f64d96ddbd69$export$9e87ff0807376738; });
$parcel$export(module.exports, "setVernacularAction", function () { return $fc04f64d96ddbd69$export$2aabbad46099ddbd; });
$parcel$export(module.exports, "toggleOverrideProtectionAction", function () { return $fc04f64d96ddbd69$export$c9a6be6a13f32a23; });
$parcel$export(module.exports, "default", function () { return $fc04f64d96ddbd69$export$2e2bcd8739ae039; });

var $1SirA = parcelRequire("1SirA");
parcelRequire("585vO");
var $csqcy = parcelRequire("csqcy");

var $iWuTI = parcelRequire("iWuTI");

var $1dWz9 = parcelRequire("1dWz9");

var $d7TC6 = parcelRequire("d7TC6");

var $3oQOj = parcelRequire("3oQOj");

var $5gW1E = parcelRequire("5gW1E");
const $fc04f64d96ddbd69$var$mergeDuplicatesSlice = (0, $1SirA.createSlice)({
    name: "mergeDupStepReducer",
    initialState: (0, $1dWz9.defaultState),
    reducers: {
        clearMergeWordsAction: (state)=>{
            state.mergeWords = [];
        },
        clearTreeAction: ()=>{
            return 0, $1dWz9.defaultState;
        },
        combineSenseAction: (state, action)=>{
            const srcRef = action.payload.src;
            const destRef = action.payload.dest;
            // Ignore dropping a sense (or one of its sub-senses) into itself.
            if (srcRef.mergeSenseId !== destRef.mergeSenseId) {
                const words = state.tree.words;
                const srcWordId = srcRef.wordId;
                const srcGuids = words[srcWordId].sensesGuids[srcRef.mergeSenseId];
                const destWordId = destRef.wordId;
                const destGuids = [];
                if (srcRef.order === undefined || srcGuids.length === 1) {
                    // A sense from a word dropped into another sense.
                    destGuids.push(...srcGuids);
                    delete words[srcWordId].sensesGuids[srcRef.mergeSenseId];
                    if (!Object.keys(words[srcWordId].sensesGuids).length) {
                        // If this was the word's last sense, move the audio...
                        const moves = state.audio.moves;
                        if (!Object.keys(moves).includes(destWordId)) moves[destWordId] = [];
                        if (state.data.words[srcWordId]) moves[destWordId].push(srcWordId);
                        if (Object.keys(moves).includes(srcWordId)) {
                            moves[destWordId].push(...moves[srcWordId]);
                            delete moves[srcWordId];
                        }
                        // ...and delete the word from the tree
                        delete words[srcWordId];
                    }
                } else {
                    // A sense from the sidebar dropped into another sense.
                    destGuids.push(srcGuids.splice(srcRef.order, 1)[0]);
                    if (srcGuids.length < 2) // If not multiple senses in the sidebar, reset the sidebar.
                    state.tree.sidebar = (0, $iWuTI.defaultSidebar);
                }
                words[destWordId].sensesGuids[destRef.mergeSenseId].push(...destGuids);
                state.tree.words = words;
            }
        },
        deleteSenseAction: (state, action)=>{
            const srcRef = action.payload;
            const srcWordId = srcRef.wordId;
            const { deletedSenseGuids: deletedSenseGuids, words: words } = state.tree;
            const sensesGuids = words[srcWordId].sensesGuids;
            const srcGuids = sensesGuids[srcRef.mergeSenseId];
            if (srcRef.order === undefined || srcGuids.length === 1) {
                // A sense deleted from a word.
                deletedSenseGuids.push(...srcGuids);
                delete sensesGuids[srcRef.mergeSenseId];
                if (!Object.keys(sensesGuids).length) {
                    delete state.audio.moves[srcWordId];
                    delete words[srcWordId];
                }
                // If the deleted sense was open in the sidebar, reset the sidebar.
                const { mergeSenseId: mergeSenseId, wordId: wordId } = state.tree.sidebar.senseRef;
                if (mergeSenseId === srcRef.mergeSenseId && wordId === srcRef.wordId) state.tree.sidebar = (0, $iWuTI.defaultSidebar);
            } else {
                // A sense deleted from the sidebar.
                deletedSenseGuids.push(srcGuids[srcRef.order]);
                srcGuids.splice(srcRef.order, 1);
                if (srcGuids.length < 2) // If not multiple senses in the sidebar, reset the sidebar.
                state.tree.sidebar = (0, $iWuTI.defaultSidebar);
            }
        },
        flagWordAction: (state, action)=>{
            state.tree.words[action.payload.wordId].flag = action.payload.flag;
        },
        getMergeWordsAction: (state)=>{
            const dataWords = Object.values(state.data.words);
            const deletedSenseGuids = state.tree.deletedSenseGuids;
            // First handle words with all senses deleted.
            state.mergeWords = (0, $d7TC6.getDeletedMergeWords)(dataWords, deletedSenseGuids);
            // Then build the rest of the mergeWords.
            // Gather all senses (accessibility will be updated as mergeWords are built).
            const wordTreeSenses = (0, $d7TC6.gatherWordSenses)(dataWords, deletedSenseGuids);
            const allSenses = Object.values(wordTreeSenses).flatMap((mergeSenses)=>mergeSenses.map((ms)=>ms.sense));
            // Build one merge word per column.
            for(const wordId in state.tree.words){
                // Get from tree the basic info for this column.
                const mergeWord = state.tree.words[wordId];
                // Get from data all senses in this column.
                const mergeSenses = Object.values(mergeWord.sensesGuids).map((guids)=>guids.map((g)=>state.data.senses[g]));
                // Update those senses in the set of all senses.
                mergeSenses.forEach((senses)=>{
                    const sensesToUpdate = senses.map((s)=>wordTreeSenses[s.srcWordId][s.order]);
                    (0, $d7TC6.combineIntoFirstSense)(sensesToUpdate);
                });
                // Check if nothing to merge.
                const wordToUpdate = state.data.words[wordId] || (0, $5gW1E.newWord)();
                const audioMoves = state.audio.moves[wordId];
                if ((0, $d7TC6.isEmptyMerge)(wordToUpdate, mergeWord) && !audioMoves?.length) continue;
                // Create merge words.
                const children = (0, $d7TC6.createMergeChildren)(mergeSenses, audioMoves);
                const parent = (0, $d7TC6.createMergeParent)(wordToUpdate, mergeWord, allSenses);
                state.mergeWords.push({
                    parent: parent,
                    children: children,
                    deleteOnly: false
                });
            }
        },
        moveSenseAction: (state, action)=>{
            const destWordId = action.payload.destWordId;
            const srcRef = action.payload.src;
            const srcWordId = srcRef.wordId;
            // Verify that this is a valid movement of a word sense.
            if (srcRef.order === undefined && srcWordId !== destWordId) {
                const mergeSenseId = srcRef.mergeSenseId;
                const words = state.tree.words;
                // Check if dropping the sense into a new word.
                if (words[destWordId] === undefined) {
                    if (Object.keys(words[srcWordId].sensesGuids).length === 1) // Don't do anything if the sense was alone in its word.
                    return;
                    words[destWordId] = (0, $iWuTI.newMergeTreeWord)();
                }
                // Update the destWord.
                const guids = words[srcWordId].sensesGuids[mergeSenseId];
                const sensesPairs = Object.entries(words[destWordId].sensesGuids);
                sensesPairs.splice(action.payload.destOrder, 0, [
                    mergeSenseId,
                    guids
                ]);
                words[destWordId].sensesGuids = Object.fromEntries(sensesPairs);
                // Cleanup the srcWord.
                delete words[srcWordId].sensesGuids[mergeSenseId];
                if (!Object.keys(words[srcWordId].sensesGuids).length) {
                    // If this was the word's last sense, move the audio...
                    const moves = state.audio.moves;
                    if (!Object.keys(moves).includes(destWordId)) moves[destWordId] = [];
                    if (state.data.words[srcWordId]) moves[destWordId].push(srcWordId);
                    if (Object.keys(moves).includes(srcWordId)) {
                        moves[destWordId].push(...moves[srcWordId]);
                        delete moves[srcWordId];
                    }
                    // ...and delete the word from the tree
                    delete words[srcWordId];
                }
            }
        },
        moveDuplicateAction: (state, action)=>{
            const srcRef = action.payload.src;
            const words = state.tree.words;
            const srcGuids = words[srcRef.wordId].sensesGuids[srcRef.mergeSenseId];
            // Verify that this is a valid movement of a sidebar sense.
            if (srcRef.order !== undefined && srcGuids.length > 1) {
                const destWordId = action.payload.destWordId;
                // Get guid of sense being restored from the sidebar.
                const guid = srcGuids.splice(srcRef.order, 1)[0];
                if (srcGuids.length < 2) // If not multiple senses in the sidebar, reset the sidebar.
                state.tree.sidebar = (0, $iWuTI.defaultSidebar);
                // Check if dropping the sense into a new word.
                if (words[destWordId] === undefined) words[destWordId] = (0, $iWuTI.newMergeTreeWord)();
                // Update the destWord.
                const sensesPairs = Object.entries(words[destWordId].sensesGuids);
                sensesPairs.splice(action.payload.destOrder, 0, [
                    crypto.randomUUID(),
                    [
                        guid
                    ]
                ]);
                words[destWordId].sensesGuids = Object.fromEntries(sensesPairs);
            }
        },
        orderDuplicateAction: (state, action)=>{
            const ref = action.payload.src;
            const oldOrder = ref.order;
            const newOrder = action.payload.destOrder;
            // Ensure the reorder is valid.
            if (oldOrder !== undefined && oldOrder !== newOrder) {
                // Move the guid.
                const oldSensesGuids = state.tree.words[ref.wordId].sensesGuids;
                const guids = [
                    ...oldSensesGuids[ref.mergeSenseId]
                ];
                const guid = guids.splice(oldOrder, 1)[0];
                guids.splice(newOrder, 0, guid);
                const sensesGuids = {
                    ...oldSensesGuids
                };
                sensesGuids[ref.mergeSenseId] = guids;
                state.tree.words[ref.wordId].sensesGuids = sensesGuids;
            }
        },
        orderSenseAction: (state, action)=>{
            const ref = action.payload.src;
            const word = state.tree.words[ref.wordId];
            // Convert the Hash<string[]> to an array to expose the order.
            const sensePairs = Object.entries(word.sensesGuids);
            const mergeSenseId = ref.mergeSenseId;
            const oldOrder = sensePairs.findIndex((p)=>p[0] === mergeSenseId);
            const newOrder = action.payload.destOrder;
            // Ensure the move is valid.
            if (oldOrder > -1 && newOrder !== undefined && oldOrder !== newOrder) {
                // Move the sense pair to its new place.
                const pair = sensePairs.splice(oldOrder, 1)[0];
                sensePairs.splice(newOrder, 0, pair);
                // Rebuild the Hash<string[]>.
                word.sensesGuids = {};
                for (const [key, value] of sensePairs)word.sensesGuids[key] = value;
                state.tree.words[ref.wordId] = word;
            }
        },
        resetTreeToInitialAction: (state)=>{
            if (state.initialTree) {
                state.tree = JSON.parse(state.initialTree);
                state.audio.moves = {};
            }
        },
        setSidebarAction: (state, action)=>{
            const sidebar = action.payload;
            // Only open sidebar with multiple senses.
            state.tree.sidebar = sidebar.mergeSenses.length > 1 ? sidebar : (0, $iWuTI.defaultSidebar);
        },
        setDataAction: (state, action)=>{
            if (action.payload.length === 0) return 0, $1dWz9.defaultState;
            else {
                const words = {};
                const senses = {};
                const wordsTree = {};
                const counts = {};
                state.hasProtected = false;
                action.payload.forEach((word)=>{
                    state.hasProtected ||= word.accessibility === (0, $csqcy.Status).Protected;
                    words[word.id] = JSON.parse(JSON.stringify(word));
                    word.senses.forEach((s, order)=>{
                        state.hasProtected ||= s.accessibility === (0, $csqcy.Status).Protected;
                        senses[s.guid] = (0, $iWuTI.convertSenseToMergeTreeSense)(s, word.id, order);
                    });
                    wordsTree[word.id] = (0, $iWuTI.convertWordToMergeTreeWord)(word);
                    counts[word.id] = word.audio.length;
                });
                state.data = {
                    ...(0, $iWuTI.defaultData),
                    senses: senses,
                    words: words
                };
                state.tree = {
                    ...(0, $iWuTI.defaultTree),
                    words: wordsTree
                };
                state.audio = {
                    ...(0, $1dWz9.defaultAudio),
                    counts: counts
                };
                state.mergeWords = [];
                state.overrideProtection = false;
                // Store the initial tree state for reset functionality
                state.initialTree = JSON.stringify(state.tree);
            }
        },
        setVernacularAction: (state, action)=>{
            state.tree.words[action.payload.wordId].vern = action.payload.vern;
        },
        toggleOverrideProtectionAction: (state)=>{
            state.overrideProtection = !state.overrideProtection;
        }
    },
    extraReducers: (builder)=>builder.addCase((0, $3oQOj.StoreActionTypes).RESET, ()=>(0, $1dWz9.defaultState))
});
const { clearMergeWordsAction: $fc04f64d96ddbd69$export$5136620ac892ddf7, clearTreeAction: $fc04f64d96ddbd69$export$77fa9fdcc4d7ee0, combineSenseAction: $fc04f64d96ddbd69$export$3cc2317805b51b14, deleteSenseAction: $fc04f64d96ddbd69$export$2e0f83b204ec839c, flagWordAction: $fc04f64d96ddbd69$export$33f7bc8190d0f3a4, getMergeWordsAction: $fc04f64d96ddbd69$export$9a051982ef39276f, moveDuplicateAction: $fc04f64d96ddbd69$export$594351f4af7c6aaa, moveSenseAction: $fc04f64d96ddbd69$export$e3f6299142b59d2f, orderDuplicateAction: $fc04f64d96ddbd69$export$39b2957690a358c4, orderSenseAction: $fc04f64d96ddbd69$export$9eb884de1a3601ee, resetTreeToInitialAction: $fc04f64d96ddbd69$export$21e2e0289ddbfc00, setDataAction: $fc04f64d96ddbd69$export$d874377755626307, setSidebarAction: $fc04f64d96ddbd69$export$9e87ff0807376738, setVernacularAction: $fc04f64d96ddbd69$export$2aabbad46099ddbd, toggleOverrideProtectionAction: $fc04f64d96ddbd69$export$c9a6be6a13f32a23 } = $fc04f64d96ddbd69$var$mergeDuplicatesSlice.actions;
var $fc04f64d96ddbd69$export$2e2bcd8739ae039 = $fc04f64d96ddbd69$var$mergeDuplicatesSlice.reducer;

});
parcelRegister("iWuTI", function(module, exports) {

$parcel$export(module.exports, "defaultData", function () { return $eb153e20f76532e9$export$54e9baa5a9072bca; });
$parcel$export(module.exports, "newMergeTreeWord", function () { return $eb153e20f76532e9$export$470dc2f69e8e80fa; });
$parcel$export(module.exports, "convertSenseToMergeTreeSense", function () { return $eb153e20f76532e9$export$5a3e2918ee258d04; });
$parcel$export(module.exports, "convertWordToMergeTreeWord", function () { return $eb153e20f76532e9$export$b9220f0bf3e9133d; });
$parcel$export(module.exports, "defaultSidebar", function () { return $eb153e20f76532e9$export$eafeffc216f9492e; });
$parcel$export(module.exports, "defaultTree", function () { return $eb153e20f76532e9$export$b2f99ab618526d01; });
parcelRequire("585vO");
var $csqcy = parcelRequire("csqcy");

var $5gW1E = parcelRequire("5gW1E");
const $eb153e20f76532e9$export$54e9baa5a9072bca = {
    words: {},
    senses: {}
};
function $eb153e20f76532e9$export$a49fef0eed09c883(gloss, srcWordId, order, guid) {
    return {
        order: order,
        protected: false,
        srcWordId: srcWordId,
        sense: guid ? {
            ...(0, $5gW1E.newSense)(gloss),
            guid: guid
        } : (0, $5gW1E.newSense)(gloss)
    };
}
function $eb153e20f76532e9$export$470dc2f69e8e80fa(vern = "", sensesGuids) {
    return {
        vern: vern,
        sensesGuids: sensesGuids ?? {},
        flag: (0, $5gW1E.newFlag)(),
        note: (0, $5gW1E.newNote)(),
        protected: false,
        audioCount: 0
    };
}
function $eb153e20f76532e9$export$5a3e2918ee258d04(sense, srcWordId = "", order = 0) {
    return {
        order: order,
        protected: sense.accessibility === (0, $csqcy.Status).Protected,
        protectReasons: sense.protectReasons ?? undefined,
        srcWordId: srcWordId,
        sense: sense
    };
}
function $eb153e20f76532e9$export$b9220f0bf3e9133d(word) {
    const mergeTreeWord = $eb153e20f76532e9$export$470dc2f69e8e80fa(word.vernacular);
    word.senses.forEach((sense)=>{
        mergeTreeWord.sensesGuids[crypto.randomUUID()] = [
            sense.guid
        ];
    });
    mergeTreeWord.flag = {
        ...word.flag
    };
    mergeTreeWord.note = {
        ...word.note
    };
    mergeTreeWord.protected = word.accessibility === (0, $csqcy.Status).Protected;
    mergeTreeWord.protectReasons = word.protectReasons ?? undefined;
    mergeTreeWord.audioCount = word.audio.length;
    return mergeTreeWord;
}
const $eb153e20f76532e9$export$eafeffc216f9492e = {
    mergeSenses: [],
    senseRef: {
        wordId: "",
        mergeSenseId: ""
    }
};
const $eb153e20f76532e9$export$b2f99ab618526d01 = {
    deletedSenseGuids: [],
    sidebar: $eb153e20f76532e9$export$eafeffc216f9492e,
    words: {}
};

});
parcelRegister("5gW1E", function(module, exports) {

$parcel$export(module.exports, "newPronunciation", function () { return $01d043ddf39e4d4d$export$47977228c3682850; });
$parcel$export(module.exports, "updateSpeakerInAudio", function () { return $01d043ddf39e4d4d$export$42f0e0e723e5ac8c; });
$parcel$export(module.exports, "newDefinition", function () { return $01d043ddf39e4d4d$export$344709b962100b9b; });
$parcel$export(module.exports, "newGloss", function () { return $01d043ddf39e4d4d$export$57dde274c06309c9; });
$parcel$export(module.exports, "newSense", function () { return $01d043ddf39e4d4d$export$d0c8b05ebd6d9491; });
$parcel$export(module.exports, "newGrammaticalInfo", function () { return $01d043ddf39e4d4d$export$a124b379da8a5963; });
$parcel$export(module.exports, "newFlag", function () { return $01d043ddf39e4d4d$export$a6fa9fd9e09c82ee; });
$parcel$export(module.exports, "newNote", function () { return $01d043ddf39e4d4d$export$c26e88def696f17b; });
$parcel$export(module.exports, "newWord", function () { return $01d043ddf39e4d4d$export$17163c2bce17e473; });
$parcel$export(module.exports, "DomainWord", function () { return $01d043ddf39e4d4d$export$9581b32629c892a8; });
$parcel$export(module.exports, "simpleWord", function () { return $01d043ddf39e4d4d$export$ece05f932165774a; });
parcelRequire("585vO");
var $cx1Zj = parcelRequire("cx1Zj");
var $csqcy = parcelRequire("csqcy");

var $jQSAt = parcelRequire("jQSAt");
function $01d043ddf39e4d4d$export$47977228c3682850(fileName = "", speakerId = "") {
    return {
        fileName: fileName,
        speakerId: speakerId,
        protected: false
    };
}
function $01d043ddf39e4d4d$export$42f0e0e723e5ac8c(audio, update) {
    const updatePredicate = (p)=>!p.protected && p.fileName === update.fileName && p.speakerId !== update.speakerId;
    if (!audio.some(updatePredicate)) return;
    return audio.map((a)=>updatePredicate(a) ? update : a);
}
function $01d043ddf39e4d4d$export$344709b962100b9b(text = "", language = "") {
    return {
        text: text,
        language: language
    };
}
function $01d043ddf39e4d4d$export$57dde274c06309c9(def = "", language = "") {
    return {
        def: def,
        language: language
    };
}
function $01d043ddf39e4d4d$export$d0c8b05ebd6d9491(gloss, lang, semDom) {
    const sense = {
        guid: crypto.randomUUID(),
        definitions: [],
        glosses: [],
        semanticDomains: [],
        accessibility: (0, $csqcy.Status).Active,
        grammaticalInfo: $01d043ddf39e4d4d$export$a124b379da8a5963()
    };
    if (gloss) sense.glosses.push($01d043ddf39e4d4d$export$57dde274c06309c9(gloss, lang));
    if (semDom) sense.semanticDomains.push(semDom);
    return sense;
}
function $01d043ddf39e4d4d$export$a6fa9fd9e09c82ee(text = "") {
    return {
        active: !!text,
        text: text
    };
}
function $01d043ddf39e4d4d$export$c26e88def696f17b(text = "", language = "") {
    return {
        text: text,
        language: language
    };
}
function $01d043ddf39e4d4d$export$a124b379da8a5963() {
    return {
        catGroup: (0, $cx1Zj.GramCatGroup).Unspecified,
        grammaticalCategory: ""
    };
}
function $01d043ddf39e4d4d$export$17163c2bce17e473(vernacular = "", lang) {
    return {
        id: "",
        guid: crypto.randomUUID(),
        vernacular: vernacular,
        senses: [],
        audio: [],
        created: "",
        modified: "",
        accessibility: (0, $csqcy.Status).Active,
        history: [],
        projectId: "",
        note: $01d043ddf39e4d4d$export$c26e88def696f17b(undefined, lang),
        flag: $01d043ddf39e4d4d$export$a6fa9fd9e09c82ee()
    };
}
class $01d043ddf39e4d4d$export$9581b32629c892a8 {
    constructor(word, senseIndex = 0){
        const sense = word.senses[senseIndex] ?? $01d043ddf39e4d4d$export$d0c8b05ebd6d9491();
        this.wordGuid = word.guid;
        this.vernacular = word.vernacular;
        this.senseGuid = sense.guid;
        this.glosses = sense.glosses;
    }
}
function $01d043ddf39e4d4d$export$ece05f932165774a(vern, gloss, lang) {
    return {
        ...$01d043ddf39e4d4d$export$17163c2bce17e473(vern, lang),
        id: (0, $jQSAt.randomIntString)(),
        senses: [
            $01d043ddf39e4d4d$export$d0c8b05ebd6d9491(gloss, lang)
        ]
    };
}
function $01d043ddf39e4d4d$export$b87b0b66b33c83e9(vern, glosses) {
    return {
        ...$01d043ddf39e4d4d$export$17163c2bce17e473(vern),
        id: (0, $jQSAt.randomIntString)(),
        senses: glosses.map((gloss)=>$01d043ddf39e4d4d$export$d0c8b05ebd6d9491(gloss))
    };
}
function $01d043ddf39e4d4d$export$30b6038c21b00143() {
    return [
        {
            ...$01d043ddf39e4d4d$export$ece05f932165774a("NoSense", ""),
            senses: []
        },
        $01d043ddf39e4d4d$export$ece05f932165774a("Yoink", "Hello"),
        $01d043ddf39e4d4d$export$ece05f932165774a("Yode", "Goodbye"),
        $01d043ddf39e4d4d$export$ece05f932165774a("Yoff", "Yes"),
        $01d043ddf39e4d4d$export$ece05f932165774a("Yank", "No"),
        $01d043ddf39e4d4d$export$ece05f932165774a("Yank", "Please help me"),
        $01d043ddf39e4d4d$export$ece05f932165774a("Ya", "Help"),
        $01d043ddf39e4d4d$export$ece05f932165774a("Yeet", "Please"),
        $01d043ddf39e4d4d$export$ece05f932165774a("Yeet", "Mandatory"),
        $01d043ddf39e4d4d$export$ece05f932165774a("Yang", "Die"),
        $01d043ddf39e4d4d$export$b87b0b66b33c83e9("Yuino", [
            "Love",
            "Boba Fett",
            "Life"
        ]),
        $01d043ddf39e4d4d$export$b87b0b66b33c83e9("Yuilo", [
            "Sadness",
            "Tree bark"
        ]),
        $01d043ddf39e4d4d$export$ece05f932165774a("Yes", "Wumbo"),
        $01d043ddf39e4d4d$export$ece05f932165774a("Yes", "Mayonnaise")
    ];
}

});


parcelRegister("1dWz9", function(module, exports) {

$parcel$export(module.exports, "defaultAudio", function () { return $0be0d940e865ac3c$export$3fefc1cf9a6ef3ea; });
$parcel$export(module.exports, "defaultState", function () { return $0be0d940e865ac3c$export$49d5fc8cba920a0; });

var $iWuTI = parcelRequire("iWuTI");
const $0be0d940e865ac3c$export$3fefc1cf9a6ef3ea = {
    counts: {},
    moves: {}
};
const $0be0d940e865ac3c$export$49d5fc8cba920a0 = {
    data: (0, $iWuTI.defaultData),
    tree: (0, $iWuTI.defaultTree),
    audio: $0be0d940e865ac3c$export$3fefc1cf9a6ef3ea,
    hasProtected: false,
    mergeWords: [],
    overrideProtection: false
};

});

parcelRegister("d7TC6", function(module, exports) {

$parcel$export(module.exports, "gatherWordSenses", function () { return $0d43e56e3c20c8da$export$86ea534cd3fe8fd4; });
$parcel$export(module.exports, "getDeletedMergeWords", function () { return $0d43e56e3c20c8da$export$4cd0ab769674a70c; });
$parcel$export(module.exports, "isEmptyMerge", function () { return $0d43e56e3c20c8da$export$5182b957196f05c1; });
$parcel$export(module.exports, "createMergeChildren", function () { return $0d43e56e3c20c8da$export$4ebe614f3f377bfb; });
$parcel$export(module.exports, "createMergeParent", function () { return $0d43e56e3c20c8da$export$72c142e63aaee4d1; });
$parcel$export(module.exports, "combineIntoFirstSense", function () { return $0d43e56e3c20c8da$export$9e4b8195861dae71; });
$parcel$export(module.exports, "combineSenses", function () { return $0d43e56e3c20c8da$export$decf952a27a30595; });
parcelRequire("585vO");
var $cx1Zj = parcelRequire("cx1Zj");
var $csqcy = parcelRequire("csqcy");

var $g5MIz = parcelRequire("g5MIz");

var $5gW1E = parcelRequire("5gW1E");

var $u1m5k = parcelRequire("u1m5k");
function $0d43e56e3c20c8da$export$86ea534cd3fe8fd4(words, deletedSenseGuids) {
    return Object.fromEntries(words.map((w)=>[
            w.id,
            $0d43e56e3c20c8da$var$gatherSenses(w, deletedSenseGuids)
        ]));
}
/** Generate MergeTreeSense array with deleted senses set to Status.Deleted. */ function $0d43e56e3c20c8da$var$gatherSenses(word, deletedSenseGuids) {
    return word.senses.map((sense, index)=>({
            order: index,
            protected: sense.accessibility === (0, $csqcy.Status).Protected,
            srcWordId: word.id,
            sense: {
                ...sense,
                accessibility: deletedSenseGuids.includes(sense.guid) ? (0, $csqcy.Status).Deleted : sense.accessibility
            }
        }));
}
function $0d43e56e3c20c8da$export$4cd0ab769674a70c(words, deletedSenseGuids) {
    return words.filter((w)=>w.senses.every((s)=>deletedSenseGuids.includes(s.guid))).map((w)=>(0, $g5MIz.newMergeWords)(w, [
            {
                srcWordId: w.id,
                getAudio: false
            }
        ], true));
}
function $0d43e56e3c20c8da$export$5182b957196f05c1(word, mergeWord) {
    const mergeSensesGuids = Object.values(mergeWord.sensesGuids);
    const mergeGuids = mergeSensesGuids.map((guids)=>guids[0]);
    const wordSenseGuids = word.senses.map((s)=>s.guid);
    return mergeSensesGuids.every((guids)=>guids.length === 1) && mergeGuids.length === wordSenseGuids.length && wordSenseGuids.every((guid)=>mergeGuids.includes(guid)) && (0, $u1m5k.compareFlags)(mergeWord.flag, word.flag) === 0;
}
function $0d43e56e3c20c8da$export$4ebe614f3f377bfb(mergeSenses, audioMoves = []) {
    const redundantIds = mergeSenses.flatMap((senses)=>senses.map((s)=>s.srcWordId));
    // Catch words whose final sense was merged in and subsequently removed.
    redundantIds.push(...audioMoves);
    const childrenIds = [
        ...new Set(redundantIds)
    ];
    return childrenIds.map((srcWordId)=>({
            srcWordId: srcWordId,
            getAudio: audioMoves.includes(srcWordId)
        }));
}
function $0d43e56e3c20c8da$export$72c142e63aaee4d1(word, mergeWord, allSenses) {
    // Construct parent.
    const senses = Object.values(mergeWord.sensesGuids).map((guids)=>guids[0]).map((g)=>allSenses.find((s)=>s.guid === g));
    return {
        ...word,
        flag: mergeWord.flag,
        senses: senses,
        vernacular: mergeWord.vern.trim() || word.vernacular.trim()
    };
}
function $0d43e56e3c20c8da$export$9e4b8195861dae71(mergeSenses) {
    // Set the main sense to the first sense (the top one when the sidebar was opened).
    const mainSense = mergeSenses[0].sense;
    const senses = [
        mainSense
    ];
    // Mark the rest as duplicates.
    // These were senses dropped into another sense.
    mergeSenses.slice(1).forEach((mergeDupSense)=>{
        mergeDupSense.sense.accessibility = (0, $csqcy.Status).Duplicate;
        senses.push(mergeDupSense.sense);
    });
    // Combine the sense content and update the main sense.
    const combinedSense = $0d43e56e3c20c8da$export$decf952a27a30595(senses);
    mainSense.definitions = combinedSense.definitions;
    mainSense.glosses = combinedSense.glosses;
    mainSense.grammaticalInfo = combinedSense.grammaticalInfo;
    mainSense.semanticDomains = combinedSense.semanticDomains;
}
function $0d43e56e3c20c8da$export$decf952a27a30595(senses) {
    if (!senses.length) return (0, $5gW1E.newSense)();
    const mainSense = {
        ...senses[0],
        definitions: [],
        glosses: [],
        grammaticalInfo: (0, $5gW1E.newGrammaticalInfo)(),
        semanticDomains: []
    };
    const sep = "; ";
    senses.forEach((dupSense)=>{
        // Merge in the definitions.
        dupSense.definitions.forEach((def)=>{
            const newText = def.text.trim();
            if (newText) {
                // Check if definitions array already has entry with the same language.
                const oldDef = mainSense.definitions.find((d)=>d.language === def.language);
                if (!oldDef) // If not, add this one to the array.
                mainSense.definitions.push({
                    ...def,
                    text: newText
                });
                else {
                    // If so, merge the text.
                    const texts = [
                        ...oldDef.text.split(sep),
                        ...newText.split(sep)
                    ];
                    oldDef.text = [
                        ...new Set(texts.map((t)=>t.trim()))
                    ].join(sep);
                }
            }
        });
        // Merge in the glosses.
        dupSense.glosses.forEach((gloss)=>{
            const newDef = gloss.def.trim();
            if (newDef) {
                // Check if glosses array already has entry with the same language.
                const oldGloss = mainSense.glosses.find((g)=>g.language === gloss.language);
                if (!oldGloss) // If not, add this one to the array.
                mainSense.glosses.push({
                    ...gloss,
                    def: newDef
                });
                else {
                    // If so, merge the defs.
                    const defs = [
                        ...oldGloss.def.split(sep),
                        ...newDef.split(sep)
                    ];
                    oldGloss.def = [
                        ...new Set(defs.map((t)=>t.trim()))
                    ].join(sep);
                }
            }
        });
        // Use the grammatical info if not already specified.
        if (mainSense.grammaticalInfo.catGroup === (0, $cx1Zj.GramCatGroup).Unspecified) mainSense.grammaticalInfo = {
            ...dupSense.grammaticalInfo
        };
        else if (mainSense.grammaticalInfo.catGroup === dupSense.grammaticalInfo.catGroup) {
            const oldCat = mainSense.grammaticalInfo.grammaticalCategory.trim();
            const oldCats = oldCat.split(sep).map((cat)=>cat.trim());
            const newCat = dupSense.grammaticalInfo.grammaticalCategory.trim();
            if (newCat && !oldCats.includes(newCat)) mainSense.grammaticalInfo.grammaticalCategory = `${oldCat}${sep}${newCat}`;
        }
        // Merge in the semantic domains.
        dupSense.semanticDomains.forEach((dom)=>{
            if (mainSense.semanticDomains.every((d)=>d.id !== dom.id)) mainSense.semanticDomains.push({
                ...dom
            });
        });
    });
    return mainSense;
}

});
parcelRegister("g5MIz", function(module, exports) {

$parcel$export(module.exports, "newMergeWords", function () { return $eb98ac0034510a23$export$fec16c5cd8aad2bf; });
$parcel$export(module.exports, "MergeDups", function () { return $eb98ac0034510a23$export$be3f29f3abb0ef5c; });
$parcel$export(module.exports, "ReviewDeferredDups", function () { return $eb98ac0034510a23$export$91d3e5e4d9b50403; });

var $eY0YF = parcelRequire("eY0YF");
function $eb98ac0034510a23$export$fec16c5cd8aad2bf(parent, children, deleteOnly = false) {
    return {
        parent: parent,
        children: children,
        deleteOnly: deleteOnly
    };
}
class $eb98ac0034510a23$export$be3f29f3abb0ef5c extends (0, $eY0YF.Goal) {
    constructor(steps = [], data = {
        plannedWords: [
            []
        ]
    }){
        super((0, $eY0YF.GoalType).MergeDups, (0, $eY0YF.GoalName).MergeDups, steps, data);
    }
}
class $eb98ac0034510a23$export$91d3e5e4d9b50403 extends (0, $eY0YF.Goal) {
    constructor(steps = [], data = {
        plannedWords: [
            []
        ]
    }){
        super((0, $eY0YF.GoalType).ReviewDeferredDups, (0, $eY0YF.GoalName).ReviewDeferredDups, steps, data);
    }
}

});

parcelRegister("u1m5k", function(module, exports) {

$parcel$export(module.exports, "compareFlags", function () { return $7c8e6744a2a0f207$export$73f1fc21dd3c75a; });
$parcel$export(module.exports, "firstGlossText", function () { return $7c8e6744a2a0f207$export$8c6adeb051ac1f2e; });
$parcel$export(module.exports, "getAnalysisLangsFromWords", function () { return $7c8e6744a2a0f207$export$8bed36a073c951eb; });
$parcel$export(module.exports, "groupGramInfo", function () { return $7c8e6744a2a0f207$export$38ad6e20fcd317f9; });
$parcel$export(module.exports, "getGramCatGroupColor", function () { return $7c8e6744a2a0f207$export$632f8795300d0dd9; });
parcelRequire("585vO");
var $cx1Zj = parcelRequire("cx1Zj");

var $gs8xE = parcelRequire("gs8xE");

var $5gW1E = parcelRequire("5gW1E");
const $7c8e6744a2a0f207$export$5aee1a5bd9743d8f = "; ";
function $7c8e6744a2a0f207$export$bcfe73af410f65f(defs) {
    const nonempty = defs.filter((d)=>d.text.length);
    const langs = [
        ...new Set(nonempty.map((d)=>d.language))
    ];
    return langs.map((language)=>(0, $5gW1E.newDefinition)(nonempty.filter((d)=>d.language === language).map((d)=>d.text).join($7c8e6744a2a0f207$export$5aee1a5bd9743d8f), language));
}
function $7c8e6744a2a0f207$export$95b72d1a26f43540(glosses) {
    const nonempty = glosses.filter((g)=>g.def.length);
    const langs = [
        ...new Set(nonempty.map((g)=>g.language))
    ];
    return langs.map((language)=>(0, $5gW1E.newGloss)(nonempty.filter((g)=>g.language === language).map((g)=>g.def).join($7c8e6744a2a0f207$export$5aee1a5bd9743d8f), language));
}
function $7c8e6744a2a0f207$export$73f1fc21dd3c75a(a, b) {
    return a.active && b.active ? a.text.localeCompare(b.text) : a.active ? -1 : b.active ? 1 : 0;
}
function $7c8e6744a2a0f207$export$8c6adeb051ac1f2e(sense, lang) {
    return sense.glosses.find((g)=>g.language === lang)?.def ?? sense.glosses[0]?.def ?? "";
}
function $7c8e6744a2a0f207$export$8bed36a073c951eb(words) {
    return $7c8e6744a2a0f207$var$reduceMultiType(words, [], $7c8e6744a2a0f207$var$wordReducer);
}
function $7c8e6744a2a0f207$var$reduceMultiType(toReduce, initial, reducer) {
    let accumulated = initial;
    toReduce.forEach((item)=>accumulated = reducer(accumulated, item));
    return accumulated;
}
function $7c8e6744a2a0f207$var$wordReducer(accumulator, word) {
    const newLangs = word.senses.flatMap((s)=>[
            ...s.definitions,
            ...s.glosses
        ]).map((dg)=>dg.language);
    return [
        ...new Set([
            ...accumulator,
            ...newLangs
        ])
    ];
}
function $7c8e6744a2a0f207$export$38ad6e20fcd317f9(infos, sep = " ; ") {
    const catGroups = [
        ...new Set(infos.map((i)=>i.catGroup))
    ].sort();
    /** Concatenate all grammatical categories of a given group */ const groupedGramCat = (group)=>{
        const cats = infos.filter((i)=>i.catGroup === group).map((i)=>i.grammaticalCategory);
        return [
            ...new Set(cats)
        ].sort().join(sep);
    };
    return catGroups.map((c)=>({
            catGroup: c,
            grammaticalCategory: groupedGramCat(c)
        }));
}
function $7c8e6744a2a0f207$export$632f8795300d0dd9(group) {
    switch(group){
        case (0, $cx1Zj.GramCatGroup).Unspecified:
            return "#ffffff";
        case (0, $cx1Zj.GramCatGroup).Other:
            return "#000000";
        case (0, $cx1Zj.GramCatGroup).Adjective:
            return (0, $gs8xE.colorblindSafePalette)[1];
        case (0, $cx1Zj.GramCatGroup).Adposition:
            return (0, $gs8xE.colorblindSafePalette)[2];
        case (0, $cx1Zj.GramCatGroup).Adverb:
            return (0, $gs8xE.colorblindSafePalette)[3];
        case (0, $cx1Zj.GramCatGroup).Classifier:
            return (0, $gs8xE.colorblindSafePalette)[4];
        case (0, $cx1Zj.GramCatGroup).Connective:
            return (0, $gs8xE.colorblindSafePalette)[5];
        case (0, $cx1Zj.GramCatGroup).Determiner:
            return (0, $gs8xE.colorblindSafePalette)[6];
        case (0, $cx1Zj.GramCatGroup).ExistentialMarker:
            return (0, $gs8xE.colorblindSafePalette)[7];
        case (0, $cx1Zj.GramCatGroup).Expletive:
            return (0, $gs8xE.colorblindSafePalette)[8];
        case (0, $cx1Zj.GramCatGroup).Interjection:
            return (0, $gs8xE.colorblindSafePalette)[9];
        case (0, $cx1Zj.GramCatGroup).Noun:
            return (0, $gs8xE.colorblindSafePalette)[10];
        case (0, $cx1Zj.GramCatGroup).Participle:
            return (0, $gs8xE.colorblindSafePalette)[11];
        case (0, $cx1Zj.GramCatGroup).Particle:
            return (0, $gs8xE.colorblindSafePalette)[12];
        case (0, $cx1Zj.GramCatGroup).Prenoun:
            return (0, $gs8xE.colorblindSafePalette)[13];
        case (0, $cx1Zj.GramCatGroup).Preverb:
            return (0, $gs8xE.colorblindSafePalette)[14];
        case (0, $cx1Zj.GramCatGroup).ProForm:
            return (0, $gs8xE.colorblindSafePalette)[15];
        case (0, $cx1Zj.GramCatGroup).Verb:
            return (0, $gs8xE.colorblindSafePalette)[16];
    }
}

});



parcelRegister("ckMxe", function(module, exports) {

$parcel$export(module.exports, "addCharInvChangesToGoalAction", function () { return $2699c1b6bf848f24$export$d879746dcada1da; });
$parcel$export(module.exports, "addCompletedMergeToGoalAction", function () { return $2699c1b6bf848f24$export$ff77929e9ce438aa; });
$parcel$export(module.exports, "addEntryEditToGoalAction", function () { return $2699c1b6bf848f24$export$c43e798d9ddb97bd; });
$parcel$export(module.exports, "incrementGoalStepAction", function () { return $2699c1b6bf848f24$export$6b0da184e1b48884; });
$parcel$export(module.exports, "loadUserEditsAction", function () { return $2699c1b6bf848f24$export$5a84726b26451525; });
$parcel$export(module.exports, "setCurrentGoalAction", function () { return $2699c1b6bf848f24$export$59e88d58f56e51b1; });
$parcel$export(module.exports, "setDataLoadStatusAction", function () { return $2699c1b6bf848f24$export$5c75637d53281e72; });
$parcel$export(module.exports, "setGoalDataAction", function () { return $2699c1b6bf848f24$export$de4e5bb6f9fe84c6; });
$parcel$export(module.exports, "setGoalStatusAction", function () { return $2699c1b6bf848f24$export$235d8513bc887f70; });
$parcel$export(module.exports, "updateStepFromDataAction", function () { return $2699c1b6bf848f24$export$8d1e64e8a97ecea8; });
$parcel$export(module.exports, "default", function () { return $2699c1b6bf848f24$export$2e2bcd8739ae039; });

var $1SirA = parcelRequire("1SirA");

var $6CGsD = parcelRequire("6CGsD");

var $3oQOj = parcelRequire("3oQOj");

var $eY0YF = parcelRequire("eY0YF");
const $2699c1b6bf848f24$var$goalSlice = (0, $1SirA.createSlice)({
    name: "goalsState",
    initialState: (0, $6CGsD.defaultState),
    reducers: {
        addCharInvChangesToGoalAction: (state, action)=>{
            if (state.currentGoal.goalType === (0, $eY0YF.GoalType).CreateCharInv) state.currentGoal.changes = action.payload;
        },
        addCompletedMergeToGoalAction: (state, action)=>{
            if (state.currentGoal.goalType === (0, $eY0YF.GoalType).MergeDups || state.currentGoal.goalType === (0, $eY0YF.GoalType).ReviewDeferredDups) {
                const changes = {
                    ...state.currentGoal.changes
                };
                if (!changes.merges) changes.merges = [];
                changes.merges.push(action.payload);
                state.currentGoal.changes = changes;
            }
        },
        addEntryEditToGoalAction: (state, action)=>{
            if (state.currentGoal.goalType === (0, $eY0YF.GoalType).ReviewEntries) {
                const changes = {
                    ...state.currentGoal.changes
                };
                if (!changes.entryEdits) changes.entryEdits = [];
                const newEdit = action.payload;
                const oldEdit = changes.entryEdits.find((e)=>e.newId === newEdit.oldId);
                if (oldEdit) oldEdit.newId = newEdit.newId;
                else changes.entryEdits.push(newEdit);
                state.currentGoal.changes = changes;
            }
        },
        incrementGoalStepAction: (state)=>{
            if (state.currentGoal.currentStep + 1 < state.currentGoal.numSteps) state.currentGoal.currentStep++;
        },
        loadUserEditsAction: (state, action)=>{
            const history = [
                ...action.payload
            ];
            state.previousGoalType = history[history.length - 1]?.goalType ?? (0, $eY0YF.GoalType).Default;
            state.history = history;
        },
        setCurrentGoalAction: (state, action)=>{
            state.currentGoal = action.payload;
            state.previousGoalType = state.currentGoal.goalType !== (0, $eY0YF.GoalType).Default ? state.currentGoal.goalType : state.previousGoalType;
        },
        setDataLoadStatusAction: (state, action)=>{
            state.dataLoadStatus = action.payload;
        },
        setGoalDataAction: (state, action)=>{
            if (action.payload.length > 0) {
                state.currentGoal.data = {
                    plannedWords: action.payload
                };
                state.currentGoal.numSteps = action.payload.length;
                state.currentGoal.currentStep = 0;
                state.currentGoal.steps = [];
            }
        },
        setGoalStatusAction: (state, action)=>{
            state.currentGoal.status = action.payload;
        },
        updateStepFromDataAction: (state)=>{
            if (state.currentGoal.goalType === (0, $eY0YF.GoalType).MergeDups || state.currentGoal.goalType === (0, $eY0YF.GoalType).ReviewDeferredDups) {
                const currentGoalData = state.currentGoal.data;
                state.currentGoal.steps[state.currentGoal.currentStep] = {
                    words: currentGoalData.plannedWords[state.currentGoal.currentStep]
                };
            }
        }
    },
    extraReducers: (builder)=>builder.addCase((0, $3oQOj.StoreActionTypes).RESET, ()=>(0, $6CGsD.defaultState))
});
const { addCharInvChangesToGoalAction: $2699c1b6bf848f24$export$d879746dcada1da, addCompletedMergeToGoalAction: $2699c1b6bf848f24$export$ff77929e9ce438aa, addEntryEditToGoalAction: $2699c1b6bf848f24$export$c43e798d9ddb97bd, incrementGoalStepAction: $2699c1b6bf848f24$export$6b0da184e1b48884, loadUserEditsAction: $2699c1b6bf848f24$export$5a84726b26451525, setCurrentGoalAction: $2699c1b6bf848f24$export$59e88d58f56e51b1, setDataLoadStatusAction: $2699c1b6bf848f24$export$5c75637d53281e72, setGoalDataAction: $2699c1b6bf848f24$export$de4e5bb6f9fe84c6, setGoalStatusAction: $2699c1b6bf848f24$export$235d8513bc887f70, updateStepFromDataAction: $2699c1b6bf848f24$export$8d1e64e8a97ecea8 } = $2699c1b6bf848f24$var$goalSlice.actions;
var $2699c1b6bf848f24$export$2e2bcd8739ae039 = $2699c1b6bf848f24$var$goalSlice.reducer;

});
parcelRegister("6CGsD", function(module, exports) {

$parcel$export(module.exports, "DataLoadStatus", function () { return $8111d8a3ad318410$export$25545ad9a6c91838; });
$parcel$export(module.exports, "defaultState", function () { return $8111d8a3ad318410$export$49d5fc8cba920a0; });

var $eY0YF = parcelRequire("eY0YF");
var $8111d8a3ad318410$export$25545ad9a6c91838 = /*#__PURE__*/ function(DataLoadStatus) {
    DataLoadStatus["Default"] = "DEFAULT";
    DataLoadStatus["Failure"] = "FAILURE";
    DataLoadStatus["Loading"] = "LOADING";
    DataLoadStatus["Success"] = "SUCCESS";
    return DataLoadStatus;
}({});
const $8111d8a3ad318410$export$9a46792dc659bfa4 = [
    (0, $eY0YF.GoalName).CreateCharInv,
    (0, $eY0YF.GoalName).MergeDups,
    (0, $eY0YF.GoalName).ReviewDeferredDups,
    (0, $eY0YF.GoalName).ReviewEntries
];
const $8111d8a3ad318410$export$49d5fc8cba920a0 = {
    allGoals: [
        ...$8111d8a3ad318410$export$9a46792dc659bfa4
    ],
    currentGoal: new (0, $eY0YF.Goal)(),
    dataLoadStatus: "DEFAULT",
    history: [],
    previousGoalType: (0, $eY0YF.GoalType).Default
};

});


parcelRegister("l3fQU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9441acec3107c764$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "changePage", function () { return $9441acec3107c764$export$af04929cb32c4bb7; });

var $1SirA = parcelRequire("1SirA");

var $3oQOj = parcelRequire("3oQOj");

var $5TZDo = parcelRequire("5TZDo");
const $9441acec3107c764$var$analyticsSlice = (0, $1SirA.createSlice)({
    name: "analyticsState",
    initialState: (0, $5TZDo.defaultState),
    reducers: {
        changePageAction: (state, action)=>{
            state.currentPage = action.payload;
        }
    },
    extraReducers: (builder)=>builder.addCase((0, $3oQOj.StoreActionTypes).RESET, ()=>(0, $5TZDo.defaultState))
});
const { changePageAction: $9441acec3107c764$var$changePageAction } = $9441acec3107c764$var$analyticsSlice.actions;
var $9441acec3107c764$export$2e2bcd8739ae039 = $9441acec3107c764$var$analyticsSlice.reducer;
function $9441acec3107c764$export$af04929cb32c4bb7(newPage) {
    return $9441acec3107c764$var$changePageAction(newPage);
}

});
parcelRegister("5TZDo", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $17968b8f4fc046bc$export$49d5fc8cba920a0; });
const $17968b8f4fc046bc$export$49d5fc8cba920a0 = {
    currentPage: ""
};

});




parcelRegister("easJz", function(module, exports) {

$parcel$export(module.exports, "appRoutes", function () { return $02b88dc607cd4615$export$61147a57d3c24ac8; });

var $bbzbN = parcelRequire("bbzbN");

var $bCSou = parcelRequire("bCSou");

var $9RhT3 = parcelRequire("9RhT3");

var $3pvf1 = parcelRequire("3pvf1");

var $aGTsZ = parcelRequire("aGTsZ");

var $iqjYa = parcelRequire("iqjYa");

var $ddz7b = parcelRequire("ddz7b");

var $KdnEy = parcelRequire("KdnEy");

var $jhOXl = parcelRequire("jhOXl");

var $293io = parcelRequire("293io");

var $7ypFZ = parcelRequire("7ypFZ");

var $6PJp8 = parcelRequire("6PJp8");

var $8S1fp = parcelRequire("8S1fp");

const $02b88dc607cd4615$var$AppWithBar = (0, $bCSou.default)(()=>(parcelRequire("5okF4")));
const $02b88dc607cd4615$export$61147a57d3c24ac8 = [
    {
        path: (0, $6PJp8.Path).Root,
        element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3pvf1.default), {})
    },
    {
        // use routerPath to get the wildcard expression for the app pages
        path: (0, $8S1fp.routerPath)((0, $6PJp8.Path).AppRoot),
        element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7ypFZ.default), {
            redirectTo: (0, $6PJp8.Path).Login,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)($02b88dc607cd4615$var$AppWithBar, {})
        })
    },
    {
        path: `${(0, $6PJp8.Path).EmailVerify}/:token`,
        element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9RhT3.default), {})
    },
    {
        path: (0, $6PJp8.Path).Login,
        element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aGTsZ.default), {})
    },
    {
        path: (0, $6PJp8.Path).Signup,
        element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ddz7b.default), {})
    },
    {
        path: `${(0, $6PJp8.Path).PwReset}/:token`,
        element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $293io.default), {})
    },
    {
        path: (0, $6PJp8.Path).PwRequest,
        element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jhOXl.default), {})
    },
    {
        path: `${(0, $6PJp8.Path).ProjInvite}/:project/:token`,
        element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iqjYa.default), {})
    },
    {
        path: "*",
        element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $KdnEy.default), {})
    }
];

});
parcelRegister("bCSou", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1f67e51ea1e89a0$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $3zeAJ = parcelRequire("3zeAJ");

var $1KLsX = parcelRequire("1KLsX");

var $8Ae2G = parcelRequire("8Ae2G");
/* eslint-disable import/prefer-default-export */ function $d1f67e51ea1e89a0$var$invariant(condition, message) {
    if (condition) return;
    var error = new Error("loadable: " + message);
    error.framesToPop = 1;
    error.name = 'Invariant Violation';
    throw error;
}
function $d1f67e51ea1e89a0$var$warn(message) {
    // eslint-disable-next-line no-console
    console.warn("loadable: " + message);
}
var $d1f67e51ea1e89a0$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext();
var $d1f67e51ea1e89a0$var$LOADABLE_REQUIRED_CHUNKS_KEY = '__LOADABLE_REQUIRED_CHUNKS__';
function $d1f67e51ea1e89a0$var$getRequiredChunkKey(namespace) {
    return "" + namespace + $d1f67e51ea1e89a0$var$LOADABLE_REQUIRED_CHUNKS_KEY;
}
var $d1f67e51ea1e89a0$var$sharedInternals = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    getRequiredChunkKey: $d1f67e51ea1e89a0$var$getRequiredChunkKey,
    invariant: $d1f67e51ea1e89a0$var$invariant,
    Context: $d1f67e51ea1e89a0$var$Context
});
var $d1f67e51ea1e89a0$var$LOADABLE_SHARED = {
    initialChunks: {}
};
var $d1f67e51ea1e89a0$var$STATUS_PENDING = 'PENDING';
var $d1f67e51ea1e89a0$var$STATUS_RESOLVED = 'RESOLVED';
var $d1f67e51ea1e89a0$var$STATUS_REJECTED = 'REJECTED';
function $d1f67e51ea1e89a0$var$resolveConstructor(ctor) {
    if (typeof ctor === 'function') return {
        requireAsync: ctor,
        resolve: function resolve() {
            return undefined;
        },
        chunkName: function chunkName() {
            return undefined;
        }
    };
    return ctor;
}
var $d1f67e51ea1e89a0$var$withChunkExtractor = function withChunkExtractor(Component) {
    var LoadableWithChunkExtractor = function LoadableWithChunkExtractor(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d1f67e51ea1e89a0$var$Context.Consumer, null, function(extractor) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, Object.assign({
                __chunkExtractor: extractor
            }, props));
        });
    };
    if (Component.displayName) LoadableWithChunkExtractor.displayName = Component.displayName + "WithChunkExtractor";
    return LoadableWithChunkExtractor;
};
var $d1f67e51ea1e89a0$var$identity = function identity(v) {
    return v;
};
function $d1f67e51ea1e89a0$var$createLoadable(_ref) {
    var _ref$defaultResolveCo = _ref.defaultResolveComponent, defaultResolveComponent = _ref$defaultResolveCo === void 0 ? $d1f67e51ea1e89a0$var$identity : _ref$defaultResolveCo, _render = _ref.render, onLoad = _ref.onLoad;
    function loadable(loadableConstructor, options) {
        if (options === void 0) options = {};
        var ctor = $d1f67e51ea1e89a0$var$resolveConstructor(loadableConstructor);
        var cache = {};
        /**
     * Cachekey represents the component to be loaded
     * if key changes - component has to be reloaded
     * @param props
     * @returns {null|Component}
     */ function _getCacheKey(props) {
            if (options.cacheKey) return options.cacheKey(props);
            if (ctor.resolve) return ctor.resolve(props);
            return 'static';
        }
        /**
     * Resolves loaded `module` to a specific `Component
     * @param module
     * @param props
     * @param Loadable
     * @returns Component
     */ function resolve(module, props, Loadable) {
            var Component = options.resolveComponent ? options.resolveComponent(module, props) : defaultResolveComponent(module); // FIXME: suppressed due to https://github.com/gregberge/loadable-components/issues/990
            // if (options.resolveComponent && !ReactIs.isValidElementType(Component)) {
            //   throw new Error(
            //     `resolveComponent returned something that is not a React component!`,
            //   )
            // }
            (0, (/*@__PURE__*/$parcel$interopDefault($8Ae2G)))(Loadable, Component, {
                preload: true
            });
            return Component;
        }
        var cachedLoad = function cachedLoad(props) {
            var cacheKey = _getCacheKey(props);
            var promise = cache[cacheKey];
            if (!promise || promise.status === $d1f67e51ea1e89a0$var$STATUS_REJECTED) {
                promise = ctor.requireAsync(props);
                promise.status = $d1f67e51ea1e89a0$var$STATUS_PENDING;
                cache[cacheKey] = promise;
                promise.then(function() {
                    promise.status = $d1f67e51ea1e89a0$var$STATUS_RESOLVED;
                }, function(error) {
                    console.error('loadable-components: failed to asynchronously load component', {
                        fileName: ctor.resolve(props),
                        chunkName: ctor.chunkName(props),
                        error: error ? error.message : error
                    });
                    promise.status = $d1f67e51ea1e89a0$var$STATUS_REJECTED;
                });
            }
            return promise;
        };
        var InnerLoadable = /*#__PURE__*/ function(_React$Component) {
            (0, $1KLsX.default)(InnerLoadable, _React$Component);
            InnerLoadable.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
                var cacheKey = _getCacheKey(props);
                return (0, $kY3Ke.default)({}, state, {
                    cacheKey: cacheKey,
                    // change of a key triggers loading state automatically
                    loading: state.loading || state.cacheKey !== cacheKey
                });
            };
            function InnerLoadable(props) {
                var _this;
                _this = _React$Component.call(this, props) || this;
                _this.state = {
                    result: null,
                    error: null,
                    loading: true,
                    cacheKey: _getCacheKey(props)
                };
                $d1f67e51ea1e89a0$var$invariant(!props.__chunkExtractor || ctor.requireSync, 'SSR requires `@loadable/babel-plugin`, please install it'); // Server-side
                if (props.__chunkExtractor) {
                    // This module has been marked with no SSR
                    if (options.ssr === false) return (0, $3zeAJ.default)(_this);
                     // We run load function, we assume that it won't fail and that it
                    // triggers a synchronous loading of the module
                    ctor.requireAsync(props)["catch"](function() {
                        return null;
                    }); // So we can require now the module synchronously
                    _this.loadSync();
                    props.__chunkExtractor.addChunk(ctor.chunkName(props));
                    return (0, $3zeAJ.default)(_this);
                } // Client-side with `isReady` method present (SSR probably)
                // If module is already loaded, we use a synchronous loading
                // Only perform this synchronous loading if the component has not
                // been marked with no SSR, else we risk hydration mismatches
                if (options.ssr !== false && (ctor.isReady && ctor.isReady(props) || // is ready - was loaded during SSR process
                ctor.chunkName && $d1f67e51ea1e89a0$var$LOADABLE_SHARED.initialChunks[ctor.chunkName(props)])) _this.loadSync();
                return _this;
            }
            var _proto = InnerLoadable.prototype;
            _proto.componentDidMount = function componentDidMount() {
                this.mounted = true; // retrieve loading promise from a global cache
                var cachedPromise = this.getCache(); // if promise exists, but rejected - clear cache
                if (cachedPromise && cachedPromise.status === $d1f67e51ea1e89a0$var$STATUS_REJECTED) this.setCache();
                 // component might be resolved synchronously in the constructor
                if (this.state.loading) this.loadAsync();
            };
            _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
                // Component has to be reloaded on cacheKey change
                if (prevState.cacheKey !== this.state.cacheKey) this.loadAsync();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                this.mounted = false;
            };
            _proto.safeSetState = function safeSetState(nextState, callback) {
                if (this.mounted) this.setState(nextState, callback);
            };
            _proto.getCacheKey = function getCacheKey() {
                return _getCacheKey(this.props);
            };
            _proto.getCache = function getCache() {
                return cache[this.getCacheKey()];
            };
            _proto.setCache = function setCache(value) {
                if (value === void 0) value = undefined;
                cache[this.getCacheKey()] = value;
            };
            _proto.triggerOnLoad = function triggerOnLoad() {
                var _this2 = this;
                if (onLoad) setTimeout(function() {
                    onLoad(_this2.state.result, _this2.props);
                });
            };
            _proto.loadSync = function loadSync() {
                // load sync is expecting component to be in the "loading" state already
                // sounds weird, but loading=true is the initial state of InnerLoadable
                if (!this.state.loading) return;
                try {
                    var loadedModule = ctor.requireSync(this.props);
                    var result = resolve(loadedModule, this.props, Loadable);
                    this.state.result = result;
                    this.state.loading = false;
                } catch (error) {
                    console.error('loadable-components: failed to synchronously load component, which expected to be available', {
                        fileName: ctor.resolve(this.props),
                        chunkName: ctor.chunkName(this.props),
                        error: error ? error.message : error
                    });
                    this.state.error = error;
                }
            };
            _proto.loadAsync = function loadAsync() {
                var _this3 = this;
                var promise = this.resolveAsync();
                promise.then(function(loadedModule) {
                    var result = resolve(loadedModule, _this3.props, Loadable);
                    _this3.safeSetState({
                        result: result,
                        loading: false
                    }, function() {
                        return _this3.triggerOnLoad();
                    });
                })["catch"](function(error) {
                    return _this3.safeSetState({
                        error: error,
                        loading: false
                    });
                });
                return promise;
            };
            _proto.resolveAsync = function resolveAsync() {
                var _this$props = this.props, __chunkExtractor = _this$props.__chunkExtractor, forwardedRef = _this$props.forwardedRef, props = (0, $cFLic.default)(_this$props, [
                    "__chunkExtractor",
                    "forwardedRef"
                ]);
                return cachedLoad(props);
            };
            _proto.render = function render() {
                var _this$props2 = this.props, forwardedRef = _this$props2.forwardedRef, propFallback = _this$props2.fallback, __chunkExtractor = _this$props2.__chunkExtractor, props = (0, $cFLic.default)(_this$props2, [
                    "forwardedRef",
                    "fallback",
                    "__chunkExtractor"
                ]);
                var _this$state = this.state, error = _this$state.error, loading = _this$state.loading, result = _this$state.result;
                if (options.suspense) {
                    var cachedPromise = this.getCache() || this.loadAsync();
                    if (cachedPromise.status === $d1f67e51ea1e89a0$var$STATUS_PENDING) throw this.loadAsync();
                }
                if (error) throw error;
                var fallback = propFallback || options.fallback || null;
                if (loading) return fallback;
                return _render({
                    fallback: fallback,
                    result: result,
                    options: options,
                    props: (0, $kY3Ke.default)({}, props, {
                        ref: forwardedRef
                    })
                });
            };
            return InnerLoadable;
        }((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
        var EnhancedInnerLoadable = $d1f67e51ea1e89a0$var$withChunkExtractor(InnerLoadable);
        var Loadable = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(EnhancedInnerLoadable, Object.assign({
                forwardedRef: ref
            }, props));
        });
        Loadable.displayName = 'Loadable'; // In future, preload could use `<link rel="preload">`
        Loadable.preload = function(props) {
            Loadable.load(props);
        };
        Loadable.load = function(props) {
            return cachedLoad(props);
        };
        return Loadable;
    }
    function lazy(ctor, options) {
        return loadable(ctor, (0, $kY3Ke.default)({}, options, {
            suspense: true
        }));
    }
    return {
        loadable: loadable,
        lazy: lazy
    };
}
function $d1f67e51ea1e89a0$var$defaultResolveComponent(loadedModule) {
    // eslint-disable-next-line no-underscore-dangle
    return loadedModule.__esModule ? loadedModule["default"] : loadedModule["default"] || loadedModule;
}
/* eslint-disable no-use-before-define, react/no-multi-comp */ var $d1f67e51ea1e89a0$var$_createLoadable = /*#__PURE__*/ $d1f67e51ea1e89a0$var$createLoadable({
    defaultResolveComponent: $d1f67e51ea1e89a0$var$defaultResolveComponent,
    render: function render(_ref) {
        var Component = _ref.result, props = _ref.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, props);
    }
}), $d1f67e51ea1e89a0$var$loadable = $d1f67e51ea1e89a0$var$_createLoadable.loadable, $d1f67e51ea1e89a0$var$lazy = $d1f67e51ea1e89a0$var$_createLoadable.lazy;
/* eslint-disable no-use-before-define, react/no-multi-comp */ var $d1f67e51ea1e89a0$var$_createLoadable$1 = /*#__PURE__*/ $d1f67e51ea1e89a0$var$createLoadable({
    onLoad: function onLoad(result, props) {
        if (result && props.forwardedRef) {
            if (typeof props.forwardedRef === 'function') props.forwardedRef(result);
            else props.forwardedRef.current = result;
        }
    },
    render: function render(_ref) {
        var result = _ref.result, props = _ref.props;
        if (props.children) return props.children(result);
        return null;
    }
}), $d1f67e51ea1e89a0$var$loadable$1 = $d1f67e51ea1e89a0$var$_createLoadable$1.loadable, $d1f67e51ea1e89a0$var$lazy$1 = $d1f67e51ea1e89a0$var$_createLoadable$1.lazy;
/* eslint-disable no-underscore-dangle, camelcase */ var $d1f67e51ea1e89a0$var$BROWSER = typeof window !== 'undefined';
function $d1f67e51ea1e89a0$export$6486163faa357bc8(done, _temp) {
    if (done === void 0) done = function done() {};
    var _ref = _temp === void 0 ? {} : _temp, _ref$namespace = _ref.namespace, namespace = _ref$namespace === void 0 ? '' : _ref$namespace, _ref$chunkLoadingGlob = _ref.chunkLoadingGlobal, chunkLoadingGlobal = _ref$chunkLoadingGlob === void 0 ? '__LOADABLE_LOADED_CHUNKS__' : _ref$chunkLoadingGlob;
    if (!$d1f67e51ea1e89a0$var$BROWSER) {
        $d1f67e51ea1e89a0$var$warn('`loadableReady()` must be called in browser only');
        done();
        return Promise.resolve();
    }
    var requiredChunks = null;
    if ($d1f67e51ea1e89a0$var$BROWSER) {
        var id = $d1f67e51ea1e89a0$var$getRequiredChunkKey(namespace);
        var dataElement = document.getElementById(id);
        if (dataElement) {
            requiredChunks = JSON.parse(dataElement.textContent);
            var extElement = document.getElementById(id + "_ext");
            if (extElement) {
                var _JSON$parse = JSON.parse(extElement.textContent), namedChunks = _JSON$parse.namedChunks;
                namedChunks.forEach(function(chunkName) {
                    $d1f67e51ea1e89a0$var$LOADABLE_SHARED.initialChunks[chunkName] = true;
                });
            } else // version mismatch
            throw new Error('loadable-component: @loadable/server does not match @loadable/component');
        }
    }
    if (!requiredChunks) {
        $d1f67e51ea1e89a0$var$warn('`loadableReady()` requires state, please use `getScriptTags` or `getScriptElements` server-side');
        done();
        return Promise.resolve();
    }
    var resolved = false;
    return new Promise(function(resolve) {
        window[chunkLoadingGlobal] = window[chunkLoadingGlobal] || [];
        var loadedChunks = window[chunkLoadingGlobal];
        var originalPush = loadedChunks.push.bind(loadedChunks);
        function checkReadyState() {
            if (requiredChunks.every(function(chunk) {
                return loadedChunks.some(function(_ref2) {
                    var chunks = _ref2[0];
                    return chunks.indexOf(chunk) > -1;
                });
            })) {
                if (!resolved) {
                    resolved = true;
                    resolve();
                }
            }
        }
        loadedChunks.push = function() {
            originalPush.apply(void 0, arguments);
            checkReadyState();
        };
        checkReadyState();
    }).then(done);
}
/* eslint-disable no-underscore-dangle */ var $d1f67e51ea1e89a0$var$loadable$2 = $d1f67e51ea1e89a0$var$loadable;
$d1f67e51ea1e89a0$var$loadable$2.lib = $d1f67e51ea1e89a0$var$loadable$1;
var $d1f67e51ea1e89a0$export$488013bae63b21da = $d1f67e51ea1e89a0$var$lazy;
$d1f67e51ea1e89a0$export$488013bae63b21da.lib = $d1f67e51ea1e89a0$var$lazy$1;
var $d1f67e51ea1e89a0$export$ae55be85d98224ed = $d1f67e51ea1e89a0$var$sharedInternals;
var $d1f67e51ea1e89a0$export$2e2bcd8739ae039 = $d1f67e51ea1e89a0$var$loadable$2;

});
parcelRegister("cFLic", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $939dffaddf93a85b$export$2e2bcd8739ae039; });
function $939dffaddf93a85b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("3zeAJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $298ff58efa174465$export$2e2bcd8739ae039; });
function $298ff58efa174465$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("1KLsX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $146ee816144a450d$export$2e2bcd8739ae039; });

var $iJeDO = parcelRequire("iJeDO");
function $146ee816144a450d$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $iJeDO.default)(t, o);
}

});
parcelRegister("iJeDO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da27c96857818bcc$export$2e2bcd8739ae039; });
function $da27c96857818bcc$export$2e2bcd8739ae039(t, e) {
    return $da27c96857818bcc$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $da27c96857818bcc$export$2e2bcd8739ae039(t, e);
}

});



parcelRegister("9RhT3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eaabe7186fbf52a5$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $5ZeKC = parcelRequire("5ZeKC");
var $gsokU = parcelRequire("gsokU");
var $c1d0r = parcelRequire("c1d0r");
var $3M96K = parcelRequire("3M96K");
var $k4oz9 = parcelRequire("k4oz9");
var $3loMv = parcelRequire("3loMv");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $gxpCl = parcelRequire("gxpCl");

var $cSUCP = parcelRequire("cSUCP");

var $2I79p = parcelRequire("2I79p");

var $3oQOj = parcelRequire("3oQOj");

var $f3nsX = parcelRequire("f3nsX");

var $6PJp8 = parcelRequire("6PJp8");
var $eaabe7186fbf52a5$export$9f959f04eaaf1fa = /*#__PURE__*/ function(EmailVerifyTextId) {
    EmailVerifyTextId["ButtonReturn"] = "emailVerify.returnButton";
    EmailVerifyTextId["InvalidLinkBody"] = "emailVerify.invalidText";
    EmailVerifyTextId["InvalidLinkTitle"] = "emailVerify.invalidTitle";
    EmailVerifyTextId["TitleSuccess"] = "emailVerify.success";
    EmailVerifyTextId["TitleVerifying"] = "emailVerify.verifying";
    return EmailVerifyTextId;
}({});
function $eaabe7186fbf52a5$export$2e2bcd8739ae039() {
    const dispatch = (0, $f3nsX.useAppDispatch)();
    const navigate = (0, $gxpCl.useNavigate)();
    const { token: token } = (0, $gxpCl.useParams)();
    const { t: t } = (0, $doyfp.useTranslation)();
    const [loaded, setLoaded] = (0, $7fPBF.useState)(false);
    const [success, setSuccess] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        if (token) (0, $cSUCP.verifyEmail)(token).then(setSuccess).finally(()=>setLoaded(true));
    }, [
        token
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (success) // Trigger logout to force user to re-login (since we don't sync state between tabs).
        dispatch((0, $3oQOj.reset)());
    }, [
        dispatch,
        success
    ]);
    if (loaded && !success) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2I79p.default), {
        bodyTextId: "emailVerify.invalidText",
        titleTextId: "emailVerify.invalidTitle"
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $k4oz9.default), {
        container: true,
        justifyContent: "center",
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gsokU.default), {
            sx: {
                width: 450
            },
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3M96K.default), {
                    title: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                        align: "center",
                        variant: "h5",
                        children: t(success ? "emailVerify.success" : "emailVerify.verifying")
                    })
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c1d0r.default), {
                    children: success && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                        onClick: ()=>navigate((0, $6PJp8.Path).Login),
                        variant: "contained",
                        children: t("emailVerify.returnButton")
                    })
                })
            ]
        })
    });
}

});
parcelRegister("5ZeKC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45be1777d6a28263$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $gjk5S = parcelRequire("gjk5S");

var $cFCqu = parcelRequire("cFCqu");

var $kDjHH = parcelRequire("kDjHH");

var $bwizY = parcelRequire("bwizY");

var $HgAeG = parcelRequire("HgAeG");

var $kDBhE = parcelRequire("kDBhE");

var $7uFHh = parcelRequire("7uFHh");

var $iVAEr = parcelRequire("iVAEr");

var $3RNaF = parcelRequire("3RNaF");

var $iibPM = parcelRequire("iibPM");

var $b6UUh = parcelRequire("b6UUh");

var $wvp8q = parcelRequire("wvp8q");

var $grOnY = parcelRequire("grOnY");

var $5zBGX = parcelRequire("5zBGX");

var $juR2n = parcelRequire("juR2n");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $45be1777d6a28263$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            variant,
            `${variant}${(0, $b6UUh.default)(color)}`,
            `size${(0, $b6UUh.default)(size)}`,
            `${variant}Size${(0, $b6UUh.default)(size)}`,
            `color${(0, $b6UUh.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth',
            loading && `loadingPosition${(0, $b6UUh.default)(loadingPosition)}`
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $b6UUh.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $b6UUh.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $grOnY.getButtonUtilityClass), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $45be1777d6a28263$var$commonIconStyles = [
    {
        props: {
            size: 'small'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: 'medium'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: 'large'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 22
            }
        }
    }
];
const $45be1777d6a28263$var$ButtonRoot = (0, $kDBhE.default)((0, $3RNaF.default), {
    shouldForwardProp: (prop)=>(0, $HgAeG.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $b6UUh.default)(ownerState.color)}`],
            styles[`size${(0, $b6UUh.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $b6UUh.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth,
            ownerState.loading && styles.loading
        ];
    }
})((0, $7uFHh.default)(({ theme: theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return {
        ...theme.typography.button,
        minWidth: 64,
        padding: '6px 16px',
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            textDecoration: 'none'
        },
        [`&.${(0, $grOnY.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    '&:hover': {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${(0, $grOnY.default).focusVisible}`]: {
                        boxShadow: (theme.vars || theme).shadows[6]
                    },
                    [`&.${(0, $grOnY.default).disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    padding: '5px 15px',
                    border: '1px solid currentColor',
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${(0, $grOnY.default).disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    padding: '6px 8px',
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $wvp8q.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--variant-textColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedBorder': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.5)` : (0, $kDjHH.alpha)(theme.palette[color].main, 0.5),
                        '--variant-containedColor': (theme.vars || theme).palette[color].contrastText,
                        '--variant-containedBg': (theme.vars || theme).palette[color].main,
                        '@media (hover: hover)': {
                            '&:hover': {
                                '--variant-containedBg': (theme.vars || theme).palette[color].dark,
                                '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kDjHH.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '--variant-outlinedBorder': (theme.vars || theme).palette[color].main,
                                '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kDjHH.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit',
                    borderColor: 'currentColor',
                    '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    '@media (hover: hover)': {
                        '&:hover': {
                            '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kDjHH.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                            '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kDjHH.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'text'
                },
                style: {
                    padding: '4px 5px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'text'
                },
                style: {
                    padding: '8px 11px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'outlined'
                },
                style: {
                    padding: '3px 9px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'outlined'
                },
                style: {
                    padding: '7px 21px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'contained'
                },
                style: {
                    padding: '4px 10px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'contained'
                },
                style: {
                    padding: '8px 22px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $grOnY.default).focusVisible}`]: {
                        boxShadow: 'none'
                    },
                    '&:active': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $grOnY.default).disabled}`]: {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    transition: theme.transitions.create([
                        'background-color',
                        'box-shadow',
                        'border-color'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    [`&.${(0, $grOnY.default).loading}`]: {
                        color: 'transparent'
                    }
                }
            }
        ]
    };
}));
const $45be1777d6a28263$var$ButtonStartIcon = (0, $kDBhE.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            ownerState.loading && styles.startIconLoadingStart,
            styles[`iconSize${(0, $b6UUh.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginLeft: -2
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginRight: -8
                }
            },
            ...$45be1777d6a28263$var$commonIconStyles
        ]
    }));
const $45be1777d6a28263$var$ButtonEndIcon = (0, $kDBhE.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            ownerState.loading && styles.endIconLoadingEnd,
            styles[`iconSize${(0, $b6UUh.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginRight: -2
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginLeft: -8
                }
            },
            ...$45be1777d6a28263$var$commonIconStyles
        ]
    }));
const $45be1777d6a28263$var$ButtonLoadingIndicator = (0, $kDBhE.default)('span', {
    name: 'MuiButton',
    slot: 'LoadingIndicator',
    overridesResolver: (props, styles)=>styles.loadingIndicator
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            },
            {
                props: {
                    loadingPosition: 'start'
                },
                style: {
                    left: 14
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    size: 'small'
                },
                style: {
                    left: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'start'
                },
                style: {
                    left: 6
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%)',
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    loadingPosition: 'end'
                },
                style: {
                    right: 14
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    size: 'small'
                },
                style: {
                    right: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'end'
                },
                style: {
                    right: 6
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    left: -10
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    right: -10
                }
            }
        ]
    }));
const $45be1777d6a28263$var$ButtonLoadingIconPlaceholder = (0, $kDBhE.default)('span', {
    name: 'MuiButton',
    slot: 'LoadingIconPlaceholder',
    overridesResolver: (props, styles)=>styles.loadingIconPlaceholder
})({
    display: 'inline-block',
    width: '1em',
    height: '1em'
});
const $45be1777d6a28263$var$Button = /*#__PURE__*/ $7fPBF.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $7fPBF.useContext((0, $5zBGX.default));
    const buttonGroupButtonContextPositionClassName = $7fPBF.useContext((0, $juR2n.default));
    const resolvedProps = (0, $gjk5S.default)(contextProps, inProps);
    const props = (0, $iVAEr.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = 'center', size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text', ...other } = props;
    const loadingId = (0, $bwizY.default)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iibPM.default), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        size: size,
        type: type,
        variant: variant
    };
    const classes = $45be1777d6a28263$var$useUtilityClasses(ownerState);
    const startIcon = (startIconProp || loading && loadingPosition === 'start') && /*#__PURE__*/ (0, $bbzbN.jsx)($45be1777d6a28263$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp || /*#__PURE__*/ (0, $bbzbN.jsx)($45be1777d6a28263$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const endIcon = (endIconProp || loading && loadingPosition === 'end') && /*#__PURE__*/ (0, $bbzbN.jsx)($45be1777d6a28263$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp || /*#__PURE__*/ (0, $bbzbN.jsx)($45be1777d6a28263$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    const loader = typeof loading === 'boolean' ? /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
    (0, $bbzbN.jsx)("span", {
        className: classes.loadingWrapper,
        style: {
            display: 'contents'
        },
        children: loading && /*#__PURE__*/ (0, $bbzbN.jsx)($45be1777d6a28263$var$ButtonLoadingIndicator, {
            className: classes.loadingIndicator,
            ownerState: ownerState,
            children: loadingIndicator
        })
    }) : null;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($45be1777d6a28263$var$ButtonRoot, {
        ownerState: ownerState,
        className: (0, $hngXp.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled || loading,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $hngXp.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type,
        id: loading ? loadingId : idProp,
        ...other,
        classes: classes,
        children: [
            startIcon,
            loadingPosition !== 'end' && loader,
            children,
            loadingPosition === 'end' && loader,
            endIcon
        ]
    });
});
var $45be1777d6a28263$export$2e2bcd8739ae039 = $45be1777d6a28263$var$Button;

});
parcelRegister("hngXp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07a883fe7c352c85$export$2e2bcd8739ae039; });
function $07a883fe7c352c85$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $07a883fe7c352c85$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $07a883fe7c352c85$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $07a883fe7c352c85$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $07a883fe7c352c85$export$2e2bcd8739ae039 = $07a883fe7c352c85$export$4f5d2d50c9deca37;

});

parcelRegister("cFCqu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93971f0806345477$export$2e2bcd8739ae039; });
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $93971f0806345477$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

});

parcelRegister("bwizY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8631184a92cee7e5$export$2e2bcd8739ae039; });

var $65Itt = parcelRequire("65Itt");
'use client';
var $8631184a92cee7e5$export$2e2bcd8739ae039 = (0, $65Itt.default);

});

parcelRegister("HgAeG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0820e164eb5fbaff$export$2e2bcd8739ae039; });

var $yfUan = parcelRequire("yfUan");
const $0820e164eb5fbaff$var$rootShouldForwardProp = (prop)=>(0, $yfUan.default)(prop) && prop !== 'classes';
var $0820e164eb5fbaff$export$2e2bcd8739ae039 = $0820e164eb5fbaff$var$rootShouldForwardProp;

});
parcelRegister("yfUan", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $066f83798075d563$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $066f83798075d563$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $066f83798075d563$export$2e2bcd8739ae039 = $066f83798075d563$var$slotShouldForwardProp;

});


parcelRegister("kDBhE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0645ef192f222f7$export$2e2bcd8739ae039; });

var $7b8EK = parcelRequire("7b8EK");

var $9P91Y = parcelRequire("9P91Y");

var $jwhZE = parcelRequire("jwhZE");

var $HgAeG = parcelRequire("HgAeG");

'use client';
const $f0645ef192f222f7$var$styled = (0, $7b8EK.default)({
    themeId: (0, $jwhZE.default),
    defaultTheme: $9P91Y.default,
    rootShouldForwardProp: $HgAeG.default
});
var $f0645ef192f222f7$export$2e2bcd8739ae039 = $f0645ef192f222f7$var$styled;

});
parcelRegister("7b8EK", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", function () { return $53a046746a0f000c$export$3ba67b570e26eea0; });
$parcel$export(module.exports, "default", function () { return $53a046746a0f000c$export$2e2bcd8739ae039; });

var $5VCcJ = parcelRequire("5VCcJ");

var $3wRTY = parcelRequire("3wRTY");

var $iCiVn = parcelRequire("iCiVn");

var $bXHHW = parcelRequire("bXHHW");

var $2G6xE = parcelRequire("2G6xE");

var $8M6a3 = parcelRequire("8M6a3");

var $dQNB5 = parcelRequire("dQNB5");
const $53a046746a0f000c$export$35e57303dbd8a66 = (0, $2G6xE.default)();
function $53a046746a0f000c$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $53a046746a0f000c$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
function $53a046746a0f000c$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $53a046746a0f000c$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $53a046746a0f000c$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $53a046746a0f000c$var$processStyle(props, style, layerName) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$53a046746a0f000c$var$processStyle(props, subStyle, layerName));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = layerName ? $53a046746a0f000c$var$shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = layerName ? $53a046746a0f000c$var$shallowLayer((0, $5VCcJ.internal_serializeStyles)(otherStyles), layerName) : otherStyles;
        }
        return $53a046746a0f000c$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ], layerName);
    }
    if (resolvedStyle?.isProcessed) return layerName ? $53a046746a0f000c$var$shallowLayer((0, $5VCcJ.internal_serializeStyles)(resolvedStyle.style), layerName) : resolvedStyle.style;
    return layerName ? $53a046746a0f000c$var$shallowLayer((0, $5VCcJ.internal_serializeStyles)(resolvedStyle), layerName) : resolvedStyle;
}
function $53a046746a0f000c$var$processStyleVariants(props, variants, results = [], layerName) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(layerName ? $53a046746a0f000c$var$shallowLayer((0, $5VCcJ.internal_serializeStyles)(variant.style(mergedState)), layerName) : variant.style(mergedState));
        } else results.push(layerName ? $53a046746a0f000c$var$shallowLayer((0, $5VCcJ.internal_serializeStyles)(variant.style), layerName) : variant.style);
    }
    return results;
}
function $53a046746a0f000c$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $53a046746a0f000c$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $53a046746a0f000c$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $53a046746a0f000c$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $53a046746a0f000c$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $5VCcJ.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== (0, $8M6a3.default)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $53a046746a0f000c$var$defaultOverridesResolver($53a046746a0f000c$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $53a046746a0f000c$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($53a046746a0f000c$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $5VCcJ.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $53a046746a0f000c$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $53a046746a0f000c$var$processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
            };
            if ((0, $3wRTY.isPlainObject)(style)) {
                const serialized = (0, $dQNB5.default)(style);
                return function styleObjectProcessor(props) {
                    if (!serialized.variants) return props.theme.modularCssLayers ? $53a046746a0f000c$var$shallowLayer(serialized.style, layerName) : serialized.style;
                    return $53a046746a0f000c$var$processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $53a046746a0f000c$var$processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? 'theme' : undefined);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $53a046746a0f000c$var$processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsTail.push((0, $8M6a3.default));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $53a046746a0f000c$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $iCiVn.default)(componentSlot || '')}`;
    return `Styled(${(0, $bXHHW.default)(tag)})`;
}
function $53a046746a0f000c$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $53a046746a0f000c$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $53a046746a0f000c$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $53a046746a0f000c$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

});
parcelRegister("bXHHW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b571bd6b8501d36$export$2e2bcd8739ae039; });

var $61wrp = parcelRequire("61wrp");
function $8b571bd6b8501d36$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $8b571bd6b8501d36$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $8b571bd6b8501d36$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $8b571bd6b8501d36$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $8b571bd6b8501d36$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $61wrp.ForwardRef:
            return $8b571bd6b8501d36$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $61wrp.Memo:
            return $8b571bd6b8501d36$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});

parcelRegister("dQNB5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1569aad1198ad2f$export$2e2bcd8739ae039; });

var $5VCcJ = parcelRequire("5VCcJ");
function $a1569aad1198ad2f$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $5VCcJ.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $5VCcJ.internal_serializeStyles)(variant.style);
    });
    return result;
}

});


parcelRegister("9P91Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $726fe1d2377a5002$export$2e2bcd8739ae039; });

var $hmhHQ = parcelRequire("hmhHQ");
'use client';
const $726fe1d2377a5002$var$defaultTheme = (0, $hmhHQ.default)();
var $726fe1d2377a5002$export$2e2bcd8739ae039 = $726fe1d2377a5002$var$defaultTheme;

});


parcelRegister("7uFHh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $574bade4fe8533ba$export$2e2bcd8739ae039; });

var $eu6uJ = parcelRequire("eu6uJ");
const $574bade4fe8533ba$var$memoTheme = (0, $eu6uJ.default);
var $574bade4fe8533ba$export$2e2bcd8739ae039 = $574bade4fe8533ba$var$memoTheme;

});
parcelRegister("eu6uJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8b8e7bf90e97755$export$2e2bcd8739ae039; });

var $dQNB5 = parcelRequire("dQNB5");
/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $a8b8e7bf90e97755$var$arg = {
    theme: undefined
};
function $a8b8e7bf90e97755$export$2e2bcd8739ae039(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $a8b8e7bf90e97755$var$arg.theme = props.theme;
            value = (0, $dQNB5.default)(styleFn($a8b8e7bf90e97755$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}

});


parcelRegister("iVAEr", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $dc79fb0f6686e80b$export$2440da353cedad43; });
parcelRequire("7fPBF");


var $7eatR = parcelRequire("7eatR");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $dc79fb0f6686e80b$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7eatR.default), {
        ...props
    });
}
var $dc79fb0f6686e80b$export$2e2bcd8739ae039 = $dc79fb0f6686e80b$var$DefaultPropsProvider;
function $dc79fb0f6686e80b$export$2440da353cedad43(params) {
    return (0, $7eatR.useDefaultProps)(params);
}

});

parcelRegister("3RNaF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d0c76ae9ca5c817$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");



var $cFCqu = parcelRequire("cFCqu");

var $18skz = parcelRequire("18skz");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $6NwTb = parcelRequire("6NwTb");

var $1XFnq = parcelRequire("1XFnq");

var $5FLzA = parcelRequire("5FLzA");

var $5rlhe = parcelRequire("5rlhe");

var $i9gyt = parcelRequire("i9gyt");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $2d0c76ae9ca5c817$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $i9gyt.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $2d0c76ae9ca5c817$export$7ec0dcc5e3cdcd36 = (0, $kDBhE.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $i9gyt.default).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $2d0c76ae9ca5c817$var$ButtonBase = /*#__PURE__*/ $7fPBF.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const buttonRef = $7fPBF.useRef(null);
    const ripple = (0, $5FLzA.default)();
    const handleRippleRef = (0, $6NwTb.default)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $7fPBF.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $7fPBF.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $7fPBF.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $2d0c76ae9ca5c817$var$useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = $2d0c76ae9ca5c817$var$useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = $2d0c76ae9ca5c817$var$useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = $2d0c76ae9ca5c817$var$useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = $2d0c76ae9ca5c817$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $2d0c76ae9ca5c817$var$useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = $2d0c76ae9ca5c817$var$useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = $2d0c76ae9ca5c817$var$useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = $2d0c76ae9ca5c817$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, $18skz.default)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $1XFnq.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, $18skz.default)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    const handleKeyDown = (0, $1XFnq.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $1XFnq.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $6NwTb.default)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    };
    const classes = $2d0c76ae9ca5c817$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($2d0c76ae9ca5c817$export$7ec0dcc5e3cdcd36, {
        as: ComponentProp,
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5rlhe.default), {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function $2d0c76ae9ca5c817$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $1XFnq.default)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $2d0c76ae9ca5c817$export$2e2bcd8739ae039 = $2d0c76ae9ca5c817$var$ButtonBase;

});
parcelRegister("18skz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d3c83b1c3920329$export$2e2bcd8739ae039; });
/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $0d3c83b1c3920329$export$2e2bcd8739ae039(element) {
    try {
        return element.matches(':focus-visible');
    } catch (error) {}
    return false;
}

});

parcelRegister("6NwTb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f30d4c1188a58e6$export$2e2bcd8739ae039; });

var $jTdAm = parcelRequire("jTdAm");
'use client';
var $4f30d4c1188a58e6$export$2e2bcd8739ae039 = (0, $jTdAm.default);

});
parcelRegister("jTdAm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7adb12ba33c17bd$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
'use client';
function $e7adb12ba33c17bd$export$2e2bcd8739ae039(...refs) {
    const cleanupRef = $7fPBF.useRef(undefined);
    const refEffect = $7fPBF.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $7fPBF.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});


parcelRegister("1XFnq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16db65b1f19e65f7$export$2e2bcd8739ae039; });

var $giDhD = parcelRequire("giDhD");
'use client';
var $16db65b1f19e65f7$export$2e2bcd8739ae039 = (0, $giDhD.default);

});
parcelRegister("giDhD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bddccca9f6cee29b$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $lJRRs = parcelRequire("lJRRs");
'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $bddccca9f6cee29b$var$useEventCallback(fn) {
    const ref = $7fPBF.useRef(fn);
    (0, $lJRRs.default)(()=>{
        ref.current = fn;
    });
    return $7fPBF.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $bddccca9f6cee29b$export$2e2bcd8739ae039 = $bddccca9f6cee29b$var$useEventCallback;

});


parcelRegister("5FLzA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4215af10cb5e802b$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $bLtIh = parcelRequire("bLtIh");
'use client';
class $4215af10cb5e802b$export$f5de0641c7db4154 {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $4215af10cb5e802b$export$f5de0641c7db4154();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, $bLtIh.default)($4215af10cb5e802b$export$f5de0641c7db4154.create).current;
        const [shouldMount, setShouldMount] = $7fPBF.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $7fPBF.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    constructor(){
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $4215af10cb5e802b$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) {
                this.didMount = true;
                this.mounted.resolve();
            }
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
function $4215af10cb5e802b$export$2e2bcd8739ae039() {
    return $4215af10cb5e802b$export$f5de0641c7db4154.use();
}
function $4215af10cb5e802b$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}

});
parcelRegister("bLtIh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $890b21ec8e20082a$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
'use client';
const $890b21ec8e20082a$var$UNINITIALIZED = {};
function $890b21ec8e20082a$export$2e2bcd8739ae039(init, initArg) {
    const ref = $7fPBF.useRef($890b21ec8e20082a$var$UNINITIALIZED);
    if (ref.current === $890b21ec8e20082a$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});


parcelRegister("5rlhe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f5ffa895ad4456e$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $4axyc = parcelRequire("4axyc");

var $hngXp = parcelRequire("hngXp");

var $de55R = parcelRequire("de55R");

var $5nUae = parcelRequire("5nUae");
var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $5geXw = parcelRequire("5geXw");

var $lCBOk = parcelRequire("lCBOk");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $3f5ffa895ad4456e$var$DURATION = 550;
const $3f5ffa895ad4456e$export$95d0c9356b2231a3 = 80;
const $3f5ffa895ad4456e$var$enterKeyframe = (0, $5nUae.keyframes)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const $3f5ffa895ad4456e$var$exitKeyframe = (0, $5nUae.keyframes)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const $3f5ffa895ad4456e$var$pulsateKeyframe = (0, $5nUae.keyframes)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const $3f5ffa895ad4456e$export$f6b7418508c72c25 = (0, $kDBhE.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $3f5ffa895ad4456e$export$676cfe7b12693c4b = (0, $kDBhE.default)((0, $5geXw.default), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${(0, $lCBOk.default).rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${$3f5ffa895ad4456e$var$enterKeyframe};
    animation-duration: ${$3f5ffa895ad4456e$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  &.${(0, $lCBOk.default).ripplePulsate} {
    animation-duration: ${({ theme: theme })=>theme.transitions.duration.shorter}ms;
  }

  & .${(0, $lCBOk.default).child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${(0, $lCBOk.default).childLeaving} {
    opacity: 0;
    animation-name: ${$3f5ffa895ad4456e$var$exitKeyframe};
    animation-duration: ${$3f5ffa895ad4456e$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  & .${(0, $lCBOk.default).childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${$3f5ffa895ad4456e$var$pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $3f5ffa895ad4456e$var$TouchRipple = /*#__PURE__*/ $7fPBF.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className, ...other } = props;
    const [ripples, setRipples] = $7fPBF.useState([]);
    const nextKey = $7fPBF.useRef(0);
    const rippleCallback = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $7fPBF.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $de55R.default)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $7fPBF.useRef(null);
    const container = $7fPBF.useRef(null);
    const startCommit = $7fPBF.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $bbzbN.jsx)($3f5ffa895ad4456e$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $hngXp.default)(classes.ripple, (0, $lCBOk.default).ripple),
                        rippleVisible: (0, $hngXp.default)(classes.rippleVisible, (0, $lCBOk.default).rippleVisible),
                        ripplePulsate: (0, $hngXp.default)(classes.ripplePulsate, (0, $lCBOk.default).ripplePulsate),
                        child: (0, $hngXp.default)(classes.child, (0, $lCBOk.default).child),
                        childLeaving: (0, $hngXp.default)(classes.childLeaving, (0, $lCBOk.default).childLeaving),
                        childPulsate: (0, $hngXp.default)(classes.childPulsate, (0, $lCBOk.default).childPulsate)
                    },
                    timeout: $3f5ffa895ad4456e$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $7fPBF.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if (event?.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event?.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($3f5ffa895ad4456e$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $7fPBF.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $7fPBF.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event?.type === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $7fPBF.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($3f5ffa895ad4456e$export$f6b7418508c72c25, {
        className: (0, $hngXp.default)((0, $lCBOk.default).root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4axyc.default), {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
var $3f5ffa895ad4456e$export$2e2bcd8739ae039 = $3f5ffa895ad4456e$var$TouchRipple;

});
parcelRegister("4axyc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30921f11ad4ef55c$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $3zeAJ = parcelRequire("3zeAJ");

var $1KLsX = parcelRequire("1KLsX");


var $7fPBF = parcelRequire("7fPBF");

var $8ovTL = parcelRequire("8ovTL");

var $3CAnX = parcelRequire("3CAnX");
var $30921f11ad4ef55c$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $30921f11ad4ef55c$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $30921f11ad4ef55c$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $3zeAJ.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $3CAnX.getInitialChildMapping)(nextProps, handleExited) : (0, $3CAnX.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $3CAnX.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $kY3Ke.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $cFLic.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $30921f11ad4ef55c$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8ovTL.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8ovTL.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$30921f11ad4ef55c$var$TransitionGroup.propTypes = {};
$30921f11ad4ef55c$var$TransitionGroup.defaultProps = $30921f11ad4ef55c$var$defaultProps;
var $30921f11ad4ef55c$export$2e2bcd8739ae039 = $30921f11ad4ef55c$var$TransitionGroup;

});
parcelRegister("8ovTL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61c94efb1735eff6$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
var $61c94efb1735eff6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);

});

parcelRegister("3CAnX", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $2a31251aa5f7eb4f$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $2a31251aa5f7eb4f$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $2a31251aa5f7eb4f$export$36fd1af28d383ec0; });

var $7fPBF = parcelRequire("7fPBF");
function $2a31251aa5f7eb4f$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $7fPBF.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $7fPBF.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $2a31251aa5f7eb4f$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $2a31251aa5f7eb4f$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $2a31251aa5f7eb4f$export$fa71e2345c31d7a2(props, onExited) {
    return $2a31251aa5f7eb4f$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $2a31251aa5f7eb4f$var$getProp(child, 'appear', props),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', props),
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', props)
        });
    });
}
function $2a31251aa5f7eb4f$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $2a31251aa5f7eb4f$export$bbc8a025727ea824(nextProps.children);
    var children = $2a31251aa5f7eb4f$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $7fPBF.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $7fPBF.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', nextProps),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $7fPBF.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', nextProps),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

});


parcelRegister("de55R", function(module, exports) {

$parcel$export(module.exports, "Timeout", function () { return $9a1088a9a7141b09$export$786b4da70f00938b; });
$parcel$export(module.exports, "default", function () { return $9a1088a9a7141b09$export$2e2bcd8739ae039; });

var $bLtIh = parcelRequire("bLtIh");

var $2v2Iy = parcelRequire("2v2Iy");
'use client';
class $9a1088a9a7141b09$export$786b4da70f00938b {
    static create() {
        return new $9a1088a9a7141b09$export$786b4da70f00938b();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
function $9a1088a9a7141b09$export$2e2bcd8739ae039() {
    const timeout = (0, $bLtIh.default)($9a1088a9a7141b09$export$786b4da70f00938b.create).current;
    (0, $2v2Iy.default)(timeout.disposeEffect);
    return timeout;
}

});
parcelRegister("2v2Iy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d2095ad20314533$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
'use client';
const $1d2095ad20314533$var$EMPTY = [];
function $1d2095ad20314533$export$2e2bcd8739ae039(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $7fPBF.useEffect(fn, $1d2095ad20314533$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});


parcelRegister("5geXw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d4a0ced9cf2c3c7$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $3d4a0ced9cf2c3c7$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $7fPBF.useState(false);
    const rippleClassName = (0, $hngXp.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $hngXp.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $7fPBF.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            className: childClassName
        })
    });
}
var $3d4a0ced9cf2c3c7$export$2e2bcd8739ae039 = $3d4a0ced9cf2c3c7$var$Ripple;

});

parcelRegister("lCBOk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbda7a0931c56f58$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $fbda7a0931c56f58$export$b464606f735ab902(slot) {
    return (0, $k6RDS.default)('MuiTouchRipple', slot);
}
const $fbda7a0931c56f58$var$touchRippleClasses = (0, $4jzsB.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $fbda7a0931c56f58$export$2e2bcd8739ae039 = $fbda7a0931c56f58$var$touchRippleClasses;

});
parcelRegister("4jzsB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32447174989d1976$export$2e2bcd8739ae039; });

var $k6RDS = parcelRequire("k6RDS");
function $32447174989d1976$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $k6RDS.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("k6RDS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea3dfa6b173640a4$export$2e2bcd8739ae039; });

var $kU6nt = parcelRequire("kU6nt");
const $ea3dfa6b173640a4$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $ea3dfa6b173640a4$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $ea3dfa6b173640a4$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $kU6nt.default).generate(componentName)}-${slot}`;
}
function $ea3dfa6b173640a4$export$34c0130b1f3e8ae3(slot) {
    return $ea3dfa6b173640a4$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("kU6nt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f37dfc12e5d89c96$export$2e2bcd8739ae039; });
const $f37dfc12e5d89c96$var$defaultGenerator = (componentName)=>componentName;
const $f37dfc12e5d89c96$var$createClassNameGenerator = ()=>{
    let generate = $f37dfc12e5d89c96$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $f37dfc12e5d89c96$var$defaultGenerator;
        }
    };
};
const $f37dfc12e5d89c96$var$ClassNameGenerator = $f37dfc12e5d89c96$var$createClassNameGenerator();
var $f37dfc12e5d89c96$export$2e2bcd8739ae039 = $f37dfc12e5d89c96$var$ClassNameGenerator;

});





parcelRegister("i9gyt", function(module, exports) {

$parcel$export(module.exports, "getButtonBaseUtilityClass", function () { return $d365e8bde1350eb0$export$fccb0498dcd99783; });
$parcel$export(module.exports, "default", function () { return $d365e8bde1350eb0$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $d365e8bde1350eb0$export$fccb0498dcd99783(slot) {
    return (0, $k6RDS.default)('MuiButtonBase', slot);
}
const $d365e8bde1350eb0$var$buttonBaseClasses = (0, $4jzsB.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $d365e8bde1350eb0$export$2e2bcd8739ae039 = $d365e8bde1350eb0$var$buttonBaseClasses;

});


parcelRegister("iibPM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d513166e63c42433$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $5nUae = parcelRequire("5nUae");
var $kDBhE = parcelRequire("kDBhE");

var $7uFHh = parcelRequire("7uFHh");

var $iVAEr = parcelRequire("iVAEr");

var $b6UUh = parcelRequire("b6UUh");

var $wvp8q = parcelRequire("wvp8q");

var $d0vho = parcelRequire("d0vho");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $d513166e63c42433$var$SIZE = 44;
const $d513166e63c42433$var$circularRotateKeyframe = (0, $5nUae.keyframes)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const $d513166e63c42433$var$circularDashKeyframe = (0, $5nUae.keyframes)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $d513166e63c42433$var$rotateAnimation = typeof $d513166e63c42433$var$circularRotateKeyframe !== 'string' ? (0, $5nUae.css)`
        animation: ${$d513166e63c42433$var$circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const $d513166e63c42433$var$dashAnimation = typeof $d513166e63c42433$var$circularDashKeyframe !== 'string' ? (0, $5nUae.css)`
        animation: ${$d513166e63c42433$var$circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const $d513166e63c42433$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $b6UUh.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $b6UUh.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $d0vho.getCircularProgressUtilityClass), classes);
};
const $d513166e63c42433$var$CircularProgressRoot = (0, $kDBhE.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $b6UUh.default)(ownerState.color)}`]
        ];
    }
})((0, $7uFHh.default)(({ theme: theme })=>({
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('transform')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: $d513166e63c42433$var$rotateAnimation || {
                    animation: `${$d513166e63c42433$var$circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...Object.entries(theme.palette).filter((0, $wvp8q.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $d513166e63c42433$var$CircularProgressSVG = (0, $kDBhE.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $d513166e63c42433$var$CircularProgressCircle = (0, $kDBhE.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $b6UUh.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, $7uFHh.default)(({ theme: theme })=>({
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('stroke-dashoffset')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine waiting for the animation to kicks in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: $d513166e63c42433$var$dashAnimation || {
                    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
                    animation: `${$d513166e63c42433$var$circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $d513166e63c42433$var$CircularProgress = /*#__PURE__*/ $7fPBF.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    };
    const classes = $d513166e63c42433$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($d513166e63c42433$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)($d513166e63c42433$var$CircularProgressRoot, {
        className: (0, $hngXp.default)(classes.root, className),
        style: {
            width: size,
            height: size,
            ...rootStyle,
            ...style
        },
        ownerState: ownerState,
        ref: ref,
        role: "progressbar",
        ...rootProps,
        ...other,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($d513166e63c42433$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$d513166e63c42433$var$SIZE / 2} ${$d513166e63c42433$var$SIZE / 2} ${$d513166e63c42433$var$SIZE} ${$d513166e63c42433$var$SIZE}`,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)($d513166e63c42433$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $d513166e63c42433$var$SIZE,
                cy: $d513166e63c42433$var$SIZE,
                r: ($d513166e63c42433$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    });
});
var $d513166e63c42433$export$2e2bcd8739ae039 = $d513166e63c42433$var$CircularProgress;

});
parcelRegister("b6UUh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $816c65c0e1f7082c$export$2e2bcd8739ae039; });

var $iCiVn = parcelRequire("iCiVn");
var $816c65c0e1f7082c$export$2e2bcd8739ae039 = (0, $iCiVn.default);

});

parcelRegister("wvp8q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $061b5988a3817e26$export$2e2bcd8739ae039; });
/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $061b5988a3817e26$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $061b5988a3817e26$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$061b5988a3817e26$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
function $061b5988a3817e26$export$2e2bcd8739ae039(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $061b5988a3817e26$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}

});

parcelRegister("d0vho", function(module, exports) {

$parcel$export(module.exports, "getCircularProgressUtilityClass", function () { return $978389e4a0c045ec$export$29cad1383b3f235d; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $978389e4a0c045ec$export$29cad1383b3f235d(slot) {
    return (0, $k6RDS.default)('MuiCircularProgress', slot);
}
const $978389e4a0c045ec$var$circularProgressClasses = (0, $4jzsB.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $978389e4a0c045ec$export$2e2bcd8739ae039 = $978389e4a0c045ec$var$circularProgressClasses;

});


parcelRegister("grOnY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getButtonUtilityClass", function () { return $bf96407f1f5b4126$export$5a6f9035944c8119; });
$parcel$export(module.exports, "default", function () { return $bf96407f1f5b4126$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $bf96407f1f5b4126$export$5a6f9035944c8119(slot) {
    return (0, $k6RDS.default)('MuiButton', slot);
}
const $bf96407f1f5b4126$var$buttonClasses = (0, $4jzsB.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge',
    'loading',
    'loadingWrapper',
    'loadingIconPlaceholder',
    'loadingIndicator',
    'loadingPositionCenter',
    'loadingPositionStart',
    'loadingPositionEnd'
]);
var $bf96407f1f5b4126$export$2e2bcd8739ae039 = $bf96407f1f5b4126$var$buttonClasses;

});

parcelRegister("5zBGX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40ed7573a59c2be9$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * @ignore - internal component.
 */ const $40ed7573a59c2be9$var$ButtonGroupContext = /*#__PURE__*/ $7fPBF.createContext({});
var $40ed7573a59c2be9$export$2e2bcd8739ae039 = $40ed7573a59c2be9$var$ButtonGroupContext;

});

parcelRegister("juR2n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e319f5c3a4402058$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * @ignore - internal component.
 */ const $e319f5c3a4402058$var$ButtonGroupButtonContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
var $e319f5c3a4402058$export$2e2bcd8739ae039 = $e319f5c3a4402058$var$ButtonGroupButtonContext;

});


parcelRegister("gsokU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfb223886c302418$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $a2ay0 = parcelRequire("a2ay0");

var $bgCoQ = parcelRequire("bgCoQ");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $bfb223886c302418$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $bgCoQ.getCardUtilityClass), classes);
};
const $bfb223886c302418$var$CardRoot = (0, $kDBhE.default)((0, $a2ay0.default), {
    name: 'MuiCard',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    overflow: 'hidden'
});
const $bfb223886c302418$var$Card = /*#__PURE__*/ $7fPBF.forwardRef(function Card(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className: className, raised: raised = false, ...other } = props;
    const ownerState = {
        ...props,
        raised: raised
    };
    const classes = $bfb223886c302418$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($bfb223886c302418$var$CardRoot, {
        className: (0, $hngXp.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $bfb223886c302418$export$2e2bcd8739ae039 = $bfb223886c302418$var$Card;

});
parcelRegister("a2ay0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74e245c78e363f11$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");



var $cFCqu = parcelRequire("cFCqu");

var $kDjHH = parcelRequire("kDjHH");

var $kDBhE = parcelRequire("kDBhE");
var $g9bTP = parcelRequire("g9bTP");

var $7uFHh = parcelRequire("7uFHh");

var $iVAEr = parcelRequire("iVAEr");

var $ckFUN = parcelRequire("ckFUN");

var $giMq6 = parcelRequire("giMq6");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $74e245c78e363f11$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $giMq6.getPaperUtilityClass), classes);
};
const $74e245c78e363f11$var$PaperRoot = (0, $kDBhE.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, $7uFHh.default)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow'),
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: 'elevation'
                },
                style: {
                    boxShadow: 'var(--Paper-shadow)',
                    backgroundImage: 'var(--Paper-overlay)'
                }
            }
        ]
    })));
const $74e245c78e363f11$var$Paper = /*#__PURE__*/ $7fPBF.forwardRef(function Paper(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const theme = (0, $g9bTP.default)();
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    };
    const classes = $74e245c78e363f11$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($74e245c78e363f11$var$PaperRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            ...variant === 'elevation' && {
                '--Paper-shadow': (theme.vars || theme).shadows[elevation],
                ...theme.vars && {
                    '--Paper-overlay': theme.vars.overlays?.[elevation]
                },
                ...!theme.vars && theme.palette.mode === 'dark' && {
                    '--Paper-overlay': `linear-gradient(${(0, $kDjHH.alpha)('#fff', (0, $ckFUN.default)(elevation))}, ${(0, $kDjHH.alpha)('#fff', (0, $ckFUN.default)(elevation))})`
                }
            },
            ...other.style
        }
    });
});
var $74e245c78e363f11$export$2e2bcd8739ae039 = $74e245c78e363f11$var$Paper;

});
parcelRegister("g9bTP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc16b792e42cac5d$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $dSbTr = parcelRequire("dSbTr");

var $9P91Y = parcelRequire("9P91Y");

var $jwhZE = parcelRequire("jwhZE");
'use client';
function $bc16b792e42cac5d$export$2e2bcd8739ae039() {
    const theme = (0, $dSbTr.default)((0, $9P91Y.default));
    return theme[0, $jwhZE.default] || theme;
}

});

parcelRegister("giMq6", function(module, exports) {

$parcel$export(module.exports, "getPaperUtilityClass", function () { return $bde3e2fffcaea664$export$29cdb466b9b6f20b; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $bde3e2fffcaea664$export$29cdb466b9b6f20b(slot) {
    return (0, $k6RDS.default)('MuiPaper', slot);
}
const $bde3e2fffcaea664$var$paperClasses = (0, $4jzsB.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $bde3e2fffcaea664$export$2e2bcd8739ae039 = $bde3e2fffcaea664$var$paperClasses;

});


parcelRegister("bgCoQ", function(module, exports) {

$parcel$export(module.exports, "getCardUtilityClass", function () { return $833ef9b800b82ea7$export$f3b76d2cce458caa; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $833ef9b800b82ea7$export$f3b76d2cce458caa(slot) {
    return (0, $k6RDS.default)('MuiCard', slot);
}
const $833ef9b800b82ea7$var$cardClasses = (0, $4jzsB.default)('MuiCard', [
    'root'
]);
var $833ef9b800b82ea7$export$2e2bcd8739ae039 = $833ef9b800b82ea7$var$cardClasses;

});


parcelRegister("c1d0r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8bffaacbbee0c705$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $gIW00 = parcelRequire("gIW00");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $8bffaacbbee0c705$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $gIW00.getCardContentUtilityClass), classes);
};
const $8bffaacbbee0c705$var$CardContentRoot = (0, $kDBhE.default)('div', {
    name: 'MuiCardContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: 16,
    '&:last-child': {
        paddingBottom: 24
    }
});
const $8bffaacbbee0c705$var$CardContent = /*#__PURE__*/ $7fPBF.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiCardContent'
    });
    const { className: className, component: component = 'div', ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $8bffaacbbee0c705$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($8bffaacbbee0c705$var$CardContentRoot, {
        as: component,
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $8bffaacbbee0c705$export$2e2bcd8739ae039 = $8bffaacbbee0c705$var$CardContent;

});
parcelRegister("gIW00", function(module, exports) {

$parcel$export(module.exports, "getCardContentUtilityClass", function () { return $c2cdbecd165cb878$export$964336739a8c7119; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $c2cdbecd165cb878$export$964336739a8c7119(slot) {
    return (0, $k6RDS.default)('MuiCardContent', slot);
}
const $c2cdbecd165cb878$var$cardContentClasses = (0, $4jzsB.default)('MuiCardContent', [
    'root'
]);
var $c2cdbecd165cb878$export$2e2bcd8739ae039 = $c2cdbecd165cb878$var$cardContentClasses;

});


parcelRegister("3M96K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2bfceb6bd3ad6f45$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $cFCqu = parcelRequire("cFCqu");

var $3loMv = parcelRequire("3loMv");
var $iG6DO = parcelRequire("iG6DO");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $2NR5i = parcelRequire("2NR5i");

var $99c9I = parcelRequire("99c9I");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $2bfceb6bd3ad6f45$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        avatar: [
            'avatar'
        ],
        action: [
            'action'
        ],
        content: [
            'content'
        ],
        title: [
            'title'
        ],
        subheader: [
            'subheader'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $2NR5i.getCardHeaderUtilityClass), classes);
};
const $2bfceb6bd3ad6f45$var$CardHeaderRoot = (0, $kDBhE.default)('div', {
    name: 'MuiCardHeader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${(0, $2NR5i.default).title}`]: styles.title
            },
            {
                [`& .${(0, $2NR5i.default).subheader}`]: styles.subheader
            },
            styles.root
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 16
});
const $2bfceb6bd3ad6f45$var$CardHeaderAvatar = (0, $kDBhE.default)('div', {
    name: 'MuiCardHeader',
    slot: 'Avatar',
    overridesResolver: (props, styles)=>styles.avatar
})({
    display: 'flex',
    flex: '0 0 auto',
    marginRight: 16
});
const $2bfceb6bd3ad6f45$var$CardHeaderAction = (0, $kDBhE.default)('div', {
    name: 'MuiCardHeader',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    flex: '0 0 auto',
    alignSelf: 'flex-start',
    marginTop: -4,
    marginRight: -8,
    marginBottom: -4
});
const $2bfceb6bd3ad6f45$var$CardHeaderContent = (0, $kDBhE.default)('div', {
    name: 'MuiCardHeader',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})({
    flex: '1 1 auto',
    [`.${(0, $iG6DO.default).root}:where(& .${(0, $2NR5i.default).title})`]: {
        display: 'block'
    },
    [`.${(0, $iG6DO.default).root}:where(& .${(0, $2NR5i.default).subheader})`]: {
        display: 'block'
    }
});
const $2bfceb6bd3ad6f45$var$CardHeader = /*#__PURE__*/ $7fPBF.forwardRef(function CardHeader(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiCardHeader'
    });
    const { action: action, avatar: avatar, component: component = 'div', disableTypography: disableTypography = false, subheader: subheaderProp, subheaderTypographyProps: subheaderTypographyProps, title: titleProp, titleTypographyProps: titleTypographyProps, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        disableTypography: disableTypography
    };
    const classes = $2bfceb6bd3ad6f45$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            title: titleTypographyProps,
            subheader: subheaderTypographyProps,
            ...slotProps
        }
    };
    let title = titleProp;
    const [TitleSlot, titleSlotProps] = (0, $99c9I.default)('title', {
        className: classes.title,
        elementType: (0, $3loMv.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            variant: avatar ? 'body2' : 'h5',
            component: 'span'
        }
    });
    if (title != null && title.type !== (0, $3loMv.default) && !disableTypography) title = /*#__PURE__*/ (0, $bbzbN.jsx)(TitleSlot, {
        ...titleSlotProps,
        children: title
    });
    let subheader = subheaderProp;
    const [SubheaderSlot, subheaderSlotProps] = (0, $99c9I.default)('subheader', {
        className: classes.subheader,
        elementType: (0, $3loMv.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            variant: avatar ? 'body2' : 'body1',
            color: 'textSecondary',
            component: 'span'
        }
    });
    if (subheader != null && subheader.type !== (0, $3loMv.default) && !disableTypography) subheader = /*#__PURE__*/ (0, $bbzbN.jsx)(SubheaderSlot, {
        ...subheaderSlotProps,
        children: subheader
    });
    const [RootSlot, rootSlotProps] = (0, $99c9I.default)('root', {
        ref: ref,
        className: classes.root,
        elementType: $2bfceb6bd3ad6f45$var$CardHeaderRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        ownerState: ownerState
    });
    const [AvatarSlot, avatarSlotProps] = (0, $99c9I.default)('avatar', {
        className: classes.avatar,
        elementType: $2bfceb6bd3ad6f45$var$CardHeaderAvatar,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ContentSlot, contentSlotProps] = (0, $99c9I.default)('content', {
        className: classes.content,
        elementType: $2bfceb6bd3ad6f45$var$CardHeaderContent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ActionSlot, actionSlotProps] = (0, $99c9I.default)('action', {
        className: classes.action,
        elementType: $2bfceb6bd3ad6f45$var$CardHeaderAction,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            avatar && /*#__PURE__*/ (0, $bbzbN.jsx)(AvatarSlot, {
                ...avatarSlotProps,
                children: avatar
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)(ContentSlot, {
                ...contentSlotProps,
                children: [
                    title,
                    subheader
                ]
            }),
            action && /*#__PURE__*/ (0, $bbzbN.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: action
            })
        ]
    });
});
var $2bfceb6bd3ad6f45$export$2e2bcd8739ae039 = $2bfceb6bd3ad6f45$var$CardHeader;

});
parcelRegister("3loMv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26f68e516ee75fc4$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $2HenE = parcelRequire("2HenE");
var $kDBhE = parcelRequire("kDBhE");

var $7uFHh = parcelRequire("7uFHh");

var $iVAEr = parcelRequire("iVAEr");

var $b6UUh = parcelRequire("b6UUh");

var $wvp8q = parcelRequire("wvp8q");

var $iG6DO = parcelRequire("iG6DO");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $26f68e516ee75fc4$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $26f68e516ee75fc4$var$extendSxProp = (0, $2HenE.internal_createExtendSxProp)();
const $26f68e516ee75fc4$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $b6UUh.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $iG6DO.getTypographyUtilityClass), classes);
};
const $26f68e516ee75fc4$export$140e2f5526d3cad8 = (0, $kDBhE.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $b6UUh.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})((0, $7uFHh.default)(({ theme: theme })=>({
        margin: 0,
        variants: [
            {
                props: {
                    variant: 'inherit'
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit'
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== 'inherit' && value && typeof value === 'object').map(([variant, value])=>({
                    props: {
                        variant: variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, $wvp8q.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette?.text || {}).filter(([, value])=>typeof value === 'string').map(([color])=>({
                    props: {
                        color: `text${(0, $b6UUh.default)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.align !== 'inherit',
                style: {
                    textAlign: 'var(--Typography-textAlign)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.noWrap,
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: '0.35em'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.paragraph,
                style: {
                    marginBottom: 16
                }
            }
        ]
    })));
const $26f68e516ee75fc4$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
const $26f68e516ee75fc4$var$Typography = /*#__PURE__*/ $7fPBF.forwardRef(function Typography(inProps, ref) {
    const { color: color, ...themeProps } = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const isSxColor = !$26f68e516ee75fc4$var$v6Colors[color];
    // TODO: Remove `extendSxProp` in v7
    const props = $26f68e516ee75fc4$var$extendSxProp({
        ...themeProps,
        ...isSxColor && {
            color: color
        }
    });
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $26f68e516ee75fc4$var$defaultVariantMapping, ...other } = props;
    const ownerState = {
        ...props,
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    };
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $26f68e516ee75fc4$var$defaultVariantMapping[variant]) || 'span';
    const classes = $26f68e516ee75fc4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($26f68e516ee75fc4$export$140e2f5526d3cad8, {
        as: Component,
        ref: ref,
        className: (0, $hngXp.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        style: {
            ...align !== 'inherit' && {
                '--Typography-textAlign': align
            },
            ...other.style
        }
    });
});
var $26f68e516ee75fc4$export$2e2bcd8739ae039 = $26f68e516ee75fc4$var$Typography;

});
parcelRegister("2HenE", function(module, exports) {

$parcel$export(module.exports, "globalCss", function () { return $1f6ac09903fa2f15$export$db53682eef82cc11; });
$parcel$export(module.exports, "internal_createExtendSxProp", function () { return $1f6ac09903fa2f15$export$7e7f5719ff4debb1; });
parcelRequire("7fPBF");

var $mqrnX = parcelRequire("mqrnX");

var $g9bTP = parcelRequire("g9bTP");

var $eaAgo = parcelRequire("eaAgo");

var $bbzbN = parcelRequire("bbzbN");

var $5nUae = parcelRequire("5nUae");

var $kDBhE = parcelRequire("kDBhE");
function $1f6ac09903fa2f15$export$db53682eef82cc11(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $bbzbN.jsx)((0, $eaAgo.default), {
            styles: typeof styles === 'function' ? (theme)=>styles({
                    theme: theme,
                    ...props
                }) : styles
        }));
    };
}
function $1f6ac09903fa2f15$export$7e7f5719ff4debb1() {
    return 0, $mqrnX.default;
}

});
parcelRegister("mqrnX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $043690c2de8ba6fa$export$2e2bcd8739ae039; });

var $3wRTY = parcelRequire("3wRTY");

var $hXGiu = parcelRequire("hXGiu");
const $043690c2de8ba6fa$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? (0, $hXGiu.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $043690c2de8ba6fa$export$2e2bcd8739ae039(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $043690c2de8ba6fa$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $3wRTY.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}

});

parcelRegister("eaAgo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a50e20ff7f02e09b$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");


var $krgTN = parcelRequire("krgTN");

var $9P91Y = parcelRequire("9P91Y");

var $jwhZE = parcelRequire("jwhZE");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $a50e20ff7f02e09b$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $krgTN.default), {
        ...props,
        defaultTheme: (0, $9P91Y.default),
        themeId: (0, $jwhZE.default)
    });
}
var $a50e20ff7f02e09b$export$2e2bcd8739ae039 = $a50e20ff7f02e09b$var$GlobalStyles;

});


parcelRegister("iG6DO", function(module, exports) {

$parcel$export(module.exports, "getTypographyUtilityClass", function () { return $d9914d0380157c73$export$24c1f8f60cbac79e; });
$parcel$export(module.exports, "default", function () { return $d9914d0380157c73$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $d9914d0380157c73$export$24c1f8f60cbac79e(slot) {
    return (0, $k6RDS.default)('MuiTypography', slot);
}
const $d9914d0380157c73$var$typographyClasses = (0, $4jzsB.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $d9914d0380157c73$export$2e2bcd8739ae039 = $d9914d0380157c73$var$typographyClasses;

});


parcelRegister("2NR5i", function(module, exports) {

$parcel$export(module.exports, "getCardHeaderUtilityClass", function () { return $20a955dc212878b8$export$f54c8b0d04b67946; });
$parcel$export(module.exports, "default", function () { return $20a955dc212878b8$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $20a955dc212878b8$export$f54c8b0d04b67946(slot) {
    return (0, $k6RDS.default)('MuiCardHeader', slot);
}
const $20a955dc212878b8$var$cardHeaderClasses = (0, $4jzsB.default)('MuiCardHeader', [
    'root',
    'avatar',
    'action',
    'content',
    'title',
    'subheader'
]);
var $20a955dc212878b8$export$2e2bcd8739ae039 = $20a955dc212878b8$var$cardHeaderClasses;

});

parcelRegister("99c9I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a8e6231295d6b22$export$2e2bcd8739ae039; });

var $jTdAm = parcelRequire("jTdAm");

var $5VXZW = parcelRequire("5VXZW");

var $eWvFH = parcelRequire("eWvFH");

var $ex1Wy = parcelRequire("ex1Wy");
'use client';
function $6a8e6231295d6b22$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, internalForwardedProps: internalForwardedProps, shouldForwardComponentProp: shouldForwardComponentProp = false, ...useSlotPropsParams } = parameters;
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    }, ...other } = externalForwardedProps;
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $eWvFH.default)(slotProps[name], ownerState);
    const { props: { component: slotComponent, ...mergedProps }, internalRef: internalRef } = (0, $ex1Wy.default)({
        className: className,
        ...useSlotPropsParams,
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $jTdAm.default)(internalRef, resolvedComponentsProps?.ref, parameters.ref);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $5VXZW.default)(elementType, {
        ...name === 'root' && !rootComponent && !slots[name] && internalForwardedProps,
        ...name !== 'root' && !slots[name] && internalForwardedProps,
        ...mergedProps,
        ...LeafComponent && !shouldForwardComponentProp && {
            as: LeafComponent
        },
        ...LeafComponent && shouldForwardComponentProp && {
            component: LeafComponent
        },
        ref: ref
    }, ownerState);
    return [
        elementType,
        props
    ];
}

});
parcelRegister("5VXZW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4520d0f80a3f7305$export$2e2bcd8739ae039; });

var $ftQl8 = parcelRequire("ftQl8");
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $4520d0f80a3f7305$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $ftQl8.default)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $4520d0f80a3f7305$export$2e2bcd8739ae039 = $4520d0f80a3f7305$var$appendOwnerState;

});
parcelRegister("ftQl8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4522a0df256fb21$export$2e2bcd8739ae039; });
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $b4522a0df256fb21$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $b4522a0df256fb21$export$2e2bcd8739ae039 = $b4522a0df256fb21$var$isHostComponent;

});


parcelRegister("eWvFH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae0f0ccae9f4b3cc$export$2e2bcd8739ae039; });
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $ae0f0ccae9f4b3cc$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $ae0f0ccae9f4b3cc$export$2e2bcd8739ae039 = $ae0f0ccae9f4b3cc$var$resolveComponentProps;

});

parcelRegister("ex1Wy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a945a7a9a1371b8c$export$2e2bcd8739ae039; });

var $hngXp = parcelRequire("hngXp");

var $atytk = parcelRequire("atytk");

var $1XtzN = parcelRequire("1XtzN");
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $a945a7a9a1371b8c$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $hngXp.default)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $atytk.default)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $1XtzN.default)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $1XtzN.default)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $hngXp.default)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $a945a7a9a1371b8c$export$2e2bcd8739ae039 = $a945a7a9a1371b8c$var$mergeSlotProps;

});
parcelRegister("atytk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a075a443b93da2d$export$2e2bcd8739ae039; });
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $7a075a443b93da2d$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $7a075a443b93da2d$export$2e2bcd8739ae039 = $7a075a443b93da2d$var$extractEventHandlers;

});

parcelRegister("1XtzN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16d23e6599aa60ec$export$2e2bcd8739ae039; });
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $16d23e6599aa60ec$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $16d23e6599aa60ec$export$2e2bcd8739ae039 = $16d23e6599aa60ec$var$omitEventHandlers;

});




parcelRegister("k4oz9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9c73cabc31b02d7$export$2e2bcd8739ae039; });


var $9IPbi = parcelRequire("9IPbi");


var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $g9bTP = parcelRequire("g9bTP");
'use client';
/**
 *
 * Demos:
 *
 * - [Grid version 2](https://v6.mui.com/material-ui/react-grid2/)
 *
 * API:
 *
 * - [Grid2 API](https://v6.mui.com/material-ui/api/grid-2/)
 */ const $e9c73cabc31b02d7$var$Grid2 = (0, $9IPbi.default)({
    createStyledComponent: (0, $kDBhE.default)('div', {
        name: 'MuiGrid2',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                ownerState.container && styles.container
            ];
        }
    }),
    componentName: 'MuiGrid2',
    useThemeProps: (inProps)=>(0, $iVAEr.useDefaultProps)({
            props: inProps,
            name: 'MuiGrid2'
        }),
    useTheme: $g9bTP.default
});
var $e9c73cabc31b02d7$export$2e2bcd8739ae039 = $e9c73cabc31b02d7$var$Grid2;

});
parcelRegister("9IPbi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $713feca741b68679$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $j4EgL = parcelRequire("j4EgL");

var $k6RDS = parcelRequire("k6RDS");

var $cFCqu = parcelRequire("cFCqu");

var $pckgl = parcelRequire("pckgl");

var $9HPC7 = parcelRequire("9HPC7");

var $dSbTr = parcelRequire("dSbTr");

var $mqrnX = parcelRequire("mqrnX");

var $2G6xE = parcelRequire("2G6xE");

var $7fa2K = parcelRequire("7fa2K");

var $gbE64 = parcelRequire("gbE64");

var $bbzbN = parcelRequire("bbzbN");
const $713feca741b68679$var$defaultTheme = (0, $2G6xE.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $713feca741b68679$var$defaultCreateStyledComponent = (0, $pckgl.default)('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $713feca741b68679$var$useThemePropsDefault(props) {
    return (0, $9HPC7.default)({
        props: props,
        name: 'MuiGrid',
        defaultTheme: $713feca741b68679$var$defaultTheme
    });
}
function $713feca741b68679$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $713feca741b68679$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $713feca741b68679$var$useThemePropsDefault, useTheme: useTheme = (0, $dSbTr.default), componentName: componentName = 'MuiGrid' } = options;
    const useUtilityClasses = (ownerState, theme)=>{
        const { container: container, direction: direction, spacing: spacing, wrap: wrap, size: size } = ownerState;
        const slots = {
            root: [
                'root',
                container && 'container',
                wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
                ...(0, $7fa2K.generateDirectionClasses)(direction),
                ...(0, $7fa2K.generateSizeClassNames)(size),
                ...container ? (0, $7fa2K.generateSpacingClassNames)(spacing, theme.breakpoints.keys[0]) : []
            ]
        };
        return (0, $cFCqu.default)(slots, (slot)=>(0, $k6RDS.default)(componentName, slot), {});
    };
    function parseResponsiveProp(propValue, breakpoints, shouldUseValue = ()=>true) {
        const parsedProp = {};
        if (propValue === null) return parsedProp;
        if (Array.isArray(propValue)) propValue.forEach((value, index)=>{
            if (value !== null && shouldUseValue(value) && breakpoints.keys[index]) parsedProp[breakpoints.keys[index]] = value;
        });
        else if (typeof propValue === 'object') Object.keys(propValue).forEach((key)=>{
            const value = propValue[key];
            if (value !== null && value !== undefined && shouldUseValue(value)) parsedProp[key] = value;
        });
        else parsedProp[breakpoints.keys[0]] = propValue;
        return parsedProp;
    }
    const GridRoot = createStyledComponent((0, $7fa2K.generateGridColumnsStyles), (0, $7fa2K.generateGridColumnSpacingStyles), (0, $7fa2K.generateGridRowSpacingStyles), (0, $7fa2K.generateGridSizeStyles), (0, $7fa2K.generateGridDirectionStyles), (0, $7fa2K.generateGridStyles), (0, $7fa2K.generateGridOffsetStyles));
    const Grid = /*#__PURE__*/ $7fPBF.forwardRef(function Grid(inProps, ref) {
        const theme = useTheme();
        const themeProps = useThemeProps(inProps);
        const props = (0, $mqrnX.default)(themeProps); // `color` type conflicts with html color attribute.
        // TODO v8: Remove when removing the legacy Grid component
        (0, $gbE64.default)(props, theme.breakpoints);
        const { className: className, children: children, columns: columnsProp = 12, container: container = false, component: component = 'div', direction: direction = 'row', wrap: wrap = 'wrap', size: sizeProp = {}, offset: offsetProp = {}, spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, unstable_level: level = 0, ...other } = props;
        const size = parseResponsiveProp(sizeProp, theme.breakpoints, (val)=>val !== false);
        const offset = parseResponsiveProp(offsetProp, theme.breakpoints);
        const columns = inProps.columns ?? (level ? undefined : columnsProp);
        const spacing = inProps.spacing ?? (level ? undefined : spacingProp);
        const rowSpacing = inProps.rowSpacing ?? inProps.spacing ?? (level ? undefined : rowSpacingProp);
        const columnSpacing = inProps.columnSpacing ?? inProps.spacing ?? (level ? undefined : columnSpacingProp);
        const ownerState = {
            ...props,
            level: level,
            columns: columns,
            container: container,
            direction: direction,
            wrap: wrap,
            spacing: spacing,
            rowSpacing: rowSpacing,
            columnSpacing: columnSpacing,
            size: size,
            offset: offset
        };
        const classes = useUtilityClasses(ownerState, theme);
        return /*#__PURE__*/ (0, $bbzbN.jsx)(GridRoot, {
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: (0, $hngXp.default)(classes.root, className),
            ...other,
            children: $7fPBF.Children.map(children, (child)=>{
                if (/*#__PURE__*/ $7fPBF.isValidElement(child) && (0, $j4EgL.default)(child, [
                    'Grid'
                ]) && container && child.props.container) return /*#__PURE__*/ $7fPBF.cloneElement(child, {
                    unstable_level: child.props?.unstable_level ?? level + 1
                });
                return child;
            })
        });
    });
    // @ts-ignore internal logic for nested grid
    Grid.muiName = 'Grid';
    return Grid;
}

});
parcelRegister("j4EgL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de2da0b284b1a3c2$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
function $de2da0b284b1a3c2$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $7fPBF.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}

});

parcelRegister("pckgl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04bbe5906d963375$export$2e2bcd8739ae039; });

var $7b8EK = parcelRequire("7b8EK");
const $04bbe5906d963375$var$styled = (0, $7b8EK.default)();
var $04bbe5906d963375$export$2e2bcd8739ae039 = $04bbe5906d963375$var$styled;

});

parcelRegister("9HPC7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71102aa90e2b2620$export$2e2bcd8739ae039; });

var $38WAi = parcelRequire("38WAi");

var $dSbTr = parcelRequire("dSbTr");
'use client';
function $71102aa90e2b2620$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $dSbTr.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $38WAi.default)({
        theme: theme,
        name: name,
        props: props
    });
}

});
parcelRegister("38WAi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $249f9015c4a2303b$export$2e2bcd8739ae039; });

var $gjk5S = parcelRequire("gjk5S");
function $249f9015c4a2303b$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $gjk5S.default)(theme.components[name].defaultProps, props);
}

});


parcelRegister("7fa2K", function(module, exports) {

$parcel$export(module.exports, "generateGridSizeStyles", function () { return $5461b987d9ed84c9$export$84053369756c53db; });
$parcel$export(module.exports, "generateGridOffsetStyles", function () { return $5461b987d9ed84c9$export$c1d4f281314969c2; });
$parcel$export(module.exports, "generateGridColumnsStyles", function () { return $5461b987d9ed84c9$export$ccc4d4a4923f1b06; });
$parcel$export(module.exports, "generateGridRowSpacingStyles", function () { return $5461b987d9ed84c9$export$68c4dad72dd49c74; });
$parcel$export(module.exports, "generateGridColumnSpacingStyles", function () { return $5461b987d9ed84c9$export$a89c28919b8e3bb5; });
$parcel$export(module.exports, "generateGridDirectionStyles", function () { return $5461b987d9ed84c9$export$2a0a3c01032b3f4; });
$parcel$export(module.exports, "generateGridStyles", function () { return $5461b987d9ed84c9$export$810b8c3ab5d46bf; });
$parcel$export(module.exports, "generateSizeClassNames", function () { return $5461b987d9ed84c9$export$e2d1175061442d38; });
$parcel$export(module.exports, "generateSpacingClassNames", function () { return $5461b987d9ed84c9$export$6c7087d27c3329d3; });
$parcel$export(module.exports, "generateDirectionClasses", function () { return $5461b987d9ed84c9$export$a7c8efbe2b138a60; });

var $7u3sn = parcelRequire("7u3sn");
function $5461b987d9ed84c9$var$getSelfSpacingVar(axis) {
    return `--Grid-${axis}Spacing`;
}
function $5461b987d9ed84c9$var$getParentSpacingVar(axis) {
    return `--Grid-parent-${axis}Spacing`;
}
const $5461b987d9ed84c9$var$selfColumnsVar = '--Grid-columns';
const $5461b987d9ed84c9$var$parentColumnsVar = '--Grid-parent-columns';
const $5461b987d9ed84c9$export$84053369756c53db = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $7u3sn.traverseBreakpoints)(theme.breakpoints, ownerState.size, (appendStyle, value)=>{
        let style = {};
        if (value === 'grow') style = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        if (value === 'auto') style = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        if (typeof value === 'number') style = {
            flexGrow: 0,
            flexBasis: 'auto',
            width: `calc(100% * ${value} / var(${$5461b987d9ed84c9$var$parentColumnsVar}) - (var(${$5461b987d9ed84c9$var$parentColumnsVar}) - ${value}) * (var(${$5461b987d9ed84c9$var$getParentSpacingVar('column')}) / var(${$5461b987d9ed84c9$var$parentColumnsVar})))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $5461b987d9ed84c9$export$c1d4f281314969c2 = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $7u3sn.traverseBreakpoints)(theme.breakpoints, ownerState.offset, (appendStyle, value)=>{
        let style = {};
        if (value === 'auto') style = {
            marginLeft: 'auto'
        };
        if (typeof value === 'number') style = {
            marginLeft: value === 0 ? '0px' : `calc(100% * ${value} / var(${$5461b987d9ed84c9$var$parentColumnsVar}) + var(${$5461b987d9ed84c9$var$getParentSpacingVar('column')}) * ${value} / var(${$5461b987d9ed84c9$var$parentColumnsVar}))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $5461b987d9ed84c9$export$ccc4d4a4923f1b06 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {
        [$5461b987d9ed84c9$var$selfColumnsVar]: 12
    };
    (0, $7u3sn.traverseBreakpoints)(theme.breakpoints, ownerState.columns, (appendStyle, value)=>{
        const columns = value ?? 12;
        appendStyle(styles, {
            [$5461b987d9ed84c9$var$selfColumnsVar]: columns,
            '> *': {
                [$5461b987d9ed84c9$var$parentColumnsVar]: columns
            }
        });
    });
    return styles;
};
const $5461b987d9ed84c9$export$68c4dad72dd49c74 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $7u3sn.traverseBreakpoints)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$5461b987d9ed84c9$var$getSelfSpacingVar('row')]: spacing,
            '> *': {
                [$5461b987d9ed84c9$var$getParentSpacingVar('row')]: spacing
            }
        });
    });
    return styles;
};
const $5461b987d9ed84c9$export$a89c28919b8e3bb5 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $7u3sn.traverseBreakpoints)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$5461b987d9ed84c9$var$getSelfSpacingVar('column')]: spacing,
            '> *': {
                [$5461b987d9ed84c9$var$getParentSpacingVar('column')]: spacing
            }
        });
    });
    return styles;
};
const $5461b987d9ed84c9$export$2a0a3c01032b3f4 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $7u3sn.traverseBreakpoints)(theme.breakpoints, ownerState.direction, (appendStyle, value)=>{
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
const $5461b987d9ed84c9$export$810b8c3ab5d46bf = ({ ownerState: ownerState })=>{
    return {
        minWidth: 0,
        boxSizing: 'border-box',
        ...ownerState.container && {
            display: 'flex',
            flexWrap: 'wrap',
            ...ownerState.wrap && ownerState.wrap !== 'wrap' && {
                flexWrap: ownerState.wrap
            },
            gap: `var(${$5461b987d9ed84c9$var$getSelfSpacingVar('row')}) var(${$5461b987d9ed84c9$var$getSelfSpacingVar('column')})`
        }
    };
};
const $5461b987d9ed84c9$export$e2d1175061442d38 = (size)=>{
    const classNames = [];
    Object.entries(size).forEach(([key, value])=>{
        if (value !== false && value !== undefined) classNames.push(`grid-${key}-${String(value)}`);
    });
    return classNames;
};
const $5461b987d9ed84c9$export$6c7087d27c3329d3 = (spacing, smallestBreakpoint = 'xs')=>{
    function isValidSpacing(val) {
        if (val === undefined) return false;
        return typeof val === 'string' && !Number.isNaN(Number(val)) || typeof val === 'number' && val > 0;
    }
    if (isValidSpacing(spacing)) return [
        `spacing-${smallestBreakpoint}-${String(spacing)}`
    ];
    if (typeof spacing === 'object' && !Array.isArray(spacing)) {
        const classNames = [];
        Object.entries(spacing).forEach(([key, value])=>{
            if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
        });
        return classNames;
    }
    return [];
};
const $5461b987d9ed84c9$export$a7c8efbe2b138a60 = (direction)=>{
    if (direction === undefined) return [];
    if (typeof direction === 'object') return Object.entries(direction).map(([key, value])=>`direction-${key}-${value}`);
    return [
        `direction-xs-${String(direction)}`
    ];
};

});
parcelRegister("7u3sn", function(module, exports) {

$parcel$export(module.exports, "traverseBreakpoints", function () { return $572e042bc49e6346$export$e04173f1577f18b7; });
const $572e042bc49e6346$export$f1ce4856483bd995 = (breakpointsKeys, responsiveKeys)=>breakpointsKeys.filter((key)=>responsiveKeys.includes(key));
const $572e042bc49e6346$export$e04173f1577f18b7 = (breakpoints, responsive, iterator)=>{
    const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.
    if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index)=>{
        iterator((responsiveStyles, style)=>{
            if (index <= breakpoints.keys.length - 1) {
                if (index === 0) Object.assign(responsiveStyles, style);
                else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
            }
        }, breakpointValue);
    });
    else if (responsive && typeof responsive === 'object') {
        // prevent null
        // responsive could be a very big object, pick the smallest responsive values
        const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : $572e042bc49e6346$export$f1ce4856483bd995(breakpoints.keys, Object.keys(responsive));
        keys.forEach((key)=>{
            if (breakpoints.keys.includes(key)) {
                // @ts-ignore already checked that responsive is an object
                const breakpointValue = responsive[key];
                if (breakpointValue !== undefined) iterator((responsiveStyles, style)=>{
                    if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
                    else responsiveStyles[breakpoints.up(key)] = style;
                }, breakpointValue);
            }
        });
    } else if (typeof responsive === 'number' || typeof responsive === 'string') iterator((responsiveStyles, style)=>{
        Object.assign(responsiveStyles, style);
    }, responsive);
};

});


parcelRegister("gbE64", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc8cc6daba60854c$export$2e2bcd8739ae039; });
const $bc8cc6daba60854c$var$getLegacyGridWarning = (propName)=>{
    if ([
        'item',
        'zeroMinWidth'
    ].includes(propName)) return `The \`${propName}\` prop has been removed and is no longer necessary. You can safely remove it.`;
    // #host-reference
    return `The \`${propName}\` prop has been removed. See https://v6.mui.com/material-ui/migration/upgrade-to-grid-v2/ for migration instructions.`;
};
const $bc8cc6daba60854c$var$warnedAboutProps = [];
function $bc8cc6daba60854c$export$2e2bcd8739ae039(props, breakpoints) {
    const propsToWarn = [];
    if (props.item !== undefined) {
        delete props.item;
        propsToWarn.push('item');
    }
    if (props.zeroMinWidth !== undefined) {
        delete props.zeroMinWidth;
        propsToWarn.push('zeroMinWidth');
    }
    breakpoints.keys.forEach((breakpoint)=>{
        if (props[breakpoint] !== undefined) {
            propsToWarn.push(breakpoint);
            delete props[breakpoint];
        }
    });
    var prop;
}

});



parcelRegister("2I79p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ceb142ffb435d7ec$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $mMVex = parcelRequire("mMVex");

var $5ZeKC = parcelRequire("5ZeKC");
var $gsokU = parcelRequire("gsokU");
var $c1d0r = parcelRequire("c1d0r");
var $3M96K = parcelRequire("3M96K");
var $k4oz9 = parcelRequire("k4oz9");
var $hG0Cb = parcelRequire("hG0Cb");
var $3loMv = parcelRequire("3loMv");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $gxpCl = parcelRequire("gxpCl");

var $6PJp8 = parcelRequire("6PJp8");

var $8S1fp = parcelRequire("8S1fp");
function $ceb142ffb435d7ec$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $doyfp.useTranslation)();
    const navigate = (0, $gxpCl.useNavigate)();
    const idAffix = "invalid-link";
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $k4oz9.default), {
        container: true,
        justifyContent: "center",
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gsokU.default), {
            sx: {
                width: 450
            },
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3M96K.default), {
                    title: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                        align: "center",
                        variant: "h5",
                        children: t(props.titleTextId)
                    })
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c1d0r.default), {
                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                        spacing: 2,
                        children: [
                            props.bodyTextId ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                children: t(props.bodyTextId)
                            }) : null,
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $k4oz9.default), {
                                container: true,
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $k4oz9.default), {
                                        size: "grow",
                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                                            id: `${idAffix}-guide`,
                                            onClick: ()=>(0, $8S1fp.openUserGuide)(),
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $mMVex.default), {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                                        id: `${idAffix}-signUp`,
                                        onClick: ()=>{
                                            navigate((0, $6PJp8.Path).Signup);
                                        },
                                        variant: "contained",
                                        children: t("login.signUp")
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                                        id: `${idAffix}-login`,
                                        onClick: ()=>{
                                            navigate((0, $6PJp8.Path).Login);
                                        },
                                        variant: "contained",
                                        children: t("login.login")
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}

});
parcelRegister("mMVex", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0448011a6368293c$export$2e2bcd8739ae039; });

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $0448011a6368293c$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 17h-2v-2h2zm2.07-7.75-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25"
}), 'Help');

});
parcelRegister("6PKLM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f9bc8f83648f682$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $freJ2 = parcelRequire("freJ2");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $4f9bc8f83648f682$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $freJ2.default), {
            "data-testid": `${displayName}Icon`,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = (0, $freJ2.default).muiName;
    return /*#__PURE__*/ $7fPBF.memo(/*#__PURE__*/ $7fPBF.forwardRef(Component));
}

});
parcelRegister("freJ2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3d4ccc5f426d62a$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $b6UUh = parcelRequire("b6UUh");

var $kDBhE = parcelRequire("kDBhE");

var $7uFHh = parcelRequire("7uFHh");

var $iVAEr = parcelRequire("iVAEr");

var $6VWZo = parcelRequire("6VWZo");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $b3d4ccc5f426d62a$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $b6UUh.default)(color)}`,
            `fontSize${(0, $b6UUh.default)(fontSize)}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $6VWZo.getSvgIconUtilityClass), classes);
};
const $b3d4ccc5f426d62a$var$SvgIconRoot = (0, $kDBhE.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $b6UUh.default)(ownerState.color)}`],
            styles[`fontSize${(0, $b6UUh.default)(ownerState.fontSize)}`]
        ];
    }
})((0, $7uFHh.default)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: theme.transitions?.create?.('fill', {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const $b3d4ccc5f426d62a$var$SvgIcon = /*#__PURE__*/ $7fPBF.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24', ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $7fPBF.isValidElement(children) && children.type === 'svg';
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $b3d4ccc5f426d62a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($b3d4ccc5f426d62a$var$SvgIconRoot, {
        as: component,
        className: (0, $hngXp.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $bbzbN.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
$b3d4ccc5f426d62a$var$SvgIcon.muiName = 'SvgIcon';
var $b3d4ccc5f426d62a$export$2e2bcd8739ae039 = $b3d4ccc5f426d62a$var$SvgIcon;

});
parcelRegister("6VWZo", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $50c5d2f6ad13a504$export$c7c50641356bdfa5; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $50c5d2f6ad13a504$export$c7c50641356bdfa5(slot) {
    return (0, $k6RDS.default)('MuiSvgIcon', slot);
}
const $50c5d2f6ad13a504$var$svgIconClasses = (0, $4jzsB.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $50c5d2f6ad13a504$export$2e2bcd8739ae039 = $50c5d2f6ad13a504$var$svgIconClasses;

});




parcelRegister("hG0Cb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cde6d60726777b50$export$2e2bcd8739ae039; });


var $iRkEk = parcelRequire("iRkEk");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");
'use client';
const $cde6d60726777b50$var$Stack = (0, $iRkEk.default)({
    createStyledComponent: (0, $kDBhE.default)('div', {
        name: 'MuiStack',
        slot: 'Root',
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $iVAEr.useDefaultProps)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $cde6d60726777b50$export$2e2bcd8739ae039 = $cde6d60726777b50$var$Stack;

});
parcelRegister("iRkEk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbad31c7655ddfe7$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $3wRTY = parcelRequire("3wRTY");

var $k6RDS = parcelRequire("k6RDS");

var $cFCqu = parcelRequire("cFCqu");

var $pckgl = parcelRequire("pckgl");

var $9HPC7 = parcelRequire("9HPC7");

var $mqrnX = parcelRequire("mqrnX");

var $2G6xE = parcelRequire("2G6xE");

var $6m7cf = parcelRequire("6m7cf");

var $dcAP4 = parcelRequire("dcAP4");

var $bbzbN = parcelRequire("bbzbN");
const $dbad31c7655ddfe7$var$defaultTheme = (0, $2G6xE.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $dbad31c7655ddfe7$var$defaultCreateStyledComponent = (0, $pckgl.default)('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $dbad31c7655ddfe7$var$useThemePropsDefault(props) {
    return (0, $9HPC7.default)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $dbad31c7655ddfe7$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $dbad31c7655ddfe7$var$joinChildren(children, separator) {
    const childrenArray = $7fPBF.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $7fPBF.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $dbad31c7655ddfe7$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $dbad31c7655ddfe7$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = {
        display: 'flex',
        flexDirection: 'column',
        ...(0, $6m7cf.handleBreakpoints)({
            theme: theme
        }, (0, $6m7cf.resolveBreakpointValues)({
            values: ownerState.direction,
            breakpoints: theme.breakpoints.values
        }), (propValue)=>({
                flexDirection: propValue
            }))
    };
    if (ownerState.spacing) {
        const transformer = (0, $dcAP4.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $6m7cf.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $6m7cf.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $dcAP4.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$dbad31c7655ddfe7$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $dcAP4.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $3wRTY.default)(styles, (0, $6m7cf.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $6m7cf.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $dbad31c7655ddfe7$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $dbad31c7655ddfe7$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $dbad31c7655ddfe7$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $cFCqu.default)(slots, (slot)=>(0, $k6RDS.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($dbad31c7655ddfe7$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $7fPBF.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $mqrnX.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false, ...other } = props;
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $bbzbN.jsx)(StackRoot, {
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $hngXp.default)(classes.root, className),
            ...other,
            children: divider ? $dbad31c7655ddfe7$var$joinChildren(children, divider) : children
        });
    });
    return Stack;
}

});


parcelRegister("6PJp8", function(module, exports) {

$parcel$export(module.exports, "Path", function () { return $6adf6b911f9ca7cb$export$4b2950bdac9b6ee9; });
var $6adf6b911f9ca7cb$export$4b2950bdac9b6ee9 = /*#__PURE__*/ function(Path) {
    Path["AppRoot"] = "/app";
    Path["DataEntry"] = "/app/data-entry";
    Path["EmailVerify"] = "/email/verify";
    Path["GoalCurrent"] = "/app/goals/current";
    Path["GoalNext"] = "/app/goals/next";
    Path["Goals"] = "/app/goals";
    Path["Login"] = "/login";
    Path["ProjInvite"] = "/invite";
    Path["ProjScreen"] = "/app/projects";
    Path["ProjSettings"] = "/app/project-settings";
    Path["PwRequest"] = "/pw/request";
    Path["PwReset"] = "/pw/reset";
    Path["Root"] = "/";
    Path["Signup"] = "/signup";
    Path["SiteSettings"] = "/app/site-settings";
    Path["Statistics"] = "/app/statistics";
    Path["UserSettings"] = "/app/user-settings";
    return Path;
}({});

});

parcelRegister("8S1fp", function(module, exports) {

$parcel$export(module.exports, "getBasePath", function () { return $04a54e0814aa543d$export$9099264ed9b1c55a; });
$parcel$export(module.exports, "openUserGuide", function () { return $04a54e0814aa543d$export$820a8592c0b667e0; });
$parcel$export(module.exports, "routerPath", function () { return $04a54e0814aa543d$export$c60284e2acffc716; });

var $6PJp8 = parcelRequire("6PJp8");
function $04a54e0814aa543d$export$9099264ed9b1c55a(pathname) {
    while(pathname.length){
        if (Object.values((0, $6PJp8.Path)).includes(pathname)) return pathname;
        pathname = pathname.substring(0, pathname.lastIndexOf("/"));
    }
    return (0, $6PJp8.Path).Root;
}
/**
 * windows.location.origin doesn't work in all browsers, so define it manually.
 * */ function $04a54e0814aa543d$var$getWindowOrigin() {
    const loc = window.location;
    return `${loc.protocol}//${loc.hostname}${loc.port ? ":" + loc.port : ""}`;
}
function $04a54e0814aa543d$export$820a8592c0b667e0(page = "") {
    const origin = $04a54e0814aa543d$var$getWindowOrigin();
    window.open(`${origin}/docs/${page}`);
}
function $04a54e0814aa543d$export$c60284e2acffc716(pathname) {
    // Define a pattern to make a path relative to the Routes where it
    // is used.  Currently, <Routes> is used in:
    //  - '*' and
    //  - 'app/*'
    // List of known sub-routes.
    const nestedRoutes = [
        (0, $6PJp8.Path).AppRoot
    ];
    if (nestedRoutes.includes(pathname)) // strip leading "/";  append "/*" to the path
    return `${pathname.slice(1)}/*`;
    let routePath = pathname.valueOf();
    for (const route of nestedRoutes)if (routePath.startsWith(route)) {
        routePath = routePath.slice(route.length);
        break;
    }
    let startIndex = 0;
    let endIndex = routePath.length;
    if (routePath.startsWith("/")) startIndex++;
    if (routePath.endsWith("/")) endIndex--;
    return routePath.slice(startIndex, endIndex);
}

});


parcelRegister("f3nsX", function(module, exports) {

$parcel$export(module.exports, "useAppDispatch", function () { return $c8939688119474c6$export$f51d452c10d5b956; });
$parcel$export(module.exports, "useAppSelector", function () { return $c8939688119474c6$export$a7347740d65f620b; });

var $kRISp = parcelRequire("kRISp");
const $c8939688119474c6$export$f51d452c10d5b956 = (0, $kRISp.useDispatch);
const $c8939688119474c6$export$a7347740d65f620b = (0, $kRISp.useSelector);

});


parcelRegister("3pvf1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34ae1d6afa2056c1$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $aili3 = parcelRequire("aili3");
var $k4oz9 = parcelRequire("k4oz9");
var $hG0Cb = parcelRequire("hG0Cb");
var $3loMv = parcelRequire("3loMv");
var $iq9YP = parcelRequire("iq9YP");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $gxpCl = parcelRequire("gxpCl");

var $i88wr = parcelRequire("i88wr");

var $lk396 = parcelRequire("lk396");

var $4Z5Yh = parcelRequire("4Z5Yh");

var $69ZoH = parcelRequire("69ZoH");

var $6PJp8 = parcelRequire("6PJp8");

var $gs8xE = parcelRequire("gs8xE");
const $34ae1d6afa2056c1$var$heightBetweenBars = window.innerHeight - (0, $69ZoH.topBarHeight) - (0, $lk396.bottomBarHeight) - parseInt((0, $gs8xE.default).spacing(1));
function $34ae1d6afa2056c1$export$2e2bcd8739ae039() {
    const isXs = (0, $iq9YP.default)((th)=>th.breakpoints.only("xs"));
    const navigate = (0, $gxpCl.useNavigate)();
    (0, $7fPBF.useEffect)(()=>{
        // If there is an AnnouncementBanner and somebody enters the URL for
        // the LandingPage when displaying page without an AppBar, this
        // prevents banner misalignment.
        navigate((0, $6PJp8.Path).Root);
    }, [
        navigate
    ]);
    const maxBodyHeight = $34ae1d6afa2056c1$var$heightBetweenBars - (isXs ? (0, $4Z5Yh.horizontalButtonsHeight) : 0);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $69ZoH.default), {}),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $k4oz9.default), {
                container: true,
                direction: isXs ? "column" : "row-reverse",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $k4oz9.default), {
                        size: "auto",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4Z5Yh.default), {
                            top: isXs
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $k4oz9.default), {
                        size: "grow",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                            style: {
                                maxHeight: maxBodyHeight,
                                overflow: "auto"
                            },
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)($34ae1d6afa2056c1$var$Body, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lk396.default), {})
        ]
    });
}
function $34ae1d6afa2056c1$var$Body() {
    const { t: t } = (0, $doyfp.useTranslation)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
        alignItems: "center",
        spacing: 3,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                sx: {
                    p: (0, $gs8xE.default).spacing(3),
                    paddingBottom: 0
                },
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3loMv.default), {
                        variant: "body2",
                        align: "justify",
                        children: [
                            t("landingPage.descriptionP1"),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                            t("landingPage.descriptionP2"),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                            t("landingPage.descriptionP3"),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                        sx: {
                            paddingTop: (0, $gs8xE.default).spacing(3)
                        },
                        variant: "h6",
                        children: t("landingPage.descriptionP4")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4Z5Yh.SignUpButton), {
                    buttonIdPrefix: "landing-body"
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $i88wr.default), {
                    height: Math.min(400, (window.innerWidth - (0, $4Z5Yh.verticalButtonsWidth)) / 5)
                })
            })
        ]
    });
}

});
parcelRegister("aili3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77ec199cefd4182a$export$2e2bcd8739ae039; });

var $eM3DW = parcelRequire("eM3DW");


var $kU6nt = parcelRequire("kU6nt");

var $hmhHQ = parcelRequire("hmhHQ");

var $jwhZE = parcelRequire("jwhZE");

var $dxABk = parcelRequire("dxABk");
'use client';
const $77ec199cefd4182a$var$defaultTheme = (0, $hmhHQ.default)();
const $77ec199cefd4182a$var$Box = (0, $eM3DW.default)({
    themeId: (0, $jwhZE.default),
    defaultTheme: $77ec199cefd4182a$var$defaultTheme,
    defaultClassName: (0, $dxABk.default).root,
    generateClassName: (0, $kU6nt.default).generate
});
var $77ec199cefd4182a$export$2e2bcd8739ae039 = $77ec199cefd4182a$var$Box;

});
parcelRegister("eM3DW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac185fd733cbe1a6$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $hngXp = parcelRequire("hngXp");

var $5VCcJ = parcelRequire("5VCcJ");

var $8M6a3 = parcelRequire("8M6a3");
var $mqrnX = parcelRequire("mqrnX");

var $dSbTr = parcelRequire("dSbTr");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $ac185fd733cbe1a6$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $5VCcJ.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $8M6a3.default));
    const Box = /*#__PURE__*/ $7fPBF.forwardRef(function Box(inProps, ref) {
        const theme = (0, $dSbTr.default)(defaultTheme);
        const { className: className, component: component = 'div', ...other } = (0, $mqrnX.default)(inProps);
        return /*#__PURE__*/ (0, $bbzbN.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, $hngXp.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}

});

parcelRegister("dxABk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9dbabfa00f5ea67f$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");
const $9dbabfa00f5ea67f$var$boxClasses = (0, $4jzsB.default)('MuiBox', [
    'root'
]);
var $9dbabfa00f5ea67f$export$2e2bcd8739ae039 = $9dbabfa00f5ea67f$var$boxClasses;

});


parcelRegister("iq9YP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d692658be43721e5$export$2e2bcd8739ae039; });

var $i1dYO = parcelRequire("i1dYO");

var $jwhZE = parcelRequire("jwhZE");
const $d692658be43721e5$var$useMediaQuery = (0, $i1dYO.unstable_createUseMediaQuery)({
    themeId: (0, $jwhZE.default)
});
var $d692658be43721e5$export$2e2bcd8739ae039 = $d692658be43721e5$var$useMediaQuery;

});
parcelRegister("i1dYO", function(module, exports) {

$parcel$export(module.exports, "unstable_createUseMediaQuery", function () { return $d1e32a1d75e60036$export$96d7927a982220b5; });

var $7fPBF = parcelRequire("7fPBF");

var $lJRRs = parcelRequire("lJRRs");

var $38WAi = parcelRequire("38WAi");

var $gU1gT = parcelRequire("gU1gT");
'use client';
// TODO React 17: Remove `useMediaQueryOld` once React 17 support is removed
function $d1e32a1d75e60036$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $7fPBF.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $lJRRs.default)(()=>{
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addEventListener('change', updateMatch);
        return ()=>{
            queryList.removeEventListener('change', updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $d1e32a1d75e60036$var$safeReact = {
    ...$7fPBF
};
const $d1e32a1d75e60036$var$maybeReactUseSyncExternalStore = $d1e32a1d75e60036$var$safeReact.useSyncExternalStore;
function $d1e32a1d75e60036$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $7fPBF.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $7fPBF.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $7fPBF.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener('change', notify);
                return ()=>{
                    mediaQueryList.removeEventListener('change', notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $d1e32a1d75e60036$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $d1e32a1d75e60036$export$96d7927a982220b5(params = {}) {
    const { themeId: themeId } = params;
    return function useMediaQuery(queryInput, options = {}) {
        let theme = (0, $gU1gT.default)();
        if (theme && themeId) theme = theme[themeId] || theme;
        // Wait for jsdom to support the match media feature.
        // All the browsers MUI support have this built-in.
        // This defensive check is here for simplicity.
        // Most of the time, the match media logic isn't central to people tests.
        const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
        const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $38WAi.default)({
            name: 'MuiUseMediaQuery',
            props: options,
            theme: theme
        });
        let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
        query = query.replace(/^@media( ?)/m, '');
        if (query.includes('print')) console.warn([
            `MUI: You have provided a \`print\` query to the \`useMediaQuery\` hook.`,
            'Using the print media query to modify print styles can lead to unexpected results.',
            'Consider using the `displayPrint` field in the `sx` prop instead.',
            'More information about `displayPrint` on our docs: https://mui.com/system/display/#display-in-print.'
        ].join('\n'));
        const useMediaQueryImplementation = $d1e32a1d75e60036$var$maybeReactUseSyncExternalStore !== undefined ? $d1e32a1d75e60036$var$useMediaQueryNew : $d1e32a1d75e60036$var$useMediaQueryOld;
        const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
        return match;
    };
}
const $d1e32a1d75e60036$var$useMediaQuery = $d1e32a1d75e60036$export$96d7927a982220b5();
var $d1e32a1d75e60036$export$2e2bcd8739ae039 = $d1e32a1d75e60036$var$useMediaQuery;

});


parcelRegister("i88wr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06685319248b3556$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $arRxM = parcelRequire("arRxM");

var $7fPBF = parcelRequire("7fPBF");

var $eEsmF = parcelRequire("eEsmF");

var $QgwxG = parcelRequire("QgwxG");

var $7Vqnf = parcelRequire("7Vqnf");
var $06685319248b3556$var$ImageAlt = /*#__PURE__*/ function(ImageAlt) {
    ImageAlt["License"] = "CC BY-SA 4.0 license";
    ImageAlt["Harvest"] = "Harvesting in Ethiopia";
    ImageAlt["Thresh"] = "Threshing in Bangladesh";
    ImageAlt["Winnow"] = "Winnowing in India";
    return ImageAlt;
}($06685319248b3556$var$ImageAlt || {});
var $06685319248b3556$var$ImageId = /*#__PURE__*/ function(ImageId) {
    ImageId["License"] = "image-license";
    ImageId["Harvest"] = "harvest-image";
    ImageId["Thresh"] = "thresh-image";
    ImageId["Winnow"] = "winnow-image";
    return ImageId;
}($06685319248b3556$var$ImageId || {});
const $06685319248b3556$var$imageMetadata = [
    (0, (/*@__PURE__*/$parcel$interopDefault($7Vqnf))).harvest,
    (0, (/*@__PURE__*/$parcel$interopDefault($7Vqnf))).thresh,
    (0, (/*@__PURE__*/$parcel$interopDefault($7Vqnf))).winnow
];
// Opacity of the 3 images, each fading in then fading out while the next fades in.
const $06685319248b3556$var$opacityKeyframes1 = [
    0,
    0.5,
    1,
    1,
    0.5,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
];
const $06685319248b3556$var$opacityKeyframes2 = [
    0,
    0,
    0,
    0,
    0.5,
    1,
    1,
    0.5,
    0,
    0,
    0,
    0,
    0
];
const $06685319248b3556$var$opacityKeyframes3 = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0.5,
    1,
    1,
    0.5,
    0,
    0
];
function $06685319248b3556$export$2e2bcd8739ae039(props) {
    (0, $7fPBF.useEffect)(()=>{
        if (props.loading) {
            const options = {
                duration: 7,
                ease: "linear",
                repeat: Infinity
            };
            (0, $arRxM.animate)(`#${"image-license"}`, {
                opacity: $06685319248b3556$var$opacityKeyframes1
            }, options);
            (0, $arRxM.animate)(`#${"harvest-image"}`, {
                opacity: $06685319248b3556$var$opacityKeyframes1
            }, options);
            (0, $arRxM.animate)(`#${"thresh-image"}`, {
                opacity: $06685319248b3556$var$opacityKeyframes2
            }, options);
            (0, $arRxM.animate)(`#${"winnow-image"}`, {
                opacity: $06685319248b3556$var$opacityKeyframes3
            }, options);
        }
    }, [
        props.loading
    ]);
    const imageSize = Math.min(0.75 * window.innerHeight, 0.25 * window.innerWidth, props.height || 1000);
    const imageStyle = {
        border: "1px solid black",
        borderRadius: imageSize,
        height: imageSize,
        position: "relative"
    };
    const overlap = 0.23;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        style: {
            height: imageSize,
            position: "relative",
            margin: 10
        },
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                alt: "Harvesting in Ethiopia",
                id: "harvest-image",
                src: (0, $QgwxG.harvest),
                style: {
                    ...imageStyle,
                    insetInlineStart: overlap * imageSize
                }
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                alt: "Threshing in Bangladesh",
                id: "thresh-image",
                src: (0, $QgwxG.thresh),
                style: {
                    ...imageStyle
                }
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                alt: "Winnowing in India",
                id: "winnow-image",
                src: (0, $QgwxG.winnow),
                style: {
                    ...imageStyle,
                    insetInlineEnd: overlap * imageSize
                }
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                id: "image-license",
                style: {
                    // Use -10 to offset the button padding
                    bottom: -10,
                    insetInlineStart: 0.2 * imageSize - 10,
                    position: "absolute"
                },
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eEsmF.default), {
                    images: $06685319248b3556$var$imageMetadata,
                    width: 0.15 * imageSize
                })
            })
        ]
    });
}

});
parcelRegister("arRxM", function(module, exports) {

$parcel$export(module.exports, "animate", function () { return $7cf482bde9d2750d$export$e3607ec2d7a891c4; });

var $8BgC3 = parcelRequire("8BgC3");

var $iwW4i = parcelRequire("iwW4i");

var $k8txR = parcelRequire("k8txR");

var $9i93l = parcelRequire("9i93l");
function $7cf482bde9d2750d$var$isSequence(value) {
    return Array.isArray(value) && value.some(Array.isArray);
}
/**
 * Creates an animation function that is optionally scoped
 * to a specific element.
 */ function $7cf482bde9d2750d$export$c17e592002be9b90(options = {}) {
    const { scope: scope, reduceMotion: reduceMotion, skipAnimations: skipAnimations } = options;
    /**
     * Implementation
     */ function scopedAnimate(subjectOrSequence, optionsOrKeyframes, options) {
        let animations = [];
        let animationOnComplete;
        const inherited = {};
        if (reduceMotion !== undefined) inherited.reduceMotion = reduceMotion;
        if (skipAnimations !== undefined) inherited.skipAnimations = skipAnimations;
        if ($7cf482bde9d2750d$var$isSequence(subjectOrSequence)) {
            const { onComplete: onComplete, ...sequenceOptions } = optionsOrKeyframes || {};
            if (typeof onComplete === "function") animationOnComplete = onComplete;
            animations = (0, $k8txR.animateSequence)(subjectOrSequence, {
                ...inherited,
                ...sequenceOptions
            }, scope);
        } else {
            // Extract top-level onComplete so it doesn't get applied per-value
            const { onComplete: onComplete, ...rest } = options || {};
            if (typeof onComplete === "function") animationOnComplete = onComplete;
            animations = (0, $9i93l.animateSubject)(subjectOrSequence, optionsOrKeyframes, {
                ...inherited,
                ...rest
            }, scope);
        }
        const animation = new (0, $8BgC3.GroupAnimationWithThen)(animations);
        if (animationOnComplete) animation.finished.then(animationOnComplete);
        if (scope) {
            scope.animations.push(animation);
            animation.finished.then(()=>{
                (0, $iwW4i.removeItem)(scope.animations, animation);
            });
        }
        return animation;
    }
    return scopedAnimate;
}
const $7cf482bde9d2750d$export$e3607ec2d7a891c4 = $7cf482bde9d2750d$export$c17e592002be9b90();

});
parcelRegister("8BgC3", function(module, exports) {

$parcel$export(module.exports, "GroupAnimationWithThen", function () { return $835a46e97c0d7449$export$77cf9b7b4d0397cf; });

var $5PnkP = parcelRequire("5PnkP");
class $835a46e97c0d7449$export$77cf9b7b4d0397cf extends (0, $5PnkP.GroupAnimation) {
    then(onResolve, _onReject) {
        return this.finished.finally(onResolve).then(()=>{});
    }
}

});
parcelRegister("5PnkP", function(module, exports) {

$parcel$export(module.exports, "GroupAnimation", function () { return $2dac054dce58bb42$export$63bc083c14074060; });
class $2dac054dce58bb42$export$63bc083c14074060 {
    constructor(animations){
        // Bound to accomadate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    get finished() {
        return Promise.all(this.animations.map((animation)=>animation.finished));
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline) {
        const subscriptions = this.animations.map((animation)=>animation.attachTimeline(timeline));
        return ()=>{
            subscriptions.forEach((cancel, i)=>{
                cancel && cancel();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get state() {
        return this.getAll("state");
    }
    get startTime() {
        return this.getAll("startTime");
    }
    get duration() {
        return $2dac054dce58bb42$var$getMax(this.animations, "duration");
    }
    get iterationDuration() {
        return $2dac054dce58bb42$var$getMax(this.animations, "iterationDuration");
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}
function $2dac054dce58bb42$var$getMax(animations, propName) {
    let max = 0;
    for(let i = 0; i < animations.length; i++){
        const value = animations[i][propName];
        if (value !== null && value > max) max = value;
    }
    return max;
}

});


parcelRegister("iwW4i", function(module, exports) {

$parcel$export(module.exports, "addUniqueItem", function () { return $3fbb49f840f4b07a$export$20e507e47fae79fd; });
$parcel$export(module.exports, "removeItem", function () { return $3fbb49f840f4b07a$export$fe2d9b4e03920b4c; });
function $3fbb49f840f4b07a$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $3fbb49f840f4b07a$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $3fbb49f840f4b07a$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}

});

parcelRegister("k8txR", function(module, exports) {

$parcel$export(module.exports, "animateSequence", function () { return $b0aeb1cc7afa379c$export$82a013c5b12ef57f; });

var $52PJo = parcelRequire("52PJo");
var $479nq = parcelRequire("479nq");

var $9U6fs = parcelRequire("9U6fs");

var $9i93l = parcelRequire("9i93l");
function $b0aeb1cc7afa379c$export$82a013c5b12ef57f(sequence, options, scope) {
    const animations = [];
    /**
     * Pre-process: replace function segments with MotionValue segments,
     * subscribe callbacks immediately
     */ const processedSequence = sequence.map((segment)=>{
        if (Array.isArray(segment) && typeof segment[0] === "function") {
            const callback = segment[0];
            const mv = (0, $52PJo.motionValue)(0);
            mv.on("change", callback);
            if (segment.length === 1) return [
                mv,
                [
                    0,
                    1
                ]
            ];
            else if (segment.length === 2) return [
                mv,
                [
                    0,
                    1
                ],
                segment[1]
            ];
            else return [
                mv,
                segment[1],
                segment[2]
            ];
        }
        return segment;
    });
    const animationDefinitions = (0, $9U6fs.createAnimationsFromSequence)(processedSequence, options, scope, {
        spring: $479nq.spring
    });
    animationDefinitions.forEach(({ keyframes: keyframes, transition: transition }, subject)=>{
        animations.push(...(0, $9i93l.animateSubject)(subject, keyframes, transition));
    });
    return animations;
}

});
parcelRegister("52PJo", function(module, exports) {

$parcel$export(module.exports, "motionValue", function () { return $eba58299b894994c$export$ce8bdc721e76545f; });

var $biy51 = parcelRequire("biy51");
var $66yMJ = parcelRequire("66yMJ");

var $iO0o7 = parcelRequire("iO0o7");

var $ibWTn = parcelRequire("ibWTn");
/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $eba58299b894994c$var$MAX_VELOCITY_DELTA = 30;
const $eba58299b894994c$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $eba58299b894994c$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $eba58299b894994c$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     */ constructor(init, options = {}){
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v)=>{
            const currentTime = (0, $iO0o7.time).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev) {
                this.events.change?.notify(this.current);
                if (this.dependents) for (const dependent of this.dependents)dependent.dirty();
            }
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $iO0o7.time).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $eba58299b894994c$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $biy51.SubscriptionManager)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $ibWTn.frame).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v) {
        if (!this.passiveEffect) this.updateAndNotify(v);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    dirty() {
        this.events.change?.notify(this.current);
    }
    addDependent(dependent) {
        if (!this.dependents) this.dependents = new Set();
        this.dependents.add(dependent);
    }
    removeDependent(dependent) {
        if (this.dependents) this.dependents.delete(dependent);
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($eba58299b894994c$export$67fcd818a264039d.current) $eba58299b894994c$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $iO0o7.time).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $eba58299b894994c$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $eba58299b894994c$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $66yMJ.velocityPerSecond)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.dependents?.clear();
        this.events.destroy?.notify();
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $eba58299b894994c$export$ce8bdc721e76545f(init, options) {
    return new $eba58299b894994c$export$8cea36d14ee64562(init, options);
}

});
parcelRegister("biy51", function(module, exports) {

$parcel$export(module.exports, "SubscriptionManager", function () { return $530b27a3f7a9b181$export$e7dff9482a5fd23c; });

var $iwW4i = parcelRequire("iwW4i");
class $530b27a3f7a9b181$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $iwW4i.addUniqueItem)(this.subscriptions, handler);
        return ()=>(0, $iwW4i.removeItem)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}

});

parcelRegister("66yMJ", function(module, exports) {

$parcel$export(module.exports, "velocityPerSecond", function () { return $53435ded96da5381$export$eab0632f7ad4f9d7; });
/*
  Convert velocity into velocity per second
*/ /*#__NO_SIDE_EFFECTS__*/ const $53435ded96da5381$export$eab0632f7ad4f9d7 = (velocity, frameDuration)=>frameDuration ? velocity * (1000 / frameDuration) : 0;

});

parcelRegister("iO0o7", function(module, exports) {

$parcel$export(module.exports, "time", function () { return $2a28679c5e08a25b$export$2da9be4cfdb689b1; });

var $9zuZQ = parcelRequire("9zuZQ");

var $ibWTn = parcelRequire("ibWTn");
let $2a28679c5e08a25b$var$now;
function $2a28679c5e08a25b$var$clearTime() {
    $2a28679c5e08a25b$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $2a28679c5e08a25b$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($2a28679c5e08a25b$var$now === undefined) $2a28679c5e08a25b$export$2da9be4cfdb689b1.set((0, $ibWTn.frameData).isProcessing || (0, $9zuZQ.MotionGlobalConfig).useManualTiming ? (0, $ibWTn.frameData).timestamp : performance.now());
        return $2a28679c5e08a25b$var$now;
    },
    set: (newTime)=>{
        $2a28679c5e08a25b$var$now = newTime;
        queueMicrotask($2a28679c5e08a25b$var$clearTime);
    }
};

});
parcelRegister("9zuZQ", function(module, exports) {

$parcel$export(module.exports, "MotionGlobalConfig", function () { return $877fe7d159c5dd4c$export$dd826089e3c5e502; });
const $877fe7d159c5dd4c$export$dd826089e3c5e502 = {};

});

parcelRegister("ibWTn", function(module, exports) {

$parcel$export(module.exports, "frame", function () { return $44c600a9437aff7c$export$2cef06c20297c17d; });
$parcel$export(module.exports, "cancelFrame", function () { return $44c600a9437aff7c$export$ec99c0ef4978dccb; });
$parcel$export(module.exports, "frameData", function () { return $44c600a9437aff7c$export$fff89137e9e818ce; });

var $7aJzA = parcelRequire("7aJzA");

var $lCeLL = parcelRequire("lCeLL");
const { schedule: $44c600a9437aff7c$export$2cef06c20297c17d, cancel: $44c600a9437aff7c$export$ec99c0ef4978dccb, state: $44c600a9437aff7c$export$fff89137e9e818ce, steps: $44c600a9437aff7c$export$1811c3a7e3af92f0 } = /* @__PURE__ */ (0, $lCeLL.createRenderBatcher)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $7aJzA.noop), true);

});
parcelRegister("7aJzA", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $69d49105ec21595d$export$8793edee2d425525; });
/*#__NO_SIDE_EFFECTS__*/ const $69d49105ec21595d$export$8793edee2d425525 = (any)=>any;

});

parcelRegister("lCeLL", function(module, exports) {

$parcel$export(module.exports, "createRenderBatcher", function () { return $ebdeb8cab5a1d6c2$export$510b0596a933801a; });

var $9zuZQ = parcelRequire("9zuZQ");

var $108F1 = parcelRequire("108F1");

var $lULs8 = parcelRequire("lULs8");
const $ebdeb8cab5a1d6c2$var$maxElapsed = 40;
function $ebdeb8cab5a1d6c2$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = (0, $108F1.stepsOrder).reduce((acc, key)=>{
        acc[key] = (0, $lULs8.createRenderStep)(flagRunNextFrame);
        return acc;
    }, {});
    const { setup: setup, read: read, resolveKeyframes: resolveKeyframes, preUpdate: preUpdate, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const useManualTiming = (0, $9zuZQ.MotionGlobalConfig).useManualTiming;
        const timestamp = useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        if (!useManualTiming) state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $ebdeb8cab5a1d6c2$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        setup.process(state);
        read.process(state);
        resolveKeyframes.process(state);
        preUpdate.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = (0, $108F1.stepsOrder).reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < (0, $108F1.stepsOrder).length; i++)steps[(0, $108F1.stepsOrder)[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}

});
parcelRegister("108F1", function(module, exports) {

$parcel$export(module.exports, "stepsOrder", function () { return $6df534696c4af587$export$71ecace0a033b35a; });
const $6df534696c4af587$export$71ecace0a033b35a = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender"
];

});

parcelRegister("lULs8", function(module, exports) {

$parcel$export(module.exports, "createRenderStep", function () { return $22c8543101d08652$export$b995e5e85f5c8289; });
function $22c8543101d08652$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            // Swap this frame and the next to avoid GC
            const prevFrame = thisFrame;
            thisFrame = nextFrame;
            nextFrame = prevFrame;
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}

});





parcelRegister("479nq", function(module, exports) {

$parcel$export(module.exports, "spring", function () { return $cf35667c22d9ae68$export$b36281d89752ae66; });

var $iH3lf = parcelRequire("iH3lf");
var $jzxS7 = parcelRequire("jzxS7");
var $jEeLK = parcelRequire("jEeLK");

var $9AMsY = parcelRequire("9AMsY");

var $fCnvu = parcelRequire("fCnvu");

var $j2L6b = parcelRequire("j2L6b");
const $cf35667c22d9ae68$var$springDefaults = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};
function $cf35667c22d9ae68$var$calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}
const $cf35667c22d9ae68$var$rootIterations = 12;
function $cf35667c22d9ae68$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $cf35667c22d9ae68$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
/**
 * This is ported from the Framer implementation of duration-based spring resolution.
 */ const $cf35667c22d9ae68$var$safeMin = 0.001;
function $cf35667c22d9ae68$var$findSpring({ duration: duration = $cf35667c22d9ae68$var$springDefaults.duration, bounce: bounce = $cf35667c22d9ae68$var$springDefaults.bounce, velocity: velocity = $cf35667c22d9ae68$var$springDefaults.velocity, mass: mass = $cf35667c22d9ae68$var$springDefaults.mass }) {
    let envelope;
    let derivative;
    (0, $jEeLK.warning)(duration <= (0, $jzxS7.secondsToMilliseconds)($cf35667c22d9ae68$var$springDefaults.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $iH3lf.clamp)($cf35667c22d9ae68$var$springDefaults.minDamping, $cf35667c22d9ae68$var$springDefaults.maxDamping, dampingRatio);
    duration = (0, $iH3lf.clamp)($cf35667c22d9ae68$var$springDefaults.minDuration, $cf35667c22d9ae68$var$springDefaults.maxDuration, (0, $jzxS7.millisecondsToSeconds)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $cf35667c22d9ae68$var$calcAngularFreq(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $cf35667c22d9ae68$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $cf35667c22d9ae68$var$calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $cf35667c22d9ae68$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$cf35667c22d9ae68$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $cf35667c22d9ae68$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $jzxS7.secondsToMilliseconds)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: $cf35667c22d9ae68$var$springDefaults.stiffness,
        damping: $cf35667c22d9ae68$var$springDefaults.damping,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $cf35667c22d9ae68$var$durationKeys = [
    "duration",
    "bounce"
];
const $cf35667c22d9ae68$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $cf35667c22d9ae68$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $cf35667c22d9ae68$var$getSpringOptions(options) {
    let springOptions = {
        velocity: $cf35667c22d9ae68$var$springDefaults.velocity,
        stiffness: $cf35667c22d9ae68$var$springDefaults.stiffness,
        damping: $cf35667c22d9ae68$var$springDefaults.damping,
        mass: $cf35667c22d9ae68$var$springDefaults.mass,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$cf35667c22d9ae68$var$isSpringType(options, $cf35667c22d9ae68$var$physicsKeys) && $cf35667c22d9ae68$var$isSpringType(options, $cf35667c22d9ae68$var$durationKeys)) {
        // Time-defined springs should ignore inherited velocity.
        // Velocity from interrupted animations can cause findSpring()
        // to compute wildly different spring parameters, leading to
        // massive oscillation on small-range animations.
        springOptions.velocity = 0;
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, $iH3lf.clamp)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = {
                ...springOptions,
                mass: $cf35667c22d9ae68$var$springDefaults.mass,
                stiffness: stiffness,
                damping: damping
            };
        } else {
            const derived = $cf35667c22d9ae68$var$findSpring({
                ...options,
                velocity: 0
            });
            springOptions = {
                ...springOptions,
                ...derived,
                mass: $cf35667c22d9ae68$var$springDefaults.mass
            };
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $cf35667c22d9ae68$export$b36281d89752ae66(optionsOrVisualDuration = $cf35667c22d9ae68$var$springDefaults.visualDuration, bounce = $cf35667c22d9ae68$var$springDefaults.bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    let { restSpeed: restSpeed, restDelta: restDelta } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $cf35667c22d9ae68$var$getSpringOptions({
        ...options,
        velocity: -(0, $jzxS7.millisecondsToSeconds)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $jzxS7.millisecondsToSeconds)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? $cf35667c22d9ae68$var$springDefaults.restSpeed.granular : $cf35667c22d9ae68$var$springDefaults.restSpeed.default);
    restDelta || (restDelta = isGranularScale ? $cf35667c22d9ae68$var$springDefaults.restDelta.granular : $cf35667c22d9ae68$var$springDefaults.restDelta.default);
    let resolveSpring;
    let resolveVelocity;
    // Underdamped coefficients, hoisted for use in the inlined next() hot path
    let angularFreq;
    let A;
    let sinCoeff;
    let cosCoeff;
    if (dampingRatio < 1) {
        angularFreq = $cf35667c22d9ae68$var$calcAngularFreq(undampedAngularFreq, dampingRatio);
        A = (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq;
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * (A * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
        // Analytical derivative of underdamped spring (px/ms)
        sinCoeff = dampingRatio * undampedAngularFreq * A + initialDelta * angularFreq;
        cosCoeff = dampingRatio * undampedAngularFreq * initialDelta - A * angularFreq;
        resolveVelocity = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return envelope * (sinCoeff * Math.sin(angularFreq * t) + cosCoeff * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) {
        // Critically damped spring
        resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        // Analytical derivative of critically damped spring (px/ms)
        const C = initialVelocity + undampedAngularFreq * initialDelta;
        resolveVelocity = (t)=>Math.exp(-undampedAngularFreq * t) * (undampedAngularFreq * C * t - initialVelocity);
    } else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
        // Analytical derivative of overdamped spring (px/ms)
        const P = (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / dampedAngularFreq;
        const sinhCoeff = dampingRatio * undampedAngularFreq * P - initialDelta * dampedAngularFreq;
        const coshCoeff = dampingRatio * undampedAngularFreq * initialDelta - P * dampedAngularFreq;
        resolveVelocity = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return envelope * (sinhCoeff * Math.sinh(freqForT) + coshCoeff * Math.cosh(freqForT));
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        velocity: (t)=>(0, $jzxS7.secondsToMilliseconds)(resolveVelocity(t)),
        next: (t)=>{
            /**
             * For underdamped physics springs we need both position and
             * velocity each tick. Compute shared trig values once to avoid
             * duplicate Math.exp/sin/cos calls on the hot path.
             */ if (!isResolvedFromDuration && dampingRatio < 1) {
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                const sin = Math.sin(angularFreq * t);
                const cos = Math.cos(angularFreq * t);
                const current = target - envelope * (A * sin + initialDelta * cos);
                const currentVelocity = (0, $jzxS7.secondsToMilliseconds)(envelope * (sinCoeff * sin + cosCoeff * cos));
                state.done = Math.abs(currentVelocity) <= restSpeed && Math.abs(target - current) <= restDelta;
                state.value = state.done ? target : current;
                return state;
            }
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                const currentVelocity = (0, $jzxS7.secondsToMilliseconds)(resolveVelocity(t));
                state.done = Math.abs(currentVelocity) <= restSpeed && Math.abs(target - current) <= restDelta;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, $fCnvu.calcGeneratorDuration)(generator), (0, $fCnvu.maxGeneratorDuration));
            const easing = (0, $9AMsY.generateLinearEasing)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        },
        toTransition: ()=>{}
    };
    return generator;
}
$cf35667c22d9ae68$export$b36281d89752ae66.applyToOptions = (options)=>{
    const generatorOptions = (0, $j2L6b.createGeneratorEasing)(options, 100, $cf35667c22d9ae68$export$b36281d89752ae66);
    options.ease = generatorOptions.ease;
    options.duration = (0, $jzxS7.secondsToMilliseconds)(generatorOptions.duration);
    options.type = "keyframes";
    return options;
};

});
parcelRegister("iH3lf", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $d412cf5d698f4b1e$export$7d15b64cf5a3a4c4; });
const $d412cf5d698f4b1e$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};

});

parcelRegister("jzxS7", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", function () { return $d17a7d2c2068c118$export$fc3e7e8557f8c8c7; });
$parcel$export(module.exports, "millisecondsToSeconds", function () { return $d17a7d2c2068c118$export$f64c3bfbc58eec0f; });
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ const $d17a7d2c2068c118$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/ const $d17a7d2c2068c118$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;

});

parcelRegister("jEeLK", function(module, exports) {

$parcel$export(module.exports, "warning", function () { return $19758d730238f0ed$export$491112666e282270; });
$parcel$export(module.exports, "invariant", function () { return $19758d730238f0ed$export$f5708dca728d7177; });

let $19758d730238f0ed$export$491112666e282270 = ()=>{};
let $19758d730238f0ed$export$f5708dca728d7177 = ()=>{};
var $19758d730238f0ed$var$check, $19758d730238f0ed$var$message, $19758d730238f0ed$var$errorCode, $19758d730238f0ed$var$check1, $19758d730238f0ed$var$message1, $19758d730238f0ed$var$errorCode1;

});

parcelRegister("9AMsY", function(module, exports) {

$parcel$export(module.exports, "generateLinearEasing", function () { return $0e9dc36f6f7cb032$export$66d3851e2b1ec912; });
const $0e9dc36f6f7cb032$export$66d3851e2b1ec912 = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += Math.round(easing(i / (numPoints - 1)) * 10000) / 10000 + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};

});

parcelRegister("fCnvu", function(module, exports) {

$parcel$export(module.exports, "maxGeneratorDuration", function () { return $9c4fce4939386ba9$export$f4ff70a5b4808fd8; });
$parcel$export(module.exports, "calcGeneratorDuration", function () { return $9c4fce4939386ba9$export$cbdd6b3d40ea54e2; });
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $9c4fce4939386ba9$export$f4ff70a5b4808fd8 = 20000;
function $9c4fce4939386ba9$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $9c4fce4939386ba9$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $9c4fce4939386ba9$export$f4ff70a5b4808fd8 ? Infinity : duration;
}

});

parcelRegister("j2L6b", function(module, exports) {

$parcel$export(module.exports, "createGeneratorEasing", function () { return $419f83f95667f286$export$7f1511d09ee75a99; });

var $jzxS7 = parcelRequire("jzxS7");

var $fCnvu = parcelRequire("fCnvu");
/**
 * Create a progress => progress easing function from a generator.
 */ function $419f83f95667f286$export$7f1511d09ee75a99(options, scale = 100, createGenerator) {
    const generator = createGenerator({
        ...options,
        keyframes: [
            0,
            scale
        ]
    });
    const duration = Math.min((0, $fCnvu.calcGeneratorDuration)(generator), (0, $fCnvu.maxGeneratorDuration));
    return {
        type: "keyframes",
        ease: (progress)=>{
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, $jzxS7.millisecondsToSeconds)(duration)
    };
}

});


parcelRegister("9U6fs", function(module, exports) {

$parcel$export(module.exports, "createAnimationsFromSequence", function () { return $03b30e8647cd05dd$export$1f0f44b51a4b2f73; });

var $j2L6b = parcelRequire("j2L6b");
var $ggba5 = parcelRequire("ggba5");
var $hcTHB = parcelRequire("hcTHB");
var $4eY6j = parcelRequire("4eY6j");
var $dP4pV = parcelRequire("dP4pV");

var $9n4TR = parcelRequire("9n4TR");
var $zbDlb = parcelRequire("zbDlb");
var $djbVF = parcelRequire("djbVF");
var $jzxS7 = parcelRequire("jzxS7");
var $jEeLK = parcelRequire("jEeLK");

var $jzR6J = parcelRequire("jzR6J");

var $5yCtR = parcelRequire("5yCtR");

var $4pboA = parcelRequire("4pboA");

var $czgr0 = parcelRequire("czgr0");

var $kYJfP = parcelRequire("kYJfP");

var $cvCRq = parcelRequire("cvCRq");
const $03b30e8647cd05dd$var$defaultSegmentEasing = "easeInOut";
const $03b30e8647cd05dd$var$MAX_REPEAT = 20;
function $03b30e8647cd05dd$export$1f0f44b51a4b2f73(sequence, { defaultTransition: defaultTransition = {}, ...sequenceTransition } = {}, scope, generators) {
    const defaultDuration = defaultTransition.duration || 0.3;
    const animationDefinitions = new Map();
    const sequences = new Map();
    const elementCache = {};
    const timeLabels = new Map();
    let prevTime = 0;
    let currentTime = 0;
    let totalDuration = 0;
    /**
     * Build the timeline by mapping over the sequence array and converting
     * the definitions into keyframes and offsets with absolute time values.
     * These will later get converted into relative offsets in a second pass.
     */ for(let i = 0; i < sequence.length; i++){
        const segment = sequence[i];
        /**
         * If this is a timeline label, mark it and skip the rest of this iteration.
         */ if (typeof segment === "string") {
            timeLabels.set(segment, currentTime);
            continue;
        } else if (!Array.isArray(segment)) {
            timeLabels.set(segment.name, (0, $4pboA.calcNextTime)(currentTime, segment.at, prevTime, timeLabels));
            continue;
        }
        let [subject, keyframes, transition = {}] = segment;
        /**
         * If a relative or absolute time value has been specified we need to resolve
         * it in relation to the currentTime.
         */ if (transition.at !== undefined) currentTime = (0, $4pboA.calcNextTime)(currentTime, transition.at, prevTime, timeLabels);
        /**
         * Keep track of the maximum duration in this definition. This will be
         * applied to currentTime once the definition has been parsed.
         */ let maxDuration = 0;
        const resolveValueSequence = (valueKeyframes, valueTransition, valueSequence, elementIndex = 0, numSubjects = 0)=>{
            const valueKeyframesAsList = $03b30e8647cd05dd$var$keyframesAsList(valueKeyframes);
            const { delay: delay = 0, times: times = (0, $ggba5.defaultOffset)(valueKeyframesAsList), type: type = defaultTransition.type || "keyframes", repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay = 0, ...remainingTransition } = valueTransition;
            let { ease: ease = defaultTransition.ease || "easeOut", duration: duration } = valueTransition;
            /**
             * Resolve stagger() if defined.
             */ const calculatedDelay = typeof delay === "function" ? delay(elementIndex, numSubjects) : delay;
            /**
             * If this animation should and can use a spring, generate a spring easing function.
             */ const numKeyframes = valueKeyframesAsList.length;
            const createGenerator = (0, $4eY6j.isGenerator)(type) ? type : generators?.[type || "keyframes"];
            if (numKeyframes <= 2 && createGenerator) {
                /**
                 * As we're creating an easing function from a spring,
                 * ideally we want to generate it using the real distance
                 * between the two keyframes. However this isn't always
                 * possible - in these situations we use 0-100.
                 */ let absoluteDelta = 100;
                if (numKeyframes === 2 && $03b30e8647cd05dd$var$isNumberKeyframesArray(valueKeyframesAsList)) {
                    const delta = valueKeyframesAsList[1] - valueKeyframesAsList[0];
                    absoluteDelta = Math.abs(delta);
                }
                const springTransition = {
                    ...defaultTransition,
                    ...remainingTransition
                };
                if (duration !== undefined) springTransition.duration = (0, $jzxS7.secondsToMilliseconds)(duration);
                const springEasing = (0, $j2L6b.createGeneratorEasing)(springTransition, absoluteDelta, createGenerator);
                ease = springEasing.ease;
                duration = springEasing.duration;
            }
            duration ?? (duration = defaultDuration);
            const startTime = currentTime + calculatedDelay;
            /**
             * If there's only one time offset of 0, fill in a second with length 1
             */ if (times.length === 1 && times[0] === 0) times[1] = 1;
            /**
             * Fill out if offset if fewer offsets than keyframes
             */ const remainder = times.length - valueKeyframesAsList.length;
            remainder > 0 && (0, $hcTHB.fillOffset)(times, remainder);
            /**
             * If only one value has been set, ie [1], push a null to the start of
             * the keyframe array. This will let us mark a keyframe at this point
             * that will later be hydrated with the previous value.
             */ valueKeyframesAsList.length === 1 && valueKeyframesAsList.unshift(null);
            /**
             * Segments can't express `repeat: Infinity` or very large
             * counts — they'd leave dead time after the segment or
             * explode the keyframe array. Ignore with a warning.
             */ if (repeat) (0, $jEeLK.warning)(repeat < $03b30e8647cd05dd$var$MAX_REPEAT, `Sequence segments can't repeat ${repeat} times \u{2014} ignoring repeat option. Use a value below ${$03b30e8647cd05dd$var$MAX_REPEAT} or apply repeat at the sequence level instead.`);
            if (repeat && repeat < $03b30e8647cd05dd$var$MAX_REPEAT) {
                /**
                 * Express repeatDelay in units of a single iteration's duration
                 * so it can be added to the per-iteration time offsets below
                 * before they're normalized to 0-1.
                 */ const repeatDelayUnits = duration > 0 ? repeatDelay / duration : 0;
                duration = (0, $5yCtR.calculateRepeatDuration)(duration, repeat, repeatDelay);
                const originalKeyframes = [
                    ...valueKeyframesAsList
                ];
                const originalTimes = [
                    ...times
                ];
                ease = Array.isArray(ease) ? [
                    ...ease
                ] : [
                    ease
                ];
                const originalEase = [
                    ...ease
                ];
                /**
                 * For reverse/mirror, alternate iterations play the segment
                 * backwards. mirror matches JSAnimation's mirroredGenerator:
                 * reversed keyframes, easings unchanged. reverse matches
                 * JSAnimation's iterationProgress = 1 - p: reversed
                 * keyframes, easing array reversed AND each function easing
                 * mapped through reverseEasing (string easings unchanged —
                 * they're resolved later by the keyframes engine).
                 */ const isFlipping = repeatType === "reverse" || repeatType === "mirror";
                let flippedKeyframes = originalKeyframes;
                let flippedEases = originalEase;
                if (isFlipping) {
                    flippedKeyframes = [
                        ...originalKeyframes
                    ].reverse();
                    if (repeatType === "reverse") flippedEases = [
                        ...originalEase
                    ].reverse().map((e)=>typeof e === "function" ? (0, $djbVF.reverseEasing)(e) : e);
                }
                for(let repeatIndex = 0; repeatIndex < repeat; repeatIndex++){
                    const isFlipped = isFlipping && repeatIndex % 2 === 0;
                    const iterKeyframes = isFlipped ? flippedKeyframes : originalKeyframes;
                    const iterEase = isFlipped ? flippedEases : originalEase;
                    const iterStartOffset = (repeatIndex + 1) * (1 + repeatDelayUnits);
                    /**
                     * If repeatDelay is set, hold the previous iteration's
                     * final value through the delay by inserting a keyframe
                     * at the moment the next iteration begins.
                     */ if (repeatDelayUnits > 0) {
                        valueKeyframesAsList.push(valueKeyframesAsList[valueKeyframesAsList.length - 1]);
                        times.push(iterStartOffset);
                        ease.push("linear");
                    }
                    valueKeyframesAsList.push(...iterKeyframes);
                    for(let keyframeIndex = 0; keyframeIndex < iterKeyframes.length; keyframeIndex++){
                        times.push(originalTimes[keyframeIndex] + iterStartOffset);
                        ease.push(keyframeIndex === 0 ? "linear" : (0, $9n4TR.getEasingForSegment)(iterEase, keyframeIndex - 1));
                    }
                }
                (0, $kYJfP.normalizeTimes)(times, repeat, repeatDelayUnits);
            }
            const targetTime = startTime + duration;
            /**
             * Add keyframes, mapping offsets to absolute time.
             */ (0, $czgr0.addKeyframes)(valueSequence, valueKeyframesAsList, ease, times, startTime, targetTime);
            maxDuration = Math.max(calculatedDelay + duration, maxDuration);
            totalDuration = Math.max(targetTime, totalDuration);
        };
        if ((0, $dP4pV.isMotionValue)(subject)) {
            const subjectSequence = $03b30e8647cd05dd$var$getSubjectSequence(subject, sequences);
            resolveValueSequence(keyframes, transition, $03b30e8647cd05dd$var$getValueSequence("default", subjectSequence));
        } else {
            const subjects = (0, $jzR6J.resolveSubjects)(subject, keyframes, scope, elementCache);
            const numSubjects = subjects.length;
            /**
             * For every element in this segment, process the defined values.
             */ for(let subjectIndex = 0; subjectIndex < numSubjects; subjectIndex++){
                /**
                 * Cast necessary, but we know these are of this type
                 */ keyframes;
                transition;
                const thisSubject = subjects[subjectIndex];
                const subjectSequence = $03b30e8647cd05dd$var$getSubjectSequence(thisSubject, sequences);
                for(const key in keyframes)resolveValueSequence(keyframes[key], $03b30e8647cd05dd$export$7c1391340308742e(transition, key), $03b30e8647cd05dd$var$getValueSequence(key, subjectSequence), subjectIndex, numSubjects);
            }
        }
        prevTime = currentTime;
        currentTime += maxDuration;
    }
    /**
     * For every element and value combination create a new animation.
     */ sequences.forEach((valueSequences, element)=>{
        for(const key in valueSequences){
            const valueSequence = valueSequences[key];
            /**
             * Arrange all the keyframes in ascending time order.
             */ valueSequence.sort((0, $cvCRq.compareByTime));
            const keyframes = [];
            const valueOffset = [];
            const valueEasing = [];
            /**
             * For each keyframe, translate absolute times into
             * relative offsets based on the total duration of the timeline.
             */ for(let i = 0; i < valueSequence.length; i++){
                const { at: at, value: value, easing: easing } = valueSequence[i];
                keyframes.push(value);
                valueOffset.push((0, $zbDlb.progress)(0, totalDuration, at));
                valueEasing.push(easing || "easeOut");
            }
            /**
             * If the first keyframe doesn't land on offset: 0
             * provide one by duplicating the initial keyframe. This ensures
             * it snaps to the first keyframe when the animation starts.
             */ if (valueOffset[0] !== 0) {
                valueOffset.unshift(0);
                keyframes.unshift(keyframes[0]);
                valueEasing.unshift($03b30e8647cd05dd$var$defaultSegmentEasing);
            }
            /**
             * If the last keyframe doesn't land on offset: 1
             * provide one with a null wildcard value. This will ensure it
             * stays static until the end of the animation.
             */ if (valueOffset[valueOffset.length - 1] !== 1) {
                valueOffset.push(1);
                keyframes.push(null);
            }
            if (!animationDefinitions.has(element)) animationDefinitions.set(element, {
                keyframes: {},
                transition: {}
            });
            const definition = animationDefinitions.get(element);
            definition.keyframes[key] = keyframes;
            /**
             * Exclude `type` from defaultTransition since springs have been
             * converted to duration-based easing functions in resolveValueSequence.
             * Including `type: "spring"` would cause JSAnimation to error when
             * the merged keyframes array has more than 2 keyframes.
             */ const { type: _type, ...remainingDefaultTransition } = defaultTransition;
            definition.transition[key] = {
                ...remainingDefaultTransition,
                duration: totalDuration,
                ease: valueEasing,
                times: valueOffset,
                ...sequenceTransition
            };
        }
    });
    return animationDefinitions;
}
function $03b30e8647cd05dd$var$getSubjectSequence(subject, sequences) {
    !sequences.has(subject) && sequences.set(subject, {});
    return sequences.get(subject);
}
function $03b30e8647cd05dd$var$getValueSequence(name, sequences) {
    if (!sequences[name]) sequences[name] = [];
    return sequences[name];
}
function $03b30e8647cd05dd$var$keyframesAsList(keyframes) {
    return Array.isArray(keyframes) ? keyframes : [
        keyframes
    ];
}
function $03b30e8647cd05dd$export$7c1391340308742e(transition, key) {
    return transition && transition[key] ? {
        ...transition,
        ...transition[key]
    } : {
        ...transition
    };
}
const $03b30e8647cd05dd$var$isNumber = (keyframe)=>typeof keyframe === "number";
const $03b30e8647cd05dd$var$isNumberKeyframesArray = (keyframes)=>keyframes.every($03b30e8647cd05dd$var$isNumber);

});
parcelRegister("ggba5", function(module, exports) {

$parcel$export(module.exports, "defaultOffset", function () { return $f8be49afc4edbaa8$export$24dbcec0b26e6d9d; });

var $hcTHB = parcelRequire("hcTHB");
function $f8be49afc4edbaa8$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $hcTHB.fillOffset)(offset, arr.length - 1);
    return offset;
}

});
parcelRegister("hcTHB", function(module, exports) {

$parcel$export(module.exports, "fillOffset", function () { return $7e6dd1d3379cddbd$export$dafee61230cf05c6; });

var $zbDlb = parcelRequire("zbDlb");

var $e9BqC = parcelRequire("e9BqC");
function $7e6dd1d3379cddbd$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $zbDlb.progress)(0, remaining, i);
        offset.push((0, $e9BqC.mixNumber)(min, 1, offsetProgress));
    }
}

});
parcelRegister("zbDlb", function(module, exports) {

$parcel$export(module.exports, "progress", function () { return $5a7354d1e57d5b3d$export$504d7abb21fa8c9; });
/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.
*/ /*#__NO_SIDE_EFFECTS__*/ const $5a7354d1e57d5b3d$export$504d7abb21fa8c9 = (from, to, value)=>{
    const range = to - from;
    return range ? (value - from) / range : 1;
};

});

parcelRegister("e9BqC", function(module, exports) {

$parcel$export(module.exports, "mixNumber", function () { return $98312100572e3dbc$export$3bb0b4ff1037b8dd; });
/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $98312100572e3dbc$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};

});



parcelRegister("4eY6j", function(module, exports) {

$parcel$export(module.exports, "isGenerator", function () { return $7499953f74b707a4$export$6ab7812f1bac68be; });
function $7499953f74b707a4$export$6ab7812f1bac68be(type) {
    return typeof type === "function" && "applyToOptions" in type;
}

});

parcelRegister("dP4pV", function(module, exports) {

$parcel$export(module.exports, "isMotionValue", function () { return $61e12cc57eeb85ed$export$605d60a2578142d3; });
const $61e12cc57eeb85ed$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);

});

parcelRegister("9n4TR", function(module, exports) {

$parcel$export(module.exports, "getEasingForSegment", function () { return $9704052b580c5cc9$export$41c5e731255a462; });

var $7U8FI = parcelRequire("7U8FI");

var $atBWw = parcelRequire("atBWw");
/*#__NO_SIDE_EFFECTS__*/ function $9704052b580c5cc9$export$41c5e731255a462(easing, i) {
    return (0, $atBWw.isEasingArray)(easing) ? easing[(0, $7U8FI.wrap)(0, easing.length, i)] : easing;
}

});
parcelRegister("7U8FI", function(module, exports) {

$parcel$export(module.exports, "wrap", function () { return $6d5cb2ed60c592f8$export$4997ffc0176396a6; });
const $6d5cb2ed60c592f8$export$4997ffc0176396a6 = (min, max, v)=>{
    const rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};

});

parcelRegister("atBWw", function(module, exports) {

$parcel$export(module.exports, "isEasingArray", function () { return $ab974cab0b2b4116$export$216948827bbdc797; });
/*#__NO_SIDE_EFFECTS__*/ const $ab974cab0b2b4116$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

});


parcelRegister("djbVF", function(module, exports) {

$parcel$export(module.exports, "reverseEasing", function () { return $931d9f9e77a0aee7$export$2c07eeff45156d4d; });
// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
/*#__NO_SIDE_EFFECTS__*/ const $931d9f9e77a0aee7$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);

});

parcelRegister("jzR6J", function(module, exports) {

$parcel$export(module.exports, "resolveSubjects", function () { return $75164a8f7eb22808$export$92b2aefc56600400; });

var $kJD4x = parcelRequire("kJD4x");

var $1GIWe = parcelRequire("1GIWe");
function $75164a8f7eb22808$export$92b2aefc56600400(subject, keyframes, scope, selectorCache) {
    if (subject == null) return [];
    if (typeof subject === "string" && (0, $1GIWe.isDOMKeyframes)(keyframes)) return (0, $kJD4x.resolveElements)(subject, scope, selectorCache);
    else if (subject instanceof NodeList) return Array.from(subject);
    else if (Array.isArray(subject)) return subject.filter((s)=>s != null);
    else return [
        subject
    ];
}

});
parcelRegister("kJD4x", function(module, exports) {

$parcel$export(module.exports, "resolveElements", function () { return $6709e3be20d4c81f$export$90ceba2564a894f8; });
function $6709e3be20d4c81f$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    if (elementOrSelector == null) return [];
    if (elementOrSelector instanceof EventTarget) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) root = scope.current;
        const elements = selectorCache?.[elementOrSelector] ?? root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector).filter((element)=>element != null);
}

});

parcelRegister("1GIWe", function(module, exports) {

$parcel$export(module.exports, "isDOMKeyframes", function () { return $555569bd38635df4$export$d276bfce3b1077ca; });
function $555569bd38635df4$export$d276bfce3b1077ca(keyframes) {
    return typeof keyframes === "object" && !Array.isArray(keyframes);
}

});


parcelRegister("5yCtR", function(module, exports) {

$parcel$export(module.exports, "calculateRepeatDuration", function () { return $70d889c086b4337b$export$fcfa02e469c39006; });
function $70d889c086b4337b$export$fcfa02e469c39006(duration, repeat, repeatDelay) {
    return duration * (repeat + 1) + repeatDelay * repeat;
}

});

parcelRegister("4pboA", function(module, exports) {

$parcel$export(module.exports, "calcNextTime", function () { return $97bb4a3a04080fbb$export$83ccd85155ba9791; });
/**
 * Given a absolute or relative time definition and current/prev time state of the sequence,
 * calculate an absolute time for the next keyframes.
 */ function $97bb4a3a04080fbb$export$83ccd85155ba9791(current, next, prev, labels) {
    if (typeof next === "number") return next;
    else if (next.startsWith("-") || next.startsWith("+")) return Math.max(0, current + parseFloat(next));
    else if (next === "<") return prev;
    else if (next.startsWith("<")) return Math.max(0, prev + parseFloat(next.slice(1)));
    else return labels.get(next) ?? current;
}

});

parcelRegister("czgr0", function(module, exports) {

$parcel$export(module.exports, "addKeyframes", function () { return $5d292411851ba8d6$export$89dfa6760a9f76e7; });

var $e9BqC = parcelRequire("e9BqC");

var $9n4TR = parcelRequire("9n4TR");
var $iwW4i = parcelRequire("iwW4i");
function $5d292411851ba8d6$export$6f93cdbb78924b88(sequence, startTime, endTime) {
    for(let i = 0; i < sequence.length; i++){
        const keyframe = sequence[i];
        if (keyframe.at > startTime && keyframe.at < endTime) {
            (0, $iwW4i.removeItem)(sequence, keyframe);
            // If we remove this item we have to push the pointer back one
            i--;
        }
    }
}
function $5d292411851ba8d6$export$89dfa6760a9f76e7(sequence, keyframes, easing, offset, startTime, endTime) {
    /**
     * Erase every existing value between currentTime and targetTime,
     * this will essentially splice this timeline into any currently
     * defined ones.
     */ $5d292411851ba8d6$export$6f93cdbb78924b88(sequence, startTime, endTime);
    for(let i = 0; i < keyframes.length; i++)sequence.push({
        value: keyframes[i],
        at: (0, $e9BqC.mixNumber)(startTime, endTime, offset[i]),
        easing: (0, $9n4TR.getEasingForSegment)(easing, i)
    });
}

});

parcelRegister("kYJfP", function(module, exports) {

$parcel$export(module.exports, "normalizeTimes", function () { return $6c835b14cec80a31$export$989461f373b2c60a; });
/**
 * Take an array of times that represent repeated keyframes. For instance
 * if we have original times of [0, 0.5, 1] then our repeated times will
 * be [0, 0.5, 1, 1, 1.5, 2]. Loop over the times and scale them back
 * down to a 0-1 scale.
 *
 * `repeatDelayUnits` is the repeatDelay expressed in units of a single
 * iteration's duration, so the total span equals `(repeat + 1) + repeat * repeatDelayUnits`.
 */ function $6c835b14cec80a31$export$989461f373b2c60a(times, repeat, repeatDelayUnits = 0) {
    const totalUnits = repeat + 1 + repeat * repeatDelayUnits;
    for(let i = 0; i < times.length; i++)times[i] = times[i] / totalUnits;
}

});

parcelRegister("cvCRq", function(module, exports) {

$parcel$export(module.exports, "compareByTime", function () { return $c7196797a7d6bc27$export$66dd3fbf44e05bd9; });
function $c7196797a7d6bc27$export$66dd3fbf44e05bd9(a, b) {
    if (a.at === b.at) {
        if (a.value === null) return 1;
        if (b.value === null) return -1;
        return 0;
    } else return a.at - b.at;
}

});


parcelRegister("9i93l", function(module, exports) {

$parcel$export(module.exports, "animateSubject", function () { return $03011c51805e7a6d$export$7f91f5969506fd92; });

var $ct3mQ = parcelRequire("ct3mQ");
var $g1ASW = parcelRequire("g1ASW");
var $dP4pV = parcelRequire("dP4pV");
var $1Zt2N = parcelRequire("1Zt2N");

var $jEeLK = parcelRequire("jEeLK");

var $2Wbp4 = parcelRequire("2Wbp4");

var $1GIWe = parcelRequire("1GIWe");

var $jzR6J = parcelRequire("jzR6J");
function $03011c51805e7a6d$var$isSingleValue(subject, keyframes) {
    return (0, $dP4pV.isMotionValue)(subject) || typeof subject === "number" || typeof subject === "string" && !(0, $1GIWe.isDOMKeyframes)(keyframes);
}
/**
 * Implementation
 */ function $03011c51805e7a6d$export$7f91f5969506fd92(subject, keyframes, options, scope) {
    const animations = [];
    if ($03011c51805e7a6d$var$isSingleValue(subject, keyframes)) animations.push((0, $ct3mQ.animateSingleValue)(subject, (0, $1GIWe.isDOMKeyframes)(keyframes) ? keyframes.default || keyframes : keyframes, options ? options.default || options : options));
    else {
        // Gracefully handle null/undefined subjects (e.g., from querySelector returning null)
        if (subject == null) return animations;
        const subjects = (0, $jzR6J.resolveSubjects)(subject, keyframes, scope);
        const numSubjects = subjects.length;
        (0, $jEeLK.invariant)(Boolean(numSubjects), "No valid elements provided.", "no-valid-elements");
        for(let i = 0; i < numSubjects; i++){
            const thisSubject = subjects[i];
            const createVisualElement = thisSubject instanceof Element ? (0, $2Wbp4.createDOMVisualElement) : (0, $2Wbp4.createObjectVisualElement);
            if (!(0, $1Zt2N.visualElementStore).has(thisSubject)) createVisualElement(thisSubject);
            const visualElement = (0, $1Zt2N.visualElementStore).get(thisSubject);
            const transition = {
                ...options
            };
            /**
             * Resolve stagger function if provided.
             */ if ("delay" in transition && typeof transition.delay === "function") transition.delay = transition.delay(i, numSubjects);
            animations.push(...(0, $g1ASW.animateTarget)(visualElement, {
                ...keyframes,
                transition: transition
            }, {}));
        }
    }
    return animations;
}

});
parcelRegister("ct3mQ", function(module, exports) {

$parcel$export(module.exports, "animateSingleValue", function () { return $e55ee0bef2336500$export$335a17c977067b99; });

var $heOY0 = parcelRequire("heOY0");

var $52PJo = parcelRequire("52PJo");

var $dP4pV = parcelRequire("dP4pV");
function $e55ee0bef2336500$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $dP4pV.isMotionValue)(value) ? value : (0, $52PJo.motionValue)(value);
    motionValue$1.start((0, $heOY0.animateMotionValue)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}

});
parcelRegister("heOY0", function(module, exports) {

$parcel$export(module.exports, "animateMotionValue", function () { return $17ccdc0a04fec700$export$90b3dfc33ff3548; });

var $9zuZQ = parcelRequire("9zuZQ");
var $jzxS7 = parcelRequire("jzxS7");

var $4TDOr = parcelRequire("4TDOr");

var $2Aaic = parcelRequire("2Aaic");

var $cyrnk = parcelRequire("cyrnk");

var $kPAiw = parcelRequire("kPAiw");

var $8NQQx = parcelRequire("8NQQx");

var $7UE0W = parcelRequire("7UE0W");

var $hFGJj = parcelRequire("hFGJj");

var $ibWTn = parcelRequire("ibWTn");
const $17ccdc0a04fec700$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $cyrnk.getValueTransition)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $jzxS7.secondsToMilliseconds)(delay);
        const options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unique transition settings for this value.
     */ if (!(0, $hFGJj.isTransitionDefined)(valueTransition)) Object.assign(options, (0, $8NQQx.getDefaultTransition)(name, options));
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ options.duration && (options.duration = (0, $jzxS7.secondsToMilliseconds)(options.duration));
        options.repeatDelay && (options.repeatDelay = (0, $jzxS7.secondsToMilliseconds)(options.repeatDelay));
        /**
     * Support deprecated way to set initial value. Prefer keyframe syntax.
     */ if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            (0, $kPAiw.makeAnimationInstant)(options);
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $9zuZQ.MotionGlobalConfig).instantAnimations || (0, $9zuZQ.MotionGlobalConfig).skipAnimations || element?.shouldSkipAnimations || valueTransition.skipAnimations) {
            shouldSkip = true;
            (0, $kPAiw.makeAnimationInstant)(options);
            options.delay = 0;
        }
        /**
     * If the transition type or easing has been explicitly set by the user
     * then we don't want to allow flattening the animation.
     */ options.allowFlatten = !valueTransition.type && !valueTransition.ease;
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $7UE0W.getFinalKeyframe)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $ibWTn.frame).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                return;
            }
        }
        return valueTransition.isSync ? new (0, $2Aaic.JSAnimation)(options) : new (0, $4TDOr.AsyncMotionValueAnimation)(options);
    };

});
parcelRegister("4TDOr", function(module, exports) {

$parcel$export(module.exports, "AsyncMotionValueAnimation", function () { return $583944b926d997b7$export$b9855e2a7dee3dd2; });

var $9zuZQ = parcelRequire("9zuZQ");
var $7aJzA = parcelRequire("7aJzA");

var $iO0o7 = parcelRequire("iO0o7");

var $2Aaic = parcelRequire("2Aaic");

var $7UE0W = parcelRequire("7UE0W");

var $eIAC2 = parcelRequire("eIAC2");

var $bfr79 = parcelRequire("bfr79");

var $QaiZw = parcelRequire("QaiZw");

var $kPAiw = parcelRequire("kPAiw");

var $5llKW = parcelRequire("5llKW");

var $jBoMs = parcelRequire("jBoMs");
/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $583944b926d997b7$var$MAX_RESOLVE_DELAY = 40;
class $583944b926d997b7$export$b9855e2a7dee3dd2 extends (0, $5llKW.WithPromise) {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", keyframes: keyframes, name: name, motionValue: motionValue, element: element, ...options }){
        super();
        /**
         * Bound to support return animation.stop pattern
         */ this.stop = ()=>{
            if (this._animation) {
                this._animation.stop();
                this.stopTimeline?.();
            }
            this.keyframeResolver?.cancel();
        };
        this.createdAt = (0, $iO0o7.time).now();
        const optionsWithDefaults = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            name: name,
            motionValue: motionValue,
            element: element,
            ...options
        };
        const KeyframeResolver$1 = element?.KeyframeResolver || (0, $eIAC2.KeyframeResolver);
        this.keyframeResolver = new KeyframeResolver$1(keyframes, (resolvedKeyframes, finalKeyframe, forced)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe, optionsWithDefaults, !forced), name, motionValue, element);
        this.keyframeResolver?.scheduleResolve();
    }
    onKeyframesResolved(keyframes, finalKeyframe, options, sync) {
        this.keyframeResolver = undefined;
        const { name: name, type: type, velocity: velocity, delay: delay, isHandoff: isHandoff, onUpdate: onUpdate } = options;
        this.resolvedAt = (0, $iO0o7.time).now();
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ let canAnimateValue = true;
        if (!(0, $QaiZw.canAnimate)(keyframes, name, type, velocity)) {
            canAnimateValue = false;
            if ((0, $9zuZQ.MotionGlobalConfig).instantAnimations || !delay) onUpdate?.((0, $7UE0W.getFinalKeyframe)(keyframes, options, finalKeyframe));
            keyframes[0] = keyframes[keyframes.length - 1];
            (0, $kPAiw.makeAnimationInstant)(options);
            options.repeat = 0;
        }
        /**
         * Resolve startTime for the animation.
         *
         * This method uses the createdAt and resolvedAt to calculate the
         * animation startTime. *Ideally*, we would use the createdAt time as t=0
         * as the following frame would then be the first frame of the animation in
         * progress, which would feel snappier.
         *
         * However, if there's a delay (main thread work) between the creation of
         * the animation and the first committed frame, we prefer to use resolvedAt
         * to avoid a sudden jump into the animation.
         */ const startTime = sync ? !this.resolvedAt ? this.createdAt : this.resolvedAt - this.createdAt > $583944b926d997b7$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt : undefined;
        const resolvedOptions = {
            startTime: startTime,
            finalKeyframe: finalKeyframe,
            ...options,
            keyframes: keyframes
        };
        /**
         * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         *
         * Also skip WAAPI when keyframes aren't animatable, as the resolved
         * values may not be valid CSS and would trigger browser warnings.
         */ const useWaapi = canAnimateValue && !isHandoff && (0, $jBoMs.supportsBrowserAnimation)(resolvedOptions);
        const element = resolvedOptions.motionValue?.owner?.current;
        let animation;
        if (useWaapi) try {
            animation = new (0, $bfr79.NativeAnimationExtended)({
                ...resolvedOptions,
                element: element
            });
        } catch  {
            animation = new (0, $2Aaic.JSAnimation)(resolvedOptions);
        }
        else animation = new (0, $2Aaic.JSAnimation)(resolvedOptions);
        animation.finished.then(()=>{
            this.notifyFinished();
        }).catch((0, $7aJzA.noop));
        if (this.pendingTimeline) {
            this.stopTimeline = animation.attachTimeline(this.pendingTimeline);
            this.pendingTimeline = undefined;
        }
        this._animation = animation;
    }
    get finished() {
        if (!this._animation) return this._finished;
        else return this.animation.finished;
    }
    then(onResolve, _onReject) {
        return this.finished.finally(onResolve).then(()=>{});
    }
    get animation() {
        if (!this._animation) {
            this.keyframeResolver?.resume();
            (0, $eIAC2.flushKeyframeResolvers)();
        }
        return this._animation;
    }
    get duration() {
        return this.animation.duration;
    }
    get iterationDuration() {
        return this.animation.iterationDuration;
    }
    get time() {
        return this.animation.time;
    }
    set time(newTime) {
        this.animation.time = newTime;
    }
    get speed() {
        return this.animation.speed;
    }
    get state() {
        return this.animation.state;
    }
    set speed(newSpeed) {
        this.animation.speed = newSpeed;
    }
    get startTime() {
        return this.animation.startTime;
    }
    attachTimeline(timeline) {
        if (this._animation) this.stopTimeline = this.animation.attachTimeline(timeline);
        else this.pendingTimeline = timeline;
        return ()=>this.stop();
    }
    play() {
        this.animation.play();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.complete();
    }
    cancel() {
        if (this._animation) this.animation.cancel();
        this.keyframeResolver?.cancel();
    }
}

});
parcelRegister("2Aaic", function(module, exports) {

$parcel$export(module.exports, "JSAnimation", function () { return $66d5e49763a7f8a0$export$3394f837405475c7; });

var $iH3lf = parcelRequire("iH3lf");
var $jzxS7 = parcelRequire("jzxS7");
var $1cyKd = parcelRequire("1cyKd");

var $iO0o7 = parcelRequire("iO0o7");

var $i3Gyx = parcelRequire("i3Gyx");

var $iAHkP = parcelRequire("iAHkP");

var $dmffy = parcelRequire("dmffy");

var $kzQQD = parcelRequire("kzQQD");

var $fCnvu = parcelRequire("fCnvu");

var $9lf10 = parcelRequire("9lf10");

var $7UE0W = parcelRequire("7UE0W");

var $d8JZP = parcelRequire("d8JZP");

var $5llKW = parcelRequire("5llKW");
const $66d5e49763a7f8a0$var$percentToProgress = (percent)=>percent / 100;
class $66d5e49763a7f8a0$export$3394f837405475c7 extends (0, $5llKW.WithPromise) {
    constructor(options){
        super();
        this.state = "idle";
        this.startTime = null;
        this.isStopped = false;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * Reusable state object for the delay phase to avoid
         * allocating a new object every frame.
         */ this.delayState = {
            done: false,
            value: undefined
        };
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            const { motionValue: motionValue } = this.options;
            if (motionValue && motionValue.updatedAt !== (0, $iO0o7.time).now()) this.tick((0, $iO0o7.time).now());
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            this.options.onStop?.();
        };
        this.options = options;
        this.initAnimation();
        this.play();
        if (options.autoplay === false) this.pause();
    }
    initAnimation() {
        const { options: options } = this;
        (0, $d8JZP.replaceTransitionType)(options);
        const { type: type = (0, $kzQQD.keyframes), repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = options;
        let { keyframes: keyframes$1 } = options;
        const generatorFactory = type || (0, $kzQQD.keyframes);
        if (generatorFactory !== (0, $kzQQD.keyframes) && typeof keyframes$1[0] !== "number") {
            this.mixKeyframes = (0, $1cyKd.pipe)($66d5e49763a7f8a0$var$percentToProgress, (0, $i3Gyx.mix)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") this.mirroredGenerator = generatorFactory({
            ...options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $fCnvu.calcGeneratorDuration)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        this.calculatedDuration = calculatedDuration;
        this.resolvedDuration = calculatedDuration + repeatDelay;
        this.totalDuration = this.resolvedDuration * (repeat + 1) - repeatDelay;
        this.generator = generator;
    }
    updateTime(timestamp) {
        const animationTime = Math.round(timestamp - this.startTime) * this.playbackSpeed;
        // Update currentTime
        if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = animationTime;
    }
    tick(timestamp, sample = false) {
        const { generator: generator, totalDuration: totalDuration, mixKeyframes: mixKeyframes, mirroredGenerator: mirroredGenerator, resolvedDuration: resolvedDuration, calculatedDuration: calculatedDuration } = this;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay = 0, keyframes: keyframes, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, type: type, onUpdate: onUpdate, finalKeyframe: finalKeyframe } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        if (sample) this.currentTime = timestamp;
        else this.updateTime(timestamp);
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.playbackSpeed >= 0 ? 1 : -1);
        const isInDelayPhase = this.playbackSpeed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $iH3lf.clamp)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ let state;
        if (isInDelayPhase) {
            this.delayState.value = keyframes[0];
            state = this.delayState;
        } else state = frameGenerator.next(elapsed);
        if (mixKeyframes && !isInDelayPhase) state.value = mixKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.playbackSpeed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        // TODO: The exception for inertia could be cleaner here
        if (isAnimationFinished && type !== (0, $dmffy.inertia)) state.value = (0, $7UE0W.getFinalKeyframe)(keyframes, this.options, finalKeyframe, this.speed);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.finished.then(resolve, reject);
    }
    get duration() {
        return (0, $jzxS7.millisecondsToSeconds)(this.calculatedDuration);
    }
    get iterationDuration() {
        const { delay: delay = 0 } = this.options || {};
        return this.duration + (0, $jzxS7.millisecondsToSeconds)(delay);
    }
    get time() {
        return (0, $jzxS7.millisecondsToSeconds)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $jzxS7.secondsToMilliseconds)(newTime);
        this.currentTime = newTime;
        if (this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.playbackSpeed;
        if (this.driver) this.driver.start(false);
        else {
            this.startTime = 0;
            this.state = "paused";
            this.holdTime = newTime;
            this.tick(newTime);
        }
    }
    /**
     * Returns the generator's velocity at the current time in units/second.
     * Uses the analytical derivative when available (springs), avoiding
     * the MotionValue's frame-dependent velocity estimation.
     */ getGeneratorVelocity() {
        const t = this.currentTime;
        if (t <= 0) return this.options.velocity || 0;
        if (this.generator.velocity) return this.generator.velocity(t);
        // Fallback: finite difference
        const current = this.generator.next(t).value;
        return (0, $9lf10.getGeneratorVelocity)((s)=>this.generator.next(s).value, t, current);
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        if (hasChanged && this.driver) this.updateTime((0, $iO0o7.time).now());
        this.playbackSpeed = newSpeed;
        if (hasChanged && this.driver) this.time = (0, $jzxS7.millisecondsToSeconds)(this.currentTime);
    }
    play() {
        if (this.isStopped) return;
        const { driver: driver = (0, $iAHkP.frameloopDriver), startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        this.options.onPlay?.();
        const now = this.driver.now();
        if (this.state === "finished") {
            this.updateFinished();
            this.startTime = now;
        } else if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime ?? now;
        if (this.state === "finished" && this.speed < 0) this.startTime += this.calculatedDuration;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        this.state = "paused";
        this.updateTime((0, $iO0o7.time).now());
        this.holdTime = this.currentTime;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.notifyFinished();
        this.teardown();
        this.state = "finished";
        this.options.onComplete?.();
    }
    cancel() {
        this.holdTime = null;
        this.startTime = 0;
        this.tick(0);
        this.teardown();
        this.options.onCancel?.();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.startTime = this.holdTime = null;
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(sampleTime) {
        this.startTime = 0;
        return this.tick(sampleTime, true);
    }
    attachTimeline(timeline) {
        if (this.options.allowFlatten) {
            this.options.type = "keyframes";
            this.options.ease = "linear";
            this.initAnimation();
        }
        this.driver?.stop();
        return timeline.observe(this);
    }
}
// Legacy function support
function $66d5e49763a7f8a0$export$ee9b76de7353d815(options) {
    return new $66d5e49763a7f8a0$export$3394f837405475c7(options);
}

});
parcelRegister("1cyKd", function(module, exports) {

$parcel$export(module.exports, "pipe", function () { return $113d54600cb8d2d0$export$a4627e546088548d; });
/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $113d54600cb8d2d0$export$a4627e546088548d = (...transformers)=>transformers.reduce((a, b)=>(v)=>b(a(v)));

});

parcelRegister("i3Gyx", function(module, exports) {

$parcel$export(module.exports, "mix", function () { return $a5735c6e2225d49f$export$2c9e8a9632a706b2; });

var $jYEAe = parcelRequire("jYEAe");

var $e9BqC = parcelRequire("e9BqC");
function $a5735c6e2225d49f$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $e9BqC.mixNumber)(from, to, p);
    const mixer = (0, $jYEAe.getMixer)(from);
    return mixer(from, to);
}

});
parcelRegister("jYEAe", function(module, exports) {

$parcel$export(module.exports, "getMixer", function () { return $864ea16ae0114b26$export$36ec24672cd098e0; });

var $1cyKd = parcelRequire("1cyKd");
var $jEeLK = parcelRequire("jEeLK");

var $fop0M = parcelRequire("fop0M");

var $5gJ5G = parcelRequire("5gJ5G");

var $FH6ft = parcelRequire("FH6ft");

var $i4293 = parcelRequire("i4293");

var $6EUbJ = parcelRequire("6EUbJ");

var $e9BqC = parcelRequire("e9BqC");

var $7Zpjt = parcelRequire("7Zpjt");
function $864ea16ae0114b26$var$mixNumber(a, b) {
    return (p)=>(0, $e9BqC.mixNumber)(a, b, p);
}
function $864ea16ae0114b26$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $864ea16ae0114b26$var$mixNumber;
    else if (typeof a === "string") return (0, $fop0M.isCSSVariableToken)(a) ? (0, $6EUbJ.mixImmediate) : (0, $5gJ5G.color).test(a) ? (0, $i4293.mixColor) : $864ea16ae0114b26$export$65516310a87d8205;
    else if (Array.isArray(a)) return $864ea16ae0114b26$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $5gJ5G.color).test(a) ? (0, $i4293.mixColor) : $864ea16ae0114b26$export$ebc23b6840c51ba1;
    return 0, $6EUbJ.mixImmediate;
}
function $864ea16ae0114b26$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$864ea16ae0114b26$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $864ea16ae0114b26$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $864ea16ae0114b26$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $864ea16ae0114b26$var$matchOrder(origin, target) {
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = origin.values[originIndex] ?? 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $864ea16ae0114b26$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $FH6ft.complex).createTransformer(target);
    const originStats = (0, $FH6ft.analyseComplexValue)(origin);
    const targetStats = (0, $FH6ft.analyseComplexValue)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $7Zpjt.invisibleValues).has(origin) && !targetStats.values.length || (0, $7Zpjt.invisibleValues).has(target) && !originStats.values.length) return (0, $7Zpjt.mixVisibility)(origin, target);
        return (0, $1cyKd.pipe)($864ea16ae0114b26$export$3bbefa2f402845c4($864ea16ae0114b26$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $jEeLK.warning)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different");
        return (0, $6EUbJ.mixImmediate)(origin, target);
    }
};

});
parcelRegister("fop0M", function(module, exports) {

$parcel$export(module.exports, "isCSSVariableName", function () { return $8e08dd08a6f8a76d$export$9de1236619d9e756; });
$parcel$export(module.exports, "isCSSVariableToken", function () { return $8e08dd08a6f8a76d$export$31f9caa2600b5723; });
$parcel$export(module.exports, "containsCSSVariable", function () { return $8e08dd08a6f8a76d$export$df8f90ab5d0b05fa; });
const $8e08dd08a6f8a76d$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $8e08dd08a6f8a76d$export$9de1236619d9e756 = /*@__PURE__*/ $8e08dd08a6f8a76d$var$checkStringStartsWith("--");
const $8e08dd08a6f8a76d$var$startsAsVariableToken = /*@__PURE__*/ $8e08dd08a6f8a76d$var$checkStringStartsWith("var(--");
const $8e08dd08a6f8a76d$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $8e08dd08a6f8a76d$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $8e08dd08a6f8a76d$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $8e08dd08a6f8a76d$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
/**
 * Check if a value contains a CSS variable anywhere (e.g. inside calc()).
 * Unlike isCSSVariableToken which checks if the value IS a var() token,
 * this checks if the value CONTAINS var() somewhere in the string.
 */ function $8e08dd08a6f8a76d$export$df8f90ab5d0b05fa(value) {
    if (typeof value !== "string") return false;
    // Strip comments to avoid false positives
    return value.split("/*")[0].includes("var(--");
}

});

parcelRegister("5gJ5G", function(module, exports) {

$parcel$export(module.exports, "color", function () { return $d252968ea52f42fd$export$35e9368ef982300f; });

var $aK4xz = parcelRequire("aK4xz");

var $fVPhx = parcelRequire("fVPhx");

var $iUhSf = parcelRequire("iUhSf");
const $d252968ea52f42fd$export$35e9368ef982300f = {
    test: (v)=>(0, $iUhSf.rgba).test(v) || (0, $aK4xz.hex).test(v) || (0, $fVPhx.hsla).test(v),
    parse: (v)=>{
        if ((0, $iUhSf.rgba).test(v)) return (0, $iUhSf.rgba).parse(v);
        else if ((0, $fVPhx.hsla).test(v)) return (0, $fVPhx.hsla).parse(v);
        else return (0, $aK4xz.hex).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $iUhSf.rgba).transform(v) : (0, $fVPhx.hsla).transform(v);
    },
    getAnimatableNone: (v)=>{
        const parsed = $d252968ea52f42fd$export$35e9368ef982300f.parse(v);
        parsed.alpha = 0;
        return $d252968ea52f42fd$export$35e9368ef982300f.transform(parsed);
    }
};

});
parcelRegister("aK4xz", function(module, exports) {

$parcel$export(module.exports, "hex", function () { return $90a7f54b29f1453c$export$834dfc94dde4b3d8; });

var $iUhSf = parcelRequire("iUhSf");

var $112ZB = parcelRequire("112ZB");
function $90a7f54b29f1453c$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $90a7f54b29f1453c$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $112ZB.isColorString)("#"),
    parse: $90a7f54b29f1453c$var$parseHex,
    transform: (0, $iUhSf.rgba).transform
};

});
parcelRegister("iUhSf", function(module, exports) {

$parcel$export(module.exports, "rgba", function () { return $ff7a2ec6f726704e$export$4e46ac54fc82cf3b; });

var $iH3lf = parcelRequire("iH3lf");

var $4FpLb = parcelRequire("4FpLb");

var $4nRDO = parcelRequire("4nRDO");

var $112ZB = parcelRequire("112ZB");
const $ff7a2ec6f726704e$var$clampRgbUnit = (v)=>(0, $iH3lf.clamp)(0, 255, v);
const $ff7a2ec6f726704e$export$7a99c86b5b1f4c9e = {
    ...(0, $4FpLb.number),
    transform: (v)=>Math.round($ff7a2ec6f726704e$var$clampRgbUnit(v))
};
const $ff7a2ec6f726704e$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $112ZB.isColorString)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $112ZB.splitColor)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $ff7a2ec6f726704e$export$7a99c86b5b1f4c9e.transform(red) + ", " + $ff7a2ec6f726704e$export$7a99c86b5b1f4c9e.transform(green) + ", " + $ff7a2ec6f726704e$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $4nRDO.sanitize)((0, $4FpLb.alpha).transform(alpha$1)) + ")"
};

});
parcelRegister("4FpLb", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $d1e8a31585ea6048$export$98e628dec113755e; });
$parcel$export(module.exports, "alpha", function () { return $d1e8a31585ea6048$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "scale", function () { return $d1e8a31585ea6048$export$dcdf75081b88279d; });

var $iH3lf = parcelRequire("iH3lf");
const $d1e8a31585ea6048$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $d1e8a31585ea6048$export$58f0f39f63f3cf42 = {
    ...$d1e8a31585ea6048$export$98e628dec113755e,
    transform: (v)=>(0, $iH3lf.clamp)(0, 1, v)
};
const $d1e8a31585ea6048$export$dcdf75081b88279d = {
    ...$d1e8a31585ea6048$export$98e628dec113755e,
    default: 1
};

});

parcelRegister("4nRDO", function(module, exports) {

$parcel$export(module.exports, "sanitize", function () { return $76d9043daec1d091$export$83d2e9e3e4ee39ed; });
// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $76d9043daec1d091$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;

});

parcelRegister("112ZB", function(module, exports) {

$parcel$export(module.exports, "isColorString", function () { return $e8d29973fdcfed04$export$2c8400d58aca05e; });
$parcel$export(module.exports, "splitColor", function () { return $e8d29973fdcfed04$export$73d6f35be992df24; });

var $33GHc = parcelRequire("33GHc");

var $lxwMY = parcelRequire("lxwMY");

var $aevHl = parcelRequire("aevHl");
/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $e8d29973fdcfed04$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $aevHl.singleColorRegex).test(v) && v.startsWith(type) || testProp && !(0, $lxwMY.isNullish)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $e8d29973fdcfed04$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $33GHc.floatRegex));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };

});
parcelRegister("33GHc", function(module, exports) {

$parcel$export(module.exports, "floatRegex", function () { return $8d7fedef37ba0db5$export$2444ca58c08448e4; });
const $8d7fedef37ba0db5$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;

});

parcelRegister("lxwMY", function(module, exports) {

$parcel$export(module.exports, "isNullish", function () { return $b64c9e190d2d6cd7$export$b931b78cbb3caf86; });
function $b64c9e190d2d6cd7$export$b931b78cbb3caf86(v) {
    return v == null;
}

});

parcelRegister("aevHl", function(module, exports) {

$parcel$export(module.exports, "singleColorRegex", function () { return $9148c009abbebc0f$export$ed808ff6ecd39e8d; });
const $9148c009abbebc0f$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;

});




parcelRegister("fVPhx", function(module, exports) {

$parcel$export(module.exports, "hsla", function () { return $f6f2a31cd5829bc5$export$810b04175080204c; });

var $4FpLb = parcelRequire("4FpLb");

var $8ID0m = parcelRequire("8ID0m");

var $4nRDO = parcelRequire("4nRDO");

var $112ZB = parcelRequire("112ZB");
const $f6f2a31cd5829bc5$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $112ZB.isColorString)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $112ZB.splitColor)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $8ID0m.percent).transform((0, $4nRDO.sanitize)(saturation)) + ", " + (0, $8ID0m.percent).transform((0, $4nRDO.sanitize)(lightness)) + ", " + (0, $4nRDO.sanitize)((0, $4FpLb.alpha).transform(alpha$1)) + ")";
    }
};

});
parcelRegister("8ID0m", function(module, exports) {

$parcel$export(module.exports, "degrees", function () { return $f1a72de1b348da89$export$41fc368e1a942b97; });
$parcel$export(module.exports, "percent", function () { return $f1a72de1b348da89$export$626336c2cd4b14de; });
$parcel$export(module.exports, "px", function () { return $f1a72de1b348da89$export$91c0eda1d06bf008; });
$parcel$export(module.exports, "vh", function () { return $f1a72de1b348da89$export$f91e8c45a95a32f2; });
$parcel$export(module.exports, "vw", function () { return $f1a72de1b348da89$export$aed3d7b7d206c196; });
$parcel$export(module.exports, "progressPercentage", function () { return $f1a72de1b348da89$export$44e2e1705876d7ed; });
/*#__NO_SIDE_EFFECTS__*/ const $f1a72de1b348da89$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $f1a72de1b348da89$export$41fc368e1a942b97 = /*@__PURE__*/ $f1a72de1b348da89$var$createUnitType("deg");
const $f1a72de1b348da89$export$626336c2cd4b14de = /*@__PURE__*/ $f1a72de1b348da89$var$createUnitType("%");
const $f1a72de1b348da89$export$91c0eda1d06bf008 = /*@__PURE__*/ $f1a72de1b348da89$var$createUnitType("px");
const $f1a72de1b348da89$export$f91e8c45a95a32f2 = /*@__PURE__*/ $f1a72de1b348da89$var$createUnitType("vh");
const $f1a72de1b348da89$export$aed3d7b7d206c196 = /*@__PURE__*/ $f1a72de1b348da89$var$createUnitType("vw");
const $f1a72de1b348da89$export$44e2e1705876d7ed = /*@__PURE__*/ (()=>({
        ...$f1a72de1b348da89$export$626336c2cd4b14de,
        parse: (v)=>$f1a72de1b348da89$export$626336c2cd4b14de.parse(v) / 100,
        transform: (v)=>$f1a72de1b348da89$export$626336c2cd4b14de.transform(v * 100)
    }))();

});



parcelRegister("FH6ft", function(module, exports) {

$parcel$export(module.exports, "analyseComplexValue", function () { return $ce3767268d4e9ade$export$b61fc7c44bf646d5; });
$parcel$export(module.exports, "complex", function () { return $ce3767268d4e9ade$export$83a0e34f1302825b; });

var $5gJ5G = parcelRequire("5gJ5G");

var $gIwY8 = parcelRequire("gIwY8");

var $33GHc = parcelRequire("33GHc");

var $4nRDO = parcelRequire("4nRDO");
function $ce3767268d4e9ade$var$test(v) {
    return isNaN(v) && typeof v === "string" && (v.match((0, $33GHc.floatRegex))?.length || 0) + (v.match((0, $gIwY8.colorRegex))?.length || 0) > 0;
}
const $ce3767268d4e9ade$var$NUMBER_TOKEN = "number";
const $ce3767268d4e9ade$var$COLOR_TOKEN = "color";
const $ce3767268d4e9ade$var$VAR_TOKEN = "var";
const $ce3767268d4e9ade$var$VAR_FUNCTION_TOKEN = "var(";
const $ce3767268d4e9ade$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $ce3767268d4e9ade$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $ce3767268d4e9ade$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($ce3767268d4e9ade$var$complexRegex, (parsedValue)=>{
        if ((0, $5gJ5G.color).test(parsedValue)) {
            indexes.color.push(i);
            types.push($ce3767268d4e9ade$var$COLOR_TOKEN);
            values.push((0, $5gJ5G.color).parse(parsedValue));
        } else if (parsedValue.startsWith($ce3767268d4e9ade$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($ce3767268d4e9ade$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($ce3767268d4e9ade$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $ce3767268d4e9ade$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($ce3767268d4e9ade$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $ce3767268d4e9ade$var$parseComplexValue(v) {
    return $ce3767268d4e9ade$export$b61fc7c44bf646d5(v).values;
}
function $ce3767268d4e9ade$var$buildTransformer({ split: split, types: types }) {
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $ce3767268d4e9ade$var$NUMBER_TOKEN) output += (0, $4nRDO.sanitize)(v[i]);
                else if (type === $ce3767268d4e9ade$var$COLOR_TOKEN) output += (0, $5gJ5G.color).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
function $ce3767268d4e9ade$var$createTransformer(source) {
    return $ce3767268d4e9ade$var$buildTransformer($ce3767268d4e9ade$export$b61fc7c44bf646d5(source));
}
const $ce3767268d4e9ade$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : (0, $5gJ5G.color).test(v) ? (0, $5gJ5G.color).getAnimatableNone(v) : v;
/**
 * Convert a parsed value to its zero equivalent, but preserve numbers
 * that act as divisors in CSS calc() expressions.
 *
 * analyseComplexValue extracts numbers from CSS strings and puts the
 * surrounding text into a `split` template array. For example:
 *   "calc(var(--gap) / 5)"  →  values: [var(--gap), 5]
 *                               split:  ["calc(", " / ", ")"]
 *
 * When building a zero-equivalent for animation, naively zeroing all
 * numbers turns the divisor into 0 → "calc(var(--gap) / 0)" → NaN.
 * We detect this by checking whether the text preceding a number
 * (split[i]) ends with "/" — the CSS calc division operator.
 */ const $ce3767268d4e9ade$var$convertToZero = (value, splitBefore)=>{
    if (typeof value === "number") return splitBefore?.trim().endsWith("/") ? value : 0;
    return $ce3767268d4e9ade$var$convertNumbersToZero(value);
};
function $ce3767268d4e9ade$var$getAnimatableNone(v) {
    const info = $ce3767268d4e9ade$export$b61fc7c44bf646d5(v);
    const transformer = $ce3767268d4e9ade$var$buildTransformer(info);
    return transformer(info.values.map((value, i)=>$ce3767268d4e9ade$var$convertToZero(value, info.split[i])));
}
const $ce3767268d4e9ade$export$83a0e34f1302825b = {
    test: $ce3767268d4e9ade$var$test,
    parse: $ce3767268d4e9ade$var$parseComplexValue,
    createTransformer: $ce3767268d4e9ade$var$createTransformer,
    getAnimatableNone: $ce3767268d4e9ade$var$getAnimatableNone
};

});
parcelRegister("gIwY8", function(module, exports) {

$parcel$export(module.exports, "colorRegex", function () { return $391b60cd5158e163$export$740b69c5fad25dba; });
const $391b60cd5158e163$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;

});


parcelRegister("i4293", function(module, exports) {

$parcel$export(module.exports, "mixColor", function () { return $08f990a3e51e69f3$export$51e568cf5c039bac; });

var $jEeLK = parcelRequire("jEeLK");

var $aK4xz = parcelRequire("aK4xz");

var $fVPhx = parcelRequire("fVPhx");

var $2HTXG = parcelRequire("2HTXG");

var $iUhSf = parcelRequire("iUhSf");

var $6EUbJ = parcelRequire("6EUbJ");

var $e9BqC = parcelRequire("e9BqC");
// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $08f990a3e51e69f3$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $08f990a3e51e69f3$var$colorTypes = [
    (0, $aK4xz.hex),
    (0, $iUhSf.rgba),
    (0, $fVPhx.hsla)
];
const $08f990a3e51e69f3$var$getColorType = (v)=>$08f990a3e51e69f3$var$colorTypes.find((type)=>type.test(v));
function $08f990a3e51e69f3$var$asRGBA(color) {
    const type = $08f990a3e51e69f3$var$getColorType(color);
    (0, $jEeLK.warning)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable");
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $fVPhx.hsla)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $2HTXG.hslaToRgba)(model);
    return model;
}
const $08f990a3e51e69f3$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $08f990a3e51e69f3$var$asRGBA(from);
    const toRGBA = $08f990a3e51e69f3$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $6EUbJ.mixImmediate)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $08f990a3e51e69f3$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $08f990a3e51e69f3$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $08f990a3e51e69f3$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $e9BqC.mixNumber)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $iUhSf.rgba).transform(blended);
    };
};

});
parcelRegister("2HTXG", function(module, exports) {

$parcel$export(module.exports, "hslaToRgba", function () { return $a395f4e8a86492ea$export$6ae64dbcd6bfc33e; });
// Adapted from https://gist.github.com/mjackson/5311256
function $a395f4e8a86492ea$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $a395f4e8a86492ea$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $a395f4e8a86492ea$var$hueToRgb(p, q, hue + 1 / 3);
        green = $a395f4e8a86492ea$var$hueToRgb(p, q, hue);
        blue = $a395f4e8a86492ea$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}

});

parcelRegister("6EUbJ", function(module, exports) {

$parcel$export(module.exports, "mixImmediate", function () { return $e493443a4fa45880$export$a6f92d4bae65c0f1; });
function $e493443a4fa45880$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}

});


parcelRegister("7Zpjt", function(module, exports) {

$parcel$export(module.exports, "invisibleValues", function () { return $21b14ab67cf766da$export$e5a55ae567dd4ac7; });
$parcel$export(module.exports, "mixVisibility", function () { return $21b14ab67cf766da$export$fed62ccc3fb1a568; });
const $21b14ab67cf766da$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $21b14ab67cf766da$export$fed62ccc3fb1a568(origin, target) {
    if ($21b14ab67cf766da$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}

});



parcelRegister("iAHkP", function(module, exports) {

$parcel$export(module.exports, "frameloopDriver", function () { return $72b107753e53f4eb$export$c1033964b5ad7fef; });

var $iO0o7 = parcelRequire("iO0o7");

var $ibWTn = parcelRequire("ibWTn");
const $72b107753e53f4eb$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: (keepAlive = true)=>(0, $ibWTn.frame).update(passTimestamp, keepAlive),
        stop: ()=>(0, $ibWTn.cancelFrame)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $ibWTn.frameData).isProcessing ? (0, $ibWTn.frameData).timestamp : (0, $iO0o7.time).now()
    };
};

});

parcelRegister("dmffy", function(module, exports) {

$parcel$export(module.exports, "inertia", function () { return $32e0d307ae2d0987$export$ee3ff3a17106998; });

var $479nq = parcelRequire("479nq");

var $9lf10 = parcelRequire("9lf10");
function $32e0d307ae2d0987$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $479nq.spring)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $9lf10.getGeneratorVelocity)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}

});
parcelRegister("9lf10", function(module, exports) {

$parcel$export(module.exports, "getGeneratorVelocity", function () { return $7ca1f8fd8c1eaa05$export$279c5e002bb29070; });

var $66yMJ = parcelRequire("66yMJ");
const $7ca1f8fd8c1eaa05$var$velocitySampleDuration = 5; // ms
function $7ca1f8fd8c1eaa05$export$279c5e002bb29070(resolveValue, t, current) {
    const prevT = Math.max(t - $7ca1f8fd8c1eaa05$var$velocitySampleDuration, 0);
    return (0, $66yMJ.velocityPerSecond)(current - resolveValue(prevT), t - prevT);
}

});


parcelRegister("kzQQD", function(module, exports) {

$parcel$export(module.exports, "keyframes", function () { return $01e9914588b77db2$export$d25ddfdf17c3ad3e; });

var $hqssh = parcelRequire("hqssh");
var $iGiEy = parcelRequire("iGiEy");
var $atBWw = parcelRequire("atBWw");

var $8IX4e = parcelRequire("8IX4e");

var $ggba5 = parcelRequire("ggba5");

var $3vZPP = parcelRequire("3vZPP");
function $01e9914588b77db2$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $hqssh.easeInOut)).splice(0, values.length - 1);
}
function $01e9914588b77db2$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $atBWw.isEasingArray)(ease) ? ease.map((0, $iGiEy.easingDefinitionToFunction)) : (0, $iGiEy.easingDefinitionToFunction)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $3vZPP.convertOffsetToTimes)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $ggba5.defaultOffset)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $8IX4e.interpolate)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $01e9914588b77db2$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}

});
parcelRegister("hqssh", function(module, exports) {

$parcel$export(module.exports, "easeIn", function () { return $0237323c43a18099$export$929e5a82286172a6; });
$parcel$export(module.exports, "easeOut", function () { return $0237323c43a18099$export$57636bb43b1ccbb0; });
$parcel$export(module.exports, "easeInOut", function () { return $0237323c43a18099$export$c07234257a03d5e9; });

var $aCaSz = parcelRequire("aCaSz");
const $0237323c43a18099$export$929e5a82286172a6 = /*@__PURE__*/ (0, $aCaSz.cubicBezier)(0.42, 0, 1, 1);
const $0237323c43a18099$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $aCaSz.cubicBezier)(0, 0, 0.58, 1);
const $0237323c43a18099$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $aCaSz.cubicBezier)(0.42, 0, 0.58, 1);

});
parcelRegister("aCaSz", function(module, exports) {

$parcel$export(module.exports, "cubicBezier", function () { return $c1fbb59bb1e3e7b4$export$2c575fa1d20488bd; });

var $7aJzA = parcelRequire("7aJzA");
/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticeably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $c1fbb59bb1e3e7b4$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $c1fbb59bb1e3e7b4$var$subdivisionPrecision = 0.0000001;
const $c1fbb59bb1e3e7b4$var$subdivisionMaxIterations = 12;
function $c1fbb59bb1e3e7b4$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $c1fbb59bb1e3e7b4$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $c1fbb59bb1e3e7b4$var$subdivisionPrecision && ++i < $c1fbb59bb1e3e7b4$var$subdivisionMaxIterations);
    return currentT;
}
/*#__NO_SIDE_EFFECTS__*/ function $c1fbb59bb1e3e7b4$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $7aJzA.noop;
    const getTForX = (aX)=>$c1fbb59bb1e3e7b4$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $c1fbb59bb1e3e7b4$var$calcBezier(getTForX(t), mY1, mY2);
}

});


parcelRegister("iGiEy", function(module, exports) {

$parcel$export(module.exports, "easingDefinitionToFunction", function () { return $33255b886b199e10$export$ef97fe084f156ca4; });

var $jEeLK = parcelRequire("jEeLK");

var $7aJzA = parcelRequire("7aJzA");

var $gAxQn = parcelRequire("gAxQn");

var $7qoQj = parcelRequire("7qoQj");

var $g82qV = parcelRequire("g82qV");

var $aCaSz = parcelRequire("aCaSz");

var $hqssh = parcelRequire("hqssh");

var $ba9E4 = parcelRequire("ba9E4");
const $33255b886b199e10$var$easingLookup = {
    linear: (0, $7aJzA.noop),
    easeIn: $hqssh.easeIn,
    easeInOut: $hqssh.easeInOut,
    easeOut: $hqssh.easeOut,
    circIn: $g82qV.circIn,
    circInOut: $g82qV.circInOut,
    circOut: $g82qV.circOut,
    backIn: $7qoQj.backIn,
    backInOut: $7qoQj.backInOut,
    backOut: $7qoQj.backOut,
    anticipate: $gAxQn.anticipate
};
const $33255b886b199e10$var$isValidEasing = (easing)=>{
    return typeof easing === "string";
};
const $33255b886b199e10$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $ba9E4.isBezierDefinition)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $jEeLK.invariant)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`, "cubic-bezier-length");
        const [x1, y1, x2, y2] = definition;
        return (0, $aCaSz.cubicBezier)(x1, y1, x2, y2);
    } else if ($33255b886b199e10$var$isValidEasing(definition)) {
        // Else lookup from table
        (0, $jEeLK.invariant)($33255b886b199e10$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`, "invalid-easing-type");
        return $33255b886b199e10$var$easingLookup[definition];
    }
    return definition;
};

});
parcelRegister("gAxQn", function(module, exports) {

$parcel$export(module.exports, "anticipate", function () { return $3364581cfa525123$export$6b0af63b873d419e; });

var $7qoQj = parcelRequire("7qoQj");
const $3364581cfa525123$export$6b0af63b873d419e = (p)=>p >= 1 ? 1 : (p *= 2) < 1 ? 0.5 * (0, $7qoQj.backIn)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));

});
parcelRegister("7qoQj", function(module, exports) {

$parcel$export(module.exports, "backOut", function () { return $99127f009a705dfc$export$77edfce482316a60; });
$parcel$export(module.exports, "backIn", function () { return $99127f009a705dfc$export$b01116c84cdfe1a2; });
$parcel$export(module.exports, "backInOut", function () { return $99127f009a705dfc$export$ddc5fd596f6c71b2; });

var $aCaSz = parcelRequire("aCaSz");

var $iJaK5 = parcelRequire("iJaK5");

var $djbVF = parcelRequire("djbVF");
const $99127f009a705dfc$export$77edfce482316a60 = /*@__PURE__*/ (0, $aCaSz.cubicBezier)(0.33, 1.53, 0.69, 0.99);
const $99127f009a705dfc$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $djbVF.reverseEasing)($99127f009a705dfc$export$77edfce482316a60);
const $99127f009a705dfc$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $iJaK5.mirrorEasing)($99127f009a705dfc$export$b01116c84cdfe1a2);

});
parcelRegister("iJaK5", function(module, exports) {

$parcel$export(module.exports, "mirrorEasing", function () { return $139640f8594c998b$export$f946554fb8aeaf0d; });
// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
/*#__NO_SIDE_EFFECTS__*/ const $139640f8594c998b$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;

});



parcelRegister("g82qV", function(module, exports) {

$parcel$export(module.exports, "circIn", function () { return $e4064fe071cf16bf$export$e444123e42d03385; });
$parcel$export(module.exports, "circOut", function () { return $e4064fe071cf16bf$export$c8d67a19199d1a50; });
$parcel$export(module.exports, "circInOut", function () { return $e4064fe071cf16bf$export$30d3455eee55bed5; });

var $iJaK5 = parcelRequire("iJaK5");

var $djbVF = parcelRequire("djbVF");
const $e4064fe071cf16bf$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $e4064fe071cf16bf$export$c8d67a19199d1a50 = (0, $djbVF.reverseEasing)($e4064fe071cf16bf$export$e444123e42d03385);
const $e4064fe071cf16bf$export$30d3455eee55bed5 = (0, $iJaK5.mirrorEasing)($e4064fe071cf16bf$export$e444123e42d03385);

});

parcelRegister("ba9E4", function(module, exports) {

$parcel$export(module.exports, "isBezierDefinition", function () { return $09983ccc000b48c8$export$ff43f99925d7366b; });
/*#__NO_SIDE_EFFECTS__*/ const $09983ccc000b48c8$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";

});


parcelRegister("8IX4e", function(module, exports) {

$parcel$export(module.exports, "interpolate", function () { return $d37269c08d34236a$export$89e29e4ab65e70a9; });

var $iH3lf = parcelRequire("iH3lf");
var $jEeLK = parcelRequire("jEeLK");
var $9zuZQ = parcelRequire("9zuZQ");
var $7aJzA = parcelRequire("7aJzA");
var $1cyKd = parcelRequire("1cyKd");
var $zbDlb = parcelRequire("zbDlb");

var $i3Gyx = parcelRequire("i3Gyx");
function $d37269c08d34236a$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $9zuZQ.MotionGlobalConfig).mix || (0, $i3Gyx.mix);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $7aJzA.noop) : ease;
            mixer = (0, $1cyKd.pipe)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revisit this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $d37269c08d34236a$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $jEeLK.invariant)(inputLength === output.length, "Both input and output ranges must be the same length", "range-length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && output[0] === output[1]) return ()=>output[1];
    const isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $d37269c08d34236a$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        if (isZeroDeltaRange && v < input[0]) return output[0];
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $zbDlb.progress)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $iH3lf.clamp)(input[0], input[inputLength - 1], v)) : interpolator;
}

});

parcelRegister("3vZPP", function(module, exports) {

$parcel$export(module.exports, "convertOffsetToTimes", function () { return $7d2ae0a920715a8d$export$2a91b4e3a4539316; });
function $7d2ae0a920715a8d$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}

});


parcelRegister("7UE0W", function(module, exports) {

$parcel$export(module.exports, "getFinalKeyframe", function () { return $fc831f8861054717$export$14de59408fad90b; });
const $fc831f8861054717$var$isNotNull = (value)=>value !== null;
function $fc831f8861054717$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe, speed = 1) {
    const resolvedKeyframes = keyframes.filter($fc831f8861054717$var$isNotNull);
    const useFirstKeyframe = speed < 0 || repeat && repeatType !== "loop" && repeat % 2 === 1;
    const index = useFirstKeyframe ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}

});

parcelRegister("d8JZP", function(module, exports) {

$parcel$export(module.exports, "replaceTransitionType", function () { return $8edc467b0ada66ea$export$98db6ef1242dfa2; });

var $dmffy = parcelRequire("dmffy");

var $kzQQD = parcelRequire("kzQQD");

var $479nq = parcelRequire("479nq");
const $8edc467b0ada66ea$var$transitionTypeMap = {
    decay: (0, $dmffy.inertia),
    inertia: $dmffy.inertia,
    tween: (0, $kzQQD.keyframes),
    keyframes: (0, $kzQQD.keyframes),
    spring: $479nq.spring
};
function $8edc467b0ada66ea$export$98db6ef1242dfa2(transition) {
    if (typeof transition.type === "string") transition.type = $8edc467b0ada66ea$var$transitionTypeMap[transition.type];
}

});

parcelRegister("5llKW", function(module, exports) {

$parcel$export(module.exports, "WithPromise", function () { return $6940fcbd8d4ca66f$export$655db786091c33e0; });
class $6940fcbd8d4ca66f$export$655db786091c33e0 {
    constructor(){
        this.updateFinished();
    }
    get finished() {
        return this._finished;
    }
    updateFinished() {
        this._finished = new Promise((resolve)=>{
            this.resolve = resolve;
        });
    }
    notifyFinished() {
        this.resolve();
    }
    /**
     * Allows the animation to be awaited.
     *
     * @deprecated Use `finished` instead.
     */ then(onResolve, onReject) {
        return this.finished.then(onResolve, onReject);
    }
}

});


parcelRegister("eIAC2", function(module, exports) {

$parcel$export(module.exports, "flushKeyframeResolvers", function () { return $cf13d99b8a449fd0$export$78b96d2a12593b05; });
$parcel$export(module.exports, "KeyframeResolver", function () { return $cf13d99b8a449fd0$export$74d34ca3182f1750; });

var $elwwa = parcelRequire("elwwa");

var $1Ac5c = parcelRequire("1Ac5c");

var $ibWTn = parcelRequire("ibWTn");
const $cf13d99b8a449fd0$var$toResolve = new Set();
let $cf13d99b8a449fd0$var$isScheduled = false;
let $cf13d99b8a449fd0$var$anyNeedsMeasurement = false;
let $cf13d99b8a449fd0$var$isForced = false;
function $cf13d99b8a449fd0$var$measureAllKeyframes() {
    if ($cf13d99b8a449fd0$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($cf13d99b8a449fd0$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $1Ac5c.removeNonTranslationalTransform)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                element.getValue(key)?.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $cf13d99b8a449fd0$var$anyNeedsMeasurement = false;
    $cf13d99b8a449fd0$var$isScheduled = false;
    $cf13d99b8a449fd0$var$toResolve.forEach((resolver)=>resolver.complete($cf13d99b8a449fd0$var$isForced));
    $cf13d99b8a449fd0$var$toResolve.clear();
}
function $cf13d99b8a449fd0$var$readAllKeyframes() {
    $cf13d99b8a449fd0$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $cf13d99b8a449fd0$var$anyNeedsMeasurement = true;
    });
}
function $cf13d99b8a449fd0$export$78b96d2a12593b05() {
    $cf13d99b8a449fd0$var$isForced = true;
    $cf13d99b8a449fd0$var$readAllKeyframes();
    $cf13d99b8a449fd0$var$measureAllKeyframes();
    $cf13d99b8a449fd0$var$isForced = false;
}
class $cf13d99b8a449fd0$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        this.state = "pending";
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.state = "scheduled";
        if (this.isAsync) {
            $cf13d99b8a449fd0$var$toResolve.add(this);
            if (!$cf13d99b8a449fd0$var$isScheduled) {
                $cf13d99b8a449fd0$var$isScheduled = true;
                (0, $ibWTn.frame).read($cf13d99b8a449fd0$var$readAllKeyframes);
                (0, $ibWTn.frame).resolveKeyframes($cf13d99b8a449fd0$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        // If initial keyframe is null we need to read it from the DOM
        if (unresolvedKeyframes[0] === null) {
            const currentValue = motionValue?.get();
            // TODO: This doesn't work if the final keyframe is a wildcard
            const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
            if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
            else if (element && name) {
                const valueAsRead = element.readValue(name, finalKeyframe);
                if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
            }
            if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
            if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
        }
        (0, $elwwa.fillWildcards)(unresolvedKeyframes);
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete(isForcedComplete = false) {
        this.state = "complete";
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, isForcedComplete);
        $cf13d99b8a449fd0$var$toResolve.delete(this);
    }
    cancel() {
        if (this.state === "scheduled") {
            $cf13d99b8a449fd0$var$toResolve.delete(this);
            this.state = "pending";
        }
    }
    resume() {
        if (this.state === "pending") this.scheduleResolve();
    }
}

});
parcelRegister("elwwa", function(module, exports) {

$parcel$export(module.exports, "fillWildcards", function () { return $08d1bfadb48645d9$export$5a98a90409277f5a; });
function $08d1bfadb48645d9$export$5a98a90409277f5a(keyframes) {
    for(let i = 1; i < keyframes.length; i++)keyframes[i] ?? (keyframes[i] = keyframes[i - 1]);
}

});

parcelRegister("1Ac5c", function(module, exports) {

$parcel$export(module.exports, "isNumOrPxType", function () { return $8f9fb54630ee1595$export$8e5250d1aa9bf370; });
$parcel$export(module.exports, "removeNonTranslationalTransform", function () { return $8f9fb54630ee1595$export$39d4bc9655f3f632; });
$parcel$export(module.exports, "positionalValues", function () { return $8f9fb54630ee1595$export$781d46a8aa670d52; });

var $eUGDt = parcelRequire("eUGDt");

var $cYSzx = parcelRequire("cYSzx");

var $4FpLb = parcelRequire("4FpLb");

var $8ID0m = parcelRequire("8ID0m");
const $8f9fb54630ee1595$export$8e5250d1aa9bf370 = (v)=>v === (0, $4FpLb.number) || v === (0, $8ID0m.px);
const $8f9fb54630ee1595$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $8f9fb54630ee1595$var$nonTranslationalTransformKeys = (0, $cYSzx.transformPropOrder).filter((key)=>!$8f9fb54630ee1595$var$transformKeys.has(key));
function $8f9fb54630ee1595$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $8f9fb54630ee1595$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $8f9fb54630ee1595$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0", boxSizing: boxSizing })=>{
        const width = x.max - x.min;
        return boxSizing === "border-box" ? width : width - parseFloat(paddingLeft) - parseFloat(paddingRight);
    },
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0", boxSizing: boxSizing })=>{
        const height = y.max - y.min;
        return boxSizing === "border-box" ? height : height - parseFloat(paddingTop) - parseFloat(paddingBottom);
    },
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: (_bbox, { transform: transform })=>(0, $eUGDt.parseValueFromTransform)(transform, "x"),
    y: (_bbox, { transform: transform })=>(0, $eUGDt.parseValueFromTransform)(transform, "y")
};
// Alias translate longform names
$8f9fb54630ee1595$export$781d46a8aa670d52.translateX = $8f9fb54630ee1595$export$781d46a8aa670d52.x;
$8f9fb54630ee1595$export$781d46a8aa670d52.translateY = $8f9fb54630ee1595$export$781d46a8aa670d52.y;

});
parcelRegister("eUGDt", function(module, exports) {

$parcel$export(module.exports, "defaultTransformValue", function () { return $f0207664133f4738$export$1f10c01143b9f089; });
$parcel$export(module.exports, "parseValueFromTransform", function () { return $f0207664133f4738$export$f9111f9e16b73a26; });
$parcel$export(module.exports, "readTransformValue", function () { return $f0207664133f4738$export$bcd97e0e03ba17f6; });
const $f0207664133f4738$var$radToDeg = (rad)=>rad * 180 / Math.PI;
const $f0207664133f4738$var$rotate = (v)=>{
    const angle = $f0207664133f4738$var$radToDeg(Math.atan2(v[1], v[0]));
    return $f0207664133f4738$var$rebaseAngle(angle);
};
const $f0207664133f4738$var$matrix2dParsers = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: (v)=>(Math.abs(v[0]) + Math.abs(v[3])) / 2,
    rotate: $f0207664133f4738$var$rotate,
    rotateZ: $f0207664133f4738$var$rotate,
    skewX: (v)=>$f0207664133f4738$var$radToDeg(Math.atan(v[1])),
    skewY: (v)=>$f0207664133f4738$var$radToDeg(Math.atan(v[2])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[2])) / 2
};
const $f0207664133f4738$var$rebaseAngle = (angle)=>{
    angle = angle % 360;
    if (angle < 0) angle += 360;
    return angle;
};
const $f0207664133f4738$var$rotateZ = $f0207664133f4738$var$rotate;
const $f0207664133f4738$var$scaleX = (v)=>Math.sqrt(v[0] * v[0] + v[1] * v[1]);
const $f0207664133f4738$var$scaleY = (v)=>Math.sqrt(v[4] * v[4] + v[5] * v[5]);
const $f0207664133f4738$var$matrix3dParsers = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: $f0207664133f4738$var$scaleX,
    scaleY: $f0207664133f4738$var$scaleY,
    scale: (v)=>($f0207664133f4738$var$scaleX(v) + $f0207664133f4738$var$scaleY(v)) / 2,
    rotateX: (v)=>$f0207664133f4738$var$rebaseAngle($f0207664133f4738$var$radToDeg(Math.atan2(v[6], v[5]))),
    rotateY: (v)=>$f0207664133f4738$var$rebaseAngle($f0207664133f4738$var$radToDeg(Math.atan2(-v[2], v[0]))),
    rotateZ: $f0207664133f4738$var$rotateZ,
    rotate: $f0207664133f4738$var$rotateZ,
    skewX: (v)=>$f0207664133f4738$var$radToDeg(Math.atan(v[4])),
    skewY: (v)=>$f0207664133f4738$var$radToDeg(Math.atan(v[1])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[4])) / 2
};
function $f0207664133f4738$export$1f10c01143b9f089(name) {
    return name.includes("scale") ? 1 : 0;
}
function $f0207664133f4738$export$f9111f9e16b73a26(transform, name) {
    if (!transform || transform === "none") return $f0207664133f4738$export$1f10c01143b9f089(name);
    const matrix3dMatch = transform.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
    let parsers;
    let match;
    if (matrix3dMatch) {
        parsers = $f0207664133f4738$var$matrix3dParsers;
        match = matrix3dMatch;
    } else {
        const matrix2dMatch = transform.match(/^matrix\(([-\d.e\s,]+)\)$/u);
        parsers = $f0207664133f4738$var$matrix2dParsers;
        match = matrix2dMatch;
    }
    if (!match) return $f0207664133f4738$export$1f10c01143b9f089(name);
    const valueParser = parsers[name];
    const values = match[1].split(",").map($f0207664133f4738$var$convertTransformToNumber);
    return typeof valueParser === "function" ? valueParser(values) : values[valueParser];
}
const $f0207664133f4738$export$bcd97e0e03ba17f6 = (instance, name)=>{
    const { transform: transform = "none" } = getComputedStyle(instance);
    return $f0207664133f4738$export$f9111f9e16b73a26(transform, name);
};
function $f0207664133f4738$var$convertTransformToNumber(value) {
    return parseFloat(value.trim());
}

});

parcelRegister("cYSzx", function(module, exports) {

$parcel$export(module.exports, "transformPropOrder", function () { return $36437dbf5b93c477$export$280dc01950909d86; });
$parcel$export(module.exports, "transformProps", function () { return $36437dbf5b93c477$export$7b42a0094fb00b6e; });
/**
 * Generate a list of every possible transform key.
 */ const $36437dbf5b93c477$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 *
 * `pathRotation` is a transform for routing purposes (skipped from raw
 * style application, wired to the transform composite, flags transform
 * dirty) but is intentionally NOT in `transformPropOrder` — it is
 * composed onto `rotate` at the build sites, not serialized in its own
 * slot, and must stay out of the order-array consumers (parse-transform,
 * unit-conversion, keys-position).
 */ const $36437dbf5b93c477$export$7b42a0094fb00b6e = /*@__PURE__*/ (()=>new Set([
        ...$36437dbf5b93c477$export$280dc01950909d86,
        "pathRotation"
    ]))();

});



parcelRegister("bfr79", function(module, exports) {

$parcel$export(module.exports, "NativeAnimationExtended", function () { return $9f819ae9491bd189$export$bd2cd6a048093d96; });

var $iH3lf = parcelRequire("iH3lf");

var $iO0o7 = parcelRequire("iO0o7");

var $74Wbj = parcelRequire("74Wbj");

var $2Aaic = parcelRequire("2Aaic");

var $b8deO = parcelRequire("b8deO");

var $d8JZP = parcelRequire("d8JZP");

var $hHPZF = parcelRequire("hHPZF");
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $9f819ae9491bd189$var$sampleDelta = 10; //ms
class $9f819ae9491bd189$export$bd2cd6a048093d96 extends (0, $b8deO.NativeAnimation) {
    constructor(options){
        /**
         * The base NativeAnimation function only supports a subset
         * of Motion easings, and WAAPI also only supports some
         * easing functions via string/cubic-bezier definitions.
         *
         * This function replaces those unsupported easing functions
         * with a JS easing function. This will later get compiled
         * to a linear() easing function.
         */ (0, $hHPZF.replaceStringEasing)(options);
        /**
         * Ensure we replace the transition type with a generator function
         * before passing to WAAPI.
         *
         * TODO: Does this have a better home? It could be shared with
         * JSAnimation.
         */ (0, $d8JZP.replaceTransitionType)(options);
        super(options);
        /**
         * Only set startTime when the animation should autoplay.
         * Setting startTime on a paused WAAPI animation unpauses it
         * (per the WAAPI spec), which breaks autoplay: false.
         */ if (options.startTime !== undefined && options.autoplay !== false) this.startTime = options.startTime;
        this.options = options;
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * Rather than read committed styles back out of the DOM, we can
     * create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to calculate velocity for any subsequent animation.
     */ updateMotionValue(value) {
        const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
        if (!motionValue) return;
        if (value !== undefined) {
            motionValue.set(value);
            return;
        }
        const sampleAnimation = new (0, $2Aaic.JSAnimation)({
            ...options,
            autoplay: false
        });
        /**
         * Use wall-clock elapsed time for sampling.
         * Under CPU load, WAAPI's currentTime may not reflect actual
         * elapsed time, causing incorrect sampling and visual jumps.
         */ const sampleTime = Math.max($9f819ae9491bd189$var$sampleDelta, (0, $iO0o7.time).now() - this.startTime);
        const delta = (0, $iH3lf.clamp)(0, $9f819ae9491bd189$var$sampleDelta, sampleTime - $9f819ae9491bd189$var$sampleDelta);
        const current = sampleAnimation.sample(sampleTime).value;
        /**
         * Write the estimated value to inline style so it persists
         * after cancel(), covering the async gap before the next
         * animation starts.
         */ const { name: name } = this.options;
        if (element && name) (0, $74Wbj.setStyle)(element, name, current);
        motionValue.setWithVelocity(sampleAnimation.sample(Math.max(0, sampleTime - delta)).value, current, delta);
        sampleAnimation.stop();
    }
}

});
parcelRegister("74Wbj", function(module, exports) {

$parcel$export(module.exports, "setStyle", function () { return $0055d05149405828$export$37a5fde709c1db82; });

var $ghYPl = parcelRequire("ghYPl");
function $0055d05149405828$export$37a5fde709c1db82(element, name, value) {
    (0, $ghYPl.isCSSVar)(name) ? element.style.setProperty(name, value) : element.style[name] = value;
}

});
parcelRegister("ghYPl", function(module, exports) {

$parcel$export(module.exports, "isCSSVar", function () { return $1abad52e84ac08f3$export$c9f584638d388483; });
const $1abad52e84ac08f3$export$c9f584638d388483 = (name)=>name.startsWith("--");

});


parcelRegister("b8deO", function(module, exports) {

$parcel$export(module.exports, "NativeAnimation", function () { return $d40de0a79038d88e$export$6c0f9803d8aa7219; });

var $jEeLK = parcelRequire("jEeLK");
var $jzxS7 = parcelRequire("jzxS7");
var $7aJzA = parcelRequire("7aJzA");

var $74Wbj = parcelRequire("74Wbj");

var $dICpH = parcelRequire("dICpH");

var $7UE0W = parcelRequire("7UE0W");

var $5llKW = parcelRequire("5llKW");

var $e1wrm = parcelRequire("e1wrm");

var $1Kj3Q = parcelRequire("1Kj3Q");
/**
 * NativeAnimation implements AnimationPlaybackControls for the browser's Web Animations API.
 */ class $d40de0a79038d88e$export$6c0f9803d8aa7219 extends (0, $5llKW.WithPromise) {
    constructor(options){
        super();
        this.finishedTime = null;
        this.isStopped = false;
        /**
         * Tracks a manually-set start time that takes precedence over WAAPI's
         * dynamic startTime. This is cleared when play() or time setter is called,
         * allowing WAAPI to take over timing.
         */ this.manualStartTime = null;
        if (!options) return;
        const { element: element, name: name, keyframes: keyframes, pseudoElement: pseudoElement, allowFlatten: allowFlatten = false, finalKeyframe: finalKeyframe, onComplete: onComplete } = options;
        this.isPseudoElement = Boolean(pseudoElement);
        this.allowFlatten = allowFlatten;
        this.options = options;
        (0, $jEeLK.invariant)(typeof options.type !== "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
        const transition = (0, $1Kj3Q.applyGeneratorOptions)(options);
        this.animation = (0, $e1wrm.startWaapiAnimation)(element, name, keyframes, transition, pseudoElement);
        if (transition.autoplay === false) this.animation.pause();
        this.animation.onfinish = ()=>{
            this.finishedTime = this.time;
            if (!pseudoElement) {
                const keyframe = (0, $7UE0W.getFinalKeyframe)(keyframes, this.options, finalKeyframe, this.speed);
                if (this.updateMotionValue) this.updateMotionValue(keyframe);
                /**
                 * If we can, we want to commit the final style as set by the user,
                 * rather than the computed keyframe value supplied by the animation.
                 * We always do this, even when a motion value is present, to prevent
                 * a visual flash in Firefox where the WAAPI animation's fill is removed
                 * during cancel() before the scheduled render can apply the correct value.
                 */ (0, $74Wbj.setStyle)(element, name, keyframe);
                this.animation.cancel();
            }
            onComplete?.();
            this.notifyFinished();
        };
    }
    play() {
        if (this.isStopped) return;
        this.manualStartTime = null;
        this.animation.play();
        if (this.state === "finished") this.updateFinished();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.finish?.();
    }
    cancel() {
        try {
            this.animation.cancel();
        } catch (e) {}
    }
    stop() {
        if (this.isStopped) return;
        this.isStopped = true;
        const { state: state } = this;
        if (state === "idle" || state === "finished") return;
        if (this.updateMotionValue) this.updateMotionValue();
        else this.commitStyles();
        if (!this.isPseudoElement) this.cancel();
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * In this method, we commit styles back to the DOM before cancelling
     * the animation.
     *
     * This is designed to be overridden by NativeAnimationExtended, which
     * will create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to also correctly calculate velocity for any subsequent animation
     * while deferring the commit until the next animation frame.
     */ commitStyles() {
        const element = this.options?.element;
        if (!this.isPseudoElement && element?.isConnected) this.animation.commitStyles?.();
    }
    get duration() {
        const duration = this.animation.effect?.getComputedTiming?.().duration || 0;
        return (0, $jzxS7.millisecondsToSeconds)(Number(duration));
    }
    get iterationDuration() {
        const { delay: delay = 0 } = this.options || {};
        return this.duration + (0, $jzxS7.millisecondsToSeconds)(delay);
    }
    get time() {
        return (0, $jzxS7.millisecondsToSeconds)(Number(this.animation.currentTime) || 0);
    }
    set time(newTime) {
        const wasFinished = this.finishedTime !== null;
        this.manualStartTime = null;
        this.finishedTime = null;
        this.animation.currentTime = (0, $jzxS7.secondsToMilliseconds)(newTime);
        if (wasFinished) this.animation.pause();
    }
    /**
     * The playback speed of the animation.
     * 1 = normal speed, 2 = double speed, 0.5 = half speed.
     */ get speed() {
        return this.animation.playbackRate;
    }
    set speed(newSpeed) {
        // Allow backwards playback after finishing
        if (newSpeed < 0) this.finishedTime = null;
        this.animation.playbackRate = newSpeed;
    }
    get state() {
        return this.finishedTime !== null ? "finished" : this.animation.playState;
    }
    get startTime() {
        return this.manualStartTime ?? Number(this.animation.startTime);
    }
    set startTime(newStartTime) {
        this.manualStartTime = this.animation.startTime = newStartTime;
    }
    /**
     * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
     */ attachTimeline({ timeline: timeline, rangeStart: rangeStart, rangeEnd: rangeEnd, observe: observe }) {
        if (this.allowFlatten) this.animation.effect?.updateTiming({
            easing: "linear"
        });
        this.animation.onfinish = null;
        if (timeline && (0, $dICpH.supportsScrollTimeline)()) {
            this.animation.timeline = timeline;
            if (rangeStart) this.animation.rangeStart = rangeStart;
            if (rangeEnd) this.animation.rangeEnd = rangeEnd;
            return 0, $7aJzA.noop;
        } else return observe(this);
    }
}

});
parcelRegister("dICpH", function(module, exports) {

$parcel$export(module.exports, "supportsScrollTimeline", function () { return $cf8d7908a6543c98$export$20d68f04f30763a5; });

var $4VSN5 = parcelRequire("4VSN5");
const $cf8d7908a6543c98$export$20d68f04f30763a5 = /* @__PURE__ */ (0, $4VSN5.memoSupports)(()=>window.ScrollTimeline !== undefined, "scrollTimeline");
const $cf8d7908a6543c98$export$206321d8c5f8fd38 = /* @__PURE__ */ (0, $4VSN5.memoSupports)(()=>window.ViewTimeline !== undefined, "viewTimeline");

});
parcelRegister("4VSN5", function(module, exports) {

$parcel$export(module.exports, "memoSupports", function () { return $3361179f8f81e58e$export$1964673d5ec13c3a; });

var $aeEwm = parcelRequire("aeEwm");

var $4X5hH = parcelRequire("4X5hH");
function $3361179f8f81e58e$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $aeEwm.memo)(callback);
    return ()=>(0, $4X5hH.supportsFlags)[supportsFlag] ?? memoized();
}

});
parcelRegister("aeEwm", function(module, exports) {

$parcel$export(module.exports, "memo", function () { return $373ae0ce1db34355$export$7c73462e0d25e514; });
/*#__NO_SIDE_EFFECTS__*/ function $373ae0ce1db34355$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}

});

parcelRegister("4X5hH", function(module, exports) {

$parcel$export(module.exports, "supportsFlags", function () { return $2e8f1cca8189061f$export$e3ad02c335474dee; });
/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $2e8f1cca8189061f$export$e3ad02c335474dee = {};

});



parcelRegister("e1wrm", function(module, exports) {

$parcel$export(module.exports, "startWaapiAnimation", function () { return $583566263f64a846$export$d896de52f97cb615; });

var $1Psqd = parcelRequire("1Psqd");
function $583566263f64a846$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease = "easeOut", times: times } = {}, pseudoElement) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $1Psqd.mapEasingToNativeEasing)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    const options = {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    };
    if (pseudoElement) options.pseudoElement = pseudoElement;
    return element.animate(keyframeOptions, options);
}

});
parcelRegister("1Psqd", function(module, exports) {

$parcel$export(module.exports, "mapEasingToNativeEasing", function () { return $5c7ca815419a9c0b$export$916ea73bcd3a6030; });

var $ba9E4 = parcelRequire("ba9E4");

var $9ZhUd = parcelRequire("9ZhUd");

var $9AMsY = parcelRequire("9AMsY");

var $9wQNZ = parcelRequire("9wQNZ");

var $c99mF = parcelRequire("c99mF");
function $5c7ca815419a9c0b$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function") return (0, $9ZhUd.supportsLinearEasing)() ? (0, $9AMsY.generateLinearEasing)(easing, duration) : "ease-out";
    else if ((0, $ba9E4.isBezierDefinition)(easing)) return (0, $9wQNZ.cubicBezierAsString)(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$5c7ca815419a9c0b$export$916ea73bcd3a6030(segmentEasing, duration) || (0, $c99mF.supportedWaapiEasing).easeOut);
    else return (0, $c99mF.supportedWaapiEasing)[easing];
}

});
parcelRegister("9ZhUd", function(module, exports) {

$parcel$export(module.exports, "supportsLinearEasing", function () { return $ab271ab2951341fd$export$866c1d07a1ac2ab; });

var $4VSN5 = parcelRequire("4VSN5");
const $ab271ab2951341fd$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $4VSN5.memoSupports)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");

});

parcelRegister("9wQNZ", function(module, exports) {

$parcel$export(module.exports, "cubicBezierAsString", function () { return $6fd375bd8200fb33$export$2523b8f0bd8f44cb; });
const $6fd375bd8200fb33$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;

});

parcelRegister("c99mF", function(module, exports) {

$parcel$export(module.exports, "supportedWaapiEasing", function () { return $7fa95de4cb88f140$export$2cf569f5e2221176; });

var $9wQNZ = parcelRequire("9wQNZ");
const $7fa95de4cb88f140$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ (0, $9wQNZ.cubicBezierAsString)([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ (0, $9wQNZ.cubicBezierAsString)([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ (0, $9wQNZ.cubicBezierAsString)([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ (0, $9wQNZ.cubicBezierAsString)([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};

});



parcelRegister("1Kj3Q", function(module, exports) {

$parcel$export(module.exports, "applyGeneratorOptions", function () { return $53d8149960f311f6$export$a31269144d66b4a; });

var $9ZhUd = parcelRequire("9ZhUd");

var $4eY6j = parcelRequire("4eY6j");
function $53d8149960f311f6$export$a31269144d66b4a({ type: type, ...options }) {
    if ((0, $4eY6j.isGenerator)(type) && (0, $9ZhUd.supportsLinearEasing)()) return type.applyToOptions(options);
    else {
        options.duration ?? (options.duration = 300);
        options.ease ?? (options.ease = "easeOut");
    }
    return options;
}

});


parcelRegister("hHPZF", function(module, exports) {

$parcel$export(module.exports, "replaceStringEasing", function () { return $3a789180528414af$export$5195f232c29d1f82; });

var $gAxQn = parcelRequire("gAxQn");
var $7qoQj = parcelRequire("7qoQj");
var $g82qV = parcelRequire("g82qV");
const $3a789180528414af$var$unsupportedEasingFunctions = {
    anticipate: $gAxQn.anticipate,
    backInOut: $7qoQj.backInOut,
    circInOut: $g82qV.circInOut
};
function $3a789180528414af$var$isUnsupportedEase(key) {
    return key in $3a789180528414af$var$unsupportedEasingFunctions;
}
function $3a789180528414af$export$5195f232c29d1f82(transition) {
    if (typeof transition.ease === "string" && $3a789180528414af$var$isUnsupportedEase(transition.ease)) transition.ease = $3a789180528414af$var$unsupportedEasingFunctions[transition.ease];
}

});


parcelRegister("QaiZw", function(module, exports) {

$parcel$export(module.exports, "canAnimate", function () { return $2a4d473bd153758e$export$1b109e6c9968df4f; });

var $jEeLK = parcelRequire("jEeLK");

var $4eY6j = parcelRequire("4eY6j");

var $7BTe3 = parcelRequire("7BTe3");
function $2a4d473bd153758e$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $2a4d473bd153758e$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $7BTe3.isAnimatable)(originKeyframe, name);
    const isTargetAnimatable = (0, $7BTe3.isAnimatable)(targetKeyframe, name);
    (0, $jEeLK.warning)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". "${isOriginAnimatable ? targetKeyframe : originKeyframe}" is not an animatable value.`, "value-not-animatable");
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $2a4d473bd153758e$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $4eY6j.isGenerator)(type)) && velocity;
}

});
parcelRegister("7BTe3", function(module, exports) {

$parcel$export(module.exports, "isAnimatable", function () { return $e770b24f49f1bf00$export$65676b58b122bc38; });

var $FH6ft = parcelRequire("FH6ft");
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $e770b24f49f1bf00$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys that might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $FH6ft.complex).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};

});


parcelRegister("kPAiw", function(module, exports) {

$parcel$export(module.exports, "makeAnimationInstant", function () { return $4513539b02d1ff31$export$b2585dd3c345da47; });
function $4513539b02d1ff31$export$b2585dd3c345da47(options) {
    options.duration = 0;
    options.type = "keyframes";
}

});

parcelRegister("jBoMs", function(module, exports) {

$parcel$export(module.exports, "supportsBrowserAnimation", function () { return $702fac286bb86197$export$ea92bde116fda821; });

var $aeEwm = parcelRequire("aeEwm");

var $i2hvp = parcelRequire("i2hvp");

var $jH6MQ = parcelRequire("jH6MQ");
const $702fac286bb86197$var$colorProperties = new Set([
    "color",
    "backgroundColor",
    "outlineColor",
    "fill",
    "stroke",
    "borderColor",
    "borderTopColor",
    "borderRightColor",
    "borderBottomColor",
    "borderLeftColor"
]);
const $702fac286bb86197$var$supportsWaapi = /*@__PURE__*/ (0, $aeEwm.memo)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
function $702fac286bb86197$export$ea92bde116fda821(options) {
    const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type, keyframes: keyframes } = options;
    const subject = motionValue?.owner?.current;
    /**
     * We use instanceof checks instead of isHTMLElement()/isSVGElement()
     * because we explicitly **don't** want elements in different timing
     * contexts (i.e. popups) to be accelerated, as it's not possible to sync
     * these animations properly with those driven from the main window
     * frameloop.
     */ if (!(subject instanceof HTMLElement) && !(subject instanceof SVGElement)) return false;
    const { onUpdate: onUpdate, transformTemplate: transformTemplate } = motionValue.owner.getProps();
    return $702fac286bb86197$var$supportsWaapi() && name && /**
         * Force WAAPI for color properties with browser-only color formats
         * (oklch, oklab, lab, lch, etc.) that the JS animation path can't parse.
         */ ((0, $i2hvp.acceleratedValues).has(name) || $702fac286bb86197$var$colorProperties.has(name) && (0, $jH6MQ.hasBrowserOnlyColors)(keyframes)) && (name !== "transform" || !transformTemplate) && /**
         * If we're outputting values to onUpdate then we can't use WAAPI as there's
         * no way to read the value from WAAPI every frame.
         */ !onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
}

});
parcelRegister("i2hvp", function(module, exports) {

$parcel$export(module.exports, "acceleratedValues", function () { return $95afec150de2825d$export$a27eefbd8fb5e404; });
/**
 * A list of values that can be hardware-accelerated.
 */ const $95afec150de2825d$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform",
    "backgroundColor"
]);

});

parcelRegister("jH6MQ", function(module, exports) {

$parcel$export(module.exports, "hasBrowserOnlyColors", function () { return $8814a910df4e458b$export$1af9e65d1501d15; });
const $8814a910df4e458b$var$browserColorFunctions = /^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/;
function $8814a910df4e458b$export$1af9e65d1501d15(keyframes) {
    for(let i = 0; i < keyframes.length; i++){
        if (typeof keyframes[i] === "string" && $8814a910df4e458b$var$browserColorFunctions.test(keyframes[i])) return true;
    }
    return false;
}

});



parcelRegister("cyrnk", function(module, exports) {

$parcel$export(module.exports, "getValueTransition", function () { return $445378a930c6db37$export$7c1391340308742e; });

var $702El = parcelRequire("702El");
function $445378a930c6db37$export$7c1391340308742e(transition, key) {
    const valueTransition = transition?.[key] ?? transition?.["default"] ?? transition;
    if (valueTransition !== transition) return (0, $702El.resolveTransition)(valueTransition, transition);
    return valueTransition;
}

});
parcelRegister("702El", function(module, exports) {

$parcel$export(module.exports, "resolveTransition", function () { return $46f6985c0d37a6d0$export$b180037f8f468d61; });
/**
 * If `transition` has `inherit: true`, shallow-merge it with
 * `parentTransition` (child keys win) and strip the `inherit` key.
 * Otherwise return `transition` unchanged.
 */ function $46f6985c0d37a6d0$export$b180037f8f468d61(transition, parentTransition) {
    if (transition?.inherit && parentTransition) {
        const { inherit: _, ...rest } = transition;
        return {
            ...parentTransition,
            ...rest
        };
    }
    return transition;
}

});


parcelRegister("8NQQx", function(module, exports) {

$parcel$export(module.exports, "getDefaultTransition", function () { return $23d00b80313b3daf$export$262124b154b9f1c0; });

var $cYSzx = parcelRequire("cYSzx");
const $23d00b80313b3daf$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $23d00b80313b3daf$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $23d00b80313b3daf$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $23d00b80313b3daf$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $23d00b80313b3daf$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $23d00b80313b3daf$var$keyframesTransition;
    else if ((0, $cYSzx.transformProps).has(valueKey)) return valueKey.startsWith("scale") ? $23d00b80313b3daf$var$criticallyDampedSpring(keyframes[1]) : $23d00b80313b3daf$var$underDampedSpring;
    return $23d00b80313b3daf$var$ease;
};

});

parcelRegister("hFGJj", function(module, exports) {

$parcel$export(module.exports, "isTransitionDefined", function () { return $ddc4f6cd9cc92def$export$ca8e47dc8ed5a9d7; });
const $ddc4f6cd9cc92def$var$orchestrationKeys = new Set([
    "when",
    "delay",
    "delayChildren",
    "staggerChildren",
    "staggerDirection",
    "repeat",
    "repeatType",
    "repeatDelay",
    "from",
    "elapsed"
]);
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $ddc4f6cd9cc92def$export$ca8e47dc8ed5a9d7(transition) {
    for(const key in transition){
        if (!$ddc4f6cd9cc92def$var$orchestrationKeys.has(key)) return true;
    }
    return false;
}

});



parcelRegister("g1ASW", function(module, exports) {

$parcel$export(module.exports, "animateTarget", function () { return $8910548cca780654$export$68cacfeee78d98d2; });

var $cyrnk = parcelRequire("cyrnk");

var $702El = parcelRequire("702El");

var $cWWp8 = parcelRequire("cWWp8");

var $gGmhO = parcelRequire("gGmhO");

var $ajW17 = parcelRequire("ajW17");

var $5AoGb = parcelRequire("5AoGb");

var $heOY0 = parcelRequire("heOY0");

var $ibWTn = parcelRequire("ibWTn");
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $8910548cca780654$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $8910548cca780654$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition, transitionEnd: transitionEnd, ...target } = targetAndTransition;
    const defaultTransition = visualElement.getDefaultTransition();
    transition = transition ? (0, $702El.resolveTransition)(transition, defaultTransition) : defaultTransition;
    const reduceMotion = transition?.reduceMotion;
    const skipAnimations = transition?.skipAnimations;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    const path = transition?.path;
    if (path) // path mutates `target` to claim x/y; loop below skips them.
    path.animateVisualElement(visualElement, target, transition, delay, animations);
    for(const key in target){
        const value = visualElement.getValue(key, visualElement.latestValues[key] ?? null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $8910548cca780654$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $cyrnk.getValueTransition)(transition || {}, key)
        };
        if (skipAnimations) valueTransition.skipAnimations = true;
        /**
         * If the value is already at the defined target, skip the animation.
         * We still re-assert the value via frame.update to take precedence
         * over any stale transitionEnd callbacks from previous animations.
         */ const currentValue = value.get();
        if (currentValue !== undefined && !value.isAnimating() && !Array.isArray(valueTarget) && valueTarget === currentValue && !valueTransition.velocity) {
            (0, $ibWTn.frame).update(()=>value.set(valueTarget));
            continue;
        }
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $5AoGb.getOptimisedAppearId)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $ibWTn.frame));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $ajW17.addValueToWillChange)(visualElement, key);
        const shouldReduceMotion = reduceMotion ?? visualElement.shouldReduceMotion;
        value.start((0, $heOY0.animateMotionValue)(key, value, valueTarget, shouldReduceMotion && (0, $cWWp8.positionalKeys).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) {
        const applyTransitionEnd = ()=>(0, $ibWTn.frame).update(()=>{
                transitionEnd && (0, $gGmhO.setTarget)(visualElement, transitionEnd);
            });
        if (animations.length) Promise.all(animations).then(applyTransitionEnd);
        else applyTransitionEnd();
    }
    return animations;
}

});
parcelRegister("cWWp8", function(module, exports) {

$parcel$export(module.exports, "positionalKeys", function () { return $3686a9bc645641a9$export$c66c0d5db2a205d; });

var $cYSzx = parcelRequire("cYSzx");
const $3686a9bc645641a9$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...(0, $cYSzx.transformPropOrder)
]);

});

parcelRegister("gGmhO", function(module, exports) {

$parcel$export(module.exports, "setTarget", function () { return $52953efd8694e3bd$export$1f61c53461aff4a5; });

var $52PJo = parcelRequire("52PJo");

var $hNCWJ = parcelRequire("hNCWJ");

var $8NRyO = parcelRequire("8NRyO");
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $52953efd8694e3bd$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $52PJo.motionValue)(value));
}
function $52953efd8694e3bd$var$resolveFinalValueInKeyframes(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $8NRyO.isKeyframesTarget)(v) ? v[v.length - 1] || 0 : v;
}
function $52953efd8694e3bd$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $hNCWJ.resolveVariant)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = $52953efd8694e3bd$var$resolveFinalValueInKeyframes(target[key]);
        $52953efd8694e3bd$var$setMotionValue(visualElement, key, value);
    }
}

});
parcelRegister("hNCWJ", function(module, exports) {

$parcel$export(module.exports, "resolveVariant", function () { return $0f821ea1e0e898c8$export$7b1b1c981f4f0558; });

var $crPmA = parcelRequire("crPmA");
function $0f821ea1e0e898c8$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $crPmA.resolveVariantFromProps)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}

});
parcelRegister("crPmA", function(module, exports) {

$parcel$export(module.exports, "resolveVariantFromProps", function () { return $20ea58c6853b5985$export$d68f140c4d9b48bc; });
function $20ea58c6853b5985$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement?.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $20ea58c6853b5985$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $20ea58c6853b5985$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $20ea58c6853b5985$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}

});


parcelRegister("8NRyO", function(module, exports) {

$parcel$export(module.exports, "isKeyframesTarget", function () { return $b86f35c91384031e$export$9153ad4c4999f4a0; });
const $b86f35c91384031e$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};

});


parcelRegister("ajW17", function(module, exports) {

$parcel$export(module.exports, "addValueToWillChange", function () { return $5d399ca24ed34089$export$3ac5aed310be0bee; });

var $9zuZQ = parcelRequire("9zuZQ");

var $lCxd0 = parcelRequire("lCxd0");
function $5d399ca24ed34089$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $lCxd0.isWillChangeMotionValue)(willChange)) return willChange.add(key);
    else if (!willChange && (0, $9zuZQ.MotionGlobalConfig).WillChange) {
        const newWillChange = new (0, $9zuZQ.MotionGlobalConfig).WillChange("auto");
        visualElement.addValue("willChange", newWillChange);
        newWillChange.add(key);
    }
}

});
parcelRegister("lCxd0", function(module, exports) {

$parcel$export(module.exports, "isWillChangeMotionValue", function () { return $ffcae9ed317c42ed$export$98397f3adbf6259f; });

var $dP4pV = parcelRequire("dP4pV");
function $ffcae9ed317c42ed$export$98397f3adbf6259f(value) {
    return Boolean((0, $dP4pV.isMotionValue)(value) && value.add);
}

});


parcelRegister("5AoGb", function(module, exports) {

$parcel$export(module.exports, "getOptimisedAppearId", function () { return $dedda87bce0b0fc0$export$5f8d21e84d1d84fc; });

var $nS8kG = parcelRequire("nS8kG");
function $dedda87bce0b0fc0$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $nS8kG.optimizedAppearDataAttribute];
}

});
parcelRegister("nS8kG", function(module, exports) {

$parcel$export(module.exports, "optimizedAppearDataAttribute", function () { return $e429a9baf33d38af$export$8592e1c077c890a6; });

var $eXAoN = parcelRequire("eXAoN");
const $e429a9baf33d38af$export$ed7b8fa9dbf0105d = "framerAppearId";
const $e429a9baf33d38af$export$8592e1c077c890a6 = "data-" + (0, $eXAoN.camelToDash)($e429a9baf33d38af$export$ed7b8fa9dbf0105d);

});
parcelRegister("eXAoN", function(module, exports) {

$parcel$export(module.exports, "camelToDash", function () { return $e3efdb4aa4767bb8$export$9fd24a634729c672; });
function $e3efdb4aa4767bb8$export$9fd24a634729c672(str) {
    return str.replace(/([A-Z])/g, (match)=>`-${match.toLowerCase()}`);
}

});




parcelRegister("1Zt2N", function(module, exports) {

$parcel$export(module.exports, "visualElementStore", function () { return $44b14b06958d6f59$export$bc2a978a17abfdde; });
const $44b14b06958d6f59$export$bc2a978a17abfdde = new WeakMap();

});

parcelRegister("2Wbp4", function(module, exports) {

$parcel$export(module.exports, "createDOMVisualElement", function () { return $3e1acd3da9b341d6$export$602bd1946a6d1d47; });
$parcel$export(module.exports, "createObjectVisualElement", function () { return $3e1acd3da9b341d6$export$69c3b8be1812d4ee; });

var $c5STy = parcelRequire("c5STy");
var $4q1M5 = parcelRequire("4q1M5");
var $hGGE9 = parcelRequire("hGGE9");
var $68Xt5 = parcelRequire("68Xt5");
var $eqSva = parcelRequire("eqSva");
var $1Zt2N = parcelRequire("1Zt2N");
function $3e1acd3da9b341d6$export$602bd1946a6d1d47(element) {
    const options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                transform: {},
                transformOrigin: {},
                style: {},
                vars: {},
                attrs: {}
            },
            latestValues: {}
        }
    };
    const node = (0, $4q1M5.isSVGElement)(element) && !(0, $hGGE9.isSVGSVGElement)(element) ? new (0, $eqSva.SVGVisualElement)(options) : new (0, $c5STy.HTMLVisualElement)(options);
    node.mount(element);
    (0, $1Zt2N.visualElementStore).set(element, node);
}
function $3e1acd3da9b341d6$export$69c3b8be1812d4ee(subject) {
    const options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                output: {}
            },
            latestValues: {}
        }
    };
    const node = new (0, $68Xt5.ObjectVisualElement)(options);
    node.mount(subject);
    (0, $1Zt2N.visualElementStore).set(subject, node);
}

});
parcelRegister("c5STy", function(module, exports) {

$parcel$export(module.exports, "HTMLVisualElement", function () { return $81ed700fe5da0b90$export$23fea75b03ac16b3; });

var $jEeLK = parcelRequire("jEeLK");

var $fop0M = parcelRequire("fop0M");

var $cYSzx = parcelRequire("cYSzx");

var $eUGDt = parcelRequire("eUGDt");

var $aijUC = parcelRequire("aijUC");

var $hGB06 = parcelRequire("hGB06");

var $e6p9v = parcelRequire("e6p9v");

var $aU7mD = parcelRequire("aU7mD");

var $ecTQD = parcelRequire("ecTQD");
function $81ed700fe5da0b90$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $81ed700fe5da0b90$export$23fea75b03ac16b3 extends (0, $hGB06.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $aU7mD.renderHTML);
    }
    mount(instance) {
        /**
         * If a custom component forwards its ref to something other than a
         * HTML/SVG element (a class instance, an imperative handle) there's
         * nothing for Motion to style, measure or attach gestures to. #2777
         */ (0, $jEeLK.invariant)(Boolean(instance.style), "motion.create() components must forward their ref to a HTML or SVG element", "custom-component-ref");
        super.mount(instance);
    }
    readValueFromInstance(instance, key) {
        if ((0, $cYSzx.transformProps).has(key)) return this.projection?.isProjecting ? (0, $eUGDt.defaultTransformValue)(key) : (0, $eUGDt.readTransformValue)(instance, key);
        else {
            const computedStyle = $81ed700fe5da0b90$export$3735103072e4a80(instance);
            const value = ((0, $fop0M.isCSSVariableName)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $aijUC.measureViewportBox)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $e6p9v.buildHTMLStyles)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $ecTQD.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    }
}

});
parcelRegister("aijUC", function(module, exports) {

$parcel$export(module.exports, "measureViewportBox", function () { return $b3c78c86be367659$export$d8718b6a7e5c624e; });

var $gz3Bu = parcelRequire("gz3Bu");

var $hfdWA = parcelRequire("hfdWA");
function $b3c78c86be367659$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $gz3Bu.convertBoundingBoxToBox)((0, $gz3Bu.transformBoxPoints)(instance.getBoundingClientRect(), transformPoint));
}
function $b3c78c86be367659$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $b3c78c86be367659$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $hfdWA.translateAxis)(viewportBox.x, scroll.offset.x);
        (0, $hfdWA.translateAxis)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}

});
parcelRegister("gz3Bu", function(module, exports) {

$parcel$export(module.exports, "convertBoundingBoxToBox", function () { return $fd94cc0f2e3ce586$export$d3955c6a8f65a36b; });
$parcel$export(module.exports, "transformBoxPoints", function () { return $fd94cc0f2e3ce586$export$21543fb75483a50; });
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $fd94cc0f2e3ce586$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $fd94cc0f2e3ce586$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $fd94cc0f2e3ce586$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}

});

parcelRegister("hfdWA", function(module, exports) {

$parcel$export(module.exports, "translateAxis", function () { return $0043a8a3eeedd876$export$a807a5ce5ebb3895; });

var $e9BqC = parcelRequire("e9BqC");

var $kIvJB = parcelRequire("kIvJB");
/**
 * Scales a point based on a factor and an originPoint
 */ function $0043a8a3eeedd876$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $0043a8a3eeedd876$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $0043a8a3eeedd876$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $0043a8a3eeedd876$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $0043a8a3eeedd876$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $0043a8a3eeedd876$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $0043a8a3eeedd876$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $0043a8a3eeedd876$export$d80074982803af5c(box, { x: x, y: y }) {
    $0043a8a3eeedd876$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $0043a8a3eeedd876$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $0043a8a3eeedd876$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $0043a8a3eeedd876$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $0043a8a3eeedd876$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) {
            $0043a8a3eeedd876$export$a807a5ce5ebb3895(box.x, -node.scroll.offset.x);
            $0043a8a3eeedd876$export$a807a5ce5ebb3895(box.y, -node.scroll.offset.y);
        }
        if (delta) {
            // Incoporate each ancestor's scale into a cumulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $0043a8a3eeedd876$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $kIvJB.hasTransform)(node.latestValues)) $0043a8a3eeedd876$export$58b16271041fbfb(box, node.latestValues, node.layout?.layoutBox);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $0043a8a3eeedd876$var$TREE_SCALE_SNAP_MAX && treeScale.x > $0043a8a3eeedd876$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $0043a8a3eeedd876$var$TREE_SCALE_SNAP_MAX && treeScale.y > $0043a8a3eeedd876$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $0043a8a3eeedd876$export$a807a5ce5ebb3895(axis, distance) {
    axis.min += distance;
    axis.max += distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $0043a8a3eeedd876$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $e9BqC.mixNumber)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $0043a8a3eeedd876$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
function $0043a8a3eeedd876$var$resolveAxisTranslate(value, axis) {
    if (typeof value === "string") return parseFloat(value) / 100 * (axis.max - axis.min);
    return value;
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $0043a8a3eeedd876$export$58b16271041fbfb(box, transform, sourceBox) {
    const resolveBox = sourceBox ?? box;
    $0043a8a3eeedd876$export$625f1dd140a2f5e7(box.x, $0043a8a3eeedd876$var$resolveAxisTranslate(transform.x, resolveBox.x), transform.scaleX, transform.scale, transform.originX);
    $0043a8a3eeedd876$export$625f1dd140a2f5e7(box.y, $0043a8a3eeedd876$var$resolveAxisTranslate(transform.y, resolveBox.y), transform.scaleY, transform.scale, transform.originY);
}

});
parcelRegister("kIvJB", function(module, exports) {

$parcel$export(module.exports, "hasTransform", function () { return $8f62b661d366a749$export$a545127cf1fbb600; });
function $8f62b661d366a749$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $8f62b661d366a749$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$8f62b661d366a749$var$isIdentityScale(scale) || !$8f62b661d366a749$var$isIdentityScale(scaleX) || !$8f62b661d366a749$var$isIdentityScale(scaleY);
}
function $8f62b661d366a749$export$a545127cf1fbb600(values) {
    return $8f62b661d366a749$export$bdf30dca883ea463(values) || $8f62b661d366a749$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $8f62b661d366a749$export$bf80f5f8f4dc327f(values) {
    return $8f62b661d366a749$var$is2DTranslate(values.x) || $8f62b661d366a749$var$is2DTranslate(values.y);
}
function $8f62b661d366a749$var$is2DTranslate(value) {
    return value && value !== "0%";
}

});



parcelRegister("hGB06", function(module, exports) {

$parcel$export(module.exports, "DOMVisualElement", function () { return $dba06d9a16f9b2fd$export$e49735c2a366bdc7; });

var $dP4pV = parcelRequire("dP4pV");

var $arSsO = parcelRequire("arSsO");

var $clmLY = parcelRequire("clmLY");
class $dba06d9a16f9b2fd$export$e49735c2a366bdc7 extends (0, $clmLY.VisualElement) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $arSsO.DOMKeyframesResolver);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        const style = props.style;
        return style ? style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $dP4pV.isMotionValue)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}

});
parcelRegister("arSsO", function(module, exports) {

$parcel$export(module.exports, "DOMKeyframesResolver", function () { return $6543679a34c2f697$export$4983792d11b61017; });

var $cWWp8 = parcelRequire("cWWp8");

var $cjHjH = parcelRequire("cjHjH");

var $kj7D2 = parcelRequire("kj7D2");

var $fop0M = parcelRequire("fop0M");

var $eIAC2 = parcelRequire("eIAC2");

var $ajIN1 = parcelRequire("ajIN1");

var $fWdvX = parcelRequire("fWdvX");

var $1Ac5c = parcelRequire("1Ac5c");
class $6543679a34c2f697$export$4983792d11b61017 extends (0, $eIAC2.KeyframeResolver) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $fop0M.isCSSVariableToken)(keyframe)) {
                    const resolved = (0, $kj7D2.getVariableValue)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $cWWp8.positionalKeys).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $cjHjH.findDimensionValueType)(origin);
        const targetType = (0, $cjHjH.findDimensionValueType)(target);
        /**
         * If one keyframe contains embedded CSS variables (e.g. in calc()) and the other
         * doesn't, we need to measure to convert to pixels. This handles GitHub issue #3410.
         */ const originHasVar = (0, $fop0M.containsCSSVariable)(origin);
        const targetHasVar = (0, $fop0M.containsCSSVariable)(target);
        if (originHasVar !== targetHasVar && (0, $1Ac5c.positionalValues)[name]) {
            this.needsMeasurement = true;
            return;
        }
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $1Ac5c.isNumOrPxType)(originType) && (0, $1Ac5c.isNumOrPxType)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else if ((0, $1Ac5c.positionalValues)[name]) /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null || (0, $ajIN1.isNone)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $fWdvX.makeNoneKeyframesAnimatable)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $1Ac5c.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $1Ac5c.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if (this.removedTransforms?.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}

});
parcelRegister("cjHjH", function(module, exports) {

$parcel$export(module.exports, "dimensionValueTypes", function () { return $a40f0a2352427e09$export$d176691c1998a1f5; });
$parcel$export(module.exports, "findDimensionValueType", function () { return $a40f0a2352427e09$export$eefdd52e3ccae428; });

var $agSAd = parcelRequire("agSAd");

var $4FpLb = parcelRequire("4FpLb");

var $8ID0m = parcelRequire("8ID0m");

var $6D3YI = parcelRequire("6D3YI");
/**
 * A list of value types commonly used for dimensions
 */ const $a40f0a2352427e09$export$d176691c1998a1f5 = [
    (0, $4FpLb.number),
    (0, $8ID0m.px),
    (0, $8ID0m.percent),
    (0, $8ID0m.degrees),
    (0, $8ID0m.vw),
    (0, $8ID0m.vh),
    (0, $agSAd.auto)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $a40f0a2352427e09$export$eefdd52e3ccae428 = (v)=>$a40f0a2352427e09$export$d176691c1998a1f5.find((0, $6D3YI.testValueType)(v));

});
parcelRegister("agSAd", function(module, exports) {

$parcel$export(module.exports, "auto", function () { return $cad1ef5802f691e6$export$dfb5619354ba860; });
/**
 * ValueType for "auto"
 */ const $cad1ef5802f691e6$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};

});

parcelRegister("6D3YI", function(module, exports) {

$parcel$export(module.exports, "testValueType", function () { return $c97168000d203dd0$export$6eae4d0a6a7ca7cd; });
/**
 * Tests a provided value against a ValueType
 */ const $c97168000d203dd0$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);

});


parcelRegister("kj7D2", function(module, exports) {

$parcel$export(module.exports, "getVariableValue", function () { return $89d5513ff5a37480$export$289398774300c991; });

var $jEeLK = parcelRequire("jEeLK");
var $krm4n = parcelRequire("krm4n");

var $fop0M = parcelRequire("fop0M");
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $89d5513ff5a37480$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $89d5513ff5a37480$export$b9f0c1f373aee2b0(current) {
    const match = $89d5513ff5a37480$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 ?? token2}`,
        fallback
    ];
}
const $89d5513ff5a37480$var$maxDepth = 4;
function $89d5513ff5a37480$export$289398774300c991(current, element, depth = 1) {
    (0, $jEeLK.invariant)(depth <= $89d5513ff5a37480$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
    const [token, fallback] = $89d5513ff5a37480$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $krm4n.isNumericalString)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $fop0M.isCSSVariableToken)(fallback) ? $89d5513ff5a37480$export$289398774300c991(fallback, element, depth + 1) : fallback;
}

});
parcelRegister("krm4n", function(module, exports) {

$parcel$export(module.exports, "isNumericalString", function () { return $162a1451c8fa55b4$export$65583ed5a868f2d9; });
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $162a1451c8fa55b4$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);

});


parcelRegister("ajIN1", function(module, exports) {

$parcel$export(module.exports, "isNone", function () { return $42f46c117bba2041$export$e56af863d5645d5f; });

var $cNP8X = parcelRequire("cNP8X");
function $42f46c117bba2041$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $cNP8X.isZeroValueString)(value);
    else return true;
}

});
parcelRegister("cNP8X", function(module, exports) {

$parcel$export(module.exports, "isZeroValueString", function () { return $410126928ba5c7af$export$ade84c85e44a6cb1; });
/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $410126928ba5c7af$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);

});


parcelRegister("fWdvX", function(module, exports) {

$parcel$export(module.exports, "makeNoneKeyframesAnimatable", function () { return $b33deb06f6bb5c07$export$8cc4958f8e540f37; });

var $FH6ft = parcelRequire("FH6ft");

var $h6Iiw = parcelRequire("h6Iiw");
/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $b33deb06f6bb5c07$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $b33deb06f6bb5c07$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$b33deb06f6bb5c07$var$invalidTemplates.has(keyframe) && (0, $FH6ft.analyseComplexValue)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $h6Iiw.getAnimatableNone)(name, animatableTemplate);
}

});
parcelRegister("h6Iiw", function(module, exports) {

$parcel$export(module.exports, "getAnimatableNone", function () { return $a6324f331d30f12e$export$cea0cedcb94873b5; });

var $FH6ft = parcelRequire("FH6ft");

var $9SyCl = parcelRequire("9SyCl");

var $1NxtI = parcelRequire("1NxtI");

var $gVs7l = parcelRequire("gVs7l");
const $a6324f331d30f12e$var$customTypes = /*@__PURE__*/ new Set([
    (0, $9SyCl.filter),
    (0, $1NxtI.mask)
]);
function $a6324f331d30f12e$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $gVs7l.getDefaultValueType)(key);
    if (!$a6324f331d30f12e$var$customTypes.has(defaultValueType)) defaultValueType = (0, $FH6ft.complex);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}

});
parcelRegister("9SyCl", function(module, exports) {

$parcel$export(module.exports, "filter", function () { return $5eadb906d7cb4f97$export$3dea766d36a8935f; });

var $FH6ft = parcelRequire("FH6ft");

var $33GHc = parcelRequire("33GHc");
/**
 * Properties that should default to 1 or 100%
 */ const $5eadb906d7cb4f97$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $5eadb906d7cb4f97$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $33GHc.floatRegex)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $5eadb906d7cb4f97$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $5eadb906d7cb4f97$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $5eadb906d7cb4f97$export$3dea766d36a8935f = {
    ...(0, $FH6ft.complex),
    getAnimatableNone: (v)=>{
        const functions = v.match($5eadb906d7cb4f97$var$functionRegex);
        return functions ? functions.map($5eadb906d7cb4f97$var$applyDefaultFilter).join(" ") : v;
    }
};

});

parcelRegister("1NxtI", function(module, exports) {

$parcel$export(module.exports, "mask", function () { return $68dbe71415cdbee1$export$d99f0801a68bbcf1; });

var $FH6ft = parcelRequire("FH6ft");
const $68dbe71415cdbee1$export$d99f0801a68bbcf1 = {
    ...(0, $FH6ft.complex),
    getAnimatableNone: (v)=>{
        const parsed = (0, $FH6ft.complex).parse(v);
        const transformer = (0, $FH6ft.complex).createTransformer(v);
        return transformer(parsed.map((v)=>typeof v === "number" ? 0 : typeof v === "object" ? {
                ...v,
                alpha: 1
            } : v));
    }
};

});

parcelRegister("gVs7l", function(module, exports) {

$parcel$export(module.exports, "getDefaultValueType", function () { return $4f34bdc9b52d7b1d$export$67d1babe0338d23b; });

var $5gJ5G = parcelRequire("5gJ5G");

var $9SyCl = parcelRequire("9SyCl");

var $1NxtI = parcelRequire("1NxtI");

var $5lj7n = parcelRequire("5lj7n");
/**
 * A map of default value types for common values
 */ const $4f34bdc9b52d7b1d$export$98cd7c72c5a731fb = {
    ...(0, $5lj7n.numberValueTypes),
    color: // Color props
    $5gJ5G.color,
    backgroundColor: (0, $5gJ5G.color),
    outlineColor: (0, $5gJ5G.color),
    fill: (0, $5gJ5G.color),
    stroke: (0, $5gJ5G.color),
    // Border props
    borderColor: (0, $5gJ5G.color),
    borderTopColor: (0, $5gJ5G.color),
    borderRightColor: (0, $5gJ5G.color),
    borderBottomColor: (0, $5gJ5G.color),
    borderLeftColor: (0, $5gJ5G.color),
    filter: $9SyCl.filter,
    WebkitFilter: (0, $9SyCl.filter),
    mask: $1NxtI.mask,
    WebkitMask: (0, $1NxtI.mask)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $4f34bdc9b52d7b1d$export$67d1babe0338d23b = (key)=>$4f34bdc9b52d7b1d$export$98cd7c72c5a731fb[key];

});
parcelRegister("5lj7n", function(module, exports) {

$parcel$export(module.exports, "numberValueTypes", function () { return $d954abda96ea0996$export$eec14432cd1cb67b; });

var $jo7Yx = parcelRequire("jo7Yx");

var $4FpLb = parcelRequire("4FpLb");

var $8ID0m = parcelRequire("8ID0m");

var $4AJly = parcelRequire("4AJly");
const $d954abda96ea0996$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $8ID0m.px),
    borderTopWidth: (0, $8ID0m.px),
    borderRightWidth: (0, $8ID0m.px),
    borderBottomWidth: (0, $8ID0m.px),
    borderLeftWidth: (0, $8ID0m.px),
    borderRadius: (0, $8ID0m.px),
    borderTopLeftRadius: (0, $8ID0m.px),
    borderTopRightRadius: (0, $8ID0m.px),
    borderBottomRightRadius: (0, $8ID0m.px),
    borderBottomLeftRadius: (0, $8ID0m.px),
    // Positioning props
    width: (0, $8ID0m.px),
    maxWidth: (0, $8ID0m.px),
    height: (0, $8ID0m.px),
    maxHeight: (0, $8ID0m.px),
    top: (0, $8ID0m.px),
    right: (0, $8ID0m.px),
    bottom: (0, $8ID0m.px),
    left: (0, $8ID0m.px),
    inset: (0, $8ID0m.px),
    insetBlock: (0, $8ID0m.px),
    insetBlockStart: (0, $8ID0m.px),
    insetBlockEnd: (0, $8ID0m.px),
    insetInline: (0, $8ID0m.px),
    insetInlineStart: (0, $8ID0m.px),
    insetInlineEnd: (0, $8ID0m.px),
    // Spacing props
    padding: (0, $8ID0m.px),
    paddingTop: (0, $8ID0m.px),
    paddingRight: (0, $8ID0m.px),
    paddingBottom: (0, $8ID0m.px),
    paddingLeft: (0, $8ID0m.px),
    paddingBlock: (0, $8ID0m.px),
    paddingBlockStart: (0, $8ID0m.px),
    paddingBlockEnd: (0, $8ID0m.px),
    paddingInline: (0, $8ID0m.px),
    paddingInlineStart: (0, $8ID0m.px),
    paddingInlineEnd: (0, $8ID0m.px),
    margin: (0, $8ID0m.px),
    marginTop: (0, $8ID0m.px),
    marginRight: (0, $8ID0m.px),
    marginBottom: (0, $8ID0m.px),
    marginLeft: (0, $8ID0m.px),
    marginBlock: (0, $8ID0m.px),
    marginBlockStart: (0, $8ID0m.px),
    marginBlockEnd: (0, $8ID0m.px),
    marginInline: (0, $8ID0m.px),
    marginInlineStart: (0, $8ID0m.px),
    marginInlineEnd: (0, $8ID0m.px),
    // Typography
    fontSize: (0, $8ID0m.px),
    // Misc
    backgroundPositionX: (0, $8ID0m.px),
    backgroundPositionY: (0, $8ID0m.px),
    ...(0, $4AJly.transformValueTypes),
    zIndex: (0, $jo7Yx.int),
    // SVG
    fillOpacity: (0, $4FpLb.alpha),
    strokeOpacity: (0, $4FpLb.alpha),
    numOctaves: (0, $jo7Yx.int)
};

});
parcelRegister("jo7Yx", function(module, exports) {

$parcel$export(module.exports, "int", function () { return $8e24186f0b4b6a11$export$7d260a2a5f8bc19e; });

var $4FpLb = parcelRequire("4FpLb");
const $8e24186f0b4b6a11$export$7d260a2a5f8bc19e = {
    ...(0, $4FpLb.number),
    transform: Math.round
};

});

parcelRegister("4AJly", function(module, exports) {

$parcel$export(module.exports, "transformValueTypes", function () { return $134d2ed44a1eadc8$export$f2e4285fee37e26; });

var $4FpLb = parcelRequire("4FpLb");

var $8ID0m = parcelRequire("8ID0m");
const $134d2ed44a1eadc8$export$f2e4285fee37e26 = {
    rotate: (0, $8ID0m.degrees),
    /**
     * Internal channel for `transition.path` orientToPath. Composed onto
     * `rotate` at the transform-build sites so the user's `rotate` is
     * never read or overwritten. Not part of `transformPropOrder`.
     */ pathRotation: (0, $8ID0m.degrees),
    rotateX: (0, $8ID0m.degrees),
    rotateY: (0, $8ID0m.degrees),
    rotateZ: (0, $8ID0m.degrees),
    scale: $4FpLb.scale,
    scaleX: (0, $4FpLb.scale),
    scaleY: (0, $4FpLb.scale),
    scaleZ: (0, $4FpLb.scale),
    skew: (0, $8ID0m.degrees),
    skewX: (0, $8ID0m.degrees),
    skewY: (0, $8ID0m.degrees),
    distance: (0, $8ID0m.px),
    translateX: (0, $8ID0m.px),
    translateY: (0, $8ID0m.px),
    translateZ: (0, $8ID0m.px),
    x: (0, $8ID0m.px),
    y: (0, $8ID0m.px),
    z: (0, $8ID0m.px),
    perspective: (0, $8ID0m.px),
    transformPerspective: (0, $8ID0m.px),
    opacity: (0, $4FpLb.alpha),
    originX: (0, $8ID0m.progressPercentage),
    originY: (0, $8ID0m.progressPercentage),
    originZ: (0, $8ID0m.px)
};

});






parcelRegister("clmLY", function(module, exports) {

$parcel$export(module.exports, "VisualElement", function () { return $67fdc880829ae48a$export$fa8b653c0f3714e5; });

var $krm4n = parcelRequire("krm4n");
var $cNP8X = parcelRequire("cNP8X");
var $jzxS7 = parcelRequire("jzxS7");
var $biy51 = parcelRequire("biy51");

var $eIAC2 = parcelRequire("eIAC2");

var $b8deO = parcelRequire("b8deO");

var $i2hvp = parcelRequire("i2hvp");

var $cTWE0 = parcelRequire("cTWE0");

var $iO0o7 = parcelRequire("iO0o7");

var $hxr3J = parcelRequire("hxr3J");

var $52PJo = parcelRequire("52PJo");

var $FH6ft = parcelRequire("FH6ft");

var $h6Iiw = parcelRequire("h6Iiw");

var $djMqu = parcelRequire("djMqu");

var $dP4pV = parcelRequire("dP4pV");

var $1Zt2N = parcelRequire("1Zt2N");

var $5eWC7 = parcelRequire("5eWC7");

var $cYSzx = parcelRequire("cYSzx");

var $dvKYx = parcelRequire("dvKYx");

var $ksrlB = parcelRequire("ksrlB");

var $crPmA = parcelRequire("crPmA");

var $hO6ti = parcelRequire("hO6ti");

var $ibWTn = parcelRequire("ibWTn");
const $67fdc880829ae48a$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * Static feature definitions - can be injected by framework layer
 */ let $67fdc880829ae48a$var$featureDefinitions = {};
/**
 * Set feature definitions for all VisualElements.
 * This should be called by the framework layer (e.g., framer-motion) during initialization.
 */ function $67fdc880829ae48a$export$8ad214844176d967(definitions) {
    $67fdc880829ae48a$var$featureDefinitions = definitions;
}
/**
 * Get the current feature definitions
 */ function $67fdc880829ae48a$export$e183cb9c018608ba() {
    return $67fdc880829ae48a$var$featureDefinitions;
}
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $67fdc880829ae48a$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, skipAnimations: skipAnimations, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * Decides whether animations should be skipped for this VisualElement.
         * Useful for E2E tests and visual regression testing.
         */ this.shouldSkipAnimations = false;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $eIAC2.KeyframeResolver);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * Track whether this element has been mounted before, to detect
         * remounts after Suspense unmount/remount cycles.
         */ this.hasBeenMounted = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $iO0o7.time).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $ibWTn.frame).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.skipAnimationsConfig = skipAnimations;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $5eWC7.isControllingVariants)(props);
        this.isVariantNode = (0, $5eWC7.isVariantNode)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $dP4pV.isMotionValue)(value)) value.set(latestValues[key]);
        }
    }
    mount(instance) {
        /**
         * If this element has been mounted before (e.g. after a Suspense
         * unmount/remount), reset motion values to their initial state
         * so animations replay correctly from initial → animate.
         */ if (this.hasBeenMounted) for(const key in this.initialValues){
            this.values.get(key)?.jump(this.initialValues[key]);
            this.latestValues[key] = this.initialValues[key];
        }
        this.current = instance;
        (0, $1Zt2N.visualElementStore).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        /**
         * Determine reduced motion preference. Only initialize the matchMedia
         * listener if we actually need the dynamic value (i.e., when config
         * is neither "never" nor "always").
         */ if (this.reducedMotionConfig === "never") this.shouldReduceMotion = false;
        else if (this.reducedMotionConfig === "always") this.shouldReduceMotion = true;
        else {
            if (!(0, $hO6ti.hasReducedMotionListener).current) (0, $ksrlB.initPrefersReducedMotion)();
            this.shouldReduceMotion = (0, $hO6ti.prefersReducedMotion).current;
        }
        /**
         * Set whether animations should be skipped based on the config.
         */ this.shouldSkipAnimations = this.skipAnimationsConfig ?? false;
        this.parent?.addChild(this);
        this.update(this.props, this.presenceContext);
        this.hasBeenMounted = true;
    }
    unmount() {
        this.projection && this.projection.unmount();
        (0, $ibWTn.cancelFrame)(this.notifyUpdate);
        (0, $ibWTn.cancelFrame)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent?.removeChild(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    addChild(child) {
        this.children.add(child);
        this.enteringChildren ?? (this.enteringChildren = new Set());
        this.enteringChildren.add(child);
    }
    removeChild(child) {
        this.children.delete(child);
        this.enteringChildren && this.enteringChildren.delete(child);
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        if (value.accelerate && (0, $i2hvp.acceleratedValues).has(key) && this.current instanceof HTMLElement) {
            const { factory: factory, keyframes: keyframes, times: times, ease: ease, duration: duration } = value.accelerate;
            const animation = new (0, $b8deO.NativeAnimation)({
                element: this.current,
                name: key,
                keyframes: keyframes,
                times: times,
                ease: ease,
                duration: (0, $jzxS7.secondsToMilliseconds)(duration)
            });
            const cleanup = factory(animation);
            this.valueSubscriptions.set(key, ()=>{
                cleanup();
                animation.cancel();
            });
            return;
        }
        const valueIsTransform = (0, $cYSzx.transformProps).has(key);
        if (valueIsTransform && this.onBindTransform) this.onBindTransform();
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $ibWTn.frame).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
            this.scheduleRender();
        });
        let removeSyncCheck;
        if (typeof window !== "undefined" && window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            if (removeSyncCheck) removeSyncCheck();
        // Defer to MotionValue.on("change") auto-stop so React 19 remounts
        // can resubscribe before the animation is cancelled (#3315).
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in $67fdc880829ae48a$var$featureDefinitions){
            const featureDefinition = $67fdc880829ae48a$var$featureDefinitions[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $hxr3J.createBox)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $67fdc880829ae48a$var$propEventHandlers.length; i++){
            const key = $67fdc880829ae48a$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $dvKYx.updateMotionValuesFromProps)(this, this.scrapeMotionValuesFromProps(props, this.prevProps || {}, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $52PJo.motionValue)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : this.getBaseTargetFromProps(this.props, key) ?? this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $krm4n.isNumericalString)(value) || (0, $cNP8X.isZeroValueString)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $djMqu.findValueType)(value) && (0, $FH6ft.complex).test(target)) value = (0, $h6Iiw.getAnimatableNone)(key, target);
            this.setBaseTarget(key, (0, $dP4pV.isMotionValue)(value) ? value.get() : value);
        }
        return (0, $dP4pV.isMotionValue)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $crPmA.resolveVariantFromProps)(this.props, initial, this.presenceContext?.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $dP4pV.isMotionValue)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $biy51.SubscriptionManager)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
    scheduleRenderMicrotask() {
        (0, $cTWE0.microtask).render(this.render);
    }
}

});
parcelRegister("cTWE0", function(module, exports) {

$parcel$export(module.exports, "microtask", function () { return $4cb138f42ee448c1$export$bb76eed83315504c; });

var $lCeLL = parcelRequire("lCeLL");
const { schedule: $4cb138f42ee448c1$export$bb76eed83315504c, cancel: $4cb138f42ee448c1$export$3252729004b8456e } = /* @__PURE__ */ (0, $lCeLL.createRenderBatcher)(queueMicrotask, false);

});

parcelRegister("hxr3J", function(module, exports) {

$parcel$export(module.exports, "createBox", function () { return $a0d315cc230b7b79$export$6459fc9e86be362e; });
const $a0d315cc230b7b79$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $a0d315cc230b7b79$export$3d227df54007d73a = ()=>({
        x: $a0d315cc230b7b79$export$ff25708b37f72782(),
        y: $a0d315cc230b7b79$export$ff25708b37f72782()
    });
const $a0d315cc230b7b79$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $a0d315cc230b7b79$export$6459fc9e86be362e = ()=>({
        x: $a0d315cc230b7b79$export$6db76765312617ac(),
        y: $a0d315cc230b7b79$export$6db76765312617ac()
    });

});

parcelRegister("djMqu", function(module, exports) {

$parcel$export(module.exports, "findValueType", function () { return $d47a0afa4e4d071c$export$950e7e59ea1ffed7; });

var $5gJ5G = parcelRequire("5gJ5G");

var $FH6ft = parcelRequire("FH6ft");

var $cjHjH = parcelRequire("cjHjH");

var $6D3YI = parcelRequire("6D3YI");
/**
 * A list of all ValueTypes
 */ const $d47a0afa4e4d071c$var$valueTypes = [
    ...(0, $cjHjH.dimensionValueTypes),
    (0, $5gJ5G.color),
    (0, $FH6ft.complex)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $d47a0afa4e4d071c$export$950e7e59ea1ffed7 = (v)=>$d47a0afa4e4d071c$var$valueTypes.find((0, $6D3YI.testValueType)(v));

});

parcelRegister("5eWC7", function(module, exports) {

$parcel$export(module.exports, "isControllingVariants", function () { return $05ee406980932703$export$4b3c3bd8d910d78d; });
$parcel$export(module.exports, "isVariantNode", function () { return $05ee406980932703$export$ce46fa4165cdec40; });

var $lQVYW = parcelRequire("lQVYW");

var $7Xwp0 = parcelRequire("7Xwp0");

var $eqNk1 = parcelRequire("eqNk1");
function $05ee406980932703$export$4b3c3bd8d910d78d(props) {
    return (0, $lQVYW.isAnimationControls)(props.animate) || (0, $eqNk1.variantProps).some((name)=>(0, $7Xwp0.isVariantLabel)(props[name]));
}
function $05ee406980932703$export$ce46fa4165cdec40(props) {
    return Boolean($05ee406980932703$export$4b3c3bd8d910d78d(props) || props.variants);
}

});
parcelRegister("lQVYW", function(module, exports) {

$parcel$export(module.exports, "isAnimationControls", function () { return $197e81262ee8f44d$export$aa71198ceeaf53ce; });
function $197e81262ee8f44d$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}

});

parcelRegister("7Xwp0", function(module, exports) {

$parcel$export(module.exports, "isVariantLabel", function () { return $b2fb93622bbd7df5$export$720b90e312cea233; });
/**
 * Decides if the supplied variable is variant label
 */ function $b2fb93622bbd7df5$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}

});

parcelRegister("eqNk1", function(module, exports) {

$parcel$export(module.exports, "variantProps", function () { return $c8a0734e2ee77275$export$1405a65085f40b9; });
const $c8a0734e2ee77275$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $c8a0734e2ee77275$export$1405a65085f40b9 = [
    "initial",
    ...$c8a0734e2ee77275$export$16e45afcc206d3a8
];

});


parcelRegister("dvKYx", function(module, exports) {

$parcel$export(module.exports, "updateMotionValuesFromProps", function () { return $16da05f34cd867a6$export$9a552858d5197f6e; });

var $52PJo = parcelRequire("52PJo");

var $dP4pV = parcelRequire("dP4pV");
/**
 * Updates motion values from props changes.
 * Uses `any` type for element to avoid circular dependencies with VisualElement.
 */ function $16da05f34cd867a6$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $dP4pV.isMotionValue)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $dP4pV.isMotionValue)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $52PJo.motionValue)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $52PJo.motionValue)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}

});

parcelRegister("ksrlB", function(module, exports) {

$parcel$export(module.exports, "initPrefersReducedMotion", function () { return $904a5ee8b5b90ab9$export$ca9f41fb23dded3d; });

var $hO6ti = parcelRequire("hO6ti");
const $904a5ee8b5b90ab9$var$isBrowser = typeof window !== "undefined";
function $904a5ee8b5b90ab9$export$ca9f41fb23dded3d() {
    (0, $hO6ti.hasReducedMotionListener).current = true;
    if (!$904a5ee8b5b90ab9$var$isBrowser) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $hO6ti.prefersReducedMotion).current = motionMediaQuery.matches;
        motionMediaQuery.addEventListener("change", setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $hO6ti.prefersReducedMotion).current = false;
}

});
parcelRegister("hO6ti", function(module, exports) {

$parcel$export(module.exports, "prefersReducedMotion", function () { return $ab7a52d88671d240$export$ff7706047246b98b; });
$parcel$export(module.exports, "hasReducedMotionListener", function () { return $ab7a52d88671d240$export$6476d16e2fd2d0db; });
// Does this device prefer reduced motion? Returns `null` server-side.
const $ab7a52d88671d240$export$ff7706047246b98b = {
    current: null
};
const $ab7a52d88671d240$export$6476d16e2fd2d0db = {
    current: false
};

});




parcelRegister("e6p9v", function(module, exports) {

$parcel$export(module.exports, "buildHTMLStyles", function () { return $4a12369564e40a1a$export$bb517f8b40f8e99d; });

var $fXvdU = parcelRequire("fXvdU");

var $5lj7n = parcelRequire("5lj7n");

var $cYSzx = parcelRequire("cYSzx");

var $fop0M = parcelRequire("fop0M");

var $5JTYy = parcelRequire("5JTYy");
function $4a12369564e40a1a$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $cYSzx.transformProps).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $fop0M.isCSSVariableName)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $fXvdU.getValueAsType)(value, (0, $5lj7n.numberValueTypes)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $5JTYy.buildTransform)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}

});
parcelRegister("fXvdU", function(module, exports) {

$parcel$export(module.exports, "getValueAsType", function () { return $1f8f8a4cd1b31868$export$453ef540a9a1bd6b; });
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $1f8f8a4cd1b31868$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};

});

parcelRegister("5JTYy", function(module, exports) {

$parcel$export(module.exports, "buildTransform", function () { return $780bba6e980489ff$export$bdc96e0d5c8f914; });

var $fXvdU = parcelRequire("fXvdU");

var $5lj7n = parcelRequire("5lj7n");

var $cYSzx = parcelRequire("cYSzx");
const $780bba6e980489ff$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $780bba6e980489ff$var$numTransforms = (0, $cYSzx.transformPropOrder).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $780bba6e980489ff$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $780bba6e980489ff$var$numTransforms; i++){
        const key = (0, $cYSzx.transformPropOrder)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else {
            const parsed = parseFloat(value);
            valueIsDefault = key.startsWith("scale") ? parsed === 1 : parsed === 0;
        }
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $fXvdU.getValueAsType)(value, (0, $5lj7n.numberValueTypes)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $780bba6e980489ff$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    // `pathRotation` composes onto `rotate` as a separate additive term so
    // the user's `rotate` is never clobbered. Deliberately not a slot in
    // `transformPropOrder`.
    const pathRotation = latestValues.pathRotation;
    if (pathRotation) {
        transformIsDefault = false;
        transformString += `rotate(${(0, $fXvdU.getValueAsType)(pathRotation, (0, $5lj7n.numberValueTypes).pathRotation)}) `;
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}

});


parcelRegister("aU7mD", function(module, exports) {

$parcel$export(module.exports, "renderHTML", function () { return $249f8557c7bc151a$export$1a32bf6229c258c0; });
function $249f8557c7bc151a$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    const elementStyle = element.style;
    let key;
    for(key in style)// CSSStyleDeclaration has [index: number]: string; in the types, so we use that as key type.
    elementStyle[key] = style[key];
    // Write projection styles directly to element style
    projection?.applyProjectionStyles(elementStyle, styleProp);
    for(key in vars)// Loop over any CSS variables and assign those.
    // They can only be assigned using `setProperty`.
    elementStyle.setProperty(key, vars[key]);
}

});

parcelRegister("ecTQD", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $bb3887c01d961675$export$16da615486abaa45; });

var $dP4pV = parcelRequire("dP4pV");

var $5W35f = parcelRequire("5W35f");
function $bb3887c01d961675$export$16da615486abaa45(props, prevProps, visualElement) {
    const style = props.style;
    const prevStyle = prevProps?.style;
    const newValues = {};
    if (!style) return newValues;
    for(const key in style)if ((0, $dP4pV.isMotionValue)(style[key]) || prevStyle && (0, $dP4pV.isMotionValue)(prevStyle[key]) || (0, $5W35f.isForcedMotionValue)(key, props) || visualElement?.getValue(key)?.liveStyle !== undefined) newValues[key] = style[key];
    return newValues;
}

});
parcelRegister("5W35f", function(module, exports) {

$parcel$export(module.exports, "isForcedMotionValue", function () { return $b4fc036121a01de5$export$6d27ce8e3de1c3cf; });

var $cYSzx = parcelRequire("cYSzx");

var $2v5l0 = parcelRequire("2v5l0");
function $b4fc036121a01de5$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $cYSzx.transformProps).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $2v5l0.scaleCorrectors)[key] || key === "opacity");
}

});
parcelRegister("2v5l0", function(module, exports) {

$parcel$export(module.exports, "scaleCorrectors", function () { return $e69bce41e90c0a87$export$91ddd985b97788d1; });

var $fop0M = parcelRequire("fop0M");

var $kZPw4 = parcelRequire("kZPw4");

var $eMRUr = parcelRequire("eMRUr");

var $4QEX1 = parcelRequire("4QEX1");
const $e69bce41e90c0a87$export$91ddd985b97788d1 = {
    borderRadius: {
        ...(0, $eMRUr.correctBorderRadius),
        applyTo: [
            ...(0, $kZPw4.cornerRadiusProps)
        ]
    },
    borderTopLeftRadius: (0, $eMRUr.correctBorderRadius),
    borderTopRightRadius: (0, $eMRUr.correctBorderRadius),
    borderBottomLeftRadius: (0, $eMRUr.correctBorderRadius),
    borderBottomRightRadius: (0, $eMRUr.correctBorderRadius),
    boxShadow: (0, $4QEX1.correctBoxShadow)
};
function $e69bce41e90c0a87$export$de9e7791c71225fd(correctors) {
    for(const key in correctors){
        $e69bce41e90c0a87$export$91ddd985b97788d1[key] = correctors[key];
        if ((0, $fop0M.isCSSVariableName)(key)) $e69bce41e90c0a87$export$91ddd985b97788d1[key].isCSSVariable = true;
    }
}

});
parcelRegister("kZPw4", function(module, exports) {

$parcel$export(module.exports, "cornerRadiusProps", function () { return $184da4a7f0af456c$export$41ef21965ed84e7a; });
/**
 * The four corner-radius longhands. Shared so the projection mixer, scale
 * corrector, WAAPI px-value set and view-transition crop pass don't each carry
 * their own copy. Order is irrelevant - every consumer mixes/corrects/animates
 * each corner independently.
 */ const $184da4a7f0af456c$export$41ef21965ed84e7a = [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomRightRadius",
    "borderBottomLeftRadius"
];

});

parcelRegister("eMRUr", function(module, exports) {

$parcel$export(module.exports, "correctBorderRadius", function () { return $2b08ad704c89288c$export$5eafb6257a5844c; });

var $8ID0m = parcelRequire("8ID0m");
function $2b08ad704c89288c$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $2b08ad704c89288c$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $8ID0m.px).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $2b08ad704c89288c$export$fafff692be55225d(latest, node.target.x);
        const y = $2b08ad704c89288c$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};

});

parcelRegister("4QEX1", function(module, exports) {

$parcel$export(module.exports, "correctBoxShadow", function () { return $918aeea44afb5b07$export$eb0bc629e74dcf8; });

var $FH6ft = parcelRequire("FH6ft");

var $e9BqC = parcelRequire("e9BqC");
const $918aeea44afb5b07$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $FH6ft.complex).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $FH6ft.complex).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $e9BqC.mixNumber)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};

});





parcelRegister("4q1M5", function(module, exports) {

$parcel$export(module.exports, "isSVGElement", function () { return $d21d6497287d50b6$export$17eda790a720ec57; });

var $4X4Gl = parcelRequire("4X4Gl");
/**
 * Checks if an element is an SVG element in a way
 * that works across iframes
 */ function $d21d6497287d50b6$export$17eda790a720ec57(element) {
    return (0, $4X4Gl.isObject)(element) && "ownerSVGElement" in element;
}

});
parcelRegister("4X4Gl", function(module, exports) {

$parcel$export(module.exports, "isObject", function () { return $d93f81859b2d5a5f$export$a6cdc56e425d0d0a; });
const $d93f81859b2d5a5f$export$a6cdc56e425d0d0a = (value)=>typeof value === "object" && value !== null;

});


parcelRegister("hGGE9", function(module, exports) {

$parcel$export(module.exports, "isSVGSVGElement", function () { return $ee6f5690d36d6bc6$export$66957ea77182581d; });

var $4q1M5 = parcelRequire("4q1M5");
/**
 * Checks if an element is specifically an SVGSVGElement (the root SVG element)
 * in a way that works across iframes
 */ function $ee6f5690d36d6bc6$export$66957ea77182581d(element) {
    return (0, $4q1M5.isSVGElement)(element) && element.tagName === "svg";
}

});

parcelRegister("68Xt5", function(module, exports) {

$parcel$export(module.exports, "ObjectVisualElement", function () { return $690a5503e9c66e24$export$fe67a5eca4e986d6; });

var $hxr3J = parcelRequire("hxr3J");

var $clmLY = parcelRequire("clmLY");
function $690a5503e9c66e24$var$isObjectKey(key, object) {
    return key in object;
}
class $690a5503e9c66e24$export$fe67a5eca4e986d6 extends (0, $clmLY.VisualElement) {
    constructor(){
        super(...arguments);
        this.type = "object";
    }
    readValueFromInstance(instance, key) {
        if ($690a5503e9c66e24$var$isObjectKey(key, instance)) {
            const value = instance[key];
            if (typeof value === "string" || typeof value === "number") return value;
        }
        return undefined;
    }
    getBaseTargetFromProps() {
        return undefined;
    }
    removeValueFromRenderState(key, renderState) {
        delete renderState.output[key];
    }
    measureInstanceViewportBox() {
        return (0, $hxr3J.createBox)();
    }
    build(renderState, latestValues) {
        Object.assign(renderState.output, latestValues);
    }
    renderInstance(instance, { output: output }) {
        Object.assign(instance, output);
    }
    sortInstanceNodePosition() {
        return 0;
    }
}

});

parcelRegister("eqSva", function(module, exports) {

$parcel$export(module.exports, "SVGVisualElement", function () { return $ea5a8c056a9a6168$export$86bcdffbaf733d84; });

var $cYSzx = parcelRequire("cYSzx");

var $gVs7l = parcelRequire("gVs7l");

var $hxr3J = parcelRequire("hxr3J");

var $hGB06 = parcelRequire("hGB06");

var $eXAoN = parcelRequire("eXAoN");

var $lAnne = parcelRequire("lAnne");

var $hQ7Xq = parcelRequire("hQ7Xq");

var $bRUDT = parcelRequire("bRUDT");

var $lpxqq = parcelRequire("lpxqq");

var $1LfRn = parcelRequire("1LfRn");
class $ea5a8c056a9a6168$export$86bcdffbaf733d84 extends (0, $hGB06.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $hxr3J.createBox);
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $cYSzx.transformProps).has(key)) {
            const defaultType = (0, $gVs7l.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $hQ7Xq.camelCaseAttributes).has(key) ? (0, $eXAoN.camelToDash)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $1LfRn.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $lAnne.buildSVGAttrs)(renderState, latestValues, this.isSVGTag, props.transformTemplate, props.style);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $lpxqq.renderSVG)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $bRUDT.isSVGTag)(instance.tagName);
        super.mount(instance);
    }
}

});
parcelRegister("lAnne", function(module, exports) {

$parcel$export(module.exports, "buildSVGAttrs", function () { return $b1850672c48c4c28$export$5475d24f125d7053; });

var $e6p9v = parcelRequire("e6p9v");

var $1Eoh9 = parcelRequire("1Eoh9");
/**
 * CSS Motion Path properties that should remain as CSS styles on SVG elements.
 */ const $b1850672c48c4c28$var$cssMotionPathProperties = [
    "offsetDistance",
    "offsetPath",
    "offsetRotate",
    "offsetAnchor"
];
/**
 * Build SVG visual attributes, like cx and style.transform
 */ function $b1850672c48c4c28$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate, styleProp) {
    (0, $e6p9v.buildHTMLStyles)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style } = state;
    /**
     * However, we apply transforms as CSS transforms.
     * So if we detect a transform, transformOrigin we take it from attrs and copy it into style.
     */ if (attrs.transform) {
        style.transform = attrs.transform;
        delete attrs.transform;
    }
    if (style.transform || attrs.transformOrigin) {
        style.transformOrigin = attrs.transformOrigin ?? "50% 50%";
        delete attrs.transformOrigin;
    }
    if (style.transform) {
        /**
         * SVG's element transform-origin uses its own median as a reference.
         * Therefore, transformBox becomes a fill-box
         */ style.transformBox = styleProp?.transformBox ?? "fill-box";
        delete attrs.transformBox;
    }
    for (const key of $b1850672c48c4c28$var$cssMotionPathProperties)if (attrs[key] !== undefined) {
        style[key] = attrs[key];
        delete attrs[key];
    }
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $1Eoh9.buildSVGPath)(attrs, pathLength, pathSpacing, pathOffset, false);
}

});
parcelRegister("1Eoh9", function(module, exports) {

$parcel$export(module.exports, "buildSVGPath", function () { return $17aabc3c06d8838a$export$311b43f666da1d82; });
const $17aabc3c06d8838a$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $17aabc3c06d8838a$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 *
 * Note: We use unitless values for stroke-dasharray and stroke-dashoffset
 * because Safari incorrectly scales px values when the page is zoomed.
 */ function $17aabc3c06d8838a$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $17aabc3c06d8838a$var$dashKeys : $17aabc3c06d8838a$var$camelKeys;
    // Build the dash offset (unitless to avoid Safari zoom bug)
    attrs[keys.offset] = `${-offset}`;
    // Build the dash array (unitless to avoid Safari zoom bug)
    attrs[keys.array] = `${length} ${spacing}`;
}

});


parcelRegister("hQ7Xq", function(module, exports) {

$parcel$export(module.exports, "camelCaseAttributes", function () { return $652662eb2acdfcdb$export$28931db5d57958e5; });
/**
 * A set of attribute names that are always read/written as camel case.
 */ const $652662eb2acdfcdb$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);

});

parcelRegister("bRUDT", function(module, exports) {

$parcel$export(module.exports, "isSVGTag", function () { return $fe39d18929b68f56$export$6328ce7565ea1049; });
const $fe39d18929b68f56$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";

});

parcelRegister("lpxqq", function(module, exports) {

$parcel$export(module.exports, "renderSVG", function () { return $08ed0d1bc64f3540$export$c5f8399d19a7394b; });

var $eXAoN = parcelRequire("eXAoN");

var $aU7mD = parcelRequire("aU7mD");

var $hQ7Xq = parcelRequire("hQ7Xq");
function $08ed0d1bc64f3540$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $aU7mD.renderHTML)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $hQ7Xq.camelCaseAttributes).has(key) ? (0, $eXAoN.camelToDash)(key) : key, renderState.attrs[key]);
}

});

parcelRegister("1LfRn", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $0cc03b58a88b997c$export$16da615486abaa45; });

var $dP4pV = parcelRequire("dP4pV");

var $cYSzx = parcelRequire("cYSzx");

var $ecTQD = parcelRequire("ecTQD");
function $0cc03b58a88b997c$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $ecTQD.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    for(const key in props)if ((0, $dP4pV.isMotionValue)(props[key]) || (0, $dP4pV.isMotionValue)(prevProps[key])) {
        const targetKey = (0, $cYSzx.transformPropOrder).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}

});






parcelRegister("eEsmF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09d3011bd3340518$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $aUdfW = parcelRequire("aUdfW");
var $8TDId = parcelRequire("8TDId");
var $3loMv = parcelRequire("3loMv");

var $7fPBF = parcelRequire("7fPBF");

var $QgwxG = parcelRequire("QgwxG");
function $09d3011bd3340518$export$2e2bcd8739ae039(props) {
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8TDId.default), {
                "aria-label": "show image attribution",
                onClick: ()=>setOpen(true),
                children: /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                    alt: "CreativeCommons-Attribution-ShareAlike",
                    src: (0, $QgwxG.copyright),
                    style: {
                        width: props.width || 60
                    }
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aUdfW.default), {
                open: open,
                onClose: ()=>setOpen(false),
                children: props.images.map((image, index)=>/*#__PURE__*/ (0, $bbzbN.jsx)($09d3011bd3340518$var$ImageAttribution, {
                        ...image
                    }, index))
            })
        ]
    });
}
/** Typography with attribution info and links for an image */ function $09d3011bd3340518$var$ImageAttribution(props) {
    const nameLink = props.nameHref ? /*#__PURE__*/ (0, $bbzbN.jsx)("a", {
        href: props.nameHref,
        rel: "noreferrer",
        target: "_blank",
        children: props.name
    }) : props.name;
    const byLink = props.byHref ? /*#__PURE__*/ (0, $bbzbN.jsx)("a", {
        href: props.byHref,
        rel: "noreferrer",
        target: "_blank",
        children: props.by
    }) : props.by;
    const licenseLink = props.licenseHref ? /*#__PURE__*/ (0, $bbzbN.jsx)("a", {
        href: props.licenseHref,
        rel: "noreferrer",
        target: "_blank",
        children: props.license
    }) : props.license;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3loMv.default), {
        children: [
            '\u2022 "',
            nameLink,
            '" by ',
            byLink,
            props.cropped ? ", cropped" : "",
            ", ",
            licenseLink
        ]
    });
}

});
parcelRegister("aUdfW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f096abd658f7c85$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $65Itt = parcelRequire("65Itt");

var $b6UUh = parcelRequire("b6UUh");

var $ehw51 = parcelRequire("ehw51");

var $8WhtA = parcelRequire("8WhtA");

var $a2ay0 = parcelRequire("a2ay0");

var $bqHow = parcelRequire("bqHow");

var $5wwR3 = parcelRequire("5wwR3");

var $jPUa4 = parcelRequire("jPUa4");

var $kDBhE = parcelRequire("kDBhE");
var $g9bTP = parcelRequire("g9bTP");

var $7uFHh = parcelRequire("7uFHh");

var $iVAEr = parcelRequire("iVAEr");

var $99c9I = parcelRequire("99c9I");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $7f096abd658f7c85$var$DialogBackdrop = (0, $kDBhE.default)((0, $jPUa4.default), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $7f096abd658f7c85$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $b6UUh.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $b6UUh.default)(scroll)}`,
            `paperWidth${(0, $b6UUh.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $bqHow.getDialogUtilityClass), classes);
};
const $7f096abd658f7c85$var$DialogRoot = (0, $kDBhE.default)((0, $ehw51.default), {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $7f096abd658f7c85$var$DialogContainer = (0, $kDBhE.default)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $b6UUh.default)(ownerState.scroll)}`]
        ];
    }
})({
    height: '100%',
    '@media print': {
        height: 'auto'
    },
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    variants: [
        {
            props: {
                scroll: 'paper'
            },
            style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
        },
        {
            props: {
                scroll: 'body'
            },
            style: {
                overflowY: 'auto',
                overflowX: 'hidden',
                textAlign: 'center',
                '&::after': {
                    content: '""',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    height: '100%',
                    width: '0'
                }
            }
        }
    ]
});
const $7f096abd658f7c85$var$DialogPaper = (0, $kDBhE.default)((0, $a2ay0.default), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $b6UUh.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $b6UUh.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})((0, $7uFHh.default)(({ theme: theme })=>({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        },
        variants: [
            {
                props: {
                    scroll: 'paper'
                },
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    scroll: 'body'
                },
                style: {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    textAlign: 'initial'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.maxWidth,
                style: {
                    maxWidth: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    maxWidth: 'xs'
                },
                style: {
                    maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
                    [`&.${(0, $bqHow.default).paperScrollBody}`]: {
                        [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                            maxWidth: 'calc(100% - 64px)'
                        }
                    }
                }
            },
            ...Object.keys(theme.breakpoints.values).filter((maxWidth)=>maxWidth !== 'xs').map((maxWidth)=>({
                    props: {
                        maxWidth: maxWidth
                    },
                    style: {
                        maxWidth: `${theme.breakpoints.values[maxWidth]}${theme.breakpoints.unit}`,
                        [`&.${(0, $bqHow.default).paperScrollBody}`]: {
                            [theme.breakpoints.down(theme.breakpoints.values[maxWidth] + 64)]: {
                                maxWidth: 'calc(100% - 64px)'
                            }
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: 'calc(100% - 64px)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullScreen,
                style: {
                    margin: 0,
                    width: '100%',
                    maxWidth: '100%',
                    height: '100%',
                    maxHeight: 'none',
                    borderRadius: 0,
                    [`&.${(0, $bqHow.default).paperScrollBody}`]: {
                        margin: 0,
                        maxWidth: '100%'
                    }
                }
            }
        ]
    })));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $7f096abd658f7c85$var$Dialog = /*#__PURE__*/ $7fPBF.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $g9bTP.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, 'aria-modal': ariaModal = true, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $a2ay0.default), PaperProps: PaperProps = {}, scroll: scroll = 'paper', slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponent = (0, $8WhtA.default), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps, ...other } = props;
    const ownerState = {
        ...props,
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    };
    const classes = $7f096abd658f7c85$var$useUtilityClasses(ownerState);
    const backdropClick = $7fPBF.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $65Itt.default)(ariaLabelledbyProp);
    const dialogContextValue = $7fPBF.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    const backwardCompatibleSlots = {
        transition: TransitionComponent,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionProps,
        paper: PaperProps,
        backdrop: BackdropProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootSlotProps] = (0, $99c9I.default)('root', {
        elementType: $7f096abd658f7c85$var$DialogRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref
    });
    const [BackdropSlot, backdropSlotProps] = (0, $99c9I.default)('backdrop', {
        elementType: $7f096abd658f7c85$var$DialogBackdrop,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [PaperSlot, paperSlotProps] = (0, $99c9I.default)('paper', {
        elementType: $7f096abd658f7c85$var$DialogPaper,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.paper, PaperProps.className)
    });
    const [ContainerSlot, containerSlotProps] = (0, $99c9I.default)('container', {
        elementType: $7f096abd658f7c85$var$DialogContainer,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.container)
    });
    const [TransitionSlot, transitionSlotProps] = (0, $99c9I.default)('transition', {
        elementType: (0, $8WhtA.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: 'presentation'
        }
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)(RootSlot, {
        closeAfterTransition: true,
        slots: {
            backdrop: BackdropSlot
        },
        slotProps: {
            backdrop: {
                transitionDuration: transitionDuration,
                as: BackdropComponent,
                ...backdropSlotProps
            }
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        onClick: handleBackdropClick,
        ...rootSlotProps,
        ...other,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)(ContainerSlot, {
                onMouseDown: handleMouseDown,
                ...containerSlotProps,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)(PaperSlot, {
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby,
                    "aria-modal": ariaModal,
                    ...paperSlotProps,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5wwR3.default).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                })
            })
        })
    });
});
var $7f096abd658f7c85$export$2e2bcd8739ae039 = $7f096abd658f7c85$var$Dialog;

});
parcelRegister("ehw51", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a65b89a1133e1fe4$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");



var $cFCqu = parcelRequire("cFCqu");

var $cbZpX = parcelRequire("cbZpX");

var $ayhm7 = parcelRequire("ayhm7");

var $kDBhE = parcelRequire("kDBhE");

var $7uFHh = parcelRequire("7uFHh");

var $iVAEr = parcelRequire("iVAEr");

var $jPUa4 = parcelRequire("jPUa4");

var $g3t58 = parcelRequire("g3t58");

var $1Qt6b = parcelRequire("1Qt6b");

var $99c9I = parcelRequire("99c9I");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $a65b89a1133e1fe4$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $1Qt6b.getModalUtilityClass), classes);
};
const $a65b89a1133e1fe4$var$ModalRoot = (0, $kDBhE.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})((0, $7uFHh.default)(({ theme: theme })=>({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open && ownerState.exited,
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $a65b89a1133e1fe4$var$ModalBackdrop = (0, $kDBhE.default)((0, $jPUa4.default), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $a65b89a1133e1fe4$var$Modal = /*#__PURE__*/ $7fPBF.forwardRef(function Modal(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $a65b89a1133e1fe4$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classesProp, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, onClose: onClose, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, open: open, slotProps: slotProps = {}, slots: slots = {}, theme: // eslint-disable-next-line react/prop-types
    theme, ...other } = props;
    const propsWithDefaults = {
        ...props,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $g3t58.default)({
        ...propsWithDefaults,
        rootRef: ref
    });
    const ownerState = {
        ...propsWithDefaults,
        exited: exited
    };
    const classes = $a65b89a1133e1fe4$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const externalForwardedProps = {
        slots: {
            root: components.Root,
            backdrop: components.Backdrop,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, $99c9I.default)('root', {
        ref: ref,
        elementType: $a65b89a1133e1fe4$var$ModalRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        getSlotProps: getRootProps,
        ownerState: ownerState,
        className: (0, $hngXp.default)(className, classes?.root, !ownerState.open && ownerState.exited && classes?.hidden)
    });
    const [BackdropSlot, backdropProps] = (0, $99c9I.default)('backdrop', {
        ref: BackdropProps?.ref,
        elementType: BackdropComponent,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps({
                ...otherHandlers,
                onClick: (event)=>{
                    if (onBackdropClick) onBackdropClick(event);
                    if (otherHandlers?.onClick) otherHandlers.onClick(event);
                }
            });
        },
        className: (0, $hngXp.default)(BackdropProps?.className, classes?.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ayhm7.default), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)(RootSlot, {
            ...rootProps,
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $bbzbN.jsx)(BackdropSlot, {
                    ...backdropProps
                }) : null,
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cbZpX.default), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $7fPBF.cloneElement(children, childProps)
                })
            ]
        })
    });
});
var $a65b89a1133e1fe4$export$2e2bcd8739ae039 = $a65b89a1133e1fe4$var$Modal;

});
parcelRegister("cbZpX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e062765deddb857$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $bNCjr = parcelRequire("bNCjr");
var $4CS7n = parcelRequire("4CS7n");
var $jTdAm = parcelRequire("jTdAm");

var $bbzbN = parcelRequire("bbzbN");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $8e062765deddb857$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $8e062765deddb857$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://issues.chromium.org/issues/41283952
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $8e062765deddb857$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $8e062765deddb857$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $8e062765deddb857$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $8e062765deddb857$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($8e062765deddb857$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $8e062765deddb857$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$8e062765deddb857$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $8e062765deddb857$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $8e062765deddb857$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $8e062765deddb857$var$defaultGetTabbable, isEnabled: isEnabled = $8e062765deddb857$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $7fPBF.useRef(false);
    const sentinelStart = $7fPBF.useRef(null);
    const sentinelEnd = $7fPBF.useRef(null);
    const nodeToRestore = $7fPBF.useRef(null);
    const reactFocusEventTarget = $7fPBF.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $7fPBF.useRef(false);
    const rootRef = $7fPBF.useRef(null);
    const handleRef = (0, $jTdAm.default)((0, $bNCjr.default)(children), rootRef);
    const lastKeydown = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $4CS7n.default)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $4CS7n.default)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                const isShiftTab = Boolean(lastKeydown.current?.shiftKey && lastKeydown.current?.key === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $7fPBF.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $8e062765deddb857$export$2e2bcd8739ae039 = $8e062765deddb857$var$FocusTrap;

});
parcelRegister("bNCjr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8971fd60a8b100cf$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
function $8971fd60a8b100cf$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($7fPBF.version, 10) >= 19) return element?.props?.ref || null;
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return element?.ref || null;
}

});

parcelRegister("4CS7n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35e4b0c27d76b933$export$2e2bcd8739ae039; });
function $35e4b0c27d76b933$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});


parcelRegister("ayhm7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7aea8adc1cf7298d$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");


var $bNCjr = parcelRequire("bNCjr");
var $k0OO4 = parcelRequire("k0OO4");
var $lJRRs = parcelRequire("lJRRs");
var $jTdAm = parcelRequire("jTdAm");
'use client';
function $7aea8adc1cf7298d$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://v6.mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://v6.mui.com/material-ui/api/portal/)
 */ const $7aea8adc1cf7298d$var$Portal = /*#__PURE__*/ $7fPBF.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $7fPBF.useState(null);
    const handleRef = (0, $jTdAm.default)(/*#__PURE__*/ $7fPBF.isValidElement(children) ? (0, $bNCjr.default)(children) : null, forwardedRef);
    (0, $lJRRs.default)(()=>{
        if (!disablePortal) setMountNode($7aea8adc1cf7298d$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $lJRRs.default)(()=>{
        if (mountNode && !disablePortal) {
            (0, $k0OO4.default)(forwardedRef, mountNode);
            return ()=>{
                (0, $k0OO4.default)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $7fPBF.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $7fPBF.cloneElement(children, newProps);
        }
        return children;
    }
    return mountNode ? /*#__PURE__*/ $fw0lo.createPortal(children, mountNode) : mountNode;
});
var $7aea8adc1cf7298d$export$2e2bcd8739ae039 = $7aea8adc1cf7298d$var$Portal;

});
parcelRegister("k0OO4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e91b37e03c9e5276$export$2e2bcd8739ae039; });
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $e91b37e03c9e5276$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}

});


parcelRegister("jPUa4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e70e583d684cb5f4$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $99c9I = parcelRequire("99c9I");

var $8WhtA = parcelRequire("8WhtA");

var $4EOyv = parcelRequire("4EOyv");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $e70e583d684cb5f4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $4EOyv.getBackdropUtilityClass), classes);
};
const $e70e583d684cb5f4$var$BackdropRoot = (0, $kDBhE.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})({
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent',
    variants: [
        {
            props: {
                invisible: true
            },
            style: {
                backgroundColor: 'transparent'
            }
        }
    ]
});
const $e70e583d684cb5f4$var$Backdrop = /*#__PURE__*/ $7fPBF.forwardRef(function Backdrop(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', invisible: invisible = false, open: open, components: components = {}, componentsProps: componentsProps = {}, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        invisible: invisible
    };
    const classes = $e70e583d684cb5f4$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        root: components.Root,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        ...componentsProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $99c9I.default)('root', {
        elementType: $e70e583d684cb5f4$var$BackdropRoot,
        externalForwardedProps: externalForwardedProps,
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $99c9I.default)('transition', {
        elementType: (0, $8WhtA.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionSlot, {
        in: open,
        timeout: transitionDuration,
        ...other,
        ...transitionProps,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)(RootSlot, {
            "aria-hidden": true,
            ...rootProps,
            classes: classes,
            ref: ref,
            children: children
        })
    });
});
var $e70e583d684cb5f4$export$2e2bcd8739ae039 = $e70e583d684cb5f4$var$Backdrop;

});
parcelRegister("8WhtA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68214be7242cbfc8$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $8qMCX = parcelRequire("8qMCX");


var $bNCjr = parcelRequire("bNCjr");

var $g9bTP = parcelRequire("g9bTP");

var $2j7bs = parcelRequire("2j7bs");

var $6NwTb = parcelRequire("6NwTb");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $68214be7242cbfc8$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $68214be7242cbfc8$var$Fade = /*#__PURE__*/ $7fPBF.forwardRef(function Fade(props, ref) {
    const theme = (0, $g9bTP.default)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $8qMCX.default), ...other } = props;
    const enableStrictModeCompat = true;
    const nodeRef = $7fPBF.useRef(null);
    const handleRef = (0, $6NwTb.default)(nodeRef, (0, $bNCjr.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $2j7bs.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, $2j7bs.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $2j7bs.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $7fPBF.cloneElement(children, {
                style: {
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$68214be7242cbfc8$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
var $68214be7242cbfc8$export$2e2bcd8739ae039 = $68214be7242cbfc8$var$Fade;

});
parcelRegister("8qMCX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $623678cbb6daf054$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $1KLsX = parcelRequire("1KLsX");


var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");

var $bTMtR = parcelRequire("bTMtR");


var $8ovTL = parcelRequire("8ovTL");

var $kKJSm = parcelRequire("kKJSm");
var $623678cbb6daf054$export$bb38bb9a1161268 = 'unmounted';
var $623678cbb6daf054$export$84cbff306f539230 = 'exited';
var $623678cbb6daf054$export$df38205c966be359 = 'entering';
var $623678cbb6daf054$export$78e9e6e3e014d60a = 'entered';
var $623678cbb6daf054$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $623678cbb6daf054$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $623678cbb6daf054$export$84cbff306f539230;
                _this.appearStatus = $623678cbb6daf054$export$df38205c966be359;
            } else initialStatus = $623678cbb6daf054$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $623678cbb6daf054$export$bb38bb9a1161268;
        else initialStatus = $623678cbb6daf054$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $623678cbb6daf054$export$bb38bb9a1161268) return {
            status: $623678cbb6daf054$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $623678cbb6daf054$export$df38205c966be359 && status !== $623678cbb6daf054$export$78e9e6e3e014d60a) nextStatus = $623678cbb6daf054$export$df38205c966be359;
            } else if (status === $623678cbb6daf054$export$df38205c966be359 || status === $623678cbb6daf054$export$78e9e6e3e014d60a) nextStatus = $623678cbb6daf054$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $623678cbb6daf054$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $kKJSm.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $623678cbb6daf054$export$84cbff306f539230) this.setState({
            status: $623678cbb6daf054$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $bTMtR.default).disabled) {
            this.safeSetState({
                status: $623678cbb6daf054$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $623678cbb6daf054$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $623678cbb6daf054$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $bTMtR.default).disabled) {
            this.safeSetState({
                status: $623678cbb6daf054$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $623678cbb6daf054$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $623678cbb6daf054$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $623678cbb6daf054$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $cFLic.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8ovTL.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$623678cbb6daf054$var$Transition.contextType = (0, $8ovTL.default);
$623678cbb6daf054$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $623678cbb6daf054$var$noop() {}
$623678cbb6daf054$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $623678cbb6daf054$var$noop,
    onEntering: $623678cbb6daf054$var$noop,
    onEntered: $623678cbb6daf054$var$noop,
    onExit: $623678cbb6daf054$var$noop,
    onExiting: $623678cbb6daf054$var$noop,
    onExited: $623678cbb6daf054$var$noop
};
$623678cbb6daf054$var$Transition.UNMOUNTED = $623678cbb6daf054$export$bb38bb9a1161268;
$623678cbb6daf054$var$Transition.EXITED = $623678cbb6daf054$export$84cbff306f539230;
$623678cbb6daf054$var$Transition.ENTERING = $623678cbb6daf054$export$df38205c966be359;
$623678cbb6daf054$var$Transition.ENTERED = $623678cbb6daf054$export$78e9e6e3e014d60a;
$623678cbb6daf054$var$Transition.EXITING = $623678cbb6daf054$export$4aacc83d4d59139f;
var $623678cbb6daf054$export$2e2bcd8739ae039 = $623678cbb6daf054$var$Transition;

});
parcelRegister("bTMtR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a9a7006a9b8efe4$export$2e2bcd8739ae039; });
var $8a9a7006a9b8efe4$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("kKJSm", function(module, exports) {

$parcel$export(module.exports, "forceReflow", function () { return $f1bbb084f2fb10b7$export$7d26bbb1236dafd6; });
var $f1bbb084f2fb10b7$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("2j7bs", function(module, exports) {

$parcel$export(module.exports, "reflow", function () { return $1ae2edacd7be6319$export$b7a864e1eaef9de5; });
$parcel$export(module.exports, "getTransitionProps", function () { return $1ae2edacd7be6319$export$8cb1e9b404609ae9; });
const $1ae2edacd7be6319$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $1ae2edacd7be6319$export$8cb1e9b404609ae9(props, options) {
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}

});


parcelRegister("4EOyv", function(module, exports) {

$parcel$export(module.exports, "getBackdropUtilityClass", function () { return $36421d1d94159248$export$9927a91fd93152bd; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $36421d1d94159248$export$9927a91fd93152bd(slot) {
    return (0, $k6RDS.default)('MuiBackdrop', slot);
}
const $36421d1d94159248$var$backdropClasses = (0, $4jzsB.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $36421d1d94159248$export$2e2bcd8739ae039 = $36421d1d94159248$var$backdropClasses;

});


parcelRegister("g3t58", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb037c33603903c5$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $irWkO = parcelRequire("irWkO");
var $4CS7n = parcelRequire("4CS7n");
var $giDhD = parcelRequire("giDhD");
var $jTdAm = parcelRequire("jTdAm");

var $atytk = parcelRequire("atytk");

var $8x9gm = parcelRequire("8x9gm");
'use client';
function $bb037c33603903c5$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $bb037c33603903c5$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
const $bb037c33603903c5$var$noop = ()=>{};
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $bb037c33603903c5$var$manager = new (0, $8x9gm.ModalManager)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $bb037c33603903c5$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $7fPBF.useRef({});
    const mountNodeRef = $7fPBF.useRef(null);
    const modalRef = $7fPBF.useRef(null);
    const handleRef = (0, $jTdAm.default)(modalRef, rootRef);
    const [exited, setExited] = $7fPBF.useState(!open);
    const hasTransition = $bb037c33603903c5$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $4CS7n.default)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        $bb037c33603903c5$var$manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $giDhD.default)(()=>{
        const resolvedContainer = $bb037c33603903c5$var$getContainer(container) || getDoc().body;
        $bb037c33603903c5$var$manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = ()=>$bb037c33603903c5$var$manager.isTopModal(getModal());
    const handlePortalRef = (0, $giDhD.default)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $8x9gm.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $7fPBF.useCallback(()=>{
        $bb037c33603903c5$var$manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp
    ]);
    $7fPBF.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $7fPBF.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            otherHandlers.onKeyDown?.(event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $atytk.default)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = {
            ...propsEventHandlers,
            ...otherHandlers
        };
        return {
            /*
       * Marking an element with the role presentation indicates to assistive technology
       * that this element should be ignored; it exists to support the web application and
       * is not meant for humans to interact with directly.
       * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
       */ role: 'presentation',
            ...externalEventHandlers,
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        };
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return {
            'aria-hidden': true,
            ...externalEventHandlers,
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        };
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $irWkO.default)(handleEnter, children?.props.onEnter ?? $bb037c33603903c5$var$noop),
            onExited: (0, $irWkO.default)(handleExited, children?.props.onExited ?? $bb037c33603903c5$var$noop)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $bb037c33603903c5$export$2e2bcd8739ae039 = $bb037c33603903c5$var$useModal;

});
parcelRegister("irWkO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6e7ffad706c848e$export$2e2bcd8739ae039; });
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $d6e7ffad706c848e$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

});

parcelRegister("8x9gm", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", function () { return $6368973433f2cfde$export$e1bd0c6150f13d96; });
$parcel$export(module.exports, "ModalManager", function () { return $6368973433f2cfde$export$ce11c4ecd08cea67; });

var $8c45K = parcelRequire("8c45K");
var $4CS7n = parcelRequire("4CS7n");
var $gE56a = parcelRequire("gE56a");
// Is a vertical scrollbar displayed?
function $6368973433f2cfde$var$isOverflowing(container) {
    const doc = (0, $4CS7n.default)(container);
    if (doc.body === container) return (0, $gE56a.default)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $6368973433f2cfde$export$e1bd0c6150f13d96(element, hide) {
    if (hide) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $6368973433f2cfde$var$getPaddingRight(element) {
    return parseInt((0, $gE56a.default)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $6368973433f2cfde$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $6368973433f2cfde$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = !blacklist.includes(element);
        const isNotForbiddenElement = !$6368973433f2cfde$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $6368973433f2cfde$export$e1bd0c6150f13d96(element, hide);
    });
}
function $6368973433f2cfde$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $6368973433f2cfde$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($6368973433f2cfde$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $8c45K.default)((0, $gE56a.default)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$6368973433f2cfde$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $4CS7n.default)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$6368973433f2cfde$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $4CS7n.default)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $gE56a.default)(container);
            scrollContainer = parent?.nodeName === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $6368973433f2cfde$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $6368973433f2cfde$export$ce11c4ecd08cea67 {
    constructor(){
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $6368973433f2cfde$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $6368973433f2cfde$var$getHiddenSiblings(container);
        $6368973433f2cfde$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $6368973433f2cfde$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $6368973433f2cfde$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $6368973433f2cfde$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $6368973433f2cfde$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $6368973433f2cfde$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $6368973433f2cfde$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $6368973433f2cfde$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}

});
parcelRegister("8c45K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f729e410b274c00$export$2e2bcd8739ae039; });
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $5f729e410b274c00$export$2e2bcd8739ae039(win = window) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = win.document.documentElement.clientWidth;
    return win.innerWidth - documentWidth;
}

});

parcelRegister("gE56a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1e4563498af7952$export$2e2bcd8739ae039; });

var $4CS7n = parcelRequire("4CS7n");
function $c1e4563498af7952$export$2e2bcd8739ae039(node) {
    const doc = (0, $4CS7n.default)(node);
    return doc.defaultView || window;
}

});



parcelRegister("1Qt6b", function(module, exports) {

$parcel$export(module.exports, "getModalUtilityClass", function () { return $1581382eb39c1df6$export$67960e22b12a638d; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $1581382eb39c1df6$export$67960e22b12a638d(slot) {
    return (0, $k6RDS.default)('MuiModal', slot);
}
const $1581382eb39c1df6$var$modalClasses = (0, $4jzsB.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $1581382eb39c1df6$export$2e2bcd8739ae039 = $1581382eb39c1df6$var$modalClasses;

});


parcelRegister("bqHow", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getDialogUtilityClass", function () { return $8523c8ab2139cf2c$export$2177af0aa15c34c2; });
$parcel$export(module.exports, "default", function () { return $8523c8ab2139cf2c$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $8523c8ab2139cf2c$export$2177af0aa15c34c2(slot) {
    return (0, $k6RDS.default)('MuiDialog', slot);
}
const $8523c8ab2139cf2c$var$dialogClasses = (0, $4jzsB.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $8523c8ab2139cf2c$export$2e2bcd8739ae039 = $8523c8ab2139cf2c$var$dialogClasses;

});

parcelRegister("5wwR3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40596d25b0f9c334$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
'use client';
const $40596d25b0f9c334$var$DialogContext = /*#__PURE__*/ $7fPBF.createContext({});
var $40596d25b0f9c334$export$2e2bcd8739ae039 = $40596d25b0f9c334$var$DialogContext;

});


parcelRegister("8TDId", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67a243c492197f3b$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $bwizY = parcelRequire("bwizY");

var $kDjHH = parcelRequire("kDjHH");

var $kDBhE = parcelRequire("kDBhE");

var $7uFHh = parcelRequire("7uFHh");

var $wvp8q = parcelRequire("wvp8q");

var $iVAEr = parcelRequire("iVAEr");

var $3RNaF = parcelRequire("3RNaF");

var $iibPM = parcelRequire("iibPM");

var $b6UUh = parcelRequire("b6UUh");

var $10KNR = parcelRequire("10KNR");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $67a243c492197f3b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size, loading: loading } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $b6UUh.default)(color)}`,
            edge && `edge${(0, $b6UUh.default)(edge)}`,
            `size${(0, $b6UUh.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $10KNR.getIconButtonUtilityClass), classes);
};
const $67a243c492197f3b$var$IconButtonRoot = (0, $kDBhE.default)((0, $3RNaF.default), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.loading && styles.loading,
            ownerState.color !== 'default' && styles[`color${(0, $b6UUh.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $b6UUh.default)(ownerState.edge)}`],
            styles[`size${(0, $b6UUh.default)(ownerState.size)}`]
        ];
    }
})((0, $7uFHh.default)(({ theme: theme })=>({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: (props)=>!props.disableRipple,
                style: {
                    '--IconButton-hoverBg': theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kDjHH.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                    '&:hover': {
                        backgroundColor: 'var(--IconButton-hoverBg)',
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: {
                    edge: 'start'
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: 'start',
                    size: 'small'
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: 'end'
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: 'end',
                    size: 'small'
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, $7uFHh.default)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            ...Object.entries(theme.palette).filter((0, $wvp8q.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $wvp8q.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--IconButton-hoverBg': theme.vars ? `rgba(${(theme.vars || theme).palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kDjHH.alpha)((theme.vars || theme).palette[color].main, theme.palette.action.hoverOpacity)
                    }
                })),
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${(0, $10KNR.default).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        },
        [`&.${(0, $10KNR.default).loading}`]: {
            color: 'transparent'
        }
    })));
const $67a243c492197f3b$var$IconButtonLoadingIndicator = (0, $kDBhE.default)('span', {
    name: 'MuiIconButton',
    slot: 'LoadingIndicator',
    overridesResolver: (props, styles)=>styles.loadingIndicator
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: (theme.vars || theme).palette.action.disabled,
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            }
        ]
    }));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $67a243c492197f3b$var$IconButton = /*#__PURE__*/ $7fPBF.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium', id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, ...other } = props;
    const loadingId = (0, $bwizY.default)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iibPM.default), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        loading: loading,
        loadingIndicator: loadingIndicator,
        size: size
    };
    const classes = $67a243c492197f3b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($67a243c492197f3b$var$IconButtonRoot, {
        id: loading ? loadingId : idProp,
        className: (0, $hngXp.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled || loading,
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: [
            typeof loading === 'boolean' && /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
            (0, $bbzbN.jsx)("span", {
                className: classes.loadingWrapper,
                style: {
                    display: 'contents'
                },
                children: /*#__PURE__*/ (0, $bbzbN.jsx)($67a243c492197f3b$var$IconButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loading && loadingIndicator
                })
            }),
            children
        ]
    });
});
var $67a243c492197f3b$export$2e2bcd8739ae039 = $67a243c492197f3b$var$IconButton;

});
parcelRegister("10KNR", function(module, exports) {

$parcel$export(module.exports, "getIconButtonUtilityClass", function () { return $0bca18aab596affa$export$5e8702d71474f093; });
$parcel$export(module.exports, "default", function () { return $0bca18aab596affa$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $0bca18aab596affa$export$5e8702d71474f093(slot) {
    return (0, $k6RDS.default)('MuiIconButton', slot);
}
const $0bca18aab596affa$var$iconButtonClasses = (0, $4jzsB.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'loading',
    'loadingIndicator',
    'loadingWrapper'
]);
var $0bca18aab596affa$export$2e2bcd8739ae039 = $0bca18aab596affa$var$iconButtonClasses;

});


parcelRegister("QgwxG", function(module, exports) {

$parcel$export(module.exports, "copyright", function () { return $09d1acbdb3991d4f$export$666c3ad173ff70db; });
$parcel$export(module.exports, "harvest", function () { return $09d1acbdb3991d4f$export$104627a8e77d43e6; });
$parcel$export(module.exports, "thresh", function () { return $09d1acbdb3991d4f$export$81a3d425ea15ed64; });
$parcel$export(module.exports, "winnow", function () { return $09d1acbdb3991d4f$export$9928f005799a708; });

const $09d1acbdb3991d4f$export$666c3ad173ff70db = new URL((parcelRequire("1oQeN"))).href;

const $09d1acbdb3991d4f$export$104627a8e77d43e6 = new URL((parcelRequire("kc3Am"))).href;

const $09d1acbdb3991d4f$export$81a3d425ea15ed64 = new URL((parcelRequire("2lISX"))).href;

const $09d1acbdb3991d4f$export$9928f005799a708 = new URL((parcelRequire("gPIvv"))).href;

});
parcelRegister("1oQeN", function(module, exports) {
module.exports = import.meta.resolve("koto8");

});

parcelRegister("kc3Am", function(module, exports) {
module.exports = import.meta.resolve("g44Qp");

});

parcelRegister("2lISX", function(module, exports) {
module.exports = import.meta.resolve("43pRX");

});

parcelRegister("gPIvv", function(module, exports) {
module.exports = import.meta.resolve("fhYJE");

});



parcelRegister("7Vqnf", function(module, exports) {
module.exports = JSON.parse("{\"harvest\":{\"name\":\"Ethiopia Farmers Harvest Teff\",\"nameHref\":\"https://commons.wikimedia.org/wiki/File:Ethiopia-farmers-harvest-teff.jpg\",\"by\":\"Esayas Ayele\",\"license\":\"CC BY-SA 4.0\",\"licenseHref\":\"https://creativecommons.org/licenses/by-sa/4.0/\",\"cropped\":true},\"thresh\":{\"name\":\"Farmers Threshing Rice Crops\",\"nameHref\":\"https://www.pexels.com/photo/farmers-threshing-rice-crops-9487554/\",\"by\":\"Imam Hossain\",\"byHref\":\"https://www.pexels.com/@imam-hossain-95404804/\",\"license\":\"Pexels license\",\"licenseHref\":\"https://www.pexels.com/license/\",\"cropped\":true},\"winnow\":{\"name\":\"A Woman with a Winnowing Basket\",\"nameHref\":\"https://www.pexels.com/photo/a-woman-with-a-winnowing-basket-19401189/\",\"by\":\"Mehmet Turgut Kirkgoz\",\"byHref\":\"https://www.pexels.com/@tkirkgoz/\",\"license\":\"Pexels license\",\"licenseHref\":\"https://www.pexels.com/license/\",\"cropped\":true}}");

});


parcelRegister("lk396", function(module, exports) {

$parcel$export(module.exports, "bottomBarHeight", function () { return $31b0bdbce5284751$export$84c3f18aa14021c8; });
$parcel$export(module.exports, "default", function () { return $31b0bdbce5284751$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $7TOmr = parcelRequire("7TOmr");
var $5ZeKC = parcelRequire("5ZeKC");
var $hG0Cb = parcelRequire("hG0Cb");
var $5Mrqo = parcelRequire("5Mrqo");
var $3loMv = parcelRequire("3loMv");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $2VP0e = parcelRequire("2VP0e");
const $31b0bdbce5284751$export$84c3f18aa14021c8 = 55;
function $31b0bdbce5284751$export$2e2bcd8739ae039() {
    const { t: t } = (0, $doyfp.useTranslation)();
    const combineAppRelease = (0, $2VP0e.RuntimeConfig).getInstance().appRelease();
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        style: {
            marginTop: $31b0bdbce5284751$export$84c3f18aa14021c8
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7TOmr.default), {
            position: "fixed",
            style: {
                bottom: 0,
                maxHeight: $31b0bdbce5284751$export$84c3f18aa14021c8,
                top: "auto"
            },
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5Mrqo.default), {
                variant: "dense",
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                    alignItems: "center",
                    direction: "row",
                    justifyContent: "space-between",
                    spacing: 1,
                    style: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                            variant: "caption",
                            children: combineAppRelease
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                            size: "small",
                            color: "inherit",
                            onClick: ()=>window.open("https://software.sil.org/language-software-privacy-policy/"),
                            id: "privacy-policy",
                            style: {
                                margin: 0
                            },
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                variant: "caption",
                                children: t("landingPage.privacyPolicy")
                            })
                        })
                    ]
                })
            })
        })
    });
}

});
parcelRegister("7TOmr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c04bc14285128b0$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $7uFHh = parcelRequire("7uFHh");

var $iVAEr = parcelRequire("iVAEr");

var $b6UUh = parcelRequire("b6UUh");

var $wvp8q = parcelRequire("wvp8q");

var $a2ay0 = parcelRequire("a2ay0");

var $cjLM4 = parcelRequire("cjLM4");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $5c04bc14285128b0$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $b6UUh.default)(color)}`,
            `position${(0, $b6UUh.default)(position)}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $cjLM4.getAppBarUtilityClass), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $5c04bc14285128b0$var$joinVars = (var1, var2)=>var1 ? `${var1?.replace(')', '')}, ${var2})` : var2;
const $5c04bc14285128b0$var$AppBarRoot = (0, $kDBhE.default)((0, $a2ay0.default), {
    name: 'MuiAppBar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $b6UUh.default)(ownerState.position)}`],
            styles[`color${(0, $b6UUh.default)(ownerState.color)}`]
        ];
    }
})((0, $7uFHh.default)(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0,
        variants: [
            {
                props: {
                    position: 'fixed'
                },
                style: {
                    position: 'fixed',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0,
                    '@media print': {
                        // Prevent the app bar to be visible on each printed page.
                        position: 'absolute'
                    }
                }
            },
            {
                props: {
                    position: 'absolute'
                },
                style: {
                    position: 'absolute',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    position: 'sticky'
                },
                style: {
                    position: 'sticky',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    position: 'static'
                },
                style: {
                    position: 'static'
                }
            },
            {
                props: {
                    position: 'relative'
                },
                style: {
                    position: 'relative'
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    '--AppBar-color': 'inherit'
                }
            },
            {
                props: {
                    color: 'default'
                },
                style: {
                    '--AppBar-background': theme.vars ? theme.vars.palette.AppBar.defaultBg : theme.palette.grey[100],
                    '--AppBar-color': theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText(theme.palette.grey[100]),
                    ...theme.applyStyles('dark', {
                        '--AppBar-background': theme.vars ? theme.vars.palette.AppBar.defaultBg : theme.palette.grey[900],
                        '--AppBar-color': theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText(theme.palette.grey[900])
                    })
                }
            },
            ...Object.entries(theme.palette).filter((0, $wvp8q.default)([
                'contrastText'
            ])).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--AppBar-background': (theme.vars ?? theme).palette[color].main,
                        '--AppBar-color': (theme.vars ?? theme).palette[color].contrastText
                    }
                })),
            {
                props: (props)=>props.enableColorOnDark === true && ![
                        'inherit',
                        'transparent'
                    ].includes(props.color),
                style: {
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)'
                }
            },
            {
                props: (props)=>props.enableColorOnDark === false && ![
                        'inherit',
                        'transparent'
                    ].includes(props.color),
                style: {
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)',
                    ...theme.applyStyles('dark', {
                        backgroundColor: theme.vars ? $5c04bc14285128b0$var$joinVars(theme.vars.palette.AppBar.darkBg, 'var(--AppBar-background)') : null,
                        color: theme.vars ? $5c04bc14285128b0$var$joinVars(theme.vars.palette.AppBar.darkColor, 'var(--AppBar-color)') : null
                    })
                }
            },
            {
                props: {
                    color: 'transparent'
                },
                style: {
                    '--AppBar-background': 'transparent',
                    '--AppBar-color': 'inherit',
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)',
                    ...theme.applyStyles('dark', {
                        backgroundImage: 'none'
                    })
                }
            }
        ]
    })));
const $5c04bc14285128b0$var$AppBar = /*#__PURE__*/ $7fPBF.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiAppBar'
    });
    const { className: className, color: color = 'primary', enableColorOnDark: enableColorOnDark = false, position: position = 'fixed', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    };
    const classes = $5c04bc14285128b0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($5c04bc14285128b0$var$AppBarRoot, {
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $hngXp.default)(classes.root, className, position === 'fixed' && 'mui-fixed'),
        ref: ref,
        ...other
    });
});
var $5c04bc14285128b0$export$2e2bcd8739ae039 = $5c04bc14285128b0$var$AppBar;

});
parcelRegister("cjLM4", function(module, exports) {

$parcel$export(module.exports, "getAppBarUtilityClass", function () { return $8f7c5161bc7a509f$export$47a2da616e55e8e9; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $8f7c5161bc7a509f$export$47a2da616e55e8e9(slot) {
    return (0, $k6RDS.default)('MuiAppBar', slot);
}
const $8f7c5161bc7a509f$var$appBarClasses = (0, $4jzsB.default)('MuiAppBar', [
    'root',
    'positionFixed',
    'positionAbsolute',
    'positionSticky',
    'positionStatic',
    'positionRelative',
    'colorDefault',
    'colorPrimary',
    'colorSecondary',
    'colorInherit',
    'colorTransparent',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning'
]);
var $8f7c5161bc7a509f$export$2e2bcd8739ae039 = $8f7c5161bc7a509f$var$appBarClasses;

});


parcelRegister("5Mrqo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4356b5696745688a$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $7uFHh = parcelRequire("7uFHh");

var $iVAEr = parcelRequire("iVAEr");

var $iU3EE = parcelRequire("iU3EE");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $4356b5696745688a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $iU3EE.getToolbarUtilityClass), classes);
};
const $4356b5696745688a$var$ToolbarRoot = (0, $kDBhE.default)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})((0, $7uFHh.default)(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: theme.spacing(2),
                    paddingRight: theme.spacing(2),
                    [theme.breakpoints.up('sm')]: {
                        paddingLeft: theme.spacing(3),
                        paddingRight: theme.spacing(3)
                    }
                }
            },
            {
                props: {
                    variant: 'dense'
                },
                style: {
                    minHeight: 48
                }
            },
            {
                props: {
                    variant: 'regular'
                },
                style: theme.mixins.toolbar
            }
        ]
    })));
const $4356b5696745688a$var$Toolbar = /*#__PURE__*/ $7fPBF.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className: className, component: component = 'div', disableGutters: disableGutters = false, variant: variant = 'regular', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        disableGutters: disableGutters,
        variant: variant
    };
    const classes = $4356b5696745688a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($4356b5696745688a$var$ToolbarRoot, {
        as: component,
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $4356b5696745688a$export$2e2bcd8739ae039 = $4356b5696745688a$var$Toolbar;

});
parcelRegister("iU3EE", function(module, exports) {

$parcel$export(module.exports, "getToolbarUtilityClass", function () { return $dc304ab6922390a3$export$b12cb262231eef32; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $dc304ab6922390a3$export$b12cb262231eef32(slot) {
    return (0, $k6RDS.default)('MuiToolbar', slot);
}
const $dc304ab6922390a3$var$toolbarClasses = (0, $4jzsB.default)('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var $dc304ab6922390a3$export$2e2bcd8739ae039 = $dc304ab6922390a3$var$toolbarClasses;

});


parcelRegister("2VP0e", function(module, exports) {

$parcel$export(module.exports, "RuntimeConfig", function () { return $227ec44f07d36609$export$ec56e2f5cfeae5ef; });
const $227ec44f07d36609$var$defaultConfig = {
    baseUrl: "http://localhost:5000",
    captchaRequired: true,
    /* https://developers.cloudflare.com/turnstile/troubleshooting/testing/
   * has dummy site keys for development and testing; options are:
   * invisible pass, invisible fail, visible pass, visible fail, forced interaction */ captchaSiteKey: "1x00000000000000000000AA",
    offline: false,
    emailServicesEnabled: true
};
class $227ec44f07d36609$export$ec56e2f5cfeae5ef {
    constructor(){
        if (!window.hasOwnProperty("runtimeConfig") || typeof window.runtimeConfig === "undefined") window.runtimeConfig = $227ec44f07d36609$var$defaultConfig;
    }
    static getInstance() {
        if (!this._instance) this._instance = new $227ec44f07d36609$export$ec56e2f5cfeae5ef();
        return this._instance;
    }
    baseUrl() {
        if (window.runtimeConfig.hasOwnProperty("useConnectionBaseUrlForApi")) return `${window.location.protocol}//${window.location.host}`;
        return $227ec44f07d36609$var$defaultConfig.baseUrl;
    }
    appRelease() {
        if (window.hasOwnProperty("release")) return window.release;
        return "v0.0.0-default.0";
    }
    captchaRequired() {
        if (window.runtimeConfig.hasOwnProperty("captchaRequired")) return window.runtimeConfig.captchaRequired;
        return $227ec44f07d36609$var$defaultConfig.captchaRequired;
    }
    captchaSiteKey() {
        if (window.runtimeConfig.hasOwnProperty("captchaSiteKey")) return window.runtimeConfig.captchaSiteKey;
        return $227ec44f07d36609$var$defaultConfig.captchaSiteKey;
    }
    emailServicesEnabled() {
        if ($227ec44f07d36609$export$ec56e2f5cfeae5ef._instance.isOffline()) return false;
        if (window.runtimeConfig.hasOwnProperty("emailServicesEnabled")) return window.runtimeConfig.emailServicesEnabled;
        return $227ec44f07d36609$var$defaultConfig.emailServicesEnabled;
    }
    isOffline() {
        if (window.runtimeConfig.hasOwnProperty("offline")) return window.runtimeConfig.offline;
        return $227ec44f07d36609$var$defaultConfig.offline;
    }
}

});


parcelRegister("4Z5Yh", function(module, exports) {

$parcel$export(module.exports, "horizontalButtonsHeight", function () { return $0512e69621186f77$export$d5bf2daa9877e467; });
$parcel$export(module.exports, "verticalButtonsWidth", function () { return $0512e69621186f77$export$6bbe5aefa70b92f1; });
$parcel$export(module.exports, "default", function () { return $0512e69621186f77$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "SignUpButton", function () { return $0512e69621186f77$export$be6d4056a7e6ee1a; });

var $bbzbN = parcelRequire("bbzbN");

var $k3Smn = parcelRequire("k3Smn");

var $5ZeKC = parcelRequire("5ZeKC");
var $gsokU = parcelRequire("gsokU");
var $hG0Cb = parcelRequire("hG0Cb");
var $3loMv = parcelRequire("3loMv");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $gxpCl = parcelRequire("gxpCl");

var $6PJp8 = parcelRequire("6PJp8");

var $gs8xE = parcelRequire("gs8xE");

var $8S1fp = parcelRequire("8S1fp");
const $0512e69621186f77$var$idAffix = "landing";
const $0512e69621186f77$var$buttonHeight = 56;
const $0512e69621186f77$var$buttonWidth = 144;
const $0512e69621186f77$var$iconButtonWidth = $0512e69621186f77$var$buttonWidth / 4;
const $0512e69621186f77$var$gap = parseInt((0, $gs8xE.default).spacing(1));
const $0512e69621186f77$export$d5bf2daa9877e467 = $0512e69621186f77$var$buttonHeight + $0512e69621186f77$var$gap;
const $0512e69621186f77$var$horizontalButtonsWidth = 2 * $0512e69621186f77$var$buttonWidth + $0512e69621186f77$var$iconButtonWidth + 2 * $0512e69621186f77$var$gap;
const $0512e69621186f77$export$6bbe5aefa70b92f1 = $0512e69621186f77$var$buttonWidth + 2 * $0512e69621186f77$var$gap;
function $0512e69621186f77$export$2e2bcd8739ae039(props) {
    const navigate = (0, $gxpCl.useNavigate)();
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gsokU.default), {
        style: {
            padding: $0512e69621186f77$var$gap,
            maxWidth: $0512e69621186f77$var$horizontalButtonsWidth
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
            direction: props.top ? "row" : "column",
            justifyContent: "space-around",
            spacing: 1,
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)($0512e69621186f77$export$be6d4056a7e6ee1a, {}),
                /*#__PURE__*/ (0, $bbzbN.jsx)($0512e69621186f77$var$LandingButton, {
                    onClick: ()=>navigate((0, $6PJp8.Path).Login),
                    textId: "login.login",
                    buttonId: `${$0512e69621186f77$var$idAffix}-login`
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)($0512e69621186f77$var$LandingButton, {
                    onClick: ()=>(0, $8S1fp.openUserGuide)(),
                    textId: "userMenu.userGuide",
                    buttonId: `${$0512e69621186f77$var$idAffix}-guide`,
                    icon: props.top ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $k3Smn.default), {}) : undefined
                })
            ]
        })
    });
}
function $0512e69621186f77$export$be6d4056a7e6ee1a(props) {
    const navigate = (0, $gxpCl.useNavigate)();
    return /*#__PURE__*/ (0, $bbzbN.jsx)($0512e69621186f77$var$LandingButton, {
        onClick: ()=>navigate((0, $6PJp8.Path).Signup),
        textId: "login.signUp",
        buttonId: `${props.buttonIdPrefix ?? $0512e69621186f77$var$idAffix}-signUp`,
        filled: true
    });
}
/** Button for the Landing Page. (Prop `icon` overrides `textId`.) */ function $0512e69621186f77$var$LandingButton(props) {
    const { t: t } = (0, $doyfp.useTranslation)();
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
        "aria-label": props.buttonLabel,
        color: "primary",
        "data-testid": props.buttonId,
        id: props.buttonId,
        onClick: props.onClick,
        style: {
            height: $0512e69621186f77$var$buttonHeight,
            width: props.icon ? $0512e69621186f77$var$iconButtonWidth : $0512e69621186f77$var$buttonWidth
        },
        variant: props.filled ? "contained" : "outlined",
        children: props.icon || /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
            variant: "subtitle1",
            children: t(props.textId)
        })
    });
}

});
parcelRegister("k3Smn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9ae413baa594b4a$export$2e2bcd8739ae039; });

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $e9ae413baa594b4a$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-6h2zm0-8h-2V7h2z"
}), 'Info');

});


parcelRegister("69ZoH", function(module, exports) {

$parcel$export(module.exports, "topBarHeight", function () { return $4dc89ba4e31a948f$export$207e6c4cacabd824; });
$parcel$export(module.exports, "default", function () { return $4dc89ba4e31a948f$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $7TOmr = parcelRequire("7TOmr");
var $hG0Cb = parcelRequire("hG0Cb");
var $5Mrqo = parcelRequire("5Mrqo");
var $3loMv = parcelRequire("3loMv");
var $iq9YP = parcelRequire("iq9YP");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $dJKzg = parcelRequire("dJKzg");
const $4dc89ba4e31a948f$export$207e6c4cacabd824 = 70;
function $4dc89ba4e31a948f$export$2e2bcd8739ae039() {
    const showSubtitle = (0, $iq9YP.default)((th)=>th.breakpoints.up("sm"));
    const isMdUp = (0, $iq9YP.default)((th)=>th.breakpoints.up("md"));
    const { t: t } = (0, $doyfp.useTranslation)();
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: "NavigationBar",
        style: {
            marginBottom: $4dc89ba4e31a948f$export$207e6c4cacabd824
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7TOmr.default), {
            position: "fixed",
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5Mrqo.default), {
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                    alignItems: "center",
                    direction: "row",
                    justifyContent: "space-between",
                    spacing: 2,
                    style: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                            src: (0, $dJKzg.white),
                            height: "50",
                            alt: "Logo"
                        }),
                        showSubtitle && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                            variant: isMdUp ? "h5" : "h6",
                            children: t("landingPage.subtitle")
                        })
                    ]
                })
            })
        })
    });
}

});
parcelRegister("dJKzg", function(module, exports) {

$parcel$export(module.exports, "small", function () { return $a00399b56f48f00e$export$3c17b0e969a90510; });
$parcel$export(module.exports, "white", function () { return $a00399b56f48f00e$export$8fa4e5556fd77a60; });

const $a00399b56f48f00e$export$c073df10e766abfa = new URL((parcelRequire("awvv0"))).href;

const $a00399b56f48f00e$export$3c17b0e969a90510 = new URL((parcelRequire("7IcBG"))).href;

const $a00399b56f48f00e$export$8fa4e5556fd77a60 = new URL((parcelRequire("fhn9h"))).href;

});
parcelRegister("awvv0", function(module, exports) {
module.exports = import.meta.resolve("fRWJH");

});

parcelRegister("7IcBG", function(module, exports) {
module.exports = import.meta.resolve("hIt1c");

});

parcelRegister("fhn9h", function(module, exports) {
module.exports = import.meta.resolve("bWdVx");

});




parcelRegister("aGTsZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3ce077e6a7799de$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $mMVex = parcelRequire("mMVex");

var $5ZeKC = parcelRequire("5ZeKC");
var $gsokU = parcelRequire("gsokU");
var $c1d0r = parcelRequire("c1d0r");
var $3M96K = parcelRequire("3M96K");
var $k4oz9 = parcelRequire("k4oz9");
var $4Kxg6 = parcelRequire("4Kxg6");
var $hG0Cb = parcelRequire("hG0Cb");
var $3loMv = parcelRequire("3loMv");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");
parcelRequire("585vO");
var $aLuLa = parcelRequire("aLuLa");

var $cSUCP = parcelRequire("cSUCP");

var $9h23A = parcelRequire("9h23A");

var $tUv8Q = parcelRequire("tUv8Q");

var $2st3N = parcelRequire("2st3N");

var $i3Fzs = parcelRequire("i3Fzs");

var $3oQOj = parcelRequire("3oQOj");

var $f3nsX = parcelRequire("f3nsX");

var $9Ihvc = parcelRequire("9Ihvc");

var $6PJp8 = parcelRequire("6PJp8");

var $2VP0e = parcelRequire("2VP0e");

var $lMWJB = parcelRequire("lMWJB");

var $8S1fp = parcelRequire("8S1fp");

var $dl3xm = parcelRequire("dl3xm");
var $e3ce077e6a7799de$export$398894e126b9ca24 = /*#__PURE__*/ function(LoginId) {
    LoginId["ButtonLogIn"] = "login-log-in-button";
    LoginId["ButtonSignUp"] = "login-sign-up-button";
    LoginId["ButtonUserGuide"] = "login-user-guide-button";
    LoginId["FieldPassword"] = "login-password-field";
    LoginId["FieldUsername"] = "login-username-field";
    LoginId["Form"] = "login-form";
    return LoginId;
}({});
var $e3ce077e6a7799de$export$9ae8b9f3bcb73c9 = /*#__PURE__*/ function(LoginTextId) {
    LoginTextId["ButtonLogin"] = "login.login";
    LoginTextId["ButtonSignUp"] = "login.signUp";
    LoginTextId["Error401"] = "login.failed";
    LoginTextId["ErrorPassword"] = "login.passwordRequirements";
    LoginTextId["ErrorUnknown"] = "login.failedUnknownReason";
    LoginTextId["FieldError"] = "login.required";
    LoginTextId["LabelPassword"] = "login.password";
    LoginTextId["LabelUsername"] = "login.usernameOrEmail";
    LoginTextId["LinkForgotPassword"] = "login.forgotPassword";
    LoginTextId["Title"] = "login.title";
    return LoginTextId;
}({});
function $e3ce077e6a7799de$export$2e2bcd8739ae039() {
    const dispatch = (0, $f3nsX.useAppDispatch)();
    const loginError = (0, $f3nsX.useAppSelector)((state)=>state.loginState.error);
    const status = (0, $f3nsX.useAppSelector)((state)=>state.loginState.loginStatus);
    const [banner, setBanner] = (0, $7fPBF.useState)("");
    const [isVerified, setIsVerified] = (0, $7fPBF.useState)(false);
    const [password, setPassword] = (0, $7fPBF.useState)("");
    const [passwordError, setPasswordError] = (0, $7fPBF.useState)(false);
    const [username, setUsername] = (0, $7fPBF.useState)("");
    const [usernameError, setUsernameError] = (0, $7fPBF.useState)(false);
    const { t: t } = (0, $doyfp.useTranslation)();
    (0, $7fPBF.useEffect)(()=>{
        dispatch((0, $3oQOj.reset)());
        (0, $cSUCP.getBannerText)((0, $aLuLa.BannerType).Login).then(setBanner);
    }, [
        dispatch
    ]);
    const handleUpdatePassword = (e)=>setPassword(e.target.value);
    const handleUpdateUsername = (e)=>setUsername(e.target.value);
    const logIn = (e)=>{
        e.preventDefault();
        const p = password.trim();
        const pOk = (0, $dl3xm.meetsPasswordRequirements)(p);
        const u = username.trim();
        setPasswordError(!pOk);
        setUsernameError(!u);
        if (pOk && u) dispatch((0, $2st3N.asyncLogIn)(u, p));
    };
    const defaultTextFieldProps = (id)=>({
            id: id,
            margin: "normal",
            required: true,
            slotProps: {
                htmlInput: {
                    maxLength: 100
                }
            },
            style: {
                width: "100%"
            },
            variant: "outlined"
        });
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $k4oz9.default), {
        container: true,
        justifyContent: "center",
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gsokU.default), {
            sx: {
                width: 450
            },
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3M96K.default), {
                    title: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                        align: "center",
                        variant: "h5",
                        children: t("login.title")
                    })
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c1d0r.default), {
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)("form", {
                        id: "login-form",
                        onSubmit: logIn,
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lMWJB.NormalizedTextField), {
                                    ...defaultTextFieldProps("login-username-field"),
                                    autoComplete: "username",
                                    autoFocus: true,
                                    error: usernameError,
                                    helperText: usernameError ? t("login.required") : undefined,
                                    label: t("login.usernameOrEmail"),
                                    onChange: handleUpdateUsername,
                                    value: username
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lMWJB.NormalizedTextField), {
                                    ...defaultTextFieldProps("login-password-field"),
                                    autoComplete: "current-password",
                                    error: passwordError,
                                    helperText: passwordError ? password ? t("login.passwordRequirements") : t("login.required") : undefined,
                                    label: t("login.password"),
                                    onChange: handleUpdatePassword,
                                    type: "password",
                                    value: password
                                }),
                                (0, $2VP0e.RuntimeConfig).getInstance().emailServicesEnabled() && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4Kxg6.default), {
                                        href: "#",
                                        onClick: ()=>(0, $9Ihvc.default).navigate((0, $6PJp8.Path).PwRequest),
                                        underline: "hover",
                                        variant: "subtitle2",
                                        children: t("login.forgotPassword")
                                    })
                                }),
                                status === (0, $i3Fzs.LoginStatus).Failure && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                    sx: {
                                        color: "error.main"
                                    },
                                    variant: "body2",
                                    children: t(loginError.includes("401") ? "login.failed" : "login.failedUnknownReason")
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $tUv8Q.default), {
                                    setSuccess: setIsVerified
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $k4oz9.default), {
                                    container: true,
                                    spacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $k4oz9.default), {
                                            size: "grow",
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                                                "data-testid": "login-user-guide-button",
                                                id: "login-user-guide-button",
                                                onClick: ()=>(0, $8S1fp.openUserGuide)(),
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $mMVex.default), {})
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                                            "data-testid": "login-sign-up-button",
                                            id: "login-sign-up-button",
                                            onClick: ()=>(0, $9Ihvc.default).navigate((0, $6PJp8.Path).Signup),
                                            variant: "outlined",
                                            children: t("login.signUp")
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9h23A.default), {
                                            buttonProps: {
                                                "data-testid": "login-log-in-button",
                                                id: "login-log-in-button",
                                                type: "submit"
                                            },
                                            disabled: !isVerified,
                                            loading: status === (0, $i3Fzs.LoginStatus).InProgress,
                                            children: t("login.login")
                                        })
                                    ]
                                }),
                                !!banner && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                    children: banner
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}

});
parcelRegister("4Kxg6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $375541c69d4ec6b6$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $kDjHH = parcelRequire("kDjHH");


var $cFCqu = parcelRequire("cFCqu");

var $18skz = parcelRequire("18skz");

var $b6UUh = parcelRequire("b6UUh");

var $kDBhE = parcelRequire("kDBhE");
var $g9bTP = parcelRequire("g9bTP");

var $7uFHh = parcelRequire("7uFHh");

var $wvp8q = parcelRequire("wvp8q");

var $iVAEr = parcelRequire("iVAEr");

var $3loMv = parcelRequire("3loMv");

var $cjzM0 = parcelRequire("cjzM0");

var $Q7L0K = parcelRequire("Q7L0K");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $375541c69d4ec6b6$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $375541c69d4ec6b6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            'root',
            `underline${(0, $b6UUh.default)(underline)}`,
            component === 'button' && 'button',
            focusVisible && 'focusVisible'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $cjzM0.getLinkUtilityClass), classes);
};
const $375541c69d4ec6b6$var$LinkRoot = (0, $kDBhE.default)((0, $3loMv.default), {
    name: 'MuiLink',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $b6UUh.default)(ownerState.underline)}`],
            ownerState.component === 'button' && styles.button
        ];
    }
})((0, $7uFHh.default)(({ theme: theme })=>{
    return {
        variants: [
            {
                props: {
                    underline: 'none'
                },
                style: {
                    textDecoration: 'none'
                }
            },
            {
                props: {
                    underline: 'hover'
                },
                style: {
                    textDecoration: 'none',
                    '&:hover': {
                        textDecoration: 'underline'
                    }
                }
            },
            {
                props: {
                    underline: 'always'
                },
                style: {
                    textDecoration: 'underline',
                    '&:hover': {
                        textDecorationColor: 'inherit'
                    }
                }
            },
            {
                props: ({ underline: underline, ownerState: ownerState })=>underline === 'always' && ownerState.color !== 'inherit',
                style: {
                    textDecorationColor: 'var(--Link-underlineColor)'
                }
            },
            ...Object.entries(theme.palette).filter((0, $wvp8q.default)()).map(([color])=>({
                    props: {
                        underline: 'always',
                        color: color
                    },
                    style: {
                        '--Link-underlineColor': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.4)` : (0, $kDjHH.alpha)(theme.palette[color].main, 0.4)
                    }
                })),
            {
                props: {
                    underline: 'always',
                    color: 'textPrimary'
                },
                style: {
                    '--Link-underlineColor': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $kDjHH.alpha)(theme.palette.text.primary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textSecondary'
                },
                style: {
                    '--Link-underlineColor': theme.vars ? `rgba(${theme.vars.palette.text.secondaryChannel} / 0.4)` : (0, $kDjHH.alpha)(theme.palette.text.secondary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textDisabled'
                },
                style: {
                    '--Link-underlineColor': (theme.vars || theme).palette.text.disabled
                }
            },
            {
                props: {
                    component: 'button'
                },
                style: {
                    position: 'relative',
                    WebkitTapHighlightColor: 'transparent',
                    backgroundColor: 'transparent',
                    // Reset default value
                    // We disable the focus ring for mouse, touch and keyboard users.
                    outline: 0,
                    border: 0,
                    margin: 0,
                    // Remove the margin in Safari
                    borderRadius: 0,
                    padding: 0,
                    // Remove the padding in Firefox
                    cursor: 'pointer',
                    userSelect: 'none',
                    verticalAlign: 'middle',
                    MozAppearance: 'none',
                    // Reset
                    WebkitAppearance: 'none',
                    // Reset
                    '&::-moz-focus-inner': {
                        borderStyle: 'none' // Remove Firefox dotted outline.
                    },
                    [`&.${(0, $cjzM0.default).focusVisible}`]: {
                        outline: 'auto'
                    }
                }
            }
        ]
    };
}));
const $375541c69d4ec6b6$var$Link = /*#__PURE__*/ $7fPBF.forwardRef(function Link(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiLink'
    });
    const theme = (0, $g9bTP.default)();
    const { className: className, color: color = 'primary', component: component = 'a', onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = 'always', variant: variant = 'inherit', sx: sx, ...other } = props;
    const [focusVisible, setFocusVisible] = $7fPBF.useState(false);
    const handleBlur = (event)=>{
        if (!(0, $18skz.default)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        if ((0, $18skz.default)(event.target)) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = {
        ...props,
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    };
    const classes = $375541c69d4ec6b6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($375541c69d4ec6b6$var$LinkRoot, {
        color: color,
        className: (0, $hngXp.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: ref,
        ownerState: ownerState,
        variant: variant,
        ...other,
        sx: [
            ...$375541c69d4ec6b6$var$v6Colors[color] === undefined ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ],
        style: {
            ...other.style,
            ...underline === 'always' && color !== 'inherit' && !$375541c69d4ec6b6$var$v6Colors[color] && {
                '--Link-underlineColor': (0, $Q7L0K.default)({
                    theme: theme,
                    ownerState: ownerState
                })
            }
        }
    });
});
var $375541c69d4ec6b6$export$2e2bcd8739ae039 = $375541c69d4ec6b6$var$Link;

});
parcelRegister("cjzM0", function(module, exports) {

$parcel$export(module.exports, "getLinkUtilityClass", function () { return $8f730237ea7fc559$export$d6efab9620b78fec; });
$parcel$export(module.exports, "default", function () { return $8f730237ea7fc559$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $8f730237ea7fc559$export$d6efab9620b78fec(slot) {
    return (0, $k6RDS.default)('MuiLink', slot);
}
const $8f730237ea7fc559$var$linkClasses = (0, $4jzsB.default)('MuiLink', [
    'root',
    'underlineNone',
    'underlineHover',
    'underlineAlways',
    'button',
    'focusVisible'
]);
var $8f730237ea7fc559$export$2e2bcd8739ae039 = $8f730237ea7fc559$var$linkClasses;

});

parcelRegister("Q7L0K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09cadfdec33133b7$export$2e2bcd8739ae039; });

var $1cYnP = parcelRequire("1cYnP");

var $kDjHH = parcelRequire("kDjHH");
const $09cadfdec33133b7$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = ownerState.color;
    // check the `main` color first for a custom palette, then fallback to the color itself
    const color = (0, $1cYnP.getPath)(theme, `palette.${transformedColor}.main`, false) || (0, $1cYnP.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $1cYnP.getPath)(theme, `palette.${transformedColor}.mainChannel`) || (0, $1cYnP.getPath)(theme, `palette.${transformedColor}Channel`);
    if ('vars' in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $kDjHH.alpha)(color, 0.4);
};
var $09cadfdec33133b7$export$2e2bcd8739ae039 = $09cadfdec33133b7$var$getTextDecoration;

});


parcelRegister("9h23A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d20b5a63d8d9297$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $5ZeKC = parcelRequire("5ZeKC");
var $iibPM = parcelRequire("iibPM");

var $gs8xE = parcelRequire("gs8xE");
function $7d20b5a63d8d9297$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $5ZeKC.default), {
        color: "primary",
        disabled: props.disabled || props.loading,
        ref: props.buttonRef,
        variant: "contained",
        ...props.buttonProps,
        children: [
            props.children,
            props.loading && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iibPM.default), {
                size: 24,
                style: {
                    color: (0, $gs8xE.themeColors).success,
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: -12,
                    marginLeft: -12
                }
            })
        ]
    });
}

});

parcelRegister("tUv8Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae1e74de809da912$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $a15PZ = parcelRequire("a15PZ");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $gzXcP = parcelRequire("gzXcP");

var $cSUCP = parcelRequire("cSUCP");

var $2VP0e = parcelRequire("2VP0e");
function $ae1e74de809da912$export$2e2bcd8739ae039(props) {
    const setSuccess = props.setSuccess;
    const isRequired = (0, $7fPBF.useRef)((0, $2VP0e.RuntimeConfig).getInstance().captchaRequired());
    const { i18n: i18n, t: t } = (0, $doyfp.useTranslation)();
    (0, $7fPBF.useEffect)(()=>{
        setSuccess(!isRequired.current);
    }, [
        isRequired,
        setSuccess
    ]);
    const fail = ()=>{
        setSuccess(false);
        (0, $gzXcP.toast).error(t("captcha.error"));
    };
    const succeed = ()=>{
        setSuccess(true);
    };
    const verify = (token)=>{
        (0, $cSUCP.verifyCaptchaToken)(token).then((isVerified)=>isVerified ? succeed() : fail());
    };
    return isRequired.current ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a15PZ.Turnstile), {
        onError: fail,
        onExpire: fail,
        onSuccess: verify,
        options: {
            language: i18n.resolvedLanguage,
            theme: "light"
        },
        siteKey: (0, $2VP0e.RuntimeConfig).getInstance().captchaSiteKey()
    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7fPBF.Fragment), {});
}

});
parcelRegister("a15PZ", function(module, exports) {

$parcel$export(module.exports, "Turnstile", function () { return $74ae86971dac331c$export$9370f0117bf9debc; });

var $7fPBF = parcelRequire("7fPBF");

var $bbzbN = parcelRequire("bbzbN");
'use client';
var $74ae86971dac331c$var$c = (0, $7fPBF.forwardRef)(({ as: e = `div`, ...t }, n)=>/* @__PURE__ */ (0, $bbzbN.jsx)(e, {
        ...t,
        ref: n
    }));
const $74ae86971dac331c$export$f87af7f569aace70 = `https://challenges.cloudflare.com/turnstile/v0/api.js`, $74ae86971dac331c$export$2eea204f6220c925 = `cf-turnstile-script`, $74ae86971dac331c$export$2ce14c6f26d19d0f = `cf-turnstile`, $74ae86971dac331c$export$da1f91a396bc4872 = `onloadTurnstileCallback`, $74ae86971dac331c$var$p = (e)=>!!document.getElementById(e), $74ae86971dac331c$var$m = ({ render: e = `explicit`, onLoadCallbackName: t = $74ae86971dac331c$export$da1f91a396bc4872, scriptOptions: { nonce: n = ``, defer: r = !0, async: i = !0, id: a = ``, appendTo: o, onError: s, crossOrigin: c = `` } = {} })=>{
    let u = a || `cf-turnstile-script`;
    if ($74ae86971dac331c$var$p(u)) return;
    let d = document.createElement(`script`);
    d.id = u, d.src = `${$74ae86971dac331c$export$f87af7f569aace70}?onload=${t}&render=${e}`, !document.querySelector(`script[src="${d.src}"]`) && (d.defer = !!r, d.async = !!i, n && d.setAttribute(`nonce`, n), c && (d.crossOrigin = c), s && (d.onerror = ()=>{
        delete window[t], s();
    }), (o === `body` ? document.body : document.getElementsByTagName(`head`)[0]).appendChild(d));
}, $74ae86971dac331c$var$h = {
    normal: {
        width: 300,
        height: 65
    },
    compact: {
        width: 150,
        height: 140
    },
    invisible: {
        width: 0,
        height: 0,
        overflow: `hidden`
    },
    flexible: {
        minWidth: 300,
        width: `100%`,
        height: 65
    }
};
function $74ae86971dac331c$var$g(e) {
    if (e !== `invisible`) return e;
}
function $74ae86971dac331c$var$_(e = $74ae86971dac331c$export$2eea204f6220c925) {
    let [t, r] = (0, $7fPBF.useState)(!1);
    return (0, $7fPBF.useEffect)(()=>{
        let t = ()=>{
            $74ae86971dac331c$var$p(e) && r(!0);
        }, n = new MutationObserver(t);
        return n.observe(document, {
            childList: !0,
            subtree: !0
        }), t(), ()=>{
            n.disconnect();
        };
    }, [
        e
    ]), t;
}
let $74ae86971dac331c$var$v = `unloaded`, $74ae86971dac331c$var$y;
const $74ae86971dac331c$var$b = new Promise((e, t)=>{
    $74ae86971dac331c$var$y = {
        resolve: e,
        reject: t
    }, $74ae86971dac331c$var$v === `ready` && e(void 0);
}), $74ae86971dac331c$var$x = (e = $74ae86971dac331c$export$da1f91a396bc4872)=>($74ae86971dac331c$var$v === `unloaded` && ($74ae86971dac331c$var$v = `loading`, window[e] = ()=>{
        $74ae86971dac331c$var$y.resolve(), $74ae86971dac331c$var$v = `ready`, delete window[e];
    }), $74ae86971dac331c$var$b), $74ae86971dac331c$export$9370f0117bf9debc = (0, $7fPBF.forwardRef)((e, l)=>{
    let { scriptOptions: u, options: d = {}, siteKey: f, onWidgetLoad: p, onSuccess: y, onExpire: b, onError: S, onBeforeInteractive: C, onAfterInteractive: w, onUnsupported: T, onTimeout: E, onLoadScript: D, id: O, style: k, as: A = `div`, injectScript: j = !0, rerenderOnCallbackChange: M = !1, ...N } = e, P = d.size, F = (0, $7fPBF.useMemo)(()=>{
        if (P === void 0) return {};
        let e = $74ae86971dac331c$var$h[P];
        return d.appearance === `interaction-only` ? {
            ...e,
            height: `auto`
        } : e;
    }, [
        P,
        d.appearance
    ]), I = d.execution === `execute` ? $74ae86971dac331c$var$h.invisible : F, [L, R] = (0, $7fPBF.useState)(I), z = (0, $7fPBF.useRef)(null), [B, V] = (0, $7fPBF.useState)(!1), H = (0, $7fPBF.useRef)(void 0), U = (0, $7fPBF.useRef)(!1), W = O || `cf-turnstile`, G = (0, $7fPBF.useRef)({
        onSuccess: y,
        onError: S,
        onExpire: b,
        onBeforeInteractive: C,
        onAfterInteractive: w,
        onUnsupported: T,
        onTimeout: E
    });
    (0, $7fPBF.useEffect)(()=>{
        M || (G.current = {
            onSuccess: y,
            onError: S,
            onExpire: b,
            onBeforeInteractive: C,
            onAfterInteractive: w,
            onUnsupported: T,
            onTimeout: E
        });
    });
    let K = u?.id || `cf-turnstile-script`, q = $74ae86971dac331c$var$_(K), J = u?.onLoadCallbackName || `onloadTurnstileCallback`, Y = (0, $7fPBF.useMemo)(()=>({
            sitekey: f,
            action: d.action,
            cData: d.cData,
            theme: d.theme || `auto`,
            language: d.language || `auto`,
            tabindex: d.tabIndex,
            "response-field": d.responseField,
            "response-field-name": d.responseFieldName,
            size: $74ae86971dac331c$var$g(P),
            retry: d.retry || `auto`,
            "retry-interval": d.retryInterval || 8e3,
            "refresh-expired": d.refreshExpired || `auto`,
            "refresh-timeout": d.refreshTimeout || `auto`,
            execution: d.execution || `render`,
            appearance: d.appearance || `always`,
            "feedback-enabled": d.feedbackEnabled ?? !0,
            "offlabel-show-privacy": d.offlabelShowPrivacy ?? !0,
            "offlabel-show-help": d.offlabelShowHelp ?? !0,
            callback: (e)=>{
                U.current = !0, M ? y?.(e) : G.current.onSuccess?.(e);
            },
            "error-callback": M ? S : (...e)=>G.current.onError?.(...e),
            "expired-callback": M ? b : (...e)=>G.current.onExpire?.(...e),
            "before-interactive-callback": M ? C : (...e)=>G.current.onBeforeInteractive?.(...e),
            "after-interactive-callback": M ? w : (...e)=>G.current.onAfterInteractive?.(...e),
            "unsupported-callback": M ? T : (...e)=>G.current.onUnsupported?.(...e),
            "timeout-callback": M ? E : (...e)=>G.current.onTimeout?.(...e)
        }), [
        d.action,
        d.appearance,
        d.cData,
        d.execution,
        d.language,
        d.refreshExpired,
        d.responseField,
        d.responseFieldName,
        d.retry,
        d.retryInterval,
        d.tabIndex,
        d.theme,
        d.feedbackEnabled,
        d.offlabelShowPrivacy,
        d.offlabelShowHelp,
        d.refreshTimeout,
        f,
        P,
        M,
        M ? y : null,
        M ? S : null,
        M ? b : null,
        M ? C : null,
        M ? w : null,
        M ? T : null,
        M ? E : null
    ]), X = (0, $7fPBF.useCallback)(()=>typeof window < `u` && !!window.turnstile, []), Z = (0, $7fPBF.useCallback)((e, t)=>{
        try {
            return window.turnstile.render(e, t);
        } catch (e) {
            let t = M ? S : G.current.onError;
            t ? t(e instanceof Error ? e.message : String(e)) : console.error(e);
            return;
        }
    }, [
        M,
        M ? S : null
    ]);
    return (0, $7fPBF.useEffect)(function() {
        j && !B && ($74ae86971dac331c$var$x(J), $74ae86971dac331c$var$m({
            onLoadCallbackName: J,
            scriptOptions: {
                ...u,
                id: K
            }
        }));
    }, [
        j,
        B,
        u,
        K,
        J
    ]), (0, $7fPBF.useEffect)(function() {
        $74ae86971dac331c$var$v !== `ready` && $74ae86971dac331c$var$x(J).then(()=>V(!0)).catch(console.error);
    }, [
        J
    ]), (0, $7fPBF.useEffect)(function() {
        if (!z.current || !B) return;
        let e = !1;
        return (async ()=>{
            if (e || !z.current) return;
            let t = Z(z.current, Y);
            H.current = t, R(I), H.current && p?.(H.current);
        })(), ()=>{
            e = !0, H.current && (window.turnstile.remove(H.current), U.current = !1);
        };
    }, [
        W,
        B,
        Y,
        I,
        Z
    ]), (0, $7fPBF.useImperativeHandle)(l, ()=>{
        let { turnstile: e } = window;
        return {
            getResponse () {
                if (!e?.getResponse || !H.current || !X()) console.warn(`Turnstile has not been loaded`);
                else return e.getResponse(H.current);
            },
            async getResponsePromise (e = 3e4, t = 100) {
                return new Promise((n, r)=>{
                    let i, a = async ()=>{
                        if (U.current && window.turnstile && H.current) try {
                            let e = window.turnstile.getResponse(H.current);
                            return i && clearTimeout(i), e ? n(e) : r(/* @__PURE__ */ Error(`No response received`));
                        } catch (e) {
                            return i && clearTimeout(i), console.warn(`Failed to get response`, e), r(/* @__PURE__ */ Error(`Failed to get response`));
                        }
                        i ||= setTimeout(()=>{
                            i && clearTimeout(i), r(/* @__PURE__ */ Error(`Timeout`));
                        }, e), await new Promise((e)=>setTimeout(e, t)), await a();
                    };
                    a();
                });
            },
            reset () {
                if (!e?.reset || !H.current || !X()) console.warn(`Turnstile has not been loaded`);
                else {
                    R(I);
                    try {
                        U.current = !1, e.reset(H.current);
                    } catch (e) {
                        console.warn(`Failed to reset Turnstile widget ${H.current}`, e);
                    }
                }
            },
            remove () {
                !e?.remove || !H.current || !X() ? console.warn(`Turnstile has not been loaded`) : (R($74ae86971dac331c$var$h.invisible), U.current = !1, e.remove(H.current), H.current = null);
            },
            render () {
                if (!e?.render || !z.current || !X() || H.current) {
                    console.warn(`Turnstile has not been loaded or container not found`);
                    return;
                }
                let t = Z(z.current, Y);
                return H.current = t, H.current && p?.(H.current), R(I), t;
            },
            execute () {
                d.execution === `execute` ? !e?.execute || !z.current || !H.current || !X() ? console.warn(`Turnstile has not been loaded or container not found`) : (e.execute(z.current), R(F)) : console.warn(`Execution mode is not set to "execute"`);
            },
            isExpired () {
                return !e?.isExpired || !H.current || !X() ? (console.warn(`Turnstile has not been loaded`), !1) : e.isExpired(H.current);
            }
        };
    }, [
        H,
        d.execution,
        Y,
        z,
        X,
        Z,
        B,
        p,
        I,
        F
    ]), (0, $7fPBF.useEffect)(()=>{
        if (B || !q) return;
        if (window.turnstile) {
            V(!0);
            return;
        }
        let e = setInterval(()=>{
            window.turnstile && (V(!0), clearInterval(e));
        }, 50);
        return ()=>{
            clearInterval(e);
        };
    }, [
        B,
        q
    ]), (0, $7fPBF.useEffect)(()=>{
        R(I);
    }, [
        I
    ]), (0, $7fPBF.useEffect)(()=>{
        q && typeof D == `function` && D();
    }, [
        q
    ]), /* @__PURE__ */ (0, $bbzbN.jsx)($74ae86971dac331c$var$c, {
        ref: z,
        as: A,
        id: W,
        style: {
            ...L,
            ...k
        },
        ...N
    });
});
$74ae86971dac331c$export$9370f0117bf9debc.displayName = `Turnstile`;

});

parcelRegister("gzXcP", function(module, exports) {

$parcel$export(module.exports, "ToastContainer", function () { return $de77e498e07914bf$export$f2815235e76a62b9; });
$parcel$export(module.exports, "toast", function () { return $de77e498e07914bf$export$b410431fab84fa58; });

var $7fPBF = parcelRequire("7fPBF");

var $7z8qi = parcelRequire("7z8qi");
'use client';
const $de77e498e07914bf$var$u = (t)=>"number" == typeof t && !isNaN(t), $de77e498e07914bf$var$d = (t)=>"string" == typeof t, $de77e498e07914bf$var$p = (t)=>"function" == typeof t, $de77e498e07914bf$var$m = (t)=>$de77e498e07914bf$var$d(t) || $de77e498e07914bf$var$p(t) ? t : null, $de77e498e07914bf$var$f = (t)=>(0, $7fPBF.isValidElement)(t) || $de77e498e07914bf$var$d(t) || $de77e498e07914bf$var$p(t) || $de77e498e07914bf$var$u(t);
function $de77e498e07914bf$export$184cca501f1aed7f(t, e, n) {
    void 0 === n && (n = 300);
    const { scrollHeight: o, style: s } = t;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = o + "px", s.transition = `all ${n}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(e, n);
        });
    });
}
function $de77e498e07914bf$export$3ff7dc44d332d222(e) {
    let { enter: a, exit: r, appendPosition: i = !1, collapse: l = !0, collapseDuration: c = 300 } = e;
    return function(e) {
        let { children: u, position: d, preventExitTransition: p, done: m, nodeRef: f, isIn: h } = e;
        const y = i ? `${a}--${d}` : a, v = i ? `${r}--${d}` : r, T = (0, $7fPBF.useRef)(0);
        return (0, $7fPBF.useLayoutEffect)(()=>{
            const t = f.current, e = y.split(" "), n = (o)=>{
                o.target === f.current && (t.dispatchEvent(new Event("d")), t.removeEventListener("animationend", n), t.removeEventListener("animationcancel", n), 0 === T.current && "animationcancel" !== o.type && t.classList.remove(...e));
            };
            t.classList.add(...e), t.addEventListener("animationend", n), t.addEventListener("animationcancel", n);
        }, []), (0, $7fPBF.useEffect)(()=>{
            const t = f.current, e = ()=>{
                t.removeEventListener("animationend", e), l ? $de77e498e07914bf$export$184cca501f1aed7f(t, m, c) : m();
            };
            h || (p ? e() : (T.current = 1, t.className += ` ${v}`, t.addEventListener("animationend", e)));
        }, [
            h
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, u);
    };
}
function $de77e498e07914bf$var$y(t, e) {
    return null != t ? {
        content: t.content,
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        status: e
    } : {};
}
const $de77e498e07914bf$var$v = {
    list: new Map,
    emitQueue: new Map,
    on (t, e) {
        return this.list.has(t) || this.list.set(t, []), this.list.get(t).push(e), this;
    },
    off (t, e) {
        if (e) {
            const n = this.list.get(t).filter((t)=>t !== e);
            return this.list.set(t, n), this;
        }
        return this.list.delete(t), this;
    },
    cancelEmit (t) {
        const e = this.emitQueue.get(t);
        return e && (e.forEach(clearTimeout), this.emitQueue.delete(t)), this;
    },
    emit (t) {
        this.list.has(t) && this.list.get(t).forEach((e)=>{
            const n = setTimeout(()=>{
                e(...[].slice.call(arguments, 1));
            }, 0);
            this.emitQueue.has(t) || this.emitQueue.set(t, []), this.emitQueue.get(t).push(n);
        });
    }
}, $de77e498e07914bf$var$T = (e)=>{
    let { theme: n, type: o, ...s } = e;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: "colored" === n ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...s
    });
}, $de77e498e07914bf$export$4f13f83fd8bb1dac = {
    info: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($de77e498e07914bf$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
        }));
    },
    warning: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($de77e498e07914bf$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
            d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
        }));
    },
    success: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($de77e498e07914bf$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
        }));
    },
    error: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($de77e498e07914bf$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
            d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
        }));
    },
    spinner: function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "Toastify__spinner"
        });
    }
};
function $de77e498e07914bf$export$b262e13ca2dd2381(t) {
    const [, o] = (0, $7fPBF.useReducer)((t)=>t + 1, 0), [l, c] = (0, $7fPBF.useState)([]), g = (0, $7fPBF.useRef)(null), h = (0, $7fPBF.useRef)(new Map).current, T = (t)=>-1 !== l.indexOf(t), C = (0, $7fPBF.useRef)({
        toastKey: 1,
        displayedToast: 0,
        count: 0,
        queue: [],
        props: t,
        containerId: null,
        isToastActive: T,
        getToast: (t)=>h.get(t)
    }).current;
    function b(t) {
        let { containerId: e } = t;
        const { limit: n } = C.props;
        !n || e && C.containerId !== e || (C.count -= C.queue.length, C.queue = []);
    }
    function I(t) {
        c((e)=>null == t ? [] : e.filter((e)=>e !== t));
    }
    function _() {
        const { toastContent: t, toastProps: e, staleId: n } = C.queue.shift();
        O(t, e, n);
    }
    function L(t, n) {
        let { delay: s, staleId: r, ...i } = n;
        if (!$de77e498e07914bf$var$f(t) || function(t) {
            return !g.current || C.props.enableMultiContainer && t.containerId !== C.props.containerId || h.has(t.toastId) && null == t.updateId;
        }(i)) return;
        const { toastId: l, updateId: c, data: T } = i, { props: b } = C, L = ()=>I(l), N = null == c;
        N && C.count++;
        const M = {
            ...b,
            style: b.toastStyle,
            key: C.toastKey++,
            ...Object.fromEntries(Object.entries(i).filter((t)=>{
                let [e, n] = t;
                return null != n;
            })),
            toastId: l,
            updateId: c,
            data: T,
            closeToast: L,
            isIn: !1,
            className: $de77e498e07914bf$var$m(i.className || b.toastClassName),
            bodyClassName: $de77e498e07914bf$var$m(i.bodyClassName || b.bodyClassName),
            progressClassName: $de77e498e07914bf$var$m(i.progressClassName || b.progressClassName),
            autoClose: !i.isLoading && (R = i.autoClose, w = b.autoClose, !1 === R || $de77e498e07914bf$var$u(R) && R > 0 ? R : w),
            deleteToast () {
                const t = $de77e498e07914bf$var$y(h.get(l), "removed");
                h.delete(l), $de77e498e07914bf$var$v.emit(4, t);
                const e = C.queue.length;
                if (C.count = null == l ? C.count - C.displayedToast : C.count - 1, C.count < 0 && (C.count = 0), e > 0) {
                    const t = null == l ? C.props.limit : 1;
                    if (1 === e || 1 === t) C.displayedToast++, _();
                    else {
                        const n = t > e ? e : t;
                        C.displayedToast = n;
                        for(let t = 0; t < n; t++)_();
                    }
                } else o();
            }
        };
        var R, w;
        M.iconOut = function(t) {
            let { theme: n, type: o, isLoading: s, icon: r } = t, i = null;
            const l = {
                theme: n,
                type: o
            };
            return !1 === r || ($de77e498e07914bf$var$p(r) ? i = r(l) : (0, $7fPBF.isValidElement)(r) ? i = (0, $7fPBF.cloneElement)(r, l) : $de77e498e07914bf$var$d(r) || $de77e498e07914bf$var$u(r) ? i = r : s ? i = $de77e498e07914bf$export$4f13f83fd8bb1dac.spinner() : ((t)=>t in $de77e498e07914bf$export$4f13f83fd8bb1dac)(o) && (i = $de77e498e07914bf$export$4f13f83fd8bb1dac[o](l))), i;
        }(M), $de77e498e07914bf$var$p(i.onOpen) && (M.onOpen = i.onOpen), $de77e498e07914bf$var$p(i.onClose) && (M.onClose = i.onClose), M.closeButton = b.closeButton, !1 === i.closeButton || $de77e498e07914bf$var$f(i.closeButton) ? M.closeButton = i.closeButton : !0 === i.closeButton && (M.closeButton = !$de77e498e07914bf$var$f(b.closeButton) || b.closeButton);
        let x = t;
        (0, $7fPBF.isValidElement)(t) && !$de77e498e07914bf$var$d(t.type) ? x = (0, $7fPBF.cloneElement)(t, {
            closeToast: L,
            toastProps: M,
            data: T
        }) : $de77e498e07914bf$var$p(t) && (x = t({
            closeToast: L,
            toastProps: M,
            data: T
        })), b.limit && b.limit > 0 && C.count > b.limit && N ? C.queue.push({
            toastContent: x,
            toastProps: M,
            staleId: r
        }) : $de77e498e07914bf$var$u(s) ? setTimeout(()=>{
            O(x, M, r);
        }, s) : O(x, M, r);
    }
    function O(t, e, n) {
        const { toastId: o } = e;
        n && h.delete(n);
        const s = {
            content: t,
            props: e
        };
        h.set(o, s), c((t)=>[
                ...t,
                o
            ].filter((t)=>t !== n)), $de77e498e07914bf$var$v.emit(4, $de77e498e07914bf$var$y(s, null == s.props.updateId ? "added" : "updated"));
    }
    return (0, $7fPBF.useEffect)(()=>(C.containerId = t.containerId, $de77e498e07914bf$var$v.cancelEmit(3).on(0, L).on(1, (t)=>g.current && I(t)).on(5, b).emit(2, C), ()=>{
            h.clear(), $de77e498e07914bf$var$v.emit(3, C);
        }), []), (0, $7fPBF.useEffect)(()=>{
        C.props = t, C.isToastActive = T, C.displayedToast = l.length;
    }), {
        getToastToRender: function(e) {
            const n = new Map, o = Array.from(h.values());
            return t.newestOnTop && o.reverse(), o.forEach((t)=>{
                const { position: e } = t.props;
                n.has(e) || n.set(e, []), n.get(e).push(t);
            }), Array.from(n, (t)=>e(t[0], t[1]));
        },
        containerRef: g,
        isToastActive: T
    };
}
function $de77e498e07914bf$var$b(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientX : t.clientX;
}
function $de77e498e07914bf$var$I(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientY : t.clientY;
}
function $de77e498e07914bf$export$a407b657d3044108(t) {
    const [o, a] = (0, $7fPBF.useState)(!1), [r, l] = (0, $7fPBF.useState)(!1), c = (0, $7fPBF.useRef)(null), u = (0, $7fPBF.useRef)({
        start: 0,
        x: 0,
        y: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        boundingRect: null,
        didMove: !1
    }).current, d = (0, $7fPBF.useRef)(t), { autoClose: m, pauseOnHover: f, closeToast: g, onClick: h, closeOnClick: y } = t;
    function v(e) {
        if (t.draggable) {
            "touchstart" === e.nativeEvent.type && e.nativeEvent.preventDefault(), u.didMove = !1, document.addEventListener("mousemove", _), document.addEventListener("mouseup", L), document.addEventListener("touchmove", _), document.addEventListener("touchend", L);
            const n = c.current;
            u.canCloseOnClick = !0, u.canDrag = !0, u.boundingRect = n.getBoundingClientRect(), n.style.transition = "", u.x = $de77e498e07914bf$var$b(e.nativeEvent), u.y = $de77e498e07914bf$var$I(e.nativeEvent), "x" === t.draggableDirection ? (u.start = u.x, u.removalDistance = n.offsetWidth * (t.draggablePercent / 100)) : (u.start = u.y, u.removalDistance = n.offsetHeight * (80 === t.draggablePercent ? 1.5 * t.draggablePercent : t.draggablePercent / 100));
        }
    }
    function T(e) {
        if (u.boundingRect) {
            const { top: n, bottom: o, left: s, right: a } = u.boundingRect;
            "touchend" !== e.nativeEvent.type && t.pauseOnHover && u.x >= s && u.x <= a && u.y >= n && u.y <= o ? C() : E();
        }
    }
    function E() {
        a(!0);
    }
    function C() {
        a(!1);
    }
    function _(e) {
        const n = c.current;
        u.canDrag && n && (u.didMove = !0, o && C(), u.x = $de77e498e07914bf$var$b(e), u.y = $de77e498e07914bf$var$I(e), u.delta = "x" === t.draggableDirection ? u.x - u.start : u.y - u.start, u.start !== u.x && (u.canCloseOnClick = !1), n.style.transform = `translate${t.draggableDirection}(${u.delta}px)`, n.style.opacity = "" + (1 - Math.abs(u.delta / u.removalDistance)));
    }
    function L() {
        document.removeEventListener("mousemove", _), document.removeEventListener("mouseup", L), document.removeEventListener("touchmove", _), document.removeEventListener("touchend", L);
        const e = c.current;
        if (u.canDrag && u.didMove && e) {
            if (u.canDrag = !1, Math.abs(u.delta) > u.removalDistance) return l(!0), void t.closeToast();
            e.style.transition = "transform 0.2s, opacity 0.2s", e.style.transform = `translate${t.draggableDirection}(0)`, e.style.opacity = "1";
        }
    }
    (0, $7fPBF.useEffect)(()=>{
        d.current = t;
    }), (0, $7fPBF.useEffect)(()=>(c.current && c.current.addEventListener("d", E, {
            once: !0
        }), $de77e498e07914bf$var$p(t.onOpen) && t.onOpen((0, $7fPBF.isValidElement)(t.children) && t.children.props), ()=>{
            const t = d.current;
            $de77e498e07914bf$var$p(t.onClose) && t.onClose((0, $7fPBF.isValidElement)(t.children) && t.children.props);
        }), []), (0, $7fPBF.useEffect)(()=>(t.pauseOnFocusLoss && (document.hasFocus() || C(), window.addEventListener("focus", E), window.addEventListener("blur", C)), ()=>{
            t.pauseOnFocusLoss && (window.removeEventListener("focus", E), window.removeEventListener("blur", C));
        }), [
        t.pauseOnFocusLoss
    ]);
    const O = {
        onMouseDown: v,
        onTouchStart: v,
        onMouseUp: T,
        onTouchEnd: T
    };
    return m && f && (O.onMouseEnter = C, O.onMouseLeave = E), y && (O.onClick = (t)=>{
        h && h(t), u.canCloseOnClick && g();
    }), {
        playToast: E,
        pauseToast: C,
        isRunning: o,
        preventExitTransition: r,
        toastRef: c,
        eventHandlers: O
    };
}
function $de77e498e07914bf$var$L(e) {
    let { closeToast: n, theme: o, ariaLabel: s = "close" } = e;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (t)=>{
            t.stopPropagation(), n(t);
        },
        "aria-label": s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $de77e498e07914bf$var$O(e) {
    let { delay: n, isRunning: o, closeToast: s, type: a = "default", hide: r, className: i, style: l, controlledProgress: u, progress: d, rtl: m, isIn: f, theme: g } = e;
    const h = r || u && 0 === d, y = {
        ...l,
        animationDuration: `${n}ms`,
        animationPlayState: o ? "running" : "paused",
        opacity: h ? 0 : 1
    };
    u && (y.transform = `scaleX(${d})`);
    const v = (0, $7z8qi.default)("Toastify__progress-bar", u ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${a}`, {
        "Toastify__progress-bar--rtl": m
    }), T = $de77e498e07914bf$var$p(i) ? i({
        rtl: m,
        type: a,
        defaultClassName: v
    }) : (0, $7z8qi.default)(v, i);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        role: "progressbar",
        "aria-hidden": h ? "true" : "false",
        "aria-label": "notification timer",
        className: T,
        style: y,
        [u && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: u && d < 1 ? null : ()=>{
            f && s();
        }
    });
}
const $de77e498e07914bf$var$N = (n)=>{
    const { isRunning: o, preventExitTransition: s, toastRef: r, eventHandlers: i } = $de77e498e07914bf$export$a407b657d3044108(n), { closeButton: l, children: u, autoClose: d, onClick: m, type: f, hideProgressBar: g, closeToast: h, transition: y, position: v, className: T, style: E, bodyClassName: C, bodyStyle: b, progressClassName: I, progressStyle: N, updateId: M, role: R, progress: w, rtl: x, toastId: $, deleteToast: k, isIn: P, isLoading: B, iconOut: D, closeOnClick: A, theme: z } = n, F = (0, $7z8qi.default)("Toastify__toast", `Toastify__toast-theme--${z}`, `Toastify__toast--${f}`, {
        "Toastify__toast--rtl": x
    }, {
        "Toastify__toast--close-on-click": A
    }), H = $de77e498e07914bf$var$p(T) ? T({
        rtl: x,
        position: v,
        type: f,
        defaultClassName: F
    }) : (0, $7z8qi.default)(F, T), S = !!w || !d, q = {
        closeToast: h,
        type: f,
        theme: z
    };
    let Q = null;
    return !1 === l || (Q = $de77e498e07914bf$var$p(l) ? l(q) : (0, $7fPBF.isValidElement)(l) ? (0, $7fPBF.cloneElement)(l, q) : $de77e498e07914bf$var$L(q)), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(y, {
        isIn: P,
        done: k,
        position: v,
        preventExitTransition: s,
        nodeRef: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        id: $,
        onClick: m,
        className: H,
        ...i,
        style: E,
        ref: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        ...P && {
            role: R
        },
        className: $de77e498e07914bf$var$p(C) ? C({
            type: f
        }) : (0, $7z8qi.default)("Toastify__toast-body", C),
        style: b
    }, null != D && (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: (0, $7z8qi.default)("Toastify__toast-icon", {
            "Toastify--animate-icon Toastify__zoom-enter": !B
        })
    }, D), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null, u)), Q, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($de77e498e07914bf$var$O, {
        ...M && !S ? {
            key: `pb-${M}`
        } : {},
        rtl: x,
        theme: z,
        delay: d,
        isRunning: o,
        isIn: P,
        closeToast: h,
        hide: g,
        type: f,
        style: N,
        className: I,
        controlledProgress: S,
        progress: w || 0
    })));
}, $de77e498e07914bf$var$M = function(t, e) {
    return void 0 === e && (e = !1), {
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: e
    };
}, $de77e498e07914bf$export$d20e79fdc3899e95 = $de77e498e07914bf$export$3ff7dc44d332d222($de77e498e07914bf$var$M("bounce", !0)), $de77e498e07914bf$export$d8dc01b5c85a37b9 = $de77e498e07914bf$export$3ff7dc44d332d222($de77e498e07914bf$var$M("slide", !0)), $de77e498e07914bf$export$65cfd44a2050f99 = $de77e498e07914bf$export$3ff7dc44d332d222($de77e498e07914bf$var$M("zoom")), $de77e498e07914bf$export$4d2fae537bd90431 = $de77e498e07914bf$export$3ff7dc44d332d222($de77e498e07914bf$var$M("flip")), $de77e498e07914bf$export$f2815235e76a62b9 = (0, $7fPBF.forwardRef)((e, n)=>{
    const { getToastToRender: o, containerRef: a, isToastActive: r } = $de77e498e07914bf$export$b262e13ca2dd2381(e), { className: i, style: l, rtl: u, containerId: d } = e;
    function f(t) {
        const e = (0, $7z8qi.default)("Toastify__toast-container", `Toastify__toast-container--${t}`, {
            "Toastify__toast-container--rtl": u
        });
        return $de77e498e07914bf$var$p(i) ? i({
            position: t,
            rtl: u,
            defaultClassName: e
        }) : (0, $7z8qi.default)(e, $de77e498e07914bf$var$m(i));
    }
    return (0, $7fPBF.useEffect)(()=>{
        n && (n.current = a.current);
    }, []), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        ref: a,
        className: "Toastify",
        id: d
    }, o((e, n)=>{
        const o = n.length ? {
            ...l
        } : {
            ...l,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: f(e),
            style: o,
            key: `container-${e}`
        }, n.map((e, o)=>{
            let { content: s, props: a } = e;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($de77e498e07914bf$var$N, {
                ...a,
                isIn: r(a.toastId),
                style: {
                    ...a.style,
                    "--nth": o + 1,
                    "--len": n.length
                },
                key: `toast-${a.key}`
            }, s);
        }));
    }));
});
$de77e498e07914bf$export$f2815235e76a62b9.displayName = "ToastContainer", $de77e498e07914bf$export$f2815235e76a62b9.defaultProps = {
    position: "top-right",
    transition: $de77e498e07914bf$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: $de77e498e07914bf$var$L,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    closeOnClick: !0,
    draggable: !0,
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light"
};
let $de77e498e07914bf$var$P, $de77e498e07914bf$var$B = new Map, $de77e498e07914bf$var$D = [], $de77e498e07914bf$var$A = 1;
function $de77e498e07914bf$var$z() {
    return "" + $de77e498e07914bf$var$A++;
}
function $de77e498e07914bf$var$F(t) {
    return t && ($de77e498e07914bf$var$d(t.toastId) || $de77e498e07914bf$var$u(t.toastId)) ? t.toastId : $de77e498e07914bf$var$z();
}
function $de77e498e07914bf$var$H(t, e) {
    return $de77e498e07914bf$var$B.size > 0 ? $de77e498e07914bf$var$v.emit(0, t, e) : $de77e498e07914bf$var$D.push({
        content: t,
        options: e
    }), e.toastId;
}
function $de77e498e07914bf$var$S(t, e) {
    return {
        ...e,
        type: e && e.type || t,
        toastId: $de77e498e07914bf$var$F(e)
    };
}
function $de77e498e07914bf$var$q(t) {
    return (e, n)=>$de77e498e07914bf$var$H(e, $de77e498e07914bf$var$S(t, n));
}
function $de77e498e07914bf$export$b410431fab84fa58(t, e) {
    return $de77e498e07914bf$var$H(t, $de77e498e07914bf$var$S("default", e));
}
$de77e498e07914bf$export$b410431fab84fa58.loading = (t, e)=>$de77e498e07914bf$var$H(t, $de77e498e07914bf$var$S("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...e
    })), $de77e498e07914bf$export$b410431fab84fa58.promise = function(t, e, n) {
    let o, { pending: s, error: a, success: r } = e;
    s && (o = $de77e498e07914bf$var$d(s) ? $de77e498e07914bf$export$b410431fab84fa58.loading(s, n) : $de77e498e07914bf$export$b410431fab84fa58.loading(s.render, {
        ...n,
        ...s
    }));
    const i = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, l = (t, e, s)=>{
        if (null == e) return void $de77e498e07914bf$export$b410431fab84fa58.dismiss(o);
        const a = {
            type: t,
            ...i,
            ...n,
            data: s
        }, r = $de77e498e07914bf$var$d(e) ? {
            render: e
        } : e;
        return o ? $de77e498e07914bf$export$b410431fab84fa58.update(o, {
            ...a,
            ...r
        }) : $de77e498e07914bf$export$b410431fab84fa58(r.render, {
            ...a,
            ...r
        }), s;
    }, c = $de77e498e07914bf$var$p(t) ? t() : t;
    return c.then((t)=>l("success", r, t)).catch((t)=>l("error", a, t)), c;
}, $de77e498e07914bf$export$b410431fab84fa58.success = $de77e498e07914bf$var$q("success"), $de77e498e07914bf$export$b410431fab84fa58.info = $de77e498e07914bf$var$q("info"), $de77e498e07914bf$export$b410431fab84fa58.error = $de77e498e07914bf$var$q("error"), $de77e498e07914bf$export$b410431fab84fa58.warning = $de77e498e07914bf$var$q("warning"), $de77e498e07914bf$export$b410431fab84fa58.warn = $de77e498e07914bf$export$b410431fab84fa58.warning, $de77e498e07914bf$export$b410431fab84fa58.dark = (t, e)=>$de77e498e07914bf$var$H(t, $de77e498e07914bf$var$S("default", {
        theme: "dark",
        ...e
    })), $de77e498e07914bf$export$b410431fab84fa58.dismiss = (t)=>{
    $de77e498e07914bf$var$B.size > 0 ? $de77e498e07914bf$var$v.emit(1, t) : $de77e498e07914bf$var$D = $de77e498e07914bf$var$D.filter((e)=>null != t && e.options.toastId !== t);
}, $de77e498e07914bf$export$b410431fab84fa58.clearWaitingQueue = function(t) {
    return void 0 === t && (t = {}), $de77e498e07914bf$var$v.emit(5, t);
}, $de77e498e07914bf$export$b410431fab84fa58.isActive = (t)=>{
    let e = !1;
    return $de77e498e07914bf$var$B.forEach((n)=>{
        n.isToastActive && n.isToastActive(t) && (e = !0);
    }), e;
}, $de77e498e07914bf$export$b410431fab84fa58.update = function(t, e) {
    void 0 === e && (e = {}), setTimeout(()=>{
        const n = function(t, e) {
            let { containerId: n } = e;
            const o = $de77e498e07914bf$var$B.get(n || $de77e498e07914bf$var$P);
            return o && o.getToast(t);
        }(t, e);
        if (n) {
            const { props: o, content: s } = n, a = {
                delay: 100,
                ...o,
                ...e,
                toastId: e.toastId || t,
                updateId: $de77e498e07914bf$var$z()
            };
            a.toastId !== t && (a.staleId = t);
            const r = a.render || s;
            delete a.render, $de77e498e07914bf$var$H(r, a);
        }
    }, 0);
}, $de77e498e07914bf$export$b410431fab84fa58.done = (t)=>{
    $de77e498e07914bf$export$b410431fab84fa58.update(t, {
        progress: 1
    });
}, $de77e498e07914bf$export$b410431fab84fa58.onChange = (t)=>($de77e498e07914bf$var$v.on(4, t), ()=>{
        $de77e498e07914bf$var$v.off(4, t);
    }), $de77e498e07914bf$export$b410431fab84fa58.POSITION = {
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right",
    TOP_CENTER: "top-center",
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right",
    BOTTOM_CENTER: "bottom-center"
}, $de77e498e07914bf$export$b410431fab84fa58.TYPE = {
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error",
    DEFAULT: "default"
}, $de77e498e07914bf$var$v.on(2, (t)=>{
    $de77e498e07914bf$var$P = t.containerId || t, $de77e498e07914bf$var$B.set($de77e498e07914bf$var$P, t), $de77e498e07914bf$var$D.forEach((t)=>{
        $de77e498e07914bf$var$v.emit(0, t.content, t.options);
    }), $de77e498e07914bf$var$D = [];
}).on(3, (t)=>{
    $de77e498e07914bf$var$B.delete(t.containerId || t), 0 === $de77e498e07914bf$var$B.size && $de77e498e07914bf$var$v.off(0).off(1).off(5);
});

});
parcelRegister("7z8qi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $582255ee0585c19b$export$2e2bcd8739ae039; });
function $582255ee0585c19b$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $582255ee0585c19b$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $582255ee0585c19b$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $582255ee0585c19b$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $582255ee0585c19b$export$2e2bcd8739ae039 = $582255ee0585c19b$export$4f5d2d50c9deca37;

});



parcelRegister("2st3N", function(module, exports) {

$parcel$export(module.exports, "asyncLogIn", function () { return $0522e3568f8c1dd6$export$769b3c23ddb3632a; });
$parcel$export(module.exports, "asyncSignUp", function () { return $0522e3568f8c1dd6$export$daf0f48e22a1166d; });

var $cSUCP = parcelRequire("cSUCP");

var $7Th0Y = parcelRequire("7Th0Y");

var $9Ihvc = parcelRequire("9Ihvc");

var $6PJp8 = parcelRequire("6PJp8");

var $b6Qf8 = parcelRequire("b6Qf8");
// Action Creation Functions
/** Don't export! Only to be used when an admin logs in. */ function $0522e3568f8c1dd6$var$setIsAdminTrue() {
    return (0, $7Th0Y.setIsAdminTrueAction)();
}
/** Don't export! Only to be used when an email-verified user logs in. */ function $0522e3568f8c1dd6$var$setIsEmailVerifiedTrue() {
    return (0, $7Th0Y.setIsEmailVerifiedTrueAction)();
}
function $0522e3568f8c1dd6$export$bff2b4217ebde9c3(username) {
    return (0, $7Th0Y.setLoginAttemptAction)(username);
}
function $0522e3568f8c1dd6$export$15d12474f2aa2a2f(error) {
    return (0, $7Th0Y.setLoginFailureAction)(error);
}
function $0522e3568f8c1dd6$export$6c3f5566e4ac0cc6() {
    return (0, $7Th0Y.setLoginSuccessAction)();
}
function $0522e3568f8c1dd6$export$8fc63489d3ea4a6b(username) {
    return (0, $7Th0Y.setSignupAttemptAction)(username);
}
function $0522e3568f8c1dd6$export$367492685e5e2ba1(error) {
    return (0, $7Th0Y.setSignupFailureAction)(error);
}
function $0522e3568f8c1dd6$export$a9b5a20880d28ceb() {
    return (0, $7Th0Y.setSignupSuccessAction)();
}
function $0522e3568f8c1dd6$export$769b3c23ddb3632a(emailOrUsername, password, onSuccess) {
    return async (dispatch)=>{
        dispatch($0522e3568f8c1dd6$export$bff2b4217ebde9c3(emailOrUsername));
        await (0, $cSUCP.authenticateUser)(emailOrUsername, password).then(async (user)=>{
            if (user.isAdmin) dispatch($0522e3568f8c1dd6$var$setIsAdminTrue());
            if (user.isEmailVerified) dispatch($0522e3568f8c1dd6$var$setIsEmailVerifiedTrue());
            dispatch($0522e3568f8c1dd6$export$6c3f5566e4ac0cc6());
            onSuccess?.();
            (0, $9Ihvc.default).navigate((0, $6PJp8.Path).ProjScreen);
        }).catch((err)=>dispatch($0522e3568f8c1dd6$export$15d12474f2aa2a2f(`${err.response?.status ?? err.message}`)));
    };
}
function $0522e3568f8c1dd6$export$daf0f48e22a1166d(name, username, email, password, onSignupSuccess, onLoginSuccess) {
    return async (dispatch)=>{
        dispatch($0522e3568f8c1dd6$export$8fc63489d3ea4a6b(username));
        // Create new user
        const user = (0, $b6Qf8.newUser)(name, username, password);
        user.email = email;
        await (0, $cSUCP.addUser)(user).then(()=>{
            dispatch($0522e3568f8c1dd6$export$a9b5a20880d28ceb());
            onSignupSuccess?.();
            setTimeout(()=>{
                dispatch($0522e3568f8c1dd6$export$769b3c23ddb3632a(username, password, onLoginSuccess));
            }, 1000);
        }).catch((err)=>dispatch($0522e3568f8c1dd6$export$367492685e5e2ba1(err.response?.data ?? err.message)));
    };
}

});
parcelRegister("b6Qf8", function(module, exports) {

$parcel$export(module.exports, "newUser", function () { return $38d6c698031364d1$export$eb3f7f9055d38f7c; });
$parcel$export(module.exports, "doesTextMatchUser", function () { return $38d6c698031364d1$export$ca3620329454f78f; });
parcelRequire("585vO");
var $7FuOy = parcelRequire("7FuOy");
function $38d6c698031364d1$export$eb3f7f9055d38f7c(name = "", username = "", password = "") {
    return {
        name: name,
        username: username,
        password: password,
        id: "",
        avatar: "",
        hasAvatar: false,
        email: "",
        phone: "",
        projectRoles: {},
        workedProjects: {},
        glossSuggestion: (0, $7FuOy.OffOnSetting).On,
        token: "",
        isAdmin: false
    };
}
function $38d6c698031364d1$export$3ebc7d25698f6f96(name = "", username = "") {
    return {
        name: name,
        username: username,
        id: "",
        hasAvatar: false
    };
}
function $38d6c698031364d1$export$ca3620329454f78f(text, user) {
    const lower = text.toLocaleLowerCase();
    return user.name.toLocaleLowerCase().includes(lower) || user.username.toLocaleLowerCase().includes(lower) || user.email.toLocaleLowerCase().includes(lower);
}

});


parcelRegister("lMWJB", function(module, exports) {

$parcel$export(module.exports, "NormalizedTextField", function () { return $866677911c3ed726$export$99a46d7d9355a3bd; });
$parcel$export(module.exports, "TextFieldWithFont", function () { return $866677911c3ed726$export$c88bdb6eb4e10c17; });
$parcel$export(module.exports, "TypographyWithFont", function () { return $866677911c3ed726$export$a5230a83009f2f6; });
$parcel$export(module.exports, "LiWithFont", function () { return $866677911c3ed726$export$84a985097c95257a; });

var $bbzbN = parcelRequire("bbzbN");

var $f6ezL = parcelRequire("f6ezL");
var $3loMv = parcelRequire("3loMv");

var $7fPBF = parcelRequire("7fPBF");

var $lUGlA = parcelRequire("lUGlA");
function $866677911c3ed726$export$99a46d7d9355a3bd(props) {
    const { form: form, ...textFieldProps } = props;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f6ezL.default), {
        autoComplete: "off",
        ...textFieldProps,
        onChange: (e)=>{
            if (textFieldProps.onChange) {
                const value = e.target.value.normalize(form || "NFC");
                textFieldProps.onChange({
                    ...e,
                    target: {
                        ...e.target,
                        value: value
                    }
                });
            }
        }
    });
}
function $866677911c3ed726$export$c88bdb6eb4e10c17(props) {
    const fontContext = (0, $7fPBF.useContext)((0, $lUGlA.default));
    // Use spread to remove the custom props from what is passed into TextField.
    const { analysis: analysis, lang: lang, vernacular: vernacular, ...textFieldProps } = props;
    return /*#__PURE__*/ (0, $bbzbN.jsx)($866677911c3ed726$export$99a46d7d9355a3bd, {
        ...textFieldProps,
        InputProps: {
            ...textFieldProps.InputProps,
            style: fontContext.addFontToStyle({
                analysis: analysis,
                lang: lang,
                vernacular: vernacular
            }, textFieldProps.InputProps?.style)
        }
    });
}
function $866677911c3ed726$export$a5230a83009f2f6(props) {
    const fontContext = (0, $7fPBF.useContext)((0, $lUGlA.default));
    // Use spread to remove the custom props from what is passed into Typography.
    const { analysis: analysis, lang: lang, vernacular: vernacular, ...typographyProps } = props;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
        ...typographyProps,
        style: fontContext.addFontToStyle({
            analysis: analysis,
            lang: lang,
            vernacular: vernacular
        }, typographyProps.style)
    });
}
function $866677911c3ed726$export$84a985097c95257a(props) {
    const fontContext = (0, $7fPBF.useContext)((0, $lUGlA.default));
    // Use spread to remove the custom props from what is passed into li.
    const { analysis: analysis, lang: lang, vernacular: vernacular, ...liProps } = props;
    return /*#__PURE__*/ (0, $bbzbN.jsx)("li", {
        ...liProps,
        style: fontContext.addFontToStyle({
            analysis: analysis,
            lang: lang,
            vernacular: vernacular
        }, liProps.style)
    });
}

});
parcelRegister("f6ezL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afe2b905acb8b9f6$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $65Itt = parcelRequire("65Itt");


var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $jiLAb = parcelRequire("jiLAb");

var $lxNRp = parcelRequire("lxNRp");

var $6WEW6 = parcelRequire("6WEW6");

var $lHSFU = parcelRequire("lHSFU");

var $3jMGu = parcelRequire("3jMGu");

var $gFr0F = parcelRequire("gFr0F");

var $jh0sD = parcelRequire("jh0sD");

var $1VsKU = parcelRequire("1VsKU");

var $99c9I = parcelRequire("99c9I");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $afe2b905acb8b9f6$var$variantComponent = {
    standard: (0, $jiLAb.default),
    filled: (0, $lxNRp.default),
    outlined: (0, $6WEW6.default)
};
const $afe2b905acb8b9f6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $1VsKU.getTextFieldUtilityClass), classes);
};
const $afe2b905acb8b9f6$var$TextFieldRoot = (0, $kDBhE.default)((0, $3jMGu.default), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $afe2b905acb8b9f6$var$TextField = /*#__PURE__*/ $7fPBF.forwardRef(function TextField(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextPropsProp, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelPropsProp, inputProps: inputPropsProp, InputProps: InputPropsProp, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectPropsProp, slots: slots = {}, slotProps: slotProps = {}, type: type, value: value, variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    };
    const classes = $afe2b905acb8b9f6$var$useUtilityClasses(ownerState);
    const id = (0, $65Itt.default)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $afe2b905acb8b9f6$var$variantComponent[variant];
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: InputPropsProp,
            inputLabel: InputLabelPropsProp,
            htmlInput: inputPropsProp,
            formHelperText: FormHelperTextPropsProp,
            select: SelectPropsProp,
            ...slotProps
        }
    };
    const inputAdditionalProps = {};
    const inputLabelSlotProps = externalForwardedProps.slotProps.inputLabel;
    if (variant === 'outlined') {
        if (inputLabelSlotProps && typeof inputLabelSlotProps.shrink !== 'undefined') inputAdditionalProps.notched = inputLabelSlotProps.shrink;
        inputAdditionalProps.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectPropsProp || !SelectPropsProp.native) inputAdditionalProps.id = undefined;
        inputAdditionalProps['aria-describedby'] = undefined;
    }
    const [RootSlot, rootProps] = (0, $99c9I.default)('root', {
        elementType: $afe2b905acb8b9f6$var$TextFieldRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref,
        additionalProps: {
            disabled: disabled,
            error: error,
            fullWidth: fullWidth,
            required: required,
            color: color,
            variant: variant
        }
    });
    const [InputSlot, inputProps] = (0, $99c9I.default)('input', {
        elementType: InputComponent,
        externalForwardedProps: externalForwardedProps,
        additionalProps: inputAdditionalProps,
        ownerState: ownerState
    });
    const [InputLabelSlot, inputLabelProps] = (0, $99c9I.default)('inputLabel', {
        elementType: (0, $lHSFU.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [HtmlInputSlot, htmlInputProps] = (0, $99c9I.default)('htmlInput', {
        elementType: 'input',
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [FormHelperTextSlot, formHelperTextProps] = (0, $99c9I.default)('formHelperText', {
        elementType: (0, $gFr0F.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectSlot, selectProps] = (0, $99c9I.default)('select', {
        elementType: (0, $jh0sD.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const InputElement = /*#__PURE__*/ (0, $bbzbN.jsx)(InputSlot, {
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: htmlInputProps,
        slots: {
            input: slots.htmlInput ? HtmlInputSlot : undefined
        },
        ...inputProps
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $bbzbN.jsx)(InputLabelSlot, {
                htmlFor: id,
                id: inputLabelId,
                ...inputLabelProps,
                children: label
            }),
            select ? /*#__PURE__*/ (0, $bbzbN.jsx)(SelectSlot, {
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement,
                ...selectProps,
                children: children
            }) : InputElement,
            helperText && /*#__PURE__*/ (0, $bbzbN.jsx)(FormHelperTextSlot, {
                id: helperTextId,
                ...formHelperTextProps,
                children: helperText
            })
        ]
    });
});
var $afe2b905acb8b9f6$export$2e2bcd8739ae039 = $afe2b905acb8b9f6$var$TextField;

});
parcelRegister("jiLAb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0d49bb29c2f8b76$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $cFCqu = parcelRequire("cFCqu");

var $3wRTY = parcelRequire("3wRTY");


var $g1o71 = parcelRequire("g1o71");

var $HgAeG = parcelRequire("HgAeG");

var $kDBhE = parcelRequire("kDBhE");

var $7uFHh = parcelRequire("7uFHh");

var $wvp8q = parcelRequire("wvp8q");

var $iVAEr = parcelRequire("iVAEr");

var $eFvie = parcelRequire("eFvie");

var $g1o71 = parcelRequire("g1o71");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $e0d49bb29c2f8b76$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $eFvie.getInputUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $e0d49bb29c2f8b76$var$InputRoot = (0, $kDBhE.default)((0, $g1o71.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $HgAeG.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $g1o71.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $7uFHh.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        position: 'relative',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    'label + &': {
                        marginTop: 16
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $eFvie.default).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $eFvie.default).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $eFvie.default).disabled}, .${(0, $eFvie.default).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $eFvie.default).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $wvp8q.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                }))
        ]
    };
}));
const $e0d49bb29c2f8b76$var$InputInput = (0, $kDBhE.default)((0, $g1o71.InputBaseInput), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $g1o71.inputOverridesResolver)
})({});
const $e0d49bb29c2f8b76$var$Input = /*#__PURE__*/ $7fPBF.forwardRef(function Input(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const classes = $e0d49bb29c2f8b76$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $3wRTY.default)(slotProps ?? componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $e0d49bb29c2f8b76$var$InputRoot;
    const InputSlot = slots.input ?? components.Input ?? $e0d49bb29c2f8b76$var$InputInput;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $g1o71.default), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$e0d49bb29c2f8b76$var$Input.muiName = 'Input';
var $e0d49bb29c2f8b76$export$2e2bcd8739ae039 = $e0d49bb29c2f8b76$var$Input;

});
parcelRegister("g1o71", function(module, exports) {

$parcel$export(module.exports, "rootOverridesResolver", function () { return $ba9f7182d6802613$export$965edad20a84fa75; });
$parcel$export(module.exports, "inputOverridesResolver", function () { return $ba9f7182d6802613$export$cf507b112810e72d; });
$parcel$export(module.exports, "InputBaseRoot", function () { return $ba9f7182d6802613$export$298a043133d72a38; });
$parcel$export(module.exports, "InputBaseInput", function () { return $ba9f7182d6802613$export$ee10465db6ff6017; });
$parcel$export(module.exports, "default", function () { return $ba9f7182d6802613$export$2e2bcd8739ae039; });

var $diYUK = parcelRequire("diYUK");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");



var $cFCqu = parcelRequire("cFCqu");

var $lBj2s = parcelRequire("lBj2s");

var $2giBU = parcelRequire("2giBU");

var $jHiZl = parcelRequire("jHiZl");

var $kPqR2 = parcelRequire("kPqR2");

var $2jx1n = parcelRequire("2jx1n");

var $2HenE = parcelRequire("2HenE");
var $kDBhE = parcelRequire("kDBhE");

var $7uFHh = parcelRequire("7uFHh");

var $iVAEr = parcelRequire("iVAEr");

var $b6UUh = parcelRequire("b6UUh");

var $6NwTb = parcelRequire("6NwTb");

var $hQtyv = parcelRequire("hQtyv");

var $87FKv = parcelRequire("87FKv");

var $3HkEr = parcelRequire("3HkEr");

var $bbzbN = parcelRequire("bbzbN");
'use client';
var $ba9f7182d6802613$var$_InputGlobalStyles;
const $ba9f7182d6802613$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $b6UUh.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $ba9f7182d6802613$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $ba9f7182d6802613$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $b6UUh.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $b6UUh.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $3HkEr.getInputBaseUtilityClass), classes);
};
const $ba9f7182d6802613$export$298a043133d72a38 = (0, $kDBhE.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $ba9f7182d6802613$export$965edad20a84fa75
})((0, $7uFHh.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $3HkEr.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '4px 0 5px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: '100%'
                }
            }
        ]
    })));
const $ba9f7182d6802613$export$ee10465db6ff6017 = (0, $kDBhE.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $ba9f7182d6802613$export$cf507b112810e72d
})((0, $7uFHh.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = {
        color: 'currentColor',
        ...theme.vars ? {
            opacity: theme.vars.opacity.inputPlaceholder
        } : {
            opacity: light ? 0.42 : 0.5
        },
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return {
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $3HkEr.default).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $3HkEr.default).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInjectingGlobalStyles,
                style: {
                    animationName: 'mui-auto-fill-cancel',
                    animationDuration: '10ms',
                    '&:-webkit-autofill': {
                        animationDuration: '5000s',
                        animationName: 'mui-auto-fill'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    height: 'auto',
                    resize: 'none',
                    padding: 0,
                    paddingTop: 0
                }
            },
            {
                props: {
                    type: 'search'
                },
                style: {
                    MozAppearance: 'textfield' // Improve type search style.
                }
            }
        ]
    };
}));
const $ba9f7182d6802613$var$InputGlobalStyles = (0, $2HenE.globalCss)({
    '@keyframes mui-auto-fill': {
        from: {
            display: 'block'
        }
    },
    '@keyframes mui-auto-fill-cancel': {
        from: {
            display: 'block'
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $ba9f7182d6802613$var$InputBase = /*#__PURE__*/ $7fPBF.forwardRef(function InputBase(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, color: color, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, error: error, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, margin: margin, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, size: size, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp, ...other } = props;
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $7fPBF.useRef(value != null);
    const inputRef = $7fPBF.useRef();
    const handleInputRefWarning = $7fPBF.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $6NwTb.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $7fPBF.useState(false);
    const muiFormControl = (0, $2jx1n.default)();
    const fcs = (0, $jHiZl.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $7fPBF.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $7fPBF.useCallback((obj)=>{
        if ((0, $87FKv.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $hQtyv.default)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $diYUK.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $7fPBF.useEffect(()=>{
        checkDirty(inputRef.current);
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = {
            type: undefined,
            minRows: rows,
            maxRows: rows,
            ...inputProps
        };
        else inputProps = {
            type: undefined,
            maxRows: maxRows,
            minRows: minRows,
            ...inputProps
        };
        InputComponent = (0, $lBj2s.default);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $7fPBF.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    };
    const classes = $ba9f7182d6802613$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $ba9f7182d6802613$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $ba9f7182d6802613$export$ee10465db6ff6017;
    inputProps = {
        ...inputProps,
        ...slotProps.input ?? componentsProps.input
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            !disableInjectingGlobalStyles && typeof $ba9f7182d6802613$var$InputGlobalStyles === 'function' && // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
            ($ba9f7182d6802613$var$_InputGlobalStyles || ($ba9f7182d6802613$var$_InputGlobalStyles = /*#__PURE__*/ (0, $bbzbN.jsx)($ba9f7182d6802613$var$InputGlobalStyles, {}))),
            /*#__PURE__*/ (0, $bbzbN.jsxs)(Root, {
                ...rootProps,
                ref: ref,
                onClick: handleClick,
                ...other,
                ...!(0, $2giBU.default)(Root) && {
                    ownerState: {
                        ...ownerState,
                        ...rootProps.ownerState
                    }
                },
                className: (0, $hngXp.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kPqR2.default).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)(Input, {
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type,
                            ...inputProps,
                            ...!(0, $2giBU.default)(Input) && {
                                as: InputComponent,
                                ownerState: {
                                    ...ownerState,
                                    ...inputProps.ownerState
                                }
                            },
                            ref: handleInputRef,
                            className: (0, $hngXp.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        })
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix({
                        ...fcs,
                        startAdornment: startAdornment
                    }) : null
                ]
            })
        ]
    });
});
var $ba9f7182d6802613$export$2e2bcd8739ae039 = $ba9f7182d6802613$var$InputBase;

});
parcelRegister("lBj2s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb9bd25a2238f701$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $gHrsh = parcelRequire("gHrsh");
var $gE56a = parcelRequire("gE56a");
var $lJRRs = parcelRequire("lJRRs");
var $giDhD = parcelRequire("giDhD");
var $jTdAm = parcelRequire("jTdAm");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $fb9bd25a2238f701$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $fb9bd25a2238f701$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $fb9bd25a2238f701$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $fb9bd25a2238f701$var$isEmpty(obj) {
    return $fb9bd25a2238f701$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://v6.mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://v6.mui.com/material-ui/api/textarea-autosize/)
 */ const $fb9bd25a2238f701$var$TextareaAutosize = /*#__PURE__*/ $7fPBF.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value, ...other } = props;
    const { current: isControlled } = $7fPBF.useRef(value != null);
    const textareaRef = $7fPBF.useRef(null);
    const handleRef = (0, $jTdAm.default)(forwardedRef, textareaRef);
    const heightRef = $7fPBF.useRef(null);
    const hiddenTextareaRef = $7fPBF.useRef(null);
    const calculateTextareaStyles = $7fPBF.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $gE56a.default)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $fb9bd25a2238f701$var$getStyleValue(computedStyle.paddingBottom) + $fb9bd25a2238f701$var$getStyleValue(computedStyle.paddingTop);
        const border = $fb9bd25a2238f701$var$getStyleValue(computedStyle.borderBottomWidth) + $fb9bd25a2238f701$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $giDhD.default)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $fb9bd25a2238f701$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $7fPBF.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $fb9bd25a2238f701$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $7fPBF.useRef(-1);
    (0, $lJRRs.default)(()=>{
        const debouncedHandleResize = (0, $gHrsh.default)(syncHeight);
        const textarea = textareaRef?.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $gE56a.default)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $lJRRs.default)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("textarea", {
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style,
                ...other
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: {
                    ...$fb9bd25a2238f701$var$styles.shadow,
                    ...style,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            })
        ]
    });
});
var $fb9bd25a2238f701$export$2e2bcd8739ae039 = $fb9bd25a2238f701$var$TextareaAutosize;

});
parcelRegister("gHrsh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c285f587ed4585eb$export$2e2bcd8739ae039; });
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $c285f587ed4585eb$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});


parcelRegister("2giBU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a5b8306608cd33a$export$2e2bcd8739ae039; });
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $1a5b8306608cd33a$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $1a5b8306608cd33a$export$2e2bcd8739ae039 = $1a5b8306608cd33a$var$isHostComponent;

});

parcelRegister("jHiZl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e570c333aacea667$export$2e2bcd8739ae039; });
function $e570c333aacea667$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});

parcelRegister("kPqR2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f29d66cab44a33c0$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * @ignore - internal component.
 */ const $f29d66cab44a33c0$var$FormControlContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
var $f29d66cab44a33c0$export$2e2bcd8739ae039 = $f29d66cab44a33c0$var$FormControlContext;

});

parcelRegister("2jx1n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1af6f86e160474f0$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $kPqR2 = parcelRequire("kPqR2");
'use client';
function $1af6f86e160474f0$export$2e2bcd8739ae039() {
    return $7fPBF.useContext((0, $kPqR2.default));
}

});

parcelRegister("hQtyv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfde3819487a0686$export$2e2bcd8739ae039; });

var $lJRRs = parcelRequire("lJRRs");
'use client';
var $cfde3819487a0686$export$2e2bcd8739ae039 = (0, $lJRRs.default);

});

parcelRegister("87FKv", function(module, exports) {

$parcel$export(module.exports, "isFilled", function () { return $5e9f5ca6e3e911fc$export$d652b828d7fdeff8; });
$parcel$export(module.exports, "isAdornedStart", function () { return $5e9f5ca6e3e911fc$export$1b68bdfa56faeb5d; });
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $5e9f5ca6e3e911fc$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $5e9f5ca6e3e911fc$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($5e9f5ca6e3e911fc$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $5e9f5ca6e3e911fc$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $5e9f5ca6e3e911fc$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}

});

parcelRegister("3HkEr", function(module, exports) {

$parcel$export(module.exports, "getInputBaseUtilityClass", function () { return $2b15682cef07fc0a$export$ef57d5c8ca2278f6; });
$parcel$export(module.exports, "default", function () { return $2b15682cef07fc0a$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $2b15682cef07fc0a$export$ef57d5c8ca2278f6(slot) {
    return (0, $k6RDS.default)('MuiInputBase', slot);
}
const $2b15682cef07fc0a$var$inputBaseClasses = (0, $4jzsB.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $2b15682cef07fc0a$export$2e2bcd8739ae039 = $2b15682cef07fc0a$var$inputBaseClasses;

});


parcelRegister("eFvie", function(module, exports) {

$parcel$export(module.exports, "getInputUtilityClass", function () { return $aadd2b32ac43594b$export$cdb270390122322b; });
$parcel$export(module.exports, "default", function () { return $aadd2b32ac43594b$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");

var $3HkEr = parcelRequire("3HkEr");
function $aadd2b32ac43594b$export$cdb270390122322b(slot) {
    return (0, $k6RDS.default)('MuiInput', slot);
}
const $aadd2b32ac43594b$var$inputClasses = {
    ...(0, $3HkEr.default),
    ...(0, $4jzsB.default)('MuiInput', [
        'root',
        'underline',
        'input'
    ])
};
var $aadd2b32ac43594b$export$2e2bcd8739ae039 = $aadd2b32ac43594b$var$inputClasses;

});


parcelRegister("lxNRp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $faf35b44bb61ebfd$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $3wRTY = parcelRequire("3wRTY");



var $cFCqu = parcelRequire("cFCqu");

var $g1o71 = parcelRequire("g1o71");

var $HgAeG = parcelRequire("HgAeG");

var $kDBhE = parcelRequire("kDBhE");

var $7uFHh = parcelRequire("7uFHh");

var $wvp8q = parcelRequire("wvp8q");

var $iVAEr = parcelRequire("iVAEr");

var $gImJ8 = parcelRequire("gImJ8");

var $g1o71 = parcelRequire("g1o71");

var $b6UUh = parcelRequire("b6UUh");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $faf35b44bb61ebfd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline, startAdornment: startAdornment, endAdornment: endAdornment, size: size, hiddenLabel: hiddenLabel, multiline: multiline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            size === 'small' && `size${(0, $b6UUh.default)(size)}`,
            hiddenLabel && 'hiddenLabel',
            multiline && 'multiline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $gImJ8.getFilledInputUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $faf35b44bb61ebfd$var$FilledInputRoot = (0, $kDBhE.default)((0, $g1o71.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $HgAeG.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $g1o71.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $7uFHh.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $gImJ8.default).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $gImJ8.default).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $gImJ8.default).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $gImJ8.default).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $gImJ8.default).disabled}, .${(0, $gImJ8.default).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $gImJ8.default).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $wvp8q.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        disableUnderline: false,
                        color: color
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '25px 12px 8px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            }
        ]
    };
}));
const $faf35b44bb61ebfd$var$FilledInputInput = (0, $kDBhE.default)((0, $g1o71.InputBaseInput), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $g1o71.inputOverridesResolver)
})((0, $7uFHh.default)(({ theme: theme })=>({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }
            }
        ]
    })));
const $faf35b44bb61ebfd$var$FilledInput = /*#__PURE__*/ $7fPBF.forwardRef(function FilledInput(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const ownerState = {
        ...props,
        disableUnderline: disableUnderline,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    };
    const classes = $faf35b44bb61ebfd$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $3wRTY.default)(filledInputComponentsProps, slotProps ?? componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $faf35b44bb61ebfd$var$FilledInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $faf35b44bb61ebfd$var$FilledInputInput;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $g1o71.default), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$faf35b44bb61ebfd$var$FilledInput.muiName = 'Input';
var $faf35b44bb61ebfd$export$2e2bcd8739ae039 = $faf35b44bb61ebfd$var$FilledInput;

});
parcelRegister("gImJ8", function(module, exports) {

$parcel$export(module.exports, "getFilledInputUtilityClass", function () { return $c2b262889cde4af1$export$3331e419f1a48437; });
$parcel$export(module.exports, "default", function () { return $c2b262889cde4af1$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");

var $3HkEr = parcelRequire("3HkEr");
function $c2b262889cde4af1$export$3331e419f1a48437(slot) {
    return (0, $k6RDS.default)('MuiFilledInput', slot);
}
const $c2b262889cde4af1$var$filledInputClasses = {
    ...(0, $3HkEr.default),
    ...(0, $4jzsB.default)('MuiFilledInput', [
        'root',
        'underline',
        'input',
        'adornedStart',
        'adornedEnd',
        'sizeSmall',
        'multiline',
        'hiddenLabel'
    ])
};
var $c2b262889cde4af1$export$2e2bcd8739ae039 = $c2b262889cde4af1$var$filledInputClasses;

});


parcelRegister("6WEW6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50e7e9efec2c0b8c$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");



var $cFCqu = parcelRequire("cFCqu");

var $eYwIX = parcelRequire("eYwIX");

var $2jx1n = parcelRequire("2jx1n");

var $jHiZl = parcelRequire("jHiZl");

var $HgAeG = parcelRequire("HgAeG");

var $kDBhE = parcelRequire("kDBhE");

var $7uFHh = parcelRequire("7uFHh");

var $wvp8q = parcelRequire("wvp8q");

var $iVAEr = parcelRequire("iVAEr");

var $lCN2y = parcelRequire("lCN2y");

var $g1o71 = parcelRequire("g1o71");

var $99c9I = parcelRequire("99c9I");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $50e7e9efec2c0b8c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $lCN2y.getOutlinedInputUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $50e7e9efec2c0b8c$var$OutlinedInputRoot = (0, $kDBhE.default)((0, $g1o71.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $HgAeG.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $g1o71.rootOverridesResolver)
})((0, $7uFHh.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $lCN2y.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $lCN2y.default).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $lCN2y.default).focused} .${(0, $lCN2y.default).notchedOutline}`]: {
            borderWidth: 2
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $wvp8q.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $lCN2y.default).focused} .${(0, $lCN2y.default).notchedOutline}`]: {
                            borderColor: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                // to overide the above style
                style: {
                    [`&.${(0, $lCN2y.default).error} .${(0, $lCN2y.default).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.error.main
                    },
                    [`&.${(0, $lCN2y.default).disabled} .${(0, $lCN2y.default).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.action.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '16.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    padding: '8.5px 14px'
                }
            }
        ]
    };
}));
const $50e7e9efec2c0b8c$var$NotchedOutlineRoot = (0, $kDBhE.default)((0, $eYwIX.default), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})((0, $7uFHh.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
}));
const $50e7e9efec2c0b8c$var$OutlinedInputInput = (0, $kDBhE.default)((0, $g1o71.InputBaseInput), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $g1o71.inputOverridesResolver)
})((0, $7uFHh.default)(({ theme: theme })=>({
        padding: '16.5px 14px',
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '8.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            }
        ]
    })));
const $50e7e9efec2c0b8c$var$OutlinedInput = /*#__PURE__*/ $7fPBF.forwardRef(function OutlinedInput(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, slotProps: slotProps = {}, type: type = 'text', ...other } = props;
    const classes = $50e7e9efec2c0b8c$var$useUtilityClasses(props);
    const muiFormControl = (0, $2jx1n.default)();
    const fcs = (0, $jHiZl.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    };
    const RootSlot = slots.root ?? components.Root ?? $50e7e9efec2c0b8c$var$OutlinedInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $50e7e9efec2c0b8c$var$OutlinedInputInput;
    const [NotchedSlot, notchedProps] = (0, $99c9I.default)('notchedOutline', {
        elementType: $50e7e9efec2c0b8c$var$NotchedOutlineRoot,
        className: classes.notchedOutline,
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps
        },
        additionalProps: {
            label: label != null && label !== '' && fcs.required ? /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
                children: [
                    label,
                    "\u2009",
                    '*'
                ]
            }) : label
        }
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $g1o71.default), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: slotProps,
        renderSuffix: (state)=>/*#__PURE__*/ (0, $bbzbN.jsx)(NotchedSlot, {
                ...notchedProps,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: {
            ...classes,
            notchedOutline: null
        }
    });
});
$50e7e9efec2c0b8c$var$OutlinedInput.muiName = 'Input';
var $50e7e9efec2c0b8c$export$2e2bcd8739ae039 = $50e7e9efec2c0b8c$var$OutlinedInput;

});
parcelRegister("eYwIX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae700d9709d2b786$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");


var $HgAeG = parcelRequire("HgAeG");

var $kDBhE = parcelRequire("kDBhE");

var $7uFHh = parcelRequire("7uFHh");

var $bbzbN = parcelRequire("bbzbN");
'use client';
var $ae700d9709d2b786$var$_span;
const $ae700d9709d2b786$var$NotchedOutlineRoot = (0, $kDBhE.default)('fieldset', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $HgAeG.default)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $ae700d9709d2b786$var$NotchedOutlineLegend = (0, $kDBhE.default)('legend', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $HgAeG.default)
})((0, $7uFHh.default)(({ theme: theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.withLabel,
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel,
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel && ownerState.notched,
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    })));
function $ae700d9709d2b786$export$2e2bcd8739ae039(props) {
    const { children: children, classes: classes, className: className, label: label, notched: notched, ...other } = props;
    const withLabel = label != null && label !== '';
    const ownerState = {
        ...props,
        notched: notched,
        withLabel: withLabel
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)($ae700d9709d2b786$var$NotchedOutlineRoot, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($ae700d9709d2b786$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                children: label
            }) : $ae700d9709d2b786$var$_span || ($ae700d9709d2b786$var$_span = /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                className: "notranslate",
                "aria-hidden": true,
                children: "\u200B"
            }))
        })
    });
}

});

parcelRegister("lCN2y", function(module, exports) {

$parcel$export(module.exports, "getOutlinedInputUtilityClass", function () { return $fbe32ff46b8bf823$export$89922944c7227687; });
$parcel$export(module.exports, "default", function () { return $fbe32ff46b8bf823$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");

var $3HkEr = parcelRequire("3HkEr");
function $fbe32ff46b8bf823$export$89922944c7227687(slot) {
    return (0, $k6RDS.default)('MuiOutlinedInput', slot);
}
const $fbe32ff46b8bf823$var$outlinedInputClasses = {
    ...(0, $3HkEr.default),
    ...(0, $4jzsB.default)('MuiOutlinedInput', [
        'root',
        'notchedOutline',
        'input'
    ])
};
var $fbe32ff46b8bf823$export$2e2bcd8739ae039 = $fbe32ff46b8bf823$var$outlinedInputClasses;

});


parcelRegister("lHSFU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fcd80672e9993aad$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $cFCqu = parcelRequire("cFCqu");

var $hngXp = parcelRequire("hngXp");

var $jHiZl = parcelRequire("jHiZl");

var $2jx1n = parcelRequire("2jx1n");

var $cnEvg = parcelRequire("cnEvg");
var $cN7rN = parcelRequire("cN7rN");

var $b6UUh = parcelRequire("b6UUh");

var $HgAeG = parcelRequire("HgAeG");

var $kDBhE = parcelRequire("kDBhE");

var $7uFHh = parcelRequire("7uFHh");

var $iVAEr = parcelRequire("iVAEr");

var $3Ha1S = parcelRequire("3Ha1S");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $fcd80672e9993aad$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, $b6UUh.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $3Ha1S.getInputLabelUtilityClasses), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the FormLabel
        ...composedClasses
    };
};
const $fcd80672e9993aad$var$InputLabelRoot = (0, $kDBhE.default)((0, $cnEvg.default), {
    shouldForwardProp: (prop)=>(0, $HgAeG.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $cN7rN.default).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})((0, $7uFHh.default)(({ theme: theme })=>({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    // slight alteration to spec spacing to match visual spec result
                    transform: 'translate(0, 20px) scale(1)'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    // Compensation for the `Input.inputSizeSmall` style.
                    transform: 'translate(0, 17px) scale(1)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.shrink,
                style: {
                    transform: 'translate(0, -1.5px) scale(0.75)',
                    transformOrigin: 'top left',
                    maxWidth: '133%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableAnimation,
                style: {
                    transition: theme.transitions.create([
                        'color',
                        'transform',
                        'max-width'
                    ], {
                        duration: theme.transitions.duration.shorter,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    // Chrome's autofill feature gives the input field a yellow background.
                    // Since the input field is behind the label in the HTML tree,
                    // the input field is drawn last and hides the label with an opaque background color.
                    // zIndex: 1 will raise the label above opaque background-colors of input.
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(12px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'filled',
                    size: 'small'
                },
                style: {
                    transform: 'translate(12px, 13px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'filled' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    transform: 'translate(12px, 7px) scale(0.75)',
                    maxWidth: 'calc(133% - 24px)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState, size: size })=>variant === 'filled' && ownerState.shrink && size === 'small',
                style: {
                    transform: 'translate(12px, 4px) scale(0.75)'
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    // see comment above on filled.zIndex
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(14px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'outlined',
                    size: 'small'
                },
                style: {
                    transform: 'translate(14px, 9px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'outlined' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    // Theoretically, we should have (8+5)*2/0.75 = 34px
                    // but it feels a better when it bleeds a bit on the left, so 32px.
                    maxWidth: 'calc(133% - 32px)',
                    transform: 'translate(14px, -9px) scale(0.75)'
                }
            }
        ]
    })));
const $fcd80672e9993aad$var$InputLabel = /*#__PURE__*/ $7fPBF.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, margin: margin, shrink: shrinkProp, variant: variant, className: className, ...other } = props;
    const muiFormControl = (0, $2jx1n.default)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $jHiZl.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = {
        ...props,
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    };
    const classes = $fcd80672e9993aad$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($fcd80672e9993aad$var$InputLabelRoot, {
        "data-shrink": shrink,
        ref: ref,
        className: (0, $hngXp.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        classes: classes
    });
});
var $fcd80672e9993aad$export$2e2bcd8739ae039 = $fcd80672e9993aad$var$InputLabel;

});
parcelRegister("cnEvg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90370d1df15229dd$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $jHiZl = parcelRequire("jHiZl");

var $2jx1n = parcelRequire("2jx1n");

var $b6UUh = parcelRequire("b6UUh");

var $kDBhE = parcelRequire("kDBhE");

var $7uFHh = parcelRequire("7uFHh");

var $wvp8q = parcelRequire("wvp8q");

var $iVAEr = parcelRequire("iVAEr");

var $cN7rN = parcelRequire("cN7rN");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $90370d1df15229dd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $b6UUh.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $cN7rN.getFormLabelUtilityClasses), classes);
};
const $90370d1df15229dd$export$aa5bc7f8a4705b27 = (0, $kDBhE.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color === 'secondary' && styles.colorSecondary,
            ownerState.filled && styles.filled
        ];
    }
})((0, $7uFHh.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.body1,
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        variants: [
            ...Object.entries(theme.palette).filter((0, $wvp8q.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $cN7rN.default).focused}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                style: {
                    [`&.${(0, $cN7rN.default).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    },
                    [`&.${(0, $cN7rN.default).error}`]: {
                        color: (theme.vars || theme).palette.error.main
                    }
                }
            }
        ]
    })));
const $90370d1df15229dd$var$AsteriskComponent = (0, $kDBhE.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})((0, $7uFHh.default)(({ theme: theme })=>({
        [`&.${(0, $cN7rN.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $90370d1df15229dd$var$FormLabel = /*#__PURE__*/ $7fPBF.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, color: color, component: component = 'label', disabled: disabled, error: error, filled: filled, focused: focused, required: required, ...other } = props;
    const muiFormControl = (0, $2jx1n.default)();
    const fcs = (0, $jHiZl.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    const classes = $90370d1df15229dd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($90370d1df15229dd$export$aa5bc7f8a4705b27, {
        as: component,
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref,
        ...other,
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $bbzbN.jsxs)($90370d1df15229dd$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    });
});
var $90370d1df15229dd$export$2e2bcd8739ae039 = $90370d1df15229dd$var$FormLabel;

});
parcelRegister("cN7rN", function(module, exports) {

$parcel$export(module.exports, "getFormLabelUtilityClasses", function () { return $94ffd68a66aaae7e$export$f7d501e40371cd17; });
$parcel$export(module.exports, "default", function () { return $94ffd68a66aaae7e$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $94ffd68a66aaae7e$export$f7d501e40371cd17(slot) {
    return (0, $k6RDS.default)('MuiFormLabel', slot);
}
const $94ffd68a66aaae7e$var$formLabelClasses = (0, $4jzsB.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $94ffd68a66aaae7e$export$2e2bcd8739ae039 = $94ffd68a66aaae7e$var$formLabelClasses;

});


parcelRegister("3Ha1S", function(module, exports) {

$parcel$export(module.exports, "getInputLabelUtilityClasses", function () { return $2b0d2ae144238f59$export$c1c4b4545ad2ea5f; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $2b0d2ae144238f59$export$c1c4b4545ad2ea5f(slot) {
    return (0, $k6RDS.default)('MuiInputLabel', slot);
}
const $2b0d2ae144238f59$var$inputLabelClasses = (0, $4jzsB.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $2b0d2ae144238f59$export$2e2bcd8739ae039 = $2b0d2ae144238f59$var$inputLabelClasses;

});


parcelRegister("3jMGu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26a8e925f0aa9998$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $87FKv = parcelRequire("87FKv");

var $b6UUh = parcelRequire("b6UUh");

var $91ID4 = parcelRequire("91ID4");

var $kPqR2 = parcelRequire("kPqR2");

var $9AiVZ = parcelRequire("9AiVZ");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $26a8e925f0aa9998$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $b6UUh.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $9AiVZ.getFormControlUtilityClasses), classes);
};
const $26a8e925f0aa9998$var$FormControlRoot = (0, $kDBhE.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`margin${(0, $b6UUh.default)(ownerState.margin)}`],
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})({
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top',
    // Fix alignment issue on Safari.
    variants: [
        {
            props: {
                margin: 'normal'
            },
            style: {
                marginTop: 16,
                marginBottom: 8
            }
        },
        {
            props: {
                margin: 'dense'
            },
            style: {
                marginTop: 8,
                marginBottom: 4
            }
        },
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        }
    ]
});
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $26a8e925f0aa9998$var$FormControl = /*#__PURE__*/ $7fPBF.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    };
    const classes = $26a8e925f0aa9998$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $7fPBF.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $7fPBF.Children.forEach(children, (child)=>{
            if (!(0, $91ID4.default)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $91ID4.default)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $87FKv.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $7fPBF.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $7fPBF.Children.forEach(children, (child)=>{
            if (!(0, $91ID4.default)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $87FKv.isFilled)(child.props, true) || (0, $87FKv.isFilled)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $7fPBF.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const registeredInput = $7fPBF.useRef(false);
    const onFilled = $7fPBF.useCallback(()=>{
        setFilled(true);
    }, []);
    const onEmpty = $7fPBF.useCallback(()=>{
        setFilled(false);
    }, []);
    const childContext = $7fPBF.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            onEmpty: onEmpty,
            onFilled: onFilled,
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        onEmpty,
        onFilled,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kPqR2.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($26a8e925f0aa9998$var$FormControlRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $hngXp.default)(classes.root, className),
            ref: ref,
            ...other,
            children: children
        })
    });
});
var $26a8e925f0aa9998$export$2e2bcd8739ae039 = $26a8e925f0aa9998$var$FormControl;

});
parcelRegister("91ID4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6926d37cb7ff7774$export$2e2bcd8739ae039; });

var $j4EgL = parcelRequire("j4EgL");
var $6926d37cb7ff7774$export$2e2bcd8739ae039 = (0, $j4EgL.default);

});

parcelRegister("9AiVZ", function(module, exports) {

$parcel$export(module.exports, "getFormControlUtilityClasses", function () { return $6fa629ce89e8ad57$export$149c8b8bab2289d1; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $6fa629ce89e8ad57$export$149c8b8bab2289d1(slot) {
    return (0, $k6RDS.default)('MuiFormControl', slot);
}
const $6fa629ce89e8ad57$var$formControlClasses = (0, $4jzsB.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $6fa629ce89e8ad57$export$2e2bcd8739ae039 = $6fa629ce89e8ad57$var$formControlClasses;

});


parcelRegister("gFr0F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0321a2cb63129955$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $jHiZl = parcelRequire("jHiZl");

var $2jx1n = parcelRequire("2jx1n");

var $kDBhE = parcelRequire("kDBhE");

var $7uFHh = parcelRequire("7uFHh");

var $iVAEr = parcelRequire("iVAEr");

var $b6UUh = parcelRequire("b6UUh");

var $1qExZ = parcelRequire("1qExZ");

var $bbzbN = parcelRequire("bbzbN");
'use client';
var $0321a2cb63129955$var$_span;
const $0321a2cb63129955$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $b6UUh.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $1qExZ.getFormHelperTextUtilityClasses), classes);
};
const $0321a2cb63129955$var$FormHelperTextRoot = (0, $kDBhE.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $b6UUh.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})((0, $7uFHh.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.caption,
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $1qExZ.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $1qExZ.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginTop: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.contained,
                style: {
                    marginLeft: 14,
                    marginRight: 14
                }
            }
        ]
    })));
const $0321a2cb63129955$var$FormHelperText = /*#__PURE__*/ $7fPBF.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p', disabled: disabled, error: error, filled: filled, focused: focused, margin: margin, required: required, variant: variant, ...other } = props;
    const muiFormControl = (0, $2jx1n.default)();
    const fcs = (0, $jHiZl.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $0321a2cb63129955$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($0321a2cb63129955$var$FormHelperTextRoot, {
        as: component,
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children === ' ' ? $0321a2cb63129955$var$_span || ($0321a2cb63129955$var$_span = /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            className: "notranslate",
            "aria-hidden": true,
            children: "\u200B"
        })) : children
    });
});
var $0321a2cb63129955$export$2e2bcd8739ae039 = $0321a2cb63129955$var$FormHelperText;

});
parcelRegister("1qExZ", function(module, exports) {

$parcel$export(module.exports, "getFormHelperTextUtilityClasses", function () { return $10a7abfeb1405549$export$a394fa61b1d583a9; });
$parcel$export(module.exports, "default", function () { return $10a7abfeb1405549$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $10a7abfeb1405549$export$a394fa61b1d583a9(slot) {
    return (0, $k6RDS.default)('MuiFormHelperText', slot);
}
const $10a7abfeb1405549$var$formHelperTextClasses = (0, $4jzsB.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $10a7abfeb1405549$export$2e2bcd8739ae039 = $10a7abfeb1405549$var$formHelperTextClasses;

});


parcelRegister("jh0sD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e07ff65b28ac412d$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $3wRTY = parcelRequire("3wRTY");

var $cFCqu = parcelRequire("cFCqu");

var $bNCjr = parcelRequire("bNCjr");

var $7HA9s = parcelRequire("7HA9s");

var $jHiZl = parcelRequire("jHiZl");

var $2jx1n = parcelRequire("2jx1n");

var $aI4oF = parcelRequire("aI4oF");

var $jiLAb = parcelRequire("jiLAb");

var $avrPa = parcelRequire("avrPa");

var $lxNRp = parcelRequire("lxNRp");

var $6WEW6 = parcelRequire("6WEW6");

var $iVAEr = parcelRequire("iVAEr");

var $6NwTb = parcelRequire("6NwTb");

var $kDBhE = parcelRequire("kDBhE");

var $HgAeG = parcelRequire("HgAeG");

var $87RNG = parcelRequire("87RNG");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $e07ff65b28ac412d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $87RNG.getSelectUtilityClasses), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $e07ff65b28ac412d$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $HgAeG.default)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $e07ff65b28ac412d$var$StyledInput = (0, $kDBhE.default)((0, $jiLAb.default), $e07ff65b28ac412d$var$styledRootConfig)('');
const $e07ff65b28ac412d$var$StyledOutlinedInput = (0, $kDBhE.default)((0, $6WEW6.default), $e07ff65b28ac412d$var$styledRootConfig)('');
const $e07ff65b28ac412d$var$StyledFilledInput = (0, $kDBhE.default)((0, $lxNRp.default), $e07ff65b28ac412d$var$styledRootConfig)('');
const $e07ff65b28ac412d$var$Select = /*#__PURE__*/ $7fPBF.forwardRef(function Select(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $aI4oF.default), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined', ...other } = props;
    const inputComponent = native ? (0, $avrPa.default) : (0, $7HA9s.default);
    const muiFormControl = (0, $2jx1n.default)();
    const fcs = (0, $jHiZl.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = {
        ...props,
        variant: variant,
        classes: classesProp
    };
    const classes = $e07ff65b28ac412d$var$useUtilityClasses(ownerState);
    const { root: root, ...restOfClasses } = classes;
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $bbzbN.jsx)($e07ff65b28ac412d$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $bbzbN.jsx)($e07ff65b28ac412d$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $bbzbN.jsx)($e07ff65b28ac412d$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $6NwTb.default)(ref, (0, $bNCjr.default)(InputComponent));
    return /*#__PURE__*/ (0, $bbzbN.jsx)($7fPBF.Fragment, {
        children: /*#__PURE__*/ $7fPBF.cloneElement(InputComponent, {
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: {
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple,
                ...native ? {
                    id: id
                } : {
                    autoWidth: autoWidth,
                    defaultOpen: defaultOpen,
                    displayEmpty: displayEmpty,
                    labelId: labelId,
                    MenuProps: MenuProps,
                    onClose: onClose,
                    onOpen: onOpen,
                    open: open,
                    renderValue: renderValue,
                    SelectDisplayProps: {
                        id: id,
                        ...SelectDisplayProps
                    }
                },
                ...inputProps,
                classes: inputProps ? (0, $3wRTY.default)(restOfClasses, inputProps.classes) : restOfClasses,
                ...input ? input.props.inputProps : {}
            },
            ...(multiple && native || displayEmpty) && variant === 'outlined' ? {
                notched: true
            } : {},
            ref: inputComponentRef,
            className: (0, $hngXp.default)(InputComponent.props.className, className, classes.root),
            // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
            ...!input && {
                variant: variant
            },
            ...other
        })
    });
});
$e07ff65b28ac412d$var$Select.muiName = 'Select';
var $e07ff65b28ac412d$export$2e2bcd8739ae039 = $e07ff65b28ac412d$var$Select;

});
parcelRegister("7HA9s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59b8977b1194262f$export$2e2bcd8739ae039; });

var $diYUK = parcelRequire("diYUK");

var $7fPBF = parcelRequire("7fPBF");



var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $65Itt = parcelRequire("65Itt");


var $cNbkS = parcelRequire("cNbkS");

var $b6UUh = parcelRequire("b6UUh");

var $gPL9h = parcelRequire("gPL9h");

var $avrPa = parcelRequire("avrPa");

var $87FKv = parcelRequire("87FKv");

var $kDBhE = parcelRequire("kDBhE");

var $yfUan = parcelRequire("yfUan");

var $6NwTb = parcelRequire("6NwTb");

var $568MF = parcelRequire("568MF");

var $87RNG = parcelRequire("87RNG");

var $bbzbN = parcelRequire("bbzbN");
'use client';
var $59b8977b1194262f$var$_span;
const $59b8977b1194262f$var$SelectSelect = (0, $kDBhE.default)((0, $avrPa.StyledSelectSelect), {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $87RNG.default).select}`]: styles.select
            },
            {
                [`&.${(0, $87RNG.default).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $87RNG.default).error}`]: styles.error
            },
            {
                [`&.${(0, $87RNG.default).multiple}`]: styles.multiple
            }
        ];
    }
})({
    // Win specificity over the input base
    [`&.${(0, $87RNG.default).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $59b8977b1194262f$var$SelectIcon = (0, $kDBhE.default)((0, $avrPa.StyledSelectIcon), {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $b6UUh.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
const $59b8977b1194262f$var$SelectNativeInput = (0, $kDBhE.default)('input', {
    shouldForwardProp: (prop)=>(0, $yfUan.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $59b8977b1194262f$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $59b8977b1194262f$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $59b8977b1194262f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $b6UUh.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $87RNG.getSelectUtilityClasses), classes);
};
/**
 * @ignore - internal component.
 */ const $59b8977b1194262f$var$SelectInput = /*#__PURE__*/ $7fPBF.forwardRef(function SelectInput(props, ref) {
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, required: required, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, type: // catching `type` from Input which makes no sense for SelectInput
    type, value: valueProp, variant: variant = 'standard', ...other } = props;
    const [value, setValueState] = (0, $568MF.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $568MF.default)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $7fPBF.useRef(null);
    const displayRef = $7fPBF.useRef(null);
    const [displayNode, setDisplayNode] = $7fPBF.useState(null);
    const { current: isOpenControlled } = $7fPBF.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $7fPBF.useState();
    const handleRef = (0, $6NwTb.default)(ref, inputRefProp);
    const handleDisplayRef = $7fPBF.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode?.parentNode;
    $7fPBF.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $7fPBF.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $7fPBF.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $7fPBF.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $cNbkS.default)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $7fPBF.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.includes(event.key)) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $87FKv.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $diYUK.default)(2));
            selected = value.some((v)=>$59b8977b1194262f$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $59b8977b1194262f$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $7fPBF.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = {
        ...props,
        variant: variant,
        value: value,
        open: open,
        error: error
    };
    const classes = $59b8977b1194262f$var$useUtilityClasses(ownerState);
    const paperProps = {
        ...MenuProps.PaperProps,
        ...MenuProps.slotProps?.paper
    };
    const listboxId = (0, $65Itt.default)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($59b8977b1194262f$var$SelectSelect, {
                as: "div",
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": open ? listboxId : undefined,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                "aria-required": required ? 'true' : undefined,
                "aria-invalid": error ? 'true' : undefined,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus,
                ...SelectDisplayProps,
                ownerState: ownerState,
                className: (0, $hngXp.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $59b8977b1194262f$var$isEmpty(display) ? $59b8977b1194262f$var$_span || ($59b8977b1194262f$var$_span = /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                    className: "notranslate",
                    "aria-hidden": true,
                    children: "\u200B"
                })) : display
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)($59b8977b1194262f$var$SelectNativeInput, {
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                required: required,
                ...other,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)($59b8977b1194262f$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gPL9h.default), {
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                ...MenuProps,
                slotProps: {
                    ...MenuProps.slotProps,
                    list: {
                        'aria-labelledby': labelId,
                        role: 'listbox',
                        'aria-multiselectable': multiple ? 'true' : undefined,
                        disableListWrap: true,
                        id: listboxId,
                        ...MenuProps.MenuListProps
                    },
                    paper: {
                        ...paperProps,
                        style: {
                            minWidth: menuMinWidth,
                            ...paperProps != null ? paperProps.style : null
                        }
                    }
                },
                children: items
            })
        ]
    });
});
var $59b8977b1194262f$export$2e2bcd8739ae039 = $59b8977b1194262f$var$SelectInput;

});
parcelRegister("cNbkS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9502daaf177b272b$export$2e2bcd8739ae039; });

var $4CS7n = parcelRequire("4CS7n");
var $9502daaf177b272b$export$2e2bcd8739ae039 = (0, $4CS7n.default);

});

parcelRegister("gPL9h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c415fb7f3f0f9d08$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");



var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");


var $kyirV = parcelRequire("kyirV");

var $elaRz = parcelRequire("elaRz");

var $dseJp = parcelRequire("dseJp");

var $ahaA4 = parcelRequire("ahaA4");

var $HgAeG = parcelRequire("HgAeG");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $ewYvI = parcelRequire("ewYvI");

var $99c9I = parcelRequire("99c9I");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $c415fb7f3f0f9d08$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $c415fb7f3f0f9d08$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $c415fb7f3f0f9d08$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $ewYvI.getMenuUtilityClass), classes);
};
const $c415fb7f3f0f9d08$var$MenuRoot = (0, $kDBhE.default)((0, $ahaA4.default), {
    shouldForwardProp: (prop)=>(0, $HgAeG.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $c415fb7f3f0f9d08$export$4f7c51a5920c9f33 = (0, $kDBhE.default)((0, $ahaA4.PopoverPaper), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $c415fb7f3f0f9d08$var$MenuMenuList = (0, $kDBhE.default)((0, $dseJp.default), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $c415fb7f3f0f9d08$var$Menu = /*#__PURE__*/ $7fPBF.forwardRef(function Menu(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering, ...TransitionProps } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $kyirV.useRtl)();
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    };
    const classes = $c415fb7f3f0f9d08$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $7fPBF.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $7fPBF.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            list: MenuListProps,
            transition: TransitionProps,
            paper: PaperProps,
            ...slotProps
        }
    };
    const rootSlotProps = (0, $elaRz.default)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const [PaperSlot, paperSlotProps] = (0, $99c9I.default)('paper', {
        className: classes.paper,
        elementType: $c415fb7f3f0f9d08$export$4f7c51a5920c9f33,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        ownerState: ownerState
    });
    const [ListSlot, listSlotProps] = (0, $99c9I.default)('list', {
        className: (0, $hngXp.default)(classes.list, MenuListProps.className),
        elementType: $c415fb7f3f0f9d08$var$MenuMenuList,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleListKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            }),
        ownerState: ownerState
    });
    const resolvedTransitionProps = typeof externalForwardedProps.slotProps.transition === 'function' ? externalForwardedProps.slotProps.transition(ownerState) : externalForwardedProps.slotProps.transition;
    return /*#__PURE__*/ (0, $bbzbN.jsx)($c415fb7f3f0f9d08$var$MenuRoot, {
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $c415fb7f3f0f9d08$var$RTL_ORIGIN : $c415fb7f3f0f9d08$var$LTR_ORIGIN,
        slots: {
            root: slots.root,
            paper: PaperSlot,
            backdrop: slots.backdrop,
            ...slots.transition && {
                // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
                transition: slots.transition
            }
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps,
            backdrop: typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop,
            transition: {
                ...resolvedTransitionProps,
                onEntering: (...args)=>{
                    handleEntering(...args);
                    resolvedTransitionProps?.onEntering?.(...args);
                }
            }
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        ownerState: ownerState,
        ...other,
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)(ListSlot, {
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant,
            ...listSlotProps,
            children: children
        })
    });
});
var $c415fb7f3f0f9d08$export$2e2bcd8739ae039 = $c415fb7f3f0f9d08$var$Menu;

});
parcelRegister("elaRz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a70b740322660959$export$2e2bcd8739ae039; });

var $jTdAm = parcelRequire("jTdAm");

var $5VXZW = parcelRequire("5VXZW");

var $ex1Wy = parcelRequire("ex1Wy");

var $eWvFH = parcelRequire("eWvFH");
'use client';
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $a70b740322660959$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $eWvFH.default)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $ex1Wy.default)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $jTdAm.default)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $5VXZW.default)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $a70b740322660959$export$2e2bcd8739ae039 = $a70b740322660959$var$useSlotProps;

});

parcelRegister("dseJp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cb95136bc90d127$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");



var $cNbkS = parcelRequire("cNbkS");

var $lAoIf = parcelRequire("lAoIf");

var $1RLwL = parcelRequire("1RLwL");

var $6NwTb = parcelRequire("6NwTb");

var $hQtyv = parcelRequire("hQtyv");

var $9kBlI = parcelRequire("9kBlI");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $9cb95136bc90d127$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $9cb95136bc90d127$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $9cb95136bc90d127$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.startsWith(textCriteria.keys.join(''));
}
function $9cb95136bc90d127$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$9cb95136bc90d127$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $9cb95136bc90d127$var$MenuList = /*#__PURE__*/ $7fPBF.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu', ...other } = props;
    const listRef = $7fPBF.useRef(null);
    const textCriteriaRef = $7fPBF.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $hQtyv.default)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $7fPBF.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $1RLwL.default)((0, $9kBlI.default)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey;
        if (isModifierKeyPressed) {
            if (onKeyDown) onKeyDown(event);
            return;
        }
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $cNbkS.default)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $9cb95136bc90d127$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $9cb95136bc90d127$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $9cb95136bc90d127$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $6NwTb.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $7fPBF.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $7fPBF.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $7fPBF.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lAoIf.default), {
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1,
        ...other,
        children: items
    });
});
var $9cb95136bc90d127$export$2e2bcd8739ae039 = $9cb95136bc90d127$var$MenuList;

});
parcelRegister("lAoIf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb70212a09473954$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $cMvyt = parcelRequire("cMvyt");

var $ik5ek = parcelRequire("ik5ek");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $fb70212a09473954$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $ik5ek.getListUtilityClass), classes);
};
const $fb70212a09473954$var$ListRoot = (0, $kDBhE.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
            style: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.subheader,
            style: {
                paddingTop: 0
            }
        }
    ]
});
const $fb70212a09473954$var$List = /*#__PURE__*/ $7fPBF.forwardRef(function List(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader, ...other } = props;
    const context = $7fPBF.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = {
        ...props,
        component: component,
        dense: dense,
        disablePadding: disablePadding
    };
    const classes = $fb70212a09473954$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cMvyt.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)($fb70212a09473954$var$ListRoot, {
            as: component,
            className: (0, $hngXp.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                subheader,
                children
            ]
        })
    });
});
var $fb70212a09473954$export$2e2bcd8739ae039 = $fb70212a09473954$var$List;

});
parcelRegister("cMvyt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94e271e17fd22222$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * @ignore - internal component.
 */ const $94e271e17fd22222$var$ListContext = /*#__PURE__*/ $7fPBF.createContext({});
var $94e271e17fd22222$export$2e2bcd8739ae039 = $94e271e17fd22222$var$ListContext;

});

parcelRegister("ik5ek", function(module, exports) {

$parcel$export(module.exports, "getListUtilityClass", function () { return $d56e26d1d10ff784$export$c6bd6795ed6e3203; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $d56e26d1d10ff784$export$c6bd6795ed6e3203(slot) {
    return (0, $k6RDS.default)('MuiList', slot);
}
const $d56e26d1d10ff784$var$listClasses = (0, $4jzsB.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $d56e26d1d10ff784$export$2e2bcd8739ae039 = $d56e26d1d10ff784$var$listClasses;

});


parcelRegister("1RLwL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15bf9ba27fbfc052$export$2e2bcd8739ae039; });

var $8c45K = parcelRequire("8c45K");
var $15bf9ba27fbfc052$export$2e2bcd8739ae039 = (0, $8c45K.default);

});

parcelRegister("9kBlI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cb2f4180c9526e0$export$2e2bcd8739ae039; });

var $gE56a = parcelRequire("gE56a");
var $6cb2f4180c9526e0$export$2e2bcd8739ae039 = (0, $gE56a.default);

});


parcelRegister("ahaA4", function(module, exports) {

$parcel$export(module.exports, "PopoverPaper", function () { return $77b3b30833fb8c12$export$821346c38a2d9390; });
$parcel$export(module.exports, "default", function () { return $77b3b30833fb8c12$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");






var $2giBU = parcelRequire("2giBU");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $52luK = parcelRequire("52luK");

var $cNbkS = parcelRequire("cNbkS");

var $9kBlI = parcelRequire("9kBlI");

var $aSK9T = parcelRequire("aSK9T");

var $ehw51 = parcelRequire("ehw51");

var $a2ay0 = parcelRequire("a2ay0");

var $edKHw = parcelRequire("edKHw");

var $99c9I = parcelRequire("99c9I");

var $6qz14 = parcelRequire("6qz14");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $77b3b30833fb8c12$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $77b3b30833fb8c12$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $77b3b30833fb8c12$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $77b3b30833fb8c12$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $77b3b30833fb8c12$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $edKHw.getPopoverUtilityClass), classes);
};
const $77b3b30833fb8c12$export$bcce13685275fc99 = (0, $kDBhE.default)((0, $ehw51.default), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $77b3b30833fb8c12$export$821346c38a2d9390 = (0, $kDBhE.default)((0, $a2ay0.default), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $77b3b30833fb8c12$var$Popover = /*#__PURE__*/ $7fPBF.forwardRef(function Popover(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: // TODO: remove in v7
    slots = {}, slotProps: slotProps = {}, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent, // TODO: remove in v7
    transitionDuration: transitionDurationProp = 'auto', TransitionProps: TransitionProps = {}, disableScrollLock: // TODO: remove in v7
    disableScrollLock = false, ...other } = props;
    const paperRef = $7fPBF.useRef();
    const ownerState = {
        ...props,
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    };
    const classes = $77b3b30833fb8c12$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $7fPBF.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $77b3b30833fb8c12$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $cNbkS.default)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $77b3b30833fb8c12$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $77b3b30833fb8c12$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $7fPBF.useCallback((elemRect)=>{
        return {
            vertical: $77b3b30833fb8c12$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $77b3b30833fb8c12$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $7fPBF.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $77b3b30833fb8c12$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $9kBlI.default)($77b3b30833fb8c12$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $77b3b30833fb8c12$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $7fPBF.useState(open);
    const setPositioningStyles = $7fPBF.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.setProperty('top', positioning.top);
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $7fPBF.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = ()=>{
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $7fPBF.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $7fPBF.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $7fPBF.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $52luK.default)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $9kBlI.default)($77b3b30833fb8c12$var$resolveAnchorEl(anchorEl));
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            transition: TransitionProps,
            paper: PaperPropsProp,
            ...slotProps
        }
    };
    const [TransitionSlot, transitionSlotProps] = (0, $99c9I.default)('transition', {
        elementType: (0, $aSK9T.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onEntering: (element, isAppearing)=>{
                    handlers.onEntering?.(element, isAppearing);
                    handleEntering();
                },
                onExited: (element)=>{
                    handlers.onExited?.(element);
                    handleExited();
                }
            }),
        additionalProps: {
            appear: true,
            in: open
        }
    });
    if (transitionDurationProp === 'auto' && !TransitionSlot.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $cNbkS.default)($77b3b30833fb8c12$var$resolveAnchorEl(anchorEl)).body : undefined);
    const [RootSlot, { slots: rootSlotsProp, slotProps: rootSlotPropsProp, ...rootProps }] = (0, $99c9I.default)('root', {
        ref: ref,
        elementType: $77b3b30833fb8c12$export$bcce13685275fc99,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        shouldForwardComponentProp: true,
        additionalProps: {
            slots: {
                backdrop: slots.backdrop
            },
            slotProps: {
                backdrop: (0, $6qz14.default)(typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop, {
                    invisible: true
                })
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className)
    });
    const [PaperSlot, paperProps] = (0, $99c9I.default)('paper', {
        ref: paperRef,
        className: classes.paper,
        elementType: $77b3b30833fb8c12$export$821346c38a2d9390,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: {
            elevation: elevation,
            style: isPositioned ? undefined : {
                opacity: 0
            }
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)(RootSlot, {
        ...rootProps,
        ...!(0, $2giBU.default)(RootSlot) && {
            slots: rootSlotsProp,
            slotProps: rootSlotPropsProp,
            disableScrollLock: disableScrollLock
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            timeout: transitionDuration,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)(PaperSlot, {
                ...paperProps,
                children: children
            })
        })
    });
});
var $77b3b30833fb8c12$export$2e2bcd8739ae039 = $77b3b30833fb8c12$var$Popover;

});
parcelRegister("52luK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3aadd01758bd49c1$export$2e2bcd8739ae039; });

var $gHrsh = parcelRequire("gHrsh");
var $3aadd01758bd49c1$export$2e2bcd8739ae039 = (0, $gHrsh.default);

});

parcelRegister("aSK9T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ec2c0aa92d4d29c$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $de55R = parcelRequire("de55R");


var $bNCjr = parcelRequire("bNCjr");

var $8qMCX = parcelRequire("8qMCX");

var $g9bTP = parcelRequire("g9bTP");

var $2j7bs = parcelRequire("2j7bs");

var $6NwTb = parcelRequire("6NwTb");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $7ec2c0aa92d4d29c$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $7ec2c0aa92d4d29c$var$styles = {
    entering: {
        opacity: 1,
        transform: $7ec2c0aa92d4d29c$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $7ec2c0aa92d4d29c$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $7ec2c0aa92d4d29c$var$Grow = /*#__PURE__*/ $7fPBF.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $8qMCX.default), ...other } = props;
    const timer = (0, $de55R.default)();
    const autoTimeout = $7fPBF.useRef();
    const theme = (0, $g9bTP.default)();
    const nodeRef = $7fPBF.useRef(null);
    const handleRef = (0, $6NwTb.default)(nodeRef, (0, $bNCjr.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $2j7bs.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $2j7bs.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $7ec2c0aa92d4d29c$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $2j7bs.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $7ec2c0aa92d4d29c$var$isWebKit154 ? duration : duration * 0.666,
                delay: $7ec2c0aa92d4d29c$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $7ec2c0aa92d4d29c$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $7fPBF.cloneElement(children, {
                style: {
                    opacity: 0,
                    transform: $7ec2c0aa92d4d29c$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$7ec2c0aa92d4d29c$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
if ($7ec2c0aa92d4d29c$var$Grow) $7ec2c0aa92d4d29c$var$Grow.muiSupportAuto = true;
var $7ec2c0aa92d4d29c$export$2e2bcd8739ae039 = $7ec2c0aa92d4d29c$var$Grow;

});

parcelRegister("edKHw", function(module, exports) {

$parcel$export(module.exports, "getPopoverUtilityClass", function () { return $a5a68170633995c3$export$88f455dd56c95edb; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $a5a68170633995c3$export$88f455dd56c95edb(slot) {
    return (0, $k6RDS.default)('MuiPopover', slot);
}
const $a5a68170633995c3$var$popoverClasses = (0, $4jzsB.default)('MuiPopover', [
    'root',
    'paper'
]);
var $a5a68170633995c3$export$2e2bcd8739ae039 = $a5a68170633995c3$var$popoverClasses;

});

parcelRegister("6qz14", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ae0554ab82ec1b4$export$2e2bcd8739ae039; });

var $hngXp = parcelRequire("hngXp");
function $4ae0554ab82ec1b4$export$2e2bcd8739ae039(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) return defaultSlotProps;
    if (typeof externalSlotProps === 'function' || typeof defaultSlotProps === 'function') return (ownerState)=>{
        const defaultSlotPropsValue = typeof defaultSlotProps === 'function' ? defaultSlotProps(ownerState) : defaultSlotProps;
        const externalSlotPropsValue = typeof externalSlotProps === 'function' ? externalSlotProps({
            ...ownerState,
            ...defaultSlotPropsValue
        }) : externalSlotProps;
        const className = (0, $hngXp.default)(ownerState?.className, defaultSlotPropsValue?.className, externalSlotPropsValue?.className);
        return {
            ...defaultSlotPropsValue,
            ...externalSlotPropsValue,
            ...!!className && {
                className: className
            },
            ...defaultSlotPropsValue?.style && externalSlotPropsValue?.style && {
                style: {
                    ...defaultSlotPropsValue.style,
                    ...externalSlotPropsValue.style
                }
            },
            ...defaultSlotPropsValue?.sx && externalSlotPropsValue?.sx && {
                sx: [
                    ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                        defaultSlotPropsValue.sx
                    ],
                    ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                        externalSlotPropsValue.sx
                    ]
                ]
            }
        };
    };
    const typedDefaultSlotProps = defaultSlotProps;
    const className = (0, $hngXp.default)(typedDefaultSlotProps?.className, externalSlotProps?.className);
    return {
        ...defaultSlotProps,
        ...externalSlotProps,
        ...!!className && {
            className: className
        },
        ...typedDefaultSlotProps?.style && externalSlotProps?.style && {
            style: {
                ...typedDefaultSlotProps.style,
                ...externalSlotProps.style
            }
        },
        ...typedDefaultSlotProps?.sx && externalSlotProps?.sx && {
            sx: [
                ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                    typedDefaultSlotProps.sx
                ],
                ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                    externalSlotProps.sx
                ]
            ]
        }
    };
}

});


parcelRegister("ewYvI", function(module, exports) {

$parcel$export(module.exports, "getMenuUtilityClass", function () { return $a942fdfc6e6c5d42$export$2cf86a63a84fe23d; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $a942fdfc6e6c5d42$export$2cf86a63a84fe23d(slot) {
    return (0, $k6RDS.default)('MuiMenu', slot);
}
const $a942fdfc6e6c5d42$var$menuClasses = (0, $4jzsB.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $a942fdfc6e6c5d42$export$2e2bcd8739ae039 = $a942fdfc6e6c5d42$var$menuClasses;

});


parcelRegister("avrPa", function(module, exports) {

$parcel$export(module.exports, "StyledSelectSelect", function () { return $7a6261f84c63d345$export$50b3545a8ccd87af; });
$parcel$export(module.exports, "StyledSelectIcon", function () { return $7a6261f84c63d345$export$7dd4d92f143902e3; });
$parcel$export(module.exports, "default", function () { return $7a6261f84c63d345$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $b6UUh = parcelRequire("b6UUh");

var $ecolw = parcelRequire("ecolw");

var $kDBhE = parcelRequire("kDBhE");

var $HgAeG = parcelRequire("HgAeG");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $7a6261f84c63d345$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $b6UUh.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $ecolw.getNativeSelectUtilityClasses), classes);
};
const $7a6261f84c63d345$export$50b3545a8ccd87af = (0, $kDBhE.default)('select', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // Reset
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        // Reset
        borderRadius: 0,
        cursor: 'pointer',
        '&:focus': {
            // Reset Chrome style
            borderRadius: 0
        },
        [`&.${(0, $ecolw.default).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'filled' && ownerState.variant !== 'outlined',
                style: {
                    // Bump specificity to allow extending custom inputs
                    '&&&': {
                        paddingRight: 24,
                        minWidth: 16 // So it doesn't collapse.
                    }
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    '&&&': {
                        paddingRight: 32
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius,
                    '&:focus': {
                        borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
                    },
                    '&&&': {
                        paddingRight: 32
                    }
                }
            }
        ]
    }));
const $7a6261f84c63d345$var$NativeSelectSelect = (0, $kDBhE.default)($7a6261f84c63d345$export$50b3545a8ccd87af, {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $HgAeG.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $ecolw.default).multiple}`]: styles.multiple
            }
        ];
    }
})({});
const $7a6261f84c63d345$export$7dd4d92f143902e3 = (0, $kDBhE.default)('svg', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        // Center vertically, height is 1em
        top: 'calc(50% - .5em)',
        // Don't block pointer events on the select under the icon.
        pointerEvents: 'none',
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $ecolw.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.open,
                style: {
                    transform: 'rotate(180deg)'
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    right: 7
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    right: 7
                }
            }
        ]
    }));
const $7a6261f84c63d345$var$NativeSelectIcon = (0, $kDBhE.default)($7a6261f84c63d345$export$7dd4d92f143902e3, {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $b6UUh.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
/**
 * @ignore - internal component.
 */ const $7a6261f84c63d345$var$NativeSelectInput = /*#__PURE__*/ $7fPBF.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        variant: variant,
        error: error
    };
    const classes = $7a6261f84c63d345$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($7a6261f84c63d345$var$NativeSelectSelect, {
                ownerState: ownerState,
                className: (0, $hngXp.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref,
                ...other
            }),
            props.multiple ? null : /*#__PURE__*/ (0, $bbzbN.jsx)($7a6261f84c63d345$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $7a6261f84c63d345$export$2e2bcd8739ae039 = $7a6261f84c63d345$var$NativeSelectInput;

});
parcelRegister("ecolw", function(module, exports) {

$parcel$export(module.exports, "getNativeSelectUtilityClasses", function () { return $a5651256592f6f65$export$1ee13051fd9e2ab5; });
$parcel$export(module.exports, "default", function () { return $a5651256592f6f65$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $a5651256592f6f65$export$1ee13051fd9e2ab5(slot) {
    return (0, $k6RDS.default)('MuiNativeSelect', slot);
}
const $a5651256592f6f65$var$nativeSelectClasses = (0, $4jzsB.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $a5651256592f6f65$export$2e2bcd8739ae039 = $a5651256592f6f65$var$nativeSelectClasses;

});


parcelRegister("568MF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b64539a8a5729fa$export$2e2bcd8739ae039; });

var $gaYwN = parcelRequire("gaYwN");
'use client';
var $3b64539a8a5729fa$export$2e2bcd8739ae039 = (0, $gaYwN.default);

});
parcelRegister("gaYwN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc6c881cebb96954$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
'use client';
function $bc6c881cebb96954$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $7fPBF.useRef(controlled !== undefined);
    const [valueState, setValue] = $7fPBF.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $7fPBF.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRegister("87RNG", function(module, exports) {

$parcel$export(module.exports, "getSelectUtilityClasses", function () { return $5ea8b5d2968b699c$export$2c0c1ee5a3392e; });
$parcel$export(module.exports, "default", function () { return $5ea8b5d2968b699c$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $5ea8b5d2968b699c$export$2c0c1ee5a3392e(slot) {
    return (0, $k6RDS.default)('MuiSelect', slot);
}
const $5ea8b5d2968b699c$var$selectClasses = (0, $4jzsB.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $5ea8b5d2968b699c$export$2e2bcd8739ae039 = $5ea8b5d2968b699c$var$selectClasses;

});


parcelRegister("aI4oF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cc16c93aade5bc5$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
'use client';
var $7cc16c93aade5bc5$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

});


parcelRegister("1VsKU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getTextFieldUtilityClass", function () { return $16716b95f6c79ff6$export$c1bdcbaf0596aeda; });
$parcel$export(module.exports, "default", function () { return $16716b95f6c79ff6$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $16716b95f6c79ff6$export$c1bdcbaf0596aeda(slot) {
    return (0, $k6RDS.default)('MuiTextField', slot);
}
const $16716b95f6c79ff6$var$textFieldClasses = (0, $4jzsB.default)('MuiTextField', [
    'root'
]);
var $16716b95f6c79ff6$export$2e2bcd8739ae039 = $16716b95f6c79ff6$var$textFieldClasses;

});


parcelRegister("lUGlA", function(module, exports) {

$parcel$export(module.exports, "ProjectFonts", function () { return $69b0bb32031f0f60$export$f9f1471fa2c4dee7; });
$parcel$export(module.exports, "default", function () { return $69b0bb32031f0f60$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
class $69b0bb32031f0f60$export$f9f1471fa2c4dee7 {
    constructor(proj){
        this.rtlLangs = {};
        this.inherit = "inherit";
        this.langMap = {};
        this.rtl = "rtl";
        this.analysisFont = this.inherit;
        this.vernacularFont = this.inherit;
        if (!proj) return;
        proj.analysisWritingSystems.forEach((ws)=>{
            const font = ws.font.replaceAll(" ", "");
            if (font && !(ws.bcp47 in this.langMap)) {
                this.langMap[ws.bcp47] = font;
                if (ws.rtl) this.rtlLangs[ws.bcp47] = true;
            }
        });
        if (proj.analysisWritingSystems.length) {
            const analysisWS = proj.analysisWritingSystems[0];
            this.analysisFont = analysisWS.font.replaceAll(" ", "") || this.inherit;
            if (analysisWS.rtl) this.analysisDir = this.rtl;
        }
        const vernFont = proj.vernacularWritingSystem.font.replaceAll(" ", "");
        if (vernFont) {
            this.vernacularFont = vernFont;
            this.langMap[proj.vernacularWritingSystem.bcp47] = vernFont;
            if (proj.vernacularWritingSystem.rtl) {
                this.rtlLangs[proj.vernacularWritingSystem.bcp47] = true;
                this.vernacularDir = this.rtl;
            }
        }
    }
    getLangDir(bcp47) {
        if (bcp47 in this.rtlLangs) return this.rtl;
    }
    getLangFont(bcp47) {
        if (bcp47 in this.langMap) return this.langMap[bcp47] || this.inherit;
        return this.inherit;
    }
    /**
   * Conditionally adds a fontFamily (and direction) to the style.
   * Precedence, from highest to lowest, moving to the next one if falsy:
   *   vernacular; lang; analysis; input style; "inherit" (direction undefined).
   */ addFontToStyle(props, style) {
        return {
            ...style,
            direction: props.vernacular ? this.vernacularDir : props.lang ? this.getLangDir(props.lang) : props.analysis ? this.analysisDir : style?.direction,
            fontFamily: props.vernacular ? this.vernacularFont : props.lang ? this.getLangFont(props.lang) : props.analysis ? this.analysisFont : style?.fontFamily ?? this.inherit
        };
    }
}
const $69b0bb32031f0f60$var$FontContext = (0, $7fPBF.createContext)(new $69b0bb32031f0f60$export$f9f1471fa2c4dee7());
var $69b0bb32031f0f60$export$2e2bcd8739ae039 = $69b0bb32031f0f60$var$FontContext;

});


parcelRegister("dl3xm", function(module, exports) {

$parcel$export(module.exports, "meetsPasswordRequirements", function () { return $8b0a8d6698686331$export$32f259c556f8ee08; });
$parcel$export(module.exports, "meetsUsernameRequirements", function () { return $8b0a8d6698686331$export$560e8084bab771b5; });
$parcel$export(module.exports, "normalizeEmail", function () { return $8b0a8d6698686331$export$5d12ac716b064a92; });
// eslint-disable-next-line @typescript-eslint/no-require-imports

var $lwrYG = parcelRequire("lwrYG");
function $8b0a8d6698686331$export$32f259c556f8ee08(password) {
    return password.length >= 8;
}
function $8b0a8d6698686331$export$560e8084bab771b5(username) {
    return username.length >= 3;
}
function $8b0a8d6698686331$export$5d12ac716b064a92(email) {
    return $lwrYG.toUnicode(email.trim()).normalize("NFC");
}

});
parcelRegister("lwrYG", function(module, exports) {

$parcel$export(module.exports, "toUnicode", function () { return $fab249e88f48896b$export$110c810e8727e62b; });
'use strict';
/** Highest positive signed 32-bit float value */ const $fab249e88f48896b$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $fab249e88f48896b$var$base = 36;
const $fab249e88f48896b$var$tMin = 1;
const $fab249e88f48896b$var$tMax = 26;
const $fab249e88f48896b$var$skew = 38;
const $fab249e88f48896b$var$damp = 700;
const $fab249e88f48896b$var$initialBias = 72;
const $fab249e88f48896b$var$initialN = 128; // 0x80
const $fab249e88f48896b$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ const $fab249e88f48896b$var$regexPunycode = /^xn--/;
const $fab249e88f48896b$var$regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const $fab249e88f48896b$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $fab249e88f48896b$var$errors = {
    'overflow': 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
/** Convenience shortcuts */ const $fab249e88f48896b$var$baseMinusTMin = $fab249e88f48896b$var$base - $fab249e88f48896b$var$tMin;
const $fab249e88f48896b$var$floor = Math.floor;
const $fab249e88f48896b$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $fab249e88f48896b$var$error(type) {
    throw new RangeError($fab249e88f48896b$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $fab249e88f48896b$var$map(array, callback) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = callback(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */ function $fab249e88f48896b$var$mapDomain(domain, callback) {
    const parts = domain.split('@');
    let result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        domain = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    domain = domain.replace($fab249e88f48896b$var$regexSeparators, '\x2E');
    const labels = domain.split('.');
    const encoded = $fab249e88f48896b$var$map(labels, callback).join('.');
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $fab249e88f48896b$export$c1700176c90f250f(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const $fab249e88f48896b$export$f999239d9b149395 = (codePoints)=>String.fromCodePoint(...codePoints);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const $fab249e88f48896b$var$basicToDigit = function(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
    return $fab249e88f48896b$var$base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const $fab249e88f48896b$var$digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const $fab249e88f48896b$var$adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? $fab249e88f48896b$var$floor(delta / $fab249e88f48896b$var$damp) : delta >> 1;
    delta += $fab249e88f48896b$var$floor(delta / numPoints);
    for(; delta > $fab249e88f48896b$var$baseMinusTMin * $fab249e88f48896b$var$tMax >> 1; k += $fab249e88f48896b$var$base)delta = $fab249e88f48896b$var$floor(delta / $fab249e88f48896b$var$baseMinusTMin);
    return $fab249e88f48896b$var$floor(k + ($fab249e88f48896b$var$baseMinusTMin + 1) * delta / (delta + $fab249e88f48896b$var$skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const $fab249e88f48896b$export$2f872c0f2117be69 = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = $fab249e88f48896b$var$initialN;
    let bias = $fab249e88f48896b$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($fab249e88f48896b$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $fab249e88f48896b$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        const oldi = i;
        for(let w = 1, k = $fab249e88f48896b$var$base;; k += $fab249e88f48896b$var$base){
            if (index >= inputLength) $fab249e88f48896b$var$error('invalid-input');
            const digit = $fab249e88f48896b$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $fab249e88f48896b$var$base) $fab249e88f48896b$var$error('invalid-input');
            if (digit > $fab249e88f48896b$var$floor(($fab249e88f48896b$var$maxInt - i) / w)) $fab249e88f48896b$var$error('overflow');
            i += digit * w;
            const t = k <= bias ? $fab249e88f48896b$var$tMin : k >= bias + $fab249e88f48896b$var$tMax ? $fab249e88f48896b$var$tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = $fab249e88f48896b$var$base - t;
            if (w > $fab249e88f48896b$var$floor($fab249e88f48896b$var$maxInt / baseMinusT)) $fab249e88f48896b$var$error('overflow');
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = $fab249e88f48896b$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($fab249e88f48896b$var$floor(i / out) > $fab249e88f48896b$var$maxInt - n) $fab249e88f48896b$var$error('overflow');
        n += $fab249e88f48896b$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const $fab249e88f48896b$export$c564cdbbe6da493 = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $fab249e88f48896b$export$c1700176c90f250f(input);
    // Cache the length.
    const inputLength = input.length;
    // Initialize the state.
    let n = $fab249e88f48896b$var$initialN;
    let delta = 0;
    let bias = $fab249e88f48896b$var$initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push($fab249e88f48896b$var$stringFromCharCode(currentValue));
    const basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push($fab249e88f48896b$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = $fab249e88f48896b$var$maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $fab249e88f48896b$var$floor(($fab249e88f48896b$var$maxInt - delta) / handledCPCountPlusOne)) $fab249e88f48896b$var$error('overflow');
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > $fab249e88f48896b$var$maxInt) $fab249e88f48896b$var$error('overflow');
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = $fab249e88f48896b$var$base;; k += $fab249e88f48896b$var$base){
                    const t = k <= bias ? $fab249e88f48896b$var$tMin : k >= bias + $fab249e88f48896b$var$tMax ? $fab249e88f48896b$var$tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = $fab249e88f48896b$var$base - t;
                    output.push($fab249e88f48896b$var$stringFromCharCode($fab249e88f48896b$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $fab249e88f48896b$var$floor(qMinusT / baseMinusT);
                }
                output.push($fab249e88f48896b$var$stringFromCharCode($fab249e88f48896b$var$digitToBasic(q, 0)));
                bias = $fab249e88f48896b$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join('');
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const $fab249e88f48896b$export$110c810e8727e62b = function(input) {
    return $fab249e88f48896b$var$mapDomain(input, function(string) {
        return $fab249e88f48896b$var$regexPunycode.test(string) ? $fab249e88f48896b$export$2f872c0f2117be69(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const $fab249e88f48896b$export$69111c4ea6e0c4a0 = function(input) {
    return $fab249e88f48896b$var$mapDomain(input, function(string) {
        return $fab249e88f48896b$var$regexNonASCII.test(string) ? 'xn--' + $fab249e88f48896b$export$c564cdbbe6da493(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const $fab249e88f48896b$var$punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ 'version': '2.3.1',
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ 'ucs2': {
        'decode': $fab249e88f48896b$export$c1700176c90f250f,
        'encode': $fab249e88f48896b$export$f999239d9b149395
    },
    'decode': $fab249e88f48896b$export$2f872c0f2117be69,
    'encode': $fab249e88f48896b$export$c564cdbbe6da493,
    'toASCII': $fab249e88f48896b$export$69111c4ea6e0c4a0,
    'toUnicode': $fab249e88f48896b$export$110c810e8727e62b
};
var $fab249e88f48896b$export$2e2bcd8739ae039 = $fab249e88f48896b$var$punycode;

});



parcelRegister("iqjYa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85ecbd6b05ceeb28$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $gxpCl = parcelRequire("gxpCl");

var $cSUCP = parcelRequire("cSUCP");

var $2I79p = parcelRequire("2I79p");

var $ddz7b = parcelRequire("ddz7b");

var $6PJp8 = parcelRequire("6PJp8");
function $85ecbd6b05ceeb28$export$2e2bcd8739ae039() {
    const navigate = (0, $gxpCl.useNavigate)();
    const { token: token, project: project } = (0, $gxpCl.useParams)();
    const [isValidLink, setIsValidLink] = (0, $7fPBF.useState)(false);
    const validateLink = (0, $7fPBF.useCallback)(async ()=>{
        if (project && token) {
            const status = await (0, $cSUCP.validateInviteToken)(project, token);
            if (status.isTokenValid && status.isUserValid) {
                navigate((0, $6PJp8.Path).Login);
                return;
            }
            setIsValidLink(status.isTokenValid);
        }
    }, [
        navigate,
        project,
        token
    ]);
    (0, $7fPBF.useEffect)(()=>{
        validateLink();
    }, [
        validateLink
    ]);
    return isValidLink ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ddz7b.default), {
        onSignup: ()=>(0, $cSUCP.validateInviteToken)(project, token)
    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2I79p.default), {
        titleTextId: "invite.invalidInvitationURL"
    });
}

});
parcelRegister("ddz7b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d5acdd63bdf9001$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $5ZeKC = parcelRequire("5ZeKC");
var $gsokU = parcelRequire("gsokU");
var $c1d0r = parcelRequire("c1d0r");
var $3M96K = parcelRequire("3M96K");
var $k4oz9 = parcelRequire("k4oz9");
var $hG0Cb = parcelRequire("hG0Cb");
var $f6ezL = parcelRequire("f6ezL");
var $3loMv = parcelRequire("3loMv");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $cSUCP = parcelRequire("cSUCP");

var $3SkrS = parcelRequire("3SkrS");

var $tUv8Q = parcelRequire("tUv8Q");

var $2st3N = parcelRequire("2st3N");

var $i3Fzs = parcelRequire("i3Fzs");

var $3oQOj = parcelRequire("3oQOj");

var $f3nsX = parcelRequire("f3nsX");

var $9Ihvc = parcelRequire("9Ihvc");

var $6PJp8 = parcelRequire("6PJp8");

var $2VP0e = parcelRequire("2VP0e");

var $lMWJB = parcelRequire("lMWJB");

var $dl3xm = parcelRequire("dl3xm");
var $4d5acdd63bdf9001$export$3250bf985e768baf = /*#__PURE__*/ function(SignupField) {
    SignupField["Email"] = "email";
    SignupField["Name"] = "name";
    SignupField["Password1"] = "password1";
    SignupField["Password2"] = "password2";
    SignupField["Username"] = "username";
    return SignupField;
}({});
const $4d5acdd63bdf9001$var$defaultSignupError = {
    ["email"]: false,
    ["name"]: false,
    ["password1"]: false,
    ["password2"]: false,
    ["username"]: false
};
const $4d5acdd63bdf9001$var$defaultSignupText = {
    ["email"]: "",
    ["name"]: "",
    ["password1"]: "",
    ["password2"]: "",
    ["username"]: ""
};
const $4d5acdd63bdf9001$export$2b1f0ce73815dd47 = {
    ["email"]: "login.email",
    ["name"]: "login.name",
    ["password1"]: "login.password",
    ["password2"]: "login.confirmPassword",
    ["username"]: "login.username"
};
const $4d5acdd63bdf9001$export$a3628ed269671036 = {
    ["email"]: "signup-email-field",
    ["name"]: "signup-name-field",
    ["password1"]: "signup-password1-field",
    ["password2"]: "signup-password2-field",
    ["username"]: "signup-username-field"
};
function $4d5acdd63bdf9001$export$2e2bcd8739ae039(props) {
    const dispatch = (0, $f3nsX.useAppDispatch)();
    const { error: error, signupStatus: signupStatus } = (0, $f3nsX.useAppSelector)((state)=>state.loginState);
    const [fieldError, setFieldError] = (0, $7fPBF.useState)($4d5acdd63bdf9001$var$defaultSignupError);
    const [fieldText, setFieldText] = (0, $7fPBF.useState)($4d5acdd63bdf9001$var$defaultSignupText);
    const [isVerified, setIsVerified] = (0, $7fPBF.useState)(false);
    const { t: t } = (0, $doyfp.useTranslation)();
    (0, $7fPBF.useEffect)(()=>{
        const search = window.location.search;
        const email = new URLSearchParams(search).get("email");
        if (email) setFieldText((prev)=>({
                ...prev,
                ["email"]: email
            }));
        dispatch((0, $3oQOj.reset)());
    }, [
        dispatch
    ]);
    const errorField = (field, error)=>{
        setFieldError((prev)=>({
                ...prev,
                [field]: error
            }));
    };
    const checkUsername = ()=>{
        const username = fieldText["username"].trim();
        errorField("username", !(0, $dl3xm.meetsUsernameRequirements)(username));
    };
    const checkPassword1 = ()=>{
        const password1 = fieldText["password1"].trim();
        errorField("password1", !(0, $dl3xm.meetsPasswordRequirements)(password1));
    };
    const checkPassword2 = ()=>{
        const password1 = fieldText["password1"].trim();
        const password2 = fieldText["password2"].trim();
        errorField("password2", password1 !== password2);
    };
    const updateField = (e, field)=>{
        setFieldText((prev)=>({
                ...prev,
                [field]: e.target.value
            }));
    };
    const signUp = async (e)=>{
        e.preventDefault();
        // Trim whitespace off fields.
        const name = fieldText["name"].trim();
        const username = fieldText["username"].trim();
        const email = (0, $dl3xm.normalizeEmail)(fieldText["email"]);
        const password1 = fieldText["password1"].trim();
        const password2 = fieldText["password2"].trim();
        // Check for bad field values.
        const err = {
            ["name"]: !name,
            ["username"]: !(0, $dl3xm.meetsUsernameRequirements)(username),
            ["email"]: !email,
            ["password1"]: !(0, $dl3xm.meetsPasswordRequirements)(password1),
            ["password2"]: password1 !== password2
        };
        if (Object.values(err).some((e)=>e)) setFieldError(err);
        else {
            const onLogin = (0, $2VP0e.RuntimeConfig).getInstance().emailServicesEnabled() ? async ()=>await (0, $cSUCP.requestEmailVerify)(email) : undefined;
            await dispatch((0, $2st3N.asyncSignUp)(name, username, email, password1, props.onSignup, onLogin));
        }
    };
    const defaultTextFieldProps = (field)=>({
            error: fieldError[field],
            id: $4d5acdd63bdf9001$export$a3628ed269671036[field],
            label: t($4d5acdd63bdf9001$export$2b1f0ce73815dd47[field]),
            margin: "normal",
            onChange: (e)=>updateField(e, field),
            required: true,
            slotProps: {
                htmlInput: {
                    maxLength: 100
                }
            },
            style: {
                width: "100%"
            },
            value: fieldText[field],
            variant: "outlined"
        });
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $k4oz9.default), {
        container: true,
        justifyContent: "center",
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gsokU.default), {
            sx: {
                width: 450
            },
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3M96K.default), {
                    title: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                        align: "center",
                        variant: "h5",
                        children: t("login.signUpNew")
                    })
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c1d0r.default), {
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)("form", {
                        onSubmit: signUp,
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lMWJB.NormalizedTextField), {
                                    ...defaultTextFieldProps("name"),
                                    autoComplete: "name",
                                    autoFocus: true,
                                    helperText: fieldError["name"] ? t("login.required") : undefined
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lMWJB.NormalizedTextField), {
                                    ...defaultTextFieldProps("username"),
                                    autoComplete: "username",
                                    helperText: t("login.usernameRequirements"),
                                    onBlur: ()=>checkUsername()
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f6ezL.default), {
                                    ...defaultTextFieldProps("email"),
                                    autoComplete: "email",
                                    type: "email" // silently converts input to punycode
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lMWJB.NormalizedTextField), {
                                    ...defaultTextFieldProps("password1"),
                                    autoComplete: "new-password",
                                    helperText: t("login.passwordRequirements"),
                                    onBlur: ()=>checkPassword1(),
                                    type: "password"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lMWJB.NormalizedTextField), {
                                    ...defaultTextFieldProps("password2"),
                                    autoComplete: "new-password",
                                    helperText: fieldError["password2"] ? t("login.confirmPasswordError") : undefined,
                                    onBlur: ()=>checkPassword2(),
                                    type: "password"
                                }),
                                !!error && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                    sx: {
                                        color: "error.main"
                                    },
                                    variant: "body2",
                                    children: t(error)
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $tUv8Q.default), {
                                    setSuccess: setIsVerified
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                                    direction: "row",
                                    justifyContent: "flex-end",
                                    spacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                                            onClick: ()=>(0, $9Ihvc.default).navigate((0, $6PJp8.Path).Login),
                                            variant: "outlined",
                                            children: t("login.backToLogin")
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3SkrS.default), {
                                            disabled: !isVerified,
                                            done: signupStatus === (0, $i3Fzs.LoginStatus).Success,
                                            doneText: t("login.signUpSuccess"),
                                            loading: signupStatus === (0, $i3Fzs.LoginStatus).InProgress,
                                            children: t("login.signUp")
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}

});
parcelRegister("3SkrS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f2623701fa3ccbf$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $3tbz9 = parcelRequire("3tbz9");

var $5ZeKC = parcelRequire("5ZeKC");
var $iibPM = parcelRequire("iibPM");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $gs8xE = parcelRequire("gs8xE");
function $3f2623701fa3ccbf$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $doyfp.useTranslation)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $5ZeKC.default), {
        type: "submit",
        variant: "contained",
        ...props.buttonProps,
        disabled: props.disabled || props.loading,
        style: {
            backgroundColor: props.done ? (0, $gs8xE.themeColors).success : undefined,
            color: props.done ? "white" : undefined,
            ...props.buttonProps?.style
        },
        children: [
            props.done ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3tbz9.default), {}),
                    props.doneText ?? t("buttons.done")
                ]
            }) : props.children,
            props.loading && !props.done && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iibPM.default), {
                size: 24,
                style: {
                    color: (0, $gs8xE.themeColors).success,
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: -12,
                    marginLeft: -12
                }
            })
        ]
    });
}

});
parcelRegister("3tbz9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $286d0d4c99531fee$export$2e2bcd8739ae039; });

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $286d0d4c99531fee$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');

});




parcelRegister("KdnEy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5758a59e892b3195$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $aili3 = parcelRequire("aili3");
var $3loMv = parcelRequire("3loMv");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $gxpCl = parcelRequire("gxpCl");

var $i88wr = parcelRequire("i88wr");

var $6PJp8 = parcelRequire("6PJp8");
function $5758a59e892b3195$export$2e2bcd8739ae039() {
    const { t: t } = (0, $doyfp.useTranslation)();
    const navigate = (0, $gxpCl.useNavigate)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        rowGap: 3,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                variant: "h4",
                children: t("generic.404Title")
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                onClick: ()=>navigate((0, $6PJp8.Path).ProjScreen),
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $i88wr.default), {})
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                variant: "h5",
                children: t("generic.404Text")
            })
        ]
    });
}

});

parcelRegister("jhOXl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76d9a1a7c12e99e4$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $5ZeKC = parcelRequire("5ZeKC");
var $gsokU = parcelRequire("gsokU");
var $c1d0r = parcelRequire("c1d0r");
var $3M96K = parcelRequire("3M96K");
var $k4oz9 = parcelRequire("k4oz9");
var $hG0Cb = parcelRequire("hG0Cb");
var $3loMv = parcelRequire("3loMv");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $gxpCl = parcelRequire("gxpCl");

var $cSUCP = parcelRequire("cSUCP");

var $3SkrS = parcelRequire("3SkrS");

var $tUv8Q = parcelRequire("tUv8Q");

var $6PJp8 = parcelRequire("6PJp8");

var $lMWJB = parcelRequire("lMWJB");
var $76d9a1a7c12e99e4$export$2439576781e15ae3 = /*#__PURE__*/ function(ResetRequestTextId) {
    ResetRequestTextId["ButtonSubmit"] = "passwordReset.submit";
    ResetRequestTextId["ButtonLogin"] = "login.backToLogin";
    ResetRequestTextId["Done"] = "passwordReset.resetDone";
    ResetRequestTextId["FieldEmailOrUsername"] = "passwordReset.emailOrUsername";
    ResetRequestTextId["FieldEmailOrUsernameError"] = "passwordReset.resetFail";
    ResetRequestTextId["Instructions"] = "passwordReset.resetRequestInstructions";
    ResetRequestTextId["Title"] = "passwordReset.resetRequestTitle";
    return ResetRequestTextId;
}({});
function $76d9a1a7c12e99e4$export$2e2bcd8739ae039() {
    const [emailOrUsername, setEmailOrUsername] = (0, $7fPBF.useState)("");
    const [isDone, setIsDone] = (0, $7fPBF.useState)(false);
    const [isError, setIsError] = (0, $7fPBF.useState)(false);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isVerified, setIsVerified] = (0, $7fPBF.useState)(false);
    const { t: t } = (0, $doyfp.useTranslation)();
    const navigate = (0, $gxpCl.useNavigate)();
    const onSubmit = (event)=>{
        event.preventDefault();
        setIsError(false);
        setIsLoading(true);
        (0, $cSUCP.resetPasswordRequest)(emailOrUsername).then(()=>{
            setIsDone(true);
        }).catch(()=>{
            setIsError(true);
            setIsLoading(false);
        });
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $k4oz9.default), {
        container: true,
        justifyContent: "center",
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gsokU.default), {
            sx: {
                width: 450
            },
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3M96K.default), {
                    title: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                        align: "center",
                        variant: "h5",
                        children: t("passwordReset.resetRequestTitle")
                    })
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c1d0r.default), {
                    children: isDone ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                        alignItems: "flex-end",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                children: t("passwordReset.resetDone")
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                                onClick: ()=>navigate((0, $6PJp8.Path).Login),
                                variant: "contained",
                                children: t("login.backToLogin")
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $bbzbN.jsx)("form", {
                        onSubmit: onSubmit,
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                    children: t("passwordReset.resetRequestInstructions")
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lMWJB.NormalizedTextField), {
                                    autoComplete: "username",
                                    fullWidth: true,
                                    helperText: isError && t("passwordReset.resetFail"),
                                    label: t("passwordReset.emailOrUsername"),
                                    onChange: (e)=>setEmailOrUsername(e.target.value),
                                    required: true,
                                    value: emailOrUsername
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $tUv8Q.default), {
                                    setSuccess: setIsVerified
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                                    direction: "row",
                                    justifyContent: "flex-end",
                                    spacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                                            onClick: ()=>navigate((0, $6PJp8.Path).Login),
                                            variant: "outlined",
                                            children: t("login.backToLogin")
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3SkrS.default), {
                                            disabled: !emailOrUsername || !isVerified,
                                            loading: isLoading,
                                            children: t("passwordReset.submit")
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}

});

parcelRegister("293io", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e350a7d896c2bce$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $5ZeKC = parcelRequire("5ZeKC");
var $gsokU = parcelRequire("gsokU");
var $c1d0r = parcelRequire("c1d0r");
var $3M96K = parcelRequire("3M96K");
var $k4oz9 = parcelRequire("k4oz9");
var $hG0Cb = parcelRequire("hG0Cb");
var $3loMv = parcelRequire("3loMv");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $gxpCl = parcelRequire("gxpCl");

var $gzXcP = parcelRequire("gzXcP");

var $cSUCP = parcelRequire("cSUCP");

var $2I79p = parcelRequire("2I79p");

var $6PJp8 = parcelRequire("6PJp8");

var $lMWJB = parcelRequire("lMWJB");

var $dl3xm = parcelRequire("dl3xm");
var $3e350a7d896c2bce$export$31fdf8a078c3d6d8 = /*#__PURE__*/ function(PasswordResetTextId) {
    PasswordResetTextId["ButtonSubmit"] = "passwordReset.submit";
    PasswordResetTextId["FieldPassword1"] = "login.password";
    PasswordResetTextId["FieldPassword1Hint"] = "login.passwordRequirements";
    PasswordResetTextId["FieldPassword2"] = "login.confirmPassword";
    PasswordResetTextId["FieldPassword2Error"] = "login.confirmPasswordError";
    PasswordResetTextId["Invalid"] = "passwordReset.invalidURL";
    PasswordResetTextId["ToastSuccess"] = "passwordReset.resetSuccess";
    PasswordResetTextId["ToastFail"] = "passwordReset.resetFail";
    PasswordResetTextId["Title"] = "passwordReset.resetTitle";
    return PasswordResetTextId;
}({});
function $3e350a7d896c2bce$export$2e2bcd8739ae039() {
    const navigate = (0, $gxpCl.useNavigate)();
    const { token: token } = (0, $gxpCl.useParams)();
    const { t: t } = (0, $doyfp.useTranslation)();
    const [isPasswordConfirmed, setIsPasswordConfirmed] = (0, $7fPBF.useState)(false);
    const [isValidLink, setIsValidLink] = (0, $7fPBF.useState)(false);
    const [password, setPassword] = (0, $7fPBF.useState)("");
    const [passwordConfirm, setPasswordConfirm] = (0, $7fPBF.useState)("");
    const [passwordFitsRequirements, setPasswordFitsRequirements] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        if (token) (0, $cSUCP.validateResetToken)(token).then(setIsValidLink);
    }, [
        token
    ]);
    const onSubmit = async (e)=>{
        if (token) {
            await asyncReset(token, password);
            e.preventDefault();
        }
    };
    const onChangePassword = (newPassword, newConfirmPassword)=>{
        setPasswordFitsRequirements((0, $dl3xm.meetsPasswordRequirements)(newPassword));
        setIsPasswordConfirmed(newPassword === newConfirmPassword);
        setPassword(newPassword);
        setPasswordConfirm(newConfirmPassword);
    };
    const asyncReset = async (token, password)=>{
        if (await (0, $cSUCP.resetPassword)(token, password)) (0, $gzXcP.toast).success(t("passwordReset.resetSuccess"));
        else (0, $gzXcP.toast).error(t("passwordReset.resetFail"));
        navigate((0, $6PJp8.Path).Login);
    };
    return isValidLink ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $k4oz9.default), {
        container: true,
        justifyContent: "center",
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gsokU.default), {
            sx: {
                width: 450
            },
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3M96K.default), {
                    title: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                        align: "center",
                        variant: "h5",
                        children: t("passwordReset.resetTitle")
                    })
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c1d0r.default), {
                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                        alignItems: "flex-end",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lMWJB.NormalizedTextField), {
                                autoComplete: "new-password",
                                error: !passwordFitsRequirements,
                                fullWidth: true,
                                helperText: !passwordFitsRequirements && t("login.passwordRequirements"),
                                id: "password-reset-password1",
                                label: t("login.password"),
                                onChange: (e)=>onChangePassword(e.target.value, passwordConfirm),
                                type: "password",
                                value: password
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lMWJB.NormalizedTextField), {
                                autoComplete: "new-password",
                                error: !isPasswordConfirmed && passwordConfirm.length > 0,
                                fullWidth: true,
                                helperText: !isPasswordConfirmed && passwordConfirm.length > 0 && t("login.confirmPasswordError"),
                                label: t("login.confirmPassword"),
                                onChange: (e)=>onChangePassword(password, e.target.value),
                                type: "password",
                                value: passwordConfirm
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                                disabled: !(passwordFitsRequirements && isPasswordConfirmed),
                                onClick: onSubmit,
                                variant: "contained",
                                children: t("passwordReset.submit")
                            })
                        ]
                    })
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2I79p.default), {
        titleTextId: "passwordReset.invalidURL"
    });
}

});

parcelRegister("7ypFZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f3277da12f12cc4$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $gxpCl = parcelRequire("gxpCl");

var $1a3s7 = parcelRequire("1a3s7");
function $3f3277da12f12cc4$export$2e2bcd8739ae039(props) {
    const user = (0, $1a3s7.getCurrentUser)();
    const loc = (0, $gxpCl.useLocation)().pathname;
    return user ? props.children : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gxpCl.Navigate), {
        to: props.redirectTo,
        state: {
            from: {
                loc: loc
            }
        },
        replace: true
    });
}

});

parcelRegister("5okF4", function(module, exports) {
module.exports = import("efjTR").then(()=>parcelRequire('93flX'));

});



parcelRegister("2yihM", function(module, exports) {

$parcel$export(module.exports, "maxWordsInMergeList", function () { return $d7b2bcba8275508c$export$a483cde3c305b5e0; });
$parcel$export(module.exports, "maxNumSteps", function () { return $d7b2bcba8275508c$export$ba7e6636fc03862a; });
$parcel$export(module.exports, "requiredPermission", function () { return $d7b2bcba8275508c$export$d04df25cc0724ccf; });
$parcel$export(module.exports, "hasChanges", function () { return $d7b2bcba8275508c$export$8c5c7c88e6e06c0e; });
$parcel$export(module.exports, "goalNameToGoal", function () { return $d7b2bcba8275508c$export$88b3e36dbba0d5b1; });
$parcel$export(module.exports, "goalNameToIcon", function () { return $d7b2bcba8275508c$export$83a65e0597dde667; });
$parcel$export(module.exports, "goalTypeToGoal", function () { return $d7b2bcba8275508c$export$148ec27c1e1cbf56; });
$parcel$export(module.exports, "convertGoalToEdit", function () { return $d7b2bcba8275508c$export$94436005d2d9de0c; });
$parcel$export(module.exports, "convertEditToGoal", function () { return $d7b2bcba8275508c$export$a6859b4514bf1bf4; });

var $bbzbN = parcelRequire("bbzbN");

var $4gpuH = parcelRequire("4gpuH");
var $3aAE3 = parcelRequire("3aAE3");
var $74GLC = parcelRequire("74GLC");
var $cFvWl = parcelRequire("cFvWl");

var $j0hjR = parcelRequire("j0hjR");
parcelRequire("585vO");
var $6fdQP = parcelRequire("6fdQP");

var $3tDFg = parcelRequire("3tDFg");

var $9CPUw = parcelRequire("9CPUw");

var $4IBDn = parcelRequire("4IBDn");

var $g5MIz = parcelRequire("g5MIz");

var $b8pfa = parcelRequire("b8pfa");

var $3bM6R = parcelRequire("3bM6R");

var $5YVNZ = parcelRequire("5YVNZ");

var $9m104 = parcelRequire("9m104");

var $eY0YF = parcelRequire("eY0YF");
const $d7b2bcba8275508c$export$a483cde3c305b5e0 = 5;
function $d7b2bcba8275508c$export$ba7e6636fc03862a(type) {
    switch(type){
        case (0, $eY0YF.GoalType).MergeDups:
            return 12;
        case (0, $eY0YF.GoalType).ReviewDeferredDups:
            return 99;
        default:
            return 1;
    }
}
function $d7b2bcba8275508c$export$d04df25cc0724ccf(type) {
    switch(type){
        case (0, $eY0YF.GoalName).MergeDups:
        case (0, $eY0YF.GoalName).ReviewDeferredDups:
            return (0, $6fdQP.Permission).MergeAndReviewEntries;
        case (0, $eY0YF.GoalName).ReviewEntries:
            return (0, $6fdQP.Permission).WordEntry; // can access, but won't have full functionality
        case (0, $eY0YF.GoalName).CreateCharInv:
            return (0, $6fdQP.Permission).CharacterInventory;
        default:
            return (0, $6fdQP.Permission).Archive;
    }
}
function $d7b2bcba8275508c$export$8c5c7c88e6e06c0e(g) {
    if (!g.changes) return false;
    switch(g.name){
        case (0, $eY0YF.GoalName).CreateCharInv:
            const cic = g.changes;
            return cic.charChanges?.length > 0 || cic.wordChanges?.length > 0;
        case (0, $eY0YF.GoalName).MergeDups:
        case (0, $eY0YF.GoalName).ReviewDeferredDups:
            const mc = g.changes;
            return mc.merges?.length > 0;
        case (0, $eY0YF.GoalName).ReviewEntries:
            const ee = g.changes;
            return ee.entryEdits?.length > 0;
        default:
            return false;
    }
}
const $d7b2bcba8275508c$var$goalNameToGoalMap = {
    [(0, $eY0YF.GoalName).CreateCharInv]: ()=>new (0, $3tDFg.CreateCharInv)(),
    [(0, $eY0YF.GoalName).CreateStrWordInv]: ()=>new (0, $9CPUw.CreateStrWordInv)(),
    [(0, $eY0YF.GoalName).HandleFlags]: ()=>new (0, $4IBDn.HandleFlags)(),
    [(0, $eY0YF.GoalName).MergeDups]: ()=>new (0, $g5MIz.MergeDups)(),
    [(0, $eY0YF.GoalName).ReviewDeferredDups]: ()=>new (0, $g5MIz.ReviewDeferredDups)(),
    [(0, $eY0YF.GoalName).ReviewEntries]: ()=>new (0, $b8pfa.ReviewEntries)(),
    [(0, $eY0YF.GoalName).SpellCheckGloss]: ()=>new (0, $3bM6R.SpellCheckGloss)(),
    [(0, $eY0YF.GoalName).ValidateChars]: ()=>new (0, $5YVNZ.ValidateChars)(),
    [(0, $eY0YF.GoalName).ValidateStrWords]: ()=>new (0, $9m104.ValidateStrWords)(),
    [(0, $eY0YF.GoalName).Default]: ()=>new (0, $eY0YF.Goal)()
};
function $d7b2bcba8275508c$export$88b3e36dbba0d5b1(name) {
    return $d7b2bcba8275508c$var$goalNameToGoalMap[name]();
}
function $d7b2bcba8275508c$export$83a65e0597dde667(name, sx = {
    fontSize: "inherit"
}) {
    switch(name){
        case (0, $eY0YF.GoalName).CreateCharInv:
            return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4gpuH.default), {
                sx: sx
            });
        case (0, $eY0YF.GoalName).MergeDups:
            return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3aAE3.default), {
                sx: sx
            });
        case (0, $eY0YF.GoalName).ReviewDeferredDups:
            return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $74GLC.default), {
                sx: sx
            });
        case (0, $eY0YF.GoalName).ReviewEntries:
            return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cFvWl.default), {
                sx: sx
            });
        default:
            return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j0hjR.default), {
                sx: sx
            });
    }
}
const $d7b2bcba8275508c$var$goalTypeToGoalMap = {
    [(0, $eY0YF.GoalType).CreateCharInv]: ()=>new (0, $3tDFg.CreateCharInv)(),
    [(0, $eY0YF.GoalType).CreateStrWordInv]: ()=>new (0, $9CPUw.CreateStrWordInv)(),
    [(0, $eY0YF.GoalType).HandleFlags]: ()=>new (0, $4IBDn.HandleFlags)(),
    [(0, $eY0YF.GoalType).MergeDups]: ()=>new (0, $g5MIz.MergeDups)(),
    [(0, $eY0YF.GoalType).ReviewDeferredDups]: ()=>new (0, $g5MIz.ReviewDeferredDups)(),
    [(0, $eY0YF.GoalType).ReviewEntries]: ()=>new (0, $b8pfa.ReviewEntries)(),
    [(0, $eY0YF.GoalType).SpellCheckGloss]: ()=>new (0, $3bM6R.SpellCheckGloss)(),
    [(0, $eY0YF.GoalType).ValidateChars]: ()=>new (0, $5YVNZ.ValidateChars)(),
    [(0, $eY0YF.GoalType).ValidateStrWords]: ()=>new (0, $9m104.ValidateStrWords)(),
    [(0, $eY0YF.GoalType).Default]: ()=>new (0, $eY0YF.Goal)()
};
function $d7b2bcba8275508c$export$148ec27c1e1cbf56(type) {
    return $d7b2bcba8275508c$var$goalTypeToGoalMap[type]();
}
function $d7b2bcba8275508c$export$94436005d2d9de0c(goal) {
    const { guid: guid, modified: modified } = goal;
    const goalType = goal.goalType;
    const stepData = goal.steps.map((s)=>JSON.stringify(s));
    const changes = JSON.stringify(goal.changes);
    return {
        guid: guid,
        goalType: goalType,
        stepData: stepData,
        changes: changes,
        modified: modified
    };
}
function $d7b2bcba8275508c$export$a6859b4514bf1bf4(edit) {
    const steps = edit.stepData.map((s)=>JSON.parse(s));
    return {
        ...$d7b2bcba8275508c$export$148ec27c1e1cbf56(edit.goalType),
        changes: JSON.parse(edit.changes),
        guid: edit.guid,
        modified: edit.modified ?? undefined,
        numSteps: steps.length,
        status: (0, $eY0YF.GoalStatus).Completed,
        steps: steps
    };
}

});
parcelRegister("4gpuH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31ac6ea439588f0d$export$2e2bcd8739ae039; });

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $31ac6ea439588f0d$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M21 11h-1.5v-.5h-2v3h2V13H21v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1zM8 10v5H6.5v-1.5h-2V15H3v-5c0-.55.45-1 1-1h3c.55 0 1 .45 1 1m-1.5.5h-2V12h2zm7 1.5c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1h-4V9h4c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1M11 10.5v.75h2v-.75zm2 2.25h-2v.75h2z"
}), 'Abc');

});

parcelRegister("3aAE3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24eebb3249f76578$export$2e2bcd8739ae039; });

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $24eebb3249f76578$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "m11.99 18.54-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27z"
}), 'Layers');

});

parcelRegister("74GLC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $526a14c46b49bacb$export$2e2bcd8739ae039; });

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $526a14c46b49bacb$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "m11.99 18.54-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27zm0-11.47L17.74 9 12 13.47 6.26 9z"
}), 'LayersOutlined');

});

parcelRegister("cFvWl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $939216fbe32d43d1$export$2e2bcd8739ae039; });

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $939216fbe32d43d1$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M7 9H2V7h5zm0 3H2v2h5zm13.59 7-3.83-3.83c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L22 17.59zM17 11c0-1.65-1.35-3-3-3s-3 1.35-3 3 1.35 3 3 3 3-1.35 3-3M2 19h10v-2H2z"
}), 'ManageSearch');

});

parcelRegister("j0hjR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd5b73a6e8ee8986$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $b6UUh = parcelRequire("b6UUh");

var $kDBhE = parcelRequire("kDBhE");

var $7uFHh = parcelRequire("7uFHh");

var $wvp8q = parcelRequire("wvp8q");

var $iVAEr = parcelRequire("iVAEr");

var $95W7n = parcelRequire("95W7n");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $dd5b73a6e8ee8986$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $b6UUh.default)(color)}`,
            `fontSize${(0, $b6UUh.default)(fontSize)}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $95W7n.getIconUtilityClass), classes);
};
const $dd5b73a6e8ee8986$var$IconRoot = (0, $kDBhE.default)('span', {
    name: 'MuiIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $b6UUh.default)(ownerState.color)}`],
            styles[`fontSize${(0, $b6UUh.default)(ownerState.fontSize)}`]
        ];
    }
})((0, $7uFHh.default)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        // Chrome fix for https://issues.chromium.org/issues/41375697
        // To remove at some point.
        overflow: 'hidden',
        display: 'inline-block',
        // allow overflow hidden to take action
        textAlign: 'center',
        // support non-square icon
        flexShrink: 0,
        variants: [
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(20)
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography.pxToRem(24)
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography.pxToRem(36)
                }
            },
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars || theme).palette.action.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            },
            ...Object.entries(theme.palette).filter((0, $wvp8q.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $dd5b73a6e8ee8986$var$Icon = /*#__PURE__*/ $7fPBF.forwardRef(function Icon(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiIcon'
    });
    const { baseClassName: baseClassName = 'material-icons', className: className, color: color = 'inherit', component: Component = 'span', fontSize: fontSize = 'medium', ...other } = props;
    const ownerState = {
        ...props,
        baseClassName: baseClassName,
        color: color,
        component: Component,
        fontSize: fontSize
    };
    const classes = $dd5b73a6e8ee8986$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($dd5b73a6e8ee8986$var$IconRoot, {
        as: Component,
        className: (0, $hngXp.default)(baseClassName, // Prevent the translation of the text content.
        // The font relies on the exact text content to render the icon.
        'notranslate', classes.root, className),
        ownerState: ownerState,
        "aria-hidden": true,
        ref: ref,
        ...other
    });
});
$dd5b73a6e8ee8986$var$Icon.muiName = 'Icon';
var $dd5b73a6e8ee8986$export$2e2bcd8739ae039 = $dd5b73a6e8ee8986$var$Icon;

});
parcelRegister("95W7n", function(module, exports) {

$parcel$export(module.exports, "getIconUtilityClass", function () { return $69f1a9b1bec8bc92$export$e7545bb336f9a5fc; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $69f1a9b1bec8bc92$export$e7545bb336f9a5fc(slot) {
    return (0, $k6RDS.default)('MuiIcon', slot);
}
const $69f1a9b1bec8bc92$var$iconClasses = (0, $4jzsB.default)('MuiIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $69f1a9b1bec8bc92$export$2e2bcd8739ae039 = $69f1a9b1bec8bc92$var$iconClasses;

});


parcelRegister("9CPUw", function(module, exports) {

$parcel$export(module.exports, "CreateStrWordInv", function () { return $82a4d9aad21f9636$export$7b4cfc58ce2c499; });

var $eY0YF = parcelRequire("eY0YF");
class $82a4d9aad21f9636$export$7b4cfc58ce2c499 extends (0, $eY0YF.Goal) {
    constructor(){
        super((0, $eY0YF.GoalType).CreateStrWordInv, (0, $eY0YF.GoalName).CreateStrWordInv);
    }
}

});

parcelRegister("4IBDn", function(module, exports) {

$parcel$export(module.exports, "HandleFlags", function () { return $1531fc5ed51c38a8$export$c8a4e1c97cb02a60; });

var $eY0YF = parcelRequire("eY0YF");
class $1531fc5ed51c38a8$export$c8a4e1c97cb02a60 extends (0, $eY0YF.Goal) {
    constructor(){
        super((0, $eY0YF.GoalType).HandleFlags, (0, $eY0YF.GoalName).HandleFlags);
    }
}

});

parcelRegister("b8pfa", function(module, exports) {

$parcel$export(module.exports, "ReviewEntries", function () { return $4d46c4f80afe5785$export$ad327e07f59e6a0e; });

var $eY0YF = parcelRequire("eY0YF");
class $4d46c4f80afe5785$export$ad327e07f59e6a0e extends (0, $eY0YF.Goal) {
    constructor(){
        super((0, $eY0YF.GoalType).ReviewEntries, (0, $eY0YF.GoalName).ReviewEntries);
    }
}

});

parcelRegister("3bM6R", function(module, exports) {

$parcel$export(module.exports, "SpellCheckGloss", function () { return $b0032059c9dfc60f$export$b958dea819f0db8d; });

var $eY0YF = parcelRequire("eY0YF");
class $b0032059c9dfc60f$export$b958dea819f0db8d extends (0, $eY0YF.Goal) {
    constructor(){
        super((0, $eY0YF.GoalType).SpellCheckGloss, (0, $eY0YF.GoalName).SpellCheckGloss);
    }
}

});

parcelRegister("5YVNZ", function(module, exports) {

$parcel$export(module.exports, "ValidateChars", function () { return $2ccbcf40c34ddc2a$export$628de27ea397c4db; });

var $eY0YF = parcelRequire("eY0YF");
class $2ccbcf40c34ddc2a$export$628de27ea397c4db extends (0, $eY0YF.Goal) {
    constructor(){
        super((0, $eY0YF.GoalType).ValidateChars, (0, $eY0YF.GoalName).ValidateChars);
    }
}

});

parcelRegister("9m104", function(module, exports) {

$parcel$export(module.exports, "ValidateStrWords", function () { return $7e2dbbe802897a76$export$436f149a9f6c1093; });

var $eY0YF = parcelRequire("eY0YF");
class $7e2dbbe802897a76$export$436f149a9f6c1093 extends (0, $eY0YF.Goal) {
    constructor(){
        super((0, $eY0YF.GoalType).ValidateStrWords, (0, $eY0YF.GoalName).ValidateStrWords);
    }
}

});




parcelRegister("fA0vm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b57a9c0f440f06b6$export$2e2bcd8739ae039; });

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $b57a9c0f440f06b6$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z"
}), 'Cancel');

});


var $bbzbN = parcelRequire("bbzbN");

var $e6xq6 = parcelRequire("e6xq6");
var $fO8TG = parcelRequire("fO8TG");

var $jIH9a = parcelRequire("jIH9a");
var $f11ec298ebcca059$export$882461b6382ed46c;
var $f11ec298ebcca059$export$757ceba2d55c277e;
'use strict';

var $fw0lo = parcelRequire("fw0lo");
var $f11ec298ebcca059$var$i;
$f11ec298ebcca059$export$882461b6382ed46c = $fw0lo.createRoot;
$f11ec298ebcca059$export$757ceba2d55c277e = $fw0lo.hydrateRoot;



var $kRISp = parcelRequire("kRISp");

var $7fPBF = parcelRequire("7fPBF");
function $e303487a144792e7$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $e303487a144792e7$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $e303487a144792e7$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $e303487a144792e7$var$_typeof(obj);
}
function $e303487a144792e7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e303487a144792e7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e303487a144792e7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e303487a144792e7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e303487a144792e7$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $e303487a144792e7$var$_possibleConstructorReturn(self, call) {
    if (call && ($e303487a144792e7$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $e303487a144792e7$var$_assertThisInitialized(self);
}
function $e303487a144792e7$var$_getPrototypeOf(o) {
    $e303487a144792e7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e303487a144792e7$var$_getPrototypeOf(o);
}
function $e303487a144792e7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e303487a144792e7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $e303487a144792e7$var$_setPrototypeOf(subClass, superClass);
}
function $e303487a144792e7$var$_setPrototypeOf(o, p) {
    $e303487a144792e7$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e303487a144792e7$var$_setPrototypeOf(o, p);
}
function $e303487a144792e7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $e303487a144792e7$export$311ca220e7478cda = /*#__PURE__*/ function(_PureComponent) {
    $e303487a144792e7$var$_inherits(PersistGate, _PureComponent);
    function PersistGate() {
        var _getPrototypeOf2;
        var _this;
        $e303487a144792e7$var$_classCallCheck(this, PersistGate);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $e303487a144792e7$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $e303487a144792e7$var$_getPrototypeOf(PersistGate)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        $e303487a144792e7$var$_defineProperty($e303487a144792e7$var$_assertThisInitialized(_this), "state", {
            bootstrapped: false
        });
        $e303487a144792e7$var$_defineProperty($e303487a144792e7$var$_assertThisInitialized(_this), "_unsubscribe", void 0);
        $e303487a144792e7$var$_defineProperty($e303487a144792e7$var$_assertThisInitialized(_this), "handlePersistorState", function() {
            var persistor = _this.props.persistor;
            var _persistor$getState = persistor.getState(), bootstrapped = _persistor$getState.bootstrapped;
            if (bootstrapped) {
                if (_this.props.onBeforeLift) Promise.resolve(_this.props.onBeforeLift()).finally(function() {
                    return _this.setState({
                        bootstrapped: true
                    });
                });
                else _this.setState({
                    bootstrapped: true
                });
                _this._unsubscribe && _this._unsubscribe();
            }
        });
        return _this;
    }
    $e303487a144792e7$var$_createClass(PersistGate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
                this.handlePersistorState();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._unsubscribe && this._unsubscribe();
            }
        },
        {
            key: "render",
            value: function render() {
                if (typeof this.props.children === 'function') return this.props.children(this.state.bootstrapped);
                return this.state.bootstrapped ? this.props.children : this.props.loading;
            }
        }
    ]);
    return PersistGate;
}((0, $7fPBF.PureComponent));
$e303487a144792e7$var$_defineProperty($e303487a144792e7$export$311ca220e7478cda, "defaultProps", {
    children: null,
    loading: null
});


parcelRequire("hDF5a");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $gxpCl = parcelRequire("gxpCl");

var $bbzbN = parcelRequire("bbzbN");

var $fA0vm = parcelRequire("fA0vm");

var $aili3 = parcelRequire("aili3");
var $8TDId = parcelRequire("8TDId");
var $5Mrqo = parcelRequire("5Mrqo");
var $3loMv = parcelRequire("3loMv");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");
parcelRequire("585vO");
var $aLuLa = parcelRequire("aLuLa");

var $cSUCP = parcelRequire("cSUCP");

var $1a3s7 = parcelRequire("1a3s7");

var $69ZoH = parcelRequire("69ZoH");

var $f3nsX = parcelRequire("f3nsX");

var $6PJp8 = parcelRequire("6PJp8");

var $gs8xE = parcelRequire("gs8xE");
var $293d358b84cb134e$var$AnnouncementBannerId = /*#__PURE__*/ function(AnnouncementBannerId) {
    AnnouncementBannerId["ButtonClose"] = "announcement-banner-close-button";
    return AnnouncementBannerId;
}($293d358b84cb134e$var$AnnouncementBannerId || {});
var $293d358b84cb134e$export$8506a579d8b577cf = /*#__PURE__*/ function(AnnouncementBannerTextId) {
    AnnouncementBannerTextId["ButtonClose"] = "siteSettings.banners.bannerCloseButton";
    return AnnouncementBannerTextId;
}({});
function $293d358b84cb134e$export$2e2bcd8739ae039() {
    const [banner, setBanner] = (0, $7fPBF.useState)("");
    const [margins, setMargins] = (0, $7fPBF.useState)({});
    const { t: t } = (0, $doyfp.useTranslation)();
    // Adjust the margins depending on whether there is an AppBar.
    const loc = (0, $f3nsX.useAppSelector)((state)=>state.analyticsState.currentPage);
    const calculateMargins = (0, $7fPBF.useCallback)(()=>{
        return loc === (0, $6PJp8.Path).Root || loc.startsWith((0, $6PJp8.Path).AppRoot) ? {
            marginTop: (0, $69ZoH.topBarHeight),
            marginBottom: -(0, $69ZoH.topBarHeight)
        } : {};
    }, [
        loc
    ]);
    // Check for announcement banner on (re)load or navigation to a new page.
    (0, $7fPBF.useEffect)(()=>{
        setMargins(calculateMargins());
        (0, $cSUCP.getBannerText)((0, $aLuLa.BannerType).Announcement).then((text)=>{
            setBanner(text !== (0, $1a3s7.getClosedBanner)() ? text : "");
        });
    }, [
        loc,
        calculateMargins
    ]);
    function closeBanner() {
        (0, $1a3s7.setClosedBanner)(banner);
        setBanner("");
    }
    return banner ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $5Mrqo.default), {
        style: {
            ...margins,
            backgroundColor: (0, $gs8xE.themeColors).warning
        },
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8TDId.default), {
                "aria-label": t("siteSettings.banners.bannerCloseButton"),
                id: "announcement-banner-close-button",
                onClick: closeBanner,
                size: "large",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fA0vm.default), {})
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                sx: {
                    width: (0, $gs8xE.default).spacing(2)
                }
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                children: banner
            })
        ]
    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7fPBF.Fragment), {});
}



var $bbzbN = parcelRequire("bbzbN");

var $gzXcP = parcelRequire("gzXcP");

function $addc744eb8fb56f9$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gzXcP.ToastContainer), {
        position: document.body.dir === "rtl" ? "top-left" : "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        draggable: true,
        pauseOnHover: true
    });
}



var $9Ihvc = parcelRequire("9Ihvc");
function $44b2a6897ba1391a$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: "App",
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $7fPBF.Suspense), {
            fallback: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {}),
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $293d358b84cb134e$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $addc744eb8fb56f9$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gxpCl.RouterProvider), {
                    router: (0, $9Ihvc.default)
                })
            ]
        })
    });
}



var $fqXGH = parcelRequire("fqXGH");

var $gs8xE = parcelRequire("gs8xE");
const $d7ff3ee147cb4273$var$container = document.getElementById("root");
const $d7ff3ee147cb4273$var$root = (0, $f11ec298ebcca059$export$882461b6382ed46c)($d7ff3ee147cb4273$var$container);
$d7ff3ee147cb4273$var$root.render(/*#__PURE__*/ (0, $bbzbN.jsx)((0, $e6xq6.default), {
    injectFirst: true,
    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fO8TG.default), {
        theme: (0, $gs8xE.default),
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jIH9a.SnackbarProvider), {
            maxSnack: 3,
            autoHideDuration: 5000,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kRISp.Provider), {
                store: (0, $fqXGH.store),
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e303487a144792e7$export$311ca220e7478cda), {
                    persistor: (0, $fqXGH.persistor),
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $44b2a6897ba1391a$export$2e2bcd8739ae039), {})
                })
            })
        })
    })
}));


//# sourceMappingURL=public.21ae786f.js.map
